import { CreditCard } from '../types/CreditCard';
import { CreditCardRewardsType } from '../types/CreditCardRewardsTypes';
import { CardData } from '../../../types/CardData';
import { CardNetwork } from '../types/CardNetwork';
import { Frequency } from '../types/Frequency';
import { PromotionalType } from '../types/PromotionalType';

export const CreditCardData: Record<CreditCard, CardData> = {
  [CreditCard.SYNCHRONY_SPORTING_GOODS_CREDIT_CARDS]: {
  "id": CreditCard.SYNCHRONY_SPORTING_GOODS_CREDIT_CARDS,
  "name": "Synchrony Sport Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_imagetype/etimg053418.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Exclusive promotional financing offers",
      "description": "Special financing/deferred-interest promotions available at participating sporting goods, bike shops, and outdoor outfitters when you use the Synchrony Sport Credit Card. Subject to credit approval; minimum monthly payments required; specific promo terms vary by merchant and offer.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "0% Fraud Liability",
      "description": "You are not responsible for unauthorized charges made to your account, providing protection from theft or loss.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=7EDBAEB071977CE856069387CF8853DE55FE0127E8B97CB4&client=Synchrony&intcmp=NoOff_SportingGoodsCreditCards_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=7EDBAEB071977CE856069387CF8853DE55FE0127E8B97CB4&client=Synchrony&intcmp=NoOff_SportingGoodsCreditCards_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=7EDBAEB071977CE856069387CF8853DE55FE0127E8B97CB4&client=Synchrony&preQual=Y&intcmp=NoOff_SportingGoodsCreditCards_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    },
    {
      "name": "Learn more about sporting goods financing",
      "url": "https://www.synchrony.com/marketplace/sporting-goods"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_sporting_goods_credit_cards.png"
},
  [CreditCard.TSC_CREDIT_CARDS]: {
  "id": CreditCard.TSC_CREDIT_CARDS,
  "name": "TSC\u00ae Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/tsc-visa/tsc-visa_171x108.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% in Rewards on eligible purchases at gas stations with the TSC Visa.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_tsc_visa_card"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3% in Rewards on eligible purchases at grocery stores with the TSC Visa.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_tsc_visa_card"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% in Rewards on all other eligible purchases with the TSC Visa.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_tsc_visa_card"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3324,
    "apr_low": 0.2641
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2641,
    "high": 0.3324,
    "description": "As of Dec 24, 2024: Purchase APR is variable 26.41%\u201333.24% (min interest charge $2). Promotional financing at Tractor Supply: 6/12/18 months deferred interest ('No interest if paid in full') on eligible amounts, and 36 months at 3.99% APR on purchases of $1,599+ until paid in full. For the TSC Visa: Balance transfer APR 33.24% and cash advance APR 33.24%; balance transfer fee 5% (min $10); cash advance fee 5% (min $10)."
  },
  "benefits": [
    {
      "name": "Automatic Preferred Plus Neighbor status",
      "description": "As a cardmember, you\u2019re automatically a Preferred Plus Neighbor (top tier) in Neighbor\u2019s Club, unlocking additional in-store perks listed below.",
      "benefit_type": null,
      "new_benefit_type": "retail_loyalty_status",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Same Day Delivery certificates",
      "description": "Receive 2 Same Day Delivery certificates per quarter on eligible Tractor Supply purchases (max $25 value per certificate). Estimated maximum value up to $200/year (2 per quarter \u00d7 4 quarters \u00d7 $25 cap).",
      "benefit_type": null,
      "new_benefit_type": "free_same_day_delivery",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free Full-Day Trailer Rentals",
      "description": "Receive 2 free full-day trailer rentals per quarter (availability varies by location; certain trailer types excluded). Value varies by store pricing.",
      "benefit_type": null,
      "new_benefit_type": "free_trailer_rental",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free Everyday Standard Shipping",
      "description": "Free standard shipping on eligible Tractor Supply purchases with $29 minimum spend (additional terms and exclusions apply).",
      "benefit_type": null,
      "new_benefit_type": "free_standard_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Birthday Gift",
      "description": "Receive a free birthday gift (Neighbor\u2019s Club online account required; provide birth month/day at least 10 days prior).",
      "benefit_type": null,
      "new_benefit_type": "birthday_gift",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "6 Months Special Financing (Deferred Interest)",
      "description": "No interest if paid in full within 6 months on purchases of $199 or more at Tractor Supply with your TSC Store Card or TSC Visa Card; interest accrues from purchase date if not paid in full by promo end. Rewards are not earned on promotional credit purchases.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": 199,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "12 Months Special Financing (Deferred Interest)",
      "description": "No interest if paid in full within 12 months on purchases of $399 or more at Tractor Supply with your TSC Store Card or TSC Visa Card; interest accrues from purchase date if not paid in full by promo end. Rewards are not earned on promotional credit purchases.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": 399,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "18 Months Special Financing (Deferred Interest) \u2014 Limited Time",
      "description": "No interest if paid in full within 18 months on purchases of $599 or more (valid 9/22/25\u20139/28/25); interest accrues from purchase date if not paid in full by promo end. Rewards are not earned on promotional credit purchases.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": 599,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "36 Months Financing at 3.99% APR (Major Purchase Plan)",
      "description": "Fixed 3.99% APR financing until paid in full on purchases of $1,599 or more at Tractor Supply with your TSC Store Card or TSC Visa Card. Rewards are not earned on promotional credit purchases.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": 1599,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Dedicated TSC Customer Service Line",
      "description": "Access to a dedicated Tractor Supply customer service phone number for cardmembers; support available 24/7.",
      "benefit_type": null,
      "new_benefit_type": "dedicated_customer_service",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 50.0,
      "spendRequirementMonths": null,
      "description": "Limited-time new cardmember offer: Earn $50 in rewards (5,000 Neighbor\u2019s Club points) after opening a new TSC Store Card or TSC Visa Card and making a qualifying Tractor Supply purchase of $50 or more between 9/2/25 and 9/28/25. Must be a Neighbor\u2019s Club member. Not valid if combined with a promotional credit purchase; applicants not immediately approved may not receive the $50 reward. Reward posts within 30 days of qualifying purchase. Limit one per new account.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 5000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.tractorsupply.com/tsc/cms/credit?cmp=W~P~E~0~Z~E~ZZZ1~AI~TS~ZZ",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-tractor-supply-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/citi-tractor-supply-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "tsc_credit_cards.png"
},
  [CreditCard.US_BANK_ALTITUDE_RESERVE_VISA_INFINITE_CARD]: {
  "id": CreditCard.US_BANK_ALTITUDE_RESERVE_VISA_INFINITE_CARD,
  "name": "U.S. Bank Altitude\u00ae Reserve Visa Infinite\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "",
  "recommendedMinCreditScore": null,
  "availability": "no_new_applicants",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.US_BANK_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5x points per $1 on prepaid hotels and car rentals booked through the Altitude Rewards Center.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5x points per $1 on prepaid hotels and car rentals booked through the Altitude Rewards Center.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases.mobileWallet",
      "earnRate": 3.0,
      "description": "3x points per $1 on mobile wallet purchases (Apple Pay, Google Pay, Samsung Pay, etc.).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "3x points per $1 on travel purchases including airlines, hotels, car rentals, taxis, and more.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 400.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 400.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "$325 Annual Travel and Dining Credit",
      "description": "$325 annual statement credit automatically applied to eligible travel and dining purchases.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass Select Lounge Access",
      "description": "Complimentary Priority Pass Select membership with access to 1,300+ airport lounges worldwide for cardholder and up to two guests.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry or TSA PreCheck Credit",
      "description": "Up to $100 statement credit for Global Entry or TSA PreCheck application fee, every 4.5 years.",
      "benefit_type": "global_entry_tsa_precheck",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer points to travel loyalty programs",
      "description": "Transfer points to participating airline and hotel loyalty programs through the Altitude Rewards Center.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$325 Annual Travel and Dining Credit",
      "description": "$325 annual statement credit automatically applied to eligible travel and dining purchases.",
      "credit_category": null,
      "new_credit_category": "travel_and_dining",
      "value": 325.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": ""
},
  [CreditCard.A_A_R_P_TRAVEL_REWARDS_MASTERCARD_FROM_BARCLAYS]: {
  "id": CreditCard.A_A_R_P_TRAVEL_REWARDS_MASTERCARD_FROM_BARCLAYS,
  "name": "AARP\u00ae Travel Rewards Mastercard\u00ae from Barclays",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/credit-card/aarp/card-art/ART_card_rCMY_Travel_WM_5492_359x246_angle_L.png-Medium.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BARCLAYCARD_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline",
      "earnRate": 3.0,
      "description": "Earn 3x rewards on airfare purchases. No cap; rewards do not expire while the account is open and in good standing.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 3.0,
      "description": "Earn 3x rewards on hotel stays. No cap; rewards do not expire while the account is open and in good standing.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 3.0,
      "description": "Earn 3x rewards on car rentals. No cap; rewards do not expire while the account is open and in good standing.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2x rewards on eligible restaurant purchases. No cap; rewards do not expire while the account is open and in good standing.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1x rewards on all other purchases. No cap; rewards do not expire while the account is open and in good standing.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.2099
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2099,
    "high": 0.2999,
    "description": "Purchases: 0.2099\u20130.2999 variable based on creditworthiness; varies with Prime Rate. Balance transfers: 0.0 introductory for 15 billing cycles on transfers that post within 45 days of account opening, then 0.2099\u20130.2999 variable. Cash advances: 0.2999 variable. Minimum interest charge: $0.50."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero liability for unauthorized charges",
      "description": "You will not be responsible for unauthorized charges made on your account.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Introductory bonus available after spending $500 on purchases in the first 90 days of account opening (exact reward amount not specified in the provided content). Estimated at ~$100 value based on common historical offers for this product tier; please verify in the current Terms & Conditions.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/aarp-travel-rewards-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/aarp-travel-rewards-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "a_a_r_p_travel_rewards_mastercard_from_barclays.png"
},
  [CreditCard.MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD]: {
  "id": CreditCard.MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD,
  "name": "Marriott Bonvoy Boundless\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/marriott_bonvoy_boundless_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.MARRIOTT_BONVOY,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.marriott",
      "earnRate": 6.0,
      "description": "6 points per $1 on qualifying purchases at hotels participating in Marriott Bonvoy (all participating Marriott brands). Additional Marriott Bonvoy program points earned on stays are separate and subject to Marriott Bonvoy terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 3.0,
      "description": "3 points per $1 on combined gas station, grocery store, and dining purchases on the first $6,000 spent each account anniversary year (shared cap). After the cap, these purchases earn 2X.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "gas",
          "grocery",
          "dining"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Gas stations, grocery stores, and dining purchases share a combined $6,000 annual cap before dropping to 2X thereafter.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2 points per $1 on all other purchases. Purchases in gas, grocery, and dining revert to 2X after the combined $6,000 annual cap is reached.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Purchase APR: 19.74%\u201328.24% variable (based on Prime Rate). Balance transfer APR: 19.74%\u201328.24% variable; note: account may not be eligible for balance transfers. Cash advance APR: 28.99% variable. Penalty APR: up to 29.99% variable if you pay late or a payment is returned; may apply indefinitely. Grace period: at least 21 days; no interest on new purchases if you pay your entire balance or Interest Saving Balance by the due date. Interest on balance transfers and cash advances begins on the transaction date. Minimum interest charge: none. Fees: balance transfer fee $5 or 5% (whichever is greater); cash advance fee $10 or 5% (whichever is greater); late fee up to $40; returned payment fee up to $40. Foreign transaction fee: none."
  },
  "benefits": [
    {
      "name": "Anniversary Free Night Award (up to 35,000 points)",
      "description": "Each account anniversary, receive 1 Free Night Award valid for a one-night stay at a property with a redemption level up to 35,000 points. Award deposits up to 8 weeks after your account anniversary; expires 12 months after issuance; not transferable; resort fees and incidentals are not covered; may be combined with points per Marriott terms. Estimated value roughly $175\u2013$280 assuming ~0.5\u20130.8 cents per point; at 0.7 cpp, about $245.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "15 Elite Night Credits each year",
      "description": "15 Marriott Bonvoy Elite Night Credits are deposited within 60 days of account opening, and on or before March 1 of each subsequent calendar year. Only one set of annual consumer-card ENCs per member (highest ENC consumer card counts); business card ENCs can stack separately. Card must be open and linked to an active Bonvoy account to receive deposits.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "1 Elite Night Credit for every $5,000 spent",
      "description": "Earn 1 additional Elite Night Credit for each $5,000 in purchases; no stated cap. Credits typically post within up to 8 weeks from the last day of each calendar month in which you qualify.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 5000,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic Marriott Bonvoy Silver Elite Status",
      "description": "Automatic Silver Elite status each calendar year as a cardmember (account must be open and not in default). Initial status may take up to 8 weeks after account opening to apply.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Gold Elite Status with $35,000 calendar-year spend",
      "description": "Earn Marriott Bonvoy Gold Elite status by spending $35,000 from January 1\u2013December 31 each calendar year. Calculation resets each Jan 1. Status posts within up to 8 weeks after qualifying; account must be open and not in default.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": 35000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DoorDash DashPass (12 months)",
      "description": "Activate with the Boundless card between 02/01/2025 and 12/31/2027 to receive 12 months of DashPass for DoorDash and Caviar. Must add card as default payment and use it at checkout; excludes third\u2011party wallets; auto-renews at then-current rate after the complimentary period unless canceled; U.S. address required. Estimated value about $120 assuming ~$9.99/month.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "Access to Visa Signature Concierge; you are responsible for the cost of goods/services purchased via the concierge.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Quarterly $10 discount on DoorDash non-restaurant orders",
      "description": "With an active DashPass (activated with the Boundless card), receive a $10 discount once per calendar quarter on one qualifying non-restaurant order, applied at checkout when selected from your promotion wallet; unused value does not roll over; one redemption per quarter; U.S. only; fees/taxes/gratuity not covered.",
      "credit_category": "dining.takeoutDelivery.doordash",
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 5 Free Night Awards (each worth up to 50,000 points) plus a $100 Airline Credit after spending $3,000 in purchases within 3 months.",
      "rewards": [
        {
          "reward_type": "marriott_bonvoy",
          "new_reward_type": null,
          "amount": 250000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HW5W&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/marriott-bonvoy/boundless?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62481.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/marriottboundlesscard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "marriott_bonvoy_boundless_credit_card.png"
},
  [CreditCard.AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD]: {
  "id": CreditCard.AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD,
  "name": "American Airlines AAdvantage\u00ae MileUp\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/aadvantage-mile-up-credit-card/aadvantage-mile-up-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.AMERICAN,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.american",
      "earnRate": 2.0,
      "description": "2x AAdvantage miles per $1 on eligible American Airlines purchases. No mileage cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x AAdvantage miles per $1 at grocery stores, including grocery delivery services. No mileage cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x AAdvantage mile per $1 on all other purchases. No mileage cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable APR for purchases and balance transfers: 0.1999-0.2899 based on creditworthiness. Cash advance APR: 0.2924. Penalty APR up to 0.2999 may apply for late or returned payments. Minimum interest charge: $0.50."
  },
  "benefits": [
    {
      "name": "25% savings on eligible inflight food & beverage purchases on American Airlines",
      "description": "Receive 25% savings on inflight food and beverage purchases when you pay with your card on American Airlines flights.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Loyalty Points toward AAdvantage status",
      "description": "Earn 1 Loyalty Point for every 1 eligible AAdvantage mile earned from purchases to help qualify for AAdvantage elite status.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn 15,000 AAdvantage bonus miles after $500 in purchases within the first 3 months of account opening. Offer may vary by channel and may not be available if you leave the page. Not available if you have received a new account bonus for, or converted another Citi credit card to, an AAdvantage MileUp account in the past 48 months. Estimated value \u2248 $195 assuming ~1.3\u00a2 per AAdvantage mile.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 15000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/aadvantage-mile-up-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "american_airlines_aadvantage_mileup_card.jpg"
},
  [CreditCard.US_BANK_CASH_SECURED_VISA_CARD]: {
  "id": CreditCard.US_BANK_CASH_SECURED_VISA_CARD,
  "name": "U.S. Bank Cash+\u00ae Secured Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/us_bank_cash_secured_visa_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "Applies only to prepaid reservations made via the U.S. Bank Travel Center; not subject to the 5% category $2,000 quarterly cap per terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Applies only to prepaid reservations made via the U.S. Bank Travel Center; not subject to the 5% category $2,000 quarterly cap per terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Applies only to prepaid reservations made via the U.S. Bank Travel Center; not subject to the 5% category $2,000 quarterly cap per terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% cash back on eligible Net Purchases. If you do not enroll in quarterly categories, all purchases earn no more than 1%.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.2899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2899,
    "high": 0.2899,
    "description": "Purchase APR 28.99% variable; Balance Transfer APR 28.99% variable; Cash Advance APR 30.99% variable; Penalty APR not applicable. Minimum interest charge at least $1. Due date 24\u201330 days after close; no interest on new purchases if paid in full by due date."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://onboarding.usbank.com/usl/consumer/secured-card/application?offerId=27PPH4GHG8&locationCode=8069&sourceCode=42962",
  "learn_more_link": "https://www.usbank.com/content/usbank/us/en/credit-cards/cash-plus-secured-visa-credit-card",
  "terms_and_conditions_link": "https://applications.usbank.com/pdap/terms?locationCode=8069&offerId=27PPH4GHG8&sourceCode=88239",
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "us_bank_cash_secured_visa_card.png"
},
  [CreditCard.TD_DOUBLE_UP_CREDIT_CARD]: {
  "id": CreditCard.TD_DOUBLE_UP_CREDIT_CARD,
  "name": "TD Double Up SM Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.td.com/content/dam/tdb/images/personal-banking/td-doubleup-548x344-40-en.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Earn 2% cash back (2 points per $1) on all eligible purchases. No caps or rotating categories; account must be open and in good standing. Non\u2011purchasing transactions do not earn rewards, including balance transfers; cash advances (e.g., convenience checks; travelers checks; money orders; lottery tickets; casino chips; wire transfers; foreign currency; cryptocurrency; debt repayments; race track wagers; legal online wagers or similar betting transactions; prepaid cards; or other cash\u2011like transactions); fees; interest; disputed, unauthorized or fraudulent charges; refunds, rebates, and similar credits. Points redeem at $0.01 per point for cash back.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "Purchase APR: 19.24%, 24.24% or 29.24% variable based on creditworthiness; all APRs vary with the Prime Rate. Balance transfer APR: 0% intro for first 15 billing cycles, then 19.24%, 24.24% or 29.24% variable."
  },
  "benefits": [
    {
      "name": "Cell phone protection (Visa benefit)",
      "description": "Cell phone protection is available when you pay your monthly mobile phone bill with the TD Double Up card (per TD\u2019s Visa benefits page). Coverage details and limits are provided by Visa; enrollment not required beyond paying the bill with the card.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1500.0,
      "spendRequirementMonths": 3,
      "description": "Earn 20,000 points (redeemable for $200 as a statement credit) after $1,500 in purchases within 90 days of account opening. Bonus posts within 6\u20138 weeks if the account is open and in good standing. New accounts only; not available if you apply via a different TD offer or if you have previously received a One-Time Bonus Offer on this or another TD account. Cash equivalents (e.g., money orders, gift cards, reloads) do not qualify.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.td.com/us/en/personal-banking/byb/credit-cards?card=tddoubleup&src=8020980003",
  "learn_more_link": "https://www.td.com/us/en/personal-banking/credit-cards/double-up",
  "terms_and_conditions_link": "https://www.td.com/content/dam/tdb/document/pdf/personal-banking/tddoubleup-personal-terms-en.pdf",
  "terms_and_conditions_button_text": "*Terms and conditions",
  "additional_links": [
    {
      "name": "Find out more",
      "url": "https://www.td.com/us/en/personal-banking/credit-cards/double-up"
    }
  ],
  "bank_name": "TD Bank",
  "imageName": "td_double_up_credit_card.png"
},
  [CreditCard.AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD]: {
  "id": CreditCard.AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD,
  "name": "Aer Lingus Visa Signature\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/aer_lingus_visa_signature_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AVIOS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.aerLingus",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Aer Lingus, British Airways, Iberia, and LEVEL. Bookings must be made directly with the airline; third-party/OTA purchases may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.britishAirways",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Aer Lingus, British Airways, Iberia, and LEVEL. Bookings must be made directly with the airline; third-party/OTA purchases may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.iberia",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Aer Lingus, British Airways, Iberia, and LEVEL. Bookings must be made directly with the airline; third-party/OTA purchases may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.level",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Aer Lingus, British Airways, Iberia, and LEVEL. Bookings must be made directly with the airline; third-party/OTA purchases may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2 Avios per $1 on hotel accommodations when purchased directly with the hotel; third-party/online travel agency bookings may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 Avios per $1 on all other purchases. Non-purchase transactions (e.g., balance transfers, cash advances, cash-like transactions, fees, interest) do not earn Avios.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate. Purchase APR: 19.74%\u201328.24% (varies by creditworthiness). Balance transfer APR: 19.74%\u201328.24% (variable); balance transfer fee: 5% ($5 min); note: account may not be eligible for balance transfers. Cash advance APR: 28.99% (variable). Penalty APR: up to 29.99% (variable). Minimum interest charge: None. Grace period: at least 21 days on purchases if paid in full by due date. Foreign transactions: None."
  },
  "benefits": [
    {
      "name": "Priority boarding on Aer Lingus (U.S.\u2013Ireland routes)",
      "description": "Primary cardmembers and authorized users receive priority boarding on Aer Lingus operated flights directly between the U.S. and Ireland; show the Aer Lingus Visa at the gate. Subject to availability.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Economy Companion Ticket after $30,000 calendar-year spend",
      "description": "Earn one economy Companion Ticket voucher after $30,000 in purchases post to statements within a single calendar year. Valid only on Aer Lingus marketed and operated nonstop flights between the U.S. and Ireland; travel must originate/return in the U.S. Companion must be booked and fly round\u2011trip with the primary traveler; voucher valid 12 months from issue; book at least 30 days prior; not transferable; one voucher per calendar year. Per terms, no taxes and fees apply to the Companion Ticket. Estimated value varies widely based on route/fare; potential savings often ~$300\u2013$700+ when used on typical economy fares.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 30000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "12 months of complimentary DoorDash DashPass",
      "description": "Activate with the Aer Lingus Visa between 02/01/2025 and 12/31/2027 to receive 12 months of DashPass for DoorDash and Caviar; must use this card for DashPass\u2011eligible orders to receive benefits; auto\u2011renews at then\u2011current rate unless canceled. Estimated value about $120 (assumes ~$10/month typical DashPass price).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$10 off one DoorDash non\u2011restaurant order each quarter (with active DashPass)",
      "description": "While enrolled in the complimentary (or ongoing) DashPass and paying with this card, get $10 off one qualifying non\u2011restaurant order each calendar quarter. Does not roll over; discount applies to subtotal; fees/taxes/gratuity extra. Estimated annual value up to $40 if used every quarter.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pricing & Terms indicate no foreign transaction fees on purchases made abroad. Potential savings ~3% compared to cards that charge foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 85,000 Avios after you spend $5,000 on purchases in the first 3 months from account opening. Not available to current cardmembers of this card or previous cardmembers who received a new cardmember bonus for this card within the last 24 months. Purchases exclude cash\u2011like transactions and fees. Bonus posts 6\u20138 weeks after qualifying. Estimated value roughly $850\u2013$1,100 assuming 1.0\u20131.3 cents per Avios (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 85000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPNH&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/avios/aer-lingus?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60972.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/aerlinguscard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "aer_lingus_visa_signature_credit_card.png"
},
  [CreditCard.AMAZON_VISA]: {
  "id": CreditCard.AMAZON_VISA,
  "name": "Amazon Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/amazon_visa.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "onlineShopping.amazon",
      "earnRate": 3.0,
      "description": "Earn 3% back at Amazon.com. Not earned on transactions on Amazon.com to which you apply a promotional financing offer (Equal Pay), or on purchases at international Amazon retail sites.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "whole_foods",
      "earnRate": 3.0,
      "description": "Earn 3% back at Whole Foods Market in the U.S. and on the Whole Foods Market website. Exclusions per program terms apply.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "Chase Travel portal bookings earn 3% back; direct bookings with travel providers do not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Earn 2% back at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2% back at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "Earn 2% back on local transit and commuting purchases (including rideshare).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2799,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2799,
    "description": "Variable APRs based on the Prime Rate. Purchase APR: 0.1924\u20130.2799; Balance Transfer APR: 0.1924\u20130.2799 (account may not be eligible for balance transfers); Cash Advance APR: 0.2899; Penalty APR: up to 0.2999. Grace period: at least 21 days; minimum interest charge: none. Promotional Equal Pay financing: 0% APR on eligible Amazon.com purchases for 6\u201348 months (purchases under Equal Pay do not earn % back; any remaining balance after promo accrues interest at the standard Purchase APR). Chase Pay Over Time fee: monthly fee up to 0.0172 of the plan amount (no interest on plan balances)."
  },
  "benefits": [
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the manufacturer\u2019s U.S. warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years from purchase date).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for damage or theft for 120 days from purchase, up to $500 per item (New York: 90 days).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Reimburses up to $100 per day for up to 3 days for essential purchases when baggage is delayed over 6 hours.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "When common carrier fare (air, bus, train, or cruise) is paid with the card, provides up to $500,000 in accidental death or dismemberment coverage.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Up to $3,000 per covered traveler for checked or carry\u2011on baggage that is lost, damaged, or stolen during a covered trip (NY: additionally limited to $2,000 per bag and $10,000 total per trip).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Coverage for theft and collision damage on most rental vehicles when you decline the rental company\u2019s CDW and pay in full with the card. In the U.S., coverage is secondary to your personal insurance.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "$50 Amazon Gift Card loaded to your Amazon account upon approval (new cardmembers only; cannot currently have an Amazon Visa or Prime Visa). Estimated value: $50 (face value of the gift card).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "gift_card",
          "amount": 50.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://creditcards.chase.com/cash-back-credit-cards/amazon-rewards?CELL=6269",
  "learn_more_link": "https://creditcards.chase.com/cash-back-credit-cards/amazon-rewards?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59318.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/amazon/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "amazon_visa.png"
},
  [CreditCard.IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD]: {
  "id": CreditCard.IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD,
  "name": "IHG One Rewards Traveler Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/ihg_one_rewards_traveler_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.IHG,
  "rewards_earn_rates": [
    {
      "category": "ihg_hotels",
      "earnRate": 5.0,
      "description": "5X points per $1 on purchases at hotels participating in IHG One Rewards. IHG membership bonus points are earned separately under IHG program rules and are not part of the credit card earn rate. Merchant coding must reflect an IHG participating hotel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "billsAndUtilities",
      "earnRate": 3.0,
      "description": "3X points per $1 on utilities purchases (per issuer merchant category coding).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 3.0,
      "description": "3X points per $1 on internet, cable, and phone services (per issuer merchant category coding).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "3X points per $1 on select streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3X points per $1 on dining at restaurants (including takeout when coded as dining).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 3.0,
      "description": "3X points per $1 on eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3X points per $1 at gas stations (per issuer merchant category coding).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2X points per $1 on all other purchases not in the above categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate (7.25% as of 9/23/2025). Purchase APR: 0.1974 to 0.2824. Balance Transfer APR: 0.1974 to 0.2824. Cash Advance APR: 0.2899. Penalty APR: up to 0.2999. Grace period: at least 21 days on purchases; interest begins on balance transfers and cash advances on the transaction date. Minimum interest charge: none. Fees: balance transfer fee 0.05 (minimum $5); cash advance fee 0.05 (minimum $10); late/return payment fee up to $40. Foreign transactions: none. Note: Account may not be eligible for balance transfers. My Chase Loan APR matches Purchase APR. Chase Pay Over Time fee up to 0.0172 monthly of plan amount (no interest on plan balances)."
  },
  "benefits": [
    {
      "name": "IHG One Rewards Silver Elite status (automatic)",
      "description": "Automatic IHG One Rewards Silver Elite status for as long as you remain a Traveler cardmember (allow 6\u20138 weeks after account opening to be applied). Silver typically provides a 20% bonus on base points earned on IHG stays, per IHG program terms.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "IHG One Rewards Gold Elite status after $20,000 annual spend",
      "description": "Earn IHG One Rewards Gold Elite status through December 31 of the following year after making $20,000+ in purchases in a calendar year. Allow up to 8 weeks after qualifying for status to be applied. Account must be open and not in default.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "4th Reward Night Free on 4+ night reward stays",
      "description": "On reward stays of 4 or more consecutive nights booked with points, every 4th night is free (0 points charged for the 4th night). Unlimited uses annually. Not valid on paid stays or Points & Cash. If you cancel or check out before the 4th night, the free night is forfeited. You\u2019re responsible for incidentals and any resort fees.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10,000 bonus points each calendar year after $10,000 spend",
      "description": "Receive 10,000 IHG bonus points in each calendar year you spend at least $10,000 on the card (allow 6\u20138 weeks to post; account must be open and not in default). Estimated value \u2248 $50 assuming ~0.5\u00a2/point; actual value varies by redemption.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Save 20% on IHG points purchases when paying with the card",
      "description": "Save at least 20% on IHG One Rewards points purchases when you pay with the IHG One Rewards Traveler (also valid with IHG Premier/Premier Business). Discount cannot be combined with other points purchase offers; points bought are non-elite-qualifying. Example: if base price were 1.0\u00a2/point, a 20% discount would lower it to 0.8\u00a2/point (pricing varies by promotion).",
      "benefit_type": "points_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to IHG Reward Night sales",
      "description": "Cardmembers get early access to select IHG Reward Night sales (discounts on the points required for award nights, or the cash portion on Points & Cash). Early access applies to bookings of three or fewer consecutive Reward Nights and cannot be combined with the 4th Reward Night Free benefit on 4+ night stays. Sale details and timing are communicated by IHG via email.",
      "benefit_type": null,
      "new_benefit_type": "early_access_reward_night_sales",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 2000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 90,000 bonus points after spending $2,000 in the first 3 months, plus up to 30,000 bonus points by earning 2 Total Points per $1 on up to $15,000 in purchases in the first 6 months.",
      "rewards": [
        {
          "reward_type": "ihg",
          "new_reward_type": null,
          "amount": 90000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HVS6&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/ihg-rewards-club/traveler?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62410.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/ihgonerewardstravelercard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "ihg_one_rewards_traveler_credit_card.png"
},
  [CreditCard.WORLD_OF_HYATT_BUSINESS_CREDIT_CARD]: {
  "id": CreditCard.WORLD_OF_HYATT_BUSINESS_CREDIT_CARD,
  "name": "World of Hyatt Business Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/world_hyatt_biz_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.HYATT,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.hyatt",
      "earnRate": 4.0,
      "description": "4x Bonus Points per $1 on qualifying purchases at Hyatt hotels and resorts participating in World of Hyatt and on World of Hyatt Experiences at hyatt.com/experiences. See hyatt.com/chase-earn-terms for exclusions.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "selectable_categories",
      "earnRate": 2.0,
      "description": "2x total points per $1 in your top three spend categories each quarter from the specified list; the remaining categories from the list earn 1x that quarter. Categories list may be updated annually at chase.com/hyattbuscard2X.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": 3,
        "categories": [
          "dining",
          "shipping",
          "travel.airline",
          "travel.transit",
          "onlineAdvertising",
          "travel.rentalCar",
          "gas",
          "internetCablePhone"
        ],
        "categoryRotationFrequency": Frequency.QUARTERLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Earn a total of 2 points per $1 in the three rewards categories (from dining; shipping; airline tickets purchased directly with the airline; local transit & commuting; social media & search engine advertising; car rental agencies; gas stations; internet, cable & phone services) where you spent the most each calendar quarter. Other categories from this list that are not in your top three earn 1x.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "fitness",
      "earnRate": 2.0,
      "description": "2x Bonus Points per $1 on fitness club and gym memberships.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x Bonus Point per $1 on all other purchases not covered by higher earn categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 199.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 199.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Purchase APR: 19.74%\u201328.24% variable (based on creditworthiness; varies with Prime Rate, 7.25% as of 9/23/2025). Balance Transfer APR: 19.74%\u201328.24% variable (account may not be eligible for balance transfers). Cash Advance APR: 28.99% variable. Penalty/Default APR: up to 29.99% variable. Grace period: at least 20 days on new purchases if paid in full; no minimum interest charge."
  },
  "benefits": [
    {
      "name": "World of Hyatt Discoverist status",
      "description": "Primary cardholder receives Discoverist status for as long as the account is open and in good standing. Includes benefits like premium internet, preferred room (when available), late checkout (subject to availability), and bonus points on stays. Value varies by travel patterns.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Gift Discoverist status to up to five employees",
      "description": "At account opening, the primary cardholder receives 5 Discoverist Upgrade Awards to gift Discoverist status to up to five employees; status lasts through the remainder of the calendar year given plus the next 14 months. Employees do not need to be authorized users to receive the gifted status.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Tier-Qualifying Night credits via spend",
      "description": "Earn 5 World of Hyatt Tier-Qualifying Night credits for every $10,000 in purchases each calendar year. No cap stated. Nights post to the calendar year in which the spend occurs. Useful for accelerating elite status and Milestone Rewards.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% points redemption bonus (after $50,000 annual spend)",
      "description": "After you and any employees collectively spend $50,000 in a calendar year, you get 10% of the World of Hyatt points you redeem back for the rest of that year, on up to 200,000 points redeemed (max 20,000 points back). Applies to free nights, Points + Cash, room upgrades, on-property dining/spa and Hyatt Experiences. Not valid on Avis certificates or airline transfers. Est. max value depends on redemptions; e.g., 20,000 points back could be worth about $300 at 1.5\u00a2/point.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": 50000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Hyatt Leverage membership",
      "description": "Complimentary enrollment in Hyatt Leverage (corporate rate program) for the authorizing officer, with potential savings up to 15% off standard rates at participating Hyatt hotels (discounts vary by property and date).",
      "benefit_type": null,
      "new_benefit_type": "hyatt_leverage_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DoorDash DashPass (12 months)",
      "description": "Receive 12 months of complimentary DashPass for DoorDash and Caviar when activated for the first time with this card between 02/01/2025 and 12/31/2027. Must set the card as default payment and activate in-app. After the complimentary period, auto-renews at then-current rate unless canceled. Est. value \u2248 $120 for 12 months at ~$9.99/mo (before tax). Note: Cardholders also get up to $10 off quarterly on non-restaurant DoorDash orders through 12/31/2027 while enrolled (separate promo terms apply).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Primary auto rental collision damage waiver",
      "description": "Primary coverage for theft and collision damage when renting for business purposes, up to $60,000 for most vehicles with MSRP of $125,000 or less, when you decline the rental company\u2019s collision insurance and charge the entire rental to the card.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip cancellation and interruption insurance",
      "description": "Reimbursement up to $1,500 per covered traveler and $6,000 per trip for prepaid, non\u2011refundable passenger fares if a trip is canceled or cut short due to covered reasons (e.g., sickness, severe weather).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $10,000 per item (New York residents: 90 days).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years from purchase in total).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and emergency assistance services",
      "description": "Access to referrals for medical/legal services and other emergency assistance while traveling; cardholder pays the cost of services obtained.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 World of Hyatt Bonus Points after you spend $5,000 on purchases in the first 3 months from account opening. Not available to current cardmembers of this business card or previous cardmembers who received a new cardmember bonus for this business card within the last 24 months. Excludes non-purchase transactions (e.g., balance transfers, cash advances, cash-like transactions, fees). Bonus posts in 6\u20138 weeks after qualifying. Account must be open and not in default at fulfillment. Estimated value \u2248 $900 assuming 1.5\u00a2 per point; actual value varies by redemption.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPV2&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/world-of-hyatt/hyatt-business-card?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61036.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement",
      "url": "https://www.chase.com/worldofhyattbuscard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "world_of_hyatt_business_credit_card.png"
},
  [CreditCard.SYNCHRONY_PROJECT_CARD]: {
  "id": CreditCard.SYNCHRONY_PROJECT_CARD,
  "name": "Synchrony Project Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.synchrony.com/syc/img/synchrony_project_card_art.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2699,
    "apr_low": 0.2699
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2699,
    "high": 0.2699,
    "description": "Purchase APR 26.99% for new accounts (as of 07/16/24 and 08/29/25). Minimum Interest Charge $2. One-time Account Activation Fee of $29\u2013$69 may apply at time of first purchase, depending on merchant offer. Promotional financing available at participating contractors (e.g., No Interest if Paid in Full within 6 or 18 months; interest accrues from purchase date if not paid in full; fixed monthly payments typically equal to 2.5% of highest promo balance). Regular account terms apply to non-promo purchases and after promo period ends."
  },
  "benefits": [
    {
      "name": "Special financing (6 to 132 months)",
      "description": "Access promotional financing plans ranging from 6 to 132 months for eligible home improvement purchases. Subject to credit approval; minimum monthly payments required; terms vary by merchant and promotion.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Deferred-interest promotions at participating contractors",
      "description": "Examples include: No Interest If Paid In Full within 6 months (some merchants; $29 activation fee may apply) and No Interest If Paid In Full within 18 months (some merchants; $69 activation fee may apply). Interest accrues from purchase date if promo balance is not paid in full by end of promo; fixed monthly payments often equal to ~2.5% of highest balance. Terms vary by merchant and offer.",
      "benefit_type": null,
      "new_benefit_type": "deferred_interest_promotion",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Accepted at thousands of contractor locations",
      "description": "Use the card with a wide network of home improvement contractors and brands nationwide.",
      "benefit_type": null,
      "new_benefit_type": "acceptance_network",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "0% Fraud Liability",
      "description": "You are not responsible for unauthorized purchases made with your card.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.synchrony.com/financing/synchrony-project-card",
  "learn_more_link": "https://www.synchrony.com/financing/synchrony-project-card",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Synchrony",
  "imageName": "synchrony_project_card.png"
},
  [CreditCard.NAVY_FEDERAL_FLAGSHIP_VISA_SIGNATURE]: {
  "id": CreditCard.NAVY_FEDERAL_FLAGSHIP_VISA_SIGNATURE,
  "name": "Visa Signature\u00ae Flagship Travel Rewards Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.navyfederal.org/content/dam/card-art/flagship/flagship-sig-visa-no-name.jpg",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.NAVY_FEDERAL_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible travel purchases. Travel is typically categorized under merchant category codes such as airline, hotel, car rental, bus lines, taxis, cruise lines, time shares, parking, and transit; depending on the merchant code used, a travel purchase may only earn 2 points per $1. Eligible purchases exclude fees, interest charges, balance transfers, gambling, convenience checks, cash advances, and other cash-equivalents (e.g., money orders, gift cards, prepaid cards).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Earn 2 points per $1 on all other eligible purchases (i.e., purchases not earning the travel rate). Eligible purchases exclude fees, interest charges, balance transfers, gambling, convenience checks, cash advances, and other cash-equivalents (e.g., money orders, gift cards, prepaid cards).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 49.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.18,
    "apr_low": 0.1474
  },
  "annualFee": 49.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.0,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1474,
    "high": 0.18,
    "description": "Purchase & Balance Transfer Variable APR between 14.74% and 18.00% (as of 03/06/2026). Rates are based on creditworthiness and will vary with the market based on the U.S. Prime Rate; APR capped at 18%."
  },
  "benefits": [
    {
      "name": "Travel and Emergency Assistance (24/7)",
      "description": "24/7 access to emergency services including medical referral, lost luggage locator service and prescription assistance (terms, restrictions and exclusions may apply; see benefits guide).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Worldwide Automatic Travel Accident Insurance",
      "description": "Automatic coverage for you and your dependents for bodily injury and/or loss on a covered trip when you charge the entire common carrier fare to the card; coverage is for 1 year from the date of the accident (terms apply).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (secondary)",
      "description": "Secondary Collision Damage Waiver coverage when you rent a car for 15 days or less and pay with the card; covers physical damage/theft, reasonable towing, valid loss-of-use charges, deductible and other eligible amounts not covered by other insurance (terms apply).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Amazon Prime\u00ae Annual Membership statement credit",
      "description": "Pay the Amazon Prime annual membership fee with the card and receive a statement credit reimbursement. Not valid for monthly Prime options (Prime Monthly, Prime for Young Adults, Prime Access). Limit 1 statement credit per card account per year; allow 6\u20138 weeks to post. Navy Federal may end/modify the offer without notice.",
      "credit_type": "merchant_or_category_specific_credit",
      "credit_category": "onlineShopping.amazon",
      "new_credit_category": null,
      "value": 139.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            139.0
          ]
        }
      ],
      "total_yearly_value": 139.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    },
    {
      "name": "Global Entry / TSA Pre\u2713\u00ae application fee statement credit (up to $120)",
      "description": "Up to $120 in statement credits for Global Entry and/or TSA Pre\u2713\u00ae application fee charges made on/after account opening and charged to the card. Entitled to up to $120 per eligible card number every 4 years per program; 4-year period based on date of first qualified transaction. Allow 6\u20138 weeks to post. Navy Federal/Visa may modify or cancel without notice; approval/enrollment controlled by CBP/TSA.",
      "credit_type": "annual_credit",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "every_four_years",
          "values": [
            120.0
          ]
        }
      ],
      "total_yearly_value": 30.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": "every_four_years",
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3500.0,
      "spendRequirementMonths": 3,
      "description": "Earn 35,000 bonus points (stated $350 value) after $3,500+ in eligible purchases within 90 days of account opening for new Visa Signature\u00ae Flagship Rewards accounts. Offer valid for accounts applied for 01/02/2026\u201306/30/2026. Points post up to 8 weeks after the 90-day period; account must be open and not in default when scheduled to post; limit one promotional offer at account opening. Eligible purchases exclude fees, interest, balance transfers, gambling, convenience checks, cash advances, and other cash equivalents (money orders, gift cards, prepaid cards), and are reduced by returns/credits.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 35000.0,
          "value_unit": "points",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.navyfederal.org/loans-cards/credit-cards/flagship-visa-signature.html",
  "learn_more_link": "https://www.navyfederal.org/loans-cards/credit-cards/flagship-visa-signature.html",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Navy Federal",
  "imageName": "navy_federal_flagship_visa_signature.jpg"
},
  [CreditCard.INK_BUSINESS_CASH_CREDIT_CARD]: {
  "id": CreditCard.INK_BUSINESS_CASH_CREDIT_CARD,
  "name": "Ink Business Cash\u00ae Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_cash_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 5.0,
      "description": "Earn 5% total rewards on the first $25,000 in combined purchases at office supply stores and on internet, cable, and phone services each account anniversary year; then 1% thereafter.",
      "spendCap": 25000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "officeSupplies",
          "internetCablePhone"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Office supply stores; internet, cable, and phone services. Combined cap across these categories each account anniversary year.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "fixed_category_group",
      "earnRate": 2.0,
      "description": "Earn 2% total rewards on the first $25,000 in combined purchases at gas stations and restaurants each account anniversary year; then 1% thereafter.",
      "spendCap": 25000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "gas",
          "dining"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Gas stations and restaurants. Combined cap across these categories each account anniversary year.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% on all other purchases with no limit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2524,
    "apr_low": 0.1724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1724,
    "high": 0.2524,
    "description": "0% intro APR on purchases for 12 months from account opening; after that a 0.1724\u20130.2524 variable APR based on creditworthiness and the Prime Rate. Penalty APR up to 0.2999 may apply."
  },
  "benefits": [
    {
      "name": "Primary Auto Rental Collision Damage Waiver (CDW) for business rentals",
      "description": "Decline the rental company\u2019s collision insurance and charge the entire rental to the card. Coverage is primary when renting for business purposes and provides reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance Services",
      "description": "Access to legal and medical referrals and other travel/emergency assistance while away from home. You are responsible for the costs of any goods or services obtained.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance (dispatch)",
      "description": "Call to have help dispatched if you have a roadside emergency. Service fees are billed to your card at the time of dispatch.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days from the date of purchase against damage or theft, up to $10,000 per item. Note: New York residents have a 90\u2011day coverage period.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (up to a total of 4 years from purchase).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic credit line increase reviews",
      "description": "As a Chase cardmember, your account is automatically reviewed for a credit line increase every 6 months or sooner.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 90,000 Ultimate Rewards points (redeemable for $900 cash back) after $6,000 in purchases within the first 3 months from account opening. Offer details note that offers may vary by application channel; landing page referenced $750 strike\u2011through $900, but the Offer Details specify 90,000 points/$900. Baseline value estimate: $900 at 1.0\u00a2 per point. Per the Rewards Program Agreement, points can be combined with certain other Chase cards with Ultimate Rewards, potentially increasing value if redeemed through those cards.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 900.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HVN8&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/ink/cash?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62361.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/inkbusinesscash/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "ink_business_cash_credit_card.png"
},
  [CreditCard.CITI_AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.CITI_AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD,
  "name": "CitiBusiness\u00ae / AAdvantage\u00ae Platinum Select\u00ae Mastercard\u00ae",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citibusiness-aadvantage-platinum-select-credit-card/citibusiness-aadvantage-platinum-select-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.AMERICAN,
  "rewards_earn_rates": [
    {
      "category": "telecommunications",
      "earnRate": 2.0,
      "description": "2x AAdvantage miles per $1 at telecommunications merchants, cable and satellite providers, car rental merchants, and at gas stations. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "2x AAdvantage miles per $1 at telecommunications merchants, cable and satellite providers, car rental merchants, and at gas stations. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 2.0,
      "description": "2x AAdvantage miles per $1 at telecommunications merchants, cable and satellite providers, car rental merchants, and at gas stations. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x AAdvantage miles per $1 at telecommunications merchants, cable and satellite providers, car rental merchants, and at gas stations. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.american",
      "earnRate": 2.0,
      "description": "2x AAdvantage miles per $1 on eligible American Airlines purchases. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x AAdvantage mile per $1 on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99%\u201328.99% variable APR for purchases based on creditworthiness; cash advance APR 29.24%; penalty APR up to 29.99%; minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "First checked bag free on American Airlines (domestic)",
      "description": "First checked bag free on domestic American Airlines itineraries for the primary cardmember and up to 4 companions on the same reservation. Estimated value: about $35 per person each way when prepaid online on AA (up to ~$350 per round-trip for 5 travelers).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred boarding on American Airlines",
      "description": "Primary cardmember and up to 4 companions on the same reservation receive preferred boarding (typically Group 5), giving earlier access to overhead bin space. Subjective value varies (~$0\u2013$50 per trip depending on traveler preference).",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% savings on inflight food and beverages",
      "description": "Receive 25% savings on food and beverage purchases on American Airlines flights when you pay with the card. Savings depends on your inflight spend (e.g., $40 spend \u2192 $10 savings).",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% savings on inflight Wi\u2011Fi",
      "description": "Get 25% savings on Wi\u2011Fi purchases on American Airlines flights when you pay with the card. Example: $20 Wi\u2011Fi \u2192 $5 savings.",
      "benefit_type": "airline_wifi_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Loyalty Points toward AAdvantage status",
      "description": "Each cardmember (primary and employees) earns 1 Loyalty Point toward AAdvantage status for every $1 spent on the card. Value depends on your pursuit of AA elite status benefits.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Airlines Companion Certificate (domestic main cabin)",
      "description": "Earn a Companion Certificate for domestic main cabin travel after $30,000 or more in purchases each cardmembership year and upon account renewal. Redeeming the certificate requires a $99 ticketing fee plus taxes and fees. Estimated net value often ranges from ~$100 to $400+ after the $99 fee, depending on fare prices and route.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 30000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases made abroad. Typical savings is ~3% vs. cards that charge FTFs (e.g., $2,000 in foreign spend \u2192 ~$60 saved).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 4,
      "description": "Earn 65,000 American Airlines AAdvantage bonus miles after $4,000 in purchases in the first 4 months of account opening. Estimated value: ~$910 at ~1.4 cents per mile (valuation varies by redemption). Bonus miles post to the company\u2019s AAdvantage Business account. Not available if you have received a new account bonus for a Citi / AAdvantage Business account in the past 48 months; offers may vary by channel.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 65000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-aadvantage-business-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_aadvantage_business_world_elite_mastercard.webp"
},
  [CreditCard.PLATINUM_VISA]: {
  "id": CreditCard.PLATINUM_VISA,
  "name": "Platinum Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-suite-visa.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 1.0,
      "description": "1% cash back on gas station purchases coded as gasoline. Purchases at warehouse clubs (e.g., Sam\u2019s Club, Costco), discount supercenters (e.g., Walmart, Target), or via PayPal, and purchases from oil/propane/home heating companies are not eligible. Merchant coding must match the gasoline category to qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 1.0,
      "description": "1% cash back on grocery store purchases. Grocery purchases do NOT include superstores; stores that sell groceries and other products like drugstores and convenience stores; or smaller stores like bakeries, candy, nut, or confection shops. Purchases at warehouse clubs (e.g., Sam\u2019s Club, Costco), discount supercenters (e.g., Walmart, Target), or via PayPal are not eligible. Merchant coding must match the grocery category to qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 1.0,
      "description": "1% cash back on internet, cable, satellite TV, and mobile phone service purchases. Purchases at warehouse clubs (e.g., Sam\u2019s Club, Costco), discount supercenters (e.g., Walmart, Target), or via PayPal are not eligible. Merchant coding must match the telecommunications/service category to qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 39.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 39.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "APR 29.49% (variable rate). Variable rates are accurate as of 8/31/2025."
  },
  "benefits": [
    {
      "name": "Credit line increase reviews",
      "description": "Regular account reviews for potential credit line increases.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Experian IdentityWorks membership (online applications)",
      "description": "Optional free membership in Experian IdentityWorks when you complete and submit your application online; service provided by Experian and subject to change.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1OX_CS_19&C1BDescriptorID=AEA3806L00&C1BSpecificationID=bc-plat-plus",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/platinum-suite-visa",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/7g?pc=WL62",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [
    {
      "name": "View All Platinum Cards",
      "url": "https://www.creditonebank.com/credit-cards/platinum"
    },
    {
      "name": "Reviews",
      "url": "https://www.creditonebank.com/credit-cards/platinum-suite-visa/reviews"
    }
  ],
  "bank_name": "Credit One",
  "imageName": "platinum_visa.png"
},
  [CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS]: {
  "id": CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS,
  "name": "Bank of America\u00ae Customized Cash Rewards Credit Card for Students",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8ckn_cshsigcm_v_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "After the first 365 days, earn 3% cash back in your selected Choice Category. The $2,500 quarterly cap is combined with the 2% grocery/wholesale club category; after the cap, purchases earn 1% for the remainder of the quarter. An additional 3% boost applies during the first 12 months (modeled via signup bonus earn rate fields) before reverting to 3%.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 4.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 5.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": 3.0,
      "signupBonusEarnRateIncreaseDurationMonths": 12,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          "gas",
          {
            "categories": [
              "onlineShopping",
              "internetCablePhone",
              "phonePlans",
              "streaming"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Online shopping (purchases must be made online via website or app) plus cable, internet, phone plans, and streaming services as part of a single choice category; some non-retail services such as doctors/hospitals, government/taxes, insurance, memberships, education/schools, and some utilities are not eligible for the online shopping bonus."
          },
          "dining",
          "travel",
          "drugstore",
          {
            "categories": [
              "homeImprovement",
              "homeFurnishings"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Home improvement and home furnishings combined as one selection."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.MONTHLY,
        "categoriesDescription": "Ongoing Choice Category earning after the first year: choose one of the listed categories; you can change your selection once per calendar month.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "Automatic 2% cash back at grocery stores and wholesale clubs. Included examples per program: supermarkets, meat/seafood markets, candy/nut/confection stores, dairy stores, and bakeries. Excludes superstores and smaller stores (e.g., drug stores) that sell groceries and other products. Shares the $2,500 combined quarterly cap with the Choice Category (3%/6% earnings); after the cap, these purchases earn 1% for the remainder of the quarter.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "wholesaleClub",
      "earnRate": 2.0,
      "description": "Automatic 2% cash back at grocery stores and wholesale clubs. Included examples per program: supermarkets, meat/seafood markets, candy/nut/confection stores, dairy stores, and bakeries. Excludes superstores and smaller stores (e.g., drug stores) that sell groceries and other products. Shares the $2,500 combined quarterly cap with the Choice Category (3%/6% earnings); after the cap, these purchases earn 1% for the remainder of the quarter.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Unlimited 1% cash back on all other purchases and on 2%/3% category purchases after the combined quarterly cap is reached. Balance transfers, cash advances, fees, and interest do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 1.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 1.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "0.0000 intro APR for 15 billing cycles on purchases and on balance transfers made within 60 days of account opening; then variable purchase/balance transfer APR 0.1824\u20130.2824 based on creditworthiness (varies with Prime). Cash advance APR 0.2124\u20130.2924 (Bank Cash Advances 0.2924). Penalty APR up to 0.2999 may apply indefinitely for late payment."
  },
  "benefits": [
    {
      "name": "Preferred Rewards bonus (25%\u201375% more cash back)",
      "description": "Bank of America Preferred Rewards members earn 25%\u201375% more cash back on every purchase. Preferred Rewards bonuses are not applied to the 3% first-year Choice Category bonus. Membership eligibility and tiers required per Bank of America program rules.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Two-part new cardmember offer: (1) $200 online cash rewards after $1,000 in purchases within 90 days of account opening; (2) an additional 3% cash back in the selected Choice Category for the first 365 days from account opening (total 6% in that category during the first year), subject to the $2,500 per-quarter combined cap across Choice Category (3%) and grocery/wholesale (2%) purchases. Online-only offer; may not be available at branches or by phone. Limit 1 bonus per new account; account must be open with active charging privileges. Purchases only; balance transfers, cash advances, fees, and certain other charges excluded. Returns/credits reduce qualifying purchases. $200 bonus typically posts within 1\u20132 billing cycles after qualification. Preferred Rewards bonus does not apply to the extra 3% first-year earnings. Estimated value note: The additional 3% first-year category bonus can be worth up to ~$300 if you spend the full $2,500 cap each quarter exclusively in the Choice Category ($10,000 total x 3%).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076372&productOfferCode=DA&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/student-cash-back-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076372&productoffercode=DA&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Customized Cash Rewards credit card for Students",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_customized_cash_rewards_for_students.png"
},
  [CreditCard.AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD,
  "name": "AAdvantage\u00ae Aviator\u00ae Red World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-front/AA_card_Red_WE_Flat_359x246.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.american",
      "earnRate": 2.0,
      "description": "Earn 2 AAdvantage miles per $1 on eligible American Airlines purchases made directly with American Airlines.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 AAdvantage mile per $1 on all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchases: 20.24%\u201329.99% variable APR based on creditworthiness (varies with Prime). Balance transfers: 0% intro APR for 15 billing cycles on transfers that post within 45 days of account opening; thereafter 20.24%\u201329.99% variable (varies with Prime). Cash advances: 29.99% variable. Minimum monthly interest charge: $0.50."
  },
  "benefits": [
    {
      "name": "Companion Certificate (anniversary)",
      "description": "Each anniversary year, earn a Companion Certificate good for 1 guest at $99 plus taxes and fees after $20,000 in purchases and if your account remains open for 45 days after your anniversary date. Estimated value: varies by fare; for a $200\u2013$400 domestic round-trip, potential savings \u2248 fare price minus $99 (+ taxes/fees).",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "First checked bag free",
      "description": "First checked bag free on American Airlines operated flights for the primary cardmember and up to 4 companions on the same reservation. Estimated value: about $35 each way per person on AA; round-trip savings \u2248 $70 per person (up to $350 for 5 travelers).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred boarding",
      "description": "Preferred boarding on domestic American Airlines itineraries for the primary cardmember and up to 4 companions on the same reservation.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% in-flight savings on food and beverages",
      "description": "Receive 25% back as statement credits on in-flight food and beverage purchases on American Airlines operated flights when you pay with the card. Example value: spend $40 in-flight in a year \u2192 get $10 back.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases. Estimated value: saves about 3% versus cards that charge foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption",
      "description": "Coverage for trip cancellation and interruption (limits and exclusions apply; see Guide to Benefits). Value varies by claim.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Reimbursement for essential items when a covered baggage delay occurs (limits/exclusions apply). Value varies by delay and policy limits.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Coverage for damage due to collision or theft when renting a car (see Guide to Benefits for details; coverage typically secondary in the U.S.).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Accidental death and dismemberment coverage while traveling (limits and exclusions apply; see Guide to Benefits).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "World Elite Mastercard travel services",
      "description": "Access to a suite of benefits, amenities, upgrades, preferential treatment and premium travel offers from select travel partners (availability varies by issuer and Mastercard).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/aadvantage-aviator-red-world-elite-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/aadvantage-aviator-red-world-elite-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "aadvantageaviatorred_world_elite_mastercard.png"
},
  [CreditCard.SAVOR_REWARDS_FOR_GOOD_CREDIT]: {
  "id": CreditCard.SAVOR_REWARDS_FOR_GOOD_CREDIT,
  "name": "Savor Rewards for Good Credit",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/new-savor-card-art.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "Earn 3% cash back at grocery stores; excludes superstores like Walmart and Target.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Purchases at restaurants, cafes, bars, lounges, fast-food chains and bakeries.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "entertainment",
      "earnRate": 3.0,
      "description": "Ticket purchases at movie theaters, sports promoters (professional and semi-professional live events), theatrical promoters, amusement parks, tourist attractions, aquariums, zoos, dance halls, record stores, pool halls, and bowling alleys; excludes golf courses, collegiate sporting events, and non-industry entertainment merchant codes like cable, digital streaming and membership services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "Popular streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other purchases that do not fall under higher bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "29.74% variable APR for purchases; no 0% intro APR. Balance transfers: 29.74% variable APR; balance transfer fee applies (percentage not disclosed)."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making purchases outside of the United States. Estimated value: typically saves about 3% of foreign spend versus cards that charge foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Concierge Service",
      "description": "Comprehensive, personalized assistance in dining, entertainment and travel\u2014available 24/7/365.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Additional warranty protection at no charge on eligible items purchased with the card. Terms and exclusions apply per your Guide to Benefits.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24-hour Travel Assistance Services",
      "description": "If your card is lost or stolen, you can get an emergency replacement card and a cash advance. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Automatic insurance for a covered loss at no extra charge when you use your card to purchase your fare. Refer to the Guide to Benefits for coverage details and exclusions.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star Status",
      "description": "Enroll via the Benefits tab to receive Hertz Five Star status, which may include a wider vehicle selection and skipping the counter at select locations. Status effective 24\u201372 hours after registration; Hertz terms apply. Estimated value: varies by rental; potential time savings and occasional upgrades.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining Access",
      "description": "Access to cardholder-only reservations at award\u2011winning restaurants and tickets to curated culinary events.",
      "benefit_type": null,
      "new_benefit_type": "dining_reservations_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment Access",
      "description": "Access to select events through the Capital One Entertainment platform. (Note: the separate 8% earn rate on Capital One Entertainment purchases is a rewards rate, not a benefit.)",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Caf\u00e9 Beverage Discount",
      "description": "50% off all handcrafted beverages every day at Capital One Caf\u00e9s nationwide; limit one per person, while supplies last. Estimated value: roughly $2\u2013$3 savings per visit based on typical beverage prices.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/savor-good-credit/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/savor-good-credit/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "savor_rewards_for_good_credit.png"
},
  [CreditCard.US_BANK_BUSINESS_TRIPLE_CASH_REWARDS_VISA]: {
  "id": CreditCard.US_BANK_BUSINESS_TRIPLE_CASH_REWARDS_VISA,
  "name": "U.S. Bank Triple Cash Rewards Visa\u00ae Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.usbank.com/content/dam/usbank/en/images/illustrations/illustrations-business-triple-cash-back.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% cash back at gas stations on transactions of $200 or less; purchases greater than $200 at gas stations earn 1%. Excludes wholesale clubs and discount stores/supercenters (e.g., Costco, Walmart, Target).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.evCharging",
      "earnRate": 3.0,
      "description": "3% cash back at EV charging stations on transactions of $200 or less; purchases greater than $200 earn 1%. Excludes wholesale clubs and discount stores/supercenters (e.g., Costco, Walmart, Target).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "officeSupplies",
      "earnRate": 3.0,
      "description": "3% cash back at office supply stores. Excludes wholesale clubs and discount stores/supercenters.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 3.0,
      "description": "3% cash back with cell phone service providers. Excludes wholesale clubs and discount stores/supercenters.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3% cash back at restaurants. Excludes wholesale clubs and discount stores/supercenters.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 3.0,
      "description": "3% cash back on restaurant delivery. Excludes wholesale clubs and discount stores/supercenters.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5% cash back on prepaid hotel reservations booked directly in the U.S. Bank Travel Center using this card.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5% cash back on prepaid car rentals booked directly in the U.S. Bank Travel Center using this card.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other eligible purchases. No limit on total rewards earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2624,
    "apr_low": 0.1724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1724,
    "high": 0.2624,
    "description": "0.0 introductory APR on purchases and on balance transfers made within 30 days of account opening for the first 12 billing cycles; after that, a variable APR currently ranges from 0.1724 to 0.2624. Intro APR does not apply to cash advances. APRs may end early and increase to the purchase/balance transfer APR or a Penalty APR if you pay late, a payment is returned, or you exceed your credit limit."
  },
  "benefits": [],
  "credits": [
    {
      "name": "Annual software services statement credit",
      "description": "Automatic $100 statement credit per 12-month period after 11 consecutive months of eligible software service purchases made directly with a software service provider (by MCC). Purchases at discount/retail stores or online retailers may not qualify. Posts within 1\u20132 billing cycles after qualification. U.S. Bank may adjust or reverse for ineligible or reversed transactions.",
      "credit_type": "annual_credit",
      "credit_category": {
        "categories": [
          "computerServices"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Eligible recurring software service providers identified by MCC (e.g., accounting or bookkeeping software like FreshBooks or QuickBooks) purchased directly from the provider."
      },
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            100.0
          ]
        }
      ],
      "total_yearly_value": 100.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "Earn a one-time $750 cash back bonus after you spend $6,000 in eligible net purchases on the Account Owner\u2019s Card within 180 days of account opening. Only spend on the Account Owner\u2019s Card counts (authorized employee cards do not count). Cash back is typically credited within 1\u20132 billing cycles after meeting the requirement. Offer may not be combined with other offers; subject to credit approval.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 750.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.usbank.com/business-banking/business-credit-cards/business-triple-cash-back-credit-card.html",
  "learn_more_link": "https://www.usbank.com/business-banking/business-credit-cards/business-triple-cash-back-credit-card.html",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "us_bank_business_triple_cash_rewards_visa.png"
},
  [CreditCard.KROGER_REWARDS_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.KROGER_REWARDS_WORLD_ELITE_MASTERCARD,
  "name": "Kroger Rewards World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.krogermastercard.com/credit/mc_kroger/images/kroger_hero_xs.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases.mobileWallet",
      "earnRate": 5.0,
      "description": "Kroger Pay (issuer\u2019s proprietary mobile payment) earns 5% up to $3,000 per calendar year, then 2% on additional Kroger Pay spend. Fuel center purchases at Kroger Family of Companies do not earn any rewards.",
      "spendCap": 3000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on purchases outside Kroger Family of Companies stores and on other eligible purchases not receiving a higher category rate. Purchases at Kroger Family of Companies Fuel Centers do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Free Kroger Boost Essential membership (Next-Day Delivery) upon approval and enrollment",
      "description": "New cardmembers who apply, are approved, and complete Boost enrollment (providing payment info) receive a free Boost Essential membership for the first year (estimated $69 value). If choosing the Same-Day Boost ($99/year), a $69 waiver applies upon enrollment. Membership auto-renews unless canceled; one free membership per household; offer cannot be used to pay for an existing Boost membership. While active, Boost includes benefits like next-day delivery and 2x Fuel Points on qualifying in-store, pickup, and delivery purchases (exclusions include gift cards, alcohol, tobacco, prescriptions, fuel purchases, and other listed categories).",
      "benefit_type": null,
      "new_benefit_type": "kroger_boost_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "2x Fuel Points on qualifying Kroger purchases via Boost membership",
      "description": "With the included Boost membership, earn 2x Fuel Points on qualifying in-store, curbside pickup, and delivery purchases ($1 spend = 1 Fuel Point + 1 bonus Fuel Point). Exclusions: gift cards, adult beverage, tobacco products, pharmacy prescriptions, Booth Service, Kroger Ship, The Little Clinic, Fred Meyer Direct, Fred Meyer Jewelry, Vitacost, homechef.com, murrayscheese.com, fuel purchases, Kroger Rush Delivery, Kroger Delivery Now, or receipt message survey invitations. Fuel Points redeemable at participating fuel locations. Availability and value depend on maintaining Boost membership (free first year via card offer).",
      "benefit_type": null,
      "new_benefit_type": "fuel_points_multiplier",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $100 statement credit after $500 in net purchases within 90 days of account opening. New cardmembers only; limited-time offer; subject to credit approval. Statement credit typically posts 6\u20138 weeks after the promotion period. Account must be open and in good standing to receive the bonus.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.krogermastercard.com/",
  "learn_more_link": "https://www.krogermastercard.com/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "kroger_rewards_world_elite_mastercard.png"
},
  [CreditCard.CITI_SIMPLICITY_CREDIT_CARD]: {
  "id": CreditCard.CITI_SIMPLICITY_CREDIT_CARD,
  "name": "Citi Simplicity\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-simplicity/citi-simplicity_90x57.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2874,
    "apr_low": 0.1799
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.2874,
    "description": "0% intro APR for 12 months on purchases and 21 months on balance transfers (for transfers completed within 4 months of account opening). After the promo periods, variable APR 0.1799-0.2874 based on creditworthiness; cash advance APR 0.2924; minimum interest charge $0.50. Balance transfer fee: 0.03 ($5 min) within first 4 months; thereafter 0.05 ($5 min). No late fees and no penalty APR. Annual fee: none."
  },
  "benefits": [
    {
      "name": "0% Intro APR on balance transfers for 21 months",
      "description": "0% introductory APR for 21 months on balance transfers from account opening; after that, variable APR 17.99%\u201328.74% based on creditworthiness. Balance transfer fee: Intro 3% ($5 min) on transfers completed within the first 4 months, then 5% ($5 min). Note: If you transfer a balance, interest may be charged on new purchases after the purchase 0% period ends unless you pay your full balance (including the transferred amount) each month. Estimated value example: Transferring $5,000 from a 20% APR card could avoid roughly ~$1,750 in interest over 21 months (simple interest approximation: $5,000 \u00d7 20% \u00d7 1.75), before accounting for transfer fees and actual amortization.",
      "benefit_type": null,
      "new_benefit_type": "intro_apr_balance_transfers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "0% Intro APR on purchases for 12 months",
      "description": "0% introductory APR for 12 months on purchases from account opening; after that, variable APR 17.99%\u201328.74% based on creditworthiness. Estimated value example: Carrying a $1,000 average purchase balance for 12 months at 20% APR would avoid about ~$200 in interest during the intro period (simple interest approximation), assuming you would have otherwise carried that balance.",
      "benefit_type": null,
      "new_benefit_type": "intro_apr_purchases",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No annual fee",
      "description": "$0 annual fee, ever. Potential value: saves the annual fee every year versus cards that charge one (actual savings depend on the fee you would otherwise pay).",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No late fees",
      "description": "No late payment fees, ever. Note: Paying late may still result in interest charges; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "no_late_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No penalty APR",
      "description": "Your APR won\u2019t increase due to a late payment (no penalty rate).",
      "benefit_type": null,
      "new_benefit_type": "no_penalty_apr",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 liability on unauthorized charges",
      "description": "You are not responsible for unauthorized charges made on your account (Mastercard $0 liability).",
      "benefit_type": null,
      "new_benefit_type": "zero_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "ID Theft Protection (Mastercard)",
      "description": "Free identity theft protection program from Mastercard (enrollment required) that monitors your chosen information and alerts you to suspicious activity.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Flexible payment due date",
      "description": "Choose a payment due date in the beginning, middle, or end of the month for added flexibility.",
      "benefit_type": null,
      "new_benefit_type": "flexible_payment_due_date",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-simplicity-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "See if You're Pre-qualified",
      "url": "https://online.citi.com/US/ag/cards/pre-screen?intc=citihpmenu_creditcards_pq&PP=citi-simplicity&OC=CC-CITI-3CY"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_simplicity_credit_card.png"
},
  [CreditCard.TRUIST_ENJOY_CASH_CREDIT_CARD]: {
  "id": CreditCard.TRUIST_ENJOY_CASH_CREDIT_CARD,
  "name": "Truist Enjoy Cash Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/truist_enjoy_cash_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% cash back on gas and EV charging, subject to combined $1,000/month cap with grocery/utility categories.",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.MONTHLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.evCharging",
      "earnRate": 3.0,
      "description": "3% cash back on gas and EV charging, subject to combined $1,000/month cap with grocery/utility categories.",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.MONTHLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% cash back on groceries and utilities, subject to combined $1,000/month cap with gas/EV categories.",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.MONTHLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "utilities",
      "earnRate": 2.0,
      "description": "2% cash back on groceries and utilities, subject to combined $1,000/month cap with gas/EV categories.",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.MONTHLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2774,
    "apr_low": 0.1874
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1874,
    "high": 0.2774,
    "description": ""
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": null,
  "learn_more_link": "https://www.truist.com/credit-cards/enjoy-cash",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Truist",
  "imageName": "truist_enjoy_cash_credit_card.png"
},
  [CreditCard.SYNCHRONY_AMAZON_STORE_CARD]: {
  "id": CreditCard.SYNCHRONY_AMAZON_STORE_CARD,
  "name": "Amazon Store Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "/cards/synchrony_amazon_store_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.amazon.com/dp/B008A0GNA8?intcmp=NoOff_AmazonStoreCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.amazon.com/dp/B008A0GNA8?intcmp=NoOff_AmazonStoreCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Synchrony",
  "imageName": "synchrony_amazon_store_card.png"
},
  [CreditCard.NHL_DISCOVER_IT_CREDIT_CARD]: {
  "id": CreditCard.NHL_DISCOVER_IT_CREDIT_CARD,
  "name": "NHL\u00ae Discover It\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "/cards/nhl_discover_it_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "quarterly_categories",
      "earnRate": 5.0,
      "description": "Earn 5% cash back in rotating quarterly categories on up to $1,500 in combined purchases each quarter when you activate.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only",
        "activation_required"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "grocery",
              "wholesaleClub",
              "streaming"
            ],
            "exclude_subcategories": [
              "walmart",
              "target"
            ],
            "is_us_only": true,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": "Q1",
            "start_date": "2026-01-01",
            "end_date": "2026-03-31",
            "category_description": "January\u2013March 2026: 5% at Grocery Stores (supermarkets, meat lockers, bakeries, smaller groceries, grocery delivery; excludes purchases from Walmart and Target), Wholesale Clubs (club acceptance varies; affiliated services may not qualify), and Select Streaming Services (examples include Amazon Music/Prime Video, AMC+, Apple Music/TV, Audible, DirecTV Stream, Fandango at Home, Google Play, Max, iHeartRadio, MLB.TV, Netflix, Pandora, Paramount+, Peacock, SiriusXM, Sling TV, Spotify, Starz, YouTube Music/Premium/TV; bundles/third-party billing may not qualify)."
          }
        ],
        "categoryRotationFrequency": Frequency.QUARTERLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Rotating 5% Cashback Bonus categories change automatically each quarter; activation required each quarter; valid on U.S. merchant purchases only. Known quarters include 2025 Q1 Restaurants/Home Improvement/Select Streaming; 2025 Q2 Grocery/Wholesale Clubs; 2025 Q3 Gas & EV Charging/Public Transit/Utilities; 2025 Q4 Amazon.com/Drug Stores; 2026 Q1 Grocery/Wholesale Clubs/Select Streaming.",
        "startDate": null,
        "endDate": null
      }
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "5% Cashback Bonus rotating categories (activation required)",
      "description": "Earn 5% Cashback Bonus in rotating categories on up to $1,500 in purchases each quarter when you activate (U.S. merchants; MCC eligibility applies). That\u2019s up to $75 per quarter (up to $300/year if all quarters are maximized). 2025 categories: Q1 Restaurants, Home Improvement Stores, Select Streaming Services; Q2 Grocery Stores and Wholesale Clubs; Q3 Gas Stations & EV Charging, Public Transit, Utilities; Q4 Amazon.com and Drug Stores. 2026 Q1: Grocery Stores, Wholesale Clubs, Select Streaming Services.",
      "benefit_type": "rotating_quarterly_rewards",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.discovercard.com/application/website/apply?srcCde=GJVV&ICMPGN=ALL_CC_NHL_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "learn_more_link": "https://www.discovercard.com/application/website/apply?srcCde=GJVV&ICMPGN=ALL_CC_NHL_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://www.discover.com/credit-cards/cash-back/cashback-calendar.html?link=%2Fweb%2Frewards%2F5percent%2F"
    }
  ],
  "bank_name": "Discover",
  "imageName": "nhl_discover_it_credit_card.png"
},
  [CreditCard.BLUE_BUSINESS_PLUS_CREDIT_CARD]: {
  "id": CreditCard.BLUE_BUSINESS_PLUS_CREDIT_CARD,
  "name": "Blue Business\u00ae Plus Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/blue-business-plus.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2X total Membership Rewards points on eligible purchases, up to $50,000 per calendar year. Excludes purchases on AmexTravel.com or the Amex Travel App from both the 2X bonus and the $50,000 cap tally.",
      "spendCap": 50000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2X total Membership Rewards points on eligible travel booked through the American Express Travel portal (AmexTravel.com/App), including air, prepaid hotels, prepaid short-term rentals, prepaid car rentals, and cruise reservations; non-prepaid bookings and ticketing or service fees are excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal",
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X Membership Rewards point per dollar on eligible purchases with no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2724,
    "apr_low": 0.1724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.027,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1724,
    "high": 0.2724,
    "description": "0% introductory APR on purchases for 12 months from account opening, then a variable APR of 17.24%\u201327.24% (Prime Rate + 9.99% to +19.99%), based on creditworthiness; Penalty APR 29.99% may apply for late/returned payments. Variable APRs will not exceed 29.99%. Balance transfers (if eligible) accrue interest from the transaction date."
  },
  "benefits": [
    {
      "name": "Membership Rewards Points Transfer",
      "description": "Transfer Membership Rewards points to participating airline and hotel partners (excise tax offset fee may apply to U.S. airline transfers; up to $0.0006 per point, max $99). Can unlock higher redemption value vs. cash back or Pay With Points.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance for travel emergencies when you\u2019re more than 100 miles from home. Third\u2011party service provider costs are the cardmember\u2019s responsibility.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss & Damage Insurance",
      "description": "Coverage for damage or theft to a rental vehicle when you pay with your card and decline the rental company\u2019s CDW/LDW (terms, exclusions and country/vehicle restrictions apply). Typically secondary coverage.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original manufacturer\u2019s warranty on eligible items purchased with the card (terms, exclusions, and limits apply).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible purchases against accidental damage or theft for a limited period after the purchase (terms, exclusions, and limits apply).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Expanded Buying Power",
      "description": "Ability to spend above your credit limit based on factors like account usage and payment history; amount above the limit is due in full each month and penalty APR may apply if the minimum due isn\u2019t paid by the closing date.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Insider Fares (Amex Travel Pay With Points)",
      "description": "On select flights booked via AmexTravel.com, fewer Membership Rewards points may be required when using Pay With Points (availability varies by flight).",
      "benefit_type": null,
      "new_benefit_type": "insider_fares",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you book a qualifying hotel on AmexTravel.com and then find the same room and rate type cheaper online, Amex will refund the difference (exclusions apply; see terms).",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rates_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Presale Tickets",
      "description": "Access to purchase presale tickets for select events using an Amex card (availability, seat inventory, and purchase limits vary by event; terms apply).",
      "benefit_type": null,
      "new_benefit_type": "amex_presale_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Reserved Tickets",
      "description": "Access to select seats reserved for Amex cardmembers at certain events (availability and limits vary; terms apply).",
      "benefit_type": null,
      "new_benefit_type": "amex_reserved_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Entrances & Fast Lanes",
      "description": "Cardmember entrances and/or dedicated fast lanes at select stadiums and arenas within the Amex Venue Collection (availability varies by venue and event; valid event ticket and Amex card required).",
      "benefit_type": null,
      "new_benefit_type": "amex_venue_collection_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Targeted merchant offers that can provide additional rewards or statement credits after enrollment and eligible spend (offers vary by cardmember and time).",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "American Express Venue Collection Concessions Statement Credit",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at venues in the Amex Venue Collection, up to $250 back per calendar year after enrollment (offer currently through Dec 31, 2026; exclusions apply).",
      "credit_type": "american_express_venue_collection_concessions",
      "credit_category": null,
      "new_credit_category": "venue_concessions",
      "value": 250.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": 10.0
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 15,000 Membership Rewards points after $3,000 in eligible purchases within the first 3 months of card membership. Points post 8\u201312 weeks after meeting the threshold. Excludes fees/interest, cash equivalents, gift cards, person\u2011to\u2011person payments, and similar. Eligibility restrictions apply if you have or have had this card. Estimated value: about $150 at 1.0\u00a2/point when using Pay With Points for flights via Amex Travel; potentially higher via partner transfers (value varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 15000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-blue-business-plus-credit-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-BlueForBusinessPlus",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-blue-business-plus-credit-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-BlueForBusinessPlus",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/bluebusinessplus-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/bluebusinessplus-credit-card/45094-AJTnC-0/?pznOfferCode=&rsvpFlag=&rc=&zc=&ch=&key=tncBody"
    }
  ],
  "bank_name": "American Express",
  "imageName": "blue_business_plus_credit_card.png"
},
  [CreditCard.CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD,
  "name": "Credit One Bank Wander\u00ae American Express\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/wander-amex-ocean.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 10.0,
      "description": "10x points on eligible hotel stays and car rentals booked through the designated travel partner portal; Additional Points (the extra 5x) typically post within 90 days after the stay/rental is used. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 10.0,
      "description": "10x points on eligible hotel stays and car rentals booked through the designated travel partner portal; Additional Points (the extra 5x) typically post within 90 days after the stay/rental is used. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "5x points on flights (airline purchases) coded in the travel category. Purchases at non-travel merchants (e.g., grocery stores, discount supercenters, warehouse clubs) do not qualify for 5x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 5.0,
      "description": "5x points on eligible restaurants (including cafes, bars, nightclubs, lounges, and fast food). Purchases at grocery stores, bakeries, candy/nut/confection shops, drugstores, convenience stores, warehouse clubs, and discount supercenters do not qualify for 5x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5x points on gasoline purchases at gas stations. Purchases from oil, propane, or at\u2011home heating companies do not qualify for 5x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5x points on hotel stays NOT purchased via the designated travel partner portal. Hotel stays booked via the portal earn 10x (or 5x if booked as part of a hotel+car package).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5x points on car rentals NOT purchased via the designated travel partner portal. Car rentals booked via the portal earn 10x when booked directly (or 5x if booked as part of a hotel+car package).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x points on all other purchases. No points on cash\u2011like transactions (e.g., travelers checks, foreign currency, money orders, wire transfers). Points are rounded to the nearest whole dollar; purchases of $0.99 or less earn no points. No cap on points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 95.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "29.49% variable APR (purchase); variable rates accurate as of 8/31/2025."
  },
  "benefits": [
    {
      "name": "Travel Accident Insurance",
      "description": "Coverage when you use your Wander card to secure travel transactions. Terms, conditions, and exclusions apply; see Guide to Benefits.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Retail Protection (American Express Network)",
      "description": "American Express network Retail Protection on eligible purchases. See network benefits for details and exclusions.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Experian IdentityWorks membership",
      "description": "Optional free membership in Experian IdentityWorks when you complete and submit your application online; separate registration required. Service subject to change.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Offers",
      "description": "Access to Amex Offers for shopping, dining, and travel deals through the American Express network.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers_merchant_discounts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1AT_CS_05&C1BSpecificationID=bc-wander-card",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/wander-american-express",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/7as?pc=WXC4",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [],
  "bank_name": "Credit One",
  "imageName": "credit_one_bank_wander_american_express_card.png"
},
  [CreditCard.PENFED_PATHFINDER_REWARDS_VISA_SIGNATURE]: {
  "id": CreditCard.PENFED_PATHFINDER_REWARDS_VISA_SIGNATURE,
  "name": "PenFed Pathfinder\u00ae Rewards Visa Signature\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/penfed_pathfinder_rewards_visa_signature.webp",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.PENFED,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "3X points on travel (4X with Honors Advantage). No caps.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "4X on travel with PenFed Honors Advantage membership",
          "promotional_type": PromotionalType.PENFED_HONORS_ADVANTAGE
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2X points on dining (3X with Honors Advantage). No caps.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "3X on dining with PenFed Honors Advantage membership",
          "promotional_type": PromotionalType.PENFED_HONORS_ADVANTAGE
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5X points on all other purchases. No caps.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.1799,
    "apr_low": 0.1799
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.1799,
    "description": "Variable Purchase APR of 17.99% based on creditworthiness. 0% introductory APR for 12 months on balance transfers made in the first 60 days after account opening, then 17.99%. 3% balance transfer fee."
  },
  "benefits": [
    {
      "name": "Global Entry or TSA PreCheck Credit",
      "description": "Receive a statement credit of up to $120 for Global Entry or $85 for TSA PreCheck every 4 years when you charge the fee to your card.",
      "benefit_type": null,
      "new_benefit_type": "travel_credit",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": "every_four_years",
      "requires_authorized_user": false
    },
    {
      "name": "Airline Ancillary Credit",
      "description": "Receive statement credits up to $100 per calendar year toward incidental air travel fees such as baggage fees, flight-change fees, in-flight food and beverage purchases, airport lounge day-passes and more.",
      "benefit_type": null,
      "new_benefit_type": "travel_credit",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass Lounge Membership",
      "description": "Access over 1,200 VIP lounges worldwide with a complimentary annual Priority Pass Select membership, with an accompanying guest. Lounge visit fees apply.",
      "benefit_type": null,
      "new_benefit_type": "lounge_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "Using your PenFed card abroad won't cost you an extra dime.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Use your card to rent a vehicle and you're automatically protected for physical damage, theft, reasonable and customary towing, and loss-of-use charges.",
      "benefit_type": null,
      "new_benefit_type": "rental_car_insurance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Reimbursement",
      "description": "Covers up to $300 per purchased ticket for reasonable expenses incurred when your trip is delayed for more than 12 hours.",
      "benefit_type": null,
      "new_benefit_type": "trip_delay_insurance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge Service",
      "description": "Visa's concierge service is available 24/7 for travel, dining, and entertainment needs.",
      "benefit_type": null,
      "new_benefit_type": "concierge",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Luxury Hotel Collection Access",
      "description": "Access to luxury hotels worldwide with premium offers and discounts through Visa Signature.",
      "benefit_type": null,
      "new_benefit_type": "hotel_program",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "Protect your cell phone against theft and damage for the next calendar month by paying your monthly wireless bill with your PenFed credit card.",
      "benefit_type": null,
      "new_benefit_type": "cell_phone_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Fraud Liability",
      "description": "You will not be responsible for unauthorized charges if your card is lost or stolen.",
      "benefit_type": null,
      "new_benefit_type": "fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Airline Ancillary Credit",
      "description": "Up to $100 per calendar year toward incidental air travel fees such as baggage fees, flight-change fees, in-flight food and beverage purchases, airport lounge day-passes and more.",
      "credit_category": "travel.airline",
      "new_credit_category": "airline_ancillary",
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry / TSA PreCheck Credit",
      "description": "Up to $120 for Global Entry or $85 for TSA PreCheck every 4 years when you charge the fee to your card.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": "every_four_years"
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 50,000 bonus points when you spend $3,000 in purchase transactions within the first 90 days of account opening. Points valued at up to $500 depending on redemption method (minimum $0.0085/point, up to $0.01/point).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.penfed.org/credit-cards/pathfinder-rewards-visa",
  "learn_more_link": "https://www.penfed.org/credit-cards/pathfinder-rewards-visa",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "PenFed",
  "imageName": "penfed_pathfinder_rewards_visa_signature.webp"
},
  [CreditCard.BJS_ONE_MASTERCARD]: {
  "id": CreditCard.BJS_ONE_MASTERCARD,
  "name": "BJ\u2019s One\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/www-bj-one-mc-240x151.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "Variable purchase APR of 19.24%\u201329.24% based on creditworthiness; rates may change with the Prime Rate."
  },
  "benefits": [
    {
      "name": "10\u00a2 off per gallon at BJ\u2019s Gas",
      "description": "Receive an instant discount of $0.10 per gallon at BJ\u2019s Gas when you pay with the BJ\u2019s One Mastercard and scan your BJ\u2019s membership card. Discount applied after sale and before payment in MD and NJ; subject to state restrictions. Estimated value: about $50/year assuming ~500 gallons purchased annually (0.10 \u00d7 500).",
      "benefit_type": null,
      "new_benefit_type": "fuel_discount_at_bjs_gas",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rewards never expire (for life of account)",
      "description": "Rewards earned with the card do not expire for the life of the account. Minimum $10 in rewards required to redeem; minimum eligible purchase amount is $10 at BJ\u2019s checkout.",
      "benefit_type": null,
      "new_benefit_type": "rewards_never_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No cap on rewards earned",
      "description": "There is no cap to the amount of rewards you can earn on eligible purchases with the BJ\u2019s One Mastercard.",
      "benefit_type": null,
      "new_benefit_type": "no_cap_on_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/bjs-wholesale-club/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/bjs-wholesale-club/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "bjs_one_mastercard.png"
},
  [CreditCard.US_BANK_SMARTLY_VISA_SIGNATURE_CARD]: {
  "id": CreditCard.US_BANK_SMARTLY_VISA_SIGNATURE_CARD,
  "name": "U.S. Bank Smartly\u2122 Visa Signature\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/us_bank_smartly_visa_signature_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Base earn rate: 2 points per $1 on eligible net purchases. Applies to all purchases regardless of bank relationship. No cap mentioned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 10000.0,
          "requireMinimumDepositAmount": null,
          "description": "Maintain $10,000\u2013$49,999 in qualifying Smartly checking/savings balances (plus an open Smartly savings account) to earn a total of 2.5x (includes base 2x + 0.5x Smartly Bonus). Bonus applies to the first $10,000 in eligible net purchases each billing cycle and excludes purchases coded as education, gift cards, insurance, taxes, business-to-business services (e.g., advertising, construction material suppliers, computer services), and third-party bill payment services.",
          "promotional_type": PromotionalType.US_BANK_SMARTLY_TIER_1
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "requireMinimumDepositAmount": null,
          "description": "Maintain $50,000\u2013$99,999 in qualifying Smartly checking/savings balances (plus an open Smartly savings account) to earn a total of 3.0x (includes base 2x + 1.0x Smartly Bonus). Bonus applies to the first $10,000 in eligible net purchases each billing cycle and excludes purchases coded as education, gift cards, insurance, taxes, business-to-business services (e.g., advertising, construction material suppliers, computer services), and third-party bill payment services.",
          "promotional_type": PromotionalType.US_BANK_SMARTLY_TIER_2
        },
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "requireMinimumDepositAmount": null,
          "description": "Maintain $100,000+ in qualifying Smartly checking/savings balances (plus an open Smartly savings account) to earn a total of 4.0x (includes base 2x + 2.0x Smartly Bonus). Bonus applies to the first $10,000 in eligible net purchases each billing cycle and excludes purchases coded as education, gift cards, insurance, taxes, business-to-business services (e.g., advertising, construction material suppliers, computer services), and third-party bill payment services.",
          "promotional_type": PromotionalType.US_BANK_SMARTLY_TIER_3
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2849,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2849,
    "description": "Purchases: 0.0 introductory APR for the first 12 billing cycles; then variable 0.1824\u20130.2849 based on creditworthiness (varies with Prime Rate). Balance transfers: 0.0 introductory APR for the first 12 billing cycles on transfers made within 60 days; then variable 0.1824\u20130.2849 (varies with Prime Rate). Cash advances: 0.3099 variable. No penalty APR."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://onboarding.usbank.com/consumer/cards/RGW2234MP4/8069/87193/start",
  "learn_more_link": "https://www.usbank.com/content/usbank/us/en/credit-cards/bank-smartly-visa-signature-credit-card",
  "terms_and_conditions_link": "https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=36672BDX52&sourceCode=87869",
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "us_bank_smartly_visa_signature_card.png"
},
  [CreditCard.GETAWAY_BY_FNBOCREDIT_CARD]: {
  "id": CreditCard.GETAWAY_BY_FNBOCREDIT_CARD,
  "name": "Getaway\u2120 Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://s7d1.scene7.com/is/image/fnnistage/getaway-mastercard-front?ts=1755532219925&$TransparentPNG$&dpr=off",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "Earn unlimited 3x points per dollar on travel purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Earn unlimited 3x points per dollar on dining purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "Earn unlimited 3x points per dollar on gas purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point per dollar on all other purchases that do not fall under travel, dining, or gas.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "0% intro APR for the first 12 billing cycles on purchases and balance transfers; after that, a variable APR based on the Prime Rate between 20.24% and 28.24%."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fee on purchases made abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Airport Concierge discount",
      "description": "Receive 15% savings on personalized airport services like a dedicated agent to escort you through the airport at 700+ airports worldwide (Mastercard benefit).",
      "benefit_type": null,
      "new_benefit_type": "airport_concierge_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Services emergency assistance",
      "description": "Provides expert assistance for a replacement card or emergency cash when traveling.",
      "benefit_type": null,
      "new_benefit_type": "global_services_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.fnbo.com/personal-banking/credit-cards#",
  "learn_more_link": "https://www.fnbo.com/personal-banking/credit-cards/getaway",
  "terms_and_conditions_link": "https://www.firstbankcard.com/lynx/#/soct/Y3WJZY42RTGMC",
  "terms_and_conditions_button_text": "Summary of Credit Terms",
  "additional_links": [],
  "bank_name": "FNBO",
  "imageName": "getaway_by_fnbocredit_card.png"
},
  [CreditCard.IHG_ONE_REWARDS_PREMIER_CREDIT_CARD]: {
  "id": CreditCard.IHG_ONE_REWARDS_PREMIER_CREDIT_CARD,
  "name": "IHG One Rewards Premier Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/ihg_one_rewards_premier_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.IHG,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.ihg",
      "earnRate": 10.0,
      "description": "10x points per $1 on qualifying purchases at hotels participating in IHG One Rewards (IHG hotels only). Additional base/elite points from the IHG One Rewards program are separate from the credit card earn.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "5x points per $1 on travel purchases, excluding IHG hotel purchases which earn 10x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5x points per $1 at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 5.0,
      "description": "5x points per $1 on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 5.0,
      "description": "5x points per $1 on eligible takeout and delivery services (part of the dining category).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Purchase APR: 19.74%\u201328.24% variable based on Prime Rate; Balance Transfer APR: 19.74%\u201328.24% variable (account may not be eligible for balance transfers); Cash Advance APR: 28.99% variable; Penalty APR: up to 29.99% variable. Minimum interest charge: None. Grace period: at least 21 days; no interest on new purchases if paid in full (or Interest Saving Balance) by due date; interest on balance transfers and cash advances starts on the transaction date. Chase Pay Over Time fee: up to 1.72% monthly of plan amount (no interest on plan balances)."
  },
  "benefits": [
    {
      "name": "Automatic IHG One Rewards Platinum Elite status",
      "description": "Automatic Platinum Elite status for as long as you remain a Premier cardmember (allow 6\u20138 weeks after account opening).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary Free Night (up to 40,000 points)",
      "description": "One Anniversary Free Night each account anniversary, valid for a standard room night costing up to 40,000 points (tax included). You may top-up with points for hotels above 40k. Must be redeemed and the stay completed within 12 months of issue. Estimated value roughly $150\u2013$250 based on ~0.5 cpp typical point value and market rates.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Fourth Reward Night Free on award stays",
      "description": "For Reward Night bookings of 4+ consecutive nights, every 4th night costs 0 points. Unlimited uses annually; forfeited if you cancel or check out before the 4th night. Estimated savings \u224825% on 4-night award stays.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual $100 statement credit after $20,000 calendar-year spend",
      "description": "Receive a $100 statement credit each calendar year you spend at least $20,000 in purchases. Estimated value: $100 if you meet the threshold.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual 10,000 bonus IHG points after $20,000 calendar-year spend",
      "description": "Receive 10,000 bonus IHG points each calendar year you spend at least $20,000 in purchases. Estimated value \u2248$50 at ~0.5 cpp.",
      "benefit_type": null,
      "new_benefit_type": "annual_spend_bonus_points",
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Diamond Elite status after $40,000 calendar-year spend",
      "description": "Qualify for IHG One Rewards Diamond Elite status through December 31 of the following year when you make $40,000+ in purchases in a calendar year (allow up to 8 weeks after qualifying for status to apply).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Save at least 20% on IHG points purchases",
      "description": "Get a minimum 20% discount on points purchases when paying with your IHG Premier/Premier Business/Traveler card. Non-elite qualifying points; not combinable with other points purchase offers; processed by Points.com.",
      "benefit_type": "points_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to IHG Reward Night Sales",
      "description": "Early access to select Reward Night sales (discounts on points needed or the cash portion of Points & Cash) when booking up to three consecutive Reward Nights while signed in. Not combinable with Fourth Night Free on 4+ night stays.",
      "benefit_type": null,
      "new_benefit_type": "early_access_reward_night_sales",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry/TSA PreCheck/NEXUS application fee credit",
      "description": "One statement credit up to $120 every 4 years after the application fee for Global Entry, TSA PreCheck, or NEXUS is charged to the card (primary or AU). Estimated annualized value \u2248$30 if you would otherwise pay the fee.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "United TravelBank cash deposits",
      "description": "$25 United TravelBank cash deposited around Jan 5 and another $25 around Jul 5 each calendar year after one-time registration at ihg.com/united (must be a MileagePlus member). Deposits expire mid\u2011year or the following January depending on deposit date. Estimated value up to $50/year if used before expiry.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass membership (DoorDash/Caviar)",
      "description": "12 months of DashPass when activated with the IHG Premier card between 02/01/2025 and 12/31/2027; auto-renews at the then-current rate unless canceled; must set card as default payment and use it at checkout. Estimated value \u2248$120 based on ~$9.99/month.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$10 off quarterly on DoorDash non-restaurant orders (with active DashPass)",
      "description": "After activating DashPass with the IHG Premier card, get one $10 discount each calendar quarter on an eligible non-restaurant order; no rollover; must pay with the enrolled card. Estimated max value $40/year.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry/TSA PreCheck/NEXUS application fee credit",
      "description": "One statement credit up to $120 every 4 years after the application fee for Global Entry, TSA PreCheck, or NEXUS is charged to the card (primary or AU). Estimated annualized value \u2248$30 if you would otherwise pay the fee.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "165,000 IHG One Rewards points after spending $3,000 on purchases in the first 3 months from account opening. Not available to current cardmembers of any personal IHG card, or to previous personal IHG cardmembers who received a new cardmember bonus within the last 24 months. Points typically post in 6\u20138 weeks after qualifying; account must be open and not in default. Estimated value \u2248$825 at ~0.5 cents per point (range ~$660\u2013$990 at 0.4\u20130.6 cpp, depending on redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 165000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HVSC&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/ihg-rewards-club/premier?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62411.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/ihgonerewardspremiercard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "ihg_one_rewards_premier_credit_card.png"
},
  [CreditCard.POTTERY_BARN_KEY_REWARDS_VISA]: {
  "id": CreditCard.POTTERY_BARN_KEY_REWARDS_VISA,
  "name": "Pottery Barn Key Rewards\u00ae Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/pb_ca_cb_rgb.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 10.0,
      "description": "New cardmembers earn 10% back in rewards on Net Eligible purchases at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation and Mark & Graham (excludes GreenRow) for the first 30 days from account opening. Valid online and in stores. Rewards are not earned on promotional financing purchases. Earnings based on merchant category code as reported by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 10.0,
      "description": "New cardmembers earn 10% back in rewards on Net Eligible purchases at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation and Mark & Graham (excludes GreenRow) for the first 30 days from account opening. Valid online and in stores. Rewards are not earned on promotional financing purchases. Earnings based on merchant category code as reported by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 5.0,
      "description": "Earn 5% back in rewards on Net Eligible purchases at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation and Mark & Graham (excludes GreenRow). Valid online and in stores. Rewards are not earned on promotional financing purchases. Earnings based on merchant category code as reported by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 5.0,
      "description": "Earn 5% back in rewards on Net Eligible purchases at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation and Mark & Graham (excludes GreenRow). Valid online and in stores. Rewards are not earned on promotional financing purchases. Earnings based on merchant category code as reported by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 4.0,
      "description": "4% back in rewards on Net Eligible purchases at grocery stores. Grocery purchases made at gas stations, convenience stores, warehouse clubs, discount stores, and super stores (or at grocery stores associated with discount or super stores) earn 1% back. Earnings based on merchant category code as reported by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4% back in rewards on Net Eligible purchases at restaurants, including fast food. Earnings based on merchant category code as reported by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 4.0,
      "description": "4% back in rewards on Net Eligible purchases with food delivery services. Earnings based on merchant category code as reported by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back in rewards on Net Eligible purchases made anywhere Visa is accepted. Earnings based on merchant category code as reported by the merchant. Rewards are not earned on promotional financing purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2924,
    "apr_low": 0.2924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2924,
    "high": 0.2924,
    "description": "Purchase APR: 29.24% variable (0.2924). Balance Transfer APR: 29.24% variable (0.2924). Cash Advance APR: 29.24% variable. 12-month zero interest promotional financing on qualifying purchases of $750+ with 12 equal payments; if not paid in full after 12 months, the standard variable purchase APR applies to the remaining balance. Cash Advance Fee: $5 or 5% of each cash advance, whichever is greater. Balance Transfer Fee: 3% of each transfer that posts at a Promotional APR."
  },
  "benefits": [
    {
      "name": "$25 birthday reward (annual certificate)",
      "description": "Receive a $25 Key Rewards birthday certificate each year during your birthday month. Requirements: account must be open and current, have a valid email and U.S. mailing address on file, and you must have made at least one purchase in the 12 months before your birthday month. New accounts opened during your birthday month are not eligible until the following year. Certificate expires 30 days after issuance. Estimated value: $25 per year if conditions are met.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "12-month promotional financing (0% APR with equal payments)",
      "description": "On qualifying in-store or online purchases of $750 or more (excluding shipping/tax) at participating Williams Sonoma, Inc. brands, you can opt for 12 equal monthly payments at 0% interest instead of earning rewards. Account must be open/current. Rewards are not earned on promotional financing purchases. If not paid in full after 12 months, the standard variable purchase APR (29.24% per disclosure) applies to remaining balance. Not eligible via certain third-party wallets/readers. Estimated savings example: financing $750 with equal payments at 0% vs. 29.24% APR could avoid roughly $100+ in interest over 12 months (estimate; actual savings vary).",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing_0_percent_12_months",
      "spend_requirement": 750,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free standard shipping at participating brands",
      "description": "Free standard shipping within the contiguous U.S. on eligible purchases when paying with your Pottery Barn/Key Rewards Visa at participating Williams Sonoma, Inc. brands on purchases of $0.01 or more. Not available when Rewards cover the entire order, or when paying with digital wallets (e.g., Apple Pay/Google Wallet/Samsung Pay) or third-party payment solutions (e.g., PayPal). Value varies by order; typical ground shipping can range roughly $6\u2013$30+ per order depending on merchant and basket.",
      "benefit_type": null,
      "new_benefit_type": "free_standard_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to sales and events",
      "description": "Cardholders receive early access to select sales and events across participating brands. Specific event schedules and savings vary.",
      "benefit_type": null,
      "new_benefit_type": "early_access_sales_events",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Welcome bonus: 10% back in rewards on Net Eligible purchases at participating Williams Sonoma, Inc. brands for the first 30 days from account opening (excludes GreenRow). After the 30-day window, the ongoing earn rate is 5% at those brands (ongoing earn is not part of the signup bonus). No minimum spend or cap disclosed. Purchases on promotional financing do not earn rewards. Some customers may not be eligible for same-day purchases until card is received/verified, which can affect the 30-day window. Estimated value: earn $10 in rewards per $100 spent at participating brands during the first 30 days.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percent_back_rewards",
          "amount": 10.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/potterybarn",
  "learn_more_link": "https://www.capitalone.com/credit-cards/potterybarn",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "pottery_barn_key_rewards_visa.png"
},
  [CreditCard.AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD,
  "name": "Air France KLM World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/1bdx_eltwldcm_mc_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AIR_FRANCE_KLM_FLYING_BLUE,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.airFranceKlmFlyingBlue",
      "earnRate": 3.0,
      "description": "3 miles per $1 on eligible direct purchases with Air France, KLM, and SkyTeam member airlines. Third\u2011party or OTA bookings may not qualify. Balance transfers, cash advances, fees, and interest do not earn miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "direct_purchase_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.skyteamAirlines",
      "earnRate": 3.0,
      "description": "3 miles per $1 on eligible direct purchases with Air France, KLM, and SkyTeam member airlines. Third\u2011party or OTA bookings may not qualify. Balance transfers, cash advances, fees, and interest do not earn miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "direct_purchase_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5 miles per $1 on all other net purchases. Excludes balance transfers, cash advances, fees, and interest. Eligible direct airline purchases with Air France, KLM, and SkyTeam earn 3x instead.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 89.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 89.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate. Purchase APR: 20.24%\u201328.24% variable; Balance transfer APR: 20.24%\u201328.24% variable. Penalty APR up to 29.99% variable may apply if you make a late payment. At least 25-day grace period on purchases if paid in full; interest on balance transfers and cash advances accrues from the transaction date."
  },
  "benefits": [
    {
      "name": "Annual XP (Experience Points)",
      "description": "Receive 20 XP every year on your account anniversary (helps qualify for Flying Blue Elite status; no direct cash value). Account must be open and in good standing.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Additional XP with Spend",
      "description": "Earn an additional 40 XP on your account anniversary when you spend $15,000 or more in net purchases within the anniversary year (for a total of 60 XP that year).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "Use the card abroad without foreign transaction fees. Potential savings ~3% vs. cards that charge this fee.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Anniversary Flying Blue Miles Bonus",
      "description": "Receive 5,000 Flying Blue miles each account anniversary after at least $50 in net purchases within the anniversary year. Estimated value \u2248 $70 (5,000 \u00d7 $0.014 per mile; valuation varies by redemption).",
      "credit_category": "travel.airline",
      "new_credit_category": "flying_blue_anniversary_miles",
      "credit_type": "anniversary_miles_bonus",
      "value": 5000,
      "value_unit": "miles",
      "spend_requirement": 50,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Online offer: 50,000 Flying Blue miles after $2,000 in purchases within 90 days of account opening, plus 60 XP upon approval. Estimated miles value \u2248 $700 using 1.4\u00a2/mile (range varies by redemption). Limit one bonus miles and XP offer per new account; purchases only (no BTs/Cash Advances); account must be open/active; allow 1\u20132 billing cycles for posting.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "xp",
          "amount": 60.0,
          "value_unit": "xp"
        }
      ]
    },
    {
      "spendRequirement": 2000.0,
      "spendRequirementMonths": 3,
      "description": "Online offer: 50,000 Flying Blue miles after $2,000 in purchases within 90 days of account opening, plus 60 XP upon approval. Estimated miles value \u2248 $700 using 1.4\u00a2/mile (range varies by redemption). Limit one bonus miles and XP offer per new account; purchases only (no BTs/Cash Advances); account must be open/active; allow 1\u20132 billing cycles for posting.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "air_france_klm_world_elite_mastercard.png"
},
  [CreditCard.VENTURE_X_REWARDS]: {
  "id": CreditCard.VENTURE_X_REWARDS,
  "name": "Capital One Venture X Rewards",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/venture_x_rewards.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CAPITAL_ONE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 10.0,
      "description": "10x miles on hotels and rental cars booked via Capital One Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "rentalCar",
      "earnRate": 10.0,
      "description": "10x miles on hotels and rental cars booked via Capital One Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "5x miles on flights and vacation rentals booked through Capital One Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2x miles on all other eligible purchases, every day.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 395.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 395.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Capital One and Priority Pass lounge access",
      "description": "Access to Capital One Lounges (present physical card or digital lounge pass) and Priority Pass lounges (enrollment required). Access subject to space availability; policies may change. Estimated value: varies widely by usage (typical day-pass equivalents ~$45+ per visit).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$300 annual Capital One Travel credit",
      "description": "Up to $300 in credit each card year for purchases made through Capital One Travel; credit is available and applied within Capital One Travel and expires on the next account anniversary. Can be used in whole or across multiple purchases; rewards are not earned on the credited amount. Estimated value: up to $300 per year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry or TSA PreCheck application fee credit",
      "description": "Statement credit up to $120 for either Global Entry or TSA PreCheck application fee (one credit per account every four years). Account must be open and in good standing when the credit is applied. Estimated value: up to $120 once every 4 years.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10,000-mile annual anniversary bonus",
      "description": "Earn 10,000 bonus miles after your anniversary each year, starting with your first anniversary. Estimated value: ~$100 at 1 cent per mile when used as travel credits; potentially higher when transferring to partners.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Premier Collection hotel and vacation rental benefits (Capital One Travel)",
      "description": "On eligible bookings made through Capital One Travel: up to $100 experience credit per stay (hotel credit applied at checkout; vacation rental experience credit applied at time of booking with host provider), plus benefits like daily breakfast for two (hotels only), complimentary Wi\u2011Fi, and when available, room upgrades, early check\u2011in and late checkout. Terms vary by property; minimum nights may apply. Estimated value: $100+ per eligible stay.",
      "benefit_type": null,
      "new_benefit_type": "hotel_collection_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lifestyle Collection hotel and vacation rental benefits (Capital One Travel)",
      "description": "On eligible bookings made through Capital One Travel: up to $50 experience credit per stay (hotel credit applied at checkout; vacation rental experience credit applied at time of booking with host provider), plus benefits like complimentary Wi\u2011Fi and, when available, room upgrades, early check\u2011in and late checkout. Terms vary by property; minimum nights may apply. Estimated value: $50+ per eligible stay.",
      "benefit_type": null,
      "new_benefit_type": "hotel_collection_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz President\u2019s Circle status",
      "description": "Complimentary Hertz President\u2019s Circle status upon enrollment via the card\u2019s Benefits/Rewards tab; status effective 24\u201372 hours after registration and lasts for the duration of the offer. Estimated value: varies (e.g., potential upgrades and faster service).",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining access",
      "description": "Access to exclusive reservations at award\u2011winning restaurants and tickets to curated culinary experiences. Estimated value: experiential; varies by availability and use.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment access",
      "description": "Access to select pre\u2011sales, ticket offers and experiences across music, sports and dining. Estimated value: experiential; varies by availability and use.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer miles to partners",
      "description": "Ability to transfer miles to participating airline and hotel loyalty programs; once transfers are final, the receiving program\u2019s terms apply. Estimated value: varies, potentially >1 cent per mile with strategic redemptions.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite travel protections (see Guide to Benefits)",
      "description": "Card includes Visa Infinite benefits; specific terms, conditions, and exclusions apply per the Guide to Benefits. Estimated value: coverage value varies by claim and usage.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "PRIOR subscription (complimentary upon enrollment)",
      "description": "Eligible cardholders who enroll receive a complimentary PRIOR subscription; account must remain open and in good standing. Offer terms apply and may change. Estimated value: depends on subscription retail price; not specified.",
      "benefit_type": null,
      "new_benefit_type": "prior_subscription",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "The Cultivist membership offer",
      "description": "Enrollment required; membership auto\u2011renews annually and charges the card on file unless canceled before renewal. Offer terms and experiences subject to change. Estimated value: depends on usage and membership tier; not specified.",
      "benefit_type": null,
      "new_benefit_type": "the_cultivist_membership_offer",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$300 annual Capital One Travel credit",
      "description": "Up to $300 in credit each card year for purchases through Capital One Travel; expires on next account anniversary; can be used in whole or across multiple purchases; rewards not earned on the credited amount.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry or TSA PreCheck application fee credit",
      "description": "One statement credit up to $120 for either Global Entry or TSA PreCheck application fee every four years; account must be open and in good standing when the credit is applied.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Annual 10000 mile anniversary bonus",
      "description": "Earn 10000 bonus miles after your anniversary each year, starting with your first anniversary. Estimated value: ~$100 at 1 cent per mile when used as travel credits; potentially higher when transferring to partners.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 10000.0,
      "value_unit": "miles",
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "One-time welcome bonus available by clicking the Apply Now button on the offer page; may not be available if you navigate away or close the page. Existing or previous cardmembers are not eligible if they have received a new cardmember bonus for this product in the past 48 months.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 75000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/venture-x/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/venture-x/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "venture_x_rewards.png"
},
  [CreditCard.SPARK_15X_MILES_SELECT]: {
  "id": CreditCard.SPARK_15X_MILES_SELECT,
  "name": "Spark 1.5X Miles Select",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/miles_new_2021/thumbnail.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CAPITAL_ONE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn unlimited 1.5X miles on every purchase for your business.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Earn unlimited 5X miles on hotels and rental cars booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Earn unlimited 5X miles on hotels and rental cars booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2349,
    "apr_low": 0.1749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1749,
    "high": 0.2349,
    "description": "17.49% - 23.49% variable APR based on your creditworthiness."
  },
  "benefits": [
    {
      "name": "Hertz Five Star Status",
      "description": "Complimentary Hertz Five Star status for the cardholder; enroll via the Benefits tab after logging in to Capital One. Skip the counter at select locations and access a wider selection of rental cars. Terms and enrollment required (see footnote 10).",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Coverage for damage or theft when renting an eligible car with the card. Terms, conditions, and exclusions apply; type not specified in source and typically secondary. Refer to Guide to Benefits (footnote 7).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Free extended warranty on eligible items purchased with the card. Terms and exclusions apply (see Guide to Benefits).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance",
      "description": "Access to services during auto-related emergencies (e.g., jump-starting, tire changes, towing). Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "Pay zero foreign transaction fees on purchases outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Miles Transfer to Partners",
      "description": "Transfer Capital One miles to 15+ travel partners. Once transferred, partner program terms govern expiry and value (footnote 3).",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Business Travel portal access",
      "description": "Complimentary access to Capital One\u2019s business travel management and booking platform. Rewards and benefits may vary between Capital One Travel and Capital One Business Travel (footnote 2).",
      "benefit_type": null,
      "new_benefit_type": "travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a one-time 50,000 miles bonus after $4,500 in purchases within the first 3 months from account opening. Offer available via the Apply Now button on the product page; may not be available if you leave the page and may be unavailable to existing or previous Spark cardholders (footnote 1). Estimated value: about $500 at 1.0\u00a2/mile when redeemed for travel via Capital One (purchase eraser or portal). Potentially higher value (e.g., ~$600\u2013$750) if transferred to airline/hotel partners and redeemed at ~1.2\u20131.5\u00a2/mile; actual value varies by partner and redemption.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/small-business/credit-cards/spark-miles-select/",
  "learn_more_link": "https://www.capitalone.com/small-business/credit-cards/spark-miles-select/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "spark_15x_miles_select.avif"
},
  [CreditCard.CITI_SECURED_MASTERCARD]: {
  "id": CreditCard.CITI_SECURED_MASTERCARD,
  "name": "Citi\u00ae Secured Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-secured-card/citi-secured-card_90x57.png",
  "recommendedMinCreditScore": "no_credit_history",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2649,
    "apr_low": 0.2649
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2649,
    "high": 0.2649,
    "description": "Variable APRs: 26.49% for purchases and balance transfers; 29.24% for cash advances; penalty APR up to 29.99% if you make a late or returned payment. Minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Complimentary Mastercard ID Theft Protection monitors the information you enroll and alerts you if suspicious activity is found; enrollment required.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Liability on Unauthorized Charges",
      "description": "You will not be responsible for charges you did not authorize, online or otherwise.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Flexible Payment Due Date",
      "description": "Choose your payment due date at the beginning, middle, or end of the month.",
      "benefit_type": null,
      "new_benefit_type": "flexible_payment_due_date",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Credit Reporting to All Three Bureaus",
      "description": "Citi reports your account activity to all three major credit bureaus, generally monthly, which can help build credit with responsible use.",
      "benefit_type": null,
      "new_benefit_type": "credit_bureau_reporting",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-secured-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_secured_mastercard.png"
},
  [CreditCard.US_BANK_CASH_VISA_SIGNATURE_CARD]: {
  "id": CreditCard.US_BANK_CASH_VISA_SIGNATURE_CARD,
  "name": "U.S. Bank Cash+\u00ae Visa Signature\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/us_bank_cash_visa_signature_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 5.0,
      "description": "5% cash back in two enrolled categories per quarter on up to $2,000 combined purchases; purchases over the cap earn 1%. Grocery at discount/supercenters and wholesale clubs, and gas/EV charging at discount/supercenters, wholesale clubs, and grocery stores/supermarkets earn only 1% regardless of selection. Not all transactions qualify (e.g., cash equivalents, balance transfers, advances, fees).",
      "spendCap": 2000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 2,
        "categories": [
          {
            "categories": [
              "dining"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Fast Food"
          },
          {
            "categories": [
              "billsAndUtilities"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Home Utilities"
          },
          {
            "categories": [
              "streaming",
              "internetCablePhone"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "TV, Internet and Streaming"
          },
          {
            "categories": [
              "departmentStores"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Department Stores"
          },
          {
            "categories": [
              "phonePlans"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Cell Phone Providers"
          },
          {
            "categories": [
              "electronics"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Electronic Stores"
          },
          {
            "categories": [
              "sportsEquipment"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Sporting Goods Stores"
          },
          {
            "categories": [
              "entertainment"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Movie Theaters"
          },
          {
            "categories": [
              "fitness"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gyms/Fitness Centers"
          },
          {
            "categories": [
              "homeFurnishings"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Furniture Stores"
          },
          {
            "categories": [
              "travel.transit"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Ground Transportation"
          },
          {
            "categories": [
              "departmentStores"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Select Clothing Stores"
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "Choose two of 12 categories each quarter for 5% cash back on up to $2,000 combined. Enrollment required.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "selectable_categories",
      "earnRate": 2.0,
      "description": "2% cash back in one enrolled category per quarter with no cap; grocery at discount/supercenters and wholesale clubs, and gas/EV charging at discount/supercenters, wholesale clubs, and grocery stores/supermarkets earn only 1% regardless of selection. Not all transactions qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          {
            "categories": [
              "grocery"
            ],
            "exclude_subcategories": [
              "wholesaleClub",
              "walmart",
              "target"
            ],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Grocery Stores and Grocery Delivery (excludes discount stores/supercenters and wholesale clubs)"
          },
          {
            "categories": [
              "dining"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Restaurants"
          },
          {
            "categories": [
              "gas",
              "gas.evCharging"
            ],
            "exclude_subcategories": [
              "wholesaleClub",
              "walmart",
              "target"
            ],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas Stations and EV Charging Stations (excludes discount stores/supercenters and wholesale clubs)"
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "Choose one of 3 everyday categories each quarter for 2% cash back with no cap. Enrollment required.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "5% total cash back on prepaid air, car, and hotel bookings made via the U.S. Bank Travel Center with the Cash+ Card. No cap disclosed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5% total cash back on prepaid air, car, and hotel bookings made via the U.S. Bank Travel Center with the Cash+ Card. No cap disclosed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5% total cash back on prepaid air, car, and hotel bookings made via the U.S. Bank Travel Center with the Cash+ Card. No cap disclosed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Base rate on all eligible net purchases. Transactions such as balance transfers, cash advances (including ATM withdrawals, money orders, traveler\u2019s checks, wire transfers, cash equivalents), fees, interest, credit insurance premiums, and funding certain prepaid card products do not earn rewards. If you fail to enroll in categories for a quarter, all purchases earn 1% that quarter.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2849,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2849,
    "description": "Purchases: 0.0 APR for first 15 billing cycles, then 0.1824\u20130.2849 variable based on creditworthiness and Prime Rate. Balance transfers: 0.0 APR for first 15 billing cycles for transfers made within 60 days of account opening, then 0.1824\u20130.2849 variable. Cash advances: 0.3099 variable. No penalty APR."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://onboarding.usbank.com/consumer/cards/WRH8D23H2R/8069/86937/start",
  "learn_more_link": "https://www.usbank.com/content/usbank/us/en/credit-cards/cash-plus-visa-signature-credit-card",
  "terms_and_conditions_link": "https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=WRH8D23H2R&sourceCode=88256",
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "us_bank_cash_visa_signature_card.png"
},
  [CreditCard.CITI_CUSTOM_CASH_CARD]: {
  "id": CreditCard.CITI_CUSTOM_CASH_CARD,
  "name": "Citi Custom Cash\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citi-custom-cash-credit-card/citi-custom-cash-credit-card_306x192.webp",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 5.0,
      "description": "Earn 5x on purchases in the single top eligible category each billing cycle up to $500 in spend; purchases in that category above $500 earn 1x.",
      "spendCap": 500.0,
      "spendCapResetFrequency": Frequency.MONTHLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": 1,
        "categories": [
          "dining",
          "gas",
          "grocery",
          "travel",
          "travel.transit",
          "streaming",
          "drugstore",
          "homeImprovement",
          "fitness",
          "entertainment.liveEntertainment"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Automatically earns 5% on purchases in your single top eligible category each billing cycle from: restaurants (dining), gas stations, grocery stores, select travel, select transit, select streaming services, drugstores, home improvement stores, fitness clubs, and live entertainment. No enrollment; the top eligible category is determined by highest spend each cycle.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1x on all purchases that are not in the top eligible category for the billing cycle and on spend in the top category above the $500 cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 4.0,
      "description": "Additional 4x on hotels, car rentals, and attractions booked with Citi Travel; no stated cap. Stacks with base/top-category earnings (e.g., may total higher than 5x if travel is also the top eligible category up to its cap).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 4.0,
      "description": "Additional 4x on hotels, car rentals, and attractions booked with Citi Travel; no stated cap. Stacks with base/top-category earnings (e.g., may total higher than 5x if travel is also the top eligible category up to its cap).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2799,
    "apr_low": 0.1799
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 3.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.2799,
    "description": "0% Intro APR for 15 months on purchases and balance transfers from account opening; after that, a variable APR of 17.99%\u201327.99% applies based on creditworthiness. Balance transfers must be completed within 4 months of account opening. Balance transfer fee: $5 or 5% of each transfer, whichever is greater."
  },
  "benefits": [
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Complimentary identity theft monitoring and alerts from Mastercard after enrollment. Estimate: comparable third\u2011party services often cost about $8\u2013$15/month, included at no additional cost with the card.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment access",
      "description": "Access to select presale tickets and exclusive entertainment experiences through Citi Entertainment.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1500.0,
      "spendRequirementMonths": 6,
      "description": "Earn $200 cash back (fulfilled as 20,000 ThankYou Points) after spending $1,500 on purchases in the first 6 months of account opening. Cash back is earned as ThankYou Points and can be redeemed for cash back (statement credit, direct deposit, or check). Restrictions: Bonus not available if you have received a new account bonus for a Citi Custom Cash\u00ae Card in the past 48 months or if you converted another Citi credit card on which you earned a new account bonus in the last 48 months into a Citi Custom Cash\u00ae Card. Citi will only issue one Citi Custom Cash\u00ae Card account per person. Offer may vary and may not be available if you leave the offer page. Estimated value: $200 at a fixed 1 cent per point (20,000 points = $200).",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-custom-cash-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "See if You're Pre-qualified",
      "url": "https://online.citi.com/US/ag/cards/pre-screen?intc=citihpmenu_creditcards_pq&PP=citi-custom-cash&OC=CC-CITI-3CY"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi-custom-cash-card.png"
},
  [CreditCard.SECURED_VISACREDIT_CARD]: {
  "id": CreditCard.SECURED_VISACREDIT_CARD,
  "name": "Rewards Secured Visa\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://s7d1.scene7.com/is/image/fnnistage/visa-green-diamond-new?ts=1753288780138&$TransparentPNG$&dpr=off",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Unlimited 1x point per dollar spent on every purchase; no category selection or spend caps disclosed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2449,
    "apr_low": 0.2449
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2449,
    "high": 0.2449,
    "description": "Variable 24.49% APR on purchases and balance transfers, based on the Prime Rate."
  },
  "benefits": [
    {
      "name": "Periodic credit limit reviews and potential deposit return",
      "description": "FNBO will periodically review your account; as your credit history improves, you may be eligible for a credit limit increase and/or to have your security deposit returned. Not all will qualify; subject to credit approval.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Reports to all three major credit bureaus",
      "description": "Card activity is reported to Equifax, Experian, and TransUnion to help build a positive credit history.",
      "benefit_type": null,
      "new_benefit_type": "reports_to_credit_bureaus",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Zero Liability",
      "description": "You won\u2019t be held responsible for unauthorized charges made with your card or account information on Visa-processed transactions. Cardholders must exercise care and promptly report unauthorized use; certain terms and restrictions apply.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Roadside Dispatch",
      "description": "24/7 access to roadside assistance services like tire changing, jump starting, or towing. This is a pay-per-use service with pre-negotiated fees for Visa cardmembers.",
      "benefit_type": null,
      "new_benefit_type": "roadside_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Global Services",
      "description": "Provides worldwide assistance for emergency card replacement and emergency cash disbursement.",
      "benefit_type": null,
      "new_benefit_type": "global_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.fnbo.com/personal-banking/credit-cards/visa-secured-card",
  "learn_more_link": "https://www.fnbo.com/personal-banking/credit-cards/visa-secured-card",
  "terms_and_conditions_link": "https://www.firstbankcard.com/lynx/#/soct/3C1VN8ML3CD8J",
  "terms_and_conditions_button_text": "Summary of Credit Terms",
  "additional_links": [
    {
      "name": "See Disclosure Details",
      "url": "https://www.fnbo.com/personal-banking/credit-cards#disclosures"
    }
  ],
  "bank_name": "FNBO",
  "imageName": "secured_visacredit_card.jpg"
},
  [CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS]: {
  "id": CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS,
  "name": "Bank of America\u00ae Travel Rewards Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8blm_trvsigcm_v_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BANK_OF_AMERICA_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn unlimited 1.5 points per $1 on all Net Purchases (purchases minus returns/credits). Balance transfers, cash advances, fees, interest, fraudulent transactions and certain other charges do not earn points. Points do not expire while the account remains open. Preferred Rewards members receive a 25%\u201375% points bonus on every purchase (tier-based).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "0% intro APR for 15 billing cycles on purchases; then variable APR 18.24%-28.24% based on creditworthiness (varies with Prime Rate). Balance transfers: 0% intro APR for 15 billing cycles on transfers made within 60 days of account opening; then 18.24%-28.24% variable. Penalty APR up to 29.99% may apply for late payment."
  },
  "benefits": [
    {
      "name": "Preferred Rewards bonus (25%-75% more points)",
      "description": "Bank of America Preferred Rewards members earn 25%-75% more points on every purchase (about 1.87\u20132.62 points per $1), depending on tier.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 25,000 bonus points after at least $1,000 in purchases within 90 days of account opening. Estimated value: $250 when redeemed as a travel/dining statement credit at 1.0\u00a2/point; ~$150 if redeemed as cash at 0.6\u00a2/point. Limit 1 per new account; purchases only (cash advances/balance transfers excluded); returns/credits reduce qualifying spend; account must be open with active charging privileges; points typically post in 1\u20132 billing cycles. Offer may be online-only and available only if applied via this page.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 25000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076499&productOfferCode=T9&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/travel-rewards-credit-card/?campaign=4076499~T9~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076499&productoffercode=T9&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Travel Rewards credit card",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://www.bankofamerica.com/credit-cards/products/travel-rewards-credit-card//?campaign=4076499~T9~en_US#headlineCcalcModule"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_travel_rewards.png"
},
  [CreditCard.CAPITAL_ONE_WALMART_REWARDS_MASTERCARD]: {
  "id": CreditCard.CAPITAL_ONE_WALMART_REWARDS_MASTERCARD,
  "name": "Capital One Walmart Rewards\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/capital_one_walmart_rewards_mastercard.jpg",
  "recommendedMinCreditScore": null,
  "availability": "no_new_applicants",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "walmart",
      "earnRate": 5.0,
      "description": "5% back on Walmart.com purchases including grocery pickup and delivery.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "walmart",
      "earnRate": 2.0,
      "description": "2% back on in-store Walmart purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "in_store_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2% back at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2% back on travel purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "capital_one_walmart_rewards_mastercard.jpg"
},
  [CreditCard.CHASE_FREEDOM_RISE_CREDIT_CARD]: {
  "id": CreditCard.CHASE_FREEDOM_RISE_CREDIT_CARD,
  "name": "Chase Freedom Rise\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/freedom_rise_alt_card2.png",
  "recommendedMinCreditScore": "no_credit_history",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Base earning: 1.5% cash back on all purchases. Transactions that do not earn include balance transfers, cash advances and cash-like transactions, lottery tickets, casino gaming chips, race track wagers or similar betting transactions, checks that access the account, interest, unauthorized or fraudulent charges, and fees of any kind.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.lyft",
      "earnRate": 2.0,
      "description": "Lyft offer valid through 09/30/2027 on qualifying rideshare, bike and scooter rides, and subscription/membership products purchased via the Lyft app. Additional cash back posts separately from base earnings.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2574,
    "apr_low": 0.2574
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2574,
    "high": 0.2574,
    "description": "Purchase APR 25.74% variable (Prime Rate + 18.49%). Balance Transfer APR 25.74% variable. Cash Advance APR 28.99% variable. Penalty APR up to 29.99% variable. No 0% intro APR. Minimum 21-day grace period; Minimum Interest Charge: None."
  },
  "benefits": [
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $500 per item (NY residents: 90 days).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years from purchase).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Insurance",
      "description": "Reimbursement up to $1,500 per covered traveler and $6,000 per trip for prepaid, non-refundable passenger fares if canceled or cut short due to covered reasons (e.g., sickness, severe weather).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary 6 Months of DashPass (DoorDash and Caviar)",
      "description": "Activate between 02/01/2025 and 12/31/2027 to receive 6 months of DashPass, which unlocks $0 delivery fees and lower service fees on eligible orders. Must add and use the card for eligible orders. Also includes up to $10 off once per calendar quarter on qualifying non-restaurant orders while enrolled in DashPass through 12/31/2027. Estimated value: approximately $60 for 6 months based on a typical $9.99/month DashPass price (actual value depends on usage).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Credit Line Increase Evaluation",
      "description": "As a cardmember, you may be evaluated for a credit line increase in as soon as 6 months.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Evaluation for Upgrade to Freedom Unlimited",
      "description": "Automatic annual evaluation for upgrade eligibility to your first Chase Freedom Unlimited card when account and payment history criteria are met (e.g., account open and used in past 12 months; all payments on time in past 12 months; no suspended Chase accounts).",
      "benefit_type": null,
      "new_benefit_type": "automatic_card_upgrade_evaluation",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "$25 statement credit after you set up automatic payments within the first 3 months from account opening and remain enrolled for at least 90 consecutive days. Offer available if you do not currently have this card and have not been approved for it in the past 24 months. Account must be open and not in default at fulfillment.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 25.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HB5Y&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/cash-back-credit-cards/freedom/rise?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC57233.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/freedomrise/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "chase_freedom_rise_credit_card.png"
},
  [CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD]: {
  "id": CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD,
  "name": "Business Advantage Unlimited Cash Rewards Mastercard\u00ae credit card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_cshbuscm_mc_sky-CSX944967d2.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5% cash back on every purchase with no annual cap; rewards do not expire as long as the account remains open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2749,
    "apr_low": 0.1749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1749,
    "high": 0.2749,
    "description": "0% intro APR on purchases for the first 9 billing cycles; then a variable APR of 17.49%\u201327.49% on purchases and on all balance transfers. Cash advance APR 28.49% variable."
  },
  "benefits": [
    {
      "name": "Preferred Rewards for Business bonus (25%-75%)",
      "description": "Enroll in Bank of America Preferred Rewards for Business to boost cash-back earnings by 25% (Gold), 50% (Platinum), or 75% (Platinum Honors). Effective earn rate on this card becomes 1.87% (Gold), 2.25% (Platinum), or up to 2.62% (Platinum Honors) on all purchases. Enrollment requires a Bank of America business checking account and a 3\u2011month combined average daily balance of $20k (Gold), $50k (Platinum), or $100k+ (Platinum Honors) across eligible Bank of America business deposit and/or Merrill business investment accounts.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel accident insurance",
      "description": "Travel benefits include $100,000 travel accident insurance when traveling. Details, terms, and exclusions apply per the card\u2019s benefits guide.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto rental collision damage waiver",
      "description": "Auto rental insurance coverage when you pay with the card. Coverage type and terms vary by issuer/benefits guide; typically secondary in the U.S. Review the full guide to confirm coverage, exclusions, and eligible rentals.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Eligible purchases may be covered against loss, damage, theft, or fire for a limited time after purchase (per the benefits guide).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Extends eligible manufacturers\u2019 warranties on covered purchases per the card\u2019s benefits guide.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "$300 online statement credit after at least $3,000 in purchases in the first 90 days of account opening. Online-only offer may not be available if you leave the application page or apply via other channels. Estimated value: $300 statement credit (cash value equals face amount).",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 300.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/unlimited-cash-rewards-business-credit-card/?campaign=4065284~NV~en_US",
  "learn_more_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/unlimited-cash-rewards-business-credit-card/?campaign=4065284~NV~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/#rates-fees-4065284~NV~en_US",
  "terms_and_conditions_button_text": "Interest Rates & Fees Summary\u2020",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://promo.bankofamerica.com/SBUnlimitedCashRewardsCalc/"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "business_advantage_unlimited_cash_rewards_credit_card.png"
},
  [CreditCard.BANKAMERICARD]: {
  "id": CreditCard.BANKAMERICARD,
  "name": "BankAmericard\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cae_nrwcm_mc_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2524,
    "apr_low": 0.1524
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1524,
    "high": 0.2524,
    "description": "Intro 0.0 APR for 18 billing cycles on purchases and on balance transfers made within 60 days of account opening; thereafter variable purchase APR 0.1524-0.2524 based on creditworthiness; APRs vary with the Prime Rate; no penalty APR."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076558&productOfferCode=NT&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/bankamericard-credit-card/?campaign=4076558~NT~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076558&productoffercode=NT&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for BankAmericard\u00ae credit card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bankamericard.png"
},
  [CreditCard.SLATE_EDGE_CREDIT_CARD]: {
  "id": CreditCard.SLATE_EDGE_CREDIT_CARD,
  "name": "Slate Edge\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/slate_edge_card_alt.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2874,
    "apr_low": 0.1874
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1874,
    "high": 0.2874,
    "description": "0.0 intro APR for 18 months on purchases and balance transfers; then variable 0.1874\u20130.2874 based on creditworthiness (varies with Prime Rate, 7.25% as of 2025-09-23). Cash advance APR 0.2899. Penalty APR up to 0.2999. APR reduction benefit: after on-time payments and $1,000 annual spend, APRs may reduce by up to 0.02 annually until APR reaches Prime + 0.0974. Balance transfer fee: 0.03 ($5 min) within 60 days of account opening; afterward 0.05 ($5 min). Foreign transaction fee: 0.03. Late/returned payment fee up to $40. Note: Account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "APR reduction up to 2% each anniversary year",
      "description": "Automatic annual review for up to a 2% reduction of your purchase and balance transfer APRs when you pay on time and make at least $1,000 in purchases by your next account anniversary; reductions continue until APR reaches Prime Rate + 9.74% (review could result in less than 2%). Estimated savings example: a 2% APR reduction on a $2,000 revolving balance saves about $40 per year.",
      "benefit_type": null,
      "new_benefit_type": "apr_reduction",
      "spend_requirement": 1000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic review for higher credit limit (first 6 months)",
      "description": "After on-time payments and $500+ in purchases through the first statement after month 6, you\u2019ll be automatically evaluated for a credit limit increase (not guaranteed).",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": 500,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "6 months complimentary DashPass (DoorDash and Caviar)",
      "description": "Activate between 02/01/2025 and 12/31/2027; auto-renews at the then-current monthly rate after the complimentary period; must add this card as default and pay with it to receive benefits. Estimated value about $60 (6 \u00d7 ~$9.99/mo), actual value depends on usage and current DashPass pricing.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$10 off once per quarter on eligible non-restaurant DoorDash orders while enrolled in DashPass",
      "description": "Available while you maintain DashPass (through 12/31/2027). Select the discount at checkout; unused value doesn\u2019t roll over; one redemption per quarter; must pay with the card used to enroll. Estimated value up to $40 per year if used every quarter.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $500 per item (New York residents: 90 days).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends eligible U.S. manufacturer warranties of three years or less by one additional year (up to four years from purchase).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (secondary in the U.S.)",
      "description": "Decline the rental company\u2019s collision insurance and pay for the rental with the card to get coverage for theft and collision damage on most rentals; in the U.S., coverage is secondary to your personal insurance.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance (pay-per-use)",
      "description": "Call to dispatch help for roadside emergencies; service fees are billed to your card at time of dispatch.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPKZ&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/balance-transfer-credit-cards/slate/edge?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60941.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "slate_edge_credit_card.png"
},
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD]: {
  "id": CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD,
  "name": "Southwest Rapid Rewards\u00ae Premier Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/southwest_rapid_rewards_premier_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.SOUTHWEST,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.southwest",
      "earnRate": 3.0,
      "description": "3x on purchases made directly with Southwest Airlines, including flights, inflight purchases, Southwest gift cards, and Southwest Vacations or Getaways by Southwest packages. Excludes Southwest Charters and Southwest Cargo. Starting 1/1/2026, Southwest Cruises are excluded from this earn rate (see separate limited-time entry).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x total on grocery store purchases, up to a combined $8,000 per account anniversary year with dining; then 1x thereafter.",
      "spendCap": 8000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x total on dining at restaurants (including takeout and eligible delivery services), up to a combined $8,000 per account anniversary year with grocery; then 1x thereafter.",
      "spendCap": 8000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2x on local transit and commuting purchases through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_7_days"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "2x on internet, cable, and phone services through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_7_days"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x on all other purchases not in bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 149.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 149.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate. Purchase APR: 19.74%\u201328.24%. Balance transfer APR: 19.74%\u201328.24%. Cash advance APR: 28.99%. Penalty APR: up to 29.99%. Minimum interest charge: none. Grace period: at least 21 days on purchases if you pay your entire balance or Interest Saving Balance by the due date; interest on balance transfers and cash advances starts on the transaction date. Note: the account may not be eligible for balance transfers. My Chase Loan APR: 19.74%\u201328.24%."
  },
  "benefits": [
    {
      "name": "First Checked Bag Free (primary cardmember + up to 8 on same reservation)",
      "description": "Primary Cardmember and up to 8 passengers on the same reservation get their first standard checked bag free on Southwest-operated flights when the Rapid Rewards number is in the reservation. Oversize/overweight/excess fees may apply. Not valid on partner carriers. Authorized users are not eligible.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred Seat Selection within 48 hours of departure",
      "description": "When available, the primary Cardmember can select a Preferred or Standard seat within 48 hours of departure for themselves and up to 8 passengers on the same reservation. Southwest-operated flights only; authorized users not eligible; if no eligible seats remain, seats will be assigned per fare rules.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 5 Boarding Benefit",
      "description": "Primary Cardmember and up to 8 passengers on the same reservation can board with Group 5 on Southwest-operated flights, provided the Cardmember remains on the reservation. Authorized users not eligible.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual 15% Southwest promo code",
      "description": "One 15% promotion code each account anniversary year, delivered within ~15 days of anniversary. Valid for 1 year from delivery on Southwest.com or Southwest app; excludes Basic fares; discount applies to base fare only (taxes/fees excluded), not combinable with other promo codes. Example value: on a $300 base fare, savings \u2248 $45; actual savings depends on fare used.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on inflight purchases (drinks and Wi\u2011Fi)",
      "description": "Get 25% back as a statement credit on Southwest inflight purchases of drinks and Wi\u2011Fi made with the card (authorized users\u2019 purchases also qualify). Example value: $40 of inflight purchases in a year \u2192 $10 back.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Southwest EarlyBird Check\u2011In credits",
      "description": "Reimbursement for up to 2 EarlyBird Check\u2011In purchases each account anniversary year when bought with the card. Posts as statement credits. Pricing varies by flight; estimated value range roughly $15\u2013$99 per one\u2011way service, so up to \u2248 $30\u2013$198/year if fully used. Note: Benefit will not apply to flights with assigned seating in 2026.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "6,000 anniversary points",
      "description": "Receive 6,000 Rapid Rewards points each account anniversary year (posts after the anniversary year closes). Estimated value \u2248 $84 using ~1.4\u00a2/point; actual value varies by redemption.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "1,500 Tier Qualifying Points per $5,000 spend",
      "description": "Earn 1,500 TQPs toward A\u2011List/A\u2011List Preferred status for each $5,000 in purchases annually (as defined by the program). Helps accelerate elite status qualification; no direct cash value.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 5000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual 10,000 Companion Pass Qualifying Points boost",
      "description": "Receive a 10,000 Companion Pass qualifying points boost each calendar year (by Jan 31 or within 30 days of account opening for new cardmembers). Counts toward Companion Pass qualification; no direct cash value.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DoorDash DashPass (12 months)",
      "description": "Activate with this card between 02/01/2025 and 12/31/2027 to receive 12 months of DashPass for both DoorDash and Caviar (auto\u2011renews at then\u2011current rate unless canceled). Must use this card for eligible orders to receive benefits. Estimated membership value \u2248 $120 (assuming ~$9.99/month), plus delivery fee savings depending on usage.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $10 off quarterly on DoorDash non\u2011restaurant orders (with DashPass active)",
      "description": "After activating DashPass with this card, get $10 off one qualifying non\u2011restaurant order each calendar quarter on DoorDash. Does not roll over; limit one per quarter; U.S. only. Estimated max value \u2248 $40/year if used every quarter.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 50,000 Rapid Rewards points after spending $1,000 on purchases in the first 3 months from account opening. Not available to current Southwest personal cardmembers or to previous Southwest personal cardmembers who received a new cardmember bonus in the past 24 months (business cardholders are excluded from this restriction). Bonus posts within up to 8 weeks after meeting the requirement. Estimated value \u2248 $700 at ~1.4\u00a2/point; actual value varies by redemption.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HW4M&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/southwest/premier?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62473.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/swapremiercard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "southwest_rapid_rewards_premier_credit_card.png"
},
  [CreditCard.COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI]: {
  "id": CreditCard.COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI,
  "name": "Costco Anywhere Visa\u00ae Business Card by Citi",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citi-costco-anywhere-visa-business-credit-card/citi-costco-anywhere-visa-business-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Base rate on purchases that do not fall into higher-earning categories and on non-qualifying restaurant/travel purchases; also applies to gas/EV charging after the combined $7,000 annual cap is reached.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Restaurants worldwide (including cafes, bars, lounges, and fast food). Certain merchants earn only 1%: some bakeries, department store restaurants, and restaurants located in grocery or warehouse clubs.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "Eligible travel worldwide, including airfare, hotels, car rentals, travel agencies, cruise lines, and Costco Travel. Certain travel types earn only 1%: train and commuter travel, timeshares, campgrounds, and bed & breakfasts.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "costco",
      "earnRate": 2.0,
      "description": "All other purchases at Costco warehouses and Costco.com. Note: Costco gasoline earns 5% under the gas category; Costco Travel earns 3% under the travel category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.costco",
      "earnRate": 5.0,
      "description": "Gas purchased at Costco warehouse locations worldwide. This 5% rate shares a combined $7,000 annual cap with the 4% category for other eligible gas and EV charging; after the combined cap is reached, gas earns 1%.",
      "spendCap": 7000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 4.0,
      "description": "Other eligible gas station purchases worldwide (excluding Costco) and EV charging. Shares a combined $7,000 annual cap with the 5% Costco gas category; after the combined cap is reached, these purchases earn 1%.",
      "spendCap": 7000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2724,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2724,
    "description": "Purchase Rate: 19.24%\u201327.24% variable APR, based on creditworthiness."
  },
  "benefits": [
    {
      "name": "Damage & Theft Purchase Protection",
      "description": "Coverage for repairs or a refund if purchases made with your Citi card are damaged or stolen within 120 days of purchase (90 days for NY residents).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Travel accident insurance when traveling. Coverage details and exclusions provided in the Guide to Benefits. Estimated value: protection against unexpected travel incidents; actual payout depends on policy terms.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Baggage Protection",
      "description": "Reimbursement/coverage for lost baggage on eligible trips. Coverage details and limits provided in the Guide to Benefits.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Worldwide Car Rental Insurance",
      "description": "Worldwide car rental insurance (Collision Damage Waiver) when you use the card for the rental. Primary/secondary status not specified on the page; see Guide to Benefits. Potential value: avoids paying the rental agency\u2019s CDW which can run ~$10\u2013$30/day.",
      "benefit_type": null,
      "new_benefit_type": "car_rental_insurance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance Dispatch Service",
      "description": "Access to roadside assistance dispatch services. Service fees may apply; see Guide to Benefits.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance",
      "description": "Help coordinating medical, legal, and other emergency services while traveling. Third\u2011party costs may apply; see Guide to Benefits.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No fees on foreign purchases. Estimated value: typically saves ~3% versus cards that charge foreign transaction fees, depending on your international spend.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment",
      "description": "Access to purchase presale tickets and select exclusive experiences for concerts, sports, dining and more.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-costco-anywhere-visa-business-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "costco-anywhere-visa-business-card-by-citi.png"
},
  [CreditCard.FRONTIER_AIRLINES_WORLD_MASTERCARD]: {
  "id": CreditCard.FRONTIER_AIRLINES_WORLD_MASTERCARD,
  "name": "FRONTIER Airlines World Mastercard",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/FTA_CD_Flat_Card_Art_370x246.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.FRONTIER,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.frontier",
      "earnRate": 5.0,
      "description": "Eligible purchases made through Frontier Airlines channels: flyfrontier.com, Frontier Airlines reservations, onboard purchases, and Frontier airport/city ticket counters. Note: Marketing references to \u201cup to 15 miles per dollar\u201d include 10 miles from Frontier Miles membership plus 5 miles from the card; the 5x shown here reflects the card earn rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Variable APR for purchases: 0.2024 to 0.2999 based on creditworthiness; varies with the Prime Rate. Cash advance APR: 0.2999 variable."
  },
  "benefits": [
    {
      "name": "Zone 2 priority boarding on Frontier",
      "description": "Cardmembers receive Zone 2 boarding on Frontier flights.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn 1 Elite Status Point per $1 spent",
      "description": "Reach Frontier Elite Status faster by earning 1 Elite Status Point for every $1 spent on the card (helps with qualifying for Frontier elite tiers).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary flight voucher after annual spend",
      "description": "Earn a flight voucher each account anniversary after spending $2,500 or more in purchases during your cardmember year. Note: The page did not state a value; public offers commonly provide a $100 Frontier flight voucher\u2014treat this value as an estimate unless confirmed in the current terms.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": 2500,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Miles remain active while account is open",
      "description": "Frontier miles do not expire as long as your account is open and in good standing.",
      "benefit_type": null,
      "new_benefit_type": "miles_expiration_waived",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Bonus miles after spending $500 on purchases and paying the annual fee in full, both within the first 90 days of account opening. Note: The exact number of bonus miles was not listed on the provided page.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": 1.0,
      "spendRequirementMonths": 3,
      "description": "Instant Frontier Elite Gold Status after your first purchase within 90 days. To maintain Elite Gold for 12 months from the account open date, you must also spend $3,000 in the first 90 days; otherwise, the status expires 90 days from account opening.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "airline_status",
          "amount": null,
          "value_unit": "status"
        }
      ]
    },
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Instant Frontier Elite Gold Status after your first purchase within 90 days. To maintain Elite Gold for 12 months from the account open date, you must also spend $3,000 in the first 90 days; otherwise, the status expires 90 days from account opening.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "airline_status",
          "amount": null,
          "value_unit": "status"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/frontier-airlines-world-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/frontier-airlines-world-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "frontier_airlines_world_mastercard.png"
},
  [CreditCard.MARRIOTT_BONVOY_BOUNTIFUL_CARD_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.MARRIOTT_BONVOY_BOUNTIFUL_CARD_AMERICAN_EXPRESS_CARD,
  "name": "Marriott Bonvoy Bountiful Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/1.8.0/package/dist/img/logos/dls-logo-stack.svg",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.MARRIOTT_BONVOY,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "marriott_bonvoy_bountiful_card_american_express_card.svg"
},
  [CreditCard.SAVOR_REWARDS]: {
  "id": CreditCard.SAVOR_REWARDS,
  "name": "Savor Rewards from Capital One",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/new-savor-card-art.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on eligible bookings via Capital One Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on eligible bookings via Capital One Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Restaurants, cafes, bars, lounges, fast-food chains and bakeries.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "At grocery stores; excludes superstores like Walmart and Target.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "entertainment",
      "earnRate": 3.0,
      "description": "Ticket purchases at movie theaters; sports and theatrical promoters; amusement parks; tourist attractions; aquariums; zoos; dance halls; record stores; pool halls; bowling alleys. Excludes golf courses, collegiate sporting events, and non-industry entertainment merchant codes like cable, digital streaming and membership services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "Popular streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other purchases that do not fall into a higher-earning category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "0% intro APR for 12 months on purchases and balance transfers; then 19.24%\u201329.24% variable APR."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "No fees on purchases made outside of the United States. Potential savings ~3% of international transaction amounts vs. typical issuer fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Concierge Service",
      "description": "24/7 personalized assistance for dining, entertainment and travel needs.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extended warranty protection on eligible items purchased with the card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24-hour Travel Assistance Services",
      "description": "Emergency card replacement and cash advance assistance if your card is lost or stolen while traveling.",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Automatic insurance for a covered loss when you use the card to purchase your fare (see Guide to Benefits for terms/exclusions).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star Status",
      "description": "Enroll to receive Hertz Five Star\u00ae status: potential upgrades, skip-the-counter at select locations and access to a wider selection of cars. Enrollment via Capital One benefits portal required; terms apply.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel portal benefits",
      "description": "Access Capital One Travel features such as flight price drop protection (up to $50 credit when you book at the recommended time and the flight price drops within 10 days), 24-hour price match guarantee on eligible flight/hotel/rental car bookings, optional \u2018Cancel For Any Reason\u2019 add-on for flights, and price watch alerts. Terms vary by booking and may not be available on all reservations.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining access",
      "description": "Cardholder access to exclusive restaurant reservations and curated culinary events.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment access",
      "description": "Cardholder access to select events and experiences via Capital One Entertainment. (Earning rates on purchases are a rewards feature, not listed here.)",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "50% off Handcrafted Beverages at Capital One Caf\u00e9s",
      "description": "50% off handcrafted beverages every day at Capital One Caf\u00e9s nationwide when paying with a Capital One card; limit one per person, while supplies last; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Limited-time offer: 1) One-time $100 Capital One Travel credit to use on flights, stays or rental cars booked through Capital One Travel during your first cardholder year (credit available in portal, can be used over one or multiple purchases, earns no rewards, expires on the first anniversary; account must be open/in good standing). 2) $200 cash bonus after spending $500 on purchases within 3 months of account opening. Estimated total value: up to $300 if you fully use the $100 travel credit and earn the $200 cash bonus. Offer availability may require applying via the page\u2019s Apply Now link; prior Savor cardholders not eligible if they received a new cardmember bonus for this product in the past 48 months.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time offer: 1) One-time $100 Capital One Travel credit to use on flights, stays or rental cars booked through Capital One Travel during your first cardholder year (credit available in portal, can be used over one or multiple purchases, earns no rewards, expires on the first anniversary; account must be open/in good standing). 2) $200 cash bonus after spending $500 on purchases within 3 months of account opening. Estimated total value: up to $300 if you fully use the $100 travel credit and earn the $200 cash bonus. Offer availability may require applying via the page\u2019s Apply Now link; prior Savor cardholders not eligible if they received a new cardmember bonus for this product in the past 48 months.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/savor/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/savor/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "savor_rewards.png"
},
  [CreditCard.UNITED_EXPLORER_CARD]: {
  "id": CreditCard.UNITED_EXPLORER_CARD,
  "name": "United\u2120 Explorer Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/united_explorer_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 mile per $1 on all purchases that qualify for earning miles per the program terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.united",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 on qualifying purchases made directly with United Airlines.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "direct_with_merchant_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 at restaurants (per merchant category coding).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 on hotel accommodations when purchased directly with the hotel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "direct_with_merchant_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.2049
  },
  "annualFee": 150.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2049,
    "high": 0.2899,
    "description": "Variable APRs based on the Prime Rate (7.50% as of 2/4/2025). Purchase APR: 20.49%\u201328.99% (0.2049\u20130.2899). Balance Transfer APR: 20.49%\u201328.99% (0.2049\u20130.2899). Cash Advance APR: 29.24% (0.2924). Penalty APR: up to 29.99% (0.2999). Due date at least 21 days; no interest on new purchases if paid in full by the due date; interest on balance transfers and cash advances begins on the transaction date. Minimum interest charge: none. Note: This account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "First checked bag free on United/United Express",
      "description": "Primary cardmember and one companion on the same reservation each get the first standard checked bag free when tickets are purchased with the card (purchase requirement waived for flights completed within 90 days of account opening). United/United Express-operated flights only; oversized/overweight fees apply. Estimated value: about $70 per person per round trip (typical $35 each way), up to ~$140 per round trip for two travelers.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority boarding on United/United Express",
      "description": "Primary cardmember (and companions on the same reservation) boards before general boarding, after Premier members and Premier Access. United/United Express-operated flights only.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Two United Club one-time passes each cardmember year",
      "description": "Two one-time United Club passes are deposited after account opening and every 12 months thereafter while the account remains open. Passes are single-use, subject to United Club rules, and expire per the date shown. Estimated value: ~$118 per year (assuming ~$59 per one-time pass).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing discount on United award flights",
      "description": "When the \u201cCardmembers Save\u201d banner is present, cardmembers\u2019 award flight pricing was 32% lower on average in 2024 than general members for the same itinerary. Discount does not apply to taxes/fees. Actual savings varies by route/date and availability.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$100 United TravelBank credit after $10,000 calendar-year spend",
      "description": "Earn $100 in United TravelBank cash after $10,000 spend in a calendar year (1 per year). Posts to MileagePlus within 6\u20138 weeks. TravelBank cash expires 12 months after issuance and is usable on United/United Express bookings subject to TravelBank terms.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 United Hotels statement credits per cardmember year",
      "description": "Receive $50 statement credit on your first and second United Hotels stays of $50+ each when booked and paid through United Hotels, up to $100 per cardmember year. Credits post in 6\u20138 weeks; applied in the year the transaction posts.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$60 rideshare statement credits ($5/month)",
      "description": "Enroll each calendar year to receive up to $5 back per month in statement credits on rideshare purchases (up to $60 per year). Enrollment required annually; credits post 6\u20138 weeks. Eligible purchases count for the month they post.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Instacart monthly $10 credit with active Instacart+",
      "description": "Get one $10 Instacart credit each month you have an active Instacart+ membership after activating the complimentary Chase Instacart+ membership (offer window 3/23/2025\u201312/31/2027). Credit is applied in-app (not a statement credit), valid on one order of $10+ per month, does not roll over.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $50 Avis or Budget TravelBank credit per year",
      "description": "Earn $25 United TravelBank cash on your first and $25 on your second eligible Avis or Budget rental (2+ day rentals booked via cars.united.com with required codes), up to $50 per year. Posts to MileagePlus 6\u20138 weeks after each eligible return.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$100 annual JSX statement credit",
      "description": "Receive up to $100 per cardmember year in automatic statement credits for purchases made directly with JSX. Credits post in 6\u20138 weeks; based on the year the transaction posts.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "Receive one statement credit (up to $120) once every four years when the application fee for Global Entry, TSA PreCheck, or NEXUS is charged to the card by you or an authorized user. Estimated value: up to ~$30/year on a four-year cycle.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on United inflight purchases and United Club premium drinks",
      "description": "Get 25% back as a statement credit on purchases of food, beverages, and Wi\u2011Fi onboard United/United Express flights (including Wi\u2011Fi subscriptions) and on premium drink purchases at United Clubs when paid with the card. Credits typically post within 24 hours of the purchase posting.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Premier Qualifying Points (PQP) from spend",
      "description": "Earn 1 PQP for every $20 in net purchases (including AU purchases), up to 1,000 PQP per calendar year, applicable toward Premier status up to Premier 1K (per MileagePlus program terms). Posts in 6\u20138 weeks.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "10,000-mile award flight discount after $20,000 calendar-year spend",
      "description": "After $20,000 in purchases in a calendar year, receive one 10,000-mile award flight discount to apply to eligible United/United Express award travel (greater than 10,000 miles redeemed). Expires 12 months after issuance. Estimated value: about ~$130 assuming 1.3\u00a2 per mile.",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership for 3 months, then 25% off annual rate",
      "description": "Activate between 3/23/2025 and 12/31/2027 to receive 3 months of Instacart+ at no cost; afterwards get 25% off the then-current $99/year rate through 12/31/2027 when paid with the card. Estimated value: ~$24.75 for the 3-month complimentary period plus ~$24.75/year savings while the 25% discount applies.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge service",
      "description": "Access to concierge assistance; you are responsible for the cost of any goods or services purchased via the concierge.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "Receive one statement credit (up to $120) once every four years when the application fee for Global Entry, TSA PreCheck, or NEXUS is charged to the card by you or an authorized user. Estimated value: up to ~$30/year on a four-year cycle.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "$100 United TravelBank credit after $10,000 calendar-year spend",
      "description": "Earn $100 in United TravelBank cash after $10,000 spend in a calendar year (limit 1 per year). Posts within 6\u20138 weeks; TravelBank cash expires 12 months after issuance.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $100 United Hotels statement credits per cardmember year",
      "description": "$50 credit on each of your first two United Hotels stays of $50+ per cardmember year when booked and paid through United Hotels.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$60 rideshare statement credits ($5/month)",
      "description": "Enroll annually to get up to $5/month back on rideshare purchases (max $60/year).",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 60.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $50 Avis or Budget TravelBank credit per year",
      "description": "$25 TravelBank after first eligible rental and $25 after second (booked via cars.united.com; 2+ day rentals; required codes).",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$100 annual JSX statement credit",
      "description": "Automatic statement credits for direct JSX purchases, up to $100 per cardmember year.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "One statement credit up to $120 once every four years when the fee is charged to the card by you or an AU.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "25% back on United inflight purchases and United Club premium drinks",
      "description": "25% back as a statement credit on eligible inflight purchases and United Club premium drinks when paid with the card.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Instacart monthly $10 credit with active Instacart+",
      "description": "One $10 Instacart app credit each month with active Instacart+ after activation during 3/23/2025\u201312/31/2027. Not a statement credit; in-app credit only.",
      "credit_category": "grocery",
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 bonus miles after $3,000 in purchases in the first 3 months from account opening, plus 10,000 bonus miles after adding your first authorized user within the first 3 months. Not available to current cardmembers of this card, or previous cardmembers who received a new cardmember bonus within the last 24 months. Bonus miles post in 6\u20138 weeks; do not count toward Premier status; account must be open and not in default at fulfillment. Chase/United may claw back if the account is closed within 6 months. Estimated value: 60,000 miles \u2248 ~$780 at 1.3\u00a2/mile; 10,000 miles \u2248 ~$130; total \u2248 ~$910 (valuation varies by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 bonus miles after $3,000 in purchases in the first 3 months from account opening, plus 10,000 bonus miles after adding your first authorized user within the first 3 months. Not available to current cardmembers of this card, or previous cardmembers who received a new cardmember bonus within the last 24 months. Bonus miles post in 6\u20138 weeks; do not count toward Premier status; account must be open and not in default at fulfillment. Chase/United may claw back if the account is closed within 6 months. Estimated value: 60,000 miles \u2248 ~$780 at 1.3\u00a2/mile; 10,000 miles \u2248 ~$130; total \u2248 ~$910 (valuation varies by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HRYN&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/united/united-explorer?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61579.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/unitedexplorercard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "united_explorer_card.png"
},
  [CreditCard.AMERICAN_EXPRESS_BLUE_CASH_PREFERRED_CARD]: {
  "id": CreditCard.AMERICAN_EXPRESS_BLUE_CASH_PREFERRED_CARD,
  "name": "Blue Cash Preferred\u00ae Card from American Express",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000264_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "grocery",
      "earnRate": 6.0,
      "description": "6% cash back at U.S. supermarkets on up to $6,000 per calendar year in purchases (then 1%). Cash back is earned as Reward Dollars.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 6.0,
      "description": "6% cash back on select U.S. streaming subscriptions from participating providers.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 3.0,
      "description": "3% cash back on transit, including trains, taxicabs, rideshare services, ferries, tolls, parking, buses, and subways. Airfare, car rentals, and cruises are not considered transit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% cash back on eligible purchases of gasoline at gas stations located in the U.S. Excludes gas sold at superstores, supermarkets, and warehouse clubs.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other eligible purchases; also applies to supermarket purchases after the $6,000 annual cap is reached.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.2024
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.027,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2924,
    "description": "0% intro APR on purchases and balance transfers for 12 months from account opening (balance transfers must be requested within 60 days). After that, variable APR 0.2024\u20130.2924 based on creditworthiness; varies with the Prime Rate. Cash advance APR 0.2949. Penalty APR 0.2999 may apply for late/returned payments."
  },
  "benefits": [
    {
      "name": "$120 Disney Streaming Credit",
      "description": "Get up to $10 in statement credits each month when you use your enrolled card to pay for Disney+, Hulu, or ESPN+ subscriptions on their U.S. websites. Enrollment required; resets monthly; annual cap $120; no minimum purchase; subscription auto-renewal; statement credits post in up to 8 weeks. Estimated value: up to $120/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Shop with Points at Amazon (Reward Dollars)",
      "description": "Use Reward Dollars at Amazon.com checkout with the same value as redeeming for a statement credit. Link your eligible card to your Amazon account; no minimum redemption; credits may post in a different billing cycle. Value depends on earned Reward Dollars.",
      "benefit_type": null,
      "new_benefit_type": "shop_with_points_at_amazon",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Send & Split with Venmo and PayPal",
      "description": "Split purchases and send money to Venmo/PayPal users from the Amex App. Enrollment and opening an Amex Send stored balance account required. Add Money transactions do not earn rewards. Value depends on use; no fixed monetary credit.",
      "benefit_type": null,
      "new_benefit_type": "send_and_split",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Events with Amex (Presales and Reserved Tickets)",
      "description": "Access to Amex Presale Tickets and Amex Reserved Tickets for select events when paying with an American Express Card. Ticket availability limited; terms and venue rules apply.",
      "benefit_type": null,
      "new_benefit_type": "events_with_amex_presales_and_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Targeted offers you can add to your card to earn bonus rewards or statement credits at select merchants. Enrollment per offer required. Value varies by offer and usage.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Concessions Credit",
      "description": "Earn 10% back as a statement credit on qualifying in-venue food and beverage concessions purchases at participating American Express Venue Collection stadiums and arenas, up to $250 per calendar year. Enrollment required via Amex Offers; offer currently ends Dec 31, 2026. Estimated value: up to $250/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "credit_type": "american_express_venue_collection_concessions",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Entrances and Fast Lanes",
      "description": "Access dedicated Amex Card Member entrances or fast lanes at select Venue Collection locations with a valid event ticket and Amex card. Availability varies by venue/event; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "venue_collection_entrances_fast_lanes",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Coverage for damage or theft to a rental vehicle when you pay with your card. Provided by AMEX Assurance Company; terms, conditions and exclusions apply. Typically secondary coverage in the U.S.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Provides coverage for eligible purchases against damage or theft for a limited time after purchase. Underwritten by AMEX Assurance Company; terms and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original manufacturer\u2019s warranty on eligible items purchased with the card. Underwritten by AMEX Assurance Company; terms and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "May refund eligible purchases when the merchant won\u2019t accept a return, subject to coverage limits and timeframes. Terms and exclusions apply.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 medical, legal, and travel emergency coordination and assistance when traveling; third\u2011party service costs are the card member\u2019s responsibility. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you find a lower publicly available online rate for the same prepaid or pay-later hotel itinerary booked on AmexTravel.com, Amex will refund the difference after verification. Terms and exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rates_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$120 Disney Streaming Credit",
      "description": "Up to $10 in statement credits per month after using your enrolled card for Disney+, Hulu, or ESPN+ subscriptions on their U.S. websites. Enrollment required; resets monthly; $120 annual cap; no minimum purchase; subscription auto\u2011renews; credits post in up to 8 weeks.",
      "credit_category": "streaming.disneyplus",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "American Express Venue Collection Concessions Credit",
      "description": "Earn 10% back as a statement credit on qualifying in-venue food and beverage concessions purchases at participating American Express Venue Collection locations, up to $250 per calendar year. Enrollment required via Amex Offers; offer currently ends Dec 31, 2026.",
      "credit_type": "american_express_venue_collection_concessions",
      "credit_category": null,
      "new_credit_category": "venue_concessions",
      "value": 250.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 6,
      "description": "Earn a $300 statement credit after $3,000 in eligible purchases on the new card within the first 6 months. Statement credit posts 8\u201312 weeks after meeting the threshold. Not eligible if you have or have had this card (or certain related versions); other eligibility factors may apply.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 300.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/blue-cash-preferred/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/blue-cash-preferred/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "american_express_blue_cash_preferred_card.png"
},
  [CreditCard.QUICKSILVERONE_REWARDS]: {
  "id": CreditCard.QUICKSILVERONE_REWARDS,
  "name": "QuicksilverOne from Capital One",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/quicksilver_one_cardart.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5% cash back on every purchase, every day. Rewards do not expire for the life of the account; redemption options include statement credits, checks, gift cards, or covering recent purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 39.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 39.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "Purchase APR: 29.74% variable APR."
  },
  "benefits": [
    {
      "name": "Automatic Credit Line Reviews",
      "description": "Be automatically considered for a higher credit line in as little as 6 months.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making a purchase outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency Card Replacement",
      "description": "If your credit card is lost or stolen, you can get an emergency replacement card.",
      "benefit_type": null,
      "new_benefit_type": "emergency_card_replacement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Fraud Liability",
      "description": "If your card is lost or stolen, you will not be responsible for unauthorized charges.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Virtual Card Numbers from Eno",
      "description": "Pay for online purchases with virtual card numbers to keep your actual card number private.",
      "benefit_type": null,
      "new_benefit_type": "virtual_card_numbers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Card Lock",
      "description": "Lock your card in the Capital One Mobile app if it\u2019s misplaced, lost, or stolen.",
      "benefit_type": null,
      "new_benefit_type": "card_lock",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel Portal Access",
      "description": "Access Capital One Travel to book trips, see competitive prices, and pay with rewards, your card, or both.",
      "benefit_type": null,
      "new_benefit_type": "travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "50% Off Handcrafted Beverages at Capital One Caf\u00e9s",
      "description": "Capital One cardholders get 50% off handcrafted beverages every day at Capital One Caf\u00e9s; limit one per person (if applicable), while supplies last.",
      "benefit_type": null,
      "new_benefit_type": "cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/quicksilverone/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/quicksilverone/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "quicksilverone_rewards.png"
},
  [CreditCard.AUTOGRAPH_CARD]: {
  "id": CreditCard.AUTOGRAPH_CARD,
  "name": "Wells Fargo Autograph\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www17.wellsfargomedia.com/assets/images/photography/product/credit-cards/WF_Autograph_NoFee_VisaSignature_Collateral_Front_RGB_290w.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.WELLS_FARGO_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Dining coded by Visa as eating places and restaurants, drinking places, fast food restaurants, and caterers. Note: Food purchases at bakeries, grocery stores or other venues with on-site restaurants, and some third\u2011party delivery services may not qualify for the bonus category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "Travel coded by Visa, including airlines, hotel/motel, timeshares, vehicle/auto rentals, cruise lines, travel agencies, discount travel sites, and campgrounds.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "Gas stations, automated fuel dispensers, and electric vehicle charging stations. Purchases at auto repair stores, superstores, car washes, warehouse/membership clubs, and grocery stores may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 3.0,
      "description": "Transit coded by Visa, including passenger railway, taxis, limousines, ferries, parking lots and garages, toll bridges and highways. Includes rideshares when coded as transit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "Popular streaming services (cable and other pay TV, digital goods, books, movies, music, and continuity/subscription services) as listed at wellsfargo.com/autographstreaming. Bundled services or third\u2011party\u2011billed services may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 3.0,
      "description": "Select phone plans from landline and cell phone providers (telecommunication services). Excludes phones/accessories, additional services (e.g., insurance, extra data), and plans bundled or billed by third parties (e.g., internet providers, in\u2011vehicle services).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Base rate on other purchases that do not fall into the listed bonus categories. Cash equivalents (e.g., cash advances, money orders, prepaid gift cards, peer\u2011to\u2011peer payments, wire transfers), balance transfers, fees, interest, and gambling transactions do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.2899,
    "description": "0% intro APR for 12 months from account opening on purchases; thereafter 18.99%, 23.99%, or 28.99% variable APR based on creditworthiness. Balance transfer APR: 18.99%, 23.99%, or 28.99% variable. Intro balance transfer fee: $5 or 3% (whichever is greater) for 120 days from account opening; after that, up to 5% ($5 min). Cash advance APR: 29.99% variable. APRs vary with the U.S. Prime Rate. Minimum interest charge $1. Late payment fee up to $40."
  },
  "benefits": [
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $600 per approved claim (max 2 paid claims per 12 months; $25 deductible per claim). Wireless bill must be paid with the Autograph card; coverage begins the month after the first eligible bill payment. Does not cover lost phones, cosmetic damage, or software/electronic failures. Potential value up to $1,200/year if two max claims are approved.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Secondary coverage for damage or theft when the entire rental is paid with the card and you decline the rental company\u2019s CDW. Certain vehicle types excluded; terms apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance Services",
      "description": "24/7 referral and assistance for medical, legal, transportation, and other emergencies while traveling. Cardholder pays costs of services rendered.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Dispatch",
      "description": "Pay-per-use towing and roadside assistance available 24/7; fees disclosed at time of service; availability may vary by area.",
      "benefit_type": null,
      "new_benefit_type": "roadside_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "Complimentary 24/7 assistance for dining, event tickets, travel planning, and more. Cardholder responsible for purchases made via concierge.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Luxury Hotel Collection",
      "description": "Access to benefits at participating properties when booked via Visa Signature channels; benefits vary by property and may include room upgrades, breakfast, late checkout, etc.; terms and availability apply.",
      "benefit_type": null,
      "new_benefit_type": "visa_signature_luxury_hotel_collection_benefits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points Transfer to Travel Partners",
      "description": "Transfer Wells Fargo Rewards points directly to participating airline/hotel partners with no minimum required. Transfers are generally 1:1 unless stated otherwise; final value depends on partner and redemption.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No fee on purchases made outside the U.S. in foreign currencies.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "My Wells Fargo Deals",
      "description": "Targeted merchant offers that provide statement credits after activation and eligible purchases; terms vary by offer and credits typically post within ~60 days.",
      "benefit_type": null,
      "new_benefit_type": "my_wells_fargo_deals_merchant_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency Cash Disbursement and Card Replacement",
      "description": "Assistance obtaining emergency cash advances (fees/interest apply) and expedited card replacement, typically within 1\u20133 business days after issuer approval.",
      "benefit_type": null,
      "new_benefit_type": "emergency_cash_disbursement_and_card_replacement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 20,000 bonus points after $1,000 in net purchases in the first 3 months from account opening (redeemable as $200 cash value). Excludes cash advances, balance transfers, fees/interest, gambling transactions, and other excluded categories per terms. Offer may be unavailable if you currently have or have had this card within the last 48 months.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "points (\u2248$200 cash redemption value)"
        }
      ]
    }
  ],
  "apply_link": "https://apply.wellsfargo.com/getting_started?FPID=012988I6P10000&applicationtype=consumercreditcard&product_code=CC&subproduct_code=AU&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "learn_more_link": "https://creditcards.wellsfargo.com/autograph-visa-credit-card/?FPID=012988I6P10000&product_code=CC&subproduct_code=AU&cx_nm=CXNAME_CSMPD_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/autograph-visa/terms/?FPID=012988I6P10000&product_code=CC&subproduct_code=AU&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [
    {
      "name": "Compare Autograph credit cards",
      "url": "https://creditcards.wellsfargo.com/wells-fargo-autograph-visa-credit-cards/?product_code=CC&subproduct_code=MC&sub_channel=SEO&vendor_code=G"
    }
  ],
  "bank_name": "Wells Fargo",
  "imageName": "autograph_card.png"
},
  [CreditCard.QUICKSILVER_REWARDS_FOR_STUDENTS]: {
  "id": CreditCard.QUICKSILVER_REWARDS_FOR_STUDENTS,
  "name": "Quicksilver Rewards for Students",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/qs_cardart_prim_1290x812.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5% cash back on every purchase, every day.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "Purchase APR: 0.1924\u20130.2924 variable. Balance transfer APR: 0.1924\u20130.2924 variable. Balance transfer fee applies (amount not disclosed). No 0% intro APR mentioned."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making purchases outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Concierge Service",
      "description": "Personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Additional warranty protection at no charge on eligible items purchased with your card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24-hour Travel Assistance Services",
      "description": "If your card is lost or stolen, you can get an emergency replacement card and a cash advance.",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Automatic insurance for a covered loss at no extra charge when you use your credit card to purchase your fare.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel",
      "description": "Access the Capital One Travel portal features like free price drop protection (up to $50 credit when you book when recommended and the price drops within 10 days), 24-hour price match on eligible bookings, optional cancel-for-any-reason coverage up to 3 hours before departure (most of booking cost refunded), and price watch alerts.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_travel_portal_benefits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment",
      "description": "Access to can\u2019t\u2011miss events across music, sports, theater and dining with exclusive pre\u2011sales, tickets, suite experiences and more via Capital One Entertainment.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining",
      "description": "Access to cardholder\u2011only reservations at select restaurants and curated culinary events.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "50% off Handcrafted Beverages at Capital One Caf\u00e9s",
      "description": "Cardholders get 50% off handcrafted beverages every day at Capital One Caf\u00e9s nationwide; limit one per person, while supplies last.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Shopping",
      "description": "Free online shopping tool that automatically applies available coupon codes to your order.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_shopping_extension",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 100.0,
      "spendRequirementMonths": 3,
      "description": "Earn a one-time $50 cash bonus after you spend $100 on purchases within 3 months from account opening. Bonus is applied to your rewards balance within two billing cycles once qualified. Existing or previous accountholders may not be eligible for this one-time bonus.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 50.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/quicksilver-student/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/quicksilver-student/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "quicksilver_rewards_for_students.png"
},
  [CreditCard.BREAD_REWARDS_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.BREAD_REWARDS_AMERICAN_EXPRESS_CARD,
  "name": "Bread Rewards\u2122 American Express\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "/cards/bread_rewards_american_express_card.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3x points per $1 at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3x points per $1 at grocery stores, excluding wholesale clubs.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3x points per $1 at restaurants, excluding food delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "utilities",
      "earnRate": 3.0,
      "description": "3x points per $1 on utilities (electric, gas, water, sanitary services).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases. With 20+ purchases per billing cycle, earn a 25% bonus on all points earned that cycle.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3349,
    "apr_low": 0.1899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.3349,
    "description": ""
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": null,
  "learn_more_link": "https://www.breadfinancial.com/en/bread-rewards-credit-card.html",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Comenity",
  "imageName": "bread_rewards_american_express_card.jpg"
},
  [CreditCard.UNITED_CLUB_BUSINESS_CARD]: {
  "id": CreditCard.UNITED_CLUB_BUSINESS_CARD,
  "name": "United Club\u2120 Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_club_biz_card_tilted.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5 miles per $1 spent on purchases. Excludes transactions that are not considered purchases: balance transfers, cash advances and cash-like transactions, travelers checks, foreign currency, money orders, wire transfers, lottery tickets, casino gaming chips, race track wagers or similar betting transactions, any checks that access your account, interest, unauthorized or fraudulent charges, and fees of any kind (including annual fee).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.united",
      "earnRate": 2.0,
      "description": "Earn 2 miles total per $1 spent on purchases from United: airline tickets purchased from United, and purchases made from United such as seat upgrades, Economy Plus, inflight food, beverages and Wi\u2011Fi, baggage service charges, and other United fees. Also excludes other United\u2011related purchases such as United Cruises, United MileagePlus X, DIRECTV, and Merchandise Awards. United tickets booked through some discount travel websites or as part of a third\u2011party travel package do not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 695.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2874,
    "apr_low": 0.2024
  },
  "annualFee": 695.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2874,
    "description": "Purchase APR 0.2024\u20130.2874 variable (based on Prime Rate); Balance Transfer APR 0.2024\u20130.2874 variable; Cash Advance APR 0.2899 variable; Penalty APR up to 0.2999 variable. Grace period: at least 20 days on purchases if you pay your entire balance or Interest Saving Balance by the due date. Minimum interest charge: None. Balance transfer fee: $5 or 0.05 of each transfer (whichever is greater). Cash advance fee: $15 or 0.05 of each transaction (whichever is greater). Late fee: $40. Return payment fee: $40. Note: This account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "United Club card membership (lounge access)",
      "description": "Primary cardmember lounge access to United Club locations worldwide (value at least ~$750/year). Authorized users do not receive their own membership. Effective 8/1/2025, you can earn All Access membership by spending $50,000 in a calendar year or by holding Premier Gold+ status; All Access includes Star Alliance lounge access and expanded guesting.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "4 United Club one-time passes annually (with All Access + employee card)",
      "description": "Earn 4 United Club one-time passes each account anniversary when you have United Club All Access membership and at least one employee/authorized user card. Passes deposit around your anniversary and require the primary or employee cardholder to be present. Estimated $200+ value per year.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": true
    },
    {
      "name": "Free first and second checked bags",
      "description": "Primary cardmember and one companion each get first and second standard checked bags free on United/United Express when MileagePlus number is on the reservation and tickets are purchased from United with the card (purchase requirement waived for first 90 days). Estimated savings up to $360 per roundtrip.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premier Access airport services",
      "description": "Priority check-in, security (where available), boarding, and baggage handling on United/United Express when traveling on the same reservation.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "2 global Economy Plus seat upgrades",
      "description": "Earn 2 Economy Plus upgrade certificates after $40,000 in purchases each calendar year; valid on United/United Express when available; must use the card to purchase tickets and include your MileagePlus number. Certificates expire 12 months from issue.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing discount",
      "description": "Save on average about 30% in miles on select United-operated award flights when the \u201cCardmembers Save\u201d banner appears (2024 data point; actual savings vary and are not guaranteed).",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn up to 28,000 Premier Qualifying Points (PQP) from spend",
      "description": "Earn 1 PQP per $15 in purchases, up to 28,000 PQP per calendar year, which can help you reach Premier status up to Premier 1K.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on United inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on food, beverage, and Wi\u2011Fi purchases onboard United/United Express and on premium drink purchases at United Clubs when paid with the card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Avis President\u2019s Club status",
      "description": "Complimentary enrollment in Avis President\u2019s Club for the primary cardmember, offering benefits like two\u2011class upgrades (subject to availability), guaranteed car availability, and expedited service.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership",
      "description": "Complimentary Instacart+ membership through 12/31/2027 (or minimum one year from activation), then auto\u2011renews at then\u2011current rate unless canceled. Est. ~$99/year value during promotional period.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Renowned Hotels and Resorts statement credit",
      "description": "Up to $200 in statement credits each account year for prepaid hotel stays booked and paid directly through Renowned Hotels and Resorts for United Cardmembers. Est. $200/year value if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$150 rideshare statement credits (enrollment required)",
      "description": "Up to $150 back per calendar year on rideshare purchases when paid with the card: up to $12/month Jan\u2013Nov and $18 in Dec; yearly opt\u2011in required. Est. $150/year value if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 in United TravelBank cash on Avis or Budget rentals",
      "description": "Earn $50 TravelBank cash on your 1st and $50 on your 2nd eligible Avis or Budget rental booked via cars.united.com and paid with the card (min. 2\u2011day rental; specific codes required), up to $100 per account year. Est. $100/year value if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$240 in Instacart credits",
      "description": "Receive two $10 Instacart credits per month (total up to $240/year) for purchases made directly through Instacart with the card; credits do not roll over. Benefit through 12/31/2027. Est. $240/year value if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 JSX statement credit",
      "description": "Up to $200 in statement credits each account year for purchases made directly with JSX when paid with the card. Est. $200/year value if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$50 United FareLock statement credit",
      "description": "Up to $50 back in statement credits each account year for FareLock purchases on United/United Express flights when paid with the card. Est. $50/year value if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Premier upgrades on award tickets (with Premier status)",
      "description": "Primary cardmember with MileagePlus Premier status and one companion on the same reservation are eligible for Complimentary Premier Upgrades on select United/United Express award flights, subject to availability and prioritization rules.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary \u2018Better Together\u2019 bonus miles",
      "description": "Earn 5,000 bonus miles each account anniversary if you (the authorizing officer) also hold a personal United credit card from Chase. Both accounts must be open and in good standing.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "Reimbursement up to $10,000 per covered traveler and $20,000 per trip for prepaid, non\u2011refundable travel expenses if your trip is canceled or cut short due to covered reasons.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Up to $100 per day for up to 3 days for essential purchases when baggage is delayed over 6 hours.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Reimbursement up to $3,000 per covered traveler for checked or carry\u2011on baggage that is lost, damaged, or stolen on a covered trip (NY limits apply).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Reimbursement",
      "description": "If common carrier travel is delayed more than 12 hours or requires an overnight stay, reimbursement for unreimbursed expenses like meals and lodging up to $500 per covered traveler.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Primary for business rentals)",
      "description": "Primary coverage for theft and collision damage on most rentals (MSRP \u2264 $125,000) when you decline the rental company\u2019s CDW and charge the entire rental to the card (primary when renting for business).",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days (90 days for NY residents) against damage or theft, up to $10,000 per item.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "If a store won\u2019t accept a return within 90 days, you can be reimbursed up to $500 per item, $1,000 per year.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends eligible U.S. manufacturer warranties of 3 years or less by 1 additional year, up to 4 years from purchase date.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Concierge",
      "description": "24/7 complimentary concierge assistance for dining, entertainment, travel planning, and more. Cardmember pays for goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$200 Renowned Hotels and Resorts statement credit",
      "description": "Up to $200 back in statement credits each account year on prepaid hotel stays booked and paid directly through Renowned Hotels and Resorts for United Cardmembers with your United Club Business Card. Estimated $200/year if fully used.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$150 rideshare statement credits (enrollment required)",
      "description": "Enroll annually to receive up to $150 back per calendar year on rideshare purchases: up to $12 per month Jan\u2013Nov and $18 in Dec, when paid with your card.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $100 United TravelBank on Avis or Budget rentals",
      "description": "Earn $50 TravelBank cash after each of your first two eligible Avis/Budget rentals booked via cars.united.com and paid with your card (min. 2 days), up to $100 per account year.",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$240 Instacart credits",
      "description": "Two $10 credits per month (total up to $240/year) in the Instacart app for purchases made directly through Instacart with your card; credits don\u2019t roll over. Benefit through 12/31/2027.",
      "credit_category": null,
      "new_credit_category": "instacart_credits",
      "value": 240.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$200 JSX statement credit",
      "description": "Up to $200 back in statement credits each account year on purchases made directly with JSX when paid with your card.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$50 United FareLock statement credit",
      "description": "Up to $50 back in statement credits each account year after you buy FareLock on a United/United Express\u2011operated flight with your card.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 100,000 bonus miles + 2,000 Premier qualifying points (PQP) after $5,000 in purchases in the first 3 months from account opening (est. 100,000 miles \u2248 ~$1,200 at ~1.2\u00a2/mile; PQP help qualify for Premier status). Plus, earn 10,000 bonus miles after adding an employee/authorized user card within the first 3 months.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "miles"
        },
        {
          "reward_type": null,
          "new_reward_type": "status_qualifying_points_united",
          "amount": 2000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Earn 100,000 bonus miles + 2,000 Premier qualifying points (PQP) after $5,000 in purchases in the first 3 months from account opening (est. 100,000 miles \u2248 ~$1,200 at ~1.2\u00a2/mile; PQP help qualify for Premier status). Plus, earn 10,000 bonus miles after adding an employee/authorized user card within the first 3 months.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HV3V&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/united/united-club-business?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62214.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/UnitedClubBusinessCard/RewardsAgreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "united_club_business_card.png"
},
  [CreditCard.CITI_SHELL_FUEL_REWARDS_MASTERCARD]: {
  "id": CreditCard.CITI_SHELL_FUEL_REWARDS_MASTERCARD,
  "name": "Shell | Fuel Rewards\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/shell-fuel-rewards-master/shell-fuel-rewards-master_222x140.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2% Shell rebates on dining purchases on the first $10,000 in combined dining and grocery purchases per year. Combined annual cap shared with groceries. Rebates are automatically applied as statement credits against Shell purchases in future billing cycles.",
      "spendCap": 10000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% Shell rebates on grocery purchases on the first $10,000 in combined dining and grocery purchases per year. Combined annual cap shared with dining. Rebates are automatically applied as statement credits against Shell purchases in future billing cycles.",
      "spendCap": 10000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.3324,
    "apr_low": 0.3324
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3324,
    "high": 0.3324,
    "description": "As of 12/24/2024 for the Shell | Fuel Rewards\u00ae Mastercard\u00ae: Purchase APR variable 33.24%; Cash Advance APR variable 33.24%. Minimum interest charge $2. Cash advance fee: $10 or 5% of each cash advance (whichever is greater). Late fee up to $40. Foreign transaction fee 3% of each purchase transaction in U.S. dollars."
  },
  "benefits": [
    {
      "name": "Everyday fuel discount at Shell (10\u00a2/gal, up to 35 gallons per fill)",
      "description": "Save 10\u00a2 per gallon every time you fill up at participating Shell locations (up to 35 gallons per fill). Savings are applied instantly at the pump. 10\u00a2/gal reflects 5\u00a2/gal from Fuel Rewards Gold Status plus 5\u00a2/gal for using the Shell | Fuel Rewards\u00ae credit card.",
      "benefit_type": null,
      "new_benefit_type": "fuel_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Fuel Rewards\u00ae Gold Status enrollment (5\u00a2/gal savings)",
      "description": "Automatic enrollment into the Fuel Rewards\u00ae program with Gold Status upon approval. Gold Status provides 5\u00a2/gal savings on fuel at participating Shell stations, up to 35 gallons per fill.",
      "benefit_type": null,
      "new_benefit_type": "fuel_rewards_gold_status",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Liability for Unauthorized Charges",
      "description": "You are not responsible for unauthorized charges made with your card. Enhanced chip security and contactless capabilities are built in.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic application/redemption of savings and rebates",
      "description": "Fuel savings apply instantly at the pump when you pay with the card. Shell rebates on eligible purchases are automatically redeemed as statement credits against Shell purchases in future billing cycles; no separate rewards tracking needed and no need to swipe a separate Fuel Rewards\u00ae loyalty card at the pump.",
      "benefit_type": null,
      "new_benefit_type": "automatic_rewards_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Save 30\u00a2/gal (up to 35 gallons) on your first 5 Shell fuel purchases. New accounts only. Apply by 12/31/25; qualifying fuel purchases must be made by 2/28/26. Savings are applied instantly at the pump at participating Shell stations. Estimated maximum value \u2248 $52.50 (0.30 \u00d7 35 gallons \u00d7 5 fills).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "cents_per_gallon_discount",
          "amount": 30.0,
          "value_unit": "cents_per_gallon"
        }
      ]
    }
  ],
  "apply_link": "https://citiretailservices.citibankonline.com/apply/shell-credit-card?app=UNSOL&siteId=PLOC_SHELL&plsrc=FR07&cmp=W~P~Z~B~7~D~ZZZ0~AI~SH~ZZ&sc=06276",
  "learn_more_link": "https://www.citi.com/credit-cards/shell-fuel-rewards-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/shell-fuel-rewards-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_shell_fuel_rewards_mastercard.png"
},
  [CreditCard.BREEZE_EASYVISA_CREDIT_CARD]: {
  "id": CreditCard.BREEZE_EASYVISA_CREDIT_CARD,
  "name": "Breeze Easy\u2122 Visa\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BRZ_CD_card_Windows_VS_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.BREEZEPOINTS,
  "rewards_earn_rates": [
    {
      "category": "breeze_bundles_and_trip_add_ons",
      "earnRate": 5.0,
      "description": "Part 1 of the Breeze earn structure for Nicer/Nicest bundles and trip add-ons. No stated cap; additional 5X awarded when you fly on the ticket.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "earn_when_buy"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.breeze",
      "earnRate": 2.0,
      "description": "Part 2 of the Breeze earn structure for Nice bundles. Combined with purchase earn, yields up to 4X on these fares.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "earn_when_fly"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "Eligible grocery store purchases. No portal required; no cap stated.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Eligible restaurant purchases, including Breeze Airways inflight food and beverages. No portal required; no cap stated.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other net purchases earn 1 BreezePoint per $1. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 89.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 89.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchases: variable 0.2024 to 0.2999 based on creditworthiness; varies with Prime Rate. Balance transfers: 0.0 introductory APR for first 12 billing cycles for transfers that post within 45 days of account opening; thereafter variable 0.2024 to 0.2999, varies with Prime Rate. Cash advances: variable 0.2999."
  },
  "benefits": [
    {
      "name": "Anniversary Bonus BreezePoints",
      "description": "Earn 7,500 Anniversary Bonus BreezePoints after every account anniversary with eligible purchases. Estimated value ~$60\u2013$90 assuming ~0.8\u20131.2 cents per BreezePoint; issuer notes award pricing varies.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "One-Way Bundle Upgrade",
      "description": "Receive one One-Way Bundle Upgrade with every $15,000 in purchases. Can be earned multiple times as spend thresholds are met. Exact dollar value varies by route and fare bundle difference.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 1 Priority Boarding on Breeze",
      "description": "Primary cardmembers and their companions receive Group 1 priority boarding on Breeze-operated flights.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Inflight Wi\u2011Fi on Breeze",
      "description": "Complimentary inflight Wi\u2011Fi when flying on Breeze Airways. Availability may vary by aircraft/route.",
      "benefit_type": "airline_wifi_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "BreezePoints Never Expire",
      "description": "As a cardmember, BreezePoints do not expire.",
      "benefit_type": null,
      "new_benefit_type": "points_never_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 30,000 BreezePoints after spending $1,000 on purchases in the first 90 days. Breeze estimates this is worth about $300 based on current award redemption rates; actual value depends on the itinerary booked.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/breeze-airways/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/breeze-airways/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "breeze_easyvisa_credit_card.png"
},
  [CreditCard.BARNES_NOBLE_MASTERCARD]: {
  "id": CreditCard.BARNES_NOBLE_MASTERCARD,
  "name": "Barnes & Noble Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BN1_card_rRGB_BarnesAndNoble_PM_359x246_Angle_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "barnesAndNoble",
      "earnRate": 5.0,
      "description": "Get 5% back on purchases made at Barnes & Noble (in stores or at bn.com) when you use the card. This automatic 5% discount is separate from the points-earning structure.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "paper_source",
      "earnRate": 5.0,
      "description": "Get 5% back on purchases made at Paper Source when you use the card. This automatic 5% discount mirrors the Barnes & Noble benefit and is separate from the points-earning structure.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2 points per $1 spent at restaurants; Barnes & Noble Caf\u00e9 purchases are excluded from this dining multiplier.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point per $1 on all other eligible purchases; Barnes & Noble and Paper Source purchases do not earn this base rate because they receive a separate 5% back benefit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2999,
    "description": "Variable APRs based on the Prime Rate: purchases 0.1824\u20130.2999; balance transfers 0.0 introductory for 15 billing cycles on transfers that post within 45 days of account opening, then 0.1824\u20130.2999; cash advances 0.2999. Minimum monthly interest charge $0.50."
  },
  "benefits": [
    {
      "name": "Complimentary Barnes & Noble Premium Membership (with annual spend)",
      "description": "Receive a complimentary Barnes & Noble Premium Membership if you spend $7,500/year on eligible purchases. Applies each year you meet the threshold. Amount/value of the membership is not listed on-page.",
      "benefit_type": null,
      "new_benefit_type": "barnes_and_noble_premium_membership",
      "spend_requirement": 7500,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Barnes & Noble gift card at 2,500 points (recurring)",
      "description": "Receive a Barnes & Noble gift card every time you earn 2,500 points. The page does not state the gift card amount; commonly, 2,500 points corresponds to a $25 B&N gift card (\u22481\u00a2 per point), but this is an estimate based on typical program structure and not explicitly confirmed by the provided text.",
      "benefit_type": null,
      "new_benefit_type": "retailer_gift_card_threshold_reward",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Introductory bonus awarded after your first purchase or balance transfer (exact amount not stated on-page). Based on typical offers for this card, this is estimated to be a $25 Barnes & Noble gift card; confirm current amount and timing in the official Terms and Conditions.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "gift_card",
          "amount": 25.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/barnes-noble-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/barnes-noble-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "barnes_noble_mastercard.png"
},
  [CreditCard.JCPENNEY_CREDIT_CARD]: {
  "id": CreditCard.JCPENNEY_CREDIT_CARD,
  "name": "JCPenney Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/jcpenney_credit_card.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.3399
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3399,
    "high": 0.3399,
    "description": "As of 01/01/25: Variable purchase APR 33.99%; variable penalty APR 39.99%; minimum interest charge $2. JCPenney Mastercard: cash advance APR 33.99% with a 5% cash advance fee (min $10). Foreign transaction fee 3% (likely Mastercard only)."
  },
  "benefits": [
    {
      "name": "Special financing on eligible JCPenney purchases",
      "description": "Promotional/special financing offers available when requested at time of purchase; subject to credit approval. See store associate or jcp.com for current terms and eligible purchases.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Birthday CashPass Reward (via JCPenney Rewards)",
      "description": "Annual birthday CashPass reward issued to eligible members. For cardmembers, eligibility includes having a birthday on file, at least one JCPenney Credit Card/Mastercard purchase in the last 12 months, and an account in good standing. One CashPass per account per year. Value varies by offer; not specified in terms.",
      "benefit_type": null,
      "new_benefit_type": "birthday_cashpass_reward",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic enrollment in JCPenney Rewards",
      "description": "Cardmembers are automatically enrolled in the JCPenney Rewards program and can earn CashPass Points and receive program offers. Points convert to CashPass rewards; exclusions and caps apply per program terms. Note: ongoing earn rates are part of the store rewards program and not treated as a signup bonus.",
      "benefit_type": null,
      "new_benefit_type": "store_rewards_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Account-opening discount(s) upon approval: extra 35% off select apparel, shoes, accessories, fine jewelry, bedding, bath, rugs, curtains; extra 20% off select home, watches, salon products, fragrances, select JCPenney Beauty; extra 10% off select electronics, floor care, small kitchen appliances, Modern Bride Design Your Dream Ring, smartwatches; US-only: extra 20% off select furniture and mattresses; PR stores: extra 20% off select PR-exclusive cosmetics. Valid in-store and at jcp.com (exclusions/brand restrictions apply). Full purchase must be charged to the new JCPenney Credit Card or JCPenney Mastercard to receive the discount. Coupon can be used multiple times within 24 hours after first use. If no instant decision is provided but later approved, a 35% off coupon is mailed with the card. Offers valid through 11/30/2025. Estimated value depends on purchase size (e.g., 35% off saves $35 per $100 of eligible apparel).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percent_off_coupon",
          "amount": 35.0,
          "value_unit": "percent"
        },
        {
          "reward_type": null,
          "new_reward_type": "percent_off_coupon",
          "amount": 20.0,
          "value_unit": "percent"
        },
        {
          "reward_type": null,
          "new_reward_type": "percent_off_coupon",
          "amount": 10.0,
          "value_unit": "percent"
        },
        {
          "reward_type": null,
          "new_reward_type": "percent_off_coupon",
          "amount": 20.0,
          "value_unit": "percent"
        },
        {
          "reward_type": null,
          "new_reward_type": "percent_off_coupon",
          "amount": 20.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://apply.syf.com/eapply/eapply.action?clientCode=JCPCON&sitecode=jcawe0y01&intcmp=NoOff_JCPenneyCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://apply.syf.com/eapply/eapply.action?clientCode=JCPCON&sitecode=jcawe0y01&intcmp=NoOff_JCPenneyCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://apply.syf.com/EApply/eapply.action?clientCode=JCPCON&preQual=Y&sitecode=jcawe0y02&intcmp=NoOff_JCPenneyCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    },
    {
      "name": "JCPenney Rewards Program Description",
      "url": "https://www.jcpenney.com/m/customer-service/rewards-terms-and-conditions"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "jcpenney_credit_card.jpg"
},
  [CreditCard.DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD,
  "name": "Delta SkyMiles\u00ae Reserve American Express Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000270_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DELTA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.delta",
      "earnRate": 3.0,
      "description": "3X miles on purchases made directly with Delta Air Lines (e.g., bookings and eligible charges via Delta channels).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1X mile per dollar on all other eligible purchases that do not earn a higher rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 650.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 650.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "MQD Headstart",
      "description": "Receive $2,500 Medallion Qualification Dollars (MQDs) each Medallion Qualification Year automatically to get closer to Delta Medallion Status.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "MQD Boost",
      "description": "Earn $1 MQD for each $10 in purchases made on your Card, helping you progress toward elevated Medallion Status for the next Medallion Year.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Delta Sky Club Access (15 visits)",
      "description": "Enjoy 15 visits each Medallion Year to the Delta Sky Club when flying Delta.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Unlock Unlimited Delta Sky Club Access after $75,000 spend",
      "description": "After $75,000 in purchases on your Card during a calendar year, unlock unlimited Delta Sky Club access for the remainder of the Medallion Year.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": 75000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$240 Resy Credit",
      "description": "Get up to $20 in statement credits each month (up to $240 per calendar year) after you pay with your enrolled Card at U.S. Resy restaurants or for other eligible Resy purchases. Enrollment required. Estimated value: up to $240/year if fully utilized.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Delta Stays Credit",
      "description": "Receive up to $200 in statement credits each year after using your Card to book prepaid hotels or vacation rentals through Delta Stays on delta.com. Estimated value: up to $200/year if fully utilized.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Companion Certificate (after renewal)",
      "description": "Receive a Companion Certificate each year after Card renewal, valid for a round-trip Delta flight in First Class, Delta Comfort+, or Main Cabin within the U.S. and to Mexico, the Caribbean, or Central America (Basic fares excluded). Taxes/fees apply (approx. $22\u2013$250 for up to four segments). Value varies widely by route/cabin; conservative estimate several hundred dollars when used strategically.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$240 Resy Credit",
      "description": "Up to $20 per month in statement credits (up to $240/year) after using your enrolled Card at U.S. Resy restaurants or for other eligible Resy purchases.",
      "credit_type": "monthly_credit",
      "credit_category": {
        "categories": [
          "dining"
        ],
        "exclude_subcategories": null,
        "is_us_only": true,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Dining at U.S. Resy restaurants or other eligible Resy purchases."
      },
      "new_credit_category": null,
      "value": 20.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0
          ]
        }
      ],
      "total_yearly_value": 240.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    },
    {
      "name": "$200 Delta Stays Credit",
      "description": "Annual statement credit of up to $200 after booking prepaid hotels or vacation rentals through Delta Stays on delta.com with your Card.",
      "credit_type": "annual_credit",
      "credit_category": {
        "categories": [
          "travel"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": true,
        "requires_travel_portal": true,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Prepaid hotels or vacation rentals booked via Delta Stays on delta.com."
      },
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            200.0
          ]
        }
      ],
      "total_yearly_value": 200.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 100,000 bonus miles after spending $6,000 in purchases in the first 6 months.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "miles",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    },
    {
      "spendRequirement": 9000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 25,000 additional bonus miles after spending $3,000 more in the first 6 months.",
      "rewards": [
        {
          "reward_type": "delta",
          "new_reward_type": null,
          "amount": 25000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/delta-reserve/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/delta-reserve/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "delta_skymiles_reserve_american_express_card.avif"
},
  [CreditCard.INK_BUSINESS_PREFERRED_CREDIT_CARD]: {
  "id": CreditCard.INK_BUSINESS_PREFERRED_CREDIT_CARD,
  "name": "Ink Business Preferred\u00ae Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_preferred_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 3.0,
      "description": "Earn 3x points in combined purchases on shipping, online advertising, internet/cable/phone services, and travel (shared $150,000 annual cap; then 1x).",
      "spendCap": 150000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "internetCablePhone",
          "onlineAdvertising",
          "shipping",
          "travel"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Earn 3x points on shipping, online advertising, internet/cable/phone services, and travel purchases combined; $150,000 cap per account anniversary year shared across these categories, then 1x.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1x point per $1 on all purchases; purchases in the 3x categories earn 1x after the combined $150,000 cap is reached. No cap on base earn. Excludes non-purchase transactions per program terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2599,
    "apr_low": 0.1999
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2599,
    "description": "Purchase APR 0.1999\u20130.2599 variable (based on Prime Rate); Balance Transfer APR 0.1999\u20130.2599 variable; Cash Advance APR 0.2899; Penalty APR up to 0.2999. Grace period at least 20 days; no minimum interest charge."
  },
  "benefits": [
    {
      "name": "1:1 Points Transfer to Travel Partners",
      "description": "Transfer Ultimate Rewards points at a 1:1 ratio to participating programs: Aer Lingus AerClub, Air Canada Aeroplan, British Airways Avios (Club), Flying Blue (Air France-KLM), Iberia Plus, JetBlue TrueBlue, Singapore KrisFlyer, Southwest Rapid Rewards, United MileagePlus, Virgin Atlantic Flying Club; hotels: IHG One Rewards, Marriott Bonvoy, World of Hyatt.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Insurance",
      "description": "Reimbursement if a trip is canceled or cut short due to covered reasons. Up to $5,000 per covered traveler and $10,000 per trip for prepaid, nonrefundable expenses (fares, tours, hotels).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Primary for Business Rentals)",
      "description": "Decline the rental company\u2019s CDW and charge the entire rental to the card. Primary coverage for business rentals; reimbursement up to $60,000 for theft and collision damage for most vehicles with MSRP of $125,000 or less.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "Up to $1,000 per claim against covered theft or damage for phones listed on a monthly bill paid with the card; max 3 claims in 12 months; $100 deductible per claim.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days from purchase against damage or theft, up to $10,000 per item. Note: New York residents have a 90-day coverage period.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the manufacturer\u2019s U.S. warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years total from purchase).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance (Dispatch)",
      "description": "Access dispatch for roadside emergencies; service fees are billed to your card at time of dispatch.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No fees on purchases made outside the U.S. Example from issuer: spending $5,000 internationally avoids $150 in fees (assumes a typical 3% fee).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Chase Travel Redemption Bonus (Limited Time)",
      "description": "Points are worth 25% more when redeemed through Chase Travel until October 25, 2025 (1 point = 1.25 cents toward travel). Starting October 26, 2025, travel redemptions are 1 cent per point.",
      "benefit_type": null,
      "new_benefit_type": "travel_portal_redemption_bonus",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 8000.0,
      "spendRequirementMonths": 3,
      "description": "90,000 bonus points after $8,000 spend in the first 3 months from account opening. Estimated value: $1,125 toward travel via Chase Travel through Oct 25, 2025 (90,000 x 1.25\u00a2), or $900 as cash back at 1.0\u00a2/point. Actual value may vary if transferring to partners.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 90000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HM3P&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/ink/business-preferred?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60250.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/inkbusinesspreferred/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "ink_business_preferred_credit_card.png"
},
  [CreditCard.ASHLEY_ADVANTAGE_CREDIT_CARD]: {
  "id": CreditCard.ASHLEY_ADVANTAGE_CREDIT_CARD,
  "name": "Ashley Advantage\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_clientoffer/e076572.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.3499,
    "apr_low": 0.3499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3499,
    "high": 0.3499,
    "description": "New Accounts as of 7/31/25: Purchase APR 34.99%. Penalty APR 39.99%. Minimum interest charge $2."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=565510A04C0A508AC067D9B072C9D4F57DB34A98269D02B5&client=Ashley%20Furniture%20HomeStore&icid=Financing-Synchrony-Apply&_gl=1*ygysck*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMjUwLjAuMC4w&intcmp=NoOff_AshleyAdvantage%C2%AECreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=565510A04C0A508AC067D9B072C9D4F57DB34A98269D02B5&client=Ashley%20Furniture%20HomeStore&icid=Financing-Synchrony-Apply&_gl=1*ygysck*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMjUwLjAuMC4w&intcmp=NoOff_AshleyAdvantage%C2%AECreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=565510A04C0A508AC067D9B072C9D4F57DB34A98269D02B5&preQual=Y&_gl=1*zv7ja3*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMjY3LjAuMC4w&intcmp=NoOff_AshleyAdvantage%C2%AECreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "ashley_advantage_credit_card.png"
},
  [CreditCard.BANANA_REPUBLIC_REWARDS_MASTERCARD]: {
  "id": CreditCard.BANANA_REPUBLIC_REWARDS_MASTERCARD,
  "name": "Banana Republic Rewards Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BR_card_NEW_Enth_MC_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "onlineShopping.gapInc",
      "earnRate": 5.0,
      "description": "Earn points for every $1 spent at Gap, Banana Republic, Old Navy, and Athleta.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn points for every $1 spent on all Mastercard purchases made outside the Gap Inc. family of brands.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.3399
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3399,
    "high": 0.3399,
    "description": "Purchase APR: 33.99% variable based on Prime Rate. Balance transfer APR: 33.99% variable based on Prime Rate. Cash advance APR: 33.99% variable based on Prime Rate."
  },
  "benefits": [
    {
      "name": "Free shipping on online orders $50+",
      "description": "Free Standard shipping on online orders of $50 or more (after discounts, before taxes) when signed into your account; Icon members receive free Express shipping on $50+ orders. Orders must ship to a single U.S. address (including Puerto Rico). Estimated value varies by order but typically saves ~$7\u2013$15 per qualifying shipment depending on standard/express rates.",
      "benefit_type": null,
      "new_benefit_type": "free_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to select sales",
      "description": "Eligible program members may receive early access to select sales; additional terms may apply and will be provided when available.",
      "benefit_type": null,
      "new_benefit_type": "early_access_to_sales",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero-liability fraud protection",
      "description": "You\u2019re not responsible for unauthorized charges made with your card.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Donate points to select charities",
      "description": "Eligible members can convert rewards to donation dollars for select organizations at a rate of 100 points = $1; subject to program caps and organizations selected by Gap Inc.",
      "benefit_type": null,
      "new_benefit_type": "points_donation_to_charity",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "New cardmembers receive 20% off their first purchase at Banana Republic when they open a Banana Republic Rewards Mastercard (or Banana Republic Rewards Credit Card). The card must be the sole payment method. If opened in-store, the discount applies the same day in-store; if opened online, a discount code is emailed and expires at 11:59 pm PT 14 days from account opening. Valid only in the U.S. (including Puerto Rico). Not valid at other Gap Inc. brands or the Clearance Center. Excludes gift cards, shipping, taxes, third\u2011party merchandise/sellers at Banana Republic, and other listed exclusions. Cannot be combined with Family of Brands Discounts or employee discount; may be combinable with certain promotional offers if advertised. One opening discount per account; subject to approval and anti\u2011gaming provisions. Estimated value: depends on purchase size (e.g., $100 cart \u2248 $20 off; $200 cart \u2248 $40 off).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percent_discount",
          "amount": 20.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/banana-republic-rewards-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/banana-republic-rewards-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "banana_republic_rewards_mastercard.png"
},
  [CreditCard.UNITED_GATEWAY_CREDIT_CARD]: {
  "id": CreditCard.UNITED_GATEWAY_CREDIT_CARD,
  "name": "United Gateway\u2120 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/united_gateway_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.united",
      "earnRate": 2.0,
      "description": "2 miles per $1 on airline tickets purchased directly from United and on the following purchases made from United: seat upgrades, Economy Plus, inflight food/beverages/Wi\u2011Fi, baggage service charges, and other United fees. Also excludes other United-related purchases such as United Cruises, United MileagePlus X, DIRECTV and Merchandise Awards. United tickets booked through some discount travel sites or as part of a third\u2011party travel package will not qualify. Must code as purchases from United.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2 miles per $1 at gas stations. Merchant must be coded as a gas station per network rules; purchases via third\u2011party wallets or readers may not qualify if not coded to this category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2 miles per $1 on local transit and commuting purchases. Merchant must code to the local transit/commuting category; third\u2011party payment methods may not qualify if not properly coded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 mile per $1 on all other purchases that do not fall into a higher-earning category. Excludes balance transfers, cash advances and other cash-like transactions, checks that access your account, interest, fees, and unauthorized or fraudulent charges.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2874,
    "apr_low": 0.2024
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2874,
    "description": "0% Intro APR on purchases for the first 12 months from account opening; after that, variable purchase APR 0.2024\u20130.2874 based on creditworthiness and the Prime Rate. Balance transfer APR 0.2024\u20130.2874 variable (account may not be eligible for balance transfers). Cash advance APR 0.2899 variable. Penalty APR up to 0.2999 may apply indefinitely if you pay late or a payment is returned. At least a 21-day grace period on purchases; no minimum interest charge."
  },
  "benefits": [
    {
      "name": "25% back on inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on food, beverage and Wi\u2011Fi purchases on board United and United Express-operated flights (including Wi\u2011Fi subscriptions) and on premium drink purchases at United Clubs when you pay with the card. Value varies by usage.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Two checked bag certificates after $10,000 calendar-year spend",
      "description": "Earn two standard checked bag certificates after $10,000 in purchases in a calendar year (limit two per calendar year). Certificates are valid on United/United Express-operated flights, deposited 6\u20138 weeks after qualification, and expire 12 months after issue. Estimated value about $70 total if both are used for first checked bags at ~$35 each (actual value depends on route/fees).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember pricing on United award flights after $10,000 calendar-year spend",
      "description": "After $10,000 in purchases in a calendar year, the primary cardmember receives United Cardmember pricing on award flight bookings on United, United Express, or select partners for the rest of that year and through the end of the following year. Value varies by route/date and award availability.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge service",
      "description": "Access to a concierge who can assist with reservations and arrangements (cardmember pays for goods/services).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 30,000 bonus miles after $1,000 in purchases in the first 3 months from account opening, plus an additional 10,000 bonus miles after adding an authorized user within the first 3 months (awarded once for the first AU). Not available to current cardmembers of this card or previous cardmembers who received a new cardmember bonus for this card within the last 24 months. Account must be open and not in default at fulfillment; miles post in 6\u20138 weeks; miles do not count toward Premier status. If the account is closed within 6 months, United/Chase may deduct the bonus miles. Estimated total value: roughly $480 for 40,000 miles at ~1.2\u00a2 per mile (actual value depends on redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Earn 30,000 bonus miles after $1,000 in purchases in the first 3 months from account opening, plus an additional 10,000 bonus miles after adding an authorized user within the first 3 months (awarded once for the first AU). Not available to current cardmembers of this card or previous cardmembers who received a new cardmember bonus for this card within the last 24 months. Account must be open and not in default at fulfillment; miles post in 6\u20138 weeks; miles do not count toward Premier status. If the account is closed within 6 months, United/Chase may deduct the bonus miles. Estimated total value: roughly $480 for 40,000 miles at ~1.2\u00a2 per mile (actual value depends on redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HNRX&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/united/united-gateway?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60660.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/UnitedGatewayCard/RewardsAgreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "united_gateway_credit_card.png"
},
  [CreditCard.AMERICAN_EXPRESS_GREEN_CARD]: {
  "id": CreditCard.AMERICAN_EXPRESS_GREEN_CARD,
  "name": "American Express Green Card\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000274_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "3X on broad travel purchases including airfare, hotels, tours, campgrounds, car rentals, cruises, vacation rentals, and more. No travel portal requirement disclosed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 3.0,
      "description": "3X on transit purchases including trains, buses, ferries, subways, and more.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3X at restaurants worldwide, including takeout and delivery in the U.S.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X on all other eligible purchases not in bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 150.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "APR for Pay Over Time Feature: 19.99% to 28.99% variable APR on eligible charges."
  },
  "benefits": [
    {
      "name": "$209 CLEAR Plus Credit",
      "description": "Up to $209 in statement credits per calendar year after you sign up and pay for a CLEAR Plus Membership (excluding taxes/fees; subject to auto\u2011renewal) with your American Express Green Card. Helps speed airport entry at 50+ airports.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Events with Amex presale and special ticket access",
      "description": "Presale and special ticket access to select events across sports, music, theatre and more via Amex Experiences; additional Card Member perks at select events. While supplies last; not all seats are offered.",
      "benefit_type": null,
      "new_benefit_type": "amex_experiences_presale_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees from American Express on international purchases with the Green Card.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Targeted offers you can add to your card to earn extra rewards or statement credits at select merchants.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Plan It monthly installments",
      "description": "Split eligible purchases of $100+ into monthly installments with a fixed fee shown upfront; you still earn rewards on planned purchases.",
      "benefit_type": null,
      "new_benefit_type": "plan_it_installments",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Send & Split with Venmo and PayPal",
      "description": "Send money and split purchases with Venmo or PayPal users in the Amex app; repayments can be credited back to your Card as a statement credit; no standard Venmo/PayPal credit card fee on sends. Enrollment and terms apply.",
      "benefit_type": null,
      "new_benefit_type": "send_and_split",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$209 CLEAR Plus Credit",
      "description": "Receive up to $209 in statement credits per calendar year after you pay for a CLEAR Plus Membership with your American Express Green Card (excluding taxes/fees; subject to auto\u2011renewal).",
      "credit_type": "annual_credit",
      "credit_category": {
        "categories": [
          "travel"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "CLEAR Plus airport expedited identity verification membership; available at 50+ U.S. airports."
      },
      "new_credit_category": null,
      "value": 209.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            209.0
          ]
        }
      ],
      "total_yearly_value": 209.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 40,000 Membership Rewards points after you spend $3,000 on eligible purchases in the first 6 months of Card Membership. Estimated value \u2248 $600 at ~1.5\u00a2 per point; actual value varies by redemption.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 40000.0,
          "value_unit": "points",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/green/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/green/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "american_express_green_card.jpeg"
},
  [CreditCard.PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE]: {
  "id": CreditCard.PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE,
  "name": "Platinum Rewards Visa with No Annual Fee",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-no-fee.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 1.0,
      "description": "1% cash back on eligible gas station purchases. Rewards are issued as automatic statement credits for Net Eligible Purchases. Purchases from certain merchant types are not eligible: oil/propane/home heating companies, PayPal, warehouse clubs (e.g., Costco, Sam\u2019s Club), and discount supercenters (e.g., Walmart, Target). Merchant coding must match the category; purchases without an eligible merchant code will not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 1.0,
      "description": "1% cash back on eligible grocery store purchases. Exclusions for grocery category: superstores; stores that sell groceries along with other products (e.g., drugstores, convenience stores); smaller stores like bakeries, candy, nut, or confection shops. General exclusions also apply: PayPal, warehouse clubs (e.g., Costco, Sam\u2019s Club), and discount supercenters (e.g., Walmart, Target). Merchant coding must match grocery; purchases without an eligible grocery merchant code will not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 1.0,
      "description": "1% cash back on eligible internet service, cable and satellite TV, and mobile phone service purchases. Purchases must be coded to these service categories to qualify. General exclusions: PayPal, warehouse clubs (e.g., Costco, Sam\u2019s Club), and discount supercenters (e.g., Walmart, Target).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "Variable APR; rates accurate as of 8/31/2025"
  },
  "benefits": [
    {
      "name": "Credit line increase reviews",
      "description": "Regular account reviews for potential credit limit increases; increases are not guaranteed.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Zero Fraud Liability",
      "description": "You won\u2019t be held responsible for unauthorized charges if you promptly notify the bank (Visa Zero Liability policy). This is a standard protection; no direct monetary value estimated.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Experian IdentityWorks membership",
      "description": "Free membership in Experian IdentityWorks when you complete and submit your application online at CreditOneBank.com; membership is optional and subject to change by Experian. Estimated value around $120/year based on comparable identity monitoring services at roughly $9.99 per month.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_monitoring",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Pick your payment due date",
      "description": "After the initial billing period, you can select a new payment due date at least 6 days before or after the original date; account must be current; limited to once every 6 months.",
      "benefit_type": null,
      "new_benefit_type": "choose_payment_due_date",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1OX_CS_01&C1BDescriptorID=AEA3800L00&C1BSpecificationID=bc-plat-pref",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/platinum-no-fee",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/7bz?pc=WL76",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [
    {
      "name": "View All Platinum Cards",
      "url": "https://www.creditonebank.com/credit-cards/platinum"
    }
  ],
  "bank_name": "Credit One",
  "imageName": "platinum_rewards_visa_with_no_annual_fee.png"
},
  [CreditCard.PLATINUM_VISA_FOR_REBUILDING_CREDIT]: {
  "id": CreditCard.PLATINUM_VISA_FOR_REBUILDING_CREDIT,
  "name": "Platinum Visa For Rebuilding Credit",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-visa-blue.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 1.0,
      "description": "1% cash back on eligible gasoline purchases. Purchases at warehouse clubs and discount supercenters (including Costco, Sam\u2019s Club, Walmart, Target) and payments via PayPal do not earn rewards. Rewards eligibility depends on how the merchant is coded; transactions without an eligible MCC will not qualify. Rewards post as automatic statement credits on statements with at least one net eligible purchase. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 1.0,
      "description": "1% cash back on eligible grocery purchases. Excludes purchases at superstores/discount supercenters (e.g., Walmart, Target), warehouse clubs (e.g., Costco, Sam\u2019s Club), stores that sell groceries and other products like drugstores and convenience stores, and smaller specialty food stores like bakeries, candy/nut/confection shops. PayPal transactions do not earn. Merchant coding must qualify. Rewards are issued as automatic statement credits on statements with at least one net eligible purchase. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 1.0,
      "description": "1% cash back on eligible monthly service bills for mobile phone service and internet, cable, and satellite TV. Purchases at warehouse clubs and discount supercenters (including Walmart, Target, Costco) and payments via PayPal do not earn rewards. Merchant coding must be in eligible telecom/internet/cable categories. Rewards post as automatic statement credits on statements with at least one net eligible purchase. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 99.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "29.49% variable APR (based on creditworthiness). Variable rates accurate as of 8/31/2025."
  },
  "benefits": [
    {
      "name": "Credit line increase opportunities",
      "description": "Regular account reviews for credit line increase opportunities based on responsible use and overall credit performance. Minimum starting credit line is $300; future increases may be granted based on performance.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Fraud Liability",
      "description": "You won\u2019t be held responsible for unauthorized charges; must notify the bank immediately. Subject to Visa Zero Liability policy (see issuer\u2019s Visa Zero Liability link for details).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Pick your payment due date",
      "description": "After the initial billing period, you may select a new payment due date that is at least 6 days before or after the original date. Effective when it appears on your statement; account must be current; may change once every 6 months.",
      "benefit_type": null,
      "new_benefit_type": "choose_payment_due_date",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Experian IdentityWorks membership (optional)",
      "description": "Optional free membership in Experian IdentityWorks if you complete and submit your application online; operated by Experian and subject to change. Estimated value up to about $120/year based on typical consumer plan pricing (~$9.99/month); actual value depends on the plan provided.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_monitoring",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1OX_CS_75&C1BDescriptorID=AEA3800L00&C1BSpecificationID=bc-rebuild",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/platinum-visa-for-rebuilding-credit",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/7ddd?pc=WL74",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [
    {
      "name": "View All Platinum Cards",
      "url": "https://www.creditonebank.com/credit-cards/platinum"
    },
    {
      "name": "Reviews",
      "url": "https://www.creditonebank.com/credit-cards/platinum-visa-for-rebuilding-credit/reviews"
    }
  ],
  "bank_name": "Credit One",
  "imageName": "platinum_visa_for_rebuilding_credit.png"
},
  [CreditCard.INK_BUSINESS_UNLIMITED_CREDIT_CARD]: {
  "id": CreditCard.INK_BUSINESS_UNLIMITED_CREDIT_CARD,
  "name": "Ink Business Unlimited\u00ae Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_unlimited_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5% cash back (1.5 points per $1) on purchases made with the card by you or an authorized user. The following do not earn points: balance transfers; cash advances and other cash-like transactions; travelers checks, foreign currency, money orders or wire transfers; lottery tickets, casino gaming chips, race track wagers or similar betting transactions; any checks that access your account; interest; unauthorized or fraudulent charges; and fees of any kind. Points don\u2019t expire while the account remains open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2324,
    "apr_low": 0.1724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1724,
    "high": 0.2324,
    "description": "Purchases: 0.0000 intro APR for 12 months from account opening; thereafter variable 0.1724\u20130.2324 based on Prime Rate. Balance transfers: variable 0.1724\u20130.2324. Cash advances: variable 0.2899. Penalty APR up to 0.2999 may apply."
  },
  "benefits": [
    {
      "name": "Primary Auto Rental Collision Damage Waiver",
      "description": "Primary coverage for theft and collision damage when you decline the rental company\u2019s collision insurance and charge the entire rental to the card for business purposes. Reimburses up to $60,000 for most rental vehicles with MSRP of $125,000 or less. Value depends on rental length and typical CDW cost (often ~$10\u2013$30/day). Restrictions, limitations and exclusions apply; see Guide to Benefits.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance",
      "description": "Provides legal and medical referrals and access to other travel/emergency assistance services while traveling. Cardholder is responsible for the cost of any goods or services obtained. Restrictions apply; see Guide to Benefits.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance",
      "description": "Access to dispatch for roadside help; service fees are billed to your card at time of dispatch. Restrictions apply; see Guide to Benefits.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $10,000 per item. Note: for New York residents, the coverage period is 90 days. Restrictions and exclusions apply; see Guide to Benefits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (maximum total coverage up to 4 years from purchase). Restrictions and exclusions apply; see Guide to Benefits.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Employee Cards at No Additional Cost",
      "description": "Add employee cards with individual spending limits to help consolidate business spend and earn rewards faster. No additional card fee noted.",
      "benefit_type": null,
      "new_benefit_type": "employee_cards_no_additional_cost",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 3,
      "description": "Offer details state: Earn 90,000 bonus points (redeemable for $900 cash back) after $6,000 in purchases in the first 3 months from account opening. Excludes balance transfers, cash advances, cash-like transactions, lottery/gaming transactions, checks that access the account, interest, fees, and unauthorized/fraudulent charges. Allow 6\u20138 weeks for points to post; account must be open and not in default. Note: Page header shows $750 cash back with a strikethrough of $900\u2014offers may vary by application channel.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 90000.0,
          "value_unit": "points"
        },
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 900.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HVMS&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/ink/unlimited?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62353.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/inkbusinessunlimited/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "ink_business_unlimited_credit_card.png"
},
  [CreditCard.CITI_STRATA_PREMIER_CARD]: {
  "id": CreditCard.CITI_STRATA_PREMIER_CARD,
  "name": "Citi Strata Premier\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citi-strata-premier-credit-card/citi-strata-premier-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 10.0,
      "description": "10x ThankYou Points per $1 on Hotels, Car Rentals, and Attractions booked through cititravel.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 10.0,
      "description": "10x ThankYou Points per $1 on Hotels, Car Rentals, and Attractions booked through cititravel.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 10.0,
      "description": "10x ThankYou Points per $1 on Hotels, Car Rentals, and Attractions booked through cititravel.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 3.0,
      "description": "3x ThankYou Points per $1 on air travel purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 3.0,
      "description": "3x ThankYou Points per $1 on other hotel purchases (non-portal bookings).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3x ThankYou Points per $1 at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3x ThankYou Points per $1 at supermarkets.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3x ThankYou Points per $1 on Gas and EV Charging Stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x ThankYou Point per $1 on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2799,
    "apr_low": 0.1999
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2799,
    "description": "Variable APR for purchases and balance transfers: 0.1999\u20130.2799 based on creditworthiness. Cash advance APR: 0.2924. Penalty APR: up to 0.2999 if you make a late or returned payment. Minimum interest charge: $0.50."
  },
  "benefits": [
    {
      "name": "$100 Annual Hotel Benefit",
      "description": "Once per calendar year, get $100 off a single hotel stay of $500+ (excluding taxes and fees) when booked through cititravel.com or 1-833-737-1288; discount applied instantly at booking. Estimated value: $100 per year if used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 500,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases made abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points transfer",
      "description": "Transfer ThankYou Points to partners like JetBlue, Virgin Atlantic, Cathay Pacific, EVA Air, Choice Hotels, The Leading Hotels of the World, and others. No fee; minimum transfer 1,000 points.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Coverage",
      "description": "Coverage for trip cancellation and trip interruption (common carrier).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Coverage",
      "description": "Trip Delay insurance when traveling.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost or Damaged Luggage Coverage",
      "description": "Coverage for lost or damaged luggage.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Collision Damage Waiver (MasterRental)",
      "description": "Mastercard rental car collision damage waiver coverage.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$100 Annual Hotel Benefit",
      "description": "Once per calendar year, get $100 off a single hotel stay of $500+ (excluding taxes and fees) when booked through cititravel.com or 1-833-737-1288; discount applied instantly at booking.",
      "credit_category": null,
      "new_credit_category": "hotel_booking_via_citi_travel_portal",
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": 500,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 ThankYou Points after spending $4,000 in the first 3 months. Offer subject to Citi\u2019s 48\u2011month family rule: Bonus not available if you received a new account bonus for a Citi Premier\u00ae or Citi Strata Premier\u00ae in the past 48 months, or if you converted another Citi card into a Premier/Strata Premier account on which you earned a new account bonus in the last 48 months. Estimated value: $600 at 1.0\u00a2/point (cash back/gift cards) up to ~$900 at 1.5\u00a2/point via high\u2011value transfer partners.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-strata-premier-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi-strata-premier-card.png"
},
  [CreditCard.AMAZON_BUSINESS_PRIME_CARD]: {
  "id": CreditCard.AMAZON_BUSINESS_PRIME_CARD,
  "name": "Amazon Business Prime American Express Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/amazon-business-prime-angled.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 3.0,
      "description": "3% back at designated Amazon U.S. properties without eligible Prime membership when choosing % Back (not Payment Terms). Cap: $120,000 per calendar year; then 1%.",
      "spendCap": 120000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 5.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "5% Back applies with an eligible Prime or Business Prime membership and only when selecting % Back (not Payment Terms) on U.S. purchases at designated Amazon properties. Earn 5% on the first $120,000 in eligible purchases per calendar year; 1% thereafter. Purchases where Payment Terms are selected earn no % Back and do not count toward the cap.",
          "promotional_type": PromotionalType.PRIME_MEMBERSHIP
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "onlineShopping.amazon",
          "whole_foods"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Designated Amazon properties in the U.S.: Amazon.com, Amazon Business, Amazon Web Services (AWS), Whole Foods Market (including 365 stores), Amazon Go, and Amazon Books.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2% back at U.S. restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2% back at U.S. gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 2.0,
      "description": "2% back on U.S. wireless phone services purchased directly from U.S. service providers (excludes Google Fi).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back on all other eligible purchases. Also applies to designated Amazon property purchases after the $120,000 annual cap or when categories above do not apply. Fees, cash advances, and other ineligible transactions do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2624,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2624,
    "description": "Variable purchase APR 0.1824\u20130.2624 (Prime Rate +10.99% to +18.99%) based on creditworthiness; cash advance APR 0.2899 (Prime Rate +21.74%); penalty APR 0.2999 (Prime Rate +25.99%) may apply for at least 12 billing periods after certain triggers. Due date at least 25 days after close; no interest on purchases if entire standard balance is paid by the due date. Payment Terms purchases accrue no interest during their Payment Terms period (90 days with eligible Prime, 60 days without)."
  },
  "benefits": [
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Coverage for theft or damage to a rental vehicle when you pay with the Card; terms, conditions and exclusions apply (typically secondary coverage).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Eligible purchases are covered against accidental damage and theft for a limited period; terms, conditions and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original manufacturer\u2019s warranty on eligible items purchased with the Card; terms, conditions and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "If a merchant won\u2019t accept a return, eligible purchases may be refundable by Amex within a limited window; terms, conditions and exclusions apply.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Insurance for lost, stolen, or damaged baggage on eligible trips when paid with the Card; terms, conditions and exclusions apply.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance while traveling; third\u2011party service costs are the Card Member\u2019s responsibility; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "American Express will not charge a foreign transaction fee on purchases made outside the U.S.; ATM/merchant fees may still apply.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Entrances and Fast Lanes",
      "description": "Access dedicated Amex Card Member entrances and/or fast lanes at select venues in the Amex Venue Collection; availability varies by event and venue; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "amex_venue_collection_entrances_and_fast_lanes",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Presale Tickets",
      "description": "Access to purchase presale tickets for select events using an American Express Card; subject to availability and third\u2011party ticketing terms.",
      "benefit_type": null,
      "new_benefit_type": "amex_presale_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Reserved Tickets",
      "description": "Access to select seats/ticket allotments for certain events when paying with an American Express Card; subject to availability and third\u2011party ticketing terms.",
      "benefit_type": null,
      "new_benefit_type": "amex_reserved_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you find the same prepaid or pay\u2011later hotel room booked on Amex Travel at a lower publicly available online price, Amex will refund the difference; exclusions and claim rules apply.",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rates_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amazon Business Enhanced Data Views",
      "description": "Item\u2011level detail for Amazon Business purchases appears on your Amex statement to aid reconciliation; requires purchases on Amazon Business with the Card.",
      "benefit_type": null,
      "new_benefit_type": "amazon_business_enhanced_data_views",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Targeted merchant offers available by enrollment in your Amex account or app; terms vary by offer.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amazon Shop with Points",
      "description": "Use earned rewards to pay at checkout on Amazon.com and Amazon Business or apply toward a statement charge; points may be forfeited under certain conditions; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "amazon_shop_with_points",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amazon Rewards and Payment Terms Option",
      "description": "At designated Amazon properties, choose either % Back rewards or Payment Terms (90 days with eligible Prime membership or 60 days without). Choosing Payment Terms forfeits % Back on that purchase; caps and rules apply.",
      "benefit_type": null,
      "new_benefit_type": "amazon_payment_terms_option",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "American Express Venue Collection Concessions Statement Credit",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at American Express Venue Collection venues, up to $250 back per calendar year after enrollment. Offer ends 12/31/2026; terms apply.",
      "credit_type": "american_express_venue_collection_concessions",
      "credit_category": {
        "categories": [
          "entertainment"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": "2026-12-31",
        "category_description": "Qualifying food and beverage concessions purchases at venues in the American Express Venue Collection; excludes Just Walk Out Stores, suites/catering, tickets, restaurants, transportation, parking, gift cards, merchandise, and other non-concession purchases."
      },
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "percent",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            250.0
          ]
        }
      ],
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": 10.0,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Amazon Gift Card loaded to your Amazon account upon approval of the Amazon Business American Express Card or Amazon Business Prime American Express Card application; amount not specified in the provided terms. Gift Card cannot be used to purchase other gift cards and is issued by ACI Gift Cards, Inc. If prompted to create a new Amazon Business account via approval\u2011page link and completed within 30 minutes, the Gift Card will be loaded to that new account instead.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "amazon_gift_card",
          "amount": null,
          "value_unit": "dollars",
          "category": "amazon",
          "category_description": "Amazon.com gift card loaded upon approval to the Amazon account used for the application (or newly created Amazon Business account via approval link)."
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-prime-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusinessPrime",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-prime-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusinessPrime",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/partner/print/business-card/microsite/amz/amazon-prime-business-credit-card/ep-45094?print=false"
    }
  ],
  "bank_name": "American Express",
  "imageName": "amazon_business_prime_card.png"
},
  [CreditCard.WELLS_FARGO_ONE_KEY_CARD]: {
  "id": CreditCard.WELLS_FARGO_ONE_KEY_CARD,
  "name": "One Key+\u2122 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/W-Card-MarketPlace/v9-10-25/images/Products/OneKey/onekeyplus_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.EXPEDIA,
  "rewards_earn_rates": [
    {
      "category": "expedia",
      "earnRate": 3.0,
      "description": "3% (1.5% base + 1.5% bonus) in OneKeyCash on eligible travel booked via the U.S. sites/apps of Expedia, Hotels.com, or Vrbo; when abroad, you must actively select the U.S. version of the site. Wells Fargo determines eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "hotels_com",
      "earnRate": 3.0,
      "description": "3% (1.5% base + 1.5% bonus) in OneKeyCash on eligible travel booked via the U.S. sites/apps of Expedia, Hotels.com, or Vrbo; when abroad, you must actively select the U.S. version of the site. Wells Fargo determines eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "vrbo",
      "earnRate": 3.0,
      "description": "3% (1.5% base + 1.5% bonus) in OneKeyCash on eligible travel booked via the U.S. sites/apps of Expedia, Hotels.com, or Vrbo; when abroad, you must actively select the U.S. version of the site. Wells Fargo determines eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% (1.5% base + 1.5% bonus) in OneKeyCash at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3% (1.5% base + 1.5% bonus) in OneKeyCash at grocery stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3% (1.5% base + 1.5% bonus) in OneKeyCash on dining.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1899
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.2899,
    "description": "Variable APRs based on creditworthiness and U.S. Prime Rate: Purchases 18.99%, 23.99%, or 28.99%; Balance Transfers same as purchases; Cash Advances 28.99%. Minimum interest charge $1; at least 25\u2011day grace period on purchases; interest on balance transfers and cash advances accrues from the transaction date. Balance transfer fee up to 5% (min $5). No foreign transaction fees."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "Use your card when you travel and pay no foreign transaction fees for purchases converted to U.S. dollars.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $1,000 per claim (max 2 paid claims per 12 months) with a $25 deductible when you pay your monthly cell phone bill with the card. Supplemental coverage; loss (unexplained disappearance) and electronic failure not covered.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Protection",
      "description": "Secondary coverage up to $5,000 for common carrier tickets when a covered reason causes cancellation or interruption; entire fare must be paid with the card.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Primary coverage (except NY residents) up to $50,000 for theft or damage when you pay for the rental with the card and decline the rental company\u2019s coverage. Certain vehicles excluded.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Accidental death and dismemberment coverage up to $1,000,000 when the common carrier fare is paid in full with the card.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic One Key Silver status",
      "description": "Automatic One Key Silver tier for primary cardholder while the account is open (no Trip Elements awarded). Silver Member Prices advertise savings of 15% or more on 10,000+ hotels. Note: Separate from the card\u2019s rewards; Gold can be unlocked with $15,000 calendar-year spend.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn $300 in OneKeyCash after $1,000 in purchases in the first 3 months. OneKeyCash is not redeemable for cash and can be used toward eligible bookings on Expedia, Hotels.com, and Vrbo. Excludes cash equivalents, balance transfers, fees/interest, and gambling transactions. Bonus typically posts within 1\u20132 billing periods after it\u2019s earned. Family rule: You may be ineligible if you opened a One Key, One Key+, or Hotels.com card within the past 48 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 300.0,
          "value_unit": "OneKeyCash"
        }
      ]
    }
  ],
  "apply_link": "https://www.expedia.com/one-key-cards/apply?FPID=21271CIO050000&app_source=WELLS_FARGO_COM&product_code=CC&subproduct_code=OF&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&referrerurl=creditcardswellsfargocom&lang=en&langid=1033",
  "learn_more_link": "https://creditcards.wellsfargo.com/one-key-plus-credit-card/?FPID=21271CIO050000&product_code=CC&subproduct_code=OF&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/terms/onekeyplus/?FPID=21271CIO050000&product_code=CC&subproduct_code=OF&cx_nm=CXNAME_CSMHP_MC&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [
    {
      "name": "Compare One Key Cards",
      "url": "https://creditcards.wellsfargo.com/compare-one-key-credit-cards/?product_code=CC&subproduct_code=MC&sub_channel=SEO&vendor_code=G"
    }
  ],
  "bank_name": "Wells Fargo",
  "imageName": "wells_fargo_one_key_card.png"
},
  [CreditCard.SPARK_2X_MILES]: {
  "id": CreditCard.SPARK_2X_MILES,
  "name": "Spark 2X Miles",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/miles_new_2021/thumbnail.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CAPITAL_ONE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Unlimited 2X miles on every purchase for your business; no enrollment or category selection required.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5X miles on hotels and rental cars when booked via Capital One\u2019s travel booking site(s).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5X miles on hotels and rental cars when booked via Capital One\u2019s travel booking site(s).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2524,
    "apr_low": 0.2524
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2524,
    "high": 0.2524,
    "description": "25.24% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "Global Entry or TSA PreCheck credit",
      "description": "Receive up to $120 statement credit for Global Entry or TSA PreCheck application fee when charged to the card; one credit per account every four years. Credit posts within two billing cycles; account must be open and in good standing.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points transfer to 15+ partners",
      "description": "Transfer miles to 15+ travel partners for potentially higher value redemptions. Once transferred, miles are subject to the receiving program\u2019s terms, including expiration and valuation.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star status",
      "description": "Complimentary Hertz Five Star status after enrollment via the Benefits tab in your Capital One account. Status typically activates within 24\u201372 hours; subject to Hertz terms and offer changes.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay zero foreign transaction fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty protection",
      "description": "Free extended warranty on eligible items purchased with the card; terms, conditions, and exclusions apply (see Guide to Benefits).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lifestyle Collection hotel perks",
      "description": "Premium hotel benefits on eligible bookings through Capital One Travel\u2019s Lifestyle Collection, including a $50 experience credit and room upgrades when available.",
      "benefit_type": null,
      "new_benefit_type": "hotel_lifestyle_collection_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Business Travel portal access",
      "description": "Complimentary access to Capital One Business Travel, an all\u2011in\u2011one business travel booking and management platform. Rewards and benefits may vary between Capital One Travel and Capital One Business Travel.",
      "benefit_type": null,
      "new_benefit_type": "business_travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry or TSA PreCheck application fee credit",
      "description": "Up to $120 statement credit for the Global Entry or TSA PreCheck application fee when charged to the card; one credit per account every four years. Posts within two billing cycles; account must be open and in good standing.",
      "credit_category": null,
      "new_credit_category": "tsa_precheck_or_global_entry_fee",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a one-time 50,000 miles after spending $4,500 on purchases within the first 3 months of account opening. Offer availability may require applying via the card\u2019s page and may not be available to existing or previous Capital One Business cardholders. Estimated value: ~$500 at 1.0\u00a2/mile via travel purchase eraser; potentially ~$750\u2013$850 at 1.5\u20131.7\u00a2/mile via partner transfers (actual value varies by partner and redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/small-business/credit-cards/spark-miles/",
  "learn_more_link": "https://www.capitalone.com/small-business/credit-cards/spark-miles/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "spark_2x_miles.avif"
},
  [CreditCard.QUICKSILVER_REWARDS]: {
  "id": CreditCard.QUICKSILVER_REWARDS,
  "name": "Quicksilver from Capital One",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/quicksilver_cardart.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5% cash back on every purchase, every day; rewards don't expire for the life of the account.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "0.0 intro APR for 15 months on purchases and balance transfers; then 0.1924 - 0.2924 variable APR."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making purchases outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Concierge Service",
      "description": "24/7 personalized assistance for dining, entertainment and travel.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Additional warranty protection at no charge on eligible items purchased with the card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24-hour Travel Assistance Services",
      "description": "If your card is lost or stolen, you can get an emergency replacement card and a cash advance.",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Automatic insurance for a covered loss at no extra charge when you use the card to purchase your fare. See Guide to Benefits for terms and exclusions.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2013 Price Drop Protection",
      "description": "If you book a flight when the portal recommends and the price drops within 10 days, you\u2019ll get up to $50 in travel credit for the difference. Availability varies by account and booking; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "price_drop_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2013 Price Match Guarantee",
      "description": "If you find a better price within 24 hours of booking an eligible flight, hotel, or rental car, Capital One will give you a travel credit for the difference. Availability varies by account and booking; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "price_match_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2013 Price Watch Alerts",
      "description": "Set flight price alerts and get notified when prices drop. Availability varies by account and booking; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "price_watch_alerts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star Status",
      "description": "Complimentary Hertz Five Star status with enrollment via the Benefits tab (skip the counter at select locations, access a wider selection). Status processed 24\u201372 hours after enrollment; offer subject to change; Hertz terms apply.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment Access",
      "description": "Access exclusive presales, tickets, suite experiences and more through Capital One Entertainment. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining Access",
      "description": "Access cardholder-only reservations at select restaurants and curated culinary events through Capital One Dining. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Limited-Time: Capital One Travel Credit (First Year)",
      "description": "One-time $100 Capital One Travel credit to use toward purchases made through Capital One Travel. Expires on the first anniversary of account opening if unused; available within Capital One Travel at checkout; rewards not earned on the credit; account must be open and in good standing. Limited-time offer; eligibility and terms apply (see footnote 8).",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Limited-time offer: Earn up to $300 in bonuses for new Quicksilver accounts opened via this offer page. Includes (1) a one-time $100 Capital One Travel credit usable during the first cardholder year (expires on the first anniversary if unused) and (2) a $200 cash bonus after spending $500 on purchases within 3 months of account opening. Existing/previous cardmembers are ineligible if they have received a new cardmember bonus for this product in the past 48 months; offer may only be available via the \u201cApply Now\u201d link on the landing page. Estimated total value: $300.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time offer: Earn up to $300 in bonuses for new Quicksilver accounts opened via this offer page. Includes (1) a one-time $100 Capital One Travel credit usable during the first cardholder year (expires on the first anniversary if unused) and (2) a $200 cash bonus after spending $500 on purchases within 3 months of account opening. Existing/previous cardmembers are ineligible if they have received a new cardmember bonus for this product in the past 48 months; offer may only be available via the \u201cApply Now\u201d link on the landing page. Estimated total value: $300.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/quicksilver/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/quicksilver/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "quicksilver_rewards.png"
},
  [CreditCard.ATT_POINTS_PLUS_CARD_FROM_CITI]: {
  "id": CreditCard.ATT_POINTS_PLUS_CARD_FROM_CITI,
  "name": "AT&T Points Plus\u00ae Card from Citi",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-att-pointsplus/citi-att-pointsplus_90x57.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3x ThankYou Points at gas and EV charging stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x ThankYou Points at grocery stores, including grocery delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x ThankYou Point on all other purchases (including AT&T products and services).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2799,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2799,
    "description": "Variable APR 19.99%\u201327.99% based on creditworthiness applies to purchases and balance transfers; cash advance APR 29.24%; penalty APR up to 29.99%; minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "AT&T wireless bill statement credits (up to $240/year)",
      "description": "Every billing cycle, earn $20 back as a statement credit after you spend $1,000 on purchases or $10 back after you spend $500\u2013$999.99 on purchases. Credit is applied toward your qualifying AT&T consumer postpaid wireless bill. Requires enrollment in paperless billing and AutoPay at AT&T with your AT&T Points Plus Card as the payment method. One credit per billing cycle. Estimated value: up to $240 per year.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment presale access",
      "description": "Access to purchase presale tickets for select music, sports, culinary experiences and more via Citi Entertainment.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_presale_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "AT&T wireless bill statement credits (up to $240/year)",
      "description": "Every billing cycle, earn $20 back as a statement credit after you spend $1,000 on purchases or $10 back after you spend $500\u2013$999.99 on purchases. Credit is applied toward your qualifying AT&T consumer postpaid wireless bill. Requires enrollment in paperless billing and AutoPay at AT&T with your AT&T Points Plus Card as the payment method. One credit per billing cycle.",
      "credit_category": null,
      "new_credit_category": "att_wireless_bill",
      "value": 240.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $200 statement credit after you spend $1,000 in purchases in the first 3 months of account opening. You will qualify for the bonus offer only if you have not received a bonus offer for opening a new AT&T Points Plus Card in the past 48 months. Offer may be page-specific and subject to change.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-att-pointsplus-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "att_points_plus_card_from_citi.png"
},
  [CreditCard.BARCLAYS_JET_BLUE_PREMIER_CARD]: {
  "id": CreditCard.BARCLAYS_JET_BLUE_PREMIER_CARD,
  "name": "JetBlue Premier Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/JBP_CD_card_Premier_WE_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.JETBLUE,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.jetblue",
      "earnRate": 6.0,
      "description": "6x TrueBlue points on eligible JetBlue purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x TrueBlue points at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x TrueBlue points at eligible grocery stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x TrueBlue points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 499.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 499.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Variable APR for purchases based on creditworthiness; 0.2024\u20130.2999; varies with the Prime Rate."
  },
  "benefits": [
    {
      "name": "Airport lounge access",
      "description": "Access to over 1,500 airport lounges (details such as network, guesting, and visit limits not specified).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "TrueBlue Travel statement credits",
      "description": "Earn up to $300 in statement credits on TrueBlue Travel purchases per calendar year (estimated value up to $300/year if fully used).",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free checked bag",
      "description": "First checked bag free for you and up to 3 eligible travel companions on JetBlue-operated flights (codeshares/partner-operated flights excluded).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority boarding",
      "description": "Group A boarding on JetBlue-operated flights (codeshares/partner-operated flights excluded).",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Inflight purchase savings",
      "description": "Savings on eligible inflight purchases on JetBlue-operated flights (percentage not specified).",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry/TSA PreCheck application fee credit",
      "description": "Up to $120 application fee statement credit every 4 years for Global Entry/TSA PreCheck (effective value \u2248 $30/year when annualized).",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Award flight points rebate/discount",
      "description": "Receive a benefit after you redeem for and travel on a JetBlue-operated award flight (e.g., points back or award discount; exact percentage/amount not specified).",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary bonus",
      "description": "An anniversary benefit is provided each year after your account anniversary (exact bonus/amount not specified; typically begins in year 2).",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn toward Mosaic status with purchases",
      "description": "Earn toward Mosaic with every purchase (tier-qualifying accrual mechanics/thresholds not specified).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fee on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "TrueBlue points do not expire",
      "description": "\u201cYour points will be ready whenever you are,\u201d indicating TrueBlue points do not expire (program-level benefit reiterated on card page).",
      "benefit_type": null,
      "new_benefit_type": "points_dont_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Redeem points for statement credits",
      "description": "The card allows you to redeem TrueBlue points for a statement credit (conversion rate not specified).",
      "benefit_type": null,
      "new_benefit_type": "points_statement_credit_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry/TSA PreCheck application fee credit",
      "description": "Up to $120 application fee statement credit every 4 years for Global Entry/TSA PreCheck (effective value \u2248 $30/year when annualized).",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "TrueBlue Travel statement credits",
      "description": "Up to $300 per calendar year in statement credits on TrueBlue Travel purchases.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry/TSA PreCheck application fee credit",
      "description": "Up to $120 application fee statement credit every 4 years (approx. $30/year when annualized).",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Introductory TrueBlue points bonus after qualifying activity: earn a bonus after spending $5,000 on purchases and paying the annual fee in full within the first 90 days (exact points amount not specified in the provided content; see Terms & Conditions).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/jetblue-premier-card/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/jetblue-premier-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "barclays_jet_blue_premier_card.jpeg"
},
  [CreditCard.CITI_STRATA_CARD]: {
  "id": CreditCard.CITI_STRATA_CARD,
  "name": "Citi Strata\u2120 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citi-strata-credit-card/citi-strata-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5x points per dollar on Hotels, Car Rentals, and Attractions booked on cititravel.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5x points per dollar on Hotels, Car Rentals, and Attractions booked on cititravel.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3x points per dollar at supermarkets.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 3.0,
      "description": "3x points per dollar on select transit purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3x points per dollar at gas stations and EV charging stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "3x points per dollar on one eligible Self-Select Category of your choice; changeable once per calendar quarter.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          "fitness",
          "streaming",
          "entertainment.liveEntertainment",
          "selfCare.cosmeticBarberHairSalons",
          "petPurchases"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "Earn 3x points in one Self-Select Category: Fitness Clubs, Select Streaming Services, Live Entertainment, Cosmetic Stores/Barber Shops/Hair Salons, or Pet Supply Stores. Default is Select Streaming Services at account opening. You may change your Self-Select Category once each calendar quarter; the change takes effect the following day at 12 AM CT.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x points per dollar at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x points per dollar on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.2899,
    "description": "0% intro APR for 15 months on purchases and balance transfers from account opening; then variable APR 18.99%\u201328.99% based on creditworthiness. Intro balance transfer fee: 3% ($5 min) on transfers completed within first 4 months; thereafter 5% ($5 min). Foreign transaction fee: 3% of each purchase. Cash advance APR: 29.24%. Penalty APR: up to 29.99%. Minimum interest charge: $0.50. No authorized user fee."
  },
  "benefits": [
    {
      "name": "ThankYou Points transfer",
      "description": "Transfer your ThankYou Points to JetBlue, Choice Hotels, and Wyndham Rewards (minimum transfer is 1,000 points).",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Identity theft monitoring and alerts from Mastercard\u00ae ID Theft Protection; enrollment required and offered at no additional cost.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment access",
      "description": "Access to purchase presale tickets and exclusive experiences for concerts, sports, arts and culture through Citi Entertainment\u00ae. Availability varies by event.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 30,000 ThankYou Points after spending $1,000 in the first 3 months. Limited-time offer; may not be available if you leave the offer page. Eligibility: Bonus ThankYou Points are not available if you received a new account bonus for Citi Strata, Citi Strata Student, Citi Rewards+ or Citi Rewards+ Student in the past 48 months, or if you converted another Citi card on which you earned a new account bonus in the last 48 months into one of those accounts. Estimated value: about $300 at 1.0 cent per point when redeemed for gift cards or travel via Citi; potential value may vary with transfer partners.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-strata-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "See if You're Pre-qualified",
      "url": "https://online.citi.com/US/ag/cards/pre-screen?intc=citihpmenu_creditcards_pq&PP=citi-strata&OC=CC-CITI-3CY"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_strata_card.webp"
},
  [CreditCard.RCIELITE_REWARDSWORLD_MASTERCARD]: {
  "id": CreditCard.RCIELITE_REWARDSWORLD_MASTERCARD,
  "name": "RCI\u00ae Elite Rewards\u00ae World Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/RCI_CD_card_RCI_PM_WM_Angle_L_359x246.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.RCI_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "rci",
      "earnRate": 5.0,
      "description": "For every $1 spent on all eligible RCI purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "For every $1 spent on eligible travel purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare",
      "earnRate": 2.0,
      "description": "For every $1 spent on rideshare purchases (e.g., Uber, Lyft).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "For every $1 spent on gas station purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "For every $1 spent on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2999,
    "description": "Variable APR for purchases is 19.99%\u201329.99% based on creditworthiness; varies with the Prime Rate. Balance transfers: 0% intro APR for 15 billing cycles on transfers that post within 45 days of account opening; then 19.99%\u201329.99% variable. Cash advance APR: 29.99% variable."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fee on international purchases (\"on international purchases\").",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Redemption bonus on every redemption",
      "description": "Receive a bonus every time you redeem rewards (percentage/amount not specified on the source page; commonly 10% on some Barclays cards, but not confirmed here).",
      "benefit_type": null,
      "new_benefit_type": "redemption_bonus",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual spending bonus after $10,000",
      "description": "Annual spending bonus after spending $10,000 in net purchases each calendar year. The source does not specify the bonus amount.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Fraud Liability",
      "description": "$0 Fraud Liability protection for unauthorized charges you report.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Earn a new cardmember bonus after making your first purchase \u2014 stated as worth $50 in RCI Member Rewards.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 50.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/rci-elite-rewards-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/rci-elite-rewards-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "rcielite_rewardsworld_mastercard.png"
},
  [CreditCard.AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD,
  "name": "Amex EveryDay\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "/cards/AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD.avif",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x at U.S. supermarkets; on up to $6,000 per year in purchases (then 1x). Superstores/warehouse clubs like Walmart, Target, and Costco are typically not coded as supermarkets.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.4,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Total 2.4x (20% extra points) at U.S. supermarkets in any billing period with 20 or more purchases on the card; supermarket earn capped at $6,000 per year (then 1.2x).",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2x on eligible travel purchases booked through AmexTravel.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.4,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Total 2.4x (20% extra points) on eligible travel booked via AmexTravel.com in any billing period with 20 or more purchases on the card.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x on all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Total 1.2x (20% extra points) on all other eligible purchases in any billing period with 20 or more purchases on the card.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/amex-everyday/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/amex-everyday/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD.avif"
},
  [CreditCard.SYNCHRONY_MUSIC_SOUND_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_MUSIC_SOUND_CREDIT_CARD,
  "name": "Synchrony Music & Sound Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_clientoffer/e069996.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=565510A04C0A508AC0A6A279E5F68EEBC709DDB2E65FD1BD&preQual=Y&_gl=1*129xf0o*_ga*MzA5NDg3Mjg2LjE2NzM1NDYyMjQ.*_ga_SHD5X90J3V*MTY5MjY0NTg5Mi4xNC4xLjE2OTI2NDczNzAuMC4wLjA.&intcmp=NoOff_SynchronyMusic&SoundCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    },
    {
      "name": "Learn more about music financing",
      "url": "https://www.synchrony.com/marketplace/music"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_music_sound_credit_card.jpg"
},
  [CreditCard.MARRIOTT_BONVOY_BOLD_CREDIT_CARD]: {
  "id": CreditCard.MARRIOTT_BONVOY_BOLD_CREDIT_CARD,
  "name": "Marriott Bonvoy Bold\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/marriott_bonvoy_bold_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.MARRIOTT_BONVOY,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.marriott",
      "earnRate": 3.0,
      "description": "3x points per $1 on purchases at hotels participating in Marriott Bonvoy. Accelerated earn is from the credit card program; additional Bonvoy points from stays post under Marriott Bonvoy terms. Merchant coding applies; non-purchase transactions do not earn.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x points per $1 at grocery stores (based on merchant category coding). Third-party payment accounts, mobile wallets, or similar technology may not qualify if not processed in this category. Non-purchase transactions do not earn.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "2x points per $1 on internet, cable, and phone services (merchant code dependent). Payments via third-party platforms/digital wallets may not qualify if not coded to this category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery.ubereats",
      "earnRate": 2.0,
      "description": "2x points per $1 on select food delivery services when purchased directly through DoorDash, Caviar, Uber Eats, Postmates, Grubhub, Seamless, or Delivery.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery.doordash",
      "earnRate": 2.0,
      "description": "2x points per $1 on select food delivery services when purchased directly through DoorDash, Caviar, Uber Eats, Postmates, Grubhub, Seamless, or Delivery.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases that do not fall into a higher earning category. Standard non-purchase exclusions apply (e.g., cash-like transactions, fees, interest).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate (0.0725 as of 2025-09-23). Purchase APR: 0.1974\u20130.2824. Balance transfer APR: 0.1974\u20130.2824 (note: account may not be eligible for balance transfers). Cash advance APR: 0.2899. Penalty APR: up to 0.2999. Minimum interest charge: none. Grace period: at least 21 days on purchases if you pay your entire balance or Interest Saving Balance by the due date."
  },
  "benefits": [
    {
      "name": "Automatic Marriott Bonvoy Silver Elite status",
      "description": "Automatic Silver Elite Status each calendar year as a cardmember. Initial status applied within ~8 weeks of account opening; account must remain open and not in default.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "5 Elite Night Credits annually",
      "description": "5 Elite Night Credits are deposited within 60 days of opening and on or before March 1 in each subsequent calendar year. Counts toward Marriott Bonvoy elite status. Limited to one eligible consumer Marriott Bonvoy card\u2019s annual ENC per member per year (highest ENC card applies).",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DoorDash DashPass membership",
      "description": "12 months of complimentary DashPass when first activated with this card between 02/01/2025 and 12/31/2027; auto-renews at then-current rate unless canceled; must use this card at checkout for DashPass benefits. Estimated value about $120 for one 12-month term (assumes ~$9.99/month).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Quarterly $10 off on DoorDash non-restaurant orders",
      "description": "Up to $10 off one qualifying non-restaurant DoorDash order each calendar quarter while enrolled in DashPass and paying with this card; discount does not cover fees/taxes/tip and does not roll over. Potential value up to $40/year if used each quarter.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Pay Yourself Back: redeem Marriott points for statement credit",
      "description": "Redeem Marriott Bonvoy points for a statement credit on eligible purchases (airline tickets purchased directly with airlines and purchases at hotels participating in Marriott Bonvoy) at a value of $100 per 12,500 points (0.8\u00a2/point), on up to $750 total in redemptions per year. Points can be redeemed in any increment; min 1 point; up to 12 transactions per order. Estimated maximum annual cash value $750 if fully utilized.",
      "benefit_type": null,
      "new_benefit_type": "points_redemption_statement_credit",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "Access to concierge service; cardmember is responsible for the cost of any goods or services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on international purchases (per Pricing & Terms).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Chase Pay Over Time financing",
      "description": "Option to split eligible purchases into fixed-fee monthly plans. Monthly fee: 0% of the amount for eligible $100\u2013$5,000 purchases at hotels participating in Marriott Bonvoy or directly with airlines; up to 1.72% for other eligible purchases. Eligibility not guaranteed. Also available at Amazon checkout on eligible orders of at least $50.",
      "benefit_type": null,
      "new_benefit_type": "pay_over_time_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 2 Free Night Awards (each redeemable for up to 50,000 points per night, total value 100,000 points) after spending $2,000 in purchases within 3 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HW5L&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/marriott-bonvoy/bold?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62480.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/marriottboldcard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "marriott_bonvoy_bold_credit_card.png"
},
  [CreditCard.A_A_R_P_ESSENTIAL_REWARDS_MASTERCARD_FROM_BARCLAYS]: {
  "id": CreditCard.A_A_R_P_ESSENTIAL_REWARDS_MASTERCARD_FROM_BARCLAYS,
  "name": "AARP\u00ae Essential Rewards Mastercard\u00ae from Barclays",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/ARE_card_rRGB_Essential_6146_359x246_Angle_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% cash back at gas stations; purchases at Walmart and Target are excluded from this bonus category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "drugstore",
      "earnRate": 3.0,
      "description": "3% cash back at drugstores; purchases at Walmart and Target are excluded from this bonus category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "medicalExpenses",
      "earnRate": 2.0,
      "description": "2% cash back on eligible medical expenses such as doctors, dentists, chiropractors, vision (glasses), hearing aids, and similar health-related purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases that do not qualify for a higher bonus category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.2099
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2099,
    "high": 0.2999,
    "description": "Purchases: variable APR 0.2099\u20130.2999 based on creditworthiness; varies with the Prime Rate. Balance transfers: 0.0000 introductory APR for 15 months (first 15 billing cycles) on transfers that post within 45 days of account opening; after intro (and for transfers posting after 45 days), variable APR 0.2099\u20130.2999; varies with the Prime Rate. Cash advances: variable APR 0.2999. Minimum interest charge: $0.50. Balance transfer fee: 0.05 (min $5). Cash advance fee: 0.05 (min $10)."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $100 cash back bonus after spending $500 on purchases in the first 90 days of account opening. Bonus may only be earned once; eligibility restrictions apply. See Terms and Conditions (Introductory Bonus Offer) for details.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/aarp-essential-rewards-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/aarp-essential-rewards-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "a_a_r_p_essential_rewards_mastercard_from_barclays.png"
},
  [CreditCard.DISCOVER_IT_MILES_CREDIT_CARD]: {
  "id": CreditCard.DISCOVER_IT_MILES_CREDIT_CARD,
  "name": "Discover it\u00ae Miles",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-travel-beachcard-620-382.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5x Miles on every dollar of every purchase; no category restrictions and no earning cap. Miles do not expire for the life of the account. No annual fee.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": 0.5,
      "signupBonusEarnRateIncreaseDurationMonths": 12
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2724,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2724,
    "description": "0.0 intro APR for 15 months on purchases and balance transfers; then 0.1824\u20130.2724 variable purchase APR applies. Cash advance APR 0.2924 variable. Minimum interest charge $0.50. Balance transfer fee 0.03 intro (until December 10, 2025); 0.05 for future transfers. Cash advance fee: greater of $10 or 0.05 of the advance amount. Rates as of August 29, 2025."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.discovercard.com/application/website/apply?srcCde=GJX4&ICMPGN=ALL_CC_TRAVEL_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "learn_more_link": "https://www.discover.com/credit-cards/travel/?ICMPGN=ALL_CC_TRAVEL_LEARN_MORE",
  "terms_and_conditions_link": "https://www.discovercard.com/application/website/ratesrewards?srcCde=GJX4&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "terms_and_conditions_button_text": "\u2020See rates, rewards, fees, and other cost information > , Opens new window",
  "additional_links": [
    {
      "name": "Reviews",
      "url": "https://www.discover.com/credit-cards/travel/reviews/#all-reviews"
    }
  ],
  "bank_name": "Discover",
  "imageName": "discover_it_miles_credit_card.png"
},
  [CreditCard.DISCOVER_IT_SECURED_CREDIT_CARD]: {
  "id": CreditCard.DISCOVER_IT_SECURED_CREDIT_CARD,
  "name": "Discover it\u00ae Secured Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-secured-black-592-478.png",
  "recommendedMinCreditScore": "no_credit_history",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 2.0,
      "description": "Earn 2% Cashback Bonus at Gas Stations and Restaurants on up to $1,000 in combined purchases each quarter, automatically.",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "gas",
          "dining"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Gas stations and restaurants; 2% cash back applies to a shared quarterly cap across both categories.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn unlimited 1% cash back on all other purchases (and on gas/restaurants after the $1,000 combined quarterly cap is reached).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2724,
    "apr_low": 0.2724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2724,
    "high": 0.2724,
    "description": "Standard variable purchase APR 27.24% (as of Aug 29, 2025). Intro balance transfer APR 10.99% for 6 months, then standard purchase APR applies. Cash advance APR 29.24% variable. Minimum interest charge $0.50. Balance transfer fee: 3% intro of amount transferred; 5% for future transfers. Cash advance fee: $10 or 5% of each cash advance, whichever is greater. Annual Fee: None."
  },
  "benefits": [
    {
      "name": "$0 Fraud Liability Guarantee",
      "description": "You are not responsible for unauthorized purchases made on your Discover card.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic reviews and potential credit line increase",
      "description": "Starting at 7 months, Discover conducts automatic monthly account reviews to see if you qualify to upgrade to an unsecured card and get your deposit back; if you qualify, you\u2019ll also be considered for a credit line increase.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Cashback Match: Discover will automatically match, dollar-for-dollar, all Cashback Bonus you earn at the end of your first year; no cap. Estimated value example: if you earn $150 in cash back during the first 12 months, Discover will match $150 for an additional $150 cash back (total first-year cash back $300).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.discovercard.com/application/website/apply?srcCde=KXPA&ICMPGN=ALL_CC_SECURED_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "learn_more_link": "https://www.discover.com/credit-cards/secured-credit-card/?ICMPGN=ALL_CC_SECURED_LEARN_MORE",
  "terms_and_conditions_link": "https://www.discovercard.com/application/website/ratesrewards?srcCde=KXPA&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "terms_and_conditions_button_text": "\u2020See rates, rewards, fees, and other cost information > , Opens new window",
  "additional_links": [
    {
      "name": "Reviews",
      "url": "https://www.discover.com/credit-cards/secured-credit-card/reviews/"
    }
  ],
  "bank_name": "Discover",
  "imageName": "discover_it_secured_credit_card.png"
},
  [CreditCard.ALASKA_AIRLINES_VISA_SIGNATURE]: {
  "id": CreditCard.ALASKA_AIRLINES_VISA_SIGNATURE,
  "name": "Atmos\u2122 Rewards Ascent Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://secure.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/1bbt_sigcm_v_atmos_ascent_250.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.ALASKA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.alaska",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible Alaska Airlines purchases made directly with the carrier (tickets, inflight purchases, lounge access, vacation packages).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible gas and EV charging purchases, select streaming and cable services, and local transit (including rideshare, ferries, commuter rail, taxis, tolls).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible gas and EV charging purchases, select streaming and cable services, and local transit (including rideshare, ferries, commuter rail, taxis, tolls).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible gas and EV charging purchases, select streaming and cable services, and local transit (including rideshare, ferries, commuter rail, taxis, tolls).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible gas and EV charging purchases, select streaming and cable services, and local transit (including rideshare, ferries, commuter rail, taxis, tolls).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible gas and EV charging purchases, select streaming and cable services, and local transit (including rideshare, ferries, commuter rail, taxis, tolls).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn unlimited 1 point for every $1 spent on all other purchases, including Choice/Grocery/Wholesale Club spend after the quarterly cap; exclusions apply to balance transfers, cash advances, fees, interest, and other ineligible transactions.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.1,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable APR based on creditworthiness and Prime Rate. Purchase APR 20.24%\u201328.24% variable; no introductory APR. Penalty APR up to 29.99%. Interest begins on balance transfers and cash advances on the transaction date; at least 25-day grace period on purchases if paid in full."
  },
  "benefits": [
    {
      "name": "Annual Companion Fare after $6,000 spend",
      "description": "Companion Fare code each account anniversary after $6,000+ in purchases in the prior anniversary year; valid for a round-trip or one-way saver or main cabin Companion Fare within North America on Alaska Airlines or Hawaiian Airlines from $122 ($99 base fare + taxes/fees from $23); must book on AlaskaAir.com and pay primary and companion fares with the card; code issued within 2 billing cycles after anniversary; expires 12 months after issuance. Estimated value: often $150\u2013$400+ in savings net of the $99+taxes depending on route pricing.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 6000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free checked bag",
      "description": "1 free checked bag for the cardholder and up to 6 guests on the same reservation on flights marketed by Alaska or Hawaiian and operated by Alaska, Hawaiian, Horizon Air or SkyWest when airfare is purchased with the card; not applicable if bags are already free. Estimated value: ~$30\u2013$40 per person each way (varies by route/policy).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred boarding",
      "description": "Preferred boarding for the cardholder and up to 6 guests on the same reservation on Alaska-marketed, Alaska-operated flights when airfare is purchased with the card and the rewards number is on the reservation (after elites, oneworld elites, First/Premium and pre-board).",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "20% inflight rebate on food, beverage and Wi\u2011Fi",
      "description": "20% back as a statement credit on eligible onboard purchases on Alaska (food, beverage, Wi\u2011Fi) and on Hawaiian (food/beverage) when paid with the card; credit posts within ~7 days.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$100 off Alaska Lounge+ Membership",
      "description": "Receive $100 off the purchase of an annual Alaska Lounge+ Membership when purchased with the card; not combinable with other Lounge+ discounts. Estimated value: $100 per membership year.",
      "benefit_type": null,
      "new_benefit_type": "lounge_membership_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "10% relationship bonus on points",
      "description": "Earn a 10% bonus on all points from card purchases if the primary or joint cardholder has a qualifying Bank of America or Merrill account. Example: 1,000 earned points becomes 1,100. Effectively increases all earn rates by 10% while qualified.",
      "benefit_type": "bofa_account_10_percent_rewards_bonus",
      "new_benefit_type": "relationship_bonus",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Status points earning (limited-time)",
      "description": "Earn 1 status point per $3 in Net Purchases, up to 30,000 status points, for transactions posting Jan 1, 2025\u2013Dec 31, 2025 across eligible Atmos Rewards consumer and business Visa cards; status points count toward elite status for remainder of 2025 and all of 2026; non-redeemable for travel.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "20% inflight rebate (statement credit)",
      "description": "Rebate posts as a statement credit on eligible inflight purchases as described in benefits.",
      "credit_category": "travel.airline.alaska",
      "new_credit_category": null,
      "value": 20.0,
      "value_unit": "percent",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "$100 Alaska Lounge+ Membership discount",
      "description": "Discount applied when purchasing an annual Lounge+ membership with the card.",
      "credit_category": "travel.airline.alaska",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 4,
      "description": "Limited-time online offer: Earn 80,000 points plus a $99 Companion Fare (base fare; taxes/fees from $23) after $4,000 in purchases within 120 days of account opening. Bookings must be on AlaskaAir.com, within North America, and primary/companion fares must be paid with the card. One bonus per new account; account must be open and in good standing; bonus posts within 2 billing cycles of qualifying. Estimated value: 80,000 points \u2248 $800\u2013$1,200 assuming ~1.0\u20131.5\u00a2/point toward Alaska/Hawaiian award travel; Companion Fare value varies by route, commonly ~$150\u2013$400+ net after paying $99 + taxes/fees.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "points"
        },
        {
          "reward_type": null,
          "new_reward_type": "companion_ticket",
          "amount": 1.0,
          "value_unit": "companion_fare_code"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4075604&productoffercode=G7&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/alaska-airlines-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4075604&productoffercode=G7&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Atmos\u2122 Rewards Ascent Visa Signature\u00ae Credit Card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "alaska_airlines_visa_signature.png"
},
  [CreditCard.CHASE_UNITED_CLUB_BUSINESS_CARD]: {
  "id": CreditCard.CHASE_UNITED_CLUB_BUSINESS_CARD,
  "name": "United Club\u2120 Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_club_biz_card_tilted.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5 miles per $1 on all other purchases. Purchases that do not earn miles include balance transfers, cash advances and cash-like transactions, lottery tickets, casino gaming chips, race track wagers, checks that access your account, interest, unauthorized or fraudulent charges, and fees of any kind.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.united",
      "earnRate": 2.0,
      "description": "2 miles total per $1 on airline tickets purchased from United and select purchases made from United: seat upgrades, Economy Plus, inflight food, beverages and Wi\u2011Fi, baggage service charges, and other United fees. Also 2x on purchases of United Card Events from Chase. Excludes other United-related purchases such as United Cruises, United MileagePlus X, DIRECTV, and Merchandise Awards. United tickets booked through some discount travel websites or as part of a third\u2011party travel package will not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5 miles total per $1 on hotel accommodation purchases when prepaid through Renowned Hotels and Resorts for United Cardmembers via Chase Travel. Only the portion paid with the card earns miles; bookings via FROSCH brands do not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 695.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.2049
  },
  "annualFee": 695.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2049,
    "high": 0.2899,
    "description": "Purchase APR 0.2049\u20130.2899 variable (varies with Prime Rate; 7.50% as of 05/13/2025). Balance transfer APR 0.2049\u20130.2899 variable (same as purchase). Cash advance APR 0.2924. Penalty APR up to 0.2999. Grace period at least 20 days. Note: Account may not be eligible for balance transfers. No 0% intro APR disclosed."
  },
  "benefits": [
    {
      "name": "United Club lounge access (primary cardmember)",
      "description": "Primary cardmember receives United Club membership (value advertised at least $750/yr) with access to 45+ United Club locations worldwide; primary may bring 1 adult guest and dependent children. Star Alliance lounge access not included with base membership.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "United Club All Access membership (earn via spend or status)",
      "description": "Unlock All Access membership after $50,000 calendar-year spend on the card or achieving Premier Gold or higher; includes access to participating Star Alliance lounges and an enhanced guest policy (2 adults or 1 adult + dependent children). Valid for the remainder of the calendar year earned and the following year; must requalify each year.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": 50000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "4 United Club one-time passes each anniversary with All Access + employee card",
      "description": "Starting with first anniversary and every anniversary thereafter, earn 4 United Club one-time passes if you have United Club All Access membership and at least one employee (authorized user) card on the account. Passes usable when primary or employee cardholder is admitted. Est. value $200+ if used.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": true
    },
    {
      "name": "Free first and second checked bags",
      "description": "Primary cardmember and one companion on the same reservation each receive first and second standard checked bags free on United/United Express when the MP number is on the reservation and tickets are purchased from United with the card (purchase requirement waived for first 90 days). Estimated savings up to $360 per roundtrip for two travelers.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premier Access airport services",
      "description": "Priority check-in, security lanes (where available), priority boarding, and priority baggage handling on United/United Express.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing discount",
      "description": "Save an average of ~30% in miles on select United-operated award flights when the \u201cCardmembers Save\u201d banner is present (pricing varies by availability).",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Premier Qualifying Points (PQP) from spend",
      "description": "Earn 1 PQP per $15 in purchases, up to 28,000 PQP per calendar year, applicable toward Premier status up to Premier 1K (subject to MileagePlus rules).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "2 Global Economy Plus seat upgrades after $40,000 spend",
      "description": "After $40,000 in purchases in a calendar year, earn 2 credits to upgrade to Economy Plus seating (when available) on United/United Express. Valid 12 months from issue; primary cardmember only; non-transferable.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on food, beverage, and Wi\u2011Fi purchases onboard United/United Express, Wi\u2011Fi subscriptions, and on premium drink purchases in United Clubs when paid with the card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Avis President\u2019s Club status",
      "description": "Enroll to receive Avis President\u2019s Club with complimentary two\u2011class upgrades when available, guaranteed car availability, expedited service, and more (enrollment required; Avis terms apply).",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership",
      "description": "Activate complimentary Instacart+ through 12/31/27 (or minimum one-year term, whichever is longer). After the complimentary term, auto-renews at then-current rate unless canceled. Terms apply.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $200 Renowned Hotels and Resorts credit (anniversary year)",
      "description": "Up to $200 in statement credits each account anniversary year on prepaid hotel accommodations booked directly through Renowned Hotels and Resorts for United Cardmembers with the card. Est. value up to $200/yr if used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $150 rideshare credits per calendar year (enrollment required)",
      "description": "Enroll annually to receive up to $150 back per calendar year on rideshare purchases: $12 per month Jan\u2013Nov and $18 in Dec when paid with the card. Credits post within 6\u20138 weeks. Est. value up to $150/yr if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 United TravelBank cash from Avis/Budget rentals (anniversary year)",
      "description": "Earn $50 TravelBank cash after each of your first two eligible Avis or Budget car rentals (min 2 days) booked via cars.united.com and paid with the card, up to $100 per anniversary year; specific AWD/BCD codes required. TravelBank cash expires 12 months after issue. Est. value up to $100/yr if used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $240 Instacart credits per calendar year",
      "description": "Receive two $10 Instacart credits per month (up to $240/yr) for purchases made directly through Instacart using the card; requires activation and an active Instacart+ membership; benefit ends 12/31/27. Credits don\u2019t roll over. Est. value up to $240/yr if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $200 JSX flight credit (anniversary year)",
      "description": "Get up to $200 back in statement credits each account anniversary year on purchases made directly with JSX using the card. Est. value up to $200/yr if used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $50 FareLock credit (anniversary year)",
      "description": "Earn up to $50 back in statement credits each account anniversary year on United/United Express FareLock purchases made with the card. Est. value up to $50/yr if used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "5,000-mile better\u2011together anniversary bonus",
      "description": "Receive 5,000 bonus miles each account anniversary year if the business card\u2019s authorizing officer is also the primary cardmember on an open personal United credit card. Est. value ~$65/yr at 1.3\u00a2/mile.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "Reimburses up to $10,000 per covered traveler and $20,000 per trip for prepaid, nonrefundable expenses if your trip is canceled or cut short due to covered reasons.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Up to $100 per day for 3 days for essential purchases when baggage is delayed over 6 hours.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Reimbursement up to $3,000 per covered traveler for lost, damaged, or stolen baggage on a covered trip (NY limits apply).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay coverage",
      "description": "If common carrier travel is delayed more than 12 hours or requires an overnight stay, coverage for unreimbursed expenses (e.g., meals and lodging) up to $500 per covered traveler.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Primary Auto Rental CDW (business use)",
      "description": "Primary coverage for theft and collision damage on most rental vehicles up to $60,000 when renting for business purposes and charging the full rental to the card.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $10,000 per item (NY: 90 days).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "If a store won\u2019t accept an eligible return within 90 days, reimbursement up to $500 per item, $1,000 per 12\u2011month period.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends eligible U.S. manufacturer\u2019s warranties of 3 years or less by 1 additional year (up to 4 years total).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Concierge",
      "description": "24/7 complimentary Visa Signature Concierge for dining, entertainment, travel assistance and more (cardholder pays for goods/services).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Premier Upgrades on award tickets (for elites)",
      "description": "Primary cardmember with MileagePlus Premier status and one companion on the same reservation are eligible for Complimentary Premier Upgrades on select United/United Express award itineraries, subject to availability.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Up to $200 Renowned Hotels and Resorts credit (anniversary year)",
      "description": "Up to $200 in statement credits each account anniversary year on prepaid hotel accommodations booked directly through Renowned Hotels and Resorts for United Cardmembers with the card.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $150 rideshare credits (calendar year; enroll annually)",
      "description": "$12/month Jan\u2013Nov and $18 in Dec back as statement credits on eligible rideshare purchases when paid with the card after annual enrollment, up to $150/year.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $100 United TravelBank cash from Avis/Budget (anniversary year)",
      "description": "$50 TravelBank cash after each of the first two eligible Avis/Budget rentals (min 2 days) booked at cars.united.com and paid with the card; required AWD/BCD codes apply.",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $240 Instacart credits (calendar year)",
      "description": "Two $10 Instacart credits per month for purchases made directly through Instacart with the card; requires activation and active Instacart+; ends 12/31/27.",
      "credit_category": "onlineShopping",
      "new_credit_category": "instacart",
      "value": 240.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $200 JSX flight credit (anniversary year)",
      "description": "Up to $200 back as a statement credit each account anniversary year on purchases made directly with JSX using the card.",
      "credit_category": "travel.airline",
      "new_credit_category": "jsx",
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $50 United FareLock credit (anniversary year)",
      "description": "Up to $50 back as a statement credit each account anniversary year on FareLock purchases for United/United Express flights.",
      "credit_category": "travel.airline",
      "new_credit_category": "farelock",
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Limited\u2011time new cardmember offer: Earn 100,000 United MileagePlus miles and 2,000 Premier Qualifying Points (PQP) after $5,000 in purchases in the first 3 months from account opening. Not available to current cardmembers of this business card or previous cardmembers who received a new cardmember bonus for this business card within the last 24 months. PQP post to MileagePlus and do not count toward the card\u2019s 28,000 PQP annual cap. Account must be open and not in default. Bonus miles do not count toward Premier status. Estimated value: 100,000 miles \u2248 $1,300 at 1.3\u00a2/mile (your value may vary); PQP has elite\u2011status value but no direct cash value.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "miles"
        },
        {
          "reward_type": null,
          "new_reward_type": "status_qualifying_points_united",
          "amount": 2000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Add an employee (authorized user) card bonus: Earn 10,000 bonus miles when you add an authorized user within the first 3 months from account opening (awarded once for the first AU added; AU must remain on the account at fulfillment). Not available to current/previous cardmembers who received a new cardmember bonus for this credit card within the last 24 months. Estimated value: 10,000 miles \u2248 $130 at 1.3\u00a2/mile (your value may vary).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "chase_united_club_business_card.png"
},
  [CreditCard.BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD]: {
  "id": CreditCard.BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD,
  "name": "Bass Pro Shops & Cabela\u2019s CLUB Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/smallbusinesscard_club_120120.jpg",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "sportingGoods.bassProAndCabelas",
      "earnRate": 5.0,
      "description": "5% back in CLUB Points on all Bass Pro Shops and Cabela\u2019s purchases (in-store and online).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5% back in CLUB Points on purchases everywhere Mastercard is accepted; excludes Bass Pro Shops and Cabela\u2019s purchases which earn 5%.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "CLUB Member Price Beat",
      "description": "Bass Pro Shops and Cabela\u2019s will match a qualifying lower price, and for CLUB Members they\u2019ll beat it by 5%.",
      "benefit_type": null,
      "new_benefit_type": "merchant_price_match_plus_5_percent",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Year-end summary and reporting",
      "description": "Receive a year-end summary of all transactions and export reports to help manage your business.",
      "benefit_type": null,
      "new_benefit_type": "year_end_summary",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 2,
      "description": "Earn $75 in CLUB Points after you spend $1,000 within 60 days of account approval. Estimated value: $75 (assumes CLUB Points redeem at roughly 1\u00a2 per point \u2192 about 7,500 points).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 75.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/club-business/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/club-business/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "bass_pro_shops_and_cabelas_club_business_mastercard.jpg"
},
  [CreditCard.SYNCHRONY_PANDORA_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_PANDORA_CREDIT_CARD,
  "name": "Pandora Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_clientoffer/e079851.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://us.pandora.net/en/pandora-credit-card/?intcmp=NoOff_PandoraCreditCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://us.pandora.net/en/pandora-credit-card/?intcmp=NoOff_PandoraCreditCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=A4A3EBF64AFDCFFCB4B92B0B7684988C26A3947570E551D8&preQual=Y&intcmp=NoOff_PandoraCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_pandora_credit_card.jpg"
},
  [CreditCard.ONE_KEY_CARD]: {
  "id": CreditCard.ONE_KEY_CARD,
  "name": "One Key\u2122 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/W-Card-MarketPlace/v9-10-25/images/Products/OneKey/onekeycash_card.png",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.EXPEDIA,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Earn 3% in OneKeyCash on dining purchases coded as eating places and restaurants, drinking places, fast food restaurants, and caterers. Purchases not coded in these categories earn the base rate. Cash equivalents do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "Earn 3% in OneKeyCash at grocery stores and supermarkets, including delis and bakeries, and miscellaneous food stores (may include some convenience and specialty stores and vending machines). Grocery purchases made at warehouses/membership clubs or meal kit services may not code as grocery and therefore may not earn the bonus. Cash equivalents do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "Earn 3% in OneKeyCash at gas stations, automated fuel dispensers, and electric vehicle charging stations. Purchases at superstores, warehouse clubs, car washes, or auto repair stores may not code as gas and may not earn the bonus. Cash equivalents do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "expedia",
      "earnRate": 3.0,
      "description": "Earn 3% in OneKeyCash on eligible travel booked through the U.S. versions of Expedia, Hotels.com, or Vrbo. Transactions must process with appropriate travel merchant categories; various third-party or supplier-direct charges are excluded. Cash equivalents do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "hotels_com",
      "earnRate": 3.0,
      "description": "Earn 3% in OneKeyCash on eligible travel booked through the U.S. versions of Expedia, Hotels.com, or Vrbo. Transactions must process with appropriate travel merchant categories; various third-party or supplier-direct charges are excluded. Cash equivalents do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "vrbo",
      "earnRate": 3.0,
      "description": "Earn 3% in OneKeyCash on eligible travel booked through the U.S. versions of Expedia, Hotels.com, or Vrbo. Transactions must process with appropriate travel merchant categories; various third-party or supplier-direct charges are excluded. Cash equivalents do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5% in OneKeyCash on other eligible net purchases outside the listed bonus categories. Cash equivalents, balance transfers, and cash advances do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.2899,
    "description": "Variable APRs based on creditworthiness and tied to the U.S. Prime Rate: Purchases 18.99%, 23.99%, or 28.99% variable; Balance transfers 18.99%, 23.99%, or 28.99% variable; Cash advances 28.99% variable. Minimum interest charge $1. At least 25 days grace period on purchases if you pay your balance in full by the due date."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "Pay no foreign transaction fees on purchases converted to U.S. dollars.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $1,000 per approved claim (max 2 claims per 12 months; $25 deductible per claim) against damage, theft, or involuntary and accidental parting when you pay your monthly wireless bill with the card. Coverage begins the month after the first eligible bill payment and is supplemental to other insurance.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Protection",
      "description": "Secondary coverage when you pay the entire common carrier fare with the card; reimburses up to $5,000 for covered reasons.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Primary)",
      "description": "Primary CDW (except for NY residents). Pay for the rental with the card and decline the rental company\u2019s coverage to be eligible. Reimburses up to $50,000 for covered theft or damage; certain vehicles excluded.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Up to $1,000,000 in accidental death and dismemberment coverage when you purchase your common carrier ticket with the card.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic One Key Silver tier",
      "description": "Primary cardholder receives automatic One Key Silver status as long as the card remains open (must have a U.S. One Key loyalty account linked to the card). Silver Member Prices can offer 15%+ savings on select hotels (per Expedia program terms).",
      "benefit_type": null,
      "new_benefit_type": "one_key_silver_status",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Path to One Key Gold tier via card spend",
      "description": "Earn One Key Gold tier by making at least $15,000 in net purchases on the card in a calendar year (status valid through the rest of the year earned, the next full calendar year, and through Feb 28 of the following year).",
      "benefit_type": null,
      "new_benefit_type": "one_key_gold_status_qualification",
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn $300 in OneKeyCash after at least $1,000 in net purchases within the first 3 months from account opening. You must have an open One Key loyalty account. Excludes cash equivalents, balance transfers, fees/interest, gambling, disputes/illegal transactions, and other excluded categories listed in terms. Bonus typically posts within 1\u20132 billing periods after it\u2019s earned. Eligibility note: You may not be eligible if you opened a One Key, One Key+, or Hotels.com card within the last 48 months (even if closed). Estimated value: $300 toward eligible bookings on Expedia, Hotels.com, or Vrbo; OneKeyCash is not redeemable for cash.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "onekeycash",
          "amount": 300.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "additional_links": [],
  "bank_name": "Wells Fargo",
  "imageName": "one_key_card.jpeg"
},
  [CreditCard.ROBINHOOD_PLATINUM_CARD]: {
  "id": CreditCard.ROBINHOOD_PLATINUM_CARD,
  "name": "Robinhood Platinum Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://images.ctfassets.net/ilblxxee70tt/3zew0ICzKRluidgSU8KDGG/425075f4e4ccec8e6005e63133ec070b/video-crop.jpg",
  "recommendedMinCreditScore": null,
  "availability": "coming_soon",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 5.0,
      "description": "Advertised as \u201c5% cash back on dining\u201d (terms apply).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "5% cash back on flights when booked through the Robinhood Banking app.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 10.0,
      "description": "10% cash back on hotels when booked through the Robinhood Banking app.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 10.0,
      "description": "10% cash back on cars (rental cars) when booked through the Robinhood Banking app.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "\u201cEarn 1% cash back on other purchases\u201d (terms apply).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 695.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 695.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Priority Pass lounge access",
      "description": "Unlimited access to 1,800+ Priority Pass lounges at airports around the globe (terms/limitations may apply).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass membership",
      "description": "Complimentary DoorDash DashPass membership (listed as a $120 value; terms/limitations may apply).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "TSA PreCheck / Global Entry benefit (mentioned)",
      "description": "Page mentions 'Stay a step ahead with Global Entry or TSA PreCheck\u00ae' but does not specify a credit amount or reimbursement terms in the provided markdown.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Oura Membership",
      "description": "Complimentary Oura Membership for personalized insights into sleep, activity, and more (terms/limitations may apply).",
      "benefit_type": null,
      "new_benefit_type": "complimentary_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Function Health Membership",
      "description": "160+ advanced lab tests and custom insights with complimentary Function Health Membership (stated $365 value; terms/limitations may apply).",
      "benefit_type": null,
      "new_benefit_type": "complimentary_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Amazon One Medical membership at no cost",
      "description": "Amazon One Medical membership at no cost (stated $199 value; terms/limitations may apply).",
      "benefit_type": null,
      "new_benefit_type": "complimentary_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees (not a credit).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "TSA PreCheck / Global Entry benefit (mentioned)",
      "description": "Page mentions 'Stay a step ahead with Global Entry or TSA PreCheck\u00ae' but does not specify a credit amount or reimbursement terms in the provided markdown.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Annual DoorDash discount",
      "description": "$250 annual DoorDash discount (terms/limitations may apply).",
      "credit_type": "merchant_or_category_specific_credit",
      "credit_category": "dining.takeoutDelivery.doordash",
      "new_credit_category": null,
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            250.0
          ]
        }
      ],
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "Annual credit at 15K+ eligible restaurants",
      "description": "$250 annual credit at 15K+ eligible restaurants (terms/limitations may apply). Specific restaurant list/merchant network not provided in the markdown.",
      "credit_type": "annual_credit",
      "credit_category": "dining",
      "new_credit_category": null,
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            250.0
          ]
        }
      ],
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "Annual hotel credit",
      "description": "$500 annual hotel credit; 'Find your perfect room directly in the app' (terms/limitations may apply). Booking appears to be in-app.",
      "credit_type": "annual_credit",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 500.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            500.0
          ]
        }
      ],
      "total_yearly_value": 500.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "Annual travel credit",
      "description": "$300 annual travel credit (terms/limitations may apply).",
      "credit_type": "annual_credit",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            300.0
          ]
        }
      ],
      "total_yearly_value": 300.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "Annual wearables credit",
      "description": "$200 annual credit toward wearables (terms/limitations may apply). Eligible merchants not specified.",
      "credit_type": "annual_credit",
      "credit_category": null,
      "new_credit_category": "wearables",
      "value": 200.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            200.0
          ]
        }
      ],
      "total_yearly_value": 200.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "Annual credit on autonomous rides",
      "description": "$250 annual credit on autonomous rides (terms/limitations may apply). Provider/eligible services not specified.",
      "credit_type": "annual_credit",
      "credit_category": null,
      "new_credit_category": "autonomous_rides",
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            250.0
          ]
        }
      ],
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    }
  ],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "Robinhood",
  "imageName": "robinhood_platinum_card.jpg"
},
  [CreditCard.CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD,
  "name": "Credit One Bank American Express\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/preferred-amex-cobalt.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Unlimited 1% cash back on all purchases credited automatically as a statement credit on each statement with at least one net purchase. Rewards are not earned on cash advances, balance transfers, interest, fees, other charges, or while the account is delinquent or in default.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 39.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 39.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "Purchase APR 29.49% variable; rates accurate as of 8/31/2025."
  },
  "benefits": [
    {
      "name": "Retail Protection (Purchase Protection)",
      "description": "Covers eligible items if accidentally damaged or stolen within 90 days of purchase.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance (Amex Network)",
      "description": "Travel Accident Insurance provided via the American Express Network. Coverage details and terms available at the Amex Network benefits page.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Access to American Express Offers for savings with select merchants; value varies by offer and is not guaranteed.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Fraud Liability",
      "description": "You won\u2019t be held responsible for unauthorized charges if you notify the bank promptly of any unauthorized use.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Experian IdentityWorks membership (optional)",
      "description": "Optional free membership in Experian IdentityWorks when you complete your credit card application online; program operated by Experian and subject to change.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1OA_CS_19&C1BDescriptorID=AEA3809L00&C1BSpecificationID=bc-amex",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/american-express-card",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/7gg?pc=WKT1",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [
    {
      "name": "Reviews",
      "url": "https://www.creditonebank.com/credit-cards/american-express-card/reviews"
    }
  ],
  "bank_name": "Credit One",
  "imageName": "credit_one_bank_american_express_card.png"
},
  [CreditCard.BANK_OF_AMERICA_ATMOS_REWARDS_SUMMIT_VISA_INFINITE_CREDIT_CARD]: {
  "id": CreditCard.BANK_OF_AMERICA_ATMOS_REWARDS_SUMMIT_VISA_INFINITE_CREDIT_CARD,
  "name": "Atmos\u2122 Rewards Summit Visa Infinite\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/1bed_rewcm_v_atmos_visafront_infinite_250.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.ALASKA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.alaska",
      "earnRate": 3.0,
      "description": "Eligible direct purchases from Alaska Airlines, including tickets, flight subscriptions, inflight food & beverages, lounge memberships and in-lounge purchases, cargo, and vacation packages when Alaska Airlines is the merchant of record. Eligible pre-paid hotels or vacation rental bookings must be booked on AlaskaAir.com. Purchases made through third-party merchants (e.g., OTAs or travel agencies) do not earn 3x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.hawaiian",
      "earnRate": 3.0,
      "description": "Eligible direct purchases from Hawaiian Airlines, including tickets, flight subscriptions, inflight food & beverages, lounge memberships and in-lounge purchases, cargo, and vacation packages when Hawaiian Airlines is the merchant of record. Eligible pre-paid hotels or vacation rental bookings must be booked on HawaiianAirlines.com. Purchases made through third-party merchants (e.g., OTAs or travel agencies) do not earn 3x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Eligible dining purchases include Caterers, Eating Places/Restaurants, Bars, Cocktail Lounges, Discotheques, Nightclubs, Taverns/Drinking Places (Alcoholic Beverages), and Fast Food Restaurants based on merchant category code.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "foreignTransactions",
      "earnRate": 3.0,
      "description": "Eligible foreign transactions are those made in a foreign currency or made in U.S. dollars but processed outside the United States and U.S. territories. How a transaction is processed is determined by the merchant/acquirer.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point per $1 on all other eligible net purchases that do not fall into the elevated categories. Balance transfers, cash advances, fees, interest, and certain other charges do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.1,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America or Merrill relationship: 10% rewards bonus applied to base earnings for this category."
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 395.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 395.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable APR for purchases: 20.24%\u201328.24% (0.2024\u20130.2824) based on creditworthiness; balance transfers have the same variable APR range. Cash advance APR: 23.24%\u201328.24% (28.24% for Bank Cash Advances). Penalty APR up to 29.99%. No introductory APR. Grace period at least 25 days; interest on balance transfers and cash advances accrues from the transaction date."
  },
  "benefits": [
    {
      "name": "Annual Global 25K Companion Award",
      "description": "Receive one Global 25K Companion Award each account anniversary, valid for up to 25,000 points off a companion\u2019s published award ticket when you redeem points on the same itinerary, booked together on AlaskaAir.com. Must be used within 12 months of issue; taxes/fees apply. Estimated value: up to 25,000 points; at ~1.2\u00a2/pt illustrative value, up to ~$300.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Global 100K Companion Award (after $60,000 spend)",
      "description": "Earn one Global 100K Companion Award (worth up to 100,000 points off a companion award) after $60,000 in Net Purchases each card anniversary year; credited within 1\u20132 billing cycles. Must be used within 12 months; taxes/fees apply. Estimated max value: up to 100,000 points (~$1,200 at 1.2\u00a2/pt illustrative value).",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 60000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Alaska Lounge Passes",
      "description": "8 Alaska Lounge day passes per year, delivered as 2 passes each calendar quarter; valid at Alaska Lounge locations for same\u2011day travel. Passes expire at quarter end. Estimated value: ~$60 per pass (typical day\u2011pass pricing), up to ~$480/year.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Alaska Airlines Wi\u2011Fi Passes",
      "description": "8 single\u2011flight Wi\u2011Fi passes per year, delivered as 2 per calendar quarter; valid through end of quarter issued. Estimated value: ~$8\u2013$20 per pass depending on route/provider, ~$64\u2013$160/year.",
      "benefit_type": "airline_wifi_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "TSA PreCheck or Global Entry Credit",
      "description": "Up to $120 in statement credits per account every four years when you pay the application fee with the card. Effective value roughly $30/year (amortized).",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Checked Bag (Alaska & Hawaiian)",
      "description": "1st checked bag free for you and up to 6 guests on the same reservation on eligible Alaska or Hawaiian flights when airfare is purchased with the card. Estimated value: ~$35 per person each way (varies by carrier/route).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred Boarding (Alaska)",
      "description": "Preferred boarding for you and up to 6 guests on the same reservation on eligible Alaska flights when airfare is purchased with the card.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Same\u2011Day Confirmed Change Fee Waiver (Alaska)",
      "description": "Free same\u2011day confirmed flight changes or standby on Alaska for eligible tickets; saver fares excluded; must keep same origin/destination/connection cities and request change before original departure. Typical value up to ~$50 per change.",
      "benefit_type": null,
      "new_benefit_type": "same_day_confirmed_change_fee_waiver",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Instant Travel Delay Credit (Alaska)",
      "description": "$50 voucher if your same\u2011day flight is delayed 2+ hours or cancelled on Alaska/Horizon/SkyWest when booked directly with Alaska using this card; one $50 credit per calendar day; voucher valid 48 hours. Value: $50 per qualifying incident.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "20% Inflight Rebate (Alaska/Hawaiian)",
      "description": "20% back as a statement credit on onboard Alaska food, beverage, and Wi\u2011Fi purchases (and onboard Hawaiian food/beverage) when paid with the card. Value depends on onboard spend (e.g., $200/year spend \u2192 $40 back).",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary Status Points",
      "description": "Receive 10,000 Atmos Rewards status points each year on your account anniversary. Status points are non\u2011redeemable and count only toward elite qualification.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Partner Redemption Booking Fee Waiver",
      "description": "Waiver of booking fees when redeeming Atmos Rewards points for travel on Alaska\u2019s network of airline partners; taxes/fees must be paid with the card.",
      "benefit_type": null,
      "new_benefit_type": "partner_redemption_booking_fee_waiver",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points Sharing",
      "description": "Share redeemable points with up to 10 additional Atmos Rewards accounts in a single sharing network; status points excluded; linked accounts changeable once every 12 months.",
      "benefit_type": null,
      "new_benefit_type": "points_sharing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Partner Program Points Transfer",
      "description": "Eligible for points transfers to participating partner programs (availability and transfer rates may vary).",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Concierge",
      "description": "Complimentary concierge for dining, tickets, travel planning and more.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Luxury Hotel Collection Perks",
      "description": "Benefits at select premium hotels (e.g., daily breakfast for two, late checkout, potential room upgrade; subject to availability).",
      "benefit_type": null,
      "new_benefit_type": "visa_infinite_luxury_hotel_collection_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Elite/Benefit Access",
      "description": "VIP amenities, complimentary status upgrades and discounts with Avis, Hertz and National (per Visa Infinite program; enrollment/availability may apply).",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Protection",
      "description": "Coverage via Visa Infinite travel protections; terms/limits apply.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Coverage for essential items when baggage is delayed; terms/limits apply.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Reimbursement for lost luggage; terms/limits apply.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency Evacuation and Transportation",
      "description": "Visa Infinite travel protections include emergency evacuation/transportation; terms/limits apply.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Bank of America Relationship Bonus",
      "description": "Earn a 10% bonus on points from purchases if you have a qualifying Bank of America or Merrill account. Example: 1,000 earned points \u2192 1,100 points.",
      "benefit_type": "bofa_account_10_percent_rewards_bonus",
      "new_benefit_type": "relationship_bonus",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "TSA PreCheck or Global Entry Credit",
      "description": "Up to $120 in statement credits per account every four years when you pay the application fee with the card. Effective value roughly $30/year (amortized).",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Annual Atmos status points boost",
      "description": "Receive 10,000 Atmos Rewards status points each account anniversary year; points post automatically when your account remains open and in good standing.",
      "credit_category": null,
      "new_credit_category": "annual_status_points_bonus",
      "value": 10000.0,
      "value_unit": "points",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time online offer: Earn 100,000 bonus points plus a Global 25K Companion Award after $6,000 in purchases within 90 days of account opening. Limit 1 per new account; bonus posts within 2 billing cycles after qualifying. Companion Award provides up to 25,000 points off a companion\u2019s award when you redeem on the same itinerary at AlaskaAir.com; must be used within 12 months; taxes/fees apply. Illustrative value: 100,000 pts ~ $1,000\u2013$1,500 at ~1.0\u20131.5\u00a2/pt (example 1.2\u00a2/pt \u2248 $1,200) plus up to 25,000 pts off a companion award (\u2248 up to ~$300 at 1.2\u00a2/pt).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "points"
        },
        {
          "reward_type": null,
          "new_reward_type": "companion_award_discount",
          "amount": 25000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4075782&productoffercode=VQ&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/alaska-airlines-infinite-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4075782&productoffercode=VQ&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Atmos\u2122 Rewards Summit Visa Infinite\u00ae Credit Card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_atmos_rewards_summit_visa_infinite_credit_card.webp"
},
  [CreditCard.JETBLUE_PLUS_CARD]: {
  "id": CreditCard.JETBLUE_PLUS_CARD,
  "name": "JetBlue Plus Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/JBE_card_Plus_WE_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.JETBLUE,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.jetblue",
      "earnRate": 6.0,
      "description": "6x TrueBlue points on eligible JetBlue purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x points at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x points at eligible grocery stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x points on all other purchases (base earn rate).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchase APR 0.2024 to 0.2999 (variable with Prime). Balance transfers: 0.0 introductory APR for the first 12 billing cycles on transfers that post within 45 days of account opening; then 0.2024 to 0.2999 variable. Cash advances: 0.2999 variable. Minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "Free first checked bag on JetBlue",
      "description": "First checked bag free for you and up to 3 eligible travel companions on JetBlue-operated flights. Typical value around $35+ per person each way, so a round trip for 4 travelers could save ~$280+, depending on route and fare rules.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Inflight purchases savings",
      "description": "Savings on eligible inflight purchases on JetBlue-operated flights when you pay with the card. Value depends on amount spent onboard.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn toward Mosaic status",
      "description": "Earn progress toward JetBlue Mosaic status with every purchase on the card (see TrueBlue program rules for how card spend converts to Mosaic progress).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points back after award travel",
      "description": "Receive TrueBlue points back after you redeem for and travel on a JetBlue-operated award flight. Rebate value varies with the points redeemed; check T&Cs for the exact rebate percentage.",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary TrueBlue points",
      "description": "Bonus TrueBlue points each year after your JetBlue Plus Card account anniversary. Amount not specified on the page; value depends on number of points awarded.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay no foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Annual JetBlue Vacations statement credit",
      "description": "Statement credit after you purchase a JetBlue Vacations package of $100 or more with the card; limit one statement credit per year.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": 100,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 bonus TrueBlue points after spending $1,000 on purchases AND paying the annual fee in full within the first 90 days; plus earn an additional 20,000 bonus points after spending $6,000 total within the first year. Estimated value: at ~1.3 cents per point, 80,000 points \u2248 $1,040 in JetBlue flights (actual value varies by route/date). Offer terms: bonus may be earned once; see issuer T&Cs for eligibility and details.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 12,
      "description": "Earn 60,000 bonus TrueBlue points after spending $1,000 on purchases AND paying the annual fee in full within the first 90 days; plus earn an additional 20,000 bonus points after spending $6,000 total within the first year. Estimated value: at ~1.3 cents per point, 80,000 points \u2248 $1,040 in JetBlue flights (actual value varies by route/date). Offer terms: bonus may be earned once; see issuer T&Cs for eligibility and details.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/jetblue-plus-card/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/jetblue-plus-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "jetblue_plus_card.png"
},
  [CreditCard.CHASE_UNITED_QUEST_CARD]: {
  "id": CreditCard.CHASE_UNITED_QUEST_CARD,
  "name": "United Quest SM Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/chase_united_quest_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Base earn rate on all purchases that do not fall into a higher-earning category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x total miles on dining purchases, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 2.0,
      "description": "2x total miles on eligible food delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "2x total miles on select streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2x total miles on travel purchases, excluding United purchases that earn 3x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.united",
      "earnRate": 3.0,
      "description": "3x total miles on eligible purchases made directly from United.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5x total miles on qualifying hotel stays booked through Renowned Hotels and Resorts for United Cardmembers via Chase Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 350.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.2049
  },
  "annualFee": 350.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2049,
    "high": 0.2899,
    "description": "Variable APRs based on Prime Rate: purchases 0.2049\u20130.2899; balance transfers 0.2049\u20130.2899; cash advances 0.2924; penalty APR up to 0.2999. Minimum 21-day grace period on purchases if paid in full; no minimum interest charge. Note: account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "Free first and second checked bags on United",
      "description": "Primary cardmember and one companion on the same reservation each receive their first and second standard checked bags free on United and United Express when the ticket is purchased with the card (purchase requirement waived for flights completed within 90 days of account opening). Authorized users only eligible when on the same reservation as the primary cardmember. Oversize/overweight fees still apply.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority boarding on United and United Express",
      "description": "Primary cardmember and companions on the same reservation can board before general boarding (after Premier members and those with Premier Access). Authorized users only eligible when on the same reservation as the primary cardmember.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on food, beverage and Wi\u2011Fi purchases onboard United/United Express and on premium drink purchases at United Clubs when paid with the card. Credits typically post within 24 hours of the purchase posting.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing discount",
      "description": "United indicates cardmembers often see lower award pricing vs. non\u2011cardholders (historically averaged ~32% lower when the \u201cCardmembers Save\u201d banner appeared; actual savings vary). Taxes and fees not discounted.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the first eligible application fee (Global Entry, TSA PreCheck, or NEXUS) is charged to the card by you or an authorized user. You are responsible for the fee until the credit posts.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary 10,000\u2011mile award flight discount",
      "description": "A 10,000\u2011mile award flight discount is deposited into the primary cardmember\u2019s MileagePlus account within ~4 weeks after each account anniversary. Valid on eligible United/United Express award flights; unused discounts expire 12 months from issue.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn a 10,000\u2011mile award flight discount with annual spend",
      "description": "Spend $20,000 in purchases in a calendar year to earn one 10,000\u2011mile award flight discount (limit 1 per calendar year). Discount valid on eligible United/United Express award travel and expires 12 months after issue.",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn 2 global Economy Plus seat upgrades with annual spend",
      "description": "After $40,000 in purchases in a calendar year, the primary cardmember earns 2 Economy Plus upgrade credits valid on United/United Express (when available). Credits are for the primary cardmember only, not transferable, and expire 12 months from issue.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Premier Upgrades on award tickets (for Premier members)",
      "description": "Primary cardmember with MileagePlus Premier status is eligible for Complimentary Premier Upgrades on select United/United Express flights when traveling on an award ticket; one companion on the same reservation is also eligible. Subject to availability and upgrade priority rules.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Premier Qualifying Points from spend",
      "description": "Earn 1 PQP for every $20 in net purchases, up to 18,000 PQP per calendar year, which apply toward Premier status up to and including Premier 1K (rules and caps may vary by program year).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "1,000 Card Bonus PQP each year",
      "description": "Primary cardmember receives 1,000 bonus PQP within 6\u20138 weeks after February 1 each year, if the account was open on December 31 of the prior year and remains open and not in default at fulfillment. Does not count against the annual PQP-from-spend cap.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership (limited-time)",
      "description": "Activate between 3/23/2025 and 12/31/2027 to receive 3 months of complimentary Instacart+ membership, then 50% off the then-current annual rate through 12/31/2027 when paid with the card. Terms apply and membership auto-renews unless canceled.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge service",
      "description": "Access to a concierge for assistance with travel, dining, and lifestyle requests. Cardmembers are responsible for the cost of any goods or services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the first eligible application fee (Global Entry, TSA PreCheck, or NEXUS) is charged to the card by you or an authorized user. You are responsible for the fee until the credit posts.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "$200 annual United TravelBank credit",
      "description": "One $200 United TravelBank cash credit added to your MileagePlus account each anniversary year. TravelBank cash must be used on United/United Express-operated flights and expires 12 months after issue.",
      "credit_category": "travel.airline.united",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$150 Renowned Hotels and Resorts statement credit",
      "description": "Up to $150 back annually in statement credits when you book and pay with your card directly through Renowned Hotels and Resorts for United Cardmembers via Chase Travel.",
      "credit_category": null,
      "new_credit_category": "renowned_hotels_and_resorts",
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$100 rideshare statement credit",
      "description": "Enroll each calendar year to earn up to $100 back: up to $8 per month January\u2013November and up to $12 in December on eligible rideshare purchases with your card.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Instacart monthly credits (with active Instacart+)",
      "description": "Receive one $10 and one $5 Instacart credit each month you have an active Instacart+ membership after activating the complimentary Instacart+ benefit. Credits are use-it-or-lose-it each month.",
      "credit_category": "instacart",
      "new_credit_category": null,
      "value": 15.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $80 Avis or Budget TravelBank credits",
      "description": "Earn $40 in TravelBank cash on each of your first two eligible Avis or Budget rentals booked via cars.united.com (2+ day rentals with specified discount codes) when paid with the card, up to $80 annually.",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 80.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$150 JSX statement credit",
      "description": "Up to $150 back annually in statement credits on purchases made directly with JSX when paid with the card.",
      "credit_category": null,
      "new_credit_category": "jsx",
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time welcome offer(s) may vary by channel. As shown: 100,000 bonus miles after $4,000 spend in the first 3 months, plus 3,000 Premier Qualifying Points (PQP) after the same $4,000 spend. Separate one-time 10,000-mile bonus after adding the first authorized user within 3 months. Account must be open and not in default; allow 6\u20138 weeks for posting; bonuses do not count toward Premier status (except PQP). Not available to current cardmembers or previous cardmembers who received a new cardmember bonus for this card in the past 24 months. Estimated value: 100,000 miles \u2248 $1,200 at ~1.2\u00a2/mile (actual value varies by redemption); AU 10,000 miles \u2248 $120.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "miles"
        },
        {
          "reward_type": null,
          "new_reward_type": "status_qualifying_points_united",
          "amount": 3000.0,
          "value_unit": "PQP"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Limited-time welcome offer(s) may vary by channel. As shown: 100,000 bonus miles after $4,000 spend in the first 3 months, plus 3,000 Premier Qualifying Points (PQP) after the same $4,000 spend. Separate one-time 10,000-mile bonus after adding the first authorized user within 3 months. Account must be open and not in default; allow 6\u20138 weeks for posting; bonuses do not count toward Premier status (except PQP). Not available to current cardmembers or previous cardmembers who received a new cardmember bonus for this card in the past 24 months. Estimated value: 100,000 miles \u2248 $1,200 at ~1.2\u00a2/mile (actual value varies by redemption); AU 10,000 miles \u2248 $120.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "chase_united_quest_card.png"
},
  [CreditCard.CHASE_UNITED_GATEWAY_CREDIT_CARD]: {
  "id": CreditCard.CHASE_UNITED_GATEWAY_CREDIT_CARD,
  "name": "United Gateway\u2120 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_gateway_card_tilted.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.united",
      "earnRate": 2.0,
      "description": "2x miles on eligible purchases from United Airlines as defined in the Rewards Program Agreement.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x miles at gas stations per Chase merchant coding rules.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2x miles on local transit and commuting purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare",
      "earnRate": 2.0,
      "description": "2x miles on rideshare services as part of local transit and commuting.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 mile per $1 on all other purchases that do not qualify for a bonus category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.2049
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2049,
    "high": 0.2899,
    "description": "0% intro APR for 12 months on purchases; then a variable purchase APR of 20.49%\u201328.99% (0.2049\u20130.2899) based on creditworthiness; APRs vary with the Prime Rate. Penalty APR up to 29.99%. Cash Advance APR 29.24%. Note: Account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "Two checked bag certificates after $10,000 spend",
      "description": "Earn two standard checked bag certificates each calendar year after $10,000 in purchases. Certificates post 6\u20138 weeks after meeting the spend; limit two per calendar year; United/United Express-operated flights only; expire 12 months after issue. Estimated value \u2248$70\u2013$80 total assuming ~$35\u2013$40 per standard bag, varies by route and baggage pricing.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on United inflight and United Club premium drink purchases",
      "description": "Automatic 25% back as a statement credit on food, beverages and Wi\u2011Fi purchased onboard United/United Express and on United Club premium drinks when paid with the card. Credits typically post within ~24 hours. Example: $40 inflight spend \u2192 $10 credit.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases made outside the U.S. Example savings: spending $5,000 abroad avoids ~$150 versus a typical 3% fee.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (CDW)",
      "description": "Coverage for theft and collision damage when you decline the rental company\u2019s CDW and pay in full with the card; in the U.S., coverage is secondary to your personal insurance. Terms, exclusions and documentation requirements apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "Reimbursement up to $1,500 per covered traveler and $6,000 per trip for prepaid, non\u2011refundable passenger fares if your trip is canceled or cut short due to covered reasons (e.g., sickness, severe weather).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Coverage for eligible new purchases against damage or theft for 120 days (New York: 90 days), up to $500 per item. Additional limits and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by one additional year on eligible warranties of three years or less (up to four years from purchase). Terms and caps apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "24/7 complimentary concierge assistance for dining, entertainment and travel requests. Availability may vary by Visa tier; some accounts may be issued Visa Platinum without this feature.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Access to United Card Events and MileagePlus Exclusives",
      "description": "Access to curated, ticketed cardmember experiences (United Card Events) and MileagePlus Exclusives redeemable with miles (availability limited; fees or miles required).",
      "benefit_type": null,
      "new_benefit_type": "exclusive_cardmember_events_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "25% back on United inflight and United Club premium drinks",
      "description": "Automatic 25% statement credit on eligible onboard purchases (food, beverages, Wi\u2011Fi) on United/United Express and United Club premium drinks when paid with the card. Posts typically within 24 hours. Example: $40 inflight spend \u2192 $10 credit.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 25.0,
      "value_unit": "percent",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 20,000 United MileagePlus miles after $1,000 in purchases within the first 3 months from account opening. Plus, earn 10,000 bonus miles after you add an authorized user within the first 3 months (awarded once for the first AU; AU must remain on the account at fulfillment). Not available to current cardmembers of this card or to previous cardmembers who received a new cardmember bonus for this card in the last 24 months. Bonus miles do not count toward Premier status. Allow 6\u20138 weeks for posting. Estimated value: 20,000 miles \u2248 $240 at 1.2\u00a2/mile; AU bonus 10,000 miles \u2248 $120; total \u2248 $360 (valuation varies).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Earn 20,000 United MileagePlus miles after $1,000 in purchases within the first 3 months from account opening. Plus, earn 10,000 bonus miles after you add an authorized user within the first 3 months (awarded once for the first AU; AU must remain on the account at fulfillment). Not available to current cardmembers of this card or to previous cardmembers who received a new cardmember bonus for this card in the last 24 months. Bonus miles do not count toward Premier status. Allow 6\u20138 weeks for posting. Estimated value: 20,000 miles \u2248 $240 at 1.2\u00a2/mile; AU bonus 10,000 miles \u2248 $120; total \u2248 $360 (valuation varies).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "chase_united_gateway_credit_card.png"
},
  [CreditCard.PLATINUM_X5_VISA]: {
  "id": CreditCard.PLATINUM_X5_VISA,
  "name": "Credit One Bank Platinum X5 Visa Signature",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/platinum-x5-visa-signature-ruby-red.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5% cash back on the first $5,000 per calendar year across combined purchases in gas, grocery, internet/cable/satellite TV, and mobile phone services; transactions at warehouse clubs (e.g., Costco, Sam\u2019s Club, BJ\u2019s), discount supercenters (e.g., Walmart, Target), purchases made with PayPal, groceries at certain non-grocery merchants (e.g., drugstores, bakeries, candy/nut/confection shops), and purchases for heating oil/propane/home heating companies earn 1% instead.",
      "spendCap": 5000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 5.0,
      "description": "5% cash back on the first $5,000 per calendar year across combined purchases in gas, grocery, internet/cable/satellite TV, and mobile phone services; transactions at warehouse clubs (e.g., Costco, Sam\u2019s Club, BJ\u2019s), discount supercenters (e.g., Walmart, Target), purchases made with PayPal, groceries at certain non-grocery merchants (e.g., drugstores, bakeries, candy/nut/confection shops), and purchases for heating oil/propane/home heating companies earn 1% instead.",
      "spendCap": 5000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 5.0,
      "description": "5% cash back on the first $5,000 per calendar year across combined purchases in gas, grocery, internet/cable/satellite TV, and mobile phone services; transactions at warehouse clubs (e.g., Costco, Sam\u2019s Club, BJ\u2019s), discount supercenters (e.g., Walmart, Target), purchases made with PayPal, groceries at certain non-grocery merchants (e.g., drugstores, bakeries, candy/nut/confection shops), and purchases for heating oil/propane/home heating companies earn 1% instead.",
      "spendCap": 5000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 5.0,
      "description": "5% cash back on the first $5,000 per calendar year across combined purchases in gas, grocery, internet/cable/satellite TV, and mobile phone services; transactions at warehouse clubs (e.g., Costco, Sam\u2019s Club, BJ\u2019s), discount supercenters (e.g., Walmart, Target), purchases made with PayPal, groceries at certain non-grocery merchants (e.g., drugstores, bakeries, candy/nut/confection shops), and purchases for heating oil/propane/home heating companies earn 1% instead.",
      "spendCap": 5000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% cash back on all other purchases. Also applies to amounts above the $5,000 annual cap in the 5% categories and to transactions subject to the listed limitations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 95.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "Purchase APR 29.49% variable; variable rates accurate as of 8/31/2025."
  },
  "benefits": [
    {
      "name": "Credit line increase reviews",
      "description": "Receive regular account reviews for potential credit limit increases.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1OX_CS_05&C1BDescriptorID=AEA3802L00&C1BSpecificationID=bc-plat-prem",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/platinum-x5-visa",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/7cu?pc=WL99",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [
    {
      "name": "View All Platinum Cards",
      "url": "https://www.creditonebank.com/credit-cards/platinum"
    }
  ],
  "bank_name": "Credit One",
  "imageName": "platinum_x5_visa.png"
},
  [CreditCard.BLUE_CASH_EVERYDAY_CARD_FROM_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.BLUE_CASH_EVERYDAY_CARD_FROM_AMERICAN_EXPRESS_CARD,
  "name": "Blue Cash Everyday\u00ae Card from American Express",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000305_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3% cash back at U.S. supermarkets on up to $6,000 per year in purchases (then 1%). Cash back is received as Reward Dollars redeemable as a statement credit.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineShopping",
      "earnRate": 3.0,
      "description": "3% cash back on U.S. online retail purchases on up to $6,000 per year in purchases (then 1%). Cash back is received as Reward Dollars redeemable as a statement credit.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% cash back at U.S. gas stations on up to $6,000 per year in purchases (then 1%). Cash back is received as Reward Dollars redeemable as a statement credit.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on other purchases. Cash back is received as Reward Dollars redeemable as a statement credit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineShopping.amazon",
      "earnRate": 1.0,
      "description": "Cash back at Amazon.com checkout refers to redeeming Reward Dollars at checkout, not an increased earn rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "redemption_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "0.0 intro APR on purchases and balance transfers for 15 months from account opening; then a variable APR from 0.1999 to 0.2899."
  },
  "benefits": [
    {
      "name": "Disney Bundle streaming statement credit (Disney+, Hulu, ESPN+)",
      "description": "Get up to a $7 monthly statement credit after using your enrolled Card to pay for a subscription (including bundle subscriptions) at Disneyplus.com, Hulu.com, or plus.espn.com U.S. websites. Subject to auto\u2011renewal. Max $84 per year.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Events with Amex \u2013 ticket presales and special access",
      "description": "Special ticket access and presales to select events, plus potential access to Amex Fan Experiences and exclusive merchandise/offers. While supplies last; not all seats may be offered.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Explore and add targeted Amex Offers to your eligible Card to earn extra rewards or statement credits on qualifying purchases at select brands. Enrollment required; terms apply to each offer.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Send & Split with Venmo and PayPal",
      "description": "Send money and split purchases with any Venmo or PayPal user directly from the Amex App after enrollment. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "send_and_split",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Use Reward Dollars at Amazon.com checkout",
      "description": "Apply your accumulated cash back Reward Dollars at Amazon.com checkout for eligible purchases.",
      "benefit_type": null,
      "new_benefit_type": "amazon_checkout_with_reward_dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Plan It installment plans",
      "description": "Split purchases of $100 or more into equal monthly installments with a fixed fee; continue to earn rewards on purchases. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "plan_it_installments",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Disney Bundle streaming statement credit (Disney+, Hulu, ESPN+)",
      "description": "Up to a $7 monthly statement credit after using your enrolled Card for a subscription (including bundle subscriptions) at Disneyplus.com, Hulu.com, or plus.espn.com U.S. websites. Subject to auto\u2011renewal. Enrollment required. Terms apply.",
      "credit_type": "monthly_credit",
      "credit_category": {
        "categories": [
          "streaming",
          "streaming.disneyplus",
          "entertainment.disneyPlusHuluEspn"
        ],
        "exclude_subcategories": null,
        "is_us_only": true,
        "is_online_only": true,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Streaming subscriptions purchased directly at Disneyplus.com, Hulu.com, or plus.espn.com in the U.S. including bundle subscriptions."
      },
      "new_credit_category": null,
      "value": 7.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            7.0,
            7.0,
            7.0,
            7.0,
            7.0,
            7.0,
            7.0,
            7.0,
            7.0,
            7.0,
            7.0,
            7.0
          ]
        }
      ],
      "total_yearly_value": 84.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 2000.0,
      "spendRequirementMonths": 6,
      "description": "Earn up to $200 cash back after spending $2,000 in purchases in the first 6 months.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 250.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/blue-cash-everyday/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/blue-cash-everyday/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "BLUE_CASH_EVERYDAY_CARD_FROM_AMERICAN_EXPRESS_CARD.avif"
},
  [CreditCard.VENTURE_X_BUSINESS]: {
  "id": CreditCard.VENTURE_X_BUSINESS,
  "name": "Venture X Business",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/vxb-card-alt-at-2x.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CAPITAL_ONE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Unlimited 2X miles on all purchases. Portal bookings have their own higher earn rates as listed in separate entries.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "5X miles on flights booked via Capital One Travel. Bookings not made through the portal earn the base 2X. Rewards are not earned on any portion paid with the $300 annual Capital One Travel credit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 10.0,
      "description": "10X miles on hotels booked via Capital One Travel. Bookings not made through the portal earn the base 2X. Rewards are not earned on any portion paid with the $300 annual Capital One Travel credit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 10.0,
      "description": "10X miles on rental cars booked via Capital One Travel. Bookings not made through the portal earn the base 2X. Rewards are not earned on any portion paid with the $300 annual Capital One Travel credit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5X miles on hotels booked via Capital One Business Travel. Rewards and benefits may differ from Capital One Travel. Bookings not made through the portal earn the base 2X.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5X miles on rental cars booked via Capital One Business Travel. Rewards and benefits may differ from Capital One Travel. Bookings not made through the portal earn the base 2X.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 395.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 395.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Airport lounge access",
      "description": "Complimentary access to Capital One Lounges and 1,300+ Priority Pass lounges worldwide; Priority Pass enrollment required after activation; access subject to space availability.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$300 annual Capital One Travel credit",
      "description": "Receive a $300 credit each year for bookings made through Capital One Travel. Credit is managed within the portal, can be used across purchases, expires on the next account anniversary, and does not earn rewards; account must be open and in good standing.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "10,000 anniversary miles",
      "description": "Earn 10,000 bonus miles every year starting on your first anniversary.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry or TSA PreCheck application credit",
      "description": "Receive a statement credit up to $120 for Global Entry or TSA PreCheck once every 4 years; credit posts in 1\u20132 billing cycles and requires the card to be open and in good standing.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz President\u2019s Circle status",
      "description": "Complimentary Hertz President\u2019s Circle status upon enrollment via the Benefits tab; status activates 24\u201372 hours after enrollment; subject to Hertz terms and eligibility.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premier Collection hotel benefits",
      "description": "When booking eligible Premier Collection properties via Capital One Travel, receive a $100 experience credit per stay plus benefits like daily breakfast for two, Wi\u2011Fi, and (when available) room upgrades, early check-in, and late checkout; hotel and program terms apply.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Extended warranty protection on eligible items purchased with the card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Miles transfer to partners",
      "description": "Ability to transfer miles to 15+ travel loyalty partners; once transferred, rewards are subject to partner program terms and expirations.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$300 annual Capital One Travel credit",
      "description": "Receive a $300 credit each year for bookings made through Capital One Travel; managed within the portal, usable across purchases, expires on the next account anniversary; no rewards earned on the credit; account must be open and in good standing.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry or TSA PreCheck application fee credit",
      "description": "One statement credit up to $120 for Global Entry or TSA PreCheck every 4 years; posts in 1\u20132 billing cycles when you pay the application fee with the card; account must be open and in good standing.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 30000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 150,000 bonus miles after spending $30,000 in the first 3 months. Capital One states this equals $1,500 in travel (implying 1 cent per mile when redeemed via Capital One). Offer availability may require applying from the promotional page and may not be available to existing or previous Spark cardholders.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 150000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/small-business/credit-cards/venture-x-business/",
  "learn_more_link": "https://www.capitalone.com/small-business/credit-cards/venture-x-business/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "venture_x_business.png"
},
  [CreditCard.MYLOWES_REWARDS_CREDIT_CARD]: {
  "id": CreditCard.MYLOWES_REWARDS_CREDIT_CARD,
  "name": "MyLowe's Rewards Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/mylowes_rewards_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.lowes.com/u/register/creditapp?cardType=LAC&diy=true&clientCode=LOWES&intcmp=NoOff_MyLowe%27sRewardsCreditCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.lowes.com/u/register/creditapp?cardType=LAC&diy=true&clientCode=LOWES&intcmp=NoOff_MyLowe%27sRewardsCreditCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://www.lowes.com/u/register/creditapp?cardType=LAC&diy=true&clientCode=LOWES&preQual=Y&sitecode=lwMS24lpn&intcmp=NoOff_MyLowe%27sRewardsCreditCard_credit%20cards_body-catalog-cards_ext"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "mylowes_rewards_credit_card.png"
},
  [CreditCard.UNITED_QUEST_CARD]: {
  "id": CreditCard.UNITED_QUEST_CARD,
  "name": "United Quest\u2120 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/united_quest_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.united",
      "earnRate": 3.0,
      "description": "3x miles on airline tickets purchased directly from United and on United purchases such as seat upgrades, Economy Plus, inflight food/beverages/Wi\u2011Fi, baggage service charges, and other United fees. United Cardmember award pricing and other United-related exclusions apply as stated by Chase. Purchases must be direct with United; third\u2011party/discount sites or packages may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x miles on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 2.0,
      "description": "2x miles on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "2x miles on select streaming services as defined by Chase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2x miles on travel purchases, excluding United purchases that qualify for 3x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x mile per $1 on all other eligible purchases that do not fall into a bonus category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 350.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2874,
    "apr_low": 0.2024
  },
  "annualFee": 350.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2874,
    "description": "Variable APRs based on Prime Rate: Purchase APR 0.2024-0.2874; Balance Transfer APR 0.2024-0.2874; Cash Advance APR 0.2899; Penalty APR up to 0.2999. Grace period: at least 21 days to avoid interest on purchases. Minimum interest charge: none. Note: This account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "$200 Annual United TravelBank Cash Credit",
      "description": "One $200 United TravelBank cash deposit within 4 weeks after each card anniversary; usable on United or United Express operated flights. TravelBank cash expires 12 months after issue and cannot be combined with travel certificates, future flight credit or miles. Estimated value: $200 if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "First and second checked bags free for primary and one companion",
      "description": "Primary cardmember and one companion on the same reservation each get their first and second standard checked bags free on United and United Express. Ticket must be purchased with the card and have MileagePlus number in the reservation (purchase requirement waived for flights completed in the first 90 days after account opening). Potential value varies; United typically charges around $35\u2013$45 per bag each way, so savings can be substantial for roundtrips.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10,000-mile award flight discount after $20,000 calendar-year spend",
      "description": "Earn one 10,000-mile award flight discount after $20,000 in purchases in a calendar year. Discount applies to eligible United/United Express award bookings of more than 10,000 miles and expires 12 months after issue. Estimated value roughly equivalent to 10,000 miles (~$120\u2013$150 at 1.2\u20131.5\u00a2 per mile) if used.",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "10,000-mile anniversary award flight discount",
      "description": "A 10,000-mile award flight discount is deposited within ~4 weeks after each cardmember anniversary for use on eligible United/United Express award travel; expires 12 months after issue. Estimated value roughly equivalent to 10,000 miles (~$120\u2013$150 at 1.2\u20131.5\u00a2 per mile) if used.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn 2 global Economy Plus seat upgrades after $40,000 calendar-year spend",
      "description": "After $40,000 in purchases in a calendar year, earn 2 Economy Plus upgrade credits for the primary cardmember to upgrade to Economy Plus on eligible United/United Express flights; valid 12 months. Estimated value varies by route and date.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$150 Renowned Hotels and Resorts statement credit",
      "description": "Up to $150 in statement credits annually for bookings paid with the card through Renowned Hotels and Resorts for United Cardmembers via Chase Travel. Estimated value: up to $150 if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 rideshare statement credit each calendar year (enrollment required)",
      "description": "Enroll each calendar year to earn up to $100 back on rideshare purchases charged to the card: $8 per month January\u2013November and $12 in December. Credits post 6\u20138 weeks after the charge. Estimated value: up to $100/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Monthly Instacart credits ($10 + $5) with active Instacart+ membership",
      "description": "With an active Instacart+ membership, receive one $10 and one $5 Instacart credit each month after activating the complimentary Instacart+ benefit; available 3/23/2025\u201312/31/2027. Credits don\u2019t roll over and require a $10+ order on Instacart.com, paid with this card. Estimated value: up to $15/month ($180/year) during the promotional window if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $80 Avis or Budget TravelBank cash annually",
      "description": "Earn $40 United TravelBank cash after your first eligible Avis or Budget rental and another $40 after your second, when booking 2+ day rentals via cars.united.com with specified discount codes and paying with the card. Posted within 6\u20138 weeks of return. Estimated value: up to $80/year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$150 JSX statement credit annually",
      "description": "Up to $150 in statement credits each year for purchases made directly with JSX and paid with the card. Estimated value: up to $150/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Priority boarding on United and United Express",
      "description": "Primary cardmember and companions on the same reservation are eligible for priority boarding on United/United Express when the MileagePlus number is in the reservation.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing on United-operated award flights",
      "description": "Cardmembers often receive lower award pricing vs. general members on United-operated flights. United reports 2024 average savings of 32% when the \u201cCardmembers Save\u201d banner was present (savings vary and exclude taxes/fees).",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry/TSA PreCheck/NEXUS application fee credit (up to $120 every 4 years)",
      "description": "One statement credit up to $120 once every 4 years when you charge a Global Entry, TSA PreCheck, or NEXUS application fee to the card. Estimated value: $100\u2013$120 per 4-year cycle (~$25\u2013$30/year equivalent).",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on inflight food, beverage and Wi\u2011Fi and United Club premium drinks",
      "description": "Get 25% back as a statement credit on eligible onboard food, beverage and Wi\u2011Fi purchases on United/United Express flights, Wi\u2011Fi subscriptions, and premium drinks at United Clubs when paid with the card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn PQP from spend toward Premier status (up to 18,000/year)",
      "description": "Earn 1 Premier Qualifying Point (PQP) for every $20 in net purchases, up to 18,000 PQP per calendar year, applied toward Premier status tiers up to Premier 1K.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "1,000 Card Bonus PQP each year",
      "description": "The primary cardmember earns 1,000 Card Bonus PQP within 6\u20138 weeks after February 1 each year, if the account was open as of the prior Dec 31. These do not count toward the 18,000 PQP-from-spend cap.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Premier Upgrades on award tickets (for Premier members)",
      "description": "Primary cardmember with MileagePlus Premier status and one companion on the same reservation are eligible for Complimentary Premier Upgrades on select United/United Express flights when traveling on award tickets, subject to availability.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership for 3 months, then 50% off through 12/31/27",
      "description": "Activate with the card between 3/23/25 and 12/31/27 to receive 3 months of Instacart+ free, then 50% off the annual rate through 12/31/27 if paid with the card. Estimated value of free period: about $24.75 at a $99/year list price.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge service",
      "description": "Access to concierge services; cardmember pays for goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry/TSA PreCheck/NEXUS application fee credit (up to $120 every 4 years)",
      "description": "One statement credit up to $120 once every 4 years when you charge a Global Entry, TSA PreCheck, or NEXUS application fee to the card. Estimated value: $100\u2013$120 per 4-year cycle (~$25\u2013$30/year equivalent).",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "$200 annual United TravelBank credit",
      "description": "One $200 United TravelBank cash credit added to your MileagePlus account each anniversary year. TravelBank cash must be used on United/United Express-operated flights and expires 12 months after issue.",
      "credit_category": "travel.airline.united",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$150 Renowned Hotels and Resorts statement credit",
      "description": "Up to $150 back annually in statement credits when you book and pay with your card directly through Renowned Hotels and Resorts for United Cardmembers via Chase Travel.",
      "credit_category": null,
      "new_credit_category": "renowned_hotels_and_resorts",
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$100 rideshare statement credit",
      "description": "Enroll each calendar year to earn up to $100 back: up to $8 per month January\u2013November and up to $12 in December on eligible rideshare purchases with your card.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Instacart monthly credits (with active Instacart+)",
      "description": "Receive one $10 and one $5 Instacart credit each month you have an active Instacart+ membership after activating the complimentary Instacart+ benefit. Credits are use-it-or-lose-it each month.",
      "credit_category": "instacart",
      "new_credit_category": null,
      "value": 15.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $80 Avis or Budget TravelBank credits",
      "description": "Earn $40 in TravelBank cash on each of your first two eligible Avis or Budget rentals booked via cars.united.com (2+ day rentals with specified discount codes) when paid with the card, up to $80 annually.",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 80.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$150 JSX statement credit",
      "description": "Up to $150 back annually in statement credits on purchases made directly with JSX when paid with the card.",
      "credit_category": null,
      "new_credit_category": "jsx",
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 70,000 United MileagePlus miles and 1,000 Premier Qualifying Points (PQP) after $4,000 in purchases in the first 3 months; plus 10,000 bonus miles for adding an authorized user within 3 months (awarded once for the first AU). Not available to current cardmembers or to previous cardmembers who received a bonus for this card in the past 24 months. Miles/PQP post in 6\u20138 weeks; account must be open and not in default. Estimated value: 70k miles \u2248 $840\u2013$1,050 at ~1.2\u20131.5\u00a2 each; AU 10k miles \u2248 $120\u2013$150; total potential value \u2248 $960\u2013$1,200 (excludes PQP\u2019s status value).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 70000.0,
          "value_unit": "miles"
        },
        {
          "reward_type": null,
          "new_reward_type": "status_qualifying_points_united",
          "amount": 1000.0,
          "value_unit": "PQP"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Earn 70,000 United MileagePlus miles and 1,000 Premier Qualifying Points (PQP) after $4,000 in purchases in the first 3 months; plus 10,000 bonus miles for adding an authorized user within 3 months (awarded once for the first AU). Not available to current cardmembers or to previous cardmembers who received a bonus for this card in the past 24 months. Miles/PQP post in 6\u20138 weeks; account must be open and not in default. Estimated value: 70k miles \u2248 $840\u2013$1,050 at ~1.2\u20131.5\u00a2 each; AU 10k miles \u2248 $120\u2013$150; total potential value \u2248 $960\u2013$1,200 (excludes PQP\u2019s status value).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HWC8&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/united/united-quest?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62521.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/UnitedQuestCard/RewardsAgreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "united_quest_card.png"
},
  [CreditCard.MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD]: {
  "id": CreditCard.MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD,
  "name": "Marriott Bonvoy Bountiful\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/marriott_bonvoy_bountiful_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.MARRIOTT_BONVOY,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.marriott",
      "earnRate": 6.0,
      "description": "6x points per $1 on qualifying purchases at hotels participating in Marriott Bonvoy. Accelerated earn is from the credit card program; additional Marriott Bonvoy program points for hotel stays follow Marriott Bonvoy terms. Excludes transactions not treated as purchases (e.g., balance transfers, cash advances, cash-like transactions, lottery tickets, casino chips, race track wagers, checks that access your account, interest, fees). Separate ongoing card benefit: up to 1,000 bonus points per eligible stay when booked/purchased directly with Marriott using this card, per stay terms apply.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 4.0,
      "description": "Earn 4x total points on the first $15,000 in combined annual purchases at grocery stores and on dining at restaurants (including takeout and eligible delivery services). After $15,000 combined, these categories earn 2x. Category qualification depends on merchant coding per Chase.",
      "spendCap": 15000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "grocery",
          "dining"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "4x total points on: grocery stores; dining at restaurants (including takeout and eligible delivery services). Applies to the first $15,000 in combined purchases across these categories each year as defined by Chase (open date to first December statement, then December-to-December cycles). After the cap, these purchases earn 2x.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2x points per $1 on all other purchases (and on dining/grocery after the combined $15,000 annual cap). Excludes transactions not treated as purchases (e.g., balance transfers, cash advances, cash-like transactions, lottery tickets, casino chips, race track wagers, checks that access your account, interest, fees).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 250.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2849,
    "apr_low": 0.1999
  },
  "annualFee": 250.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2849,
    "description": "Purchase APR: 19.99%\u201328.49% variable based on Prime Rate; Balance transfer APR: 19.99%\u201328.49% variable; Cash advance APR: 29.24% variable; Penalty APR up to 29.99% variable. Minimum interest charge: None. Grace period: at least 21 days on purchases if paid in full. Variable APRs tied to Prime Rate (7.50% as of 2/4/2025)."
  },
  "benefits": [
    {
      "name": "Complimentary Free Night Award after $15,000 spend",
      "description": "Earn one Free Night Award each calendar year after $15,000 in purchases, valid at properties up to 50,000 points. Award deposits within ~12 weeks after qualifying purchases; expires 12 months from issuance. Estimated value up to ~50,000 points (~$350 at ~0.7 cpp), varies by redemption.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "15 Elite Night Credits each year",
      "description": "Receive 15 Elite Night Credits deposited within 60 days of account opening and by March 1 in subsequent years (one consumer Marriott Bonvoy card\u2019s ENC benefit per member per year). Helps accelerate earning higher elite status tiers.",
      "benefit_type": null,
      "new_benefit_type": "elite_night_credits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic Marriott Bonvoy Gold Elite Status",
      "description": "Gold Elite status automatically each calendar year while account is open and in good standing. Initial status may take up to 8 weeks to post. Provides on-property Gold benefits per Marriott Bonvoy program rules (e.g., 25% points bonus on stays, enhanced room upgrade, 2pm late checkout where available).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "1,000 Bonus Points per eligible Marriott stay",
      "description": "Earn up to 1,000 bonus points per eligible paid stay at participating Marriott Bonvoy properties when the stay is purchased directly with Marriott using the Bountiful card and you are the primary cardmember. Estimated value per stay ~1,000 points (~$7 at ~0.7 cpp).",
      "benefit_type": null,
      "new_benefit_type": "hotel_stay_bonus_points",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass (DoorDash/Caviar) for 12 months",
      "description": "12 months of complimentary DashPass when first activated with the card between 02/01/2025 and 12/31/2027; auto-renews at then-current rate unless canceled. Must use this card at checkout for DashPass benefits. Estimated value up to ~$120 (assuming ~$10/mo), varies by pricing and usage.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$10 off once per quarter on DoorDash non-restaurant orders (with active DashPass)",
      "description": "After activating the included DashPass, receive one $10 discount each calendar quarter on a qualifying non-restaurant DoorDash order when paying with this card. Does not roll over. Estimated recurring value up to $40 per year if fully used.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "Access to Visa Signature Concierge; cardmember pays for goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 85,000 Marriott Bonvoy points after $4,000 in purchases in the first 3 months from account opening. Not available if you currently have this card or received a new cardmember bonus for this card in the past 24 months. Additional family restrictions apply: not available if you (1) currently have or had certain Amex/Marriott/SPG cards in the last 30 days, (2) were approved for any of those cards in the last 90 days, or (3) received a new cardmember/upgrade bonus on any of those cards in the last 24 months. Allow up to 8 weeks for points to post; account must be open and not in default. If account not open for at least 6 months, Marriott and Chase may deduct the bonus from your Marriott Bonvoy account. Estimated value ~85,000 points \u2248 ~$595 at ~0.7 cents/point (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 85000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HR9W&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/marriott-bonvoy/bountiful?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61472.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/marriottbountifulcard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "marriott_bonvoy_bountiful_credit_card.png"
},
  [CreditCard.DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD,
  "name": "Delta SkyMiles\u00ae Gold American Express Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000268_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DELTA,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "At restaurants; includes takeout and delivery in the U.S.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "At U.S. supermarkets.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.delta",
      "earnRate": 2.0,
      "description": "Delta purchases made directly with Delta.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "On all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 150.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "$200 Delta Flight Credit (after $10,000 calendar-year spend)",
      "description": "Earn a $200 Delta Flight Credit toward future Delta travel after you spend $10,000 in purchases on the Card in a calendar year. Estimated value: up to $200 per year if spend threshold is met.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "TakeOff 15: 15% award savings on Delta-operated flights",
      "description": "Save 15% on the miles required when you book Award Travel on Delta and Delta Connection carrier-operated flights via delta.com or the Fly Delta app; discount excludes partner-operated flights and taxes/fees. (Example estimate: a 25,000-mile award would save 3,750 miles; at ~1.2\u00a2/mile that\u2019s about $45 in value.)",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$100 Delta Stays statement credit (annual)",
      "description": "Receive up to $100 in statement credits each year after using the Card to book prepaid hotels or vacation rentals through Delta Stays on delta.com. Estimated value: up to $100 yearly with eligible bookings.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "First checked bag free on Delta flights",
      "description": "Check your first bag free on Delta flights. Amex cites savings up to $70 on a round-trip per person (up to $280 for a family of four).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "20% back on eligible Delta in\u2011flight purchases",
      "description": "Get 20% back in the form of a statement credit on eligible Delta in\u2011flight purchases of food and beverages when you pay with the Card. Estimated value: 20% of eligible in\u2011flight spend.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 70,000 bonus miles after spending $3,000 in purchases in the first 6 months. Plus earn 20,000 bonus miles after spending an additional $2,000 in the first 6 months.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 70000.0,
          "value_unit": "miles",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    },
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 20,000 additional bonus miles after spending $2,000 more in the first 6 months.",
      "rewards": [
        {
          "reward_type": "delta",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-gold-american-express-card/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-gold-american-express-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "delta_skymiles_gold_american_express_card.png"
},
  [CreditCard.WILLIAMS_SONOMA_KEY_REWARDS_VISA]: {
  "id": CreditCard.WILLIAMS_SONOMA_KEY_REWARDS_VISA,
  "name": "Williams Sonoma Key Rewards\u00ae Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/ws_ca_cb_rgb_card_art.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 10.0,
      "description": "New cardmembers earn 10% back in rewards on purchases made at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham during the first 30 days from account opening (online and in stores). Excludes GreenRow. Rewards are not earned on promotional financing purchases. Some customers may not be eligible for same\u2011day purchases until authentication is completed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 10.0,
      "description": "New cardmembers earn 10% back in rewards on purchases made at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham during the first 30 days from account opening (online and in stores). Excludes GreenRow. Rewards are not earned on promotional financing purchases. Some customers may not be eligible for same\u2011day purchases until authentication is completed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 5.0,
      "description": "5% back in rewards at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham (online and in stores). Excludes GreenRow. Rewards are not earned on promotional financing purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 5.0,
      "description": "5% back in rewards at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham (online and in stores). Excludes GreenRow. Rewards are not earned on promotional financing purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 4.0,
      "description": "4% back in rewards at grocery stores, restaurants (including fast food), and food delivery services. Grocery purchases made at gas stations, convenience stores, warehouse clubs, discount stores, and super stores (or at grocery stores associated with discount or super stores) earn 1% back. Earnings are determined by the merchant category code (MCC) used by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4% back in rewards at grocery stores, restaurants (including fast food), and food delivery services. Grocery purchases made at gas stations, convenience stores, warehouse clubs, discount stores, and super stores (or at grocery stores associated with discount or super stores) earn 1% back. Earnings are determined by the merchant category code (MCC) used by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 4.0,
      "description": "4% back in rewards at grocery stores, restaurants (including fast food), and food delivery services. Grocery purchases made at gas stations, convenience stores, warehouse clubs, discount stores, and super stores (or at grocery stores associated with discount or super stores) earn 1% back. Earnings are determined by the merchant category code (MCC) used by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back in rewards on all other purchases anywhere Visa is accepted. Earnings are determined by the merchant category code (MCC) used by the merchant. Rewards are not earned on promotional financing purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2924,
    "apr_low": 0.2924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2924,
    "high": 0.2924,
    "description": "Purchase APR: 29.24% variable; Balance Transfer APR: 29.24% variable; Cash Advance APR: 29.24% variable. 12-month zero-interest promotional financing with equal payments on qualifying purchases of $750+ at participating brands; if not paid in full after 12 months, the standard variable purchase APR applies to the remaining balance. Cash advance fee: $5 or 5% of each cash advance, whichever is greater. Balance transfer fee: 3% of each transfer that posts at a promotional APR."
  },
  "benefits": [
    {
      "name": "$25 birthday reward",
      "description": "Receive a $25 Birthday rewards certificate during your birthday month when your account has a valid email and U.S. mailing address, is open and current, and you have made at least one purchase in the 12 months before your birthday month. One certificate per 12 months; must be redeemed within 30 days. New accounts opened in your birthday month are eligible starting with the next calendar year. Estimated value: $25 per year if conditions are met.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free standard shipping at Williams Sonoma brands",
      "description": "Free standard shipping within the contiguous 48 states on eligible purchases ($0.01+) in-store or online at participating Williams Sonoma, Inc. brands when you pay with your Key Rewards Visa. Not available when Rewards cover the entire order, or when paying via digital wallets or third\u2011party payment solutions. Estimated value: typically saves ~$7\u2013$15 per order, depending on order size and destination.",
      "benefit_type": null,
      "new_benefit_type": "free_standard_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "12-month promotional financing on $750+ at WS family brands",
      "description": "Opt into zero interest with 12 equal monthly payments on qualifying purchases of $750 or more (excluding shipping and tax) at Williams Sonoma, Pottery Barn, West Elm, Rejuvenation, Mark & Graham, etc. Account must be open and current. Rewards are not earned on promotional financing purchases. If not paid in full after 12 months, the standard variable purchase APR (29.24% at time of disclosure) applies to the remaining balance. Purchases via third\u2011party payment accounts or digital wallets are not eligible. Estimated value: avoids interest; for a $750 purchase otherwise carried for 12 months at ~29.24% APR with equal payments, interest saved is roughly ~$110 (approximation using average-balance method).",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing",
      "spend_requirement": 750,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to sales and events",
      "description": "Cardmembers may receive early access to sales and events at Williams Sonoma family brands. Details may vary by event.",
      "benefit_type": null,
      "new_benefit_type": "early_access_sales_and_events",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Welcome bonus: 10% back in rewards on Net Eligible purchases at Williams Sonoma, Williams Sonoma Home, Pottery Barn (including Kids & Teen), West Elm, Rejuvenation, and Mark & Graham during the first 30 days from account opening (5% thereafter). No stated minimum spend; earnings depend on how much you spend at participating brands during the 30-day window. Estimated value: 10% of your brand spend in the first 30 days; incremental value vs. the ongoing 5% rate is an extra 5%. Example: $500 in brand purchases \u2192 $50 rewards (incremental +$25 over ongoing 5%). Excludes GreenRow; rewards follow merchant category coding rules.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "bonus_rewards_rate",
          "amount": 10.0,
          "value_unit": "percent_back"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/williams-sonoma/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/williams-sonoma/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "williams_sonoma_key_rewards_visa.png"
},
  [CreditCard.HARRIS_TEETER_REWARDS_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.HARRIS_TEETER_REWARDS_WORLD_ELITE_MASTERCARD,
  "name": "Harris Teeter Rewards World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.htmastercard.com/credit/mc_harris_teeter/images/hero-xs.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases.mobileWallet",
      "earnRate": 5.0,
      "description": "Earn 5% on mobile wallet transactions on the first $3,000 per calendar year, then 1% thereafter, regardless of where the purchase is made (including Harris Teeter locations). Mobile wallet transactions at Harris Teeter Fuel Centers do not earn rewards. The issuer may determine eligibility if a transaction could qualify for multiple categories.",
      "spendCap": 3000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 3.0,
      "description": "Earn 3% on dining and fuel purchases (including Mobile Pay within the Harris Teeter App at Harris Teeter Fuel Centers) on the first $6,000 per calendar year; 1% thereafter. Note: Mobile wallet transactions at Harris Teeter Fuel Centers do not earn rewards.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "dining",
          "gas"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Dining and fuel station purchases, plus Mobile Pay within the Harris Teeter App at Harris Teeter Fuel Centers, share a combined calendar-year cap.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Base earn rate for purchases that do not qualify for higher category rates; marketing describes this as 1% outside of Harris Teeter stores. Dining and fuel categories earn 3% up to the combined cap; Harris Teeter in-store purchases earn 2%; certain mobile wallet transactions have separate caps and rates.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn $100 statement credit after $500 in net purchases within 90 days of account opening. New cardmembers only; limited-time offer. Statement credit posts in 6\u20138 weeks; account must be open and in good standing.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "New cardmember HT Plus bundle: After approval and completing HT Plus enrollment, get 2x Fuel Points on qualifying Harris Teeter in-store, curbside pickup, and delivery purchases, plus a free Next-Day HT Plus membership (or a $69 waiver toward the $99 Same-Day membership). One free membership per household; enrollment with payment info required; membership auto-renews unless canceled; exclusions apply.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "fuel_points",
          "category": "grocery",
          "category_description": "2x Fuel Points on qualifying Harris Teeter in-store, curbside pickup, and delivery purchases after HT Plus enrollment; excludes gift cards, adult beverage, tobacco products, pharmacy prescriptions, Ship, Vitacost, homechef.com, murrayscheese.com, and fuel purchases. Note: Harris Teeter fuel program typically awards 1 Fuel Point per $1; 100 points often = $0.10/gal discount (value varies by redemption and gallons)."
        },
        {
          "reward_type": null,
          "new_reward_type": "free_membership",
          "amount": 69.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": "One free year of HT Plus Next-Day membership (normally $69/year) OR a $69 waiver toward the $99/year Same-Day membership upon enrollment. If the credit card is closed and membership not canceled before period end, the annual fee may be charged."
        }
      ]
    }
  ],
  "apply_link": "https://www.htmastercard.com/",
  "learn_more_link": "https://www.htmastercard.com/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "harris_teeter_rewards_world_elite_mastercard.png"
},
  [CreditCard.CAPITAL_ONE_B_JS_ONE_MASTERCARD]: {
  "id": CreditCard.CAPITAL_ONE_B_JS_ONE_MASTERCARD,
  "name": "BJ\u2019s One\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/www-bj-one-mc-240x151.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5% back in rewards on purchases made outside of BJ\u2019s everywhere Mastercard is accepted. Excludes purchases at BJ\u2019s clubs, BJ\u2019s Gas, BJs.com, BJ\u2019s app, and BJ\u2019s B2B/Global Sales (these are considered BJ\u2019s purchases and are not \u2018outside of BJ\u2019s\u2019). No cap on earnings; rewards do not expire while the account is open. Redemption requires a minimum rewards balance of $10.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "Variable purchase APR of 19.24% or 29.24% based on creditworthiness and the Prime Rate; variable rates may change when the Prime Rate changes."
  },
  "benefits": [
    {
      "name": "BJ\u2019s Gas discount",
      "description": "Save 10\u00a2 per gallon at BJ\u2019s Gas when you pay with the BJ\u2019s One Mastercard and scan your membership card. Discount is applied per gallon at purchase; BJ\u2019s Gas transactions do not earn rewards. Estimated value: a typical driver using ~480 gallons/year (12,000 miles at 25 MPG) would save about $48/year. Subject to state restrictions (e.g., MD, NJ discount applied after sale, before payment). Requires active BJ\u2019s membership.",
      "benefit_type": null,
      "new_benefit_type": "gas_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rewards never expire (while account open)",
      "description": "Rewards are yours for the life of the account and will not expire as long as the account remains open. Minimum balance of $10 in rewards required to redeem; minimum eligible purchase amount at BJ\u2019s checkout is $10. Exclusions apply (e.g., alcohol, tobacco, gift cards, BJ\u2019s Gas, membership fees, certain services and taxes).",
      "benefit_type": null,
      "new_benefit_type": "rewards_never_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/bjs-wholesale-club/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/bjs-wholesale-club/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "capital_one_b_js_one_mastercard.avif"
},
  [CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS]: {
  "id": CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS,
  "name": "Bank of America\u00ae Travel Rewards Credit Card for Students",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8blm_trvsigcm_v_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.BANK_OF_AMERICA_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "3x points on eligible travel purchases made through the Bank of America Travel Center. Balance transfers, cash advances, fees, interest, and fraudulent transactions do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 4.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 5.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5 points per $1 on all purchases everywhere, every time. Points do not expire while the account remains open. Balance transfers, cash advances, fees, interest, and fraudulent transactions do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "Intro APR: 0.0 for purchases for the first 15 billing cycles. Balance transfers made within 60 days of account opening also receive 0.0 for the first 15 billing cycles. After the intro period, the variable purchase and balance transfer APR is 0.1824\u20130.2824 based on creditworthiness and the Prime Rate. Cash advance APR: 0.2124\u20130.2924 for Direct Deposit and Check Cash Advances; 0.2924 for Bank Cash Advances. Penalty APR up to 0.2999 may apply indefinitely if you make a late payment. Grace period: at least 25 days; no interest on purchases if you pay your entire balance or Interest Saving Balance by the due date each month. Balance transfers and cash advances accrue interest from the transaction date. Monthly Custom Pay Plan Fee: 1.72% of the amount assigned to a plan."
  },
  "benefits": [
    {
      "name": "Preferred Rewards bonus",
      "description": "If you\u2019re enrolled in Bank of America Preferred Rewards, you earn 25%\u201375% more points on every purchase.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "25,000 bonus points after $1,000 in purchases within the first 90 days of account opening. Estimated value: about $250 when redeemed as a travel or dining statement credit at 1.0\u00a2/point (per terms: 2,500 points = $25), or about $150 if redeemed for cash at 0.6\u00a2/point. Purchases that qualify exclude balance transfers and cash advances; returns/credits reduce qualifying spend. Limit 1 per new account; account must be open to receive the bonus.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 25000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076503&productoffercode=KP&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/student-rewards-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076503&productoffercode=KP&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Travel Rewards Credit Card for Students",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_travel_rewards_for_students.png"
},
  [CreditCard.SYNCHRONY_SEWING_MORE_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_SEWING_MORE_CREDIT_CARD,
  "name": "Synchrony Sewing & More\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.sewingandmore.synchrony365.com/mysyf/img/sew_card_2100x1344_051623.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3499,
    "apr_low": 0.3499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3499,
    "high": 0.3499,
    "description": "For new accounts as of 07/31/25: Purchase APR 34.99%. Penalty APR 39.99%. Minimum interest charge $2. Special financing: No Interest if Paid in Full within 6 months on qualifying purchases of $150+; if not paid in full, interest is charged from the purchase date."
  },
  "benefits": [
    {
      "name": "6-month promotional financing on $150+ purchases",
      "description": "No Interest if Paid in Full Within 6 Months on single\u2011receipt qualifying purchases of $150+ made with the Sewing & More Credit Card. Interest accrues from the purchase date if the promo balance isn\u2019t paid in full within 6 months. Minimum monthly payments required. Available every day; additional options may be available at participating retailers. Subject to credit approval.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": 150,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No annual fee",
      "description": "No annual fee on the Sewing & More Credit Card. (As of 07/31/25: Purchase APR 34.99%, Penalty APR 39.99%, Minimum interest charge $2; see terms.)",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 fraud liability",
      "description": "Cardholders are not responsible for unauthorized charges made with the card.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Exclusive offers and partner deals",
      "description": "Access to exclusive offers and deals from participating Sewing & More network merchants; availability varies by retailer.",
      "benefit_type": null,
      "new_benefit_type": "merchant_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.sewingandmore.synchrony365.com/?intcmp=NoOff_SynchronySewing&MoreCreditCard_credit%20cards_body-catalog-cards_synchrony_int",
  "learn_more_link": "https://www.sewingandmore.synchrony365.com/?intcmp=NoOff_SynchronySewing&MoreCreditCard_credit%20cards_body-catalog-cards_synchrony_int",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?mid=5348120510901507&pcgc=WS00&preQual=Y&sitecode=sva000d11&intcmp=NoOff_mysynchrony_body-find-service_apply_int"
    },
    {
      "name": "Find a location",
      "url": "https://www.synchrony.com/marketplace/locations?category=Sewing"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_sewing_more_credit_card.png"
},
  [CreditCard.INK_BUSINESS_PREMIER_CREDIT_CARD]: {
  "id": CreditCard.INK_BUSINESS_PREMIER_CREDIT_CARD,
  "name": "Ink Business Premier\u00ae Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/ink_business_premier_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "Earn 5% total on travel purchases made using your card through Chase Travel. Only the portion paid with the card qualifies. No rewards on balance transfers, cash advances or cash-like transactions, lottery tickets, casino chips, race track wagers, checks that access the account, interest, unauthorized charges, or fees.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.5,
      "description": "Earn 2.5% total (0.5% additional on top of base 2%) on any single purchase of $5,000 or more. Excludes non-purchase transactions such as balance transfers, cash advances and cash-like transactions, lottery tickets, casino chips, race track wagers, checks that access the account, interest, unauthorized or fraudulent charges, and fees.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": 5000.0,
      "conditionalTags": [
        "single_purchase_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Earn 2% Cash Back rewards on all other purchases. Excludes balance transfers, cash advances and cash-like transactions, lottery tickets, casino gaming chips, race track wagers, checks that access the account, interest, unauthorized or fraudulent charges, and fees.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 195.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2649,
    "apr_low": 0.1849
  },
  "annualFee": 195.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1849,
    "high": 0.2649,
    "description": "Flex for Business variable APR: 18.49%-26.49% based on creditworthiness; varies with the Prime Rate (Prime + 10.99% to 18.99%; maximum 29.99%). Grace period minimum 20 days; no minimum interest charge. Pay in Full balance must be paid each month; interest applies only to Flex for Business balances."
  },
  "benefits": [
    {
      "name": "Primary Auto Rental Collision Damage Waiver",
      "description": "Primary CDW when renting for business purposes and the entire rental is charged to the card; reimbursement up to $60,000 for theft and collision damage for most rental vehicles with an MSRP of $125,000 or less. Decline the rental company\u2019s collision insurance to be covered. Restrictions and exclusions apply; see Guide to Benefits.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance",
      "description": "Provides legal and medical referrals and access to other travel and emergency assistance services while away from home. Cardholder is responsible for the cost of any goods or services obtained.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance",
      "description": "Access to dispatch for roadside help; service fees are billed to your card at time of dispatch. Not a complimentary tow/coverage benefit; pay-per-use terms apply.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days from purchase against damage or theft, up to $10,000 per item. New York residents: 90-day coverage period. Limits, exclusions, and claim deadlines apply; see Guide to Benefits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years total from purchase). Limits and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "When you pay your monthly cell phone bill with the card, get up to $1,000 per claim for covered theft or damage; maximum of 3 claims in a 12\u2011month period with a $100 deductible per claim. Terms and exclusions apply.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Employee Cards",
      "description": "Add employee cards at no additional cost, set individual spending limits, and earn rewards on employee spending. The authorizing officer and the business are liable for all charges.",
      "benefit_type": null,
      "new_benefit_type": "free_employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "0% foreign transaction fees on international purchases. Estimated value: saves about 3% compared to common cards that charge a 3% foreign transaction fee (actual savings depend on your foreign spend).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Refer\u2011a\u2011Business Bonus",
      "description": "Earn 20,000 bonus points for each business you refer that\u2019s approved for any Chase for Business credit card, up to 100,000 points per year. Availability and terms can vary; check current Refer\u2011A\u2011Friend offer details.",
      "benefit_type": null,
      "new_benefit_type": "refer_a_friend",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 10000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 100,000 points (redeemable as $1,000 cash back at 1\u00a2/point) after $10,000 in purchases in the first 3 months from account opening. Excludes balance transfers, cash advances and cash\u2011like transactions, fees, and certain other ineligible purchases. Allow 6\u20138 weeks for points to post; account must be open and not in default at fulfillment.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 1000.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=GQ5X&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/ink/premier?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC53051.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program and Agreement (PDF)",
      "url": "https://www.chase.com/inkbusinessPremier/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "ink_business_premier_credit_card.png"
},
  [CreditCard.HILTON_HONORS_BUSINESS_CARD]: {
  "id": CreditCard.HILTON_HONORS_BUSINESS_CARD,
  "name": "Hilton Honors American Express Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/hilton-honors.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.HILTON,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.hilton",
      "earnRate": 12.0,
      "description": "12X Hilton Honors Bonus Points per dollar for eligible purchases made directly with hotels and resorts within the Hilton portfolio. Third-party bookings (e.g., online travel agencies) are not eligible. Incidental charges at Hilton properties must be charged to your room and paid with the Card at checkout to qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 5.0,
      "description": "5X Hilton Honors Bonus Points on the first $100,000 in eligible non\u2011Hilton purchases each calendar year. Eligible purchases exclude fees, interest, cash equivalents, and third\u2011party payment wallets as described in terms. 3X thereafter.",
      "spendCap": 100000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "Base earn rate of 3X Hilton Honors Points on eligible non\u2011Hilton purchases after the $100,000 annual cap for 5X is reached (Hilton purchases earn 12X).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 195.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 195.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable purchase APR 19.99%\u201328.99% based on creditworthiness; varies with the Prime Rate (will not exceed 29.99%). Cash advance APR 29.24% variable. Penalty APR 29.99% may apply in certain circumstances."
  },
  "benefits": [
    {
      "name": "$240 Hilton Credit",
      "description": "Up to $60 back in statement credits each calendar quarter (up to $240 per year) for eligible purchases made directly with properties in the Hilton portfolio, including bookings made through Hilton channels and incidentals charged to the room and paid with this card. Estimated value: up to $240/yr if fully utilized.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Hilton Honors Gold Status",
      "description": "Automatic Hilton Honors Gold status for the Basic Card Member (allow up to 12 weeks after account opening). Includes benefits like 80% bonus on Base Points, space-available room upgrades at select properties, and more. Estimated value varies by travel patterns (~$150\u2013$300+/yr for frequent Hilton stays).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Upgrade to Hilton Honors Diamond Status (with spend)",
      "description": "Earn Hilton Honors Diamond status through the end of the next calendar year after $40,000 in eligible purchases on the card in a calendar year (additional cardmember spend counts; status applies to Basic Card Member). Estimated incremental value over Gold can be substantial for frequent Hilton travelers.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary National Car Rental Emerald Club Executive Status",
      "description": "Enroll through your Amex online account to receive National Emerald Club Executive status, which can include Executive Area access (for full-size reservations and above) at participating US and Canada locations. Terms and enrollment required.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "American Express will not charge foreign transaction fees on purchases made outside the United States with this card.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance (Secondary)",
      "description": "Coverage for damage or theft of a rental vehicle when you pay with the card (subject to terms, conditions, and exclusions). Typically secondary to other coverage.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage for lost, damaged, or stolen baggage when travel is purchased with the card (subject to terms, conditions, and exclusions).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Coverage for eligible purchases against accidental damage or theft for a limited time after purchase (subject to terms, conditions, and exclusions).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original manufacturer\u2019s warranty on eligible items purchased with the card (subject to terms, conditions, and exclusions).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "Access to 24/7 coordination and assistance services when traveling; third-party service costs are the cardmember\u2019s responsibility. Useful for emergency assistance while abroad.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Concessions Credit (enrollment required)",
      "description": "Earn 10% back as a statement credit on qualifying food & beverage concessions purchases at venues in the Amex Venue Collection, up to $250 back per calendar year on the enrolled card. Offer currently ends 12/31/2026; terms apply. Estimated value: up to $250/yr if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "credit_type": "american_express_venue_collection_concessions",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Entrances and Fast Lanes",
      "description": "Access dedicated Amex entrances/fast lanes at participating venues in the Amex Venue Collection when you present a valid Amex card and event ticket; availability varies by venue/event.",
      "benefit_type": null,
      "new_benefit_type": "amex_venue_collection_entrances_fast_lanes",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Presale Tickets",
      "description": "Access to purchase presale tickets for select events and seats when paying with an Amex card; availability varies and terms apply.",
      "benefit_type": null,
      "new_benefit_type": "amex_presale_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Reserved Tickets",
      "description": "Access to reserved tickets for select events and seats when paying with an Amex card; availability varies and terms apply.",
      "benefit_type": null,
      "new_benefit_type": "amex_reserved_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you book a qualifying hotel on AmexTravel.com or the Amex Travel app and find the same room at a lower public price online, Amex will refund the difference (subject to detailed terms and exclusions).",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rates_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$240 Hilton Credit",
      "description": "Up to $60 per quarter (up to $240/yr) in statement credits for eligible purchases charged directly with Hilton properties when booked through Hilton channels; incidentals must be charged to the room and paid with this card.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 240.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY
    },
    {
      "name": "Amex Venue Collection Concessions Credit (enrollment required)",
      "description": "10% back as a statement credit on qualifying concessions at participating Venue Collection stadiums/arenas, up to $250 per calendar year on the enrolled card; offer currently ends 12/31/2026.",
      "credit_category": "entertainment",
      "new_credit_category": null,
      "value": 250.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 130,000 Hilton Honors Bonus Points after you spend $6,000 on eligible purchases in the first 6 months of Card Membership. Points post 8\u201312 weeks after meeting the threshold. Prior or current cardholders may be ineligible per Amex\u2019s welcome offer rules; additional card members are not eligible to receive the offer. Bonus points do not count toward elite tier qualification. Estimated value: roughly $520\u2013$780 assuming ~0.4\u20130.6 cents per Hilton point.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 130000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/hilton-honors/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Hilton",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/hilton-honors/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Hilton",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/hilton-honors-american-express-business-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/hilton-honors-american-express-business-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "hilton_honors_business_card.png"
},
  [CreditCard.DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD,
  "name": "Delta SkyMiles\u00ae Blue American Express Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000267_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.DELTA,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2X miles on dining purchases at restaurants in the U.S., including takeout and delivery.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.delta",
      "earnRate": 2.0,
      "description": "2X miles on Delta purchases made directly with Delta.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X mile on all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "20% Back on In\u2011flight Purchases",
      "description": "Receive a 20% savings as a statement credit after using the card on eligible Delta in\u2011flight purchases of food and beverages.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees when making purchases abroad with the Delta SkyMiles Blue American Express Card.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Pay with Miles",
      "description": "Exclusive to Delta SkyMiles American Express Card Members: redeem miles toward Delta tickets at booking on delta.com. Get up to $50 off per 5,000 miles redeemed (1 cent per mile) in 5,000\u2011mile increments.",
      "benefit_type": null,
      "new_benefit_type": "pay_with_miles",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Events with Amex",
      "description": "Access select ticket presales, special ticket allotments (while supplies last), Amex Fan Experiences, and select event offers.",
      "benefit_type": null,
      "new_benefit_type": "amex_experiences_presales",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "20% In\u2011flight Savings (Statement Credit)",
      "description": "Get 20% back as a statement credit on eligible food and beverage purchases made in\u2011flight on Delta when using the card.",
      "credit_type": "in_flight_purchases_statement_credit",
      "credit_category": "travel.airline.delta",
      "new_credit_category": null,
      "value": 20.0,
      "value_unit": "percent",
      "value_unit_schedule": null,
      "total_yearly_value": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "statement_credit_percentage_back": 20.0,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 10,000 Bonus Miles after spending $1,000 in purchases on your new Card in your first 6 months of Card Membership. Amex may determine you are not eligible for a welcome offer and will notify you prior to processing, giving you the option to withdraw. Estimated value \u2248 $100 at 1.0\u00a2/mile to ~$120 at 1.2\u00a2/mile (typical SkyMiles valuation range).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-blue-american-express-card/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-blue-american-express-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/delta-skymiles-blue-american-express-card/36182-10-0"
    }
  ],
  "bank_name": "American Express",
  "imageName": "delta_skymiles_blue_american_express_card.webp"
},
  [CreditCard.QUICKSILVER_SECURED_REWARDS]: {
  "id": CreditCard.QUICKSILVER_SECURED_REWARDS,
  "name": "Quicksilver Secured from Capital One",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/quicksilver_cardart.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5% cash back on all purchases. No additional categories, portals, or caps disclosed on the page.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Reports to all three credit bureaus",
      "description": "Your card status is regularly reported to Experian, Equifax and TransUnion to help build credit with responsible use.",
      "benefit_type": null,
      "new_benefit_type": "credit_bureau_reporting",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Path to unsecured card and refundable deposit",
      "description": "With responsible use (e.g., on-time payments), you could earn back your security deposit as a statement credit and upgrade to an unsecured Quicksilver card; deposit is also refunded when you close the account and pay the balance in full.",
      "benefit_type": null,
      "new_benefit_type": "upgrade_path_to_unsecured",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Potential credit limit increase",
      "description": "Raise your initial credit line by depositing more than the $200 minimum before activation (up to a maximum). Upon approval, maximum credit limit is assigned in the $1,000\u2013$3,000 range based on creditworthiness.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/quicksilver-secured/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/quicksilver-secured/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "quicksilver_secured_rewards.png"
},
  [CreditCard.SHOP_YOUR_WAY_MASTERCARD]: {
  "id": CreditCard.SHOP_YOUR_WAY_MASTERCARD,
  "name": "Citi ThankYou\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/shop_your_way_mastercard.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5X ThankYou Points on gas station purchases for the first $10,000 in gas station purchases per year, then 1X. Does not include fuel purchased at superstores, supermarkets, grocery stores, convenience stores, or warehouse clubs.",
      "spendCap": 10000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3X ThankYou Points on restaurant and grocery store purchases for the first $10,000 in combined restaurant and grocery store purchases per year, then 1X. Does not include restaurants inside other establishments, superstores, convenience stores, or warehouse clubs.",
      "spendCap": 10000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3X ThankYou Points on restaurant and grocery store purchases for the first $10,000 in combined restaurant and grocery store purchases per year, then 1X. Does not include restaurants inside other establishments, superstores, convenience stores, or warehouse clubs.",
      "spendCap": 10000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "department_store",
      "earnRate": 2.0,
      "description": "2X ThankYou Points on department store and drugstore purchases for the first $10,000 in combined department store and drugstore purchases per year, then 1X. Does not include warehouse clubs, superstores, supermarkets, or discount stores.",
      "spendCap": 10000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "drugstore",
      "earnRate": 2.0,
      "description": "2X ThankYou Points on department store and drugstore purchases for the first $10,000 in combined department store and drugstore purchases per year, then 1X. Does not include warehouse clubs, superstores, supermarkets, or discount stores.",
      "spendCap": 10000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X ThankYou Points on all other purchases, including purchases once category spending limits have been reached.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Citi ThankYou Rewards Redemption",
      "description": "Redeem ThankYou Points for gift cards to major brands, travel bookings through Citi Travel, or Shop with Points at participating partners online and in-store.",
      "benefit_type": null,
      "new_benefit_type": "flexible_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": null,
  "learn_more_link": "https://citicards.citi.com/crs/CitiThankYou/Benefits/info/default.htm",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Citi",
  "imageName": "shop_your_way_mastercard.png"
},
  [CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD]: {
  "id": CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD,
  "name": "Business Advantage Unlimited Cash Rewards Mastercard\u00ae Secured credit card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_cshbuscm_mc_sky-CSX944967d2.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5% cash back on every purchase. No annual cap; rewards don\u2019t expire while the account remains open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2749,
    "apr_low": 0.2749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2749,
    "high": 0.2749,
    "description": "No introductory APR; standard purchase APR is 27.49% variable."
  },
  "benefits": [
    {
      "name": "Travel accident insurance",
      "description": "$100,000 in travel accident insurance when traveling; terms apply.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto rental car insurance (CDW)",
      "description": "Coverage for collision/damage on eligible car rentals; terms apply. Card page does not specify primary vs. secondary\u2014most Mastercard coverage is secondary in the U.S., so treated as secondary.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Coverage for eligible purchases against loss, damage, theft, or fire; terms apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Extends the manufacturer\u2019s warranty on eligible purchases; terms apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and emergency assistance",
      "description": "Travel assistance services including emergency ticket replacement, lost-luggage assistance, and legal/medical referrals (assistance services; not insurance).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Potential transition to an unsecured card",
      "description": "Bank of America will periodically review the account; if overall credit history improves, you may be transitioned to an unsecured card (not guaranteed).",
      "benefit_type": null,
      "new_benefit_type": "possible_transition_to_unsecured_card",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/unlimited-cash-rewards-secured-business-credit-card/?campaign=4065324~9G~en_US",
  "learn_more_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/unlimited-cash-rewards-secured-business-credit-card/?campaign=4065324~9G~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/#rates-fees-4065324~9G~en_US",
  "terms_and_conditions_button_text": "Interest Rates & Fees Summary\u2020",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "business_advantage_unlimited_cash_rewards_mastercard_secured_credit_card.png"
},
  [CreditCard.WYNDHAM_REWARDS_EARNER_PLUS_CARD]: {
  "id": CreditCard.WYNDHAM_REWARDS_EARNER_PLUS_CARD,
  "name": "Wyndham Rewards Earner\u00ae Plus Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/WYF_card_rRGB_EarnerPlus_VS_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.WYNDHAM,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.wyndham",
      "earnRate": 6.0,
      "description": "6x points per $1 on eligible purchases made at Hotels by Wyndham.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 6.0,
      "description": "6x points per $1 on qualifying gas purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4x points per $1 on eligible dining purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 4.0,
      "description": "4x points per $1 on eligible grocery store purchases; excludes Target and Walmart.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases; excludes Wyndham Timeshare resort down payments. No limit to the number of points you can earn.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 75.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.1999
  },
  "annualFee": 75.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2999,
    "description": "Variable purchase APR 19.99%\u201329.99% based on creditworthiness; varies with the Prime Rate. 0% promotional APR for 6 billing cycles on Wyndham Timeshare Purchases, then the standard purchase APR applies. Cash advance APR 29.99% variable. Minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "7,500 anniversary bonus points",
      "description": "Receive 7,500 bonus points each anniversary year\u2014enough for up to one free night at participating properties (lowest-tier 7,500-point hotels). Resort fees may apply and cannot be paid with points.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Wyndham Rewards Platinum status",
      "description": "Automatic Wyndham Rewards Platinum member level with perks like early check-in and car rental upgrades (see Wyndham Rewards member level details for full benefits).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% fewer points on award nights",
      "description": "Redeem 10% fewer Wyndham Rewards points when you book free nights at participating properties.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember hotel rate discount",
      "description": "Cardmembers can save on the Standard Rate at participating Hotels by Wyndham.",
      "benefit_type": null,
      "new_benefit_type": "hotel_rate_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Intro offer after spending $1,000 in the first 90 days; marketed as \u201cenough for up to 6 free nights.\u201d Estimated as ~45,000 Wyndham points based on the 7,500-point low-tier award level. Free night availability varies; resort fees may apply and cannot be paid with points.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 45000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-plus-card/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-plus-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "wyndham_rewards_earner_plus_card.png"
},
  [CreditCard.DUCKS_UNLIMITED_REWARDS_VISA]: {
  "id": CreditCard.DUCKS_UNLIMITED_REWARDS_VISA,
  "name": "Ducks Unlimited Rewards Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/ducks_unlimited_rewards_visa.jpeg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5% back on everyday purchases (no cap).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Earn a one-time $35 statement credit after your first purchase within the first 3 billing cycles after account opening (intended to cover Ducks Unlimited membership). Offer may vary by application channel and requires applying via the provided link.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 35.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": "$35 statement credit after first purchase to cover Ducks Unlimited membership"
        }
      ]
    }
  ],
  "apply_link": "https://www.card.fnbo.com/landing/ducksunlimited/visa-platinum",
  "learn_more_link": "https://www.card.fnbo.com/landing/ducksunlimited/visa-platinum",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "FNBO",
  "imageName": "ducks_unlimited_rewards_visa.jpeg"
},
  [CreditCard.BASS_PRO_SHOPS_CLUB_CARD]: {
  "id": CreditCard.BASS_PRO_SHOPS_CLUB_CARD,
  "name": "Bass Pro Shops CLUB Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/bass_pro_cardart.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "sportingGoods.bassProAndCabelas",
      "earnRate": 2.0,
      "description": "Classic tier earn rate on purchases at Bass Pro Shops and Cabela\u2019s (in-store, online, by phone, and signature events). Points do not expire on open accounts and have no stated earning cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "sportingGoods.bassProAndCabelas",
      "earnRate": 3.0,
      "description": "Silver tier earn rate on purchases at Bass Pro Shops and Cabela\u2019s (in-store, online, by phone, and signature events).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "sportingGoods.bassProAndCabelas",
      "earnRate": 5.0,
      "description": "Black tier earn rate on purchases at Bass Pro Shops and Cabela\u2019s (in-store, online, by phone, and signature events).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% in CLUB Points on purchases everywhere else Mastercard is accepted (excludes Bass Pro Shops and Cabela\u2019s purchases, which earn at the applicable tier rate).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Exclusive CLUB member retail perks",
      "description": "Access to in-store events, extra point promotions and discounts, exclusive CLUB member pricing, and giveaways at Bass Pro Shops and Cabela\u2019s.",
      "benefit_type": null,
      "new_benefit_type": "retail_member_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Exclusive access to outdoor experiences",
      "description": "CLUB Members get access to world-class hunting and fishing experiences around the world.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_experiences_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Retail price match plus 5% for CLUB Members",
      "description": "Bass Pro Shops and Cabela\u2019s will beat a qualifying local or website price by 5% for CLUB Members (retailer policy; see basspro.com/club for details).",
      "benefit_type": null,
      "new_benefit_type": "retailer_price_match_plus_5_percent",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "CLUB Points do not expire (while account is open)",
      "description": "Points never expire as long as the account remains open; redeemable at Bass Pro Shops and Cabela\u2019s.",
      "benefit_type": null,
      "new_benefit_type": "points_never_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Special financing rate at Bass Pro Shops and Cabela\u2019s",
      "description": "Purchases made with Bass Pro Shops and Cabela\u2019s qualify for a 9.99% APR (in-store, online, phone, and Signature Events).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_at_bass_pro_and_cabelas",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Earn up to $50 in CLUB Points: (1) $20 in CLUB Points upon approval; (2) $10 in CLUB Points after 2 Bass Pro Shops or Cabela\u2019s purchases within 30 days of account approval; (3) $20 in CLUB Points after 5 purchases everywhere else Mastercard is accepted within 30 days of account approval. Estimated points: assuming the common CLUB conversion of 100 points = $1, these correspond to ~2,000 + 1,000 + 2,000 = 5,000 points total (~$50 value) redeemable at Bass Pro Shops/Cabela\u2019s. Conditions are purchase count- and merchant-based rather than dollar spend.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 2000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 1,
      "description": "Earn up to $50 in CLUB Points: (1) $20 in CLUB Points upon approval; (2) $10 in CLUB Points after 2 Bass Pro Shops or Cabela\u2019s purchases within 30 days of account approval; (3) $20 in CLUB Points after 5 purchases everywhere else Mastercard is accepted within 30 days of account approval. Estimated points: assuming the common CLUB conversion of 100 points = $1, these correspond to ~2,000 + 1,000 + 2,000 = 5,000 points total (~$50 value) redeemable at Bass Pro Shops/Cabela\u2019s. Conditions are purchase count- and merchant-based rather than dollar spend.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 1000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 1,
      "description": "Earn up to $50 in CLUB Points: (1) $20 in CLUB Points upon approval; (2) $10 in CLUB Points after 2 Bass Pro Shops or Cabela\u2019s purchases within 30 days of account approval; (3) $20 in CLUB Points after 5 purchases everywhere else Mastercard is accepted within 30 days of account approval. Estimated points: assuming the common CLUB conversion of 100 points = $1, these correspond to ~2,000 + 1,000 + 2,000 = 5,000 points total (~$50 value) redeemable at Bass Pro Shops/Cabela\u2019s. Conditions are purchase count- and merchant-based rather than dollar spend.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 2000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/bass-pro-shops/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/bass-pro-shops/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "bass_pro_shops_club_card.png"
},
  [CreditCard.GOLDMAN_SACHS_MY_GM_REWARDS_MASTERCARD]: {
  "id": CreditCard.GOLDMAN_SACHS_MY_GM_REWARDS_MASTERCARD,
  "name": "My GM Rewards\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.marcus.com/us/en/credit-cards/gm-cards/_jcr_content/root/responsivegrid_1357540861/responsivegrid_gener_694162966/responsivegrid_gener_56754636/core_image.coreimg.82.360.png/1741263592668/group26231550.png",
  "recommendedMinCreditScore": null,
  "availability": "no_new_applicants",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 4.0,
      "description": "Earn 4 points per $1 on purchases outside of GM (minus credits/returns). Points are not earned on fees or interest charges, cash advances, wire transfers, unauthorized or fraudulent transactions, purchases of travelers checks or other cash equivalents. Eligible GM purchases are excluded from this base rate as they earn 7x under a separate rule.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Fuel Statement Credit",
      "description": "Receive a $100 statement credit each calendar year after making $1,500+ in eligible fuel purchases at gas stations. Must activate the benefit each year at mygmrewardscard.com and link card to My GM Rewards Account. Credit may post up to 30 business days after meeting the spend requirement.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 1500,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "EV Statement Credit",
      "description": "GM electric vehicle owners can receive a $100 statement credit after paying 6 monthly electric utility bills that post in the same calendar year using the card. Must activate the benefit each year at mygmrewardscard.com and link card to My GM Rewards Account. Out-of-home EV charging station purchases are not eligible. Credit may post up to 30 business days after qualification.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Vehicle Detailing Allowance",
      "description": "$50 allowance per calendar year toward vehicle detailing services at a participating GM dealer; applied at time of service. No activation required.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Points Don't Expire",
      "description": "My GM Rewards points do not expire as long as the credit card account remains open and in good standing.",
      "benefit_type": null,
      "new_benefit_type": "points_no_expiration",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "World Elite Mastercard Benefits",
      "description": "Access to World Elite Mastercard benefits offered by Mastercard (administered by third parties; see Mastercard site for current details).",
      "benefit_type": null,
      "new_benefit_type": "world_elite_mastercard_benefits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "Goldman Sachs",
  "imageName": ""
},
  [CreditCard.BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD]: {
  "id": CreditCard.BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD,
  "name": "British Airways Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/british_airways_visa_signature_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AVIOS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.britishAirways",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with British Airways, Aer Lingus, Iberia, and LEVEL. Purchases must be made directly with the airline and properly code as such; third-party payment methods or wallets that do not code to the airline may not qualify. Excludes non-purchase transactions (e.g., cash advances, cash-like, fees, interest). A U.S. address must be listed on the British Airways Executive Club profile to earn Avios in this program.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.aerLingus",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with British Airways, Aer Lingus, Iberia, and LEVEL. Purchases must be made directly with the airline and properly code as such; third-party payment methods or wallets that do not code to the airline may not qualify. Excludes non-purchase transactions (e.g., cash advances, cash-like, fees, interest). A U.S. address must be listed on the British Airways Executive Club profile to earn Avios in this program.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.iberia",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with British Airways, Aer Lingus, Iberia, and LEVEL. Purchases must be made directly with the airline and properly code as such; third-party payment methods or wallets that do not code to the airline may not qualify. Excludes non-purchase transactions (e.g., cash advances, cash-like, fees, interest). A U.S. address must be listed on the British Airways Executive Club profile to earn Avios in this program.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.level",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with British Airways, Aer Lingus, Iberia, and LEVEL. Purchases must be made directly with the airline and properly code as such; third-party payment methods or wallets that do not code to the airline may not qualify. Excludes non-purchase transactions (e.g., cash advances, cash-like, fees, interest). A U.S. address must be listed on the British Airways Executive Club profile to earn Avios in this program.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2 Avios per $1 on hotel accommodations when purchased directly with the hotel. Reservations made through third parties (e.g., online travel agencies) may not qualify if they do not code as direct hotel purchases. Excludes non-purchase transactions. A U.S. address must be listed on the Executive Club profile to earn Avios in this program.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 Avios per $1 on all other purchases. Excludes balance transfers, cash advances and other cash-like transactions, lottery tickets, gambling transactions, any checks that access the account, interest, unauthorized or fraudulent charges, and fees of any kind. Avios are transferred to the British Airways Executive Club after each billing cycle; a U.S. address must be on the Executive Club profile to earn in this program.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Purchase APR: 0.1974\u20130.2824 variable; Balance Transfer APR: 0.1974\u20130.2824 variable; Cash Advance APR: 0.2899 variable; Penalty APR: up to 0.2999 variable. APRs vary with the Prime Rate."
  },
  "benefits": [
    {
      "name": "10% off British Airways flights",
      "description": "10% discount on BA-operated flights originating in the U.S. when booking at ba.com/Chase10 and paying with the card. Discount applies to base fare plus taxes/fees/carrier charges for up to 7 companions traveling on the same itinerary as the cardmember. Not valid on codeshares or franchise carriers; other fare rules/restrictions apply.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Together Ticket (Companion/50% Avios voucher)",
      "description": "Earn 1 Travel Together Ticket after $30,000 in purchases in a calendar year. Redeem the voucher within 2 years for: (a) a companion on a Reward Flight for no additional Avios (taxes/fees/carrier charges apply), or (b) 50% fewer Avios when traveling solo. Valid on British Airways, Iberia, or Aer Lingus Reward Flights; any cabin; one-way or round-trip; primary cardmember must travel. Limit 1 voucher per calendar year.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 30000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass membership",
      "description": "12 months of complimentary DashPass for DoorDash and Caviar when activated with the card between 02/01/2025 and 12/31/2027. Must add the card as default payment and use it for eligible DashPass orders. Auto-renews at the then-current rate after the complimentary period unless canceled.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Use Avios to cover taxes/fees on reward bookings via BA call center",
      "description": "Cardmembers can apply Avios to reduce the cash portion of taxes, fees, and carrier charges on reward bookings made via the British Airways Executive Club Contact Centre (down to a $5 minimum paid with the BA Visa). Not available on ba.com; subject to availability and quoted Avios amounts at booking.",
      "benefit_type": null,
      "new_benefit_type": "avios_taxes_fees_offset_on_reward_bookings",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "85,000 Bonus Avios after $5,000 in purchases in the first 3 months from account opening. Not available to current cardmembers of this card or to previous cardmembers who received a new cardmember bonus for this card in the last 24 months. Estimated value about $1,020 assuming 1.2 cents per Avios (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 85000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPNB&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/avios/british-airways?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60971.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/bacard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "british_airways_visa_signature_credit_card.png"
},
  [CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED]: {
  "id": CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED,
  "name": "Bank of America\u00ae Unlimited Cash Rewards Secured Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cty_cshcm_v_250x157.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5% cash back on all Net Purchases each billing cycle. Online-only introductory applications receive an extra 0.5% for the first 12 months (modeled via signup bonus fields) before reverting to the base 1.5%. Balance Transfers, Cash Advances, fees, interest charges, fraudulent transactions, and certain other charges do not earn rewards. No limit; rewards do not expire while the account is open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": 0.5,
      "signupBonusEarnRateIncreaseDurationMonths": 12
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.2824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2824,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate: Purchases 28.24% variable; Balance Transfers 28.24% variable; Cash Advances 29.24% variable. Penalty APR up to 29.99% may apply if you make a late payment. Interest begins on Balance Transfers and Cash Advances on the transaction date; at least a 25-day grace period on purchases if you pay your entire balance or Interest Saving Balance each month."
  },
  "benefits": [
    {
      "name": "Bank of America Preferred Rewards bonus (25%\u201375% more cash back)",
      "description": "Preferred Rewards members earn an additional 25%\u201375% cash back multiplier on base purchases (1.5% becomes up to 2.625%). Eligibility requires meeting Bank of America/Merrill balance requirements; bonus does not apply to the extra 0.5% first-year promotional earn.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "First-year additional 0.5% cash rewards on all purchases (for a total of 2% vs the base 1.5%) on net purchases that post within 365 days of account opening. Cash advances and balance transfers do not qualify. Limit 1 bonus cash rewards offer per new account; no Preferred Rewards bonus applies to the additional 0.5%; account must be open with active charging privileges to receive.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 0.5,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076445&productoffercode=SF&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-secured-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076445&productoffercode=SF&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Unlimited Cash Rewards secured credit card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_unlimited_cash_rewards_secured.png"
},
  [CreditCard.PRIME_VISA]: {
  "id": CreditCard.PRIME_VISA,
  "name": "Prime Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/prime_visa.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "onlineShopping.amazon",
      "earnRate": 3.0,
      "description": "3% back at Amazon.com and Whole Foods Market when your card is not associated with an eligible Prime membership on the Amazon.com account where the card is loaded. Same exclusions apply as the 5% category (no Amazon Pay, no international Amazon retail sites, no international Whole Foods, no third\u2011party Whole Foods channels, no online WF gift cards, certain in\u2011store third\u2011party vendors/services excluded). Transactions on Amazon Equal Pay/Installments do not earn % back.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 5.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "5% back at Amazon.com (including digital downloads, Amazon.com Gift Cards, Amazon Fresh orders, Amazon Prime subscriptions, and items sold by third-party merchants on Amazon.com) and at Whole Foods Market locations/website with an eligible Prime membership. Exclusions include: purchases via Amazon Pay, purchases at international Amazon retail sites not listed in the benefits page, purchases at international Whole Foods Markets, Whole Foods orders via third-party services (e.g., Instacart, Eventbrite, Google Express, Shipt), online purchases of Whole Foods gift cards, certain third-party vendors within Whole Foods, massage services, and Spa@Ink. Transactions placed on Amazon Equal Pay/Installments do not earn % back.",
          "promotional_type": PromotionalType.PRIME_MEMBERSHIP
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "whole_foods",
      "earnRate": 3.0,
      "description": "3% back at Amazon.com and Whole Foods Market when your card is not associated with an eligible Prime membership on the Amazon.com account where the card is loaded. Same exclusions apply as the 5% category (no Amazon Pay, no international Amazon retail sites, no international Whole Foods, no third\u2011party Whole Foods channels, no online WF gift cards, certain in\u2011store third\u2011party vendors/services excluded). Transactions on Amazon Equal Pay/Installments do not earn % back.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 5.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "5% back at Amazon.com (including digital downloads, Amazon.com Gift Cards, Amazon Fresh orders, Amazon Prime subscriptions, and items sold by third-party merchants on Amazon.com) and at Whole Foods Market locations/website with an eligible Prime membership. Exclusions include: purchases via Amazon Pay, purchases at international Amazon retail sites not listed in the benefits page, purchases at international Whole Foods Markets, Whole Foods orders via third-party services (e.g., Instacart, Eventbrite, Google Express, Shipt), online purchases of Whole Foods gift cards, certain third-party vendors within Whole Foods, massage services, and Spa@Ink. Transactions placed on Amazon Equal Pay/Installments do not earn % back.",
          "promotional_type": PromotionalType.PRIME_MEMBERSHIP
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "3% back on travel purchases booked through Chase Travel when you do not have an eligible Prime membership. If paid partially with points, only the portion paid with the card earns rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 5.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "5% back on travel purchases booked through Chase Travel with an eligible Prime membership. If paid partially with points, only the portion paid with the card earns rewards.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2% back at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2% back at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2% back on local transit and commuting, including rideshare.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2799,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2799,
    "description": "Purchase APR 0.1924\u20130.2799 variable based on creditworthiness (varies with the Prime Rate). Balance Transfer APR 0.1924\u20130.2799 variable. Cash Advance APR 0.2899 variable. Penalty APR up to 0.2999 variable. Grace period at least 21 days; no minimum interest charge. Balance transfer fee 4% (min $5); cash advance fee 4% (min $5). Late/returned payment fees up to $39. No foreign transaction fees. Note: the account may not be eligible for balance transfers. Promotional 0% Equal Pay financing on Amazon.com purchases may be offered for 6\u201348 months; purchases under Equal Pay do not earn % back rewards."
  },
  "benefits": [
    {
      "name": "Extended Warranty Protection",
      "description": "Adds one additional year to the manufacturer\u2019s U.S. warranty on eligible items with original warranties of three years or less (up to a total of four years from purchase). Restrictions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for damage or theft for 120 days from purchase, up to $500 per item. Note: For New York residents, coverage period is 90 days.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Reimburses up to $100 per day for up to 3 days for essential purchases when baggage is delayed more than 6 hours.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "When you pay for your air, bus, train, or cruise transportation with the card, you are eligible for up to $500,000 in accidental death or dismemberment coverage. Restrictions and exclusions apply.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Provides reimbursement up to $3,000 per covered traveler for checked or carry\u2011on baggage that is lost, damaged, or stolen during a covered trip. New York residents: limited to $2,000 per bag and $10,000 per trip.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Secondary)",
      "description": "Decline the rental company\u2019s collision insurance and pay with your card to receive coverage for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal auto insurance.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Liability Protection",
      "description": "You won\u2019t be held responsible for unauthorized charges made with your card or account information. Does not apply to use by an authorized user without the primary cardmember\u2019s approval.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Prime members receive a $150 Amazon Gift Card instantly loaded to their Amazon account upon approval. New cardmembers only; not available to those who currently have an Amazon Visa or Prime Visa. No minimum spend required; Amazon account must be open; gift card cannot be used to purchase other gift cards. Estimated value: $150 at face value.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "gift_card",
          "amount": 150.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://creditcards.chase.com/cash-back-credit-cards/amazon-prime-rewards?CELL=6269",
  "learn_more_link": "https://creditcards.chase.com/cash-back-credit-cards/amazon-prime-rewards?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC59329.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/amazon/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "prime_visa.png"
},
  [CreditCard.ATTUNE_CARD]: {
  "id": CreditCard.ATTUNE_CARD,
  "name": "Wells Fargo Attune\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/rv/assets/attune.TShlU095_24rmsu.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "fitness",
      "earnRate": 4.0,
      "description": "Self-care group: gym memberships. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs, or through third-party payment accounts/mobile card readers/online marketplaces, may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "selfCare",
      "earnRate": 4.0,
      "description": "Self-care group: massages, hair and nail salons. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs, or through third-party payment accounts/mobile card readers/online marketplaces, may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gardeningFloral",
      "earnRate": 4.0,
      "description": "Select Sports, Recreation, and Entertainment group: gardening and floral stores. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "sportsEquipment",
      "earnRate": 4.0,
      "description": "Select Sports, Recreation, and Entertainment group: sports supplies. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "entertainment.liveEntertainment",
      "earnRate": 4.0,
      "description": "Select Sports, Recreation, and Entertainment group: live shows and sporting events. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "petPurchases",
      "earnRate": 4.0,
      "description": "Select Sports, Recreation, and Entertainment group: pet supplies, boarding, and grooming. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 4.0,
      "description": "Planet-Friendly Purchases: public transportation. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "thriftStores",
      "earnRate": 4.0,
      "description": "Planet-Friendly Purchases: EV charging stations and select secondhand stores. Earn 4% cash rewards when purchases are coded to eligible merchant category codes. Purchases not processed under qualifying MCCs may not qualify. Cash equivalents excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other net purchases not in the above bonus categories earn 1% cash rewards. Cash equivalents, balance transfers, and similar transactions do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.2899,
    "description": "0.0 intro APR on purchases for 12 months from account opening. After that, variable purchase APR of 0.1899, 0.2399, or 0.2899 based on creditworthiness (varies with U.S. Prime Rate). Balance transfer APR is variable at 0.1899, 0.2399, or 0.2899. Cash advance/overdraft protection APR is 0.2999 variable. Grace period: at least 25 days; minimum interest charge: $1.00. Balance transfer fee: 0.03 for first 120 days (min $5), then up to 0.05 (min $5). Foreign transaction fee: 0.03."
  },
  "benefits": [
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $600 per approved claim (maximum 2 claims per 12-month period; $1,200 annual maximum) with a $25 deductible per claim when you pay your monthly wireless bill with the card. Coverage begins the first day of the month after you first pay your wireless bill with the card and continues while you keep paying it with the card. Covers damage, theft, and involuntary and accidental parting; excludes lost phones (mysterious disappearance), cosmetic damage, cracked screens, and software/electronic failures. Estimated value: up to $1,200/year if fully utilized; typical value varies based on incident frequency.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Secondary)",
      "description": "Secondary coverage for covered damage or theft when you pay for the entire rental with the card and decline the rental company\u2019s CDW. Certain vehicles/restrictions apply. Estimated value: can save roughly $10\u2013$30 per rental day if you rely on this instead of purchasing the agency\u2019s CDW (actual savings vary).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge Service (World Elite Mastercard)",
      "description": "24/7 personal assistant to help with travel, dining, and experiences via worldeliteconcierge.mastercard.com. Benefits may change per Mastercard terms.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard Travel & Lifestyle Services",
      "description": "24/7 Lifestyle Manager support; can liaise with 3\u2011star+ hotels to help resolve stay issues and assist with planning/booking. Terms and availability per Mastercard.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection",
      "description": "No\u2011extra\u2011cost monitoring and assistance (registration required; provided by Iris Powered by Generali) to help detect and remediate identity theft issues.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard Global Service",
      "description": "24/7 worldwide assistance for card-related needs, including emergency services while traveling.",
      "benefit_type": null,
      "new_benefit_type": "mastercard_global_service",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $100 cash rewards bonus after $500 in net purchases within the first 3 months of account opening. Bonus appears as redeemable within 1\u20132 billing periods after it is earned. Not available if you currently have or have had the Attune card within the past 48 months. For applications submitted 6/5/2024\u201312/31/2025 and subsequently approved, Wells Fargo will donate $50 to Capital Link when you qualify for the $100 bonus (donation is not a cardholder reward). Exclusions: cash advances, balance transfers, fees/interest, gambling, and other excluded transactions do not count toward spend or earn rewards.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://apply.wellsfargo.com/getting_started?FPID=012286I6P10000&product_code=CC&subproduct_code=EM&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC_CG&applicationtype=consumercreditcard",
  "learn_more_link": "https://creditcards.wellsfargo.com/attune-credit-card/?FPID=012286I6P10000&product_code=CC&subproduct_code=EM&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC_CG",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/attune/terms/?FPID=012286I6P10000&product_code=CC&subproduct_code=EM&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC_CG",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [
    {
      "name": "Capital Link",
      "url": "https://www.caplink.org/solar-for-health-centers-attune-card?sub_channel=SEO&vendor_code=G"
    }
  ],
  "bank_name": "Wells Fargo",
  "imageName": "attune_card.png"
},
  [CreditCard.SPARK_2_CASH]: {
  "id": CreditCard.SPARK_2_CASH,
  "name": "Spark 2% Cash",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/spark-cash-plus/thumbnail.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Unlimited 2% cash back on every purchase, everywhere; no category restrictions.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on hotel purchases booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on rental car purchases booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2524,
    "apr_low": 0.2524
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2524,
    "high": 0.2524,
    "description": "Purchase rate 25.24% variable APR."
  },
  "benefits": [
    {
      "name": "Extended warranty",
      "description": "Get free additional warranty and protection on eligible items purchased with the card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay zero foreign transaction fees on purchases made outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside assistance services",
      "description": "Access services for auto-related emergencies like jump-starts, tire changes and towing (terms and fees may apply).",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Business Travel access",
      "description": "Complimentary access to Capital One\u2019s business travel management and booking platform to help save time and money on business travel.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_business_travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free employee cards",
      "description": "Add employee cards at no additional cost and earn rewards on their purchases; set customized spend limits and track transactions.",
      "benefit_type": null,
      "new_benefit_type": "free_employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 10000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $1,000 cash bonus after spending $10,000 in the first 3 months. Estimated value: $1,000 cash. Offer may require applying via the specific offer page and may not be available to existing or previous Capital One Business cardholders.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 1000.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/small-business/credit-cards/spark-cash/",
  "learn_more_link": "https://www.capitalone.com/small-business/credit-cards/spark-cash/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "spark_2_cash.webp"
},
  [CreditCard.F_N_B_O_GREEN_SELECT_CREDIT_CARD]: {
  "id": CreditCard.F_N_B_O_GREEN_SELECT_CREDIT_CARD,
  "name": "GreenSelect\u2120 Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://s7d1.scene7.com/is/image/fnnistage/greenselect-new-orange?ts=1755532345515&$TransparentPNG$&dpr=off",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2599,
    "apr_low": 0.1599
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1599,
    "high": 0.2599,
    "description": "0.0 intro APR on purchases and balance transfers for the first 18 billing cycles; after that, a variable APR based on the Prime Rate between 0.1599 and 0.2599."
  },
  "benefits": [
    {
      "name": "Roadside Dispatch",
      "description": "Provides 24-hour access to roadside assistance such as tire changing, jump starting, or towing. Pay-per-use service with pre-negotiated fees available to Visa cardmembers.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Global Services (Emergency Assistance)",
      "description": "Provides worldwide expert assistance for emergency card replacement or emergency cash disbursement.",
      "benefit_type": null,
      "new_benefit_type": "global_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.fnbo.com/personal-banking/credit-cards#",
  "learn_more_link": "https://www.fnbo.com/personal-banking/credit-cards/greenselect",
  "terms_and_conditions_link": "https://www.firstbankcard.com/lynx/#/soct/611NC1TH17VCP",
  "terms_and_conditions_button_text": "Summary of Credit Terms",
  "additional_links": [],
  "bank_name": "FNBO",
  "imageName": "f_n_b_o_green_select_credit_card.png"
},
  [CreditCard.CITI_WAYFAIR_CREDIT_CARDS]: {
  "id": CreditCard.CITI_WAYFAIR_CREDIT_CARDS,
  "name": "Wayfair Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://assets.wfcdn.com/im/90986153/resize-h280-w600%5Ecompr-r85/2897/289749685/wayfair_credit_card_overlay_image_large_289749685.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "onlineShopping.wayfair",
      "earnRate": 7.0,
      "description": "Wayfair purchases (Wayfair, AllModern, Birch Lane, Joss & Main, Perigold; plus eligible Wayfair-owned stores) earn 7% in Wayfair Reward Dollars when promotional financing is not used. Rewards Dollars have no cash value and are not redeemable for cash; forfeiture may occur upon account closure per program terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "applies_to_wayfair_credit_card_and_mastercard"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineShopping.wayfair",
      "earnRate": 5.0,
      "description": "Wayfair purchases with promotional financing earn 5% in Wayfair Reward Dollars instead of 7%.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "applies_to_wayfair_credit_card_and_mastercard",
        "promotional_financing_applied"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "Standard grocery store purchases earn 3%; purchases at wholesale/supercenters/discount stores and similar MCCs earn only 1%.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "wayfair_mastercard_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineShopping",
      "earnRate": 2.0,
      "description": "2% on qualifying non-Wayfair online purchases; numerous MCC-based exclusions apply; mobile wallet or manually keyed transactions may default to 1%.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "wayfair_mastercard_only",
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Base earn rate for non-bonus, non-Wayfair purchases on the Wayfair Mastercard.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "wayfair_mastercard_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3424,
    "apr_low": 0.3049
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3049,
    "high": 0.3424,
    "description": "As of 6/6/2025: Wayfair Credit Card purchase APR variable 30.49\u201334.24% (min interest charge $2). Wayfair Mastercard purchase APR variable 30.49\u201334.24%; balance transfer APR variable 30.49\u201334.24%; cash advance APR variable 30.49\u201334.24%. Balance transfer fee is the greater of $10 or 5% of each transfer; cash advance fee is the greater of $10 or 5%. Foreign transaction fee is 3% of the U.S. dollar amount of each purchase. Promotional financing: no interest if paid in full for 6/12/18/24 months on qualifying Wayfair purchases; major purchase plans at 9.99% APR for 36/48/60 months."
  },
  "benefits": [
    {
      "name": "Free Wayfair Rewards membership (fees waived while account open)",
      "description": "Automatic, free enrollment in Wayfair Rewards when the account is opened, with the program\u2019s membership fees waived as long as the card account remains open. Rewards do not expire while the account is active; if the account is closed, rewards are forfeited 90 days after notice unless you enroll as a paid member within 30 days of expiration of the free membership. Estimated value: about $29 per year based on the stated Wayfair Rewards paid membership fee.",
      "benefit_type": null,
      "new_benefit_type": "free_wayfair_rewards_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Promotional financing on Wayfair purchases",
      "description": "Ongoing financing offers at Wayfair Family of Brands when paying with the Wayfair Credit Card or Wayfair Mastercard: (a) Deferred interest plans up to 24 months if paid in full (6 months on $199+, 12 months on $799+, 18 months on $1,499+, 24 months on $2,999+; promotional period currently through 01/22/2026); and (b) Major Purchase Plans at 9.99% APR for 36 months on $1,599+, 48 months on $1,799+, or 60 months on $1,999+ (currently through 01/22/2026). Financing not available in all stores; additional terms apply. Note: promotional financing orders are not eligible for the introductory $40 offer; choosing financing at Wayfair earns 5% in rewards instead of 7%.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing_options",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 100.0,
      "spendRequirementMonths": null,
      "description": "Introductory offer: $40 off your qualifying first Wayfair order when you open a new account. Wayfair\u2019s apply page states the minimum purchase is $100 and the offer is valid through 2/28/2026; Citi marketing pages may show a $250 minimum. Cannot be combined with other discounts or financing offers; excludes select manufacturers, gift cards, and Wayfair Professional purchases; not valid at Perigold or outlet stores; minimum excludes tax, shipping, and other discounts; subject to credit approval; only available on the first order placed with the Wayfair Credit Card or Wayfair Mastercard.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 40.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.wayfair.com/wayfaircard?init_app_type=FULL_APPLICATION&from=citimpp",
  "learn_more_link": "https://www.citi.com/credit-cards/wayfair-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/wayfair-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_wayfair_credit_cards.png"
},
  [CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD]: {
  "id": CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD,
  "name": "Hawaiian Airlines\u00ae World Elite Business Mastercard\u00ae",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BHA_card_rRGB_BC_Angle_359x246_Angle_L_2021-09-22T04_42_44.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.ALASKA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.hawaiian",
      "earnRate": 3.0,
      "description": "Eligible purchases made directly with Hawaiian Airlines and Alaska Airlines earn 3x miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.alaska",
      "earnRate": 3.0,
      "description": "Eligible purchases made directly with Hawaiian Airlines and Alaska Airlines earn 3x miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Gas station purchases earn 2x miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Dining purchases earn 2x miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "officeSupplies",
      "earnRate": 2.0,
      "description": "Office supply store purchases earn 2x miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other purchases earn 1x miles.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchases APR: 20.24%\u201329.99% variable; Balance transfers APR: 20.24%\u201329.99% variable; Cash advances APR: 29.99% variable. APRs vary with the market based on the Prime Rate and depend on creditworthiness."
  },
  "benefits": [
    {
      "name": "Anniversary Bonus \u2013 20,000 miles after $50,000 annual spend",
      "description": "Earn 20,000 bonus HawaiianMiles if you spend $50,000\u2013$99,999 in annual purchases. Estimated value \u2248 $200 assuming 1.0\u00a2 per mile.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": 50000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary Bonus \u2013 40,000 miles after $100,000+ annual spend",
      "description": "Earn 40,000 bonus HawaiianMiles if you spend $100,000 or more in annual purchases. Estimated value \u2248 $400 assuming 1.0\u00a2 per mile.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": 100000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn elite-qualifying miles from card spend",
      "description": "Cardmembers earn 1 elite\u2011qualifying mile for every $3 spent on the card, helping accelerate progress toward Pualani elite status.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on international purchases (saves ~3% compared to cards that charge this fee).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Miles never expire",
      "description": "HawaiianMiles earned with this card do not expire, letting you earn and redeem at your own pace.",
      "benefit_type": null,
      "new_benefit_type": "points_never_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary employee cards",
      "description": "Add employee cards at no additional cost to help earn rewards faster and control business spending.",
      "benefit_type": null,
      "new_benefit_type": "employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Easier expense tracking",
      "description": "Consolidated statements showing all expenses to simplify business expense management.",
      "benefit_type": null,
      "new_benefit_type": "expense_reporting",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel assistance services",
      "description": "Access to a suite of travel assistance services you can use at home and away. Specific coverages not detailed on the source page.",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 50,000 bonus HawaiianMiles after spending $4,000 on purchases and paying the annual fee in full, both within the first 90 days. Estimated value \u2248 $500 at 1.0\u00a2 per mile (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "One-time 50%-off companion discount for roundtrip coach travel between Hawaii and North America on Hawaiian Airlines. No spend requirement mentioned. Value varies by fare; for example, 50% off a $600 companion fare \u2248 $300 in savings.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "companion_discount",
          "amount": 50.0,
          "value_unit": "percent_off"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-business-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-business-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "hawaiian_airlines_world_elite_business_mastercard.png"
},
  [CreditCard.ATHLETA_REWARDS_MASTERCARD]: {
  "id": CreditCard.ATHLETA_REWARDS_MASTERCARD,
  "name": "Athleta Rewards Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/AT_card_NEW_Enth_MC_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "onlineShopping.gapInc",
      "earnRate": 5.0,
      "description": "Earn 5 points for every $1 spent at Gap Inc. family of brands (Gap, Banana Republic, Old Navy, Athleta). A Gap Inc. Credit Card must be used as the sole payment type. Rewards are redeemable across the family of brands.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point for every $1 spent on all Mastercard purchases made outside the Gap Inc. family of brands.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.3399
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3399,
    "high": 0.3399,
    "description": "Purchase APR 33.99% variable (based on Prime). Balance transfer APR 33.99% variable (when using your Mastercard). Cash advance APR 33.99% variable (when using your Mastercard)."
  },
  "benefits": [
    {
      "name": "Free shipping on online orders $50+",
      "description": "Free Standard shipping on online orders of $50 or more (after discounts, before taxes) shipped within the U.S. (including Puerto Rico) to a single address when signed into your online account. Icon members receive free Express shipping on orders of $50 or more. Additional terms and eligibility restrictions apply per Reward Program Terms.",
      "benefit_type": null,
      "new_benefit_type": "free_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to select sales",
      "description": "Eligible program members may receive early access to select sales. Details provided when available and may be subject to additional terms and conditions.",
      "benefit_type": null,
      "new_benefit_type": "early_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero liability fraud protection",
      "description": "You are not responsible for charges you did not authorize (Mastercard Zero Liability).",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Donate points to select charities",
      "description": "Eligible program members can convert rewards points to donation dollars for select organizations at a rate of 100 points = $1 donation, subject to a program cap and other terms.",
      "benefit_type": null,
      "new_benefit_type": "points_donation",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "athleta_rewards_mastercard.png"
},
  [CreditCard.LL_BEAN_MASTERCARD]: {
  "id": CreditCard.LL_BEAN_MASTERCARD,
  "name": "L.L.Bean\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-llbean/citi-llbean_222x140.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "sportsEquipment.llBean",
      "earnRate": 4.0,
      "description": "Earn 4% in Bean Bucks on purchases at L.L.Bean\u2019s businesses in the U.S.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2% at restaurants; however, purchases at bakeries and certain restaurants/cafes inside department stores, grocery stores, or warehouse clubs may be coded differently and earn 1% instead.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Earn 2% at gas stations; gas purchases at superstores, supermarkets, convenience stores, and warehouse clubs, or fuel for non\u2011automobile use, earn 1% instead due to merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% on all other eligible net purchases and on transactions that don\u2019t qualify for bonus rates due to merchant coding. Bean Bucks are not earned on balance transfers, cash advances, fees, or interest.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3124,
    "apr_low": 0.2024
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.3124,
    "description": "As of 12/24/2024: Purchase APR and balance transfer APR are variable 0.2024\u20130.3124 based on creditworthiness; cash advance APR is 0.3324. APRs vary with the Prime Rate. Minimum Interest Charge $2."
  },
  "benefits": [
    {
      "name": "Free standard shipping at L.L.Bean (when paying with card or Bean Bucks)",
      "description": "Free standard U.S. shipping on L.L.Bean orders when the purchase is paid with the L.L.Bean Mastercard or entirely with Bean Bucks. Excludes expedited shipping, oversized freight, L.L.Bean for Business orders, and shipments outside the U.S. Estimated value ~$6\u2013$10 per eligible order based on typical standard shipping rates.",
      "benefit_type": null,
      "new_benefit_type": "free_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free return shipping for L.L.Bean purchases made with the card or Bean Bucks",
      "description": "Free return shipping on items purchased at L.L.Bean when the original purchase was paid with the L.L.Bean Mastercard or entirely with Bean Bucks. Not valid for items requiring oversized freight, L.L.Bean for Business items, or items returned from international locations. Estimated value ~$6\u2013$8 per return label.",
      "benefit_type": "return_shipping",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free monogramming on eligible L.L.Bean items",
      "description": " Complimentary monogramming on eligible items purchased at L.L.Bean when paid with the L.L.Bean Mastercard or entirely with Bean Bucks. Excludes L.L.Bean for Business and international orders. Estimated value ~$8 per item (typical monogramming fee).",
      "benefit_type": null,
      "new_benefit_type": "free_monogramming",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "One-time 20% off an L.L.Bean purchase upon instant approval; valid only during the same llbean.com session and only when paying with the new L.L.Bean Mastercard. Excludes shipping, return labels, taxes, gift cards, certain services, and various listed categories; cannot be combined with other offers.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "instant_discount",
          "amount": 20.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://www.llbean.com/llb/shop/514535?nav=gn-514535&cmp=W~P~Z~B~3~E~ZZZ0~CL~LL~ZZ",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-llbean-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/citi-llbean-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "ll_bean_mastercard.png"
},
  [CreditCard.SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS]: {
  "id": CreditCard.SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS,
  "name": "Susan G. Komen\u00ae Customized Cash Rewards credit card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/qvys_sigcm_v_250.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "6% total in your selected Choice Category for the first year (3% base + 3% first\u2011year bonus). Category can be changed once per calendar month via Online/Mobile Banking.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_12_months"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 4.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 5.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": 3.0,
      "signupBonusEarnRateIncreaseDurationMonths": 12,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          "gas",
          {
            "categories": [
              "onlineShopping",
              "internetCablePhone",
              "phonePlans",
              "streaming"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": true,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Online Shopping choice category: purchases must be made online via a website or app. Includes cable, internet, phone plans and streaming when paid online. Not eligible if made by phone, mail, or in-person (including mobile wallet/contactless in-store). Some non-retail services are not eligible (e.g., doctors/hospitals, government/taxes, insurance, membership orgs, education/schools, some utilities)."
          },
          "dining",
          "travel",
          "drugstore",
          {
            "categories": [
              "homeImprovement",
              "homeFurnishings"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Home Improvement and Furnishings (both categories earn when this single combined choice is selected)."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.MONTHLY,
        "categoriesDescription": "Choice one category per month: Gas & EV charging stations; Online Shopping (online purchases only; includes cable, internet, phone plans, streaming); Dining; Travel; Drug stores/pharmacies; or Home Improvement and Furnishings (both).",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% at grocery stores and wholesale clubs (includes supermarkets, meat/seafood stores, candy/nut/confection stores, dairy stores, bakeries). Excludes superstores and smaller stores (e.g., many drug stores) that sell groceries and other products. Shares a combined $2,500 per\u2011quarter cap with the Choice Category; after cap, earns 1% for the remainder of the quarter.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "wholesaleClub",
      "earnRate": 2.0,
      "description": "2% at grocery stores and wholesale clubs (includes supermarkets, meat/seafood stores, candy/nut/confection stores, dairy stores, bakeries). Excludes superstores and smaller stores (e.g., many drug stores) that sell groceries and other products. Shares a combined $2,500 per\u2011quarter cap with the Choice Category; after cap, earns 1% for the remainder of the quarter.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases (and on Choice/Grocery/Wholesale purchases after the quarterly cap is reached).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 1.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 1.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "0% intro APR for 15 billing cycles on purchases and on balance transfers made within 60 days of account opening; thereafter variable APR 0.1824\u20130.2824 based on creditworthiness (varies with Prime Rate). Penalty APR up to 0.2999 may apply for late payment. Note: Monthly Custom Pay Plan fixed finance charge of 0.0172 of purchases assigned to a plan."
  },
  "benefits": [
    {
      "name": "Bank of America Preferred Rewards bonus",
      "description": "Preferred Rewards members earn 25%-75% more cash back on every purchase. Not applied to the 3% first-year category bonus. Estimated value varies by tier; for example, if you earn $400 in base cash back per year, the boost could add about $100 (25% tier) to $300 (75% tier).",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "$200 online cash rewards bonus after at least $1,000 in purchases post within 90 days of account opening (purchases only; balance transfers and cash advances excluded; limit 1 per new account; account must be open and in good standing). Estimated value: $200 as cash back, paid within 1\u20132 billing cycles after qualification.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076267&productoffercode=DS&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/susan-komen-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076267&productoffercode=DS&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Susan G. Komen\u00ae Customized Cash Rewards credit card",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://www.bankofamerica.com/credit-cards/products/susan-komen-credit-card//?campaign=4076267~DS~en_US#headlineCcalcModule"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "susan_g_komen_customized_cash_rewards.png"
},
  [CreditCard.VENTUREONE_REWARDS_FOR_GOOD_CREDIT]: {
  "id": CreditCard.VENTUREONE_REWARDS_FOR_GOOD_CREDIT,
  "name": "VentureOne Rewards for Good Credit",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/ventureone_cardart_prim_323x203.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CAPITAL_ONE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.25,
      "description": "Unlimited 1.25 miles per dollar on all purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Earn 5 miles per dollar on hotels, vacation rentals, and rental cars booked via Capital One Travel. Unlimited; no spend cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Earn 5 miles per dollar on hotels, vacation rentals, and rental cars booked via Capital One Travel. Unlimited; no spend cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "Purchase APR: 29.74% variable. No 0% intro APR offer mentioned."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making purchases outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Miles Transfer Partners",
      "description": "Transfer your VentureOne miles to 15+ travel loyalty programs for more flexibility. Once transferred, partner program terms apply.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2014 Price Drop Protection",
      "description": "If you book a flight when Capital One Travel recommends and the price drops within 10 days, you\u2019ll receive up to $50 in travel credit for the difference. Estimated value: up to $50 per eligible flight; only applies when you follow portal recommendations and terms.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2014 24\u2011Hour Price Match Guarantee",
      "description": "If you find a better price within 24 hours of booking an eligible flight, hotel or rental car through Capital One Travel, you\u2019ll receive a travel credit for the difference. Estimated value varies by fare/room/car price difference; subject to portal terms.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2014 Airfare Savings via Price Prediction",
      "description": "Save an average of 15% on flights using Capital One Travel\u2019s price prediction and booking recommendations (savings not guaranteed; varies by route and timing). Example estimate: a $400 flight could save about $60 on average if conditions match historical trends.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment Access",
      "description": "Access exclusive presales, tickets, and select experiences across music, sports and dining.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining Access",
      "description": "Access cardholder\u2011only reservations at select award\u2011winning restaurants and curated culinary events.",
      "benefit_type": null,
      "new_benefit_type": "dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/ventureone-good-credit/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/ventureone-good-credit/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "ventureone_rewards_for_good_credit.png"
},
  [CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD]: {
  "id": CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD,
  "name": "Chase Freedom Unlimited\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/freedom_unlimited_card_alt.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Base rate on all purchases not otherwise earning a higher category rate. Points are tracked as Ultimate Rewards points (1% cash back = 100 points).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Dining at restaurants, including takeout and eligible delivery services. Merchant coding must qualify as dining; third\u2011party wallet or processor routing that doesn\u2019t pass dining MCC may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "drugstore",
      "earnRate": 3.0,
      "description": "Drugstore purchases. Merchant coding must qualify as drugstore; third\u2011party wallet or processor routing that doesn\u2019t pass drugstore MCC may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.lyft",
      "earnRate": 2.0,
      "description": "Promotional Lyft earn rate; appears as additional cash back above base in a separate line item on statements.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only",
        "time_limited"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2849,
    "apr_low": 0.1899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.2849,
    "description": "0.0 intro APR for 15 months on purchases and balance transfers; after that, variable APR 0.1899\u20130.2849 based on creditworthiness (varies with Prime Rate). Cash advance APR 0.2924. Penalty APR up to 0.2999 and may apply indefinitely if you pay late or a payment is returned."
  },
  "benefits": [
    {
      "name": "6 months of complimentary DoorDash DashPass",
      "description": "Get 6 months of complimentary DashPass for DoorDash and Caviar when activated between 02/01/2025 and 12/31/2027. Estimated value about $60 assuming ~$9.99/month. Auto-renews at then-current rate after the complimentary period unless canceled. Must add and use the card for eligible DashPass orders.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Quarterly DoorDash non-restaurant discount",
      "description": "Up to $10 off one qualifying non-restaurant DoorDash order each calendar quarter while enrolled in DashPass, through 12/31/2027. Estimated value up to ~$40 per year if used each quarter. Discount applies to subtotal only; fees/taxes/gratuity still apply. Does not roll over.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $500 per item (NY residents: 90 days).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less, up to 4 years from purchase date.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "Reimburses up to $1,500 per covered traveler and $6,000 per trip for pre-paid, non-refundable passenger fares if canceled or cut short due to covered reasons (e.g., sickness, severe weather).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Coverage for theft and collision damage on most rental vehicles when you decline the rental company\u2019s CDW and pay with the card. In the U.S., coverage is secondary to your personal insurance.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance Services",
      "description": "Access to legal and medical referrals and other assistance while traveling (cardholder responsible for costs of any services obtained).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cash Back rewards do not expire",
      "description": "Ultimate Rewards points (tracked as Cash Back rewards) do not expire as long as the account remains open. Points are forfeited if the account is closed for misuse/fraud or otherwise per program terms.",
      "benefit_type": null,
      "new_benefit_type": "points_never_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $200 bonus (awarded as 20,000 Ultimate Rewards points) after spending $500 on purchases in the first 3 months from account opening. Not available to current cardmembers of this card or to previous cardmembers who received a new cardmember bonus for this card within the last 24 months. Purchases exclude balance transfers, cash advances, cash-like transactions, lottery tickets, gambling, checks that access your account, interest, and fees. Allow 6\u20138 weeks after qualification for the points to post; account must be open and not in default at fulfillment.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HRJ5&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/cash-back-credit-cards/freedom/unlimited?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61498.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/freedomunlimited/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "chase_freedom_unlimited_credit_card.png"
},
  [CreditCard.VENTUREONE_REWARDS]: {
  "id": CreditCard.VENTUREONE_REWARDS,
  "name": "VentureOne Rewards from Capital One",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/ventureone_cardart_prim_323x203.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CAPITAL_ONE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.25,
      "description": "Unlimited 1.25 miles per dollar on every purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Earn 5 miles per dollar on hotels, vacation rentals and rental cars booked through Capital One Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Earn 5 miles per dollar on hotels, vacation rentals and rental cars booked through Capital One Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "0.0000 intro APR for 15 months on purchases and balance transfers; 0.1924 - 0.2924 variable APR after that; balance transfer fee applies (percentage not specified)."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making purchases outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer Your Miles",
      "description": "Transfer Venture miles to 15+ travel loyalty programs for more flexibility (once transfers are final, partner terms apply).",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star Status",
      "description": "Enrollment required via your card\u2019s Benefits/Rewards tab. After enrollment, receive Hertz Five Star status (skip the counter at select locations and choose from a wider selection of cars). Status activates in ~24\u201372 hours and lasts for the duration of the offer; Hertz terms and age restrictions apply.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2013 Price Drop Protection",
      "description": "When you book a flight when Capital One recommends and the price drops within 10 days, receive up to $50 in travel credit for the difference. Availability varies by account and booking; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "travel_portal_price_drop_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2013 Price Match Guarantee",
      "description": "If you find a better price within 24 hours of booking an eligible flight, hotel, or rental car through Capital One Travel, you\u2019ll receive a travel credit for the difference. Availability varies; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "travel_portal_price_match_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment Access",
      "description": "Access exclusive presales, tickets, suite experiences and more through Capital One Entertainment. (Separate 5x earn promo through 12/31/2025 exists but is not a benefit.)",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining Access",
      "description": "Access cardholder-only reservations at select restaurants and curated culinary events via Capital One Dining.",
      "benefit_type": null,
      "new_benefit_type": "dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Use Rewards at Amazon.com",
      "description": "Use Capital One rewards to pay for eligible Amazon.com purchases after linking your account.",
      "benefit_type": null,
      "new_benefit_type": "shop_with_rewards_at_amazon",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Redeem Rewards with PayPal",
      "description": "Use Capital One rewards on eligible purchases at millions of online stores when you check out with PayPal (linking required).",
      "benefit_type": null,
      "new_benefit_type": "redeem_rewards_with_paypal",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Caf\u00e9 Beverage Discount",
      "description": "50% off handcrafted beverages every day at any Capital One Caf\u00e9 when paying with a Capital One card; limit one per person, while supplies last; provided by third-party vendor; details vary by Caf\u00e9.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Capital One Travel Credit (Limited-Time, First Year)",
      "description": "One-time $100 credit to use toward purchases made through Capital One Travel during the first cardholder year; available within the portal at checkout; can be used in full or across multiple purchases; no rewards earned on the credit; restored if a purchase using the credit is canceled before expiration; expires on the first anniversary of account opening; account must be open and in good standing.",
      "credit_category": null,
      "new_credit_category": "capital_one_travel_portal",
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Limited-time welcome offer: 1) One-time $100 Capital One Travel credit available during the first cardholder year (no spend required; portal use only; expires on the account anniversary). 2) Earn 20,000 bonus miles after $500 in purchases within 3 months of account opening (Capital One indicates this is equivalent to $200 toward travel via their travel purchase eraser). Offer availability may require applying via the specific offer page; prior cardholders who received a new cardmember bonus for this product within the past 48 months are not eligible. Estimated total value up to $300 (assuming 20,000 miles = $200 at 1.0\u00a2/mile plus $100 travel credit).",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time welcome offer: 1) One-time $100 Capital One Travel credit available during the first cardholder year (no spend required; portal use only; expires on the account anniversary). 2) Earn 20,000 bonus miles after $500 in purchases within 3 months of account opening (Capital One indicates this is equivalent to $200 toward travel via their travel purchase eraser). Offer availability may require applying via the specific offer page; prior cardholders who received a new cardmember bonus for this product within the past 48 months are not eligible. Estimated total value up to $300 (assuming 20,000 miles = $200 at 1.0\u00a2/mile plus $100 travel credit).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/ventureone/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/ventureone/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "ventureone_rewards.png"
},
  [CreditCard.SYNCHRONY_BELK_REWARDS_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_BELK_REWARDS_CREDIT_CARD,
  "name": "Belk Rewards+ Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://apply.syf.com/cs/groups/public/documents/et_clientoffer/e074503.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Open a new Belk Rewards+ credit card and receive: (1) a one-time 20% off coupon for purchases made on the first day you use the new account (15% off for home/shoes; exclusions apply; one offer per cardholder), and (2) 1,000 Bonus Belk Reward Points (=$10 Belk Reward Dollars) after you make a purchase the day the account is opened. $10 Belk Reward Dollars typically become available within 10 days via your Belk Rewards+ account or in-store; exclusions and terms apply.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "discount_coupon",
          "amount": 20.0,
          "value_unit": "percent_off_first_day_purchases"
        },
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 1000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://apply.syf.com/eapply/eapply.action?clientCode=BELK&intcmp=NoOff_BelkRewards+%C2%AECreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://apply.syf.com/eapply/eapply.action?clientCode=BELK&intcmp=NoOff_BelkRewards+%C2%AECreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://apply.syf.com/eapply/eapply.action?clientCode=BELK&preQual=Y&intcmp=NoOff_BelkRewards+%C2%AECreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_belk_rewards_credit_card.png"
},
  [CreditCard.VENMO_VISA_CREDIT_CARD]: {
  "id": CreditCard.VENMO_VISA_CREDIT_CARD,
  "name": "Venmo Visa\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://images.ctfassets.net/gkyt4bl1j2fs/2gmzLkSclqY22w0ax0APFI/2713c5d459bf612f8f1533915eef0327/Venmo_CC_Shot4_Fan_Multicolor_1_copy.png?w=1906&h=1312&q=50&fm=png&bg=transparent",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "3% cash back on the single Spend Category with the highest dollar amount of Eligible Purchases in each statement period (Top Spend). No enrollment or caps; category determined automatically each cycle.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": 1,
        "categories": [
          "dining",
          "travel",
          "billsAndUtilities",
          {
            "categories": [
              "grocery",
              "wholesaleClub"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Grocery: stores that sell food merchandise for home consumption, including convenience stores, bakeries, and delicatessens, and wholesale clubs that sell a full range of goods; these are grouped under Grocery in the Venmo app."
          },
          "gas",
          {
            "categories": [
              "travel.transit",
              "travel.rideshare",
              "travel.rentalCar"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Transportation: ground transportation including rental cars, taxicabs, rideshare merchants, limousines, bus lines, and passenger railways; also includes tolls, parking meters, and parking garage fees."
          },
          "entertainment",
          {
            "categories": [
              "drugstore",
              "selfCare",
              "fitness"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Health & Beauty: drug stores and pharmacies (prescriptions and OTC), cosmetic/beauty stores, and sports/recreation facilities requiring membership such as health clubs, tennis, golf, and swimming clubs."
          }
        ],
        "categoryRotationFrequency": Frequency.MONTHLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Top spend categories eligible for 3% or 2% include Dining & Nightlife, Travel (airlines, hotels, cruises, short-term rentals), Bills & Utilities (phone, internet, streaming, electric, gas, water, subscriptions), Health & Beauty, Grocery (including wholesale clubs, convenience, bakery, deli), Gas, Transportation (ground transportation, tolls, parking), and Entertainment (movies, concerts, books, amusement parks, music, toy/hobby).",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "selectable_categories",
      "earnRate": 2.0,
      "description": "2% cash back on the Spend Category with the second-highest dollar amount of Eligible Purchases in each statement period (Second Top Spend). No enrollment or caps; category determined automatically each cycle.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": 1,
        "categories": [
          "dining",
          "travel",
          "billsAndUtilities",
          {
            "categories": [
              "grocery",
              "wholesaleClub"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Grocery: stores that sell food merchandise for home consumption, including convenience stores, bakeries, and delicatessens, and wholesale clubs that sell a full range of goods; these are grouped under Grocery in the Venmo app."
          },
          "gas",
          {
            "categories": [
              "travel.transit",
              "travel.rideshare",
              "travel.rentalCar"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Transportation: ground transportation including rental cars, taxicabs, rideshare merchants, limousines, bus lines, and passenger railways; also includes tolls, parking meters, and parking garage fees."
          },
          "entertainment",
          {
            "categories": [
              "drugstore",
              "selfCare",
              "fitness"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Health & Beauty: drug stores and pharmacies (prescriptions and OTC), cosmetic/beauty stores, and sports/recreation facilities requiring membership such as health clubs, tennis, golf, and swimming clubs."
          }
        ],
        "categoryRotationFrequency": Frequency.MONTHLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Second Top Spend category each statement period earns 2% among the same eight category types listed.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other Eligible Purchases, including purchases in the 'Other' category and any spend in the eight categories that is not the Top or Second Top Spend for the cycle. Venmo P2P transactions earn 1% only if classified as a purchase (non\u2011Venmo P2P typically classify as cash advances and do not earn). Transactions processed via technology that does not transmit an MCC (e.g., certain third-party payment accounts, mobile/wireless card readers, or digital wallets without MCC) earn 1%.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3149,
    "apr_low": 0.1949
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1949,
    "high": 0.3149,
    "description": "Variable APRs based on creditworthiness: purchases APR is 19.49%, 28.49%, or 31.49% when you open your account; after that, APRs vary with the Prime Rate (max 35.99%). Cash advance APR: 31.49% variable. Penalty APR: 34.99% variable; may apply if you make a late payment and can remain indefinitely. Grace period: at least 23 days; no interest on purchases if you pay your balance in full by the due date. Minimum interest charge: $2. Paper statement fee: $1.99/month. Cash advance fee: greater of $10 or 5% per advance. Late fee: up to $41. Returned payment fee: up to $41. Foreign transaction fee: none."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://venmo.com/about/creditcard/?intcmp=NoOff_VenmoVisa%C2%AECreditCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://venmo.com/about/creditcard/?intcmp=NoOff_VenmoVisa%C2%AECreditCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": "https://www.synchronybankterms.com/gecrbterms/html/VenmoApplyTerms_combo.htm?intcmp=NoOff_VenmoVisa%C2%AECreditCard_credit%20cards_body-catalog-cards_syfbank_int",
  "terms_and_conditions_button_text": "Terms and Rates",
  "additional_links": [
    {
      "name": "Rewards Program Terms",
      "url": "https://www.synchronycredit.com/gecrbterms/html/RewardsTerms.htm"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "venmo_visa_credit_card.png"
},
  [CreditCard.DOORDASH_REWARDS_MASTERCARD]: {
  "id": CreditCard.DOORDASH_REWARDS_MASTERCARD,
  "name": "DoorDash Rewards Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/doordash_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "dining.takeoutDelivery.doordash",
      "earnRate": 4.0,
      "description": "4% cash back on DoorDash and Caviar orders placed directly via their websites/apps with the card; excludes DashPass subscription fee purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3% cash back on dining when purchased directly from a restaurant (subject to merchant category coding).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% cash back at grocery stores, online or in\u2011store.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1874
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1874,
    "high": 0.2824,
    "description": "Variable purchase APR 0.1874-0.2824 based on creditworthiness and the Prime Rate (Prime 7.25% as of 9/23/2025). Balance transfer APR 0.1874-0.2824 variable; cash advance APR 0.2899 variable; penalty APR up to 0.2999. No minimum interest charge; at least a 21-day grace period on purchases. Note: account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "DashPass Anniversary Membership",
      "description": "Receive 12 months of complimentary DashPass each Anniversary Year when you spend at least $10,000 on the card in that Anniversary Year. Benefit applies to the primary cardmember and up to one authorized user. If you do not meet the spend requirement when a paid DashPass renewal occurs, the membership auto-renews at the then-current annual rate unless you cancel. Estimated value: $96 per year based on DoorDash\u2019s stated annual price.",
      "benefit_type": null,
      "new_benefit_type": "dashpass_membership",
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "World Elite Mastercard cell phone protection when you pay the monthly phone bill with the card; secondary coverage and subject to policy terms and limits.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Secondary)",
      "description": "Decline the rental company\u2019s collision insurance and pay for the entire rental with the card to receive reimbursement for theft and collision damage for most rental vehicles. In the U.S., coverage is secondary to your personal insurance.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the manufacturer\u2019s U.S. warranty by 1 additional year on eligible warranties of 3 years or less, up to 4 years from the date of purchase.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $500 per item (90 days for NY residents).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Insurance",
      "description": "Reimbursement up to $1,500 per covered traveler and $6,000 per trip for prepaid, nonrefundable passenger fares when a covered reason applies (e.g., sickness, severe weather).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "World Elite Concierge",
      "description": "Complimentary 24/7 concierge service to assist with dining reservations, finding items, and more.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Monthly 10% Off Select DoorDash Orders (through 12/31/2025)",
      "description": "Get 10% off one Convenience, Grocery, Alcohol, Retail or DashMart order per month on DoorDash when you pay with the card (max discount $15/month; U.S. only; not valid on Caviar; select promo code from wallet). Estimated value if fully used: up to $180/year through 6/30/2026.",
      "benefit_type": null,
      "new_benefit_type": "monthly_doordash_order_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Lyft Monthly Credit",
      "description": "Take 3 Lyft rides in a calendar month and pay with your World Elite Mastercard to earn a $5 Lyft credit. Ends 9/30/2025.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 5.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Complimentary DashPass for 12 months at account opening for the primary cardmember (valued at $96 by DoorDash). Up to one authorized user also receives up to 12 months of DashPass aligned to the primary\u2019s activation window. Auto-activation occurs upon approval when the card is set as default in the DoorDash wallet; otherwise, add the card to activate. After the complimentary period, enrollment auto-renews at the then-current annual price unless canceled. U.S. address required; valid only in the U.S.; must pay with the card at checkout to receive DashPass benefits; payments via third-party wallets are excluded.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "dashpass_membership",
          "amount": 12.0,
          "value_unit": "months"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Complimentary DashPass for 12 months at account opening for the primary cardmember (valued at $96 by DoorDash). Up to one authorized user also receives up to 12 months of DashPass aligned to the primary\u2019s activation window. Auto-activation occurs upon approval when the card is set as default in the DoorDash wallet; otherwise, add the card to activate. After the complimentary period, enrollment auto-renews at the then-current annual price unless canceled. U.S. address required; valid only in the U.S.; must pay with the card at checkout to receive DashPass benefits; payments via third-party wallets are excluded.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "dashpass_membership",
          "amount": 12.0,
          "value_unit": "months"
        }
      ]
    }
  ],
  "apply_link": "https://creditcards.chase.com/cash-back-credit-cards/doordash?CELL=6269",
  "learn_more_link": "https://creditcards.chase.com/cash-back-credit-cards/doordash?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61934.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/doordash/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "doordash_rewards_mastercard.png"
},
  [CreditCard.CELEBRITY_CRUISES_VISA_SIGNATURE]: {
  "id": CreditCard.CELEBRITY_CRUISES_VISA_SIGNATURE,
  "name": "Celebrity Cruises Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/ragf_sigcm_v_250.png",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.MYCRUISE_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.cruise.royalCaribbean",
      "earnRate": 2.0,
      "description": "2 MyCruise points per $1 on qualifying purchases made directly with Celebrity Cruises, Royal Caribbean, or Silversea. To qualify for the 2x rate, the merchant on your statement must appear as Celebrity Cruises, Royal Caribbean, Silversea, or a ship name. Points cap: maximum 540,000 MyCruise points earned per calendar year across purchases; points expire 60 months after they are earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 MyCruise point per $1 on all other purchases that do not qualify for the bonus cruise-line rate. Points cap of 540,000 per calendar year applies across all earnings; points expire 60 months after they are earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "Variable APR for purchases: 0.1824\u20130.2824 based on creditworthiness (varies with Prime). No introductory APR. Balance transfers: APR 0.1824\u20130.2824; interest accrues from the transaction date. Cash advances: 0.2124\u20130.2924 for Direct Deposit/Check; 0.2924 for Bank Cash Advances. Penalty APR up to 0.2999 may apply indefinitely if you make a late payment. At least 25-day grace period on purchases if you pay your balance in full."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases made abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No annual fee",
      "description": "$0 annual fee.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "30,000 MyCruise bonus points after $1,000 in purchases in the first 90 days; purchases must post within 90 days; balance transfers and cash advances excluded; limit 1 bonus per new account; account must be open and active to receive; bonus posts ~1\u20132 billing cycles after qualifying. Estimated value: $300 in onboard credit (~1.0\u00a2/point per issuer quote).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "celebrity_cruises_visa_signature.png"
},
  [CreditCard.SECURED_CARD]: {
  "id": CreditCard.SECURED_CARD,
  "name": "Credit One Bank Secured Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/padded/secured-yellow-padded.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 1.0,
      "description": "1% cash back as an automatic statement credit on purchases coded as gasoline. Purchases from warehouse clubs (e.g., Costco), discount supercenters (e.g., Walmart, Target), PayPal, and certain ineligible merchant types (e.g., oil/propane/home heating) do not earn rewards. No rewards on cash advances, balance transfers, interest, fees, or while the account is delinquent. Eligibility is based on merchant category code (MCC). Statement credit appears on statements with at least one Net Eligible Purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 1.0,
      "description": "1% cash back as an automatic statement credit on purchases coded as grocery. Excludes purchases at superstores and stores that sell groceries plus other products (e.g., drugstores, convenience stores) and smaller specialty shops (e.g., bakeries, candy/nut/confection stores). Purchases from warehouse clubs (e.g., Costco), discount supercenters (e.g., Walmart, Target), and PayPal do not earn rewards. No rewards on cash advances, balance transfers, interest, fees, or while the account is delinquent. MCC coding determines eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 1.0,
      "description": "1% cash back as an automatic statement credit on monthly mobile phone service and internet/cable service (also includes satellite TV service). Purchases via PayPal, warehouse clubs (e.g., Costco), and discount supercenters (e.g., Walmart, Target) do not earn rewards. No rewards on cash advances, balance transfers, interest, fees, or while the account is delinquent. Eligibility based on MCC; statement credit applied on statements with at least one Net Eligible Purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "29.49% variable APR; variable rates accurate as of 2025-08-31 per terms. Balance calculated using average daily balance (including new purchases)."
  },
  "benefits": [
    {
      "name": "Interest on Security Deposit Account",
      "description": "Your required security deposit account earns a competitive interest rate (minimum deposit $200; funds held as collateral while the account is open).",
      "benefit_type": null,
      "new_benefit_type": "security_deposit_interest",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Experian IdentityWorks Membership",
      "description": "Optional free membership in Experian IdentityWorks when you apply online at CreditOneBank.com and enroll via Experian; operated by Experian and subject to change.",
      "benefit_type": null,
      "new_benefit_type": "experian_identityworks_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Fraud Liability",
      "description": "Visa Zero Liability protection against unauthorized charges; you must notify the bank immediately of any unauthorized use.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Credit Reporting to All 3 Bureaus",
      "description": "Payment history is reported to the three major credit bureaus to help build or rebuild credit with responsible use.",
      "benefit_type": null,
      "new_benefit_type": "credit_bureau_reporting",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1OS&C1BDescriptorID=AEA3800L00&C1BSpecificationID=bc-secured",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/secured-card-visa",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/7rr?pc=WSB4",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [],
  "bank_name": "Credit One",
  "imageName": "secured_card.png"
},
  [CreditCard.TARGET_CIRCLE_CARD]: {
  "id": CreditCard.TARGET_CIRCLE_CARD,
  "name": "Target\u2122 Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://assets.targetimg1.com/webui/redcard/circle_card.svg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "target",
      "earnRate": 5.0,
      "description": "Instant 5% discount at Target stores and Target.com when purchase amount is charged to the Target Circle Card. Exclusions include: prescriptions and OTC items behind pharmacy counter; Target Optical eye exams and protection plans (products like glasses/contacts are eligible); Target GiftCards and most third\u2011party gift cards (incl. Starbucks gift cards purchased at in\u2011store Starbucks); previous purchases; Target credit account payments, reloads, cash back/advances; Shipt and Target Circle 360 membership fees; alcohol purchases in Indiana; wireless protection program purchases and required mobile carrier deposits; gift wrapping services; taxes, shipping, delivery, handling and other fees; where prohibited by law. 5% can stack with Target Circle deals. Also applies to in\u2011store Starbucks locations (excluding Starbucks gift cards).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Earn 2% rewards toward a Target GiftCard on eligible gas purchases (MCC 5541 or 5542\u2014merchants that primarily sell automotive gasoline). Merchants that do not primarily sell gasoline (e.g., truck stops, marinas) are not eligible. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2% rewards toward a Target GiftCard on eligible dining purchases (MCC 5812, 5813, or 5814\u2014restaurants including fast food). Food and beverage merchants within larger establishments (e.g., theme parks, casinos, stadiums) are not eligible. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% rewards toward a Target GiftCard on eligible purchases outside Target that are not in gas or dining categories. Excludes cash advances/ATM, money orders and cash-like transactions, card fees/interest, unauthorized or prohibited transactions, and purchases or reloads of gift cards or prepaid cards. No stated cap. Note: Some non-discounted purchases at Target stores (e.g., eye exams, clinic services, certain mobile carrier-related transactions, and certain in-store restaurant purchases) also earn 1%.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Free standard/2\u2011day shipping at Target.com",
      "description": "Free standard shipping on most items and free 2\u2011day shipping on eligible items at Target.com when you use your Target Circle credit card. Hundreds of thousands of items qualify; order cutoff times, select ZIP codes, and other restrictions apply (some items may require a minimum purchase; upgraded methods may incur fees).",
      "benefit_type": null,
      "new_benefit_type": "free_standard_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended returns (extra 30 days) at Target",
      "description": "Receive 30 additional days to return purchases made at Target stores or Target.com when you pay with your Target Circle credit card. Exclusions include Target Optical purchases, non\u2011returnable items, contract mobile phones, and online SNAP EBT items purchased with both EBT and a Target Circle Card.",
      "benefit_type": null,
      "new_benefit_type": "extended_returns",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Exclusive extras offers throughout the year",
      "description": "Cardholders may receive special items and offers at Target\u2019s discretion throughout the year. Availability varies by cardholder and may depend on factors like past purchases or location; enrollment in Target Circle may be required to redeem. Not all cardholders will receive every offer.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_extras_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$50 off Target Circle 360 membership each year",
      "description": "Annual discount that reduces the Target Circle 360 membership from $99 to $49 when your Target Circle Card (credit or debit) is saved to your Target account. Subject to membership terms; cannot be combined with other promotions. Estimated value: $50 per year if you keep the membership.",
      "benefit_type": null,
      "new_benefit_type": "membership_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 50.0,
      "spendRequirementMonths": 2,
      "description": "Get $50 in Target Circle Rewards after you spend $50 or more on qualifying purchases at Target (in store or Target.com) with your Target Circle credit card within 60 days of approval. Offer is added to your Target Circle account within 24 hours of approval; excludes mail-in applications. Qualifying purchases exclude alcohol, Target GiftCards, third\u2011party prepaid/gift cards, CVS pharmacy, clinic, and Target Optical. Offer does not apply to the Target Circle debit card. Target Circle Rewards expire after one year of no earning or redemption activity.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 50.0,
          "value_unit": "dollars",
          "category": "target",
          "category_description": "Target purchases in-store and at Target.com; exclusions apply"
        }
      ]
    }
  ],
  "apply_link": "https://www.target.com/circlecard",
  "learn_more_link": "https://www.target.com/circlecard",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "TD Bank",
  "imageName": "target_circle_card.jpeg"
},
  [CreditCard.APPLE_CARD]: {
  "id": CreditCard.APPLE_CARD,
  "name": "Apple Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.apple.com/v/apple-card/n/images/overview/routers/wallet__invyty308pui_large.jpg",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "electronics.apple",
      "earnRate": 3.0,
      "description": "3% Daily Cash back on purchases made directly with Apple, including Apple retail stores, apple.com, the Apple Store app, iTunes, App Store (including in\u2011app purchases), Apple Music, and Apple TV+. Apple Pay is not required for Apple\u2011direct purchases. Apple Card Monthly Installments purchases also earn 3% Daily Cash up front. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeImprovement.aceHardware",
      "earnRate": 3.0,
      "description": "3% Daily Cash at participating Ace Hardware with Apple Pay as above. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "booking_com",
      "earnRate": 3.0,
      "description": "3% Daily Cash on eligible prepaid stays and car rentals booked through the exclusive Booking.com link with Apple Pay. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay",
        "require_travel_portal",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "exxon",
      "earnRate": 3.0,
      "description": "3% Daily Cash at Exxon and Mobil with Apple Pay where available. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "mobil",
      "earnRate": 3.0,
      "description": "3% Daily Cash at Exxon and Mobil with Apple Pay where available. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.uber",
      "earnRate": 3.0,
      "description": "3% Daily Cash on eligible Uber rides with Apple Pay. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery.ubereats",
      "earnRate": 3.0,
      "description": "3% Daily Cash on eligible Uber Eats orders with Apple Pay. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "drugstore.walgreens",
      "earnRate": 3.0,
      "description": "3% Daily Cash at Walgreens with Apple Pay, subject to listed exclusions. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "duane_reade",
      "earnRate": 3.0,
      "description": "3% Daily Cash at Duane Reade with Apple Pay, subject to listed exclusions. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_apple_pay"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases.mobileWallet.applePay",
      "earnRate": 2.0,
      "description": "2% Daily Cash on all other Apple Pay purchases. Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% Daily Cash on purchases made without Apple Pay (e.g., using the titanium card in\u2011store or the virtual card number online). Unlimited; no cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2849,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2849,
    "description": "Variable purchase APR ranges from 18.24% to 28.49% based on creditworthiness and varies with the Prime Rate. As of 06/30/2025 the WSJ Prime Rate was 7.50% and Apple Card adds a margin of 10.74%\u201320.99%. Variable APRs will not exceed 29.99%. Apple Card has no fees (no annual, late, over\u2011the\u2011limit, or foreign-transaction fees)."
  },
  "benefits": [
    {
      "name": "Apple Card Monthly Installments (ACMI) - 0% APR financing at Apple",
      "description": "0% APR monthly installments on eligible Apple purchases at Apple retail, apple.com, and Apple Store app when ACMI is selected at checkout; taxes/shipping subject to variable APR; not available at certain special storefronts; term length varies by product.",
      "benefit_type": null,
      "new_benefit_type": "0_percent_financing_at_apple",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Uber One 6\u2011month free trial",
      "description": "Six\u2011month free trial of Uber One when you sign up via the exclusive link using Apple Card with Apple Pay; valid for new or returning Uber One subscribers (not current members); auto\u2011renews at $9.99/month unless canceled. Estimated value \u2248 $59.94.",
      "benefit_type": null,
      "new_benefit_type": "uber_one_free_trial",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay no foreign transaction fees on purchases made abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No annual fee",
      "description": "Card has no annual fee.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No late fees",
      "description": "No late fees are charged (though interest can still accrue on unpaid balances).",
      "benefit_type": null,
      "new_benefit_type": "no_late_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No over\u2011the\u2011limit fees",
      "description": "No fees for exceeding your credit limit (authorization may still be declined).",
      "benefit_type": null,
      "new_benefit_type": "no_over_the_limit_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Apple Card Family sharing and credit building",
      "description": "Option to add a Co\u2011Owner and up to four Participants; Co\u2011Owners build credit as equals; Participants 18+ may choose to be reported to bureaus to build credit; spend controls and limits available.",
      "benefit_type": null,
      "new_benefit_type": "family_sharing_and_credit_building",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://card.apple.com/apply/application?referrer=cid%3Dapy-200-10000036&start=false",
  "learn_more_link": "https://www.apple.com/apple-card/",
  "terms_and_conditions_link": "https://www.goldmansachs.com/terms-and-conditions/Apple-Card-Customer-Agreement.pdf",
  "terms_and_conditions_button_text": "Apple Card Customer Agreement",
  "additional_links": [
    {
      "name": "Features",
      "url": "https://www.apple.com/apple-card/features/"
    },
    {
      "name": "Apple Card Family",
      "url": "https://www.apple.com/apple-card/family/"
    },
    {
      "name": "Apple Card Monthly Installments",
      "url": "https://www.apple.com/apple-card/monthly-installments/"
    },
    {
      "name": "How-To Videos",
      "url": "https://www.apple.com/apple-card/how-to/"
    },
    {
      "name": "Learn more about Savings",
      "url": "https://www.apple.com/apple-card/financial-health/#grow-daily-cash"
    },
    {
      "name": "Financial Health",
      "url": "https://www.apple.com/apple-card/financial-health/"
    },
    {
      "name": "How Apple Card applications are evaluated",
      "url": "https://support.apple.com/kb/HT209218?cid=general-applecard-marcom-08152025"
    },
    {
      "name": "About Apple Card Monthly Installments (eligibility and details)",
      "url": "https://support.apple.com/102730"
    }
  ],
  "bank_name": "Goldman Sachs",
  "imageName": "apple_card.png"
},
  [CreditCard.CITI_DILLARDS_CREDIT_CARDS]: {
  "id": CreditCard.CITI_DILLARDS_CREDIT_CARDS,
  "name": "Dillard\u2019s Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/dillards-mastercard/dillards-mastercard_171x108.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2 points per $1 at U.S. gas stations on net eligible purchases with the Dillard\u2019s Mastercard. Excludes typical non-purchase transactions (cash advances, fees, etc.). Points expire 12 months after being earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2 points per $1 at U.S. supermarkets and grocery stores on net eligible purchases with the Dillard\u2019s Mastercard. Excludes typical non-purchase transactions. Points expire 12 months after being earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 point per $1 on all other net eligible purchases where Mastercard is accepted with the Dillard\u2019s Mastercard (non-bonus spend). Excludes typical non-purchase transactions. Points expire 12 months after being earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "departmentStores.dillards",
      "earnRate": 2.0,
      "description": "2 points per $1 on net eligible purchases at Dillard\u2019s (in-store, online, or by phone) when using either the Dillard\u2019s Credit Card or Dillard\u2019s Mastercard.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3324,
    "apr_low": 0.3324
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3324,
    "high": 0.3324,
    "description": "As of 12/24/2024: Dillard\u2019s Credit Card purchase APR: variable 33.24%. Dillard\u2019s Mastercard purchase APR: variable 33.24%; balance transfer APR: variable 33.24%; cash APR: variable 33.24%. Minimum interest charge: $2. Balance transfer fee: greater of $10 or 5% of each transfer. Cash advance fee: greater of $10 or 5% of each cash advance. Foreign transaction fee: 3% of the U.S. dollar amount of each purchase."
  },
  "benefits": [
    {
      "name": "Special Financing Offers on qualifying purchases",
      "description": "Promotional financing available at select Dillard\u2019s stores on qualifying purchases when paid with the Dillard\u2019s Credit Card or Dillard\u2019s Mastercard. Not available for online or phone purchases; additional restrictions apply (see store for details).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard Priceless Experiences and special offers (Dillard\u2019s Mastercard only)",
      "description": "Access to Mastercard Priceless experiences and select Mastercard offers when you have the Dillard\u2019s Mastercard (not available on the store-only Dillard\u2019s Credit Card).",
      "benefit_type": null,
      "new_benefit_type": "mastercard_priceless_experiences",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 100.0,
      "spendRequirementMonths": 0,
      "description": "10% off Welcome Shopping Pass after account opening: Earn a one-day 10% off Shopping Pass (max $100 discount) included with your first statement when you make $100 in net purchases at Dillard\u2019s (in-store or dillards.com) on the day your account is opened, using either the Dillard\u2019s Credit Card or Dillard\u2019s Mastercard. The pass provides a 10% discount on one day\u2019s eligible purchases at Dillard\u2019s, must be used by 11:59pm CT on the day of use, and cannot be combined with Dillard\u2019s percentage-off coupons or Rewards Certificates. Not redeemable for cash, gift cards, or prior purchases; additional terms apply. Estimated value: up to $100 depending on how much you spend on the chosen shopping day (e.g., $500 spend \u2192 ~$50 discount; $1,000+ spend \u2192 capped at $100).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "shopping_pass_discount",
          "amount": 10.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://citiretailservices.citibankonline.com/apply/dillards-credit-card?app=UNSOL&siteId=PLCN_DILLARDS&sc=08601&cmp=W~8~M~I~Z~E~ZZZ1~AI~DL~ZZ",
  "learn_more_link": "https://www.citi.com/credit-cards/dillards-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/dillards-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_dillards_credit_cards.png"
},
  [CreditCard.BARCLAYS_CARNIVAL_WORLD_MASTERCARD]: {
  "id": CreditCard.BARCLAYS_CARNIVAL_WORLD_MASTERCARD,
  "name": "Carnival\u00ae World Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/SMC_NewMC_card_angled_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CARNIVAL,
  "rewards_earn_rates": [
    {
      "category": "travel.cruise.carnival",
      "earnRate": 2.0,
      "description": "Earn 2x FunPoints per $1 spent on purchases made directly with Carnival Cruise Line.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1x FunPoints per $1 spent on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2999,
    "description": "Variable purchase APR 19.24%\u201329.99% based on creditworthiness; varies with the Prime Rate. 0% promotional APR for 6 billing cycles on Qualifying Carnival Cruise Booking Purchases, then the purchase APR applies (19.24%\u201329.99% variable). Cash advance APR 29.99% variable."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "0% Promotional APR on Carnival cruise bookings",
      "description": "0% APR for 6 months from the transaction date on qualifying Carnival cruise booking purchases; then variable APR applies per terms.",
      "benefit_type": null,
      "new_benefit_type": "promotional_apr_carnival_bookings",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "0% Intro APR on balance transfers",
      "description": "0% APR for 15 months on balance transfers that post within 45 days of account opening; then variable APR applies per terms.",
      "benefit_type": null,
      "new_benefit_type": "intro_balance_transfer_apr",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Intro offer after spending $1,000 in the first 90 days. Barclays states it\u2019s enough for $200 in onboard credit. Estimated at ~20,000 FunPoints assuming ~1 cent per point toward onboard credit. Offer may only be earned once; eligibility restrictions and anti-gaming terms apply. See Terms and Conditions for full details.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars",
          "category": "carnival_cruise",
          "category_description": "onboard credit"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/carnival-world-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/carnival-world-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "carnival_world_mastercard.png"
},
  [CreditCard.HSBC_PREMIER_CREDIT_CARD]: {
  "id": CreditCard.HSBC_PREMIER_CREDIT_CARD,
  "name": "HSBC Premier World Mastercard\u00ae credit card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.us.hsbc.com/content/dam/hsbc/us/images/tile-16-9/14388-hsbc-premier-mastercard-pearl-bg-1600x900.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3x Points on gas purchases. No spend cap disclosed; no portal requirement.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3x Points on grocery purchases. No spend cap disclosed; no portal requirement.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2x Points on travel purchases (including flights, hotels, and car rentals). No spend cap disclosed; no portal requirement.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x Points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2424,
    "apr_low": 0.2024
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2424,
    "description": "Variable Purchase APR: 20.24%\u201324.24% (0.2024\u20130.2424) based on creditworthiness. Variable Balance Transfer APR: 20.24%\u201324.24% (0.2024\u20130.2424). Cash Advance APR: 29.24% (0.2924). APRs vary with the Prime Rate; maximum APR 29.99% (0.2999). Minimum Interest Charge $1. Balance transfer/credit card check/cash advance fee: $10 or 5% (whichever is greater). No foreign transaction fees. Annual fee $95 primary; $0 authorized users; $0 primary/AU for Private Banking or HSBC US employees (conditional)."
  },
  "benefits": [
    {
      "name": "Streaming TV subscription credit",
      "description": "Up to $5 per month in statement credits for eligible TV streaming subscriptions (MCC 4899), up to $60 per calendar year. Card must be open/in good standing. Est. value: $60/yr if you have at least one eligible $5+ monthly subscription.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Instacart+ membership and monthly discount",
      "description": "New Instacart+ members get 3 free months of Instacart+ and $10 off your second qualifying order of $10+ each month (offer expires 01/31/2027). HSBC cites up to $140 in annual value, depending on usage.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Lyft monthly app credit",
      "description": "Take 3 eligible Lyft rides in a calendar month and receive a $5 Lyft app credit. Limit one $5 credit per month. Valid in the USA through 1/31/2026. Credit expires 30 days after application. Est. value up to $60/yr if met monthly.",
      "benefit_type": null,
      "new_benefit_type": "lyft_monthly_app_credit",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary ShopRunner membership",
      "description": "Free ShopRunner membership (enroll with eligible HSBC Premier card). Enrollment offer valid through 9/30/2025. Est. value: $79/yr (per ShopRunner).",
      "benefit_type": null,
      "new_benefit_type": "shoprunner_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry/TSA PreCheck/NEXUS application fee credit",
      "description": "Automatic statement credit up to $85 for the first eligible application fee that posts, once every 54 months (1\u20132 billing cycles to appear). Est. long-term value: $85/54 months (~$18.89/yr) if used.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Booking.com prepaid hotel discount",
      "description": "Save up to 7% on prepaid accommodation when you book through booking.com/mastercardUS and select Pay Now with your eligible HSBC Mastercard. Valid until 9/30/2025. Discount varies by property/dates.",
      "benefit_type": null,
      "new_benefit_type": "hotel_discount_booking_com",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rewards for Miles points transfer",
      "description": "Transfer HSBC points to 11 airline and 2 hotel partners. Conversion rates vary; transfers post in up to 14 days; transfers are final and cannot be reversed.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Wireless Telephone Protection",
      "description": "Coverage up to $600 per claim if your cellphone is stolen or damaged; limits/exclusions apply. Refer to Guide to Benefits for full terms.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection and Identity Fraud Expense Reimbursement",
      "description": "Monitoring/support via Iris Powered by Generali; registration required. Includes expense reimbursement for identity fraud. Terms, conditions and exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Assurance (Purchase Protection)",
      "description": "Covers theft or damage to most new purchases within 90 days, up to $1,000 per claim. Item must be purchased entirely with your HSBC Mastercard and/or points. Claims generally must be reported within 60 days.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry/TSA PreCheck/NEXUS application fee credit",
      "description": "Automatic statement credit up to $85 for the first eligible application fee that posts, once every 54 months (1\u20132 billing cycles to appear). Est. long-term value: $85/54 months (~$18.89/yr) if used.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Streaming TV subscription statement credit",
      "description": "Up to $5 per month ($60 per calendar year) in statement credits for eligible TV streaming subscriptions (MCC 4899). Card must be open/in good standing.",
      "credit_category": "streaming",
      "new_credit_category": null,
      "value": 5.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Global Entry/TSA PreCheck/NEXUS fee credit",
      "description": "Automatic statement credit up to $85 for the first eligible application fee that posts, once every 54 months.",
      "credit_category": "travel.transit",
      "new_credit_category": null,
      "value": 85.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 50,000 points after $4,000 in purchases within the first 3 months. Est. value up to $625 in travel when booked through HSBC Travel (implies 1.25 cents per point via portal). Excludes upgrades, account transfers, balance transfers, credit card checks, cash advances, and overdrafts. Account must be open and in good standing; bonus posts 4\u20136 weeks after the promotional period. Ineligible if you opened the same product in the last 36 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.us.hsbc.com/credit-cards/products/premier/#apply",
  "learn_more_link": "https://www.us.hsbc.com/credit-cards/products/premier/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "HSBC",
  "imageName": "hsbc_premier_credit_card.jpg"
},
  [CreditCard.CITI_DIAMOND_PREFERRED_CREDIT_CARD]: {
  "id": CreditCard.CITI_DIAMOND_PREFERRED_CREDIT_CARD,
  "name": "Citi\u00ae Diamond Preferred\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-diamond/citi-diamond_90x57.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2774,
    "apr_low": 0.1699
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1699,
    "high": 0.2774,
    "description": "0.0 intro APR for 12 months on purchases and 0.0 intro APR for 21 months on balance transfers; after the intro periods, a variable APR of 0.1699\u20130.2774 applies based on creditworthiness."
  },
  "benefits": [
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Monitoring of selected personal information with alerts if suspicious activity is found; enrollment required; available at no additional charge.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment access",
      "description": "Access to purchase presale tickets and exclusive experiences for concerts, sports, dining and more via Citi Entertainment.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Liability on Unauthorized Charges",
      "description": "You won\u2019t be responsible for unauthorized charges made to your account.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-diamond-preferred-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "See if You're Pre-qualified",
      "url": "https://online.citi.com/US/ag/cards/pre-screen?intc=citihpmenu_creditcards_pq&PP=citi-diamond&OC=CC-CITI-3CY"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_diamond_preferred_credit_card.png"
},
  [CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS]: {
  "id": CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS,
  "name": "Bank of America\u00ae Premium Rewards\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/bofa_prmsigcm_255x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.BANK_OF_AMERICA_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2 points per $1 on travel purchases (e.g., airlines, hotels, car rentals, cruise lines, travel agencies/tour operators, passenger rail, buses, taxis/limos, ferries/boat rentals, parking, tolls/bridge fees, tourist attractions like amusement parks/zoos/aquariums). Exclusions include some travel-adjacent purchases like in\u2011flight goods/services and duty\u2011free airport purchases. No cap; points don\u2019t expire while the account remains open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2 points per $1 on dining purchases (restaurants including fast food, and bars/taverns). No cap; points don\u2019t expire while the account remains open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 1.5,
      "description": "1.5 points per $1 on purchases that do not qualify for the Travel or Dining categories. No cap; points don\u2019t expire while the account remains open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "allPurchases"
            ],
            "exclude_subcategories": [
              "travel",
              "dining"
            ],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "All other purchases that are not in the Travel or Dining categories."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "All purchases except those that code as Travel or Dining.",
        "startDate": null,
        "endDate": null
      }
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable purchase APR 0.2024\u20130.2824 based on creditworthiness; varies with the Prime Rate. No introductory APR. Balance transfer APR 0.2024\u20130.2824 (variable) with interest accruing from the transaction date; balance transfer fee 0.04 of each transaction. Penalty APR up to 0.2999 may apply indefinitely after a late payment. Grace period at least 25 days; no interest on purchases if the entire balance or Interest Saving Balance is paid by the due date. Foreign transaction fee: none."
  },
  "benefits": [
    {
      "name": "Airline incidental statement credit",
      "description": "Up to $100 in statement credits each calendar year for qualifying airline incidental purchases (e.g., seat upgrades, baggage fees, in-flight services, and airline lounge fees) on select U.S.-domestic carriers; excludes Allegiant, Spirit, and Sun Country. Estimated value: $100/year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "TSA PreCheck or Global Entry application fee credit",
      "description": "Up to $100 in statement credits per account every 4 years for TSA PreCheck or Global Entry application fees. Effective value estimate: $25/year averaged over 4 years if fully used.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel insurance (trip delay/cancellation/interruption)",
      "description": "Travel protections that can assist with trip delays, cancellations and interruptions. Details provided with card benefits guide.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage delay insurance",
      "description": "Coverage for baggage delays.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost luggage reimbursement",
      "description": "Coverage for lost luggage.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency evacuation and transportation",
      "description": "Emergency evacuation and transportation coverage as part of travel insurance protections. See benefits guide for terms/limits.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Collision damage waiver coverage when renting a car with the card (Visa Signature benefit).",
      "benefit_type": null,
      "new_benefit_type": "auto_rental_collision_damage_waiver",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Dispatch",
      "description": "24/7 Roadside Dispatch program access via Visa Signature.",
      "benefit_type": null,
      "new_benefit_type": "roadside_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Purchase Security to help with repair, replacement or reimbursement on eligible purchases.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Warranty Manager Service that can extend eligible manufacturers\u2019 warranties.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return protection",
      "description": "Return Protection on eligible purchases.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Luxury Hotel Collection",
      "description": "Perks when booking through the Visa Signature Luxury Hotel Collection with the card (e.g., on-property benefits; see program site for details).",
      "benefit_type": null,
      "new_benefit_type": "visa_signature_luxury_hotel_collection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge service",
      "description": "Visa Signature concierge for travel planning, dining recommendations and event reservations.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred Rewards bonus",
      "description": "Bank of America Preferred Rewards members earn 25%-75% more points on every purchase (e.g., 2.5\u20133.5x on travel/dining and 1.87\u20132.62x on other purchases). Requires meeting Preferred Rewards program eligibility.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Airline incidental statement credit",
      "description": "Up to $100 in airline incidental fee statement credits each calendar year for eligible U.S.-domestic carrier purchases (e.g., seat upgrades, baggage fees, in-flight services, airline lounge fees). Excludes Allegiant, Spirit, Sun Country; ticket purchases and certain other transactions do not qualify.",
      "credit_category": null,
      "new_credit_category": "airline_incidentals",
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "TSA PreCheck/Global Entry fee credit",
      "description": "Up to $100 statement credit every 4 years when you pay the TSA PreCheck or Global Entry application fee with the card.",
      "credit_category": null,
      "new_credit_category": "tsa_precheck_or_global_entry",
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "60,000 online bonus points after at least $4,000 in purchases post within 90 days of account opening. Estimated value: $600 (points redeem at $0.01 each per program terms). Limit 1 bonus per new account; purchases only (annual fee, cash advances, and balance transfers excluded). Account must be open with active charging privileges; points typically post within 1\u20132 billing cycles. Offer availability may vary by application channel; card may be unavailable if you currently have or have had the card in the preceding 24 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076573&productOfferCode=47&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/premium-rewards-credit-card/?campaign=4076573~47~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076573&productoffercode=47&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Premium Rewards\u00ae credit card",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://www.bankofamerica.com/credit-cards/products/premium-rewards-credit-card/?campaign=4076573~47~en_US#headlineCcalcModule"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_premium_rewards.png"
},
  [CreditCard.SYNCHRONY_THE_J_CREW_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_THE_J_CREW_CREDIT_CARD,
  "name": "J.Crew Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.jcrew.com/brand_creative/jccc/202401_JCCC_mastercard.png?imformat=original",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 2.5,
      "description": "Earn 1 point per $1 (2.5% back) on gas station purchases with the J.Crew Mastercard. Rewards convert at 200 points = $5.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "require_mastercard_variant"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.5,
      "description": "Earn 1 point per $1 (2.5% back) on grocery store purchases with the J.Crew Mastercard. Rewards convert at 200 points = $5.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "require_mastercard_variant"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.25,
      "description": "Earn 1 point per $2 (1.25% back) on all other purchases wherever Mastercard is accepted, excluding gas and grocery (which earn 2.5%) and excluding J.Crew and J.Crew Factory purchases which earn 5%\u20137.5% based on status. Rewards convert at 200 points = $5.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "require_mastercard_variant"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Instant NAVY Access in J.Crew Passport",
      "description": "Cardmembers automatically skip from GREEN to NAVY Access in the J.Crew Passport loyalty program (enrollment required), providing enhanced earn rates and perks compared to basic membership.",
      "benefit_type": null,
      "new_benefit_type": "loyalty_status_upgrade",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$25 Birthday Gift",
      "description": "Receive a $25 birthday gift each year (issued as a reward/coupon; terms may apply).",
      "benefit_type": null,
      "new_benefit_type": "birthday_gift",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free Standard Shipping",
      "description": "Free standard shipping at J.Crew and J.Crew Factory for cardmembers (perks shown for both NAVY and GOLD).",
      "benefit_type": null,
      "new_benefit_type": "free_standard_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Standard Alterations",
      "description": "Complimentary standard alterations for cardmembers (perks shown for both NAVY and GOLD).",
      "benefit_type": null,
      "new_benefit_type": "free_standard_alterations",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Get 20% off your first purchase when you open and use your new J.Crew Credit Card or J.Crew Mastercard. One-time use only; card must be the sole payment type. Exclusions include phone orders, charitable products, third-party brands, Madewell styles, gift cards, taxes, and shipping. In-store: discount must be used the day you\u2019re approved. Online: a code is provided upon approval and can be used in store or online. Cannot be combined with more than one other offer or applied to previous purchases; not redeemable for cash. Estimated value: 20% of your first purchase amount (e.g., a $150 first purchase saves $30).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percent_discount",
          "amount": 20.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://www.jcrew.com/company/credit-card?intcmp=NoOff_TheJ.CrewCreditCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.jcrew.com/company/credit-card?intcmp=NoOff_TheJ.CrewCreditCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you Prequalify",
      "url": "https://www.jcrew.com/company/credit-card?intcmp=NoOff_TheJ.CrewCreditCard_credit%20cards_body-catalog-cards_ext#applyNow"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_the_j_crew_credit_card.png"
},
  [CreditCard.THE_KEY_REWARDS_VISA]: {
  "id": CreditCard.THE_KEY_REWARDS_VISA,
  "name": "The Key Rewards\u00ae Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/kr_ca_cb_rgb.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 10.0,
      "description": "10% back in rewards at participating Williams\u2011Sonoma, Inc. brands (Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, Mark & Graham) for the first 30 days from account opening; excludes GreenRow. Valid for online and in\u2011store purchases. Rewards not earned on transactions placed on the 12\u2011month promotional financing plan.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 10.0,
      "description": "10% back in rewards at participating Williams\u2011Sonoma, Inc. brands (Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, Mark & Graham) for the first 30 days from account opening; excludes GreenRow. Valid for online and in\u2011store purchases. Rewards not earned on transactions placed on the 12\u2011month promotional financing plan.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 5.0,
      "description": "5% back in rewards at participating Williams\u2011Sonoma, Inc. brands (Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, Mark & Graham) online and in stores; excludes GreenRow. Rewards not earned on purchases made using the 12\u2011month promotional financing option.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 5.0,
      "description": "5% back in rewards at participating Williams\u2011Sonoma, Inc. brands (Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, Mark & Graham) online and in stores; excludes GreenRow. Rewards not earned on purchases made using the 12\u2011month promotional financing option.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 4.0,
      "description": "4% back at grocery stores (based on MCC). Grocery purchases at gas stations, convenience stores, warehouse clubs, discount stores, super stores, or affiliated grocery locations earn 1% instead.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4% back at restaurants (including fast food), based on MCC.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 4.0,
      "description": "4% back on food delivery services, based on MCC.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back on other net eligible purchases everywhere Visa is accepted.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.2924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2924,
    "high": 0.2924,
    "description": "Variable APRs: Purchase APR 29.24%; Balance Transfer APR 29.24%; Cash Advance APR 29.24%. Cash advance fee: $5 or 5% of each cash advance, whichever is greater. Special financing: 0% interest for 12 months with equal monthly payments on eligible $750+ purchases at participating brands; if not paid in full after 12 months, the standard variable purchase APR applies to the remaining balance."
  },
  "benefits": [
    {
      "name": "$25 birthday reward",
      "description": "A $25 Birthday rewards certificate is issued during your birthday month and available in your Williams\u2011Sonoma, Inc. account. To qualify, your account must be open and current, have a valid email and U.S. mailing address on file, and you must have made a purchase in the 12 months before your birthday month. New accounts opened during your birthday month are not eligible until the next calendar year. One certificate per 12 months; expires 30 days after issuance.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free standard shipping at participating WSI brands",
      "description": "Free standard shipping within the contiguous 48 states on eligible purchases of $0.01+ made in-store or online at participating Williams\u2011Sonoma, Inc. brands when you pay with The Key Rewards Visa. Not available when Rewards cover the entire order, or when using digital wallets (e.g., Apple Pay, Google Wallet, Samsung Pay) or third\u2011party payment solutions (e.g., PayPal).",
      "benefit_type": null,
      "new_benefit_type": "free_standard_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "12-month promotional financing (0% APR with equal payments) on $750+ brand purchases",
      "description": "Zero interest for 12 months with 12 equal monthly payments on qualifying purchases of $750 or more (excluding shipping and tax) made with The Key Rewards Visa at participating Williams\u2011Sonoma, Inc. brands. Account must be open and current; rewards are not earned on promotional financing purchases. If not paid in full after 12 months, the standard variable purchase APR (29.24%) applies to the remaining program balance. Purchases via third\u2011party payment accounts or digital wallets are not eligible. Estimated value: if you would otherwise carry a $750 balance at a 29.24% APR for 12 months, interest savings could be roughly $100+; actual savings depend on your payoff behavior.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing",
      "spend_requirement": 750,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to sales and events",
      "description": "Cardmembers may receive early access to select sales and events across participating Williams\u2011Sonoma, Inc. brands. Availability and specifics may vary by promotion.",
      "benefit_type": null,
      "new_benefit_type": "early_access_to_sales_and_events",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Welcome offer: 10% back in rewards on Net Eligible purchases at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation and Mark & Graham (excludes GreenRow) for the first 30 days from account opening; thereafter the ongoing brand rate is 5% (ongoing rate is not part of the signup bonus). Some new cardmembers may not be able to make same\u2011day purchases (e.g., if virtual card is unavailable or authentication is incomplete). No stated cap. Estimated value depends on your brand spend in the first 30 days; for example, $500 in qualifying brand spend would yield $50 in rewards (incremental value vs. ongoing 5% is $25).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "bonus_category_rate",
          "amount": 10.0,
          "value_unit": "percent_back"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/thekeyrewards/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/thekeyrewards/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "the_key_rewards_visa.png"
},
  [CreditCard.WORLD_OF_HYATT_CREDIT_CARD]: {
  "id": CreditCard.WORLD_OF_HYATT_CREDIT_CARD,
  "name": "World of Hyatt\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/world_of_hyatt_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.HYATT,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.hyatt",
      "earnRate": 4.0,
      "description": "4x World of Hyatt Bonus Points on qualifying purchases made at Hyatt hotels and resorts participating in the World of Hyatt Program and on purchases of World of Hyatt Experiences at hyatt.com/experiences. Certain purchases may not qualify; see hyatt.com/chase-earn-terms. Standard non-purchase transactions (cash-like, balance transfers, etc.) do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x World of Hyatt Bonus Points at restaurants. Excludes dining purchases that qualify for 4x at Hyatt properties (those typically code as Hyatt/hotel). Non-purchase transactions do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 2.0,
      "description": "2x World of Hyatt Bonus Points on airline tickets when purchased directly with the airline.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2x World of Hyatt Bonus Points on local transit and commuting purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fitness",
      "earnRate": 2.0,
      "description": "2x World of Hyatt Bonus Points on fitness club and gym memberships.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x World of Hyatt Bonus Point per $1 on all other purchases that do not fall into the listed bonus categories. Non-purchase transactions (e.g., balance transfers, cash advances, cash-like transactions, fees, interest) do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": 1.0,
      "signupBonusEarnRateIncreaseDurationMonths": 6
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Purchase APR: 0.1974\u20130.2824 (variable, based on Prime Rate). Balance transfer APR: 0.1974\u20130.2824 (variable). Cash advance APR: 0.2899 (variable). Penalty APR: up to 0.2999 (variable). Minimum interest charge: none. Grace period: at least 21 days; no interest on new purchases if you pay your balance (or Interest Saving Balance) in full by the due date; interest begins on balance transfers and cash advances on the transaction date."
  },
  "benefits": [
    {
      "name": "Annual Category 1\u20134 Free Night Award",
      "description": "One free night certificate valid at Hyatt Category 1\u20134 properties every cardmember anniversary; valid 12 months from issuance; not valid at Miraval, Hyatt Zilara or Hyatt Ziva; resort/destination/facility fees waived on award night (excluding Hyatt Residence Club). Estimated value: roughly $150\u2013$250 depending on property/date.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Category 1\u20134 Free Night After $15,000 In Purchases (each calendar year)",
      "description": "Earn one additional Category 1\u20134 free night certificate after $15,000 in purchases in a calendar year; valid 12 months; same Category 1\u20134 and brand exclusions apply. Estimated value: roughly $150\u2013$250.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Discoverist Elite Status (World of Hyatt)",
      "description": "Primary cardmember receives Discoverist status while account is open and in good standing; allow up to 8 weeks from account opening for status to apply. Authorized users do not receive status via the card.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "5 Tier-Qualifying Night Credits each calendar year",
      "description": "Receive 5 World of Hyatt Tier-Qualifying Night credits within ~8 weeks of account open (first year) and within ~8 weeks of January 1 in subsequent years. Helps progress toward elite status and milestone rewards.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "2 Tier-Qualifying Night Credits for every $5,000 in purchases",
      "description": "Earn 2 additional Tier-Qualifying Night credits for every $5,000 in purchases; no cap stated; nights post within ~8 weeks from the last day of the month in which qualifying spend occurs.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 5000,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DoorDash DashPass (12 months)",
      "description": "Activate DashPass between 02/01/2025 and 12/31/2027 to receive 12 months of complimentary DashPass for DoorDash and Caviar; must add card as default payment and use it at checkout for benefits. Auto-renews at then-current rate unless canceled. Estimated value ~$120 based on $9.99/month list price (value varies).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Quarterly $10 DoorDash discount on one non-restaurant order (with active DashPass)",
      "description": "Once DashPass is activated and while enrolled, receive $10 off one eligible non-restaurant DoorDash order each calendar quarter; discount does not roll over; U.S. only; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "Access to Visa Signature Concierge; cardmember pays cost of goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No fees on foreign transactions per Pricing and Terms; saves typically ~3% versus cards that charge foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 30,000 Bonus Points after spending $3,000 in the first 3 months. Plus, earn up to 30,000 more Bonus Points by earning 2 Total Points per $1 spent on up to $15,000 in purchases in the first 6 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPTC&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/world-of-hyatt-credit-card?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61032.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/worldofhyattcard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "world_of_hyatt_credit_card.png"
},
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD]: {
  "id": CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD,
  "name": "Southwest Rapid Rewards\u00ae Premier Business Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/swa_premier_biz_card_ribbon.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.SOUTHWEST,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.southwest",
      "earnRate": 3.0,
      "description": "3x points on purchases made directly with Southwest Airlines, including flights, inflight purchases, Southwest gift cards, and Southwest Vacations or Getaways by Southwest packages. Excludes Southwest Charters and Southwest Cargo. From Jan 1, 2026 onward, Southwest Cruises are excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x points at gas stations on the first $8,000 in combined purchases with dining per account anniversary year; then 1x.",
      "spendCap": 8000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x points at restaurants on the first $8,000 in combined purchases with gas per account anniversary year; then 1x. Includes takeout and eligible delivery services.",
      "spendCap": 8000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.travelportal",
      "earnRate": 2.0,
      "description": "Time-limited 2x at participating Rapid Rewards hotel and rental car partners.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal",
        "time_limited_2025-12-31"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "Time-limited 2x on local transit and commuting purchases, including rideshare.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_2025-12-31"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 149.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 149.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs that adjust with the Prime Rate. Purchase APR: 0.1974\u20130.2824 based on creditworthiness (Prime 7.25% as of 9/23/2025; margin 0.1249\u20130.2099; max 0.2999). Balance transfer APR: same as purchase. Cash advance APR: 0.2899. Default APR up to 0.2999. Grace period: at least 20 days on new purchases if paid in full."
  },
  "benefits": [
    {
      "name": "Free first checked bag (primary cardmember + up to 8 passengers)",
      "description": "Primary cardmember and up to 8 passengers on the same reservation each get the first standard checked bag free on Southwest-operated flights. Oversize/overweight and extra bag fees apply; partner flights excluded; authorized users/employee cards not eligible; account must be open/in good standing. Estimated savings: ~$35 each way per person (e.g., ~$70 roundtrip per traveler; up to ~$280 roundtrip for a group of 4, per issuer example).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Preferred/Standard seat selection within 48 hours of departure (availability-based)",
      "description": "Primary cardmember can select a Preferred or Standard seat within 48 hours of departure when available; can extend to up to 8 additional passengers on the same reservation. Southwest-operated flights only; not valid on partner itineraries; authorized users/employee cards not eligible; if account is closed/in default or cardmember removed from reservation, selections may be released. Applies to flights operating in 2026 and beyond.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 5 boarding for cardmember + up to 8 passengers (2026+)",
      "description": "Primary cardmember and up to 8 passengers on the same reservation board with Group 5 on Southwest-operated flights; not valid on partner itineraries; authorized users/employee cards not eligible; account must be open/in good standing at time of travel. Applies to flights operating in 2026 and beyond.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual 15% Southwest promo code (account anniversary)",
      "description": "Receive one 15% promo code each account anniversary year; appears in Rapid Rewards account within ~15 days of anniversary and is valid for one year. Applies to base fare (excludes Basic fare); taxes/fees still apply. Redeemable only on Southwest.com or the Southwest app; exclusions include group travel, Southwest Vacations/Getaways, SWABIZ, GDS bookings, special/military/government fares, and cannot stack with other promo codes. Not redeemable for cash.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on Southwest inflight purchases (drinks and Wi\u2011Fi)",
      "description": "Get 25% back as a statement credit on inflight purchases of drinks and Wi\u2011Fi made with the card (also applies to employee cards). Credits typically post same day and appear within 6\u20138 weeks. Example: $8 Wi\u2011Fi \u2192 ~$2 back.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "6,000 anniversary Rapid Rewards points each year",
      "description": "Receive 6,000 bonus Rapid Rewards points each account anniversary year (posts within up to ~8 weeks). Estimated value: ~$78\u2013$96 assuming ~1.3\u20131.6 cents per point, depending on fare redemption.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Tier Qualifying Points toward A\u2011List: 2,000 TQPs per $5,000 annual spend",
      "description": "Earn 2,000 TQPs for every $5,000 in purchases, calculated on the annual cycle defined in the program agreement. TQPs count toward A\u2011List/A\u2011List Preferred qualification.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Reimbursement up to $3,000 per covered traveler for lost, damaged, or stolen checked/carry-on baggage on a covered trip (NY: $2,000 per bag; $10,000 aggregate per trip). Restrictions apply; see Guide to Benefits.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Reimburses up to $100 per day for up to 3 days for essential purchases when baggage is delayed over 6 hours. Restrictions apply; see Guide to Benefits.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years from purchase). Restrictions apply; see Guide to Benefits.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days from purchase against damage or theft, up to $10,000 per item (NY: coverage period 90 days). Restrictions apply; see Guide to Benefits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases. Example savings: ~$150 avoided on $5,000 of foreign spend versus a typical 3% fee.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Companion Pass qualifying points boost (10,000 CPQPs per calendar year)",
      "description": "As a Southwest Rapid Rewards Cardmember, receive one boost of 10,000 Companion Pass qualifying points each calendar year (deposited by Jan 31 or up to 30 days after account opening). One boost per Rapid Rewards member per year; account must be open and not in default at fulfillment.",
      "benefit_type": null,
      "new_benefit_type": "companion_pass_qualifying_points_boost",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Southwest EarlyBird Check-In reimbursement",
      "description": "Each anniversary year, be reimbursed for up to 2 EarlyBird Check-In purchases made with the card (one-way per passenger). Statement credits post when the purchase posts; price varies. Note: this benefit will not apply to flights with assigned seating in 2026.",
      "credit_category": null,
      "new_credit_category": "airline_fees",
      "value": 2.0,
      "value_unit": "services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$500 fee credit for Rapid Rewards points transfers",
      "description": "Automatic statement credits reimbursing fees charged by Southwest for transferring Rapid Rewards points to another member or eligible charity, up to $500 per account anniversary year.",
      "credit_category": null,
      "new_credit_category": "points_transfer_fees",
      "value": 500.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 Rapid Rewards points after $3,000 in purchases in the first 3 months from account opening. Not available to current cardmembers of this business credit card, or to previous cardmembers who received a new cardmember bonus for this business card within the last 24 months. Allow up to 8 weeks for bonus to post; account must be open and not in default at fulfillment. Estimated value: roughly $780\u2013$900 assuming ~1.3\u20131.5 cents per point, depending on redemption.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HSQQ&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/southwest/premier-business?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61808.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement",
      "url": "https://www.chase.com/swapremierbizcard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "southwest_rapid_rewards_premier_business_credit_card.png"
},
  [CreditCard.CHASE_INSTACART_MASTERCARD]: {
  "id": CreditCard.CHASE_INSTACART_MASTERCARD,
  "name": "Instacart Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/instacart_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "Includes flights, hotels and more when booked via Chase Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Dining at restaurants, including takeout and eligible delivery services and restaurant orders on Instacart powered by Uber Eats.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Purchases at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "Select streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other purchases that do not fall into a higher-earning category (including Instacart purchases after the annual Instacart cap is reached).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "instacart",
      "earnRate": 5.0,
      "description": "Until 2025-04-29: 5% back on qualifying purchases made directly through Instacart.com or the Instacart app, including Instacart memberships and subscriptions. Exclusions may apply; see instacart.com/InstacartMastercard.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": "2022-07-11",
      "endDate": "2025-04-29",
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "instacart",
      "earnRate": 5.0,
      "description": "Starting 2025-04-30: 5% total back on the first $6,000 spent annually on qualifying purchases made directly through Instacart.com or the Instacart app, including Instacart memberships and subscriptions. Exclusions may apply; see instacart.com/InstacartMastercard.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": "2025-04-30",
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1874
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1874,
    "high": 0.2824,
    "description": "Purchase APR 18.74%\u201328.24% variable with the market based on the Prime Rate (7.25% as of 9/23/2025; Prime +11.49% to +20.99%; max APR 29.99%). Balance Transfer APR 18.74%\u201328.24% variable. Cash Advance APR 28.99% variable. Penalty APR up to 29.99% variable. Note: This account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases made outside the United States. Estimated value: saves up to ~3% on foreign purchases compared to cards that charge a foreign transaction fee.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "New cardmember offer: Receive a $50 Instacart credit automatically upon approval. Instacart new cardmember bonuses are valid only once per Instacart account. Chase eligibility: you must not currently have the Instacart Mastercard and must not have received a cash back new cardmember bonus for this card in the past 24 months. Credit typically loads immediately upon approval (may take up to 10 days). Instacart credit exclusions include restaurant orders on Instacart powered by Uber Eats, alcohol, gift cards, prescriptions, fees, taxes, and tips; not redeemable for cash; U.S. use only; single Instacart account use.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "instacart_credit",
          "amount": 50.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://creditcards.chase.com/cash-back-credit-cards/instacart?CELL=6269",
  "learn_more_link": "https://creditcards.chase.com/cash-back-credit-cards/instacart?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60680.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/instacart/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "chase_instacart_mastercard.png"
},
  [CreditCard.EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD,
  "name": "Emirates Skywards Rewards World Elite Mastercard",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/EKS_card_rRGB_Rewards_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.EMIRATES,
  "rewards_earn_rates": [
    {
      "category": "emirates_airlines",
      "earnRate": 3.0,
      "description": "Earn 3 Skywards Miles per $1 spent on eligible purchases directly with Emirates at emirates.com or at Emirates Sales offices.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "Earn 2 Skywards Miles per $1 spent on eligible travel purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 Skywards Mile per $1 on all other purchases that are not with Emirates.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Variable APR for purchases is 0.2024 to 0.2999 based on creditworthiness and varies with the Prime Rate. APR for balance transfers is 0.0 introductory for the first 12 billing cycles on transfers that post within 45 days of account opening; thereafter 0.2024 to 0.2999 variable. APR for cash advances is 0.2999 variable."
  },
  "benefits": [
    {
      "name": "Emirates Skywards Silver status",
      "description": "Complimentary Emirates Skywards Silver tier during your first cardmember year; retain your tier status in subsequent years by spending $20,000 each cardmembership year (per Barclays terms).",
      "benefit_type": "airline_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% discount when buying or gifting Skywards Miles",
      "description": "Receive a 25% savings when you Buy Skywards Miles for yourself or Gift Miles while your account remains open.",
      "benefit_type": "points_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a bonus of Skywards Miles after spending $3,000 in purchases within the first 90 days of account opening (exact miles amount not shown in provided content). Estimation note: Skywards Miles are often valued around 1.2 cents each; for example, if the offer were 30,000 miles, that would be roughly $360 in value (illustrative only).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 40000,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/emirates-skywards-rewards-world-elite-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/emirates-skywards-rewards-world-elite-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "emirates_skywards_rewards_world_elite_mastercard.png"
},
  [CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD]: {
  "id": CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD,
  "name": "Hilton Honors American Express Surpass\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000328_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.HILTON,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.hilton",
      "earnRate": 12.0,
      "description": "12X points on eligible purchases made directly with hotels and resorts within the Hilton portfolio.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 6.0,
      "description": "6X points at U.S. restaurants (includes takeout and delivery).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 6.0,
      "description": "6X points at U.S. supermarkets.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 6.0,
      "description": "6X points at U.S. gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineShopping",
      "earnRate": 4.0,
      "description": "4X points on U.S. online retail purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "3X points on other eligible purchases (non-bonus categories).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 150.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "Hilton Honors Gold Status",
      "description": "Complimentary Hilton Honors Gold status for as long as you have the card. Includes on-property benefits such as bonus points on stays, space-available upgrades at select properties, and daily food & beverage credit at select U.S. brands or continental breakfast at select brands outside the U.S. (per Hilton program terms).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Hilton Statement Credit",
      "description": "Get up to $50 in statement credits each calendar quarter for purchases made directly with properties in the Hilton portfolio on your card (up to $200 total per calendar year). Estimate: up to $200/year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free Night Reward after $15,000 spend",
      "description": "Earn one Free Night Reward from Hilton Honors after you spend $15,000 on eligible purchases on the card in a calendar year. Earnable each calendar year you meet the spend. Estimated value often ~$150\u2013$300+ depending on redemption.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "National Car Rental Emerald Club Executive Status",
      "description": "Complimentary National Car Rental Emerald Club Executive status, including Executive Area Access for full-size reservations and above in the U.S. and Canada. Enrollment through your Amex online account is required. Terms apply.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Upgrade to Hilton Honors Diamond Status with spend",
      "description": "Spend $40,000 on eligible purchases on the card in a calendar year to earn an upgrade to Hilton Honors Diamond status through the end of the next calendar year. Includes enhanced on-property benefits like 100% base points bonus, premium Wi\u2011Fi at select properties, daily F&B credit at select U.S. brands or continental breakfast at select brands outside the U.S., space-available room upgrades, and lounge access at select properties.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$200 Hilton Statement Credit",
      "description": "Up to $50 back in statement credits each calendar quarter on purchases made directly with Hilton portfolio properties (up to $200/year). Enrollment not required; use your card at Hilton properties. Terms apply.",
      "credit_type": "quarterly_credit",
      "credit_category": {
        "categories": [
          "travel.hotel"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Direct purchases with hotels and resorts within the Hilton portfolio worldwide."
      },
      "new_credit_category": null,
      "value": 50.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "quarterly",
          "values": [
            50.0,
            50.0,
            50.0,
            50.0
          ]
        }
      ],
      "total_yearly_value": 200.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 130,000 Hilton Honors Bonus Points plus a Free Night Reward after you spend $3,000 in purchases in the first 6 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 155000.0,
          "value_unit": "points",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/hilton-honors-surpass/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/hilton-honors-surpass/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "hilton_honors_american_express_surpass_card.avif"
},
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD]: {
  "id": CreditCard.SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD,
  "name": "Southwest Rapid Rewards\u00ae Priority Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/southwest_rapid_rewards_priority_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.SOUTHWEST,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.southwest",
      "earnRate": 4.0,
      "description": "4x points on purchases made directly with Southwest Airlines, including flight, inflight, Southwest gift cards, and Southwest Vacations/Getaways by Southwest packages. Excludes Southwest Charters and Southwest Cargo. Effective ongoing; terms updated 1/1/2026 to exclude Southwest Cruises.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x points on gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x points on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2x points on local transit and commuting purchases from 7/24/2025 through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "2x points on internet, cable, and phone services from 7/24/2025 through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "2x points on select streaming services from 7/24/2025 through 12/31/2025 (only select providers qualify per Chase\u2019s streaming list).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point on all other purchases. Excludes transactions that are not purchases (e.g., balance transfers, cash advances, cash-like transactions, lottery/gambling, checks that access the account, interest, fees, and unauthorized/fraudulent charges).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 229.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 229.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs based on Prime. Purchases: 0.1974\u20130.2824. Balance transfers: 0.1974\u20130.2824. Cash advances: 0.2899. Penalty APR: up to 0.2999 (may apply if a minimum payment is late or a payment is returned and can remain indefinitely). Minimum interest charge: none. Grace period: at least 21 days on purchases if the full balance or Interest Saving Balance is paid by the due date; interest on balance transfers and cash advances begins on the transaction date. Balance transfer fee: 0.05 (min $5). Late fee up to $40; returned payment fee up to $40. Note: account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "7,500 anniversary Rapid Rewards points",
      "description": "Receive 7,500 Rapid Rewards points each account anniversary year (posts within ~8 weeks after the anniversary period closes). Estimated value \u2248 $98 assuming ~1.3\u00a2/point; actual value varies by fare.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "10,000 Companion Pass qualifying points boost",
      "description": "Get one boost of 10,000 Companion Pass qualifying points deposited each calendar year (by Jan 31 or within ~30 days of account opening for the first year). Helps toward earning Companion Pass; not redeemable for travel.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "2,500 Tier Qualifying Points per $5,000 in purchases",
      "description": "Earn 2,500 tier qualifying points (TQPs) toward A\u2011List/A\u2011List Preferred for each $5,000 spent annually (tracking period defined in terms).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 5000,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred or Standard seat selection at booking",
      "description": "Primary cardmember can select a Preferred or Standard seat at booking (or up to 30 minutes pre\u2011departure) for themselves and up to 8 companions on the same reservation, when available. Authorized users are not eligible. Account must be open and not in default.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extra Legroom seat upgrade within 48 hours of departure",
      "description": "Primary cardmember can upgrade to an Extra Legroom seat within 48 hours of departure for themselves and up to 8 companions on the same reservation, when available. Authorized users are not eligible. Account must be open and not in default. Value varies by route; often ~$15\u2013$60 per person each way.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 5 boarding",
      "description": "Primary cardmember (and up to 8 companions on the same reservation) may board with Group 5 on Southwest\u2011operated flights. Authorized users are not eligible. Account must be open and not in default.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "First checked bag free",
      "description": "Primary cardmember and up to 8 companions on the same reservation get their first standard checked bag free on Southwest\u2011operated flights (oversize/overweight fees may apply; not valid on partner flights). Example value if standard bag fee were $35 each way: ~$70 round\u2011trip per person.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on Southwest inflight purchases",
      "description": "Get 25% back as a statement credit on Southwest inflight purchases (drinks and Wi\u2011Fi) made with the card. Posts within 6\u20138 weeks. Applies to authorized user purchases as well.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$75 Southwest annual travel credit",
      "description": "Automatically receive up to $75 per account anniversary year in statement credits for Southwest purchases (excludes Upgraded Boardings and inflight purchases). Value: up to $75 per year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to 4 Upgraded Boardings reimbursed per anniversary year",
      "description": "Receive statement credits for up to 4 purchases of Upgraded Boardings (A1\u2013A15) each anniversary year when bought with the card. Price varies by itinerary; typical cost ~$30\u2013$80 each (potential annual value up to ~$120\u2013$320). Note: This benefit will not apply to flights with assigned seating in 2026.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass (DoorDash & Caviar)",
      "description": "12 months of DashPass when first activated with this card between 02/01/2025 and 12/31/2027; auto\u2011renews at then\u2011current rate unless canceled. Estimated value \u2248 $120 assuming $9.99/month.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Quarterly $10 discount on DoorDash non\u2011restaurant order",
      "description": "While enrolled in the complimentary DashPass with this card, get $10 off one qualifying non\u2011restaurant DoorDash order each calendar quarter (limit 1/quarter, no rollover). Estimated value up to $40/year if used each quarter.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$75 Southwest annual travel credit",
      "description": "Automatically receive up to $75 per account anniversary year in statement credits for Southwest purchases (excludes Upgraded Boardings and inflight purchases).",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 75.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to 4 Upgraded Boardings credit",
      "description": "Statement credits for up to 4 purchases of Upgraded Boardings (A1\u2013A15) each anniversary year when purchased with the card. Price varies by itinerary; typical cost ~$30\u2013$80 each.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "25% back on Southwest inflight purchases",
      "description": "25% back as a statement credit for Southwest inflight drinks and Wi\u2011Fi purchased with the card.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "DoorDash non\u2011restaurant $10 quarterly discount",
      "description": "$10 off one qualifying non\u2011restaurant DoorDash order each calendar quarter while enrolled in DashPass with this card (no rollover).",
      "credit_category": "dining.takeoutDelivery.doordash",
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 50,000 Rapid Rewards points after you spend $1,000 on purchases in the first 3 months from account opening. Offer not available to (i) current Southwest Rapid Rewards consumer credit cardmembers, or (ii) previous Southwest Rapid Rewards consumer credit cardmembers who received a new cardmember bonus within the last 24 months. Business cardholders are excluded from this restriction. Account must be open and not in default at fulfillment; allow up to 8 weeks for points to post.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HVTN&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/southwest/priority?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62417.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/swaprioritycard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "southwest_rapid_rewards_priority_credit_card.png"
},
  [CreditCard.DISCOVER_IT_CASH_BACK_CREDIT_CARD]: {
  "id": CreditCard.DISCOVER_IT_CASH_BACK_CREDIT_CARD,
  "name": "Discover it\u00ae Cash Back",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-cash-it-bluecard-600-370.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "quarterly_categories",
      "earnRate": 5.0,
      "description": "5% Cashback Bonus on rotating categories (per quarter) up to $1,500 in combined purchases when activated; categories and restrictions as listed for each quarter; rewards typically post within two billing periods.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only",
        "require_activation"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "grocery",
              "wholesaleClub",
              "streaming"
            ],
            "exclude_subcategories": null,
            "is_us_only": true,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": "Q1",
            "start_date": "2026-01-01",
            "end_date": "2026-03-31",
            "category_description": "Q1 2026: Grocery Stores (supermarkets, meat lockers, bakeries, smaller grocery stores, grocery delivery services; Walmart and Target purchases are not eligible; some convenience/discount stores may not qualify), Wholesale Clubs (acceptance varies; affiliated services like delivery, travel, and cell phone purchases may be ineligible; individual merchants/stand\u2011alone stores within clubs or online may be ineligible), and Select Streaming Services (e.g., Amazon Music/Prime Video, AMC+, Apple Music/TV, Audible, DirecTV Stream, Fandango at Home, Google Play, Max, iHeartRadio, MLB.TV, Netflix, Pandora, Paramount+, Peacock, SiriusXM, Sling TV, Spotify, Starz, YouTube Music/Premium/TV; bundled or third\u2011party\u2011billed subscriptions and certain add\u2011ons may be ineligible)."
          }
        ],
        "categoryRotationFrequency": Frequency.QUARTERLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Rotating 5% categories each quarter; activation required; combined purchases in listed categories earn 5% on up to $1,500 per quarter; U.S. merchants only; merchant MCC and third\u2011party payment details must qualify.",
        "startDate": null,
        "endDate": null
      }
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "5% rotating categories (activation required, $1,500 quarterly cap)",
      "description": "Earn 5% Cashback Bonus on up to $1,500 in purchases each quarter in rotating categories when you activate. 2025 categories: Q1 Restaurants, Home Improvement Stores, Select Streaming Services; Q2 Grocery Stores and Wholesale Clubs; Q3 Gas Stations & EV Charging, Public Transit, Utilities; Q4 Amazon.com and Drug Stores. 2026 Q1: Grocery Stores, Wholesale Clubs, Select Streaming Services. Purchases must be with U.S. merchants; eligibility depends on merchant category codes and certain third\u2011party/digital wallet transactions may not qualify. Estimated value: up to $75 per quarter ($300 per year) if you max the $1,500 cap each quarter.",
      "benefit_type": "rotating_quarterly_rewards",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.discovercard.com/application/website/apply?srcCde=GJVP&ICMPGN=ALL_CC_CB_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "learn_more_link": "https://www.discovercard.com/application/website/apply?srcCde=GJVP&ICMPGN=ALL_CC_CB_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://www.discover.com/credit-cards/cash-back/it-card/reviews/#all-reviews"
    },
    {
      "name": "Link 3",
      "url": "https://www.discover.com/credit-cards/cash-back/cashback-calendar.html?link=%2Fweb%2Frewards%2F5percent%2F"
    }
  ],
  "bank_name": "Discover",
  "imageName": "discover_it_cash_back_credit_card.png"
},
  [CreditCard.AEROPLAN_CARD]: {
  "id": CreditCard.AEROPLAN_CARD,
  "name": "Aeroplan\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/aeroplan_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AIR_CANADA_AEROPLAN,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.airCanadaAeroplan",
      "earnRate": 3.0,
      "description": "3x points on purchases made directly with Air Canada. Excludes: gift cards; car rentals, hotel bookings, and other third\u2011party partner products and services purchased through aircanada.com; onboard Wi\u2011Fi. Air Canada tickets purchased via travel agencies, discount travel sites, vacation clubs, tour operators, or as part of a travel package offered by non\u2011airline merchants will not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3x points at grocery stores. Merchant eligibility is based on merchant category codes; purchases may not qualify if the merchant is not coded as a grocery store or if processed through third\u2011party payment systems not set up to pass the grocery category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3x points on dining at restaurants, including takeout and eligible delivery services. Merchant eligibility is based on restaurant coding; some delivery services may not qualify if not coded as restaurants or if processed through third\u2011party wallets not set up to pass the dining category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases that do not fall into the above bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2874,
    "apr_low": 0.2024
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2874,
    "description": "Variable APRs based on Prime Rate (7.25% as of 09/23/2025): Purchases 0.2024\u20130.2874; Balance transfers 0.2024\u20130.2874; Cash advances 0.2899; Penalty APR up to 0.2999. Minimum interest charge: none. Note: Account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "Free first checked bag on Air Canada-operated flights",
      "description": "Primary cardmember and up to 8 companions on the same reservation each get the first checked bag free (up to 50 lb) when checking in with Air Canada, Air Canada Rouge or Air Canada Express. Must check at the counter; gate-checked bags not eligible. If the bag is already complimentary via fare or elite status, no extra benefit applies.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Aeroplan 25K Status for new cardmembers",
      "description": "Complimentary Aeroplan 25K Status for the calendar year in which the account is opened and the following calendar year (not available to current/previous cardmembers who received this benefit in the last 60 months). Account must be linked to your Aeroplan number and remain open and in good standing. Note: Aeroplan Elite Status changes effective Jan 1, 2026 may affect this benefit.",
      "benefit_type": "airline_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Maintain or requalify for Aeroplan 25K Status with spend",
      "description": "Earn Aeroplan 25K Status through the following calendar year each year you spend at least $15,000 in purchases on the card. Calculation resets Jan 1 each year. Status is non-transferable and requires account to remain open and in good standing.",
      "benefit_type": "airline_status",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Aeroplan Elite Status Level Up with $50,000 annual spend",
      "description": "Each calendar year you spend at least $50,000, receive a one-level Aeroplan Elite Status increase for the next calendar year (e.g., from 25K to 35K). If you otherwise earn Super Elite for the next year and also meet the $50,000 spend, you can gift one 50K status. Limited to one level-up per year; not cumulative year-to-year.",
      "benefit_type": "airline_status",
      "new_benefit_type": null,
      "spend_requirement": 50000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred pricing on Air Canada flight rewards",
      "description": "Cardmembers often require fewer Aeroplan points to redeem for Air Canada-operated flight rewards versus non-cardmembers. Applies only to Air Canada flights; subject to change by Aeroplan.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the application fee for Global Entry, TSA PreCheck, or NEXUS is charged to the card by the primary or an authorized user via eligible channels. Account must be open and not in default.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass",
      "description": "12 months of DashPass when activated with the Aeroplan Card between 02/01/2025 and 12/31/2027; membership auto-renews at the then-current rate unless canceled. Must use the Aeroplan Card at checkout and meet merchant/order eligibility; U.S. address required.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "World Elite Mastercard Concierge",
      "description": "Access to concierge services; cardmember is responsible for the cost of any goods or services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% Aeroplan bonus on Ultimate Rewards point transfers",
      "description": "If you also hold an eligible Chase Ultimate Rewards card, get a 10% Aeroplan bonus when you transfer 50,000+ UR points in a single transaction to Aeroplan, up to 25,000 bonus points per calendar year. Bonus posts within ~7 days; only valid to the primary cardmember\u2019s Aeroplan account and requires the Aeroplan Card account to be open and in good standing.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Purchases made in foreign currencies incur no foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the application fee for Global Entry, TSA PreCheck, or NEXUS is charged to the card by the primary or an authorized user via eligible channels. Account must be open and not in default.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn up to 100,000 Aeroplan points: 75,000 bonus points after $4,000 in purchases in the first 3 months from account opening, plus 25,000 additional bonus points after a total of $20,000 in purchases in the first 12 months (cumulative). Not available to current Aeroplan Card cardmembers or previous cardmembers who received a new cardmember bonus on this card in the past 24 months. Please allow 6\u20138 weeks for bonus points to post. Account must be open and not in default at fulfillment. Offers may vary by application channel.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 75000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": 20000.0,
      "spendRequirementMonths": 12,
      "description": "Earn up to 100,000 Aeroplan points: 75,000 bonus points after $4,000 in purchases in the first 3 months from account opening, plus 25,000 additional bonus points after a total of $20,000 in purchases in the first 12 months (cumulative). Not available to current Aeroplan Card cardmembers or previous cardmembers who received a new cardmember bonus on this card in the past 24 months. Please allow 6\u20138 weeks for bonus points to post. Account must be open and not in default at fulfillment. Offers may vary by application channel.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 25000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HVD5&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/aircanada/aeroplan?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62259.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/aeroplancard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "aeroplan_card.png"
},
  [CreditCard.BILT_MASTERCARD]: {
  "id": CreditCard.BILT_MASTERCARD,
  "name": "Bilt World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/bilt_mastercard.png",
  "recommendedMinCreditScore": null,
  "availability": "discontinued",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BILT_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "rent",
      "earnRate": 1.0,
      "description": "1x on rent paid through Bilt. Requires 5+ posted transactions in the statement period to earn at the 1x rate; otherwise a flat 250 points posts for the rent payment.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": 5,
      "minimumTransactionCountType": "across_all_categories",
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3x on dining. Requires 5+ posted transactions in the statement period to earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": 5,
      "minimumTransactionCountType": "across_all_categories",
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 6.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Rent Day double points on dining: valid only on the 1st day of each month from 12:00am ET to 11:59pm PT. Excludes rent and certain third-party or mobile wallet transactions, capped at 1,000 bonus points per month across Rent Day bonuses, and still requires 5+ posted transactions in the statement period.",
          "promotional_type": PromotionalType.BILT_RENT_DAY
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 2.0,
      "description": "2x on travel when booked directly with airlines, hotels, rental car agencies, and cruise lines. Requires 5+ posted transactions in the statement period to earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": 5,
      "minimumTransactionCountType": "across_all_categories",
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Rent Day double points on travel: valid only on the 1st day of each month from 12:00am ET to 11:59pm PT. Excludes rent, capped at 1,000 bonus points per month across Rent Day bonuses, and still requires 5+ posted transactions in the statement period.",
          "promotional_type": PromotionalType.BILT_RENT_DAY
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2x on travel when booked directly with airlines, hotels, rental car agencies, and cruise lines. Requires 5+ posted transactions in the statement period to earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": 5,
      "minimumTransactionCountType": "across_all_categories",
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Rent Day double points on travel: valid only on the 1st day of each month from 12:00am ET to 11:59pm PT. Excludes rent, capped at 1,000 bonus points per month across Rent Day bonuses, and still requires 5+ posted transactions in the statement period.",
          "promotional_type": PromotionalType.BILT_RENT_DAY
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 2.0,
      "description": "2x on travel when booked directly with airlines, hotels, rental car agencies, and cruise lines. Requires 5+ posted transactions in the statement period to earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": 5,
      "minimumTransactionCountType": "across_all_categories",
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Rent Day double points on travel: valid only on the 1st day of each month from 12:00am ET to 11:59pm PT. Excludes rent, capped at 1,000 bonus points per month across Rent Day bonuses, and still requires 5+ posted transactions in the statement period.",
          "promotional_type": PromotionalType.BILT_RENT_DAY
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.cruise",
      "earnRate": 2.0,
      "description": "2x on travel when booked directly with airlines, hotels, rental car agencies, and cruise lines. Requires 5+ posted transactions in the statement period to earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": 5,
      "minimumTransactionCountType": "across_all_categories",
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Rent Day double points on travel: valid only on the 1st day of each month from 12:00am ET to 11:59pm PT. Excludes rent, capped at 1,000 bonus points per month across Rent Day bonuses, and still requires 5+ posted transactions in the statement period.",
          "promotional_type": PromotionalType.BILT_RENT_DAY
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "Up to 2x on travel booked through the Bilt Travel Portal, subject to portal terms and timing rules; portions paid with points are ineligible. 5\u2011transaction minimum may not apply to some portal bookings per program rules.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.lyft",
      "earnRate": 3.0,
      "description": "3x on Lyft rides when you pay with the Bilt Mastercard (no linking required). Not subject to the 5\u2011transaction minimum.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 5.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Link your Bilt Rewards account in the Lyft app, set Bilt as the active loyalty partner, and pay with the Bilt Mastercard to earn 5x total points (extra 2x) on eligible U.S. Lyft rides; excludes bikes/scooters and certain fees per Lyft and Bilt terms.",
          "promotional_type": PromotionalType.BILT_CONNECT_TO_LYFT
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x on other purchases that don\u2019t qualify for higher category rates. Requires 5+ posted transactions in the statement period to earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": 5,
      "minimumTransactionCountType": "across_all_categories",
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Rent Day double points on other purchases (excluding rent, travel, and dining): valid only on the 1st day of each month from 12:00am ET to 11:59pm PT. Capped at 1,000 bonus points per month across Rent Day bonuses, excludes certain third-party or mobile wallet transactions, and still requires 5+ posted transactions in the statement period.",
          "promotional_type": PromotionalType.BILT_RENT_DAY
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable APR based on creditworthiness and the U.S. Prime Rate. Purchases: 0.2024, 0.2324, or 0.2824 (20.24%, 23.24%, or 28.24%). Balance transfers: same as purchases. Cash advances: 0.2799 (27.99%). Minimum interest charge $1. Grace period: at least 25 days on purchases if paid in full."
  },
  "benefits": [
    {
      "name": "Waived transaction fee on rent payments",
      "description": "The card waives the rent payment processing fee when you pay rent via the Bilt app or website with the Bilt Mastercard. Estimated savings depend on your landlord\u2019s typical fee; for example, at a 3% fee a $3,000 monthly rent would save ~$90/month (~$1,080/year).",
      "benefit_type": null,
      "new_benefit_type": "waived_rent_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free rent reporting",
      "description": "Boost your credit with free rent reporting for payments made through Bilt (as advertised on the card page).",
      "benefit_type": null,
      "new_benefit_type": "free_rent_reporting",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rent Day double points (1st of each month)",
      "description": "On the 1st day of each month, earn double points on dining, travel, and other purchases (excluding rent) up to 1,000 bonus points, if you made at least 5 transactions in the statement period. Certain transaction types are excluded (e.g., tax payments, third-party payment accounts, some mobile/digital wallet transactions). Estimated monthly value up to 1,000 points (~$10\u2013$15 if you assume ~1.0\u20131.5 cents per point; actual value varies by redemption).",
      "benefit_type": null,
      "new_benefit_type": "rent_day_double_points",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Protection",
      "description": "Reimburses nonrefundable Common Carrier tickets for covered reasons when you pay the entire fare with the card/points. Coverage up to $5,000 per covered traveler per trip; secondary to other reimbursements.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Reimbursement",
      "description": "If a trip on a Common Carrier is delayed 6+ hours, reimburses reasonable expenses (e.g., food, lodging, lounge day passes) at $200 per day per covered traveler for up to 3 days; maximum $1,800 total per trip for all covered travelers; secondary coverage.",
      "benefit_type": null,
      "new_benefit_type": "trip_delay_reimbursement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Primary)",
      "description": "Covers damage or theft to a rental car when you pay in full with the card and decline the rental company\u2019s CDW. Primary coverage in the U.S. (except NY residents) and primary outside the U.S.; up to $50,000; rentals up to 31 consecutive days; certain countries excluded (e.g., Israel, Jamaica, Republic of Ireland/Northern Ireland).",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on international purchases. Typical savings is about 3% compared to many cards that charge this fee.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points transfer to airline/hotel partners",
      "description": "Convert Bilt Points into airline miles or hotel points; Elite Status may unlock transfer bonuses from time to time.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Book travel with points + cash (Bilt Travel Portal)",
      "description": "Use Bilt Points alone or combine points + cash to book flights, hotels, cars, and more via the Bilt Travel Portal.",
      "benefit_type": null,
      "new_benefit_type": "travel_portal_points_plus_cash",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Telephone Protection",
      "description": "When you pay your monthly wireless bill with the card, get cell phone protection for damage, theft, or involuntary/accidental parting. Up to $800 per claim, $1,600 per 12 months; max 2 paid claims per 12 months; $25 deductible per claim; supplemental to other coverage.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Security",
      "description": "Reimburses for eligible items that are damaged or stolen within 90 days of purchase when paid with the card/associated rewards. Up to $10,000 per item; $50,000 per 12 months; excess of other insurance.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection",
      "description": "No-cost identity theft monitoring and resolution services (enrollment required), including dark web monitoring, credit monitoring (TransUnion), and specialist support.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge and Mastercard Travel & Lifestyle Services",
      "description": "24/7 personal concierge for travel, dining, and lifestyle needs, plus Mastercard Lowest Hotel Rate Guarantee and Hotel Stay Guarantee via Mastercard Travel & Lifestyle Services. Costs of goods/services billed to your card.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard Golf access",
      "description": "Access to a network of TPC clubs, golf packages, schools, and select PGA TOUR event experiences (costs billed to your card).",
      "benefit_type": null,
      "new_benefit_type": "mastercard_golf_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Fast track to Bilt Elite Status and Milestone Rewards",
      "description": "Earn Milestone Rewards every 25,000 qualifying points in a calendar year toward Bilt Elite Status (e.g., temporary points multipliers in select categories, collection points, Lyft boosts, etc.). Elite Status may also provide transfer bonuses, early access to experiences, and status-match opportunities.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "Wells Fargo",
  "imageName": "bilt_mastercard.png"
},
  [CreditCard.SIGNIFY_BUSINESS_CARD]: {
  "id": CreditCard.SIGNIFY_BUSINESS_CARD,
  "name": "Signify Business Cash\u00ae",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/rv/assets/signify-card-shiny.lrweRqwi_1lC2Le.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Earns 2% cash rewards on all qualifying purchases. Exclusions: cash advances and equivalents (ATM transactions, cash advances, money orders, pre-paid gift cards, traveler\u2019s checks, wire transfers, peer-to-peer payments, overdraft protection advances), disputed or illegal purchases, purchases that violate program or account terms, any fees or interest (including foreign transaction fees, late fees), and gambling transactions (online bets/wagers, casino gaming chips, lottery tickets, off-track wagers). No category restrictions or spending caps.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2524,
    "apr_low": 0.1724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1724,
    "high": 0.2524,
    "description": "0% introductory APR on purchases for 12 months from account opening; after that, variable purchase APR 17.24%\u201325.24% based on creditworthiness and U.S. Prime Rate. Cash advances and overdraft protection advances APR: 29.99% variable. Minimum interest charge: $1. Paying interest: at least 25-day grace period on purchases if paid in full each month."
  },
  "benefits": [
    {
      "name": "Priority Pass membership (pay-per-visit)",
      "description": "Complimentary Priority Pass membership giving access to 1,300+ airport lounges worldwide; lounge visits are pay-as-you-go. Enrollment may be required.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Worldwide Automatic Common Carrier Travel Accident Insurance",
      "description": "Up to $250,000 in travel accident insurance when the common carrier fare is purchased with the card.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "MasterRental Insurance Coverage",
      "description": "Coverage for damage to or theft of a rental vehicle when rented and paid with the card; terms apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard Business Assistant",
      "description": "24/7 assistance for arranging business travel or meetings and recommendations; concierge-style support.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Identity theft monitoring, alerts, and expert resolution 24/7/365; enrollment required.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Liability Protection",
      "description": "You will not be held responsible for unauthorized transactions if reported promptly.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $500 cash rewards bonus after at least $5,000 in qualifying purchases (purchases minus returns/credits) post to the account within 3 months of account opening. Excludes cash advances and equivalents, fees/interest, disputed/illegal transactions, and gambling transactions. Bonus becomes redeemable within 1\u20132 billing periods after it\u2019s earned. Offer availability may vary by channel; must apply via the offer link.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 500.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://apply.wellsfargo.com/getting_started?FPID=7086BAI6000000&product_code=BD&subproduct_code=BCMC&applicationtype=businesscreditcard&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "learn_more_link": "https://creditcards.wellsfargo.com/business-credit-cards/signify-business-cash-credit-card/?FPID=7086BAI6000000&product_code=BD&subproduct_code=BCMC&cx_nm=CXNAME_CSMPD_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_link": "https://www.wellsfargo.com/biz/business-credit/credit-cards/signify-business-cash-credit-card-terms-conditions?FPID=7086BAI6000000&product_code=BD&subproduct_code=BCMC&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [],
  "bank_name": "Wells Fargo",
  "imageName": "signify_business_card.png"
},
  [CreditCard.PNC_CASH_REWARDS_VISA]: {
  "id": CreditCard.PNC_CASH_REWARDS_VISA,
  "name": "PNC Cash Rewards\u00ae Visa\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/pnc_cash_rewards_visa.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 4.0,
      "description": "4% cash back on gas station purchases, subject to combined $8,000/year cap.",
      "spendCap": 8000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3% cash back on dining, subject to combined $8,000/year cap.",
      "spendCap": 8000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% cash back on grocery store purchases, subject to combined $8,000/year cap.",
      "spendCap": 8000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2849,
    "apr_low": 0.1849
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1849,
    "high": 0.2849,
    "description": ""
  },
  "benefits": [
    {
      "name": "Cell Phone Protection",
      "description": "Up to $800 per claim ($50 deductible, max 2 claims per 12 months) when you pay your monthly wireless bill with the card.",
      "benefit_type": null,
      "new_benefit_type": "cell_phone_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "$200 statement credit after spending $1,000 in first 3 months.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": "https://www.pnc.com/en/personal-banking/banking/credit-cards/pnc-cash-rewards-visa-credit-card.html",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "PNC",
  "imageName": "pnc_cash_rewards_visa.png"
},
  [CreditCard.AMERICAN_EXPRESS_GOLD_CARD]: {
  "id": CreditCard.AMERICAN_EXPRESS_GOLD_CARD,
  "name": "American Express\u00ae Gold Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000174_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4x points at restaurants worldwide on up to $50,000 in purchases per calendar year. Exclusions per terms include restaurants located within another establishment (e.g., inside a hotel/casino/venue), events held within a restaurant, event tickets, third\u2011party food delivery services outside the U.S., and purchases at bars, nightclubs, cafeterias, caterers, theatre clubs, breweries, bakeries, and meeting venues. Merchant category coding must qualify as restaurant.",
      "spendCap": 50000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 4.0,
      "description": "4x points at U.S. supermarkets on up to $25,000 in purchases per calendar year; merchant must code as a supermarket.",
      "spendCap": 25000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 3.0,
      "description": "3x points on airfare on scheduled flights booked directly with passenger airlines or on AmexTravel.com. Charter/private jet flights excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2x points on prepaid hotels, prepaid car rentals, and cruise reservations booked through AmexTravel.com. Non\u2011prepaid car rentals/hotels and ticketing fees do not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 2.0,
      "description": "2x points on prepaid hotels, prepaid car rentals, and cruise reservations booked through AmexTravel.com. Non\u2011prepaid car rentals/hotels and ticketing fees do not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.cruise",
      "earnRate": 2.0,
      "description": "2x points on prepaid hotels, prepaid car rentals, and cruise reservations booked through AmexTravel.com. Non\u2011prepaid car rentals/hotels and ticketing fees do not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per dollar on other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 325.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2924,
    "apr_low": 0.2024
  },
  "annualFee": 325.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2924,
    "description": "Pay Over Time purchase APR: 20.24%\u201329.24% variable based on creditworthiness; varies with the Prime Rate. Cash advance APR: 29.49% variable. Penalty APR: up to 29.99% variable if you pay late or a payment is returned (applies for at least 6 months). Plan It fee: up to 1.33% per month of each purchase placed in a plan. No 0% intro APR disclosed. No foreign transaction fees."
  },
  "benefits": [
    {
      "name": "$120 Uber Cash",
      "description": "$10 in Uber Cash each month for U.S. rides or Uber Eats orders when an Amex Card is selected and the Gold Card is added to your Uber account. Uber Cash from this benefit expires monthly. Estimated annual value: $120 if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120 Dining Credit",
      "description": "Up to $10 in statement credits each month at participating partners (Grubhub/Seamless, The Cheesecake Factory, Goldbelly, Wine.com, Five Guys). Enrollment required. One credit per account per month across all cards. Estimated annual value: $120 if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$100 Resy Credit",
      "description": "Up to $100 in statement credits per calendar year for eligible purchases at U.S. Resy restaurants or via Resy Pay\u2014up to $50 Jan\u2013Jun and up to $50 Jul\u2013Dec. Enrollment required. Cap is per account across all cards. Estimated annual value: $100 if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$84 Dunkin\u2019 Credit",
      "description": "Up to $7 in monthly statement credits at U.S. Dunkin\u2019 locations after enrollment. Cap is per account across all cards. Estimated annual value: $84 if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "The Hotel Collection $100 Experience Credit",
      "description": "Book 2+ consecutive nights through AmexTravel.com at participating properties to receive a $100 credit per stay toward eligible on-property charges (type varies by property). Room upgrade, early check-in/late check-out are subject to availability. Credit is per room, per stay; not annual\u2014use as often as you qualify.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Insurance",
      "description": "Coverage for eligible trip delays when travel is purchased with the card; terms, conditions, and limits apply. Provided by New Hampshire Insurance Company (AIG).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Secondary coverage for damage or theft of a rental car when you pay with your card and decline the rental company\u2019s collision/damage waiver; exclusions and terms apply. Underwritten by AMEX Assurance Company.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage for lost, damaged, or stolen baggage on eligible trips purchased with the card; terms, conditions, and exclusions apply. Underwritten by AMEX Assurance Company.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Eligible new purchases may be covered against accidental damage or theft for a limited period; terms and exclusions apply. Underwritten by AMEX Assurance Company.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends eligible U.S. manufacturer\u2019s warranties on covered purchases; terms, limits, and exclusions apply. Underwritten by AMEX Assurance Company.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance when traveling; third-party service costs are your responsibility. Useful for lost passports, emergencies, and referrals.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No Amex foreign transaction fees on purchases made outside the U.S. Merchant/ATM fees may still apply.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Membership Rewards Points Transfer",
      "description": "Transfer Membership Rewards points to airline and hotel partners (a $0.0006/point excise fee applies to U.S. airline transfers, capped at $99). Partner availability varies.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$120 Uber Cash",
      "description": "$10 in Uber Cash per month for U.S. rides or Uber Eats when an Amex Card is selected and the Gold Card is added to your Uber account. Expires monthly; not a statement credit.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$120 Dining Credit",
      "description": "Up to $10 in monthly statement credits at Grubhub/Seamless, The Cheesecake Factory, Goldbelly, Wine.com, and Five Guys. Enrollment required. One credit per month per account.",
      "credit_category": "dining",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$100 Resy Credit",
      "description": "Up to $100 per calendar year in statement credits for eligible Resy purchases\u2014up to $50 Jan\u2013Jun and up to $50 Jul\u2013Dec. Enrollment required. Cap per account across all cards.",
      "credit_category": "dining",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY
    },
    {
      "name": "$84 Dunkin\u2019 Credit",
      "description": "Up to $7 in monthly statement credits at U.S. Dunkin\u2019 locations after enrollment. Cap per account across all cards.",
      "credit_category": "dining",
      "new_credit_category": null,
      "value": 84.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "The Hotel Collection $100 Experience Credit",
      "description": "$100 credit per eligible THC stay (2-night minimum) for on-property charges at participating hotels when booked via AmexTravel.com. Credit applied at checkout; frequency depends on usage.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars_per_stay",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "As high as 100,000 Membership Rewards points after you spend $6,000 on purchases in the first 6 months of Card Membership. Exact offer amount is disclosed after approval and may be less than 100,000. Not available to applicants who currently have or previously had this card or certain related cards; other eligibility factors apply. Points post 8\u201312 weeks after meeting the requirement. Estimated value (max scenario): ~$1,000\u2013$1,500 at ~1.0\u20131.5 cents per point (varies by redemption; higher via airline partners).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "american_express_gold_card.png"
},
  [CreditCard.BARCLAYS_G_M_BUSINESS_MASTERCARD]: {
  "id": CreditCard.BARCLAYS_G_M_BUSINESS_MASTERCARD,
  "name": "GM Business\u2122 Mastercard\u00ae",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-front/GMB_CD_Flat_Card_Art_359x226.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GM_BUSINESS_CARD_POINTS,
  "rewards_earn_rates": [
    {
      "category": "gm_purchases",
      "earnRate": 7.0,
      "description": "Earn 7x GM Business Card Points for every $1 spent on eligible GM purchases noted above. No limit to points earned. Per program rules, points are not earned on discounts, rebates, credits, shipping fees, state inspection fees, warranty repair work, or body shop repair orders. Points may only be earned and redeemed at GM dealers in the fifty United States and Washington, D.C., per the card\u2019s Reward Rules.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "Earn 3x GM Business Card Points for every $1 spent on all other purchases. No limit to points earned. Per the Reward Rules, points may only be earned and redeemed at GM dealers in the fifty United States and Washington, D.C.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3299,
    "apr_low": 0.2299
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2299,
    "high": 0.3299,
    "description": "Variable purchase APR 0.2299\u20130.3299 based on creditworthiness; varies with Prime. 0% intro APR for 9 billing cycles on qualifying GM purchases > $499 made within 30 days of account opening; 0% promotional APR for 6 billing cycles on qualifying GM purchases > $499 made after 30 days (not applicable to other purchases, balance transfers, or cash advances). Balance transfer APR variable 0.2299\u20130.3299; cash advance APR 0.3399. Minimum interest charge $1."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 5,
      "description": "Introductory bonus available: Earn an unspecified amount of GM Business Card Points after spending $5,000 in the first 5 months of account opening (exact bonus amount not provided in the source; see Terms and Conditions).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 100000,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/general-motors-business/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/general-motors-business/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "barclays_g_m_business_mastercard.png"
},
  [CreditCard.MARRIOTT_BONVOY_BUSINESS_CARD]: {
  "id": CreditCard.MARRIOTT_BONVOY_BUSINESS_CARD,
  "name": "Marriott Bonvoy Business\u00ae Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/amex-marriott-bonvoy-business.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.MARRIOTT_BONVOY,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.marriott",
      "earnRate": 6.0,
      "description": "6x points on eligible purchases charged directly with properties participating in Marriott Bonvoy, standalone Marriott\u2011branded retail establishments, and Marriott\u2011branded online stores (including online purchases of Marriott\u2011branded gift cards) owned or managed by Marriott. Merchant coding and use of third\u2011party processors/digital wallets may affect bonus eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4x points at restaurants worldwide. Merchant coding and use of third\u2011party processors/digital wallets may affect bonus eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 4.0,
      "description": "4x points on gasoline at U.S. gas stations. Merchant coding and use of third\u2011party processors/digital wallets may affect bonus eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 4.0,
      "description": "4x points on wireless telephone services purchased directly from U.S. service providers. Excludes Google Fi. Merchant coding and use of third\u2011party processors/digital wallets may affect bonus eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "shipping",
      "earnRate": 4.0,
      "description": "4x points on U.S. purchases for shipping. Merchant coding and use of third\u2011party processors/digital wallets may affect bonus eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2x points on all other eligible purchases not in the above bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 125.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 125.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable purchase APR 19.99%\u201328.99% based on creditworthiness (varies with Prime Rate; will not exceed 29.99%). Cash advance APR 29.24% variable. Penalty APR 29.99% variable may apply after a returned payment, two late payments in 12 billing periods, or not paying the Minimum Payment by the Closing Date; if applied, it lasts at least 12 billing periods. At least a 25\u2011day grace period on purchases; no interest charged on purchases if the entire balance is paid by the due date."
  },
  "benefits": [
    {
      "name": "Marriott Bonvoy Room Rate Discount (Amex Business Card Rate)",
      "description": "Receive a 7% discount off the Standard Flexible Room Rate on eligible bookings at participating Marriott Bonvoy hotels when booked under the Amex Business Card Rate via Marriott channels and while logged into the Bonvoy account linked to the card. Not combinable with other promos; excludes certain brands and rate types. Estimated value: saves 7% of eligible room rate; for example, $1,000/year in eligible spend could save ~$70.",
      "benefit_type": null,
      "new_benefit_type": "marriott_room_rate_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Free Night Award (up to 35,000 points) after renewal",
      "description": "Receive 1 Free Night Award each year after your card renewal month; valid for a one-night stay at participating Marriott Bonvoy hotels at or under 35,000 points. Deposited 8\u201312 weeks after renewal; expires 1 year from issuance; can top off with up to 15,000 points. Estimated value: roughly $175\u2013$280 based on ~0.5\u20130.8 cents per point for a 35k redemption (midpoint \u2248$210).",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Additional Free Night Award (up to 35,000 points) after $60,000 annual spend",
      "description": "Earn an extra Free Night Award in any calendar year you spend $60,000 on the card; valid up to 35,000 points at participating properties. Deposited 8\u201312 weeks after meeting spend; expires 1 year from issuance; can top off with up to 15,000 points. Estimated value: roughly $175\u2013$280 based on ~0.5\u20130.8 cents per point for a 35k redemption (midpoint \u2248$210).",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": 60000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "15 Elite Night Credits each calendar year",
      "description": "Receive 15 Elite Night Credits toward higher Marriott Bonvoy elite status each calendar year. Not exclusive to Amex-issued cards and limited to one eligible Marriott Bonvoy business card\u2019s ENC per Bonvoy account per year (highest ENC card applies). Initial deposit within ~60 days of opening; annually by March 1 thereafter.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Marriott Bonvoy Gold Elite Status",
      "description": "Gold Elite status with your card (basic card member only). Includes 25% bonus points on eligible hotel spend, 2 p.m. late checkout (subject to availability), and enhanced room upgrades where available. Applied within up to 12 weeks of account opening; removed if card is canceled. Estimated value varies by travel pattern; frequent Marriott guests may see material value from late checkout and bonus points.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premium on\u2011property Internet Access",
      "description": "Complimentary in-room premium internet at participating Marriott Bonvoy hotels for the primary card member (1 room per stay; Bonvoy number required; exclusions apply). Estimated value: often $5\u2013$15 per night where premium tiers are otherwise charged.",
      "benefit_type": null,
      "new_benefit_type": "premium_internet_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "0% foreign transaction fees on purchases made outside the U.S. (merchant/ATM fees may still apply). Estimated value: saves ~3% versus cards that charge FTF; e.g., $2,000 in foreign spend could save ~$60.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage when eligible common carrier fare is charged to the card (terms, conditions, and exclusions apply; see policy guide).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss & Damage Insurance",
      "description": "Secondary collision/loss damage coverage when you use the card to pay for an eligible rental and decline the rental agency\u2019s CDW/LDW (terms, conditions, and exclusions apply).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends eligible U.S. manufacturer\u2019s warranties on covered purchases (terms and limits apply).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Coverage for eligible new purchases against damage or theft for a limited period (terms, conditions, and exclusions apply).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance when traveling; third\u2011party service provider costs are the card member\u2019s responsibility (see terms).",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Marriott Bonvoy Points Transfer to Airlines (with 5k bonus miles per 60k transferred)",
      "description": "Transfer Bonvoy points to many airline programs; Marriott adds 5,000 bonus miles for every 60,000 points transferred (programs and ratios subject to change).",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Concessions Statement Credit",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at American Express Venue Collection stadiums/arenas, up to $250 back per calendar year after enrollment; offer currently scheduled through 12/31/2026. Estimated value: up to $250/year if you spend $2,500+ at eligible concessions.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "credit_type": "american_express_venue_collection_concessions",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Entrances and Fast Lanes",
      "description": "Access dedicated Amex Card Member entrances/fast lanes at select venues in the Amex Venue Collection (availability may vary by event and venue; terms apply).",
      "benefit_type": null,
      "new_benefit_type": "venue_fast_lane_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (when booking via AmexTravel)",
      "description": "If you find a lower publicly available online rate for the same room and conditions after booking via AmexTravel, Amex will refund the difference (exclusions apply).",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rates_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 8000.0,
      "spendRequirementMonths": 6,
      "description": "Limited Time Offer: Earn 125,000 Marriott Bonvoy bonus points after $8,000 in eligible purchases within the first 6 months of Card Membership. Account must be open and not past due at fulfillment; bonus typically posts 8\u201312 weeks after meeting the threshold and may post in multiple deposits. Offer ends 10/22/25 and is subject to Amex/Marriott family eligibility rules (certain current/past Chase/Amex Marriott cardholders may be ineligible).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 125000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amex-marriott-bonvoy-business-credit-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Marriott",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amex-marriott-bonvoy-business-credit-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Marriott",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/marriott-bonvoy-business-american-express-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/marriott-bonvoy-business-american-express-card/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "marriott_bonvoy_business_card.png"
},
  [CreditCard.BUSINESS_PLATINUM_CARD]: {
  "id": CreditCard.BUSINESS_PLATINUM_CARD,
  "name": "The Business Platinum Card\u00ae from American Express",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/aurora/aurora-hero-card.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "Earn 5 Membership Rewards points per $1 (1 base + 4 bonus) on eligible travel purchases: scheduled flights booked online at AmexTravel.com/Amex Travel App and prepaid hotel purchases made through American Express Travel. Excludes non-prepaid hotel bookings, vacation packages, car rentals, cruise, group reservations/events, ticketing/service fees, cancellation fees, interest, and cash-equivalent purchases. Purchases eligible for multiple additional point bonuses receive only the highest bonus.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Earn 5 Membership Rewards points per $1 (1 base + 4 bonus) on eligible travel purchases: scheduled flights booked online at AmexTravel.com/Amex Travel App and prepaid hotel purchases made through American Express Travel. Excludes non-prepaid hotel bookings, vacation packages, car rentals, cruise, group reservations/events, ticketing/service fees, cancellation fees, interest, and cash-equivalent purchases. Purchases eligible for multiple additional point bonuses receive only the highest bonus.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeImprovement",
      "earnRate": 2.0,
      "description": "Earn 2 Membership Rewards points per $1 on up to $2,000,000 per calendar year in purchases at U.S. construction material and hardware suppliers (merchant-code based). Purchases eligible for multiple additional point bonuses receive only the highest bonus.",
      "spendCap": 2000000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "electronics",
      "earnRate": 2.0,
      "description": "Earn 2 Membership Rewards points per $1 on up to $2,000,000 per calendar year in purchases at U.S. electronic goods retailers and U.S. software & cloud system providers (merchant-code based). Purchases eligible for multiple additional point bonuses receive only the highest bonus.",
      "spendCap": 2000000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "computerServices",
      "earnRate": 2.0,
      "description": "Earn 2 Membership Rewards points per $1 on up to $2,000,000 per calendar year in purchases at U.S. electronic goods retailers and U.S. software & cloud system providers (merchant-code based). Purchases eligible for multiple additional point bonuses receive only the highest bonus.",
      "spendCap": 2000000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "shipping",
      "earnRate": 2.0,
      "description": "Earn 2 Membership Rewards points per $1 on up to $2,000,000 per calendar year in purchases at U.S. shipping providers (merchant-code based). Purchases eligible for multiple additional point bonuses receive only the highest bonus.",
      "spendCap": 2000000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn at least 1 Membership Rewards point per $1 on other eligible purchases (purchases for goods and services minus returns/credits; excludes fees/interest and various cash-equivalent transactions).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 895.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1824
  },
  "annualFee": 895.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2899,
    "description": "Pay Over Time APR: 18.24% (Prime Rate + 10.99%) to 28.99% (Prime Rate + 21.74%), based on creditworthiness; variable with the market based on the Prime Rate. Penalty APR: 29.99% (Prime Rate + 25.99%), variable; applies if payment is returned, 2 late payments in 12 billing periods, or failure to pay Minimum Payment Due by the Closing Date; applies for at least 12 billing periods and continues until 12 billing periods of timely payments with no returned payments. Interest not charged if entire balance is paid by due date each month (due date at least 25 days after close of billing period)."
  },
  "benefits": [
    {
      "name": "The Global Lounge Collection\u00ae (Centurion Lounges + partners)",
      "description": "Access to The Global Lounge Collection including Centurion Lounge access and other partner lounges (e.g., Priority Pass Select, Plaza Premium, Escape Lounges, Lufthansa lounges). Terms, locations, guest policies and enrollment requirements vary by lounge program; access generally requires same-day travel boarding pass, eligible card, and ID. Delta Sky Club access is governed by a separate visit-based benefit described separately.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass\u2122 Select membership",
      "description": "Priority Pass Select membership (enrollment required) for U.S. Business Platinum Card Members and Additional Business Platinum Card Members. Provides access to participating Priority Pass lounges; typically includes complimentary access for up to 2 guests where permitted; additional guests may be charged by Priority Pass per lounge terms. Membership ends if the card account is canceled.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Delta Sky Club\u00ae Access (visit allotment; potential unlimited with spend)",
      "description": "Eligible Platinum Card Members receive 10 Delta Sky Club/Grab and Go Visits per Eligible Platinum Card each year (issued at account opening, then Feb 1 annually; expire Jan 31). Access only when traveling on same-day eligible Delta-operated flight (or Delta-marketed WestJet with ticket number starting 006); Basic Economy excluded. After 10 visits, cardholders may purchase visits ($50 per person) or Grab and Go visits ($25). Unlimited Delta Sky Club access can be unlocked after $75,000+ in eligible purchases on the account in a calendar year (processing may take up to 12 weeks; effective for remainder of that year, next year, and through Jan 31 following).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": 75000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Lufthansa Lounge Access \u2013 Platinum",
      "description": "Complimentary access to select Lufthansa Business Lounges (regardless of ticket class) and Lufthansa Senator Lounges (when flying business class) when flying on a Lufthansa Group flight (Lufthansa, SWISS, Austrian). Requires presenting eligible card, ID, and same-day boarding pass; guest access subject to lounge terms.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Plaza Premium Lounge access",
      "description": "Complimentary access to Plaza Premium Lounges globally for U.S. Business Platinum Card Members; may bring up to 2 companions as complimentary guests. Requires eligible card, ID and same-day boarding pass; age rules and house rules apply.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Escape Lounges access",
      "description": "Complimentary access to all Escape Lounge locations (including Centurion Studio Partner locations) for U.S. Business Platinum Card Members. Up to 2 complimentary guests per visit. Requires eligible card, ID, and same-day boarding pass; space availability and location rules apply.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "The Centurion\u00ae Lounge & guest policy spend threshold",
      "description": "Unlimited complimentary access to The Centurion\u00ae Lounge for U.S. Business Platinum Card Members. Guest fees generally apply ($50 per guest; $30 for children 2\u201317) unless cardholder qualifies for Complimentary Guest Access after $75,000+ in eligible purchases in a calendar year (processing may take up to 12 weeks; valid for remainder of that year, next year, and through Jan 31 following).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": 75000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Hilton Honors Gold Status",
      "description": "Complimentary Hilton Honors Gold status (enrollment required through Amex). Status remains as long as the card account remains eligible; subject to Hilton program terms and benefit availability by property.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Marriott Bonvoy\u00ae Gold Elite Status",
      "description": "Complimentary Marriott Bonvoy Gold Elite status (enrollment required through Amex). Status remains as long as the account remains eligible; subject to Marriott Bonvoy terms and benefit availability by property.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Leaders Club Sterling Status (The Leading Hotels of the World)",
      "description": "Complimentary Leaders Club Sterling Status from The Leading Hotels of the World (enrollment required; requires Leaders Club membership). Status maintained while card remains eligible; subject to program terms.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Fine Hotels + Resorts\u00ae (FHR) program benefits",
      "description": "Access to Fine Hotels + Resorts benefits on new bookings made through Amex Travel at participating properties (e.g., potential room upgrade at check-in, daily breakfast for two, property experience credit (often $100), and other on-property benefits), subject to availability and program terms. (Note: the separate $600 Hotel Credit is modeled as a credit, not a benefit.)",
      "benefit_type": "travel_insurance",
      "new_benefit_type": "hotel_program_benefits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "The Hotel Collection (THC) program benefits",
      "description": "Access to The Hotel Collection benefits on eligible bookings of 2+ consecutive nights through Amex Travel at participating properties; typically includes a $100 property credit for eligible charges and potential room upgrade (subject to availability) per program terms. (Note: the separate $600 Hotel Credit is modeled as a credit, not a benefit.)",
      "benefit_type": "travel_insurance",
      "new_benefit_type": "hotel_program_benefits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "International Airline Program (IAP)",
      "description": "Discounted fares on select premium cabin (and sometimes economy) international flights booked through Amex Travel for eligible Platinum Card Members; savings apply to base airfare and are subject to airline and program terms.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Dining Access by Resy",
      "description": "Access to Resy Global Dining Access features (exclusive reservations, Priority Notify, and select events) for eligible cardmembers; requires adding eligible card to Resy profile; reservations subject to availability and restaurant policies.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": "dining_reservation_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Platinum Nights by Resy",
      "description": "Access to Platinum Nights by Resy\u2014special in-restaurant reservations on select nights in select cities; reservations limited and subject to availability and cancellation policies; requires adding eligible card to Resy profile.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": "dining_reservation_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge",
      "description": "American Express Concierge assistance with event tickets, dining reservations, travel inquiries, and shopping requests; cardmember responsible for costs and third-party terms.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premium Global Assist\u00ae Hotline",
      "description": "Premium Global Assist Hotline coordination/assistance services at no additional charge from Amex; cardmember may be responsible for third-party costs. Emergency medical transportation assistance may be provided at no cost if approved and coordinated by the hotline (terms apply).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "Cell Phone Protection coverage at no additional cost when eligible wireless bills are paid with the card; coverage is provided by New Hampshire Insurance Company (AIG) and is excess of other applicable insurance/indemnity; subject to terms, conditions, limitations and exclusions.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Baggage Insurance Plan underwritten by AMEX Assurance Company; subject to terms, conditions, exclusions and coverage limits.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": "baggage_insurance_plan",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Insurance",
      "description": "Trip Delay Insurance provided by New Hampshire Insurance Company (AIG); secondary coverage; subject to terms, conditions, limitations and exclusions.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": "trip_delay_insurance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Insurance",
      "description": "Trip Cancellation and Interruption Insurance provided by New Hampshire Insurance Company (AIG); secondary coverage; subject to terms, conditions, limitations and exclusions.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Car Rental Loss and Damage Insurance underwritten by AMEX Assurance Company; subject to terms, conditions, exclusions and coverage limits.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Purchase Protection underwritten by AMEX Assurance Company; subject to terms, conditions, exclusions and coverage limits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extended Warranty underwritten by AMEX Assurance Company; subject to terms, conditions, exclusions and coverage limits.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "Return Protection benefit subject to additional terms, conditions and exclusions.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Up to $600 Hotel Credit (FHR/THC via Amex Travel)",
      "description": "Up to $600 per calendar year in statement credits for eligible prepaid Fine Hotels + Resorts\u00ae and The Hotel Collection bookings made through American Express Travel (amextravel.com, Amex Travel App, Amex App, or by phone). Structured as up to $300 in statement credits semi-annually (Jan\u2013Jun and Jul\u2013Dec). The Hotel Collection requires a minimum 2-night stay. Booking must be new, prepaid, and processed in the applicable eligibility period. Excludes interest, cancellation/property fees and charges billed by the property outside the prepaid booking.",
      "credit_type": "lifestyle_hotel_credit",
      "credit_category": {
        "categories": [
          "travel.hotel"
        ],
        "exclude_subcategories": null,
        "is_us_only": true,
        "is_online_only": false,
        "requires_travel_portal": true,
        "active_quarter": null,
        "start_date": "2025-09-18",
        "end_date": null,
        "category_description": "Prepaid Fine Hotels + Resorts\u00ae and The Hotel Collection bookings made through American Express Travel (amextravel.com, Amex Travel App, Amex App, or by phone). The Hotel Collection bookings require a minimum stay of two consecutive nights."
      },
      "new_credit_category": null,
      "value": 600.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "biannually",
          "values": [
            300.0,
            300.0
          ]
        }
      ],
      "total_yearly_value": 600.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Up to $200 Airline Fee Credit",
      "description": "Up to $200 per calendar year in statement credits for eligible incidental fees charged by your one selected qualifying airline (selection required; can change once per year in January). Incidental fees must be separate from airfare and coded properly; excludes tickets, upgrades, mileage purchases/transfer fees, gift cards, duty free, and award tickets.",
      "credit_type": "annual_credit",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 200.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Up to $200 Hilton Statement Credit (Hilton for Business)",
      "description": "Up to $200 per calendar year in statement credits for eligible purchases made directly with properties in the Hilton portfolio, for enrolled Hilton for Business members. Provides up to $50 per quarter in statement credits (quarters: Jan\u2013Mar, Apr\u2013Jun, Jul\u2013Sep, Oct\u2013Dec). Enrollment required; purchases through third parties are excluded; effective Jan 31, 2026 Hilton gift cards no longer eligible.",
      "credit_type": "quarterly_credit",
      "credit_category": "travel.hotel.hilton",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "quarterly",
          "values": [
            50.0,
            50.0,
            50.0,
            50.0
          ]
        }
      ],
      "total_yearly_value": 200.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Up to $209 CLEAR\u00ae Plus Credit",
      "description": "Up to $209 per calendar year in statement credits when the card is used to pay for an annual auto-renewing CLEAR\u00ae Plus membership (excluding taxes/fees). If CLEAR application is not approved, CLEAR refunds charges and any statement credits already applied may be reversed.",
      "credit_type": "annual_credit",
      "credit_category": null,
      "new_credit_category": "CLEAR Plus membership",
      "value": 209.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 209.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Up to $1,150 Dell Technologies Credit",
      "description": "Statement credits up to $150 on U.S. purchases made directly with Dell Technologies, plus an additional $1,000 statement credit after $5,000+ in eligible Dell purchases in a calendar year. Enrollment required. Valid only when Dell is merchant of record in the U.S. and U.S. territories; shipping outside U.S./territories excluded.",
      "credit_type": "merchant_or_category_specific_credit",
      "credit_category": "dell",
      "new_credit_category": null,
      "value": 1150.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 1150.0,
      "spend_requirement": 5000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "$250 Adobe Credit (after spend)",
      "description": "A $250 statement credit per calendar year after $600+ in eligible U.S. purchases made directly with Adobe (or adobe.com where Adobe is merchant of record). Enrollment required. Benefit begins July 1, 2025 (only purchases from that date count).",
      "credit_type": "spend_milestone_credit",
      "credit_category": null,
      "new_credit_category": "adobe",
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 250.0,
      "spend_requirement": 600,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    },
    {
      "name": "Up to $360 Indeed Credit",
      "description": "Statement credits up to $90 per quarter (Jan\u2013Mar, Apr\u2013Jun, Jul\u2013Sep, Oct\u2013Dec) for eligible U.S. purchases made directly with Indeed (Indeed, Inc. as merchant of record). Enrollment required.",
      "credit_type": "quarterly_credit",
      "credit_category": "indeed",
      "new_credit_category": null,
      "value": 360.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "quarterly",
          "values": [
            90.0,
            90.0,
            90.0,
            90.0
          ]
        }
      ],
      "total_yearly_value": 360.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Up to $120 Wireless Credit",
      "description": "Statement credits up to $10 per month for eligible monthly wireless telephone service charges made directly with U.S. wireless providers (service only; hardware/equipment excluded). Enrollment required; excludes Google Fi and third-party/authorized retailers/resellers and bundled TV/Internet/VoIP services.",
      "credit_type": "monthly_credit",
      "credit_category": "phonePlans",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0
          ]
        }
      ],
      "total_yearly_value": 120.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    },
    {
      "name": "Fee Credit for Global Entry or TSA PreCheck\u00ae",
      "description": "Statement credit for either Global Entry application fee ($120) once every 4 years OR TSA PreCheck application fee (up to $85) once every 4.5 years, when charged to the eligible card. Only one program credit per eligible period (whichever is paid first).",
      "credit_type": "tsa_pre_global_entry",
      "credit_category": null,
      "new_credit_category": "Global Entry / TSA PreCheck application fee",
      "value": 120.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "every_four_years",
          "values": [
            120.0
          ]
        }
      ],
      "total_yearly_value": 30.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": "every_four_years",
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    },
    {
      "name": "American Express One AP\u00ae Statement Credit (after $250,000 annual spend)",
      "description": "After $250,000 in eligible purchases in a calendar year, unlock up to $2,400 in statement credits in the following calendar year for American Express One AP\u00ae monthly/platform access fees, transaction fees, and applicable taxes charged to the qualified card account during the Jan 1\u2013Dec 31 active credit window. Enrollment in the credit is not required, but a One AP account request/approval is required and One AP fees must be billed to the qualified card account.",
      "credit_type": "spend_milestone_credit",
      "credit_category": null,
      "new_credit_category": "American Express One AP fees (accounts payable solution)",
      "value": 2400.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 2400.0,
      "spend_requirement": 250000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "Amex Travel Online Flight Statement Credit (after $250,000 annual spend)",
      "description": "After $250,000 in eligible purchases in a calendar year, unlock up to $1,200 in statement credits in the following calendar year for eligible flights booked on AmexTravel.com or the Amex Travel App and charged to the qualified card account during the Jan 1\u2013Dec 31 active credit window. Enrollment not required; flights booked directly with airlines are not eligible.",
      "credit_type": "spend_milestone_credit",
      "credit_category": {
        "categories": [
          "travel.airline"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": true,
        "requires_travel_portal": true,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Flights booked on AmexTravel.com or the Amex Travel App and charged to the qualified Business Platinum card account during the active credit window."
      },
      "new_credit_category": null,
      "value": 1200.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 1200.0,
      "spend_requirement": 250000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": null
    },
    {
      "name": "American Express Venue Collection\u2122 Concessions Statement Credit (Amex Offer)",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at participating American Express Venue Collection\u2122 stadiums/arenas after adding the offer to an eligible card. Limit up to $250 back in statement credits each calendar year; offer ends Dec 31, 2026. Excludes tickets, restaurants, transportation, parking, gift cards, merchandise, suite/catering orders, and other non-concession purchases; subject to merchant reporting.",
      "credit_type": "american_express_venue_collection_concessions",
      "credit_category": null,
      "new_credit_category": "American Express Venue Collection concessions",
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": 10.0,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 20000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 200,000 Membership Rewards\u00ae points after you spend $20,000 in eligible purchases within the first 3 months of Card Membership (limit one offer per Card Account; not eligible if you have or have had this card/versions; Amex may deny based on history).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 200000.0,
          "value_unit": "points",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-platinum-credit-card-amex/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-platinum-credit-card-amex/",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/business-platinum-charge-card/45094-9-0",
  "terms_and_conditions_button_text": "Rates & Fees",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/business-platinum-charge-card/45094-9-0"
    }
  ],
  "bank_name": "American Express",
  "imageName": "business_platinum_card.avif"
},
  [CreditCard.CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD]: {
  "id": CreditCard.CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD,
  "name": "Chase Sapphire Reserve for Business\u2120",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 8.0,
      "description": "8x points on travel purchases made through Chase Travel. Any portion of purchases that qualify for the $300 Annual Travel Credit or the $500 Credit for stays with The Edit will not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 4.0,
      "description": "4x points on flights booked direct with the airline. Purchases made via Reserve Travel Designers or FROSCH only qualify if the transaction is booked directly with (and processed by) the airline. Any portion of purchases that qualify for the $300 Annual Travel Credit will not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 4.0,
      "description": "4x points on hotels booked direct with the hotel. Purchases made via Reserve Travel Designers or FROSCH only qualify if the transaction is booked directly with (and processed by) the hotel. Stays that qualify for The Edit credit or the $300 Annual Travel Credit will not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineAdvertising",
      "earnRate": 3.0,
      "description": "3x points on social media and search engine advertising purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.lyft",
      "earnRate": 5.0,
      "description": "5x points on eligible Lyft purchases through 09/30/2027. Additional points post separately from base points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only",
        "time_limited_until_2027_09_30"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases. Excludes balance transfers, cash advances and cash-like transactions, lottery tickets, casino gaming chips, race track wagers or similar betting transactions, any checks that access your account, interest, unauthorized or fraudulent charges, and fees of any kind. Purchases that qualify for the $300 Annual Travel Credit or the $500 Credit for stays with The Edit do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 795.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2649,
    "apr_low": 0.1849
  },
  "annualFee": 795.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1849,
    "high": 0.2649,
    "description": "Flex for Business purchase APR is variable, 18.49%\u201326.49% based on creditworthiness; varies with the Prime Rate (Prime + 10.99% to 18.99%; max APR 29.99%). Grace period: at least 20 days. Minimum interest charge: none. Late fee: $40 or 2% of Minimum Payment Due, whichever is greater. Cash advance fee: $15 or 5%, whichever is greater."
  },
  "benefits": [
    {
      "name": "$300 Annual Travel Credit",
      "description": "Automatic statement credits for travel category purchases, up to $300 per cardmember year. Purchases that receive this credit do not earn points. Est. value: $300/yr.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$500 Credit for stays with The Edit by Chase Travel",
      "description": "Automatic statement credits on prepaid \u201cPay Now\u201d stays of 2+ nights booked via The Edit: up to $250 Jan\u2013Jun and up to $250 Jul\u2013Dec (max $500/yr). Purchases that receive this credit do not earn points. Authorized users are not eligible for The Edit program benefits. Est. value: up to $500/yr.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "The Edit Program Hotel Perks",
      "description": "Per-room benefits at select properties when booked as The Edit reservations through Chase Travel; benefits vary and are subject to availability (complimentary Wi\u2011Fi noted; benefits not combinable with other offers). Authorized users are not eligible for The Edit program benefits.",
      "benefit_type": null,
      "new_benefit_type": "hotel_program_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass Select Membership",
      "description": "Lounge access for the authorizing officer with up to two complimentary guests per visit; additional guests $27. Access subject to lounge capacity and Priority Pass terms. Authorized users are not eligible for this benefit.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS Application Fee Credit",
      "description": "One statement credit up to $120 every 4 years after the application fee is charged to the card. Est. value: up to $120 per 4\u2011year period (~$30/yr averaged).",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DoorDash DashPass (DoorDash and Caviar)",
      "description": "At least 12 months of DashPass when activated with the card by 12/31/2027; must pay with the card for DashPass benefits to apply. Est. value varies by market; commonly ~$96\u2013$120+ per year if used.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "DoorDash $5 off one restaurant order each month",
      "description": "$5 discount once per month on one qualifying DoorDash restaurant order while enrolled in DashPass and paying with the enrolled card. Unused value does not roll over. Est. value: up to $60/yr if used monthly.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "DoorDash two $10 discounts per month on non\u2011restaurant orders",
      "description": "Two $10 discounts per month (each on a separate non\u2011restaurant order) while enrolled in DashPass and paying with the enrolled card. Unused value does not roll over. Est. value: up to $240/yr if both used monthly.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual ZipRecruiter Credit (through 12/31/2027)",
      "description": "Automatic statement credits for ZipRecruiter purchases, up to $200 Jan\u2013Jun and up to $200 Jul\u2013Dec (max $400/yr). Est. value: up to $400/yr through 2027.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Google Workspace Credit (through 12/31/2027)",
      "description": "Automatic statement credits for Google/Workspace purchases, up to $200 per calendar year through 2027. Est. value: up to $200/yr through 2027.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Monthly Lyft Credit (through 9/30/2027)",
      "description": "$10 Lyft credit each calendar month toward eligible rides when paying with the card in the Lyft app (one credit per account per month; membership purchases excluded). Est. value: up to $120/yr through 9/30/2027.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Curated Gift Card Credit (through 10/31/2028)",
      "description": "Automatic statement credits for purchases at giftcards.com/reservebusiness, up to $50 Jan\u2013Jun and up to $50 Jul\u2013Dec (max $100/yr) through 10/31/2028. Est. value: up to $100/yr.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 $500 Credit for The Shops at Chase",
      "description": "After $120,000 in calendar\u2011year purchases (starting 2025), automatic statement credits for purchases at The Shops at Chase, up to $500 for the rest of that year and through the following year. Max available at one time is $1,000 if qualifying in consecutive years. Est. value: up to $500 per qualification period.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 IHG One Rewards Diamond Elite Status",
      "description": "After $120,000 in calendar\u2011year purchases (starting 2025), the authorizing officer can activate IHG Diamond Elite for the rest of that year and the following year (account linking required). Value varies by stay patterns and usage.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 Southwest Rapid Rewards A\u2011List Status",
      "description": "After $120,000 in calendar\u2011year purchases (starting 2025), the authorizing officer can activate Southwest A\u2011List for the rest of that year and the following year. Last year to newly qualify is 2027 (status valid until 12/31/2028). Value varies by travel frequency.",
      "benefit_type": "airline_status",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 $500 Southwest Airlines Chase Travel Credit",
      "description": "After $120,000 in calendar\u2011year purchases (starting 2025), automatic statement credits for Southwest purchases made via Chase Travel, up to $500 for the rest of that year, expiring at the end of the following year. Purchases by authorized users do not qualify. Est. value: up to $500 per qualification period.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "IHG One Rewards Platinum Elite Status (through 12/31/2027)",
      "description": "Authorizing officer eligible for IHG Platinum Elite through 12/31/2027 after linking their IHG account. Value varies by usage (e.g., room upgrades, bonus points).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer Points to Frequent Travel Programs",
      "description": "Ability to transfer Ultimate Rewards points (in 1,000\u2011point increments) to participating frequent travel programs belonging to you or an eligible company owner AU; a transfer fee may apply per agreement.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "0% foreign transaction fee on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Car Rental Discounts (Avis, National)",
      "description": "Discounts on base rates when booked directly with Avis or National using the Visa Infinite code; not valid when booking via Chase Travel. Standard rental terms and exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "car_rental_discounts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Concierge Service",
      "description": "Access to concierge services; cardmember pays cost of goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS Application Fee Credit",
      "description": "One statement credit up to $120 every 4 years after the application fee is charged to the card. Est. value: up to $120 per 4\u2011year period (~$30/yr averaged).",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "$300 Annual Travel Credit",
      "description": "Automatic statement credits for travel category purchases, up to $300 per cardmember year. Purchases that receive this credit do not earn points. Est. value: $300/yr.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$500 Credit for stays with The Edit by Chase Travel",
      "description": "Automatic statement credits on prepaid \u201cPay Now\u201d stays of 2+ nights booked via The Edit: up to $250 Jan\u2013Jun and up to $250 Jul\u2013Dec (max $500/yr). Purchases that receive this credit do not earn points. Est. value: up to $500/yr.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 500.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Annual ZipRecruiter Credit (through 12/31/2027)",
      "description": "Automatic statement credits for ZipRecruiter purchases, up to $200 Jan\u2013Jun and up to $200 Jul\u2013Dec (max $400/yr). Est. value: up to $400/yr through 2027.",
      "credit_category": "businessConsultingServices",
      "new_credit_category": null,
      "value": 400.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Annual Google Workspace Credit (through 12/31/2027)",
      "description": "Automatic statement credits for Google/Workspace purchases, up to $200 per calendar year through 2027. Est. value: up to $200/yr through 2027.",
      "credit_category": "computerServices",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Monthly Lyft Credit (through 9/30/2027)",
      "description": "$10 Lyft credit each calendar month toward eligible rides when paying with the card in the Lyft app (one credit per account per month; membership purchases excluded). Est. value: up to $120/yr through 9/30/2027.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Annual Curated Gift Card Credit (through 10/31/2028)",
      "description": "Automatic statement credits for purchases at giftcards.com/reservebusiness, up to $50 Jan\u2013Jun and up to $50 Jul\u2013Dec (max $100/yr) through 10/31/2028. Est. value: up to $100/yr.",
      "credit_category": "onlineShopping",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$120,000 Spend Benefit \u2013 $500 Credit for The Shops at Chase",
      "description": "After $120,000 in calendar\u2011year purchases (starting 2025), automatic statement credits for purchases at The Shops at Chase, up to $500 for the rest of that year and through the following year. Max available at one time is $1,000 if qualifying in consecutive years.",
      "credit_category": "onlineShopping",
      "new_credit_category": null,
      "value": 500.0,
      "value_unit": "dollars",
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$120,000 Spend Benefit \u2013 $500 Southwest Airlines Chase Travel Credit",
      "description": "After $120,000 in calendar\u2011year purchases (starting 2025), automatic statement credits for Southwest purchases made via Chase Travel, up to $500 for the rest of that year, expiring at the end of the following year. Purchases by authorized users do not qualify.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 500.0,
      "value_unit": "dollars",
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "DoorDash $5 off one restaurant order each month",
      "description": "$5 discount once per month on one qualifying DoorDash restaurant order while enrolled in DashPass and paying with the enrolled card. Unused value does not roll over. Est. value: up to $60/yr.",
      "credit_category": "dining.takeoutDelivery",
      "new_credit_category": null,
      "value": 5.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "DoorDash two $10 discounts per month on non\u2011restaurant orders",
      "description": "Two $10 discounts per month (each on a separate non\u2011restaurant order) while enrolled in DashPass and paying with the enrolled card. Unused value does not roll over. Est. value: up to $240/yr.",
      "credit_category": "onlineShopping",
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 20000.0,
      "spendRequirementMonths": 6,
      "description": "200,000 Ultimate Rewards points after you spend $30,000 on purchases in the first 6 months from account opening. Purchases that qualify exclude cash\u2011like transactions, balance transfers, fees, etc. Allow 6\u20138 weeks for points to post; account must be open and not in default. Estimated base value: ~$2,000 at 1.0 cent per point per the Rewards Program Agreement; potentially more if transferring to partners.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 200000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HR3S&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/sapphire/reserve?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61414.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD.webp"
},
  [CreditCard.SYNCHRONY_MATTRESS_FIRM_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_MATTRESS_FIRM_CREDIT_CARD,
  "name": "Mattress Firm Synchrony HOME\u2122 Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://mattressfirm.brightspotcdn.com/dims4/default/36343fa/2147483647/strip/true/crop/966x450+0+0/resize/768x358!/quality/90/?url=http%3A%2F%2Fmattress-firm-brightspot.s3.us-east-1.amazonaws.com%2F32%2F91%2F11b518e04a84904b3fbfa693df32%2Fsyf-credit-card-img-no-chip-1x.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3499,
    "apr_low": 0.3499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3499,
    "high": 0.3499,
    "description": "New Accounts as of 2025-07-31: Purchase APR 34.99% (0.3499). Penalty APR 39.99% (0.3999). Minimum Interest Charge $2. Promotional financing options: No Interest if Paid in Full within 6, 12, or 24 months (deferred interest; interest accrues from purchase date if promo balance not paid in full by end of promo). Also available: 60 or 72 months equal monthly payments with 0% interest on the amount financed (taxes and delivery must be paid upfront; in-store for 60/72 months). Regular account terms apply to non\u2011promo purchases and to any remaining promo balance after the promo period."
  },
  "benefits": [
    {
      "name": "Deferred-interest special financing (6, 12, or 24 months)",
      "description": "No Interest if Paid in Full within 6, 12 or 24 months on qualifying Mattress Firm purchases with your Mattress Firm or Synchrony HOME credit card. Interest accrues from the purchase date and is charged if the promo balance is not paid in full by the end of the promo period. Minimum monthly payments required. Minimum purchase thresholds: In-store: 6 & 12 months $0; 24 months $999. Online checkout: 6 & 12 months $0\u2013$1,498.99; 24 months $999\u2013$1,498.99. New Accounts as of 7/31/2025: Purchase APR 34.99%, Penalty APR 39.99%, Minimum Interest Charge $2. Subject to credit approval; offer subject to change. Estimated value example: Paying a $1,200 purchase off in 12 months during the promo avoids roughly ~$200\u2013$250 in interest versus revolving at ~34.99% APR (approximation based on average balance over 12 months).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_deferred_interest",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "0% equal monthly payments (36, 48, 60, or 72 months)",
      "description": "0% Interest with equal monthly payments for 36, 48, 60, or 72 months on qualifying purchases. Minimum purchase thresholds (in-store): 36 mo $1,499; 48 mo $2,499; 60 mo $2,999; 72 mo $3,299. Online checkout ranges: 36 mo $1,499\u2013$2,498.99; 48 mo $2,499\u2013$2,998.99; 60 mo $2,999\u2013$3,298.99; 72 mo $3,299+. For 60 & 72 months in-store purchases, taxes and delivery fees must be paid upfront and cannot be charged to the card. Equal monthly payments required; payments calculated as amount financed \u00f7 promo months (rounded up). Regular terms apply to non-promo purchases. Estimated value example: Financing $3,299 at 0% for 72 months yields about $46/mo and avoids hundreds of dollars in interest compared with carrying a balance at a 34.99% APR over a year (illustrative; actual avoided interest depends on repayment behavior without the promo).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_equal_payment_0_apr",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Limited-time 3% back rebate (Visa Prepaid Card)",
      "description": "3% back on net purchases of $1,999+ when using up to 24 months special financing at participating Mattress Firm stores, online via chat, or by phone from 7/30/25\u20131/27/26. Paid via virtual or mailed Visa Prepaid Card after delivery and submission of a rebate form by 2/27/26. One rebate per qualifying purchase; max rebate $500 per customer. Visa Prepaid Card funds expire 6 months from issue. Not a signup bonus; time-limited cardholder rebate promotion.",
      "credit_category": null,
      "new_credit_category": "store_rebate",
      "value": 3.0,
      "value_unit": "percent",
      "spend_requirement": 1999,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [],
  "apply_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=82FDD7321D7D37B51DBBE6B139A6876039013F724108EA60&client=Mattress%20Firm&intcmp=NoOff_MattressFirmCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=82FDD7321D7D37B51DBBE6B139A6876039013F724108EA60&client=Mattress%20Firm&intcmp=NoOff_MattressFirmCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=82FDD7321D7D37B51DBBE6B139A6876039013F724108EA60&preQual=Y&intcmp=NoOff_MattressFirmCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    },
    {
      "name": "Financing details",
      "url": "https://www.mattressfirm.com/financing-mattress-firm-credit-card.html"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "mattress_firm_credit_card.png"
},
  [CreditCard.WYNDHAM_REWARDS_EARNERCARD]: {
  "id": CreditCard.WYNDHAM_REWARDS_EARNERCARD,
  "name": "Wyndham Rewards Earner\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/WYZ_card_rRGB_NoFeeEarner_VS_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.WYNDHAM,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.wyndham",
      "earnRate": 5.0,
      "description": "5x points per $1 on eligible purchases made at Hotels by Wyndham. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5x points per $1 on qualifying gas purchases. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x points per $1 on eligible dining purchases. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x points per $1 at grocery stores; excludes Walmart and Target. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases; excludes Wyndham Timeshare resort down payments from earning points. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2999,
    "description": "Variable purchase APR: 0.1999\u20130.2999 based on credit; varies with Prime. Promotional APR: 0.0 for 6 billing cycles on Wyndham Timeshare Purchases. Balance transfers: 0.0 introductory APR for 15 billing cycles on transfers that post within 45 days of account opening; then variable 0.1999\u20130.2999. Cash advance APR: 0.2999. Minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "Automatic Wyndham Rewards Gold status",
      "description": "Automatic Wyndham Rewards GOLD member level with perks like free Wi\u2011Fi, preferred room selection, and late checkout. Estimated value ~$20\u2013$40 per stay depending on usage.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% fewer points on free night awards",
      "description": "Redeem 10% fewer Wyndham Rewards points when you book free nights. Example: a 15,000\u2011point night would price at 13,500 points. Estimated savings value depends on redemption; at 0.9\u00a2/point, saving 1,500 points \u2248 $13.50 per 15k redemption.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary bonus: 7,500 points after $15,000 spend",
      "description": "Earn 7,500 bonus points each anniversary year after $15,000 in eligible purchases. Estimated value \u2248 $68 at 0.9\u00a2/point. Offer subject to credit line/ability to maintain that line.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember hotel rate discount",
      "description": "Wyndham Rewards Earner Cardmembers can save on the Standard Rate at participating Hotels by Wyndham. Discount amount varies by property and date.",
      "benefit_type": null,
      "new_benefit_type": "hotel_rate_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 30,000 Wyndham Rewards points after spending $1,000 in the first 90 days (advertised as \u201cenough for up to 4 free nights,\u201d assuming 7,500 points per night). Estimated value \u2248 $270 at 0.9\u00a2/point. Free nights require up to 30,000 points per bedroom; resort fees may apply and can\u2019t be paid with points.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-card/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "wyndham_rewards_earnercard.png"
},
  [CreditCard.DELTA_SKYMILES_GOLD_BUSINESS_CARD]: {
  "id": CreditCard.DELTA_SKYMILES_GOLD_BUSINESS_CARD,
  "name": "Delta SkyMiles\u00ae Gold Business American Express Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/gold-delta-skymiles-business.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DELTA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.delta",
      "earnRate": 2.0,
      "description": "2x miles on purchases charged directly with Delta (Delta as merchant of record via delta.com, Fly Delta app, phone reservations, or ticket counters). Includes upgrades, miles purchases, seat selection, Delta Sky Club membership, and in-flight food/beverage on Delta-operated flights, Delta Vacations packages, and new prepaid Delta Stays hotel or vacation rental bookings on delta.com/stays. Excludes in-flight purchases where Delta is not merchant of record (e.g., Wi\u2011Fi), charitable contributions, Delta Gift Cards, purchases at deltashop.com, and Delta Flight Museum.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "shipping",
      "earnRate": 2.0,
      "description": "2x miles on eligible U.S. shipping purchases, up to $50,000 in purchases per calendar year per Card Account.",
      "spendCap": 50000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x miles at restaurants worldwide. May not receive bonus at restaurants located within another establishment (e.g., inside a hotel, casino, or event venue) or for purchases made through third\u2011party food delivery services outside the U.S. Excludes bars, nightclubs, cafeterias, and convenience stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x mile per dollar on all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 150.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable purchase APR 19.99%\u201328.99% (Prime + 12.74% to +21.74%), based on creditworthiness; cash advance APR 29.24% (variable); penalty APR 29.99% may apply after certain late/returned payments; variable APRs will not exceed 29.99%. Grace period: at least 25 days if you pay your balance in full."
  },
  "benefits": [
    {
      "name": "TakeOff 15: 15% off Delta award tickets",
      "description": "Get at least 15% off the mileage portion of Award Tickets on Delta and Delta Connection flights booked at delta.com or in the Fly Delta app (excludes partner-operated flights and taxes/fees). Example: a 25,000-mile award would price at 21,250 miles. Cardholder must be logged into a SkyMiles account linked to this card.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "First Checked Bag Free on Delta",
      "description": "First standard checked bag free for the Basic Card Member and up to 8 companions on the same reservation on Delta- and Delta Connection-operated flights when the Basic Card Member\u2019s SkyMiles number is on the reservation. Estimated value: up to $70 round-trip per person (e.g., family of four could save up to $280 per round trip).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zone 5 Priority Boarding on Delta",
      "description": "Early boarding (Zone 5) for the Basic Card Member and up to 8 companions on the same reservation on Delta- and Delta Connection-operated flights.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Delta Flight Credit",
      "description": "Receive a $200 Delta eCredit after $10,000 in purchases on the card in a calendar year. Issued 6\u20138 weeks after meeting the requirement; valid toward Delta-marketed flights (including taxes/fees on tickets), expires one year from issuance, and appears in your SkyMiles account. Limit one per calendar year.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $150 Delta Stays Statement Credit",
      "description": "Up to $150 back in statement credits each calendar year for prepaid hotels and vacation rentals booked through Delta Stays on delta.com/stays with the card. Excludes various fees (e.g., resort/property fees). Posts within ~90 days. Estimated value: up to $150/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "20% back on in-flight food & beverage",
      "description": "Get 20% back as a statement credit on eligible pre-purchased meals and in-flight food & beverage purchases on Delta-operated flights when paid with this card. Posts in 6\u20138 weeks. Estimated value depends on in-flight spend (e.g., $50 in eligible purchases \u2192 ~$10 back).",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "Pay no foreign transaction fees on purchases made outside the U.S. Potential savings ~3% compared to cards that charge this fee, depending on your international spend.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage for lost, damaged, or stolen baggage when you purchase the Entire Fare with the card. Up to $1,250 for carry-on and up to $500 for checked baggage (excess of carrier coverage). Terms, exclusions, and state-specific limits apply.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss & Damage Insurance (Secondary)",
      "description": "Secondary coverage for damage or theft when you pay for the entire rental with the card and decline the rental company\u2019s CDW. Exclusions apply; not available in Australia, Italy, or New Zealand; no liability coverage.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Eligible items purchased with the card may be covered against accidental damage or theft for a limited period after purchase; terms and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends eligible U.S. manufacturer\u2019s warranties on covered purchases when charged to the card; terms, caps, and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Pay with Miles (Delta)",
      "description": "Redeem SkyMiles at booking on Delta-operated and ticketed flights at increments of 5,000 miles for generally $50 off per 5,000 miles (~1.0\u00a2 per mile). Must pay any remainder with the card. Not combinable with Award Tickets; Basic Economy limitations apply.",
      "benefit_type": null,
      "new_benefit_type": "pay_with_miles",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$200 Delta Flight Credit",
      "description": "Earn a $200 Delta eCredit each calendar year after $10,000 in eligible purchases; valid toward Delta-marketed flights; expires one year from issuance.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $150 Delta Stays Statement Credit",
      "description": "Up to $150 in statement credits per calendar year for prepaid hotels and vacation rentals booked through Delta Stays on delta.com/stays.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "20% back on in-flight food & beverage",
      "description": "20% back as a statement credit on eligible pre-purchased meals and in-flight food & beverage on Delta-operated flights.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "Limited Time Offer: Earn 90,000 Bonus Miles after $6,000 in purchases in the first 6 months of Card Membership. Offer expires 10/29/2025. Account must be open and not past due at fulfillment; ineligible if you have or have had this card. Abuse/misuse may lead to clawback. Bonus posts 8\u201312 weeks after meeting the requirement.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 90000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-gold/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaGold",
  "learn_more_link": "https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-gold/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaGold",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-gold/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-gold/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "delta_skymiles_gold_business_card.png"
},
  [CreditCard.SPARK_CLASSIC]: {
  "id": CreditCard.SPARK_CLASSIC,
  "name": "Spark 1% Classic",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/classic_new_2021/thumbnail.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Unlimited 1% cash back on every purchase, everywhere, with no limits or category restrictions.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on hotels and rental cars booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on hotels and rental cars booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "29.74% variable APR on purchases"
  },
  "benefits": [
    {
      "name": "Extended warranty",
      "description": "Get free additional warranty and protection on eligible items purchased with the card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay zero foreign transaction fees on purchases made outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside assistance",
      "description": "Access services to help during auto-related emergencies, such as jump-starting, tire changes and towing.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Business Travel access",
      "description": "Complimentary access to an all-in-one business travel management and booking solution via Capital One Business Travel.",
      "benefit_type": null,
      "new_benefit_type": "business_travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free employee cards",
      "description": "Add free employee cards, set spending limits and earn rewards from employee purchases.",
      "benefit_type": null,
      "new_benefit_type": "free_employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/small-business/credit-cards/spark-classic/",
  "learn_more_link": "https://www.capitalone.com/small-business/credit-cards/spark-classic/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "spark_classic.png"
},
  [CreditCard.CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD]: {
  "id": CreditCard.CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD,
  "name": "Chase Sapphire Preferred\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/sapphire_preferred_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "Earn 5x total points on travel purchased through Chase Travel. Only the portion paid with the card earns points when combined with points. Hotel purchases that qualify for the $50 Annual Chase Travel Hotel Credit do not earn points on the credited amount.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "Earn 2x points on other travel purchases (excluding those booked through Chase Travel that earn 5x). Travel purchased through FROSCH and its family of travel companies qualifies for 2x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Earn 3x points on dining at restaurants, including eligible delivery services, takeout, and dining out.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "Earn 3x points on select streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point per dollar on all other purchases. Purchases that qualify for the $50 Annual Chase Travel Hotel Credit and certain transaction types (e.g., cash-like transactions, fees) do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 0.1,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% anniversary points bonus: Each account anniversary year, earn bonus points equal to 10% of total purchases (in points) from the prior account anniversary year (e.g., spend $25,000 \u2192 2,500 bonus points). Account must be open and not in default at fulfillment.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.lyft",
      "earnRate": 5.0,
      "description": "Limited-time offer: Earn 5x total points on qualifying Lyft purchases (rideshare; bike and scooter rides; subscription and membership products) made through the Lyft app through 09/30/2027. Excludes gift cards, car rentals, vehicle service centers, miscellaneous fees and other Lyft products/services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2799,
    "apr_low": 0.1974
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2799,
    "description": "Variable purchase APR 0.1974\u20130.2799 based on creditworthiness and the Prime Rate; balance transfer APR 0.1974\u20130.2799 variable; cash advance APR 0.2899; penalty APR up to 0.2999. No minimum interest charge. At least 21-day grace period on new purchases if paid in full; interest on balance transfers and cash advances starts on the transaction date. Note: Account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "$50 Annual Chase Travel Hotel Credit",
      "description": "Up to $50 in statement credits each account anniversary year for hotel stays purchased through Chase Travel. The first $50 in Chase Travel hotel purchases each year will not earn points. Estimated value: $50 per year if you book at least $50 in eligible Chase Travel hotels.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "1:1 Point Transfer",
      "description": "Transfer Ultimate Rewards points at 1:1 to: Aer Lingus AerClub, Air Canada Aeroplan, British Airways Executive Club, Flying Blue (Air France-KLM), Iberia Plus, JetBlue TrueBlue, Singapore KrisFlyer, Southwest Rapid Rewards, United MileagePlus, Virgin Atlantic Flying Club; and hotel partners IHG One Rewards, Marriott Bonvoy, World of Hyatt.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% Anniversary Points Bonus",
      "description": "Each account anniversary year, earn bonus points equal to 10% of total purchases made in the previous account anniversary year (e.g., $25,000 spend \u2192 2,500 bonus points).",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "Reimbursement up to $10,000 per covered traveler and $20,000 per trip for prepaid, nonrefundable expenses (e.g., fares, tours, hotels) if your trip is canceled or cut short due to covered reasons.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Reimbursement",
      "description": "If common carrier travel is delayed more than 12 hours or requires an overnight stay, reimbursement for unreimbursed expenses (e.g., meals, lodging) up to $500 per covered traveler.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Reimburses up to $100 per day for up to 5 days for essential purchases when baggage is delayed over 6 hours.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Primary)",
      "description": "Primary coverage for theft and collision damage when you decline the rental company\u2019s collision insurance and pay with the card; reimbursement up to $60,000 for most rental vehicles with MSRP of $125,000 or less. Note: For NY residents, coverage is secondary inside the U.S.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $500 per item. Note: For NY residents, coverage period is 90 days.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years total from purchase).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance",
      "description": "Access to legal and medical referrals and other travel/emergency assistance services (cardmember responsible for costs of goods/services).",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "DoorDash DashPass Membership",
      "description": "Complimentary DashPass for at least 12 months when activated by 12/31/2027; valid on DoorDash and Caviar with Sapphire Preferred on file. Current stated value: about $120 for 12 months. AU cards can also activate their own membership during the same membership period.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$10 Monthly DoorDash Non\u2011Restaurant Discount",
      "description": "$10 off one qualifying non\u2011restaurant DoorDash order each calendar month while enrolled in the Sapphire DashPass membership through 12/31/2027 (U.S. only). Estimated value up to $120/year if used monthly.",
      "benefit_type": null,
      "new_benefit_type": "doordash_non_restaurant_monthly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "0% foreign transaction fees on purchases made outside the U.S. Example from issuer: $5,000 international spend avoids ~$150 in typical 3% fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$50 Annual Chase Travel Hotel Credit",
      "description": "Up to $50 in statement credits each account anniversary year for hotel stays purchased through Chase Travel. First $50 in Chase Travel hotel purchases will not earn points.",
      "credit_category": null,
      "new_credit_category": "travel",
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 75,000 bonus points after you spend $5,000 on purchases in the first 3 months from account opening. Not available if you currently have any personal Sapphire card open, previously held this card, or already received a new cardmember bonus for this card. Chase may consider the number of cards you\u2019ve opened/closed when determining eligibility. Allow 6\u20138 weeks for bonus to post; account must be open and not in default at fulfillment. Estimated value: $750+ at a minimum 1.0\u00a2 per point (cash/travel); potentially higher via 1:1 transfer partners.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 75000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HSGD&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/rewards-credit-cards/sapphire/preferred?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61729.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/sapphirepreferred/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "chase_sapphire_preferred_credit_card.png"
},
  [CreditCard.BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD]: {
  "id": CreditCard.BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD,
  "name": "Business Advantage Travel Rewards World Mastercard\u00ae Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_trvbuswldcm_mc-CSX44dee15a.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BANK_OF_AMERICA_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5 points per $1 spent on all purchases. Points do not expire while the account remains open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on travel purchases made at the Bank of America Travel Center. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 4.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 5.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2749,
    "apr_low": 0.1749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1749,
    "high": 0.2749,
    "description": "0.0000 intro APR on purchases for the first 9 billing cycles; thereafter a variable APR of 0.1749\u20130.2749 applies to purchases and balance transfers; cash advances have a 0.2849 variable APR."
  },
  "benefits": [
    {
      "name": "Travel accident insurance",
      "description": "Travel accident insurance up to $1,000,000 when traveling on a common carrier.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost luggage reimbursement",
      "description": "Reimbursement for lost luggage when traveling.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip cancellation coverage",
      "description": "Coverage for eligible non-refundable travel expenses if a covered trip is canceled for a covered reason.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip delay reimbursement",
      "description": "Reimbursement for certain expenses incurred due to covered trip delays.",
      "benefit_type": null,
      "new_benefit_type": "trip_delay_reimbursement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Coverage for eligible new purchases against loss, damage, theft, or fire for a limited time after purchase.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Extends eligible manufacturer warranties on qualifying purchases.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred Rewards for Business points boost",
      "description": "Earn up to 75% more points on every purchase (up to 2.62 points per $1) when you have a Bank of America business checking account and qualify for Preferred Rewards for Business (Platinum Honors tier).",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No international transaction fees on purchases made outside the U.S.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Online offer: Earn 30,000 bonus points after $3,000 in purchases in the first 90 days of account opening. Estimated value ~$300 when redeemed as a statement credit toward travel or dining purchases at 1 cent per point. Offer may not be available outside this application page.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/travel-rewards-business-credit-card/?campaign=4069740~GU~en_US",
  "learn_more_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/travel-rewards-business-credit-card/?campaign=4069740~GU~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/#rates-fees-4069740~GU~en_US",
  "terms_and_conditions_button_text": "Interest Rates & Fees Summary\u2020",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://promo.bankofamerica.com/CalculateBusinessAdvantageTravelRewards/"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "business_advantage_travel_rewards_credit_card.png"
},
  [CreditCard.SAMS_CLUB_CREDIT_CARD]: {
  "id": CreditCard.SAMS_CLUB_CREDIT_CARD,
  "name": "Sam's Club\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/sams_club_credit_card.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5% cash back on gas station purchases up to $6,000 per year, then 1%.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3% cash back on dining and takeout.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.284,
    "apr_low": 0.204
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.204,
    "high": 0.284,
    "description": ""
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.samsclub.com/account/credit-app-login?refsite=MPAN&intcmp=NoOff_Sam%27sClubcreditcard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.samsclub.com/account/credit-app-login?refsite=MPAN&intcmp=NoOff_Sam%27sClubcreditcard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://www.samsclub.com/account/credit-app-login?refsite=MPPQ&preQual=true&intcmp=NoOff_Sam%27sClubcreditcard_credit%20cards_body-catalog-cards_ext"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "sams_club_credit_card.webp"
},
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD]: {
  "id": CreditCard.SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD,
  "name": "Southwest Rapid Rewards\u00ae Plus Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/southwest_rapid_rewards_plus_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.SOUTHWEST,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.southwest",
      "earnRate": 2.0,
      "description": "2x points on purchases made directly with Southwest Airlines, including flights, inflight purchases, Southwest gift cards, and Southwest Vacations/Getaways by Southwest packages. Excludes Southwest Charters and Southwest Cargo. (Promotional partner categories and Southwest Cruises are captured in separate entries.)",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x points on gas stations, up to a combined $5,000 per account anniversary year when combined with grocery category; after the cap, purchases earn 1x. \"Account anniversary year\" is defined by Chase.",
      "spendCap": 5000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x points on grocery stores, up to a combined $5,000 per account anniversary year when combined with gas category; after the cap, purchases earn 1x. \"Account anniversary year\" is defined by Chase.",
      "spendCap": 5000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point on all other purchases not in a bonus category (and on gas/grocery after the combined $5,000 account-anniversary-year cap).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "LIMITED TIME: 2x points on local transit and commuting purchases from 07/24/2025 through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_promo"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "LIMITED TIME: 2x points on internet, cable, and phone services from 07/24/2025 through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_promo"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate. Purchase APR: 19.74%\u201328.24% (variable). Balance transfer APR: 19.74%\u201328.24% (variable). Cash advance APR: 28.99% (variable). Penalty APR: up to 29.99% (variable) if you pay late or a payment is returned; may apply indefinitely. Grace period: at least 21 days on purchases if you pay your entire balance or Interest Saving Balance by the due date; interest on balance transfers and cash advances starts on the transaction date. Minimum interest charge: none. Balance transfer fee: $5 or 5% (whichever is greater). Cash advance fee: $10 or 5% (whichever is greater). Note: This account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "First checked bag free on Southwest flights",
      "description": "Primary Cardmember and up to 8 passengers on the same reservation get their first standard checked bag free on Southwest-operated flights (card must be linked to the reservation). Estimated value varies by trip and prevailing bag fees; if a typical first-bag fee were ~$35 each way, potential value could be ~$70 round trip per traveler.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Standard seat selection within 48 hours of departure",
      "description": "When available, the primary Cardmember can select a Standard seat within 48 hours prior to scheduled departure for themselves and up to 8 passengers on the same reservation on Southwest-operated flights. Value depends on route and demand; useful for ensuring adjacent seating without extra fees.",
      "benefit_type": null,
      "new_benefit_type": "airline_standard_seat_selection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 5 boarding on Southwest",
      "description": "Primary Cardmember (and up to 8 passengers on the same reservation) can board with Group 5 on Southwest-operated flights. Value varies by trip; can save time and improve seat selection.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual 10% Southwest promo code",
      "description": "Receive one 10% promo code each account anniversary year, valid for a year and applied to base fare (before taxes/fees) on eligible Southwest bookings; excludes Basic fares and certain channels. Estimated value depends on fare\u2014for example, ~$30 off a $300 base fare.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Companion Pass qualifying points boost",
      "description": "Receive one boost of 10,000 Companion Pass qualifying points each calendar year (posted by Jan 31 or up to 30 days after account opening). This accelerates earning the Companion Pass; value depends on how you leverage Companion Pass, often worth several hundred dollars or more if used frequently.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass (DoorDash & Caviar)",
      "description": "12 months of complimentary DashPass when first activated with this card between 02/01/2025 and 12/31/2027; must keep the card as default and use it at checkout to receive benefits. Estimated value about $120 for 12 months at ~$9.99/month, excluding potential delivery fee savings.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary bonus: 3,000 Rapid Rewards points",
      "description": "Receive 3,000 Rapid Rewards points each account anniversary year (posts within ~8 weeks). Estimated value ~$36\u2013$45 (assuming ~1.2\u20131.5 cents per point; midpoint \u2248 $42).",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Southwest EarlyBird Check-In reimbursement",
      "description": "Reimbursement for up to 2 EarlyBird Check-Ins each account anniversary year when purchased with the card; credits post within 6\u20138 weeks. Note: Will not apply to flights with assigned seating in 2026.",
      "credit_category": "travel.airline.southwest",
      "new_credit_category": "southwest_airlines_earlybird_check_in",
      "value": 2.0,
      "value_unit": "purchases_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "DoorDash quarterly discount (non-restaurant orders)",
      "description": "After activating DashPass with this card, get $10 off one qualifying non-restaurant DoorDash order each calendar quarter while enrolled in DashPass (no rollover).",
      "credit_category": "dining.takeoutDelivery.doordash",
      "new_credit_category": "doordash_non_restaurant_orders",
      "value": 10.0,
      "value_unit": "dollars_per_quarter",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 50,000 Rapid Rewards points after you spend $1,000 on purchases in the first 3 months from account opening. Not available to current Southwest Rapid Rewards consumer cardmembers or to previous consumer cardmembers who received a new cardmember bonus in the past 24 months (business/employee cards excluded). Allow up to 8 weeks for points to post. Estimated value \u2248 $600\u2013$750 assuming ~1.2\u20131.5 cents per point (midpoint \u2248 $700).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HW4B&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/southwest/plus?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62472.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/swapluscard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "southwest_rapid_rewards_plus_credit_card.png"
},
  [CreditCard.DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD]: {
  "id": CreditCard.DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD,
  "name": "Discover it\u00ae Student Cash Back",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-student-it-iridescent-620-382.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 5.0,
      "description": "Earn 5% Cashback Bonus at Grocery Stores, Wholesale Clubs, and Select Streaming Services from Jan 1\u2013Mar 31, 2026, on up to $1,500 in combined purchases when activated.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": "2026-01-01",
      "endDate": "2026-03-31",
      "excludeMerchants": [
        "walmart",
        "target"
      ],
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_activation",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "grocery",
          "wholesaleClub",
          "streaming"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Q1 2026 bonus categories across combined purchases: Grocery Stores (supermarkets, meat lockers, bakeries, smaller groceries, grocery delivery services; all Walmart and Target purchases are not eligible; convenience/discount stores may not qualify), Wholesale Clubs (acceptance may vary; affiliated services like delivery, travel, and cell phones may not be eligible; individual merchants or stand\u2011alone stores inside clubs or online may not be eligible), and Select Streaming Services (examples include Amazon Music/Prime Video, AMC+, Apple Music/TV, Audible, DirecTV Stream, Fandango at Home, Google Play Music/Video, Max, iHeartRadio, MLB.TV, Netflix, Pandora, Paramount Plus, Peacock, SiriusXM, Sling TV, Spotify, Starz, YouTube Music/Premium/TV; bundles or third\u2011party billing may not qualify).",
        "startDate": "2026-01-01",
        "endDate": "2026-03-31"
      }
    },
    {
      "category": "rotating_quarterly_rewards",
      "earnRate": 5.0,
      "description": "Earn 5% Cashback Bonus on rotating quarterly categories on up to $1,500 in combined purchases per quarter when you activate. See quarterly entries for specific categories and dates.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 99901,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_activation",
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "5% rotating categories (activation required; $1,500 per quarter cap)",
      "description": "Earn 5% Cashback Bonus in rotating categories each quarter when you activate, on up to $1,500 in category purchases per quarter (up to $75 back per quarter; approximately $300 annually if maxed). 2025: Q1 Restaurants, Home Improvement Stores, Select Streaming Services; Q2 Grocery Stores & Wholesale Clubs; Q3 Gas Stations & EV Charging, Public Transit, Utilities; Q4 Amazon.com & Drug Stores. 2026 Q1: Grocery Stores, Wholesale Clubs, Select Streaming Services. U.S. merchants only; merchant category code (MCC) and some digital wallet transactions may not qualify. Rewards typically post within two billing periods.",
      "benefit_type": "rotating_quarterly_rewards",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.discovercard.com/application/website/apply?srcCde=RJQX&ICMPGN=ALL_CC_STUDENT_CB_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "learn_more_link": "https://www.discovercard.com/application/website/apply?srcCde=RJQX&ICMPGN=ALL_CC_STUDENT_CB_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://www.discover.com/credit-cards/student-credit-card/it-card/reviews/#all-reviews"
    },
    {
      "name": "Link 3",
      "url": "https://www.discover.com/credit-cards/cash-back/cashback-calendar.html?link=%2Fweb%2Frewards%2F5percent%2F"
    }
  ],
  "bank_name": "Discover",
  "imageName": "discover_it_student_cash_back_credit_card.png"
},
  [CreditCard.DELTA_SKYMILES_RESERVE_BUSINESS_CARD]: {
  "id": CreditCard.DELTA_SKYMILES_RESERVE_BUSINESS_CARD,
  "name": "Delta SkyMiles\u00ae Reserve Business American Express Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/delta-reserve-business.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DELTA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.delta",
      "earnRate": 3.0,
      "description": "Purchases made directly with Delta (Delta as merchant of record) including delta.com, Fly Delta app, phone reservations, ticket counters; upgrades, miles purchases, seat selection, Delta Sky Club membership, in\u2011flight food and beverages on Delta\u2011operated flights, Delta Vacations packages, and new Delta Stays prepaid bookings on delta.com/stays. Excludes purchases where Delta is not merchant of record (e.g., in\u2011flight Wi\u2011Fi, charitable contributions), Delta Gift Cards, deltashop.com, and the Delta Flight Museum.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 1.5,
      "description": "Eligible transit purchases include train, taxicab, rideshare, ferry, tolls, parking, bus, and subway merchants. Airfare, car rentals, and cruises are excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 1.5,
      "description": "Eligible purchases at U.S. shipping merchants (courier, postal, and freight).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "shipping"
            ],
            "exclude_subcategories": null,
            "is_us_only": true,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "U.S. courier, postal, and freight shippers. Excludes shipping costs added to retail purchases and moving services."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "U.S. shipping purchases at courier, postal, and freight shippers.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "fixed_category_group",
      "earnRate": 1.5,
      "description": "Eligible purchases at office supply stores located in the U.S.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "officeSupplies"
            ],
            "exclude_subcategories": null,
            "is_us_only": true,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Purchases at office supply stores located in the U.S. (e.g., paper, notebooks, office equipment, office furniture). Office supplies bought at non\u2011office\u2011supply retailers are excluded."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "U.S. office supply store purchases.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other eligible purchases not in bonus categories earn 1x mile per dollar.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Accelerated 1.5x earn rate on eligible purchases after meeting $150,000 calendar\u2011year spend; resets each January 1.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": 150000.0,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "annual_spend_milestone_bonus"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 650.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 650.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable purchase APR 19.99%\u201328.99% (0.1999\u20130.2899) based on creditworthiness; varies with the Prime Rate. Penalty APR 29.99% (0.2999) may apply for late/returned payments or not paying the Minimum Payment Due by the Closing Date; applies for at least 12 billing periods. At least 25\u2011day grace period; no interest on purchases if paid in full by the due date. Variable APRs will not exceed 29.99%."
  },
  "benefits": [
    {
      "name": "Delta Sky Club Access (15 Visits; Unlock Unlimited After $75k Spend)",
      "description": "Receive 15 visits each Medallion Year to Delta Sky Club when flying Delta, plus four One-Time Guest Passes per Medallion Year. Unlock unlimited Sky Club access for the rest of the year, the following year, and through Jan 31 of the next year after $75,000 in eligible purchases in a calendar year. Standard guest access available for a fee; Basic Economy not eligible. Visits reset annually per program terms.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "The Centurion Lounge and Escape Lounges Access (on Delta Itineraries)",
      "description": "Complimentary access to The Centurion Lounge and Escape Lounge locations when flying on a same-day Delta-marketed or Delta-operated flight booked on a U.S.-issued Amex. Guest fees apply; arrival time windows and access policies vary by lounge.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Companion Certificate (upon renewal)",
      "description": "Each year after Card renewal, receive a Companion Certificate valid for one round-trip in First, Premium Select, Comfort+, or Main Cabin on eligible Delta, Delta Connection, or Delta Shuttle flights originating in the U.S., PR, or USVI to the U.S., PR, USVI, Mexico, Caribbean, or Central America. Taxes/fees up to $80 domestic or $250 international (up to four segments) apply; Basic Economy not eligible; additional fare rules and inventory class restrictions apply.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "TakeOff 15 (15% miles discount on Delta award tickets)",
      "description": "Get at least 15% off the mileage portion of Delta- and Delta Connection-operated award tickets booked at delta.com or in the Fly Delta app. Discount excludes partner flights and does not apply to taxes/fees, Pay with Miles, or Miles + Cash.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "MQD Headstart (2,500 MQDs per year)",
      "description": "Receive 2,500 Medallion Qualification Dollars each Qualification Year toward Medallion Status. MQDs deposit 6\u20138 weeks after Feb 1 for existing Card Members or shortly after account open for new Card Members.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "MQD Boost (earn MQDs from spend)",
      "description": "Earn 1 MQD for each $10 in eligible purchases on the Card during a Qualification Year. MQDs post 8\u201312 weeks after the transaction posts; returns/credits reduce MQDs.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Upgrade Priority",
      "description": "Priority over other passengers with the same Medallion tier, product class, fare experience, and Million Miler milestone when on the Delta complimentary upgrade list.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Upgrade List (non-Medallion)",
      "description": "Basic Card Members (non\u2011Medallion) with eligible tickets are added to the complimentary upgrade list after Medallion Members for select cabins on eligible U.S. routes, subject to availability. Basic Economy not eligible.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "First Checked Bag Free",
      "description": "First checked bag fee waiver on Delta flights for the Basic Card Member and up to 8 travel companions on the same reservation (up to 9 total), on Delta/Delta Connection-operated itineraries. Delta cites potential savings up to $70 per person per round trip.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zone 5 Priority Boarding",
      "description": "Zone 5 priority boarding on Delta and Delta Connection operated flights for the Basic Card Member and up to 8 companions on the same reservation.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry or TSA PreCheck Fee Credit",
      "description": "Statement credit for the Global Entry application fee ($120 every 4 years) or TSA PreCheck (up to $85 every 4.5 years) when charged to the Card; one credit per account per interval.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$240 Resy Credit",
      "description": "Up to $20 per month (up to $240 per calendar year) in statement credits after enrollment for eligible purchases at U.S. restaurants on Resy (Resy Pay, reservations on Resy app/site, and participating Resy restaurant charges). Excludes gift cards/Resy OS and some third\u2011party processing. Enrollment required.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120 Rideshare Credit",
      "description": "Up to $10 per month (up to $120 per year) in statement credits after enrollment for eligible U.S. rideshare purchases with select providers (currently Uber, Lyft, Curb, Revel, Alto; subject to change). Excludes delivery and non\u2011rideshare services.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$250 Delta Stays Credit",
      "description": "Up to $250 per calendar year in statement credits for new prepaid hotels or vacation rentals booked via Delta Stays on delta.com/stays (excludes property/resort fees, cancellations, and non\u2011prepaid products).",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "20% Back on In\u2011Flight Food & Beverage Purchases (Delta\u2011operated)",
      "description": "Get 20% back as a statement credit on eligible pre\u2011purchased meals and in\u2011flight food and beverage purchases on Delta\u2011operated flights when charged to the Card. Excludes Wi\u2011Fi and certain services.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz President\u2019s Circle Status",
      "description": "Complimentary Hertz President\u2019s Circle\u00ae status after linking Hertz Gold Plus Rewards to your SkyMiles account and enrolling via delta.com/hertz. Terms, enrollment, and age/location restrictions apply.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "American Express does not charge foreign transaction fees on purchases made outside the U.S. (merchant/ATM fees may still apply).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Insurance",
      "description": "If a round\u2011trip is paid entirely with the Card and a covered reason delays your trip more than 6 hours, receive up to $500 per trip for eligible expenses; max 2 claims per Eligible Card per 12\u2011month period. Secondary coverage; terms apply.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Insurance",
      "description": "If a round\u2011trip is paid entirely with the Card and a covered reason cancels or interrupts your trip, receive up to $10,000 per trip and up to $20,000 per Eligible Card per 12\u2011month period for non\u2011refundable travel expenses. Secondary coverage; terms apply.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage for lost, damaged, or stolen baggage when you purchase the entire fare with the Card: up to $1,250 for carry\u2011on and up to $500 for checked baggage (excess of carrier coverage). Terms and exclusions apply.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Secondary coverage for damage to or theft of a rental vehicle when you reserve and pay with the Card and decline the rental company\u2019s CDW. Not available in some countries; vehicle exclusions apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "Cell phone protection provided by New Hampshire Insurance Company (AIG), excess of other coverage; terms, conditions, and limits apply.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Coverage for eligible purchases against accidental damage or theft for a limited period after purchase, per policy terms and limits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original U.S. manufacturer\u2019s warranty on eligible items purchased with the Card, per policy terms and limits.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "May refund eligible Card purchases when the merchant won\u2019t accept a return, subject to limits and exclusions.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Dining Access by Resy",
      "description": "Access to exclusive and hard\u2011to\u2011get restaurant reservations, Priority Notify, premium dining experiences and events via Resy when you add your eligible Card to your Resy profile.",
      "benefit_type": null,
      "new_benefit_type": "global_dining_access_by_resy",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Perks",
      "description": "Access to Amex Card Member entrances/fast lanes at select venues and an optional 10% back concessions offer (enrollment required; up to $250 back per calendar year through 12/31/2026) at participating stadiums/arenas. Terms apply.",
      "benefit_type": "statement_credit",
      "new_benefit_type": "american_express_venue_collection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$240 Resy Credit",
      "description": "Up to $20 per month (up to $240/yr) in statement credits after enrollment for eligible U.S. Resy purchases (Resy restaurants on Resy, Resy app/site, or Resy Pay). Excludes Resy OS/gift cards and certain third\u2011party processed transactions.",
      "credit_type": "monthly_credit",
      "credit_category": {
        "categories": [
          "dining"
        ],
        "exclude_subcategories": null,
        "is_us_only": true,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Eligible purchases at U.S. restaurants that offer reservations on Resy.com or the Resy app and accept American Express Cards, including Resy Pay and purchases made directly on Resy.com or the Resy app."
      },
      "new_credit_category": null,
      "value": 20.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0,
            20.0
          ]
        }
      ],
      "total_yearly_value": 240.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    },
    {
      "name": "$120 Rideshare Credit",
      "description": "Up to $10 per month (up to $120/yr) in statement credits after enrollment for eligible U.S. rideshare purchases with select providers (Uber, Lyft, Curb, Revel, Alto; subject to change). Excludes delivery and non\u2011rideshare services.",
      "credit_type": "monthly_credit",
      "credit_category": {
        "categories": [
          "travel.rideshare",
          "travel.rideshare.uber",
          "travel.rideshare.lyft"
        ],
        "exclude_subcategories": null,
        "is_us_only": true,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Eligible rideshare services in the U.S. with select providers (currently Uber, Lyft, Curb, Revel, Alto)."
      },
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0,
            10.0
          ]
        }
      ],
      "total_yearly_value": 120.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    },
    {
      "name": "$250 Delta Stays Credit",
      "description": "Up to $250 per calendar year in statement credits for new prepaid hotel or vacation rental bookings via Delta Stays on delta.com/stays. Excludes property/resort fees, cancellations, and non\u2011prepaid products.",
      "credit_type": "annual_credit",
      "credit_category": {
        "categories": [
          "travel"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": true,
        "requires_travel_portal": true,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Prepaid hotels and vacation rentals booked through Delta Stays on delta.com/stays."
      },
      "new_credit_category": null,
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            250.0
          ]
        }
      ],
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    },
    {
      "name": "20% Back on Delta In\u2011Flight Food & Beverage",
      "description": "Get 20% back as a statement credit on eligible pre\u2011purchased meals and in\u2011flight food and beverages on Delta\u2011operated flights when charged to the Card. Excludes Wi\u2011Fi and some services.",
      "credit_type": "rebate_credit",
      "credit_category": {
        "categories": [
          "travel.airline",
          "travel.airline.delta"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Eligible in\u2011flight food and beverage purchases on Delta\u2011operated flights, including pre\u2011purchased meals."
      },
      "new_credit_category": null,
      "value": null,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "statement_credit_percentage_back": 20.0,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Global Entry or TSA PreCheck Application Fee Credit",
      "description": "Statement credit for the Global Entry application fee ($120 every 4 years) or TSA PreCheck (up to $85 every 4.5 years) when charged to the Card; one credit per account per interval.",
      "credit_type": "tsa_pre_global_entry",
      "credit_category": null,
      "new_credit_category": "global_entry_or_tsa_precheck_fee",
      "value": 120.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            120.0
          ]
        }
      ],
      "total_yearly_value": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    },
    {
      "name": "American Express Venue Collection Concessions Credit",
      "description": "Earn 10% back as a statement credit, up to $250 per calendar year, on qualifying food and beverage concessions at participating American Express Venue Collection stadiums/arenas after enrollment. Offer currently through 12/31/2026.",
      "credit_type": "merchant_or_category_specific_credit",
      "credit_category": {
        "categories": [
          "entertainment"
        ],
        "exclude_subcategories": null,
        "is_us_only": true,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": "2026-12-31",
        "category_description": "Qualifying in\u2011venue concessions at participating American Express Venue Collection stadiums/arenas."
      },
      "new_credit_category": null,
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            250.0
          ]
        }
      ],
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": 10.0,
      "is_guaranteed": false,
      "is_recurring": true,
      "max_occurrences_per_period": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 15000.0,
      "spendRequirementMonths": 6,
      "description": "Limited Time Offer: Earn 125,000 Delta SkyMiles after $15,000 in eligible purchases within the first 6 months from account opening. Offer ends 10/29/2025. Not available to previous or current cardholders of this product per Amex lifetime language; eligibility determined by Amex. Estimated value ~$1,500 at 1.2\u00a2/mile (range ~$1,250\u2013$2,000+ depending on redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 125000.0,
          "value_unit": "miles",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-reserve/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaReserve",
  "learn_more_link": "https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-reserve/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaReserve",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-reserve/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "delta_skymiles_reserve_business_card.png"
},
  [CreditCard.US_BANK_ALTITUDE_GO_SECURED_VISA_CARD]: {
  "id": CreditCard.US_BANK_ALTITUDE_GO_SECURED_VISA_CARD,
  "name": "U.S. Bank Altitude\u00ae Go Secured Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/us_bank_altitude_go_secured_visa_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.US_BANK_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4x (1x base + 3x bonus) on restaurant, fast-food restaurant, and bar purchases on the first $2,000 in spend each quarter. Purchases over $2,000 in that quarter earn 1x.",
      "spendCap": 2000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x at gas stations and EV charging stations. Purchases at discount stores/supercenters, wholesale clubs, and grocery stores/supermarkets earn only 1x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x at grocery stores and supermarkets. Purchases at discount stores/supercenters such as Target and Walmart and at wholesale clubs earn only 1x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "2x on qualifying streaming subscription services. Qualifying services include: Amazon Music Unlimited, Amazon Prime Video, AMC+, Apple Music, Apple TV+, Audible, DirecTV Stream, Discovery+, Disney+, ESPN+, Fandango at Home, FanDuel Sports Network, Fubo TV, Max, Hulu, iHeart, LiveOne, Luminary, MLB TV, NBA League Pass, Netflix, Pandora, Paramount+, Peacock, Showtime, SiriusXM, Sling TV, Spotify, Starz, Stitcher, Tidal, YouTube Music, YouTube Premium, and YouTube TV.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other eligible Net Purchases. Merchant category coding by Visa determines eligibility for bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.2899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2899,
    "high": 0.2899,
    "description": "Purchase APR 28.99% variable (based on Prime Rate). Balance transfer APR 28.99% variable (based on Prime Rate). Cash advance APR 30.99% variable (based on Prime Rate). Penalty APR not applicable. Minimum interest charge at least $1. Grace period 24\u201330 days; no interest on new purchases if you pay your balance in full by the due date each month."
  },
  "benefits": [
    {
      "name": "Transfer points between Altitude accounts",
      "description": "Transfer points you earned to other qualifying U.S. Bank Altitude Go or Altitude Connect accounts. Both accounts must be in good standing. You may transfer out up to 20,000 points per calendar year and accept up to 20,000 points per calendar year. All transfers are final.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer points to participating travel loyalty programs",
      "description": "You may have the opportunity to transfer points to participating airline/hotel loyalty programs via the Rewards Center. Transfer ratios vary by partner and over time; transfers generally process by the next business day (up to 72 hours). The card account name must match the partner program account name. Transfers are final and non-reversible; limits may apply.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Real-Time Rewards (instant redemption by text)",
      "description": "Enroll to instantly redeem points for eligible purchases via text message. U.S. merchant transactions only; you must have enough points to cover the full purchase. Lodging and car rental have a $150 minimum purchase. A statement credit is applied within about 3 business days and does not count toward your minimum payment. Redemptions are final.",
      "benefit_type": null,
      "new_benefit_type": "real_time_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Charitable contribution match on point redemptions",
      "description": "When redeeming points toward a monetary contribution to a named charity in the Rewards Center, U.S. Bank matches 100% of the contribution (no cap). Named charity may vary; tax treatment may vary.",
      "benefit_type": null,
      "new_benefit_type": "charitable_contribution_match",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Annual streaming services statement credit",
      "description": "Automatic $15 statement credit each 12\u2011month period after 11 consecutive months of eligible streaming service purchases, if the account is in good standing. Qualifying services include: Amazon Music Unlimited, Amazon Prime Video, AMC+, Apple Music, Apple TV+, Audible, DirecTV Stream, Discovery+, Disney+, ESPN+, Fandango at Home, FanDuel Sports Network, Fubo TV, Max, Hulu, iHeart, LiveOne, Luminary, MLB TV, NBA League Pass, Netflix, Pandora, Paramount+, Peacock, Showtime, SiriusXM, Sling TV, Spotify, Starz, Stitcher, Tidal, YouTube Music, YouTube Premium and YouTube TV.",
      "credit_category": "streaming",
      "new_credit_category": null,
      "value": 15.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [],
  "apply_link": "https://applications.usbank.com/pdap/begin?locationCode=18569&offerId=P3934BH7MQ&sourceCode=42955",
  "learn_more_link": "https://www.usbank.com/content/usbank/us/en/credit-cards/altitude-go-secured-visa-credit-card",
  "terms_and_conditions_link": "https://applications.usbank.com/pdap/terms?locationCode=18569&offerId=P3934BH7MQ&sourceCode=88242",
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Program Rules",
      "url": "https://rewards.usbank.com/benefits/card/AltitudeGoSecBenefits/program-rules"
    }
  ],
  "bank_name": "US Bank",
  "imageName": "us_bank_altitude_go_secured_visa_card.png"
},
  [CreditCard.DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD]: {
  "id": CreditCard.DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD,
  "name": "Discover it\u00ae Student Chrome",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-cash-chrome-platinum-620-382.png",
  "recommendedMinCreditScore": "no_credit_history",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 2.0,
      "description": "2% Cashback Bonus on combined gas station and restaurant purchases, up to $1,000 per quarter (then 1%).",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": 2.0,
      "signupBonusEarnRateIncreaseDurationMonths": 12,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": 2,
        "categories": [
          {
            "categories": [
              "gas"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas station purchases."
          },
          {
            "categories": [
              "dining"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Restaurant purchases."
          }
        ],
        "categoryRotationFrequency": Frequency.QUARTERLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Gas stations and restaurants combined ($1,000 quarterly cap).",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% Cashback Bonus on all other purchases (and on gas/restaurants once the combined quarterly cap is reached). Unlimited.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": 1.0,
      "signupBonusEarnRateIncreaseDurationMonths": 12
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2624,
    "apr_low": 0.1724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1724,
    "high": 0.2624,
    "description": "Purchase APR: 0% intro for 6 months, then 17.24%\u201326.24% variable. Balance Transfer APR: 10.99% intro for 6 months, then Purchase APR applies. Cash Advance APR: 29.24% variable. Minimum interest charge: $0.50. Cash advance fee: greater of $10 or 5% of the advance amount. Balance transfer fee: 3% intro; 5% for future transfers. Rates as of August 29, 2025."
  },
  "benefits": [
    {
      "name": "Free Social Security number alerts",
      "description": "Get an alert if Discover finds your Social Security number on the dark web. Activation required; free for cardmembers.",
      "benefit_type": null,
      "new_benefit_type": "social_security_number_alerts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Freeze your account (on/off)",
      "description": "If you misplace your card, you can prevent new purchases and cash advances in seconds with an on/off switch in the Discover app or website.",
      "benefit_type": null,
      "new_benefit_type": "account_freeze_control",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": 12,
      "description": "Cashback Match: Discover will automatically match all the cash back you earn at the end of your first year for new cardmembers. No limit and no minimum spend beyond earning cash back. Estimate examples (based on the card\u2019s ongoing earn rates shown on the page): if you earn $100 in cash back during the first 12 months, Discover adds $100 (total $200). If you max the 2% gas/restaurants cap ($1,000 per quarter, $4,000/year) and spend nothing else, you\u2019d earn $80 in year-one cash back and receive an additional $80 from the match (total $160 from those purchases). If you spend $500/month with $200 in 2% categories and $300 at 1%, you\u2019d earn about $84 over the year and receive an additional ~$84 from the match (total ~$168).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.discovercard.com/application/website/apply?srcCde=RJRM&ICMPGN=ALL_CC_STUDENT_CHROME_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "learn_more_link": "https://www.discover.com/credit-cards/student-credit-card/chrome-card.html?ICMPGN=ALL_CC_STUDENT_CHROME_LEARN_MORE",
  "terms_and_conditions_link": "https://www.discovercard.com/application/website/ratesrewards?srcCde=RJRM&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "terms_and_conditions_button_text": "\u2020See rates, rewards, fees, and other cost information > , Opens new window",
  "additional_links": [
    {
      "name": "Reviews",
      "url": "https://www.discover.com/credit-cards/student-credit-card/chrome-card/reviews/#all-reviews"
    }
  ],
  "bank_name": "Discover",
  "imageName": "discover_it_student_chrome_credit_card.png"
},
  [CreditCard.JETBLUE_BUSINESS_CARD]: {
  "id": CreditCard.JETBLUE_BUSINESS_CARD,
  "name": "JetBlue Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BJT_card_BC_WE_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.JETBLUE,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.jetblue",
      "earnRate": 6.0,
      "description": "6X points on eligible JetBlue purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2X points at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "officeSupplies",
      "earnRate": 2.0,
      "description": "2X points at office supply stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 99.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchase APR 0.2024\u20130.2999 (variable, based on Prime). Balance transfer APR 0.2024\u20130.2999 (variable, based on Prime). Cash advance APR 0.2999 (variable, based on Prime)."
  },
  "benefits": [
    {
      "name": "First Checked Bag Free",
      "description": "First checked bag free for the primary cardmember and up to 3 eligible travel companions on the same reservation on JetBlue-operated flights. Codeshare/partner flights do not qualify.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Boarding (Group A)",
      "description": "Priority (Group A) boarding on JetBlue-operated flights. Codeshare/partner flights excluded.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Inflight Purchase Discount",
      "description": "Discount on eligible inflight purchases on JetBlue-operated flights. Estimate: historically 50% savings on inflight food and drink with JetBlue cards; exact percentage not shown on the page provided.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary Bonus Points",
      "description": "Bonus TrueBlue points each year after your account anniversary. Estimate: commonly 5,000 points on JetBlue Business; the exact amount was not specified on the page.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Points Back on Award Redemptions",
      "description": "Receive a rebate of TrueBlue points after you redeem for and travel on a JetBlue-operated award flight. Estimate: typically 10% of points back; the exact percentage was not specified on the page.",
      "benefit_type": null,
      "new_benefit_type": "points_back_on_award_flights",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Toward Mosaic Status with Spend",
      "description": "Card spend helps you earn toward Mosaic status (per TrueBlue program terms; details/earn rate not specified on the page).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "JetBlue Vacations Statement Credit",
      "description": "Statement credit after purchasing a JetBlue Vacations package of $100 or more with the card; limit one statement credit per calendar year.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": 100,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 2000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 bonus TrueBlue points after spending $2,000 on purchases and paying the annual fee in full within the first 90 days; plus earn an additional 20,000 bonus points after reaching $6,000 in total purchases within the first year. Estimated value: assuming ~1.3\u00a2 per point, 80,000 points \u2248 $1,040 in JetBlue flight value (estimate; actual value varies by fare).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 12,
      "description": "Earn 60,000 bonus TrueBlue points after spending $2,000 on purchases and paying the annual fee in full within the first 90 days; plus earn an additional 20,000 bonus points after reaching $6,000 in total purchases within the first year. Estimated value: assuming ~1.3\u00a2 per point, 80,000 points \u2248 $1,040 in JetBlue flight value (estimate; actual value varies by fare).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/jetblue-business-card/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/jetblue-business-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "jetblue_business_card.png"
},
  [CreditCard.REDSTONE_FCU_VISA_SIGNATURE]: {
  "id": CreditCard.REDSTONE_FCU_VISA_SIGNATURE,
  "name": "Redstone FCU Visa Signature\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/redstone_fcu_visa_signature.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 5.0,
      "description": "5% cash back on your selected quarterly boosted category. You choose each quarter from popular categories including restaurants, travel, Amazon, home improvement, and more. Spending caps apply; purchases over the cap earn reduced rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          "dining",
          "travel",
          "onlineShopping",
          "homeImprovement"
        ],
        "categoryRotationFrequency": Frequency.QUARTERLY,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "Choose one boosted category each quarter from popular options like restaurants, travel, Amazon, home improvement, and more. Purchases over the spending cap earn reduced rewards.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2% cash back on gas purchases automatically.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% cash back on grocery purchases automatically.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.18,
    "apr_low": 0.155
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.0,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.155,
    "high": 0.18,
    "description": "15.50% - 18.00% variable APR based on creditworthiness at account opening."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn $150 in CashBack+ rewards after $3,000 in purchases within the first 90 days of account opening.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 150.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": "$150 CashBack+ bonus after $3,000 spend in 90 days. Must be open and in good standing. Allow 45 days after promotional period for deposit."
        }
      ]
    }
  ],
  "apply_link": "https://www.redfcu.org/personal/credits-cards/visa-signature",
  "learn_more_link": "https://www.redfcu.org/personal/credits-cards/visa-signature",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Redstone FCU",
  "imageName": "redstone_fcu_visa_signature.png"
},
  [CreditCard.KOHLS_REWARDS_VISA]: {
  "id": CreditCard.KOHLS_REWARDS_VISA,
  "name": "Kohl's Rewards\u00ae Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/kohls_visa_sig_master_rgb_300x189.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "departmentStores.kohls",
      "earnRate": 7.5,
      "description": "7.5% in Kohl\u2019s rewards at Kohl\u2019s stores or Kohls.com; excludes gift cards. Qualifying purchase amount is after coupons/discounts and before shipping, fees, or taxes. Merchant category codes (MCCs) determine eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% in Kohl\u2019s rewards at merchants whose primary business is the sale of automotive gasoline, whether purchased inside the station or at the automated fuel pump. MCCs determine eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% in Kohl\u2019s rewards at grocery stores; excludes discount stores, superstores (including warehouse clubs), and convenience stores (these earn 1%). MCCs determine eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% in Kohl\u2019s rewards on purchases everywhere else Visa is accepted. Qualifying purchases exclude cash advances, balance transfers, account access checks, and gift cards at Kohl\u2019s. Rewards convert to Kohl\u2019s Cash in $5 increments monthly, valid for 30 days.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Visa Signature Concierge",
      "description": "24-hour Visa Signature Concierge access for travel, dining, and entertainment assistance (available with the Kohl\u2019s Rewards Visa).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency and Travel Assistance Services",
      "description": "Access to Visa Signature emergency and travel assistance services (assistance, not insurance coverage; specific coverages not listed).",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Monthly exclusive savings",
      "description": "Cardholder-only coupons and promotions each month. Estimated value varies by usage; for example, using one $10\u2013$20 promo monthly could equate to ~$120\u2013$240 per year.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_cardholder_discounts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Special anniversary offer",
      "description": "A special anniversary offer each year for cardholders (details vary and not specified). Estimated value not disclosed by issuer; historically may be a coupon or targeted discount.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "MVC (Most Valued Customer) status with $600 annual Kohl\u2019s spend",
      "description": "Spend $600 at Kohl\u2019s in a calendar year with the card to receive MVC status, which provides monthly free shipping opportunities. Estimated value depends on usage; e.g., 6 free shipping redemptions at ~$8 each \u2248 $48.",
      "benefit_type": null,
      "new_benefit_type": "retailer_status_free_shipping",
      "spend_requirement": 600,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "One-time 40% off coupon valid on qualifying purchases for one transaction with your new Kohl\u2019s Card within 30 days of credit availability. Not combinable with other percent-off coupons and subject to category/brand exclusions (e.g., Sephora at Kohl\u2019s, gift cards, taxes, shipping/handling, and other listed exclusions). Estimated value depends on purchase size (e.g., $100 purchase saves $40; $200 purchase saves $80). Limit one per customer; nontransferable.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percent_off_coupon",
          "amount": 40.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/kohls/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/kohls/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "kohls_rewards_visa.png"
},
  [CreditCard.REI_COOP_MASTERCARD]: {
  "id": CreditCard.REI_COOP_MASTERCARD,
  "name": "REI Co-op\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/pages/rei/rei-co-op-mastercard.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5% in REI Co-op Mastercard Rewards on all other net purchases. Cash advances and balance transfers do not earn rewards. REI purchases earn at their own higher rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2924,
    "description": "Purchase and Balance Transfer APR: 18.24%\u201329.24% variable. Cash Advance APR: 29.24% variable. Balance transfer fee: $0 when transferred at the standard Transfer APR; 3% of each transferred balance that posts at a Promotional APR (if offered). Cash advance fee: $5 or 5% of the amount, whichever is greater. No foreign transaction fees."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "Avoid additional charges while abroad or with foreign currency.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard World Elite benefits",
      "description": "Access to Mastercard World Elite benefits (see Mastercard site for full list).",
      "benefit_type": null,
      "new_benefit_type": "mastercard_world_elite_benefits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rewards don\u2019t expire",
      "description": "REI Co-op Mastercard Rewards are available for redemption as soon as they post and won\u2019t expire for the life of the account.",
      "benefit_type": null,
      "new_benefit_type": "rewards_do_not_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No annual fee",
      "description": "$0 annual fee to use or maintain the card.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1.0,
      "spendRequirementMonths": 2,
      "description": "Earn a $100 REI gift card after your first non\u2011REI purchase made within 60 days of account opening. Existing or previous REI Co\u2011op Mastercard cardmembers are not eligible. Gift card will be sent as an e\u2011gift card if email is on file; otherwise mailed within 6\u20138 weeks after qualification. Estimation note: issuer does not specify a minimum dollar amount for the qualifying purchase; a $1 minimum is assumed for mapping purposes.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "gift_card",
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/rei/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/rei/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "rei_coop_mastercard.png"
},
  [CreditCard.AUTOGRAPH_JOURNEY_CARD]: {
  "id": CreditCard.AUTOGRAPH_JOURNEY_CARD,
  "name": "Wells Fargo Autograph Journey\u2120 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/rv/assets/autograph-journey.CX8QRJ3I_Z1vqKKW.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.WELLS_FARGO_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5x (1 base + 4 bonus) points per $1 at merchants whose MCC is hotel/motel. Unlimited; no portal requirement. Cash equivalents do not earn points. Merchant coding controls eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 4.0,
      "description": "4x (1 base + 3 bonus) points per $1 with merchants whose MCC is airlines and air carriers. Unlimited; no portal requirement. Cash equivalents do not earn points. Merchant coding controls eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3x (1 base + 2 bonus) points per $1 at restaurants, bars, fast food, and caterers (per MCC). Third\u2011party delivery services may not qualify for the bonus. Unlimited.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 3.0,
      "description": "3x (1 base + 2 bonus) points per $1 on other travel categories: vehicle/auto rentals, cruise lines, timeshares, travel agencies, discount travel sites, and campgrounds (per MCC). Excludes airlines and hotels which earn higher rates. Unlimited.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.cruise",
      "earnRate": 3.0,
      "description": "3x (1 base + 2 bonus) points per $1 on other travel categories: vehicle/auto rentals, cruise lines, timeshares, travel agencies, discount travel sites, and campgrounds (per MCC). Excludes airlines and hotels which earn higher rates. Unlimited.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other net purchases not in the above bonus categories. Cash equivalents, balance transfers, fees, interest, and gambling transactions do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable APRs based on creditworthiness: Purchases 0.1999\u20130.2899; Balance Transfers 0.1999\u20130.2899; Cash Advances 0.2999. At least 25-day grace period on purchases; minimum interest charge $1. Balance transfer fee: intro $5 or 0.03 (whichever greater) for first 120 days from account opening, then up to 0.05 (min $5). Late payment fee up to $40. No foreign transaction fee."
  },
  "benefits": [
    {
      "name": "$50 Annual Airline Statement Credit",
      "description": "Receive a one-time $50 statement credit each year after your first airline purchase of $50 or more; automatically applied. Available at account opening in year 1; thereafter the annual credit window resets after the annual fee posts.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 50,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Worldwide Automatic Common Carrier Travel Accident Insurance",
      "description": "Up to $1,000,000 in coverage for accidental loss of life, limb, sight, speech, or hearing on a covered trip when common carrier fare is paid with the card; restrictions apply.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Baggage Reimbursement",
      "description": "Secondary coverage up to $3,000 per trip for baggage lost due to theft or misdirection by a common carrier when fare is purchased with the card; limits and exclusions apply.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Protection",
      "description": "Secondary coverage up to $15,000 for nonrefundable expenses when a covered reason cancels or interrupts your trip; entire trip cost must be paid with the card (less vouchers/coupons).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Secondary coverage for damage or theft when you pay for the rental with the card and decline the rental company\u2019s collision damage waiver; certain vehicles excluded.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $1,000 per approved claim (max 2 claims per 12 months) with a $25 deductible per claim when you pay your monthly wireless bill with the card; excludes lost phones and certain failures.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "$0 foreign transaction fees on purchases made abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "24/7 assistance for dining, travel, entertainment and more; cardholder pays for any goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Luxury Hotel Collection",
      "description": "Access to a collection of premium properties with benefits when booked via the program; restrictions apply by property.",
      "benefit_type": null,
      "new_benefit_type": "visa_signature_luxury_hotel_collection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Dispatch",
      "description": "Pay-per-use roadside assistance available 24/7; fees confirmed at time of service; availability varies by area.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance Services",
      "description": "Referral and assistance services while traveling; cardholder is responsible for costs of services rendered.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points Transfer to Travel Partners",
      "description": "Transfer Wells Fargo Rewards points to select airline/hotel partners at 1:1 (unless otherwise noted) with no minimum; transfers are final and subject to partner terms.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "My Wells Fargo Deals",
      "description": "Access targeted merchant offers that provide statement credits after activation and eligible spend; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "merchant_offers_portal",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Autograph Card Exclusives",
      "description": "Access to select presale/preferred tickets for live events during specified windows; limited availability and terms apply.",
      "benefit_type": null,
      "new_benefit_type": "event_ticket_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Annual Airline Statement Credit",
      "description": "Automatically receive a $50 statement credit after your first airline purchase of $50+ each year; available at account opening in year 1; resets on the first day of the month after your annual fee is billed in subsequent years.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": 50,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 Wells Fargo Rewards points after $4,000 in purchases in the first 3 months. Estimated value about $600 at 1\u00a2/point based on issuer examples. Excludes cash equivalents, balance transfers, fees/interest, gambling, and other excluded transactions. Offer availability may vary by channel; not available if you have or had this card and received a bonus in the last 48 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://apply.wellsfargo.com/getting_started?FPID=0127E1I0P10000&product_code=CC&subproduct_code=MT&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC_CG&applicationtype=consumercreditcard",
  "learn_more_link": "https://creditcards.wellsfargo.com/autograph-journey-visa-credit-card/?FPID=0127E1I0P10000&product_code=CC&subproduct_code=MT&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC_CG",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/autograph-journey-visa/terms/?FPID=0127E1I0P10000&product_code=CC&subproduct_code=MT&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC_CG",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [
    {
      "name": "Compare Autograph credit cards",
      "url": "https://creditcards.wellsfargo.com/wells-fargo-autograph-visa-credit-cards/?product_code=CC&subproduct_code=MC&sub_channel=SEO&vendor_code=G"
    }
  ],
  "bank_name": "Wells Fargo",
  "imageName": "autograph_journey_card.png"
},
  [CreditCard.PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD]: {
  "id": CreditCard.PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD,
  "name": "Platinum Plus\u00ae Mastercard\u00ae Business Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_pltbuscm_mc-CSX9775b891.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2649,
    "apr_low": 0.1549
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1549,
    "high": 0.2649,
    "description": "0% intro APR on purchases for the first 7 billing cycles; then a 15.49%\u201326.49% variable APR applies to purchases and all balance transfers. Cash advance APR: 28.49% variable."
  },
  "benefits": [
    {
      "name": "Employee cards at no additional cost",
      "description": "Add employee cards with individual spending limits at no additional cost.",
      "benefit_type": null,
      "new_benefit_type": "free_employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard Easy Savings automatic rebates",
      "description": "Automatic rebates at participating merchants when you pay with your enrolled Mastercard business card (typical examples range ~4%\u201325% at select partners; offers vary and can change).",
      "benefit_type": null,
      "new_benefit_type": "mastercard_easy_savings_rebates",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel accident insurance",
      "description": "Travel accident insurance coverage up to $100,000.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto rental insurance",
      "description": "Coverage for rental cars (collision/damage waiver). Coverage level (primary vs. secondary) not specified by issuer materials.",
      "benefit_type": null,
      "new_benefit_type": "auto_rental_collision_damage_waiver",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and emergency assistance services",
      "description": "Emergency ticket replacement, lost-luggage assistance, and legal/medical referrals while traveling.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Coverage for eligible purchases against loss, damage, theft, or fire (per issuer protections).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Extended warranty coverage on eligible purchases (per issuer protections).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "$300 online statement credit after at least $3,000 in purchases in the first 90 days of account opening. Online-only offer availability noted by issuer. Estimated value: $300 (cash value equals statement credit amount).",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 300.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/platinum-plus-business-credit-card/?campaign=4065316~8T~en_US",
  "learn_more_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/platinum-plus-business-credit-card/?campaign=4065316~8T~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/#rates-fees-4065316~8T~en_US",
  "terms_and_conditions_button_text": "Interest Rates & Fees Summary\u2020",
  "additional_links": [
    {
      "name": "Mastercard Easy Savings",
      "url": "http://www.priceless.com/easysavings"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "platinum_plus_mastercard_business_card.png"
},
  [CreditCard.SYNCHRONY_PAY_PAL_CASHBACK_WORLD_MASTERCARD]: {
  "id": CreditCard.SYNCHRONY_PAY_PAL_CASHBACK_WORLD_MASTERCARD,
  "name": "PayPal Cashback Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/synchrony_pay_pal_cashback_world_mastercard.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5% cash back on Eligible Purchases made everywhere else that Mastercard is accepted (i.e., not made through PayPal). No cap and no minimum spend; standard exclusions apply.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "excludes_paypal_account",
        "excludes_paypal_checkout"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.paypal.com/credit-application/co/landing?intcmp=NoOff_PayPalCashbackWorldMastercard%C2%AE_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.paypal.com/credit-application/co/landing?intcmp=NoOff_PayPalCashbackWorldMastercard%C2%AE_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": "https://www.synchronycredit.com/gecrbterms/html/PayPalCashbackRewardsTerms.htm?intcmp=NoOff_PayPalCashbackWorldMastercard%C2%AE_credit%20cards_body-catalog-cards_synchrony_int",
  "terms_and_conditions_button_text": "Terms and Rates",
  "additional_links": [
    {
      "name": "Rewards Program Terms",
      "url": "https://www.synchronycredit.com/gecrbterms/html/PayPalCashbackRewardsTerms.htm"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_pay_pal_cashback_world_mastercard.jpg"
},
  [CreditCard.CHASE_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD]: {
  "id": CreditCard.CHASE_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD,
  "name": "Chase Sapphire Reserve for BusinessSM",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/chase_sapphire_reserve_for_business_s_m_credit_card.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 8.0,
      "description": "8x points on purchases made using your card through Chase Travel. Any purchases that qualify for the $300 Annual Travel Credit or the $500 Credit for stays with The Edit will not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 4.0,
      "description": "4x points on flights booked direct with the airline. If purchased through Reserve Travel Designers or FROSCH, it must be charged directly by the airline to qualify. Purchases reimbursed by the $300 Annual Travel Credit do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 4.0,
      "description": "4x points on hotels booked direct with the hotel. If purchased through Reserve Travel Designers or FROSCH, it must be charged directly by the hotel to qualify. Purchases that qualify for the $500 Credit for stays with The Edit do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineAdvertising",
      "earnRate": 3.0,
      "description": "3x points on social media and search engine advertising purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.lyft",
      "earnRate": 5.0,
      "description": "Earn 5x on eligible Lyft purchases made in the Lyft app through 9/30/2027. Additional points post separately from base points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_through_2027-09-30"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point on all other purchases. Excludes balance transfers, cash advances and cash-like transactions (e.g., travelers checks, foreign currency, money orders, wire transfers), lottery tickets, casino gaming chips, race track wagers or similar betting transactions, any checks that access your account, interest, unauthorized or fraudulent charges, and fees of any kind. Purchases that qualify for the $300 Annual Travel Credit or the $500 Credit for stays with The Edit do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 795.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2649,
    "apr_low": 0.1849
  },
  "annualFee": 795.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1849,
    "high": 0.2649,
    "description": "Flex for Business purchase APR 18.49%\u201326.49% variable based on creditworthiness; varies with the Prime Rate (7.50% as of 2025-02-04). Chase adds 10.99%\u201318.99% to Prime; maximum APR 29.99%. Grace period minimum 20 days; no minimum interest charge."
  },
  "benefits": [
    {
      "name": "$300 Annual Travel Credit",
      "description": "Automatic statement credits for travel-category purchases, up to $300 per account year. Purchases reimbursed by this credit do not earn points. Estimated value: up to $300/year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$500 Credit for stays with The Edit",
      "description": "Automatic statement credits for prepaid ('Pay Now') stays of 2 nights or more booked through The Edit by Chase Travel: up to $250 from Jan 1\u2013Jun 30 and up to $250 from Jul 1\u2013Dec 31 (max $500/year). Points are not earned on reimbursed purchases. Estimated value: up to $500/year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "The Edit Program Benefits",
      "description": "Per-room hotel perks at select properties when booked as 'The Edit' through Chase Travel (e.g., complimentary Wi\u2011Fi; benefits may vary and are subject to availability). Authorized users on this business account are not eligible for The Edit program benefits.",
      "benefit_type": null,
      "new_benefit_type": "hotel_perks_program",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass Select Membership",
      "description": "Airport lounge access for the authorizing officer with up to two complimentary guests per visit; additional guests $27 each. Access subject to lounge capacity and Priority Pass Select terms. Authorized users are not eligible for this membership. Estimated value varies with usage (lounge visits often ~$30\u2013$60+ per person).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry/TSA PreCheck/NEXUS Application Fee Credit",
      "description": "One statement credit up to $120 every 4 years after the fee posts for Global Entry, TSA PreCheck, or NEXUS when paid with the card. Estimated value: up to $120 per 4-year cycle.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass (DoorDash & Caviar)",
      "description": "At least 12 months of DashPass for primary and authorized users when activated by 12/31/2027 and paid with the card. Includes monthly discounts while enrolled: $5 off one restaurant order per month and two $10 off non\u2011restaurant orders per month (each discount used on separate orders; no rollover). Potential savings up to $25/month ($300/year) if fully used, plus DashPass fee savings depending on order volume.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$10 Monthly Lyft Credit (through 9/30/2027)",
      "description": "$10 Lyft ride credit each calendar month (Standard, Extra Comfort, XL, Black, Black SUV) when paying with the card in the Lyft app; unused credit forfeited monthly. Estimated value: up to $120/year through 9/30/2027 if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$400 Annual ZipRecruiter Credit (through 12/31/2027)",
      "description": "Automatic statement credits for ZipRecruiter purchases: up to $200 Jan\u2013Jun and up to $200 Jul\u2013Dec (max $400/year) through 12/31/2027. Estimated value: up to $400/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Annual Google Workspace Credit (through 12/31/2027)",
      "description": "Automatic statement credits for eligible Google/Workspace.Google.com purchases, up to $200 per calendar year through 12/31/2027. Estimated value: up to $200/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$100 Annual Curated Gift Card Credit (through 10/31/2028)",
      "description": "Automatic statement credits for purchases at giftcards.com/reservebusiness: up to $50 Jan\u2013Jun and up to $50 Jul\u2013Dec (max $100/year) through 10/31/2028. Estimated value: up to $100/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 $500 Credit for The Shops at Chase",
      "description": "After $120,000 in calendar\u2011year purchases (beginning 2025), authorizing officer receives up to $500 in statement credits for purchases at The Shops at Chase for the rest of that calendar year and the following year (cap of $1,000 available if qualified in consecutive years). Estimated value: up to $500 per qualification period if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 IHG One Rewards Diamond Elite Status",
      "description": "After $120,000 in calendar\u2011year purchases (beginning 2025), authorizing officer eligible for IHG Diamond Elite status for the remainder of that year and the following year (activation by linking IHG account required). Estimated value varies based on stay volume (e.g., potential value from upgrades, breakfast/welcome amenity, bonus points).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 Southwest Rapid Rewards A\u2011List Status",
      "description": "After $120,000 in calendar\u2011year purchases (beginning 2025), authorizing officer eligible for Southwest A\u2011List status for the remainder of that calendar year through the following calendar year. Last year to newly qualify is 2027 (status valid until 12/31/2028). Estimated value varies based on Southwest flying (e.g., priority boarding, same\u2011day standby, earning bonus).",
      "benefit_type": "airline_status",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120,000 Spend Benefit \u2013 $500 Southwest Airlines Chase Travel Credit",
      "description": "After $120,000 in calendar\u2011year purchases (beginning 2025), authorizing officer receives up to $500 in statement credits for Southwest purchases made via Chase Travel for the rest of that calendar year; expires at the end of the following calendar year (cap of $1,000 available if qualified in consecutive years). Authorized user purchases do not qualify. Estimated value: up to $500 per qualification period if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 120000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "IHG One Rewards Platinum Elite Status (through 12/31/2027)",
      "description": "Authorizing officer eligible for IHG Platinum Elite status through 12/31/2027 after linking their IHG account. Estimated value varies by stay activity (e.g., room upgrades where available, bonus points).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points transfer to travel partners",
      "description": "Transfer Ultimate Rewards points to participating frequent travel programs in 1,000\u2011point increments (to accounts belonging to you or an owner listed as an authorized user).",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Concierge",
      "description": "24/7 concierge assistance for travel, dining, and experiences. Cardmember pays for goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rental Car Discounts (Avis & National)",
      "description": "Base\u2011rate discounts when booking directly with Avis or National using the Visa Infinite code (not valid when booking via Chase Travel).",
      "benefit_type": null,
      "new_benefit_type": "rental_car_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry/TSA PreCheck/NEXUS Application Fee Credit",
      "description": "One statement credit up to $120 every 4 years after the fee posts for Global Entry, TSA PreCheck, or NEXUS when paid with the card. Estimated value: up to $120 per 4-year cycle.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 20000.0,
      "spendRequirementMonths": 6,
      "description": "200,000 bonus points after spending $30,000 on purchases in the first 6 months from account opening. Based on the Rewards Program Agreement, Ultimate Rewards points are redeemable for at least $0.01 per point toward cash, gift cards, or travel (i.e., 200,000 points \u2248 $2,000 minimum value). Allow 6\u20138 weeks after qualifying for points to post; account must be open and not in default at fulfillment.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 200000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HR3S&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/sapphire/reserve?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61414.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/reserveforbusiness/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "chase_sapphire_reserve_for_business_s_m_credit_card.webp"
},
  [CreditCard.IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD]: {
  "id": CreditCard.IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD,
  "name": "IHG One Rewards Premier Business Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/IHG_One_Premier_Biz_card_alt.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.IHG,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.ihg",
      "earnRate": 10.0,
      "description": "10 points per $1 on qualifying purchases at hotels participating in IHG One Rewards. Separate from IHG One Rewards member and Platinum Elite points (which can add up to 16X more). Standard non-purchase transactions (e.g., balance transfers, cash advances) do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "5 points per $1 on travel purchases; excludes purchases made at IHG Hotels & Resorts that qualify for the 10X IHG category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 5.0,
      "description": "5 points per $1 on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineAdvertising",
      "earnRate": 5.0,
      "description": "5 points per $1 on social media and search engine advertising purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "officeSupplies",
      "earnRate": 5.0,
      "description": "5 points per $1 at office supply stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5 points per $1 at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "3 points per $1 on all other purchases that do not fall into the categories above. Balance transfers, cash advances, and other cash-like transactions do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs based on the Prime Rate. Purchase APR: 19.74%\u201328.24% variable; Balance transfer APR: 19.74%\u201328.24% variable (account may not be eligible for balance transfers); Cash advance APR: 28.99% variable; Penalty APR up to 29.99%. Minimum 20-day grace period on new purchases if you pay the entire balance or Interest Saving Balance by the due date; interest on balance transfers and cash advances begins on the transaction date; minimum interest charge: none. Balance transfer fee: $5 or 5% of each transfer (whichever is greater). Late payment fee: $40; returned payment fee: $40."
  },
  "benefits": [
    {
      "name": "Automatic IHG One Rewards Platinum Elite Status",
      "description": "Automatic Platinum Elite status for as long as the card is open and the IHG One Rewards account remains in good standing. Status can add on-property perks when staying with IHG.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary Free Night (up to 40,000 points)",
      "description": "One Free Night Award each account anniversary, valid at properties costing up to 40,000 points; can use your own points to top-off above 40k. Must be used and stay completed within 12 months. Estimated value ~$160\u2013$240 assuming ~0.4\u20130.6 cents per IHG point (40,000 pts x ~$0.004\u2013$0.006).",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Redeem 3 Nights, Get 4th Night Free (on award stays)",
      "description": "For 4+ consecutive-night award stays, every 4th night is free; unlimited uses annually. Example value: on a 4-night award priced at 35k pts/night, you save 35k points (effective 25% discount on 4-night redemptions).",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry, TSA PreCheck or NEXUS application fee credit",
      "description": "Statement credit up to $120 once every 4 years after the program fee is charged to the card (primary or AU). Estimated annualized value ~$30.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual spend perk: $100 statement credit after $20,000 calendar-year spend",
      "description": "Receive a $100 statement credit each calendar year in which you spend at least $20,000 on the card. Posts 6\u20138 weeks after qualifying. Effective 0.5% rebate on the first $20,000 in annual spend when met.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual spend perk: 10,000 bonus IHG points after $20,000 calendar-year spend",
      "description": "Earn 10,000 bonus points each calendar year you spend at least $20,000 on the card (in addition to the $100 statement credit). Estimated value ~$50 assuming ~0.5 cents/point.",
      "benefit_type": null,
      "new_benefit_type": "annual_spend_bonus_points",
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Save 20% on IHG points purchases",
      "description": "At least 20% discount on purchased IHG points when paying with this card. If standard price is ~1.0 cent/point, discount lowers the effective cost to ~0.8 cent/point (actual pricing subject to IHG).",
      "benefit_type": "points_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $10,000 per item (New York residents: 90 days). Limits and exclusions apply; see Guide to Benefits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "If a trip is canceled or cut short due to covered reasons (e.g., sickness, severe weather), be reimbursed up to $1,500 per person and $6,000 per trip for prepaid, nonrefundable expenses (fares, tours, hotels). Terms and exclusions apply; see Guide to Benefits.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No fees on international purchases. Example: spending $5,000 abroad avoids ~$150 in 3% FX fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry, TSA PreCheck or NEXUS application fee credit",
      "description": "Statement credit up to $120 once every 4 years after the program fee is charged to the card (primary or AU). Estimated annualized value ~$30.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Global Entry/TSA PreCheck/NEXUS Credit",
      "description": "Up to $120 statement credit once every 4 years after the application fee is charged to the card.",
      "credit_category": null,
      "new_credit_category": "tsa_precheck_global_entry_nexus_fee",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Annual $100 credit after $20,000 calendar-year spend",
      "description": "Receive a $100 statement credit each calendar year with $20,000 in purchases.",
      "credit_category": null,
      "new_credit_category": "general_statement_credit",
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time offer: Up to 200,000 IHG points. Earn 140,000 points after $4,000 in purchases in the first 3 months from account opening; plus 60,000 additional points after a total of $9,000 in purchases in the first 6 months (200,000 total). Not available to current cardmembers of this business card, or previous cardmembers who received a new cardmember bonus for this business card within the last 24 months. Purchases exclude cash-like transactions, balance transfers, cash advances, fees, etc. Allow 6\u20138 weeks for points to post. Estimated value: ~$900\u2013$1,200 assuming ~0.45\u20130.60 cents per point (200,000 pts x ~$0.0045\u2013$0.0060).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 140000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": 9000.0,
      "spendRequirementMonths": 6,
      "description": "Limited-time offer: Up to 200,000 IHG points. Earn 140,000 points after $4,000 in purchases in the first 3 months from account opening; plus 60,000 additional points after a total of $9,000 in purchases in the first 6 months (200,000 total). Not available to current cardmembers of this business card, or previous cardmembers who received a new cardmember bonus for this business card within the last 24 months. Purchases exclude cash-like transactions, balance transfers, cash advances, fees, etc. Allow 6\u20138 weeks for points to post. Estimated value: ~$900\u2013$1,200 assuming ~0.45\u20130.60 cents per point (200,000 pts x ~$0.0045\u2013$0.0060).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPHV&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/IHG/business-premier?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60915.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/ihgonerewardspremierbizcard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "ihg_one_rewards_premier_business_credit_card.png"
},
  [CreditCard.ROBINHOOD_CARD]: {
  "id": CreditCard.ROBINHOOD_CARD,
  "name": "Robinhood Gold Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://cdn.robinhood.com/app_assets/credit-card/gold/web/shadow_card_desktop.png",
  "recommendedMinCreditScore": null,
  "availability": "waitlist",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "3 points per $1 on all Eligible Purchases. Exclusions include (but are not limited to): balance transfers, cash advances, cash equivalents (e.g., traveler\u2019s checks, money orders, gift card loads), wire transfers, lottery/gaming, government services, person-to-person payments, business-type transactions (including reselling), fees/charges, and disputed/unauthorized or fraudulent transactions. Foreign currency purchases earn after conversion to USD if otherwise eligible.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3299,
    "apr_low": 0.2999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.0,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2999,
    "high": 0.3299,
    "description": "Variable APRs tied to the Prime Rate. Purchases, balance transfers, cash advances, and APR-based Pay Over Time Plans: 0.2999-0.3299. No penalty APR. At least a 21-day grace period on purchases if the entire adjusted statement balance is paid by the due date. Interest on balance transfers and cash advances begins on the transaction date or the first day of the billing cycle in which the transaction posts, whichever is later. Minimum interest charge: none."
  },
  "benefits": [
    {
      "name": "Trip Cancellation and Interruption",
      "description": "Visa Signature trip cancellation and interruption coverage. See Visa insurance terms for specific coverage limits, triggers, and exclusions.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Security",
      "description": "Coverage for eligible new purchases against damage or theft for a limited time after purchase. Refer to Visa Purchase Security terms for coverage details and exclusions.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Collision/damage waiver when you decline the rental company\u2019s CDW and pay with the card. Typically secondary coverage for personal rentals in the U.S.; check Visa ARCDW terms for when it may be primary and for full exclusions.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the original manufacturer\u2019s warranty on eligible items purchased with the card. See Visa Extended Warranty terms for covered durations and limits.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "Assistance when a merchant won\u2019t accept a return on eligible items purchased with the card, subject to limits and exclusions in the Visa Return Protection terms.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "24/7 personal assistance for travel, dining, and entertainment planning and bookings.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance Services",
      "description": "Referral and coordination services for medical, legal, and travel emergencies while away from home. Not insurance; fees from service providers may apply.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Dispatch",
      "description": "Pay-per-use roadside assistance coordination through Visa (e.g., towing, tire change). Service fees apply per use.",
      "benefit_type": null,
      "new_benefit_type": "roadside_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Liability Protection",
      "description": "You won\u2019t be held responsible for unauthorized transactions if you promptly report them and meet Visa\u2019s conditions.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No additional fee on international purchases. Estimated value: saves about 3% compared to cards that charge typical foreign transaction fees, depending on your annual overseas spend.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Virtual Card Numbers",
      "description": "Generate disposable virtual card numbers for more private and controlled online spending.",
      "benefit_type": null,
      "new_benefit_type": "virtual_card_numbers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mystery Box bonus offers (ongoing program feature)",
      "description": "Optional rewards feature in the app offering odds-based prizes such as bonus points or temporary elevated cashback caps on select categories/merchants. Availability, caps, and odds subject to change; see app for current terms.",
      "benefit_type": null,
      "new_benefit_type": "mystery_box_bonus_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "additional_links": [],
  "bank_name": "Robinhood",
  "imageName": "robinhood_card.webp"
},
  [CreditCard.GAP_GOOD_REWARDS_MASTERCARD]: {
  "id": CreditCard.GAP_GOOD_REWARDS_MASTERCARD,
  "name": "Gap Good Rewards Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/GP_card_NEW_Enth_MC_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "onlineShopping.gapInc",
      "earnRate": 5.0,
      "description": "Earn points for every $1 spent at Gap, Banana Republic, Old Navy, and Athleta. The exact earn rate was not specified in the provided content.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "must_use_gap_inc_card_as_sole_payment_type"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn points for every $1 spent on Mastercard purchases made outside the Gap Inc. family of brands. The exact earn rate was not specified in the provided content.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.3399,
    "apr_low": 0.3399
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3399,
    "high": 0.3399,
    "description": "Purchases APR: 33.99% variable; Balance transfers APR: 33.99% variable when using your Mastercard; Cash advances APR: 33.99% variable. All APRs vary with the market based on the Prime Rate."
  },
  "benefits": [
    {
      "name": "Free Shipping on Orders $50+ (Program Benefit)",
      "description": "Eligible program members receive free Standard shipping on online orders of $50 or more (Icon members receive free Express shipping) when signed into their account; orders must ship to a single U.S. address. Estimate: value varies by order; typical standard shipping savings ~$5\u2013$9 per qualifying order.",
      "benefit_type": null,
      "new_benefit_type": "free_shipping_over_threshold",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early Access to Select Sales",
      "description": "Eligible program members may receive early access to select sales; additional details provided when available and may be subject to extra terms.",
      "benefit_type": null,
      "new_benefit_type": "early_access_to_sales",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Liability for Unauthorized Charges",
      "description": "You are not responsible for charges you did not authorize (Mastercard zero-liability policy).",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Donate Points to Select Charities",
      "description": "Eligible program members can convert rewards to donation dollars for select charities (100 points = $1 donation), subject to program caps and restrictions.",
      "benefit_type": null,
      "new_benefit_type": "points_donation",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "One-time welcome offer: 20% off your first purchase made with your new Gap Good Rewards Credit Card or Gap Good Rewards Mastercard (code expires 14 days from account opening; card must be sole payment type). Not combinable with the Family of Brands Discount; excludes gift cards, shipping, taxes, and third-party shipped merchandise; U.S. only; one-time use. Also includes free shipping on your first order at gap.com or gapfactory.com to your order\u2019s first ship-to address using Standard shipping. Estimated value: 20% off saves $20 on a $100 first purchase; first-order free shipping typically saves ~$5\u2013$9 depending on location and promo pricing.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percentage_discount",
          "amount": 20.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "gap_good_rewards_mastercard.png"
},
  [CreditCard.BLUE_BUSINESS_CASHTM_CARD]: {
  "id": CreditCard.BLUE_BUSINESS_CASHTM_CARD,
  "name": "American Express Blue Business Cash\u2122 Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/blue-business-cash.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2% cash back on all eligible purchases, up to $50,000 per calendar year. Cash back is automatically credited as a statement credit (typically by the second billing statement). Same exclusions apply as listed.",
      "spendCap": 50000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on eligible purchases after $50,000 in eligible purchases have posted in the calendar year. Cash back is automatically credited as a statement credit. Same exclusions apply as listed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2724,
    "apr_low": 0.1724
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.027,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1724,
    "high": 0.2724,
    "description": "0% intro APR on purchases for 12 months from account opening; then variable APR 17.24%\u201327.24% (Prime + 9.99% to +19.99%). Penalty APR 29.99% may apply and will end any intro APR. Variable APRs will not exceed 29.99%."
  },
  "benefits": [
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Secondary collision damage waiver when you decline the rental company\u2019s CDW; terms, exclusions, and vehicle restrictions apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Coverage for eligible purchases against accidental damage or theft for a limited time; terms and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original manufacturer\u2019s warranty on eligible items; terms, caps, and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance for travel emergencies; third\u2011party charges are the cardmember\u2019s responsibility.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you book a qualifying hotel on AmexTravel and find a publicly available lower rate that matches room and rate conditions, Amex will refund the difference; exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rate_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Expanded Buying Power",
      "description": "Ability to spend above your credit limit based on account usage and other factors; amount above the limit is due in full each cycle.",
      "benefit_type": null,
      "new_benefit_type": "expanded_buying_power",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Targeted merchant offers available after enrollment in Amex Offers; statement credits or bonus rewards vary by offer.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Entertainment Access (Presale and Reserved Tickets)",
      "description": "Access to Amex Presale Tickets and Amex Reserved Tickets for select events when paying with an Amex card; availability and limits apply.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_ticket_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection \u2013 Entrances and Fast Lanes",
      "description": "Dedicated entrances/fast lanes at select venues in the Amex Venue Collection when you show an eligible Amex card and event ticket; availability varies by event and venue.",
      "benefit_type": null,
      "new_benefit_type": "amex_venue_collection_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection \u2013 Concessions Statement Credit",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at participating Venue Collection locations after enrollment, up to $250 back per calendar year (offer currently through 12/31/2026). Estimated value: up to $250/year if you spend $2,500 on qualifying concessions.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $250 statement credit after you spend $3,000 in eligible purchases on the Card within your first 3 months of Card Membership. Limit one welcome offer per account; not available to applicants who have or have had this card. Excludes fees, interest, cash equivalents, gift cards, and similar transactions. Statement credit typically posts 8\u201312 weeks after meeting the requirement if the account is not past due or canceled. Amex may determine you ineligible based on your history with Amex and other factors.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 250.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/en-us/business/credit-cards/blue-business-cash/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-BlueBusinessCash",
  "learn_more_link": "https://www.americanexpress.com/en-us/business/credit-cards/blue-business-cash/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-BlueBusinessCash",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/bluebusinesscash-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/bluebusinesscash-credit-card/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "blue_business_cashtm_card.png"
},
  [CreditCard.BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD]: {
  "id": CreditCard.BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD,
  "name": "Business Advantage Customized Cash Rewards Mastercard\u00ae credit card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-bofa_cshbuscm_mc-CSXc0949a8f.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "Earn 3% cash back in your selected category. The $50,000 annual cap is COMBINED with 2% dining purchases; after the combined cap is reached, purchases in these categories earn 1%.",
      "spendCap": 50000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 4.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 5.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          "gas",
          "officeSupplies",
          "travel",
          "internetCablePhone",
          "telecommunications",
          "phonePlans",
          "computerServices",
          "businessConsultingServices"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.MONTHLY,
        "categoriesDescription": "3% cash back category of your choice. Options: gas stations and EV charging (mapped as gas), office supply stores, travel, TV/telecom & wireless (mapped as internet/cable/phone + telecommunications + phone plans), computer services, or business consulting services. You may change your choice once per calendar month for future purchases.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2% cash back on dining. The $50,000 annual cap is COMBINED with your 3% selected category; after the combined cap is reached, dining earns 1%.",
      "spendCap": 50000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% cash back on all purchases. Also applies to dining and selected category purchases after the combined $50,000 annual cap is reached.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 1.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 1.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2749,
    "apr_low": 0.1749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1749,
    "high": 0.2749,
    "description": "0% intro APR on purchases for 9 billing cycles; after that, a variable APR of 0.1749\u20130.2749 applies to purchases and all balance transfers. Cash advance APR is 0.2849 variable."
  },
  "benefits": [
    {
      "name": "Preferred Rewards for Business bonus",
      "description": "Earn up to 75% more cash back (up to 5.25% in your selected choice category, up to 3.5% on dining on the first $50,000 in combined purchases per calendar year, and up to 1.75% on all other purchases) if you have a Bank of America business checking account and qualify for Preferred Rewards for Business Platinum Honors tier.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel accident insurance and assistance",
      "description": "Travel benefits including $100,000 in travel accident insurance plus emergency ticket replacement, lost-luggage assistance, and legal/medical referrals when away from home.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto rental collision damage waiver",
      "description": "Auto rental insurance coverage for damage/theft when you pay with the card. Type not specified; assumed secondary coverage.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Covers certain purchases against loss, damage, theft, or fire (per card\u2019s protections).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Extends eligible manufacturer warranties on covered purchases.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free access to business credit scores",
      "description": "View Dun & Bradstreet business credit scores for free within Business Advantage 360 (for eligible U.S.-based BofA small business clients who enroll).",
      "benefit_type": null,
      "new_benefit_type": "free_access_to_dun_and_bradstreet_business_credit_scores",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Online offer: $300 statement credit after you make at least $3,000 in purchases in the first 90 days of account opening.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 300.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/cash-rewards-business-credit-card/?campaign=4065310~DS~en_US",
  "learn_more_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/cash-rewards-business-credit-card/?campaign=4065310~DS~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/#rates-fees-4065310~DS~en_US",
  "terms_and_conditions_button_text": "Interest Rates & Fees Summary\u2020",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://promo.bankofamerica.com/CalculateBusinessAdvantageCashRewards/"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "business_advantage_customized_cash_rewards_credit_card.png"
},
  [CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD]: {
  "id": CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD,
  "name": "Hilton Honors American Express Aspire Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000329_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.HILTON,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.hilton",
      "earnRate": 14.0,
      "description": "Eligible purchases made directly with hotels and resorts in the Hilton portfolio.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 7.0,
      "description": "Flights booked directly with airlines or through AmexTravel.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 7.0,
      "description": "Car rentals booked directly with select car rental companies.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 7.0,
      "description": "Dining at U.S. restaurants; includes takeout and delivery.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "All other eligible purchases not in the above categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 550.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 550.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "Hilton Honors Diamond Status",
      "description": "Complimentary Hilton Honors Diamond status with the card, including 100% bonus on Base Points on stays, premium Wi\u2011Fi, space-available room upgrades at select properties, and executive lounge access at select properties.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$400 Hilton Resort Credit",
      "description": "Up to $200 in statement credits semi\u2011annually (total up to $400 per year) on eligible purchases made directly with participating Hilton Resorts using the card. Enrollment/eligibility and terms apply.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free Night Reward",
      "description": "One Annual Free Night Reward from Hilton Honors in the first year of card membership and every year upon card renewal. Terms apply; redemption subject to Hilton Free Night Reward rules and property availability.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Flight Credit",
      "description": "Up to $50 in statement credits each quarter (up to $200 per calendar year) on flight purchases made directly with an airline or through AmexTravel.com using the card. Terms apply.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "$209 CLEAR Plus Credit",
      "description": "Up to $209 in statement credits per calendar year after paying for CLEAR Plus membership (subject to auto\u2011renewal) with the card. CLEAR operates at 50+ airports. Terms apply.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Hilton Resort Credit",
      "description": "Receive up to $200 in statement credits semi\u2011annually (up to $400 per year) on eligible purchases made directly with participating Hilton Resorts using the card. Terms apply.",
      "credit_type": "semi_annual_resort_credit",
      "credit_category": {
        "categories": [
          "travel.hotel",
          "travel.hotel.hilton"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Eligible purchases made directly with participating Hilton Resorts; see Hilton\u2019s official list of participating resorts."
      },
      "new_credit_category": null,
      "value": 400.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "biannually",
          "values": [
            200.0,
            200.0
          ]
        }
      ],
      "total_yearly_value": 400.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    },
    {
      "name": "Flight Credit",
      "description": "Up to $50 in statement credits each quarter (up to $200 per year) on flight purchases made directly with an airline or through AmexTravel.com when using the card. Terms apply.",
      "credit_type": "quarterly_airfare_credit",
      "credit_category": {
        "categories": [
          "travel.airline",
          "travel"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Flight purchases made directly with airlines or via AmexTravel.com."
      },
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "quarterly",
          "values": [
            50.0,
            50.0,
            50.0,
            50.0
          ]
        }
      ],
      "total_yearly_value": 200.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    },
    {
      "name": "CLEAR Plus Credit",
      "description": "Receive up to $209 in statement credits per calendar year after paying for CLEAR Plus membership (subject to auto\u2011renewal) with the card. Terms apply.",
      "credit_type": "clear_plus_credit",
      "credit_category": {
        "categories": [
          "travel",
          "travel.transit"
        ],
        "exclude_subcategories": null,
        "is_us_only": true,
        "is_online_only": false,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "CLEAR Plus membership fee at participating U.S. airports and venues."
      },
      "new_credit_category": null,
      "value": 209.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "annually",
          "values": [
            209.0
          ]
        }
      ],
      "total_yearly_value": 209.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": false,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "Limited-time welcome offer: Earn 175,000 Hilton Honors Bonus Points after spending $6,000 in purchases within the first 6 months of card membership. Offer ends 1/14/2026. Estimated value ~$875 assuming 0.5\u00a2 per point (valuation varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 175000.0,
          "value_unit": "points",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/hilton-honors-aspire/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/hilton-honors-aspire/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "hilton_honors_american_express_aspire_card.avif"
},
  [CreditCard.SYNCHRONY_LUXURY_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_LUXURY_CREDIT_CARD,
  "name": "Synchrony Luxury Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_clientoffer/e073410.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3499,
    "apr_low": 0.3499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3499,
    "high": 0.3499,
    "description": "New Accounts as of 7/31/25: Purchase APR 34.99%. Penalty APR 39.99%. Minimum Interest Charge $2. Promotional financing may be available (equal payment no-interest promotions, deferred interest if paid in full, or fixed pay promotions with reduced APR, e.g., 7.9% for 24 months)."
  },
  "benefits": [
    {
      "name": "Promotional financing at participating retailers",
      "description": "Access to promotional financing offers for eligible purchases at retailers that accept the Synchrony Luxury Credit Card, including: Equal Payment (no interest with equal monthly payments during the promo period), Deferred Interest (no interest if paid in full within the promo period; interest accrues from purchase date and is charged if not paid in full by the end of the period), and Fixed Pay promotions (reduced APR with fixed payments; example shown: 7.9% APR for 24 months). Availability and terms vary by retailer; subject to credit approval.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No annual fee",
      "description": "$0 annual fee for the Synchrony Luxury Credit Card.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.mysynchrony.com/luxury/cardholder.html",
  "learn_more_link": "https://www.mysynchrony.com/luxury/cardholder.html",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=FB74B472A81C4552A801417CF7FBBCAEA37EE990E0184DA6&preQual=Y&mySYFSERDYID=8484781944455637238&adobe_mc=MCMID%3D26363313776279084750302551543666281855%7CMCORGID%3D22602B6956FAB4777F000101%2540AdobeOrg%7CTS%3D1756320627&_gl=1*bunrfb*_gcl_au*MzEzNjE1ODgxLjE3NTIyNzI4OTY.*_ga*MTY3NjU4MzgyNi4xNzQ0MzA2MDc5*_ga_SHD5X90J3V*czE3NTYzMjAyNjkkbzI4JGcxJHQxNzU2MzIwNjI3JGo0MSRsMCRoMA..&platformtoken=006f078d9d758cf01cd9d039e82676bdd1b10c02&orgchannel=SyfMarketing&storeNumber=othd&intcmp=NoOff_SynchronyLuxuryCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_luxury_credit_card.avif"
},
  [CreditCard.CHASE_SAPPHIRE_RESERVE_CREDIT_CARD]: {
  "id": CreditCard.CHASE_SAPPHIRE_RESERVE_CREDIT_CARD,
  "name": "Chase Sapphire Reserve\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/chase_sapphire_reserve_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 8.0,
      "description": "8x points per $1 on travel purchases booked via Chase Travel. Only the portion paid with the card earns points when combining points + card payment. Concierge/agency bookings qualify only if processed directly through Chase Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 4.0,
      "description": "4x points per $1 on flights and hotels booked direct with the airline or hotel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 4.0,
      "description": "4x points per $1 on flights and hotels booked direct with the airline or hotel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3x points per $1 on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 3.0,
      "description": "3x points per $1 on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 795.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2849,
    "apr_low": 0.1999
  },
  "annualFee": 795.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2849,
    "description": "Purchase APR 0.1999\u20130.2849 variable with the Prime Rate (7.25% as of 9/23/2025). Balance transfer APR 0.1999\u20130.2849 variable (note: this account may not be eligible for balance transfers). Cash advance APR 0.2899 variable. Penalty APR up to 0.2999 may apply if you pay late or a payment is returned and could remain indefinitely. Minimum interest charge: none. Grace period: at least 21 days on purchases if you pay your entire balance or Interest Saving Balance by the due date; interest on balance transfers and cash advances starts on the transaction date."
  },
  "benefits": [
    {
      "name": "$300 Annual Travel Credit",
      "description": "Automatic statement credits for purchases in the travel category, up to $300 per cardmember year. Credit must be available at time of purchase; transactions that receive the credit do not earn points. Estimated value: up to $300 per year.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$500 Credit for stays with The Edit by Chase Travel",
      "description": "Automatic statement credits for purchases made with The Edit by Chase Travel, up to $500 per calendar year. Split into two earning windows: up to $250 from Jan 1\u2013Jun 30 with a minimum two-night stay, and up to $250 from Jul 1\u2013Dec 31 with a minimum two-night stay. Credit must be available at time of purchase; transactions that receive the credit do not earn points. Estimated value: up to $500 per year.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer points to participating frequent travel programs",
      "description": "Transfer Ultimate Rewards points in 1,000-point increments to participating airline and hotel programs for you or one authorized household member on the account. Once transferred, points are subject to the partner program\u2019s terms and cannot be reversed.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$500 Edit Travel Credit",
      "description": "Up to $250 in statement credits Jan\u2013Jun and again Jul\u2013Dec (two-night minimum) when you prepay stays through The Edit by Chase Travel. Purchases that qualify will not earn points.",
      "credit_type": "travel_portal_credit",
      "credit_category": {
        "categories": [
          "travel.hotel"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": true,
        "requires_travel_portal": true,
        "active_quarter": null,
        "start_date": null,
        "end_date": null,
        "category_description": "Prepaid hotel stays booked through The Edit by Chase Travel (two-night minimum stay required each half-year)."
      },
      "new_credit_category": null,
      "value": 500.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "biannually",
          "values": [
            250.0,
            250.0
          ]
        }
      ],
      "total_yearly_value": 500.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "$300 Travel Credit",
      "description": "Automatic statement credits for travel purchases each account anniversary year, up to $300. Purchases that qualify will not earn points.",
      "credit_type": "travel_credit",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 300.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "$300 Dining Credit",
      "description": "Up to $150 in statement credits Jan\u2013Jun and again Jul\u2013Dec for dining at restaurants in the Sapphire Reserve Exclusive Tables collection. Purchases that qualify will not earn points.",
      "credit_type": "dining_credit",
      "credit_category": "dining",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "biannually",
          "values": [
            150.0,
            150.0
          ]
        }
      ],
      "total_yearly_value": 300.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "DoorDash DashPass Membership",
      "description": "Complimentary DashPass for at least one year when activated by 12/31/27 (estimated $120 value).",
      "credit_type": "subscription_credit",
      "credit_category": "food_delivery",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 120.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "DoorDash Monthly Promos",
      "description": "One $5 DoorDash restaurant promo and two $10 non-restaurant promos each month through 12/31/27 (activation required).",
      "credit_type": "subscription_credit",
      "credit_category": {
        "categories": [
          "food_delivery",
          "retail"
        ],
        "exclude_subcategories": null,
        "is_us_only": false,
        "is_online_only": true,
        "requires_travel_portal": false,
        "active_quarter": null,
        "start_date": null,
        "end_date": "2027-12-31",
        "category_description": "Monthly DoorDash restaurant and non-restaurant promotional credits."
      },
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            5.0,
            10.0,
            10.0
          ]
        }
      ],
      "total_yearly_value": 300.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "StubHub & viagogo Credit",
      "description": "Up to $150 in statement credits Jan\u2013Jun and again Jul\u2013Dec for StubHub and viagogo purchases through 12/31/27 (activation required).",
      "credit_type": "entertainment_credit",
      "credit_category": "entertainment",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "biannually",
          "values": [
            150.0,
            150.0
          ]
        }
      ],
      "total_yearly_value": 300.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Apple TV+ and Apple Music",
      "description": "Complimentary Apple TV+ and Apple Music through 6/22/27 (estimated $250 value for the promotional period).",
      "credit_type": "subscription_credit",
      "credit_category": "entertainment",
      "new_credit_category": null,
      "value": 250.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 250.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Lyft In-App Credits",
      "description": "Up to $10 in monthly Lyft in-app credits through 9/30/27 (estimated $120 annual value).",
      "credit_type": "rideshare_credit",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            10.0
          ]
        }
      ],
      "total_yearly_value": 120.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Peloton Membership Credit",
      "description": "$10 in monthly statement credits on eligible Peloton All-Access or App+ memberships through 12/31/27 (activation required).",
      "credit_type": "fitness_credit",
      "credit_category": "fitness",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            10.0
          ]
        }
      ],
      "total_yearly_value": 120.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    },
    {
      "name": "Priority Pass Select",
      "description": "Complimentary Priority Pass Select membership with access to 1,300+ lounges worldwide (includes up to two guests) plus Chase Sapphire Lounges; estimated $469 annual value.",
      "credit_type": "lounge_access",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 469.0,
      "value_unit": "dollars",
      "value_unit_schedule": null,
      "total_yearly_value": 469.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": null
    }
  ],
  "signupBonus": [],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HWHN&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HWHN&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://www.chase.com/sapphirereserve/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "chase_sapphire_reserve_credit_card.png"
},
  [CreditCard.PLATINUM_MASTERCARD]: {
  "id": CreditCard.PLATINUM_MASTERCARD,
  "name": "Platinum Mastercard\u00ae from Capital One",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/plat_cardart_prim_323x203.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "29.74% variable APR for purchases"
  },
  "benefits": [
    {
      "name": "Automatic credit line reviews",
      "description": "Be automatically considered for a higher credit line in as little as 6 months.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "You won\u2019t pay a transaction fee when making a purchase outside of the United States. Estimated value: roughly 3% savings on foreign purchases compared to cards that charge foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 fraud liability",
      "description": "You will not be responsible for unauthorized charges if your card is lost or stolen (subject to investigation and verification).",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency card replacement",
      "description": "If your card is lost or stolen, you can get an emergency replacement card.",
      "benefit_type": null,
      "new_benefit_type": "emergency_card_replacement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "50% off handcrafted beverages at Capital One Caf\u00e9s",
      "description": "Capital One cardholders receive 50% off all handcrafted beverages every day at Capital One Caf\u00e9s nationwide. Limit one per person; while supplies last. Example value estimate: a $5 drink once per week saves about $2.50/week (~$130/year).",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Virtual card numbers from Eno",
      "description": "Generate virtual card numbers for online purchases to keep your actual card number private.",
      "benefit_type": null,
      "new_benefit_type": "virtual_card_numbers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/platinum/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/platinum/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "platinum_mastercard.png"
},
  [CreditCard.US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD]: {
  "id": CreditCard.US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD,
  "name": "U.S. Bank Shopper Cash Rewards\u00ae Visa Signature\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.usbank.com/content/dam/usbank/en/images/photos/credit-cards/photo-shopper-cash-rewards--no-glow-2x3.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 6.0,
      "description": "Earn 6% cash back on the first $1,500 in combined purchases each quarter at your two selected retailers (enrollment required each quarter; processing may take up to 3 business days). After the cap, and if not enrolled, purchases earn 1.5%. Purchases made through merchant subsidiaries or third\u2011party delivery services are not eligible for the 6% rate and will earn 1.5%.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 2,
        "categories": [
          "homeImprovement.aceHardware",
          "electronics.apple",
          {
            "categories": [
              "onlineShopping.amazon"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": true,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Amazon purchases (online-only merchant)."
          },
          "anthropologie",
          "bedBathBeyond",
          "electronics.bestBuy",
          {
            "categories": [
              "petPurchases.chewy"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": true,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Chewy.com purchases (online-only merchant)."
          },
          "homeFurnishings.crateAndBarrel",
          "entertainment.disney",
          "homeImprovement.homeDepot",
          "homeFurnishings.ikea",
          "departmentStores.kohls",
          "homeImprovement.lowes",
          "lululemon",
          "departmentStores.macys",
          "homeImprovement.menards",
          "departmentStores.nordstrom",
          "homeFurnishings.potteryBarn",
          "qvc",
          "homeFurnishings.restorationHardware",
          "target",
          "walmart",
          {
            "categories": [
              "onlineShopping.wayfair"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": true,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Wayfair.com purchases (online-only merchant)."
          },
          "homeFurnishings.williamsSonoma"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "6% cash back at two selected retailers each quarter (choose 2 from Ace Hardware, Apple, Amazon.com, Anthropologie, Bed Bath & Beyond, Best Buy, Chewy.com, Crate & Barrel, Disney, The Home Depot, IKEA, Kohl's, Lowe's, Lululemon, Macy's, Menards, Nordstrom, Pottery Barn, QVC, Restoration Hardware, Target, Walmart, Wayfair.com, Williams Sonoma). Enrollment required each quarter; allow up to 3 business days after registration before higher rates apply. Merchant list subject to change.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "Earn 3% cash back on the first $1,500 in purchases each quarter in your one selected category. After the cap, and if not enrolled, purchases earn 1.5%. Merchant subsidiaries and third\u2011party delivery services are not eligible for the 3% rate and will earn 1.5%.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          {
            "categories": [
              "gas"
            ],
            "exclude_subcategories": [
              "walmart",
              "target",
              "costco"
            ],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas and EV charging stations; excludes purchases coded as discount stores/supercenters (e.g., Walmart and Target), wholesale clubs (e.g., Costco), and grocery/supermarkets."
          },
          "wholesaleClub",
          "billsAndUtilities"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "3% cash back each quarter on one selected everyday category: gas and EV charging stations (excludes discount stores/supercenters, wholesale clubs, and grocery/supermarkets), wholesale clubs, or bills and home utilities. Enrollment required each quarter; allow up to 3 business days after registration before higher rates apply.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.5,
      "description": "5.5% cash back on prepaid hotel and car reservations when booked through the issuer\u2019s Travel Center with this card. Not stated to have a cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.5,
      "description": "5.5% cash back on prepaid hotel and car reservations when booked through the issuer\u2019s Travel Center with this card. Not stated to have a cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5% cash back on all other eligible purchases; also applies to spend above quarterly caps and to purchases not eligible for bonus rates.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 95.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Rewards Center Shopping Deals",
      "description": "Earn additional cash back by shopping through U.S. Bank\u2019s Rewards Center Shopping Deals at 1,100+ online stores when you pay with this card. Stacks on top of the card\u2019s base earnings.",
      "benefit_type": null,
      "new_benefit_type": "shopping_portal_cash_back_boosters",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Real-Time Rewards redemptions",
      "description": "Opt in to receive texts after purchases and instantly redeem your accumulated cash rewards to offset the full purchase amount; redemption posts as a statement credit.",
      "benefit_type": null,
      "new_benefit_type": "real_time_rewards_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Flexible redemption options",
      "description": "Redeem cash back as a statement credit, a rewards card, merchant gift cards, or direct deposit into a U.S. Bank checking or savings account. Statement credit or direct deposit typically provides maximum redemption value (per issuer footnote).",
      "benefit_type": null,
      "new_benefit_type": "flexible_redemption_options",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cash rewards never expire",
      "description": "Cash Rewards do not expire, per program footnotes.",
      "benefit_type": null,
      "new_benefit_type": "rewards_no_expiration",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "U.S. Bank ExtendPay installment plans",
      "description": "Option to split eligible purchases (over $100 and made within 60 days of enrollment) into fixed monthly payments with no interest, just a fixed monthly fee. Eligibility appears in your account when available.",
      "benefit_type": null,
      "new_benefit_type": "installment_plan_option",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Intro ExtendPay $0 fee offer",
      "description": "New cardmembers receive a $0 fee offer on ExtendPay Plans opened in the first 60 days after account opening.",
      "benefit_type": null,
      "new_benefit_type": "installment_plan_fee_waiver_intro",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 2000.0,
      "spendRequirementMonths": 4,
      "description": "Earn a $250 bonus after spending $2,000 in eligible purchases within the first 120 days of account opening. Not available to current or previous cardmembers of this specific product; bonus typically posts within 1\u20132 billing cycles and cannot be combined with other bonus offers.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 250.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://onboarding.usbank.com/usl-ce/apply/consumer-digital-credit-cards/application?sourceCode=88249&offerId=32VH7G6DBG&locationCode=8069",
  "learn_more_link": "https://www.usbank.com/credit-cards/shopper-cash-rewards-visa-signature-credit-card.html",
  "terms_and_conditions_link": "https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=32VH7G6DBG&sourceCode=88249",
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "us_bank_shopper_cash_rewards_visa_signature_card.png"
},
  [CreditCard.DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD,
  "name": "Delta SkyMiles\u00ae Platinum American Express Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000269_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DELTA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.delta",
      "earnRate": 3.0,
      "description": "3x miles on purchases made directly with Delta.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 3.0,
      "description": "3x miles on purchases made directly with hotels (not via third-party travel sites).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x miles at restaurants in the U.S., including takeout and delivery.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x miles at U.S. supermarkets.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x mile per dollar on all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 350.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 350.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "MQD Headstart",
      "description": "Receive $2,500 Medallion Qualification Dollars (MQDs) each Medallion Qualification Year to jump-start progress toward Delta Medallion Status. Estimated value varies by member; useful primarily for flyers pursuing status.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "MQD Boost",
      "description": "Earn $1 in Medallion Qualification Dollars for each $20 in purchases made on the card, helping you reach higher Delta Medallion Status levels. Ongoing benefit; value depends on annual spend and your valuation of Delta status.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "TakeOff 15 (Award Travel Discount)",
      "description": "Save 15% when booking Delta-operated award flights with miles via delta.com or the Fly Delta app; discount does not apply to partner-operated flights or to taxes and fees. Estimated value equals 15% of redeemed miles on eligible bookings.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$120 Rideshare Credit",
      "description": "Enroll and earn up to $10 in statement credits each month after using the card on eligible U.S. rideshare purchases with select providers (up to $120 per calendar year). Face value up to $120/year if fully utilized.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$150 Delta Stays Credit",
      "description": "Get up to $150 back each year as a statement credit after using the card to book prepaid hotels or vacation rentals through Delta Stays on delta.com. Face value up to $150/year if fully utilized.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Companion Certificate (Main Cabin)",
      "description": "Each year after account renewal, receive a Companion Certificate valid for a Delta Main Cabin round-trip within the U.S. and to Mexico, the Caribbean, or Central America. Taxes and fees of $22\u2013$250 apply; baggage charges and other restrictions apply; Basic fares are not eligible. Potential value varies widely based on fare prices (commonly $150\u2013$400+ when used on higher-cost itineraries).",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 80,000 bonus miles after spending $4,000 in purchases in the first 6 months. Plus earn 20,000 bonus miles after spending an additional $2,000 in the first 6 months.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "miles",
          "category": null,
          "category_description": null
        }
      ]
    },
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 20,000 additional bonus miles after spending $2,000 more in the first 6 months.",
      "rewards": [
        {
          "reward_type": "delta",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-platinum-american-express-card/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/delta-skymiles-platinum-american-express-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "delta_skymiles_platinum_american_express_card.png"
},
  [CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_CARD,
  "name": "Hilton Honors American Express Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000327_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.HILTON,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.hilton",
      "earnRate": 7.0,
      "description": "Eligible purchases made directly with hotels and resorts in the Hilton portfolio; bookings must be made directly with Hilton (not via third-party sites).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 5.0,
      "description": "Earn 5X Hilton Honors Bonus Points at U.S. restaurants, including takeout and delivery.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 5.0,
      "description": "Earn 5X Hilton Honors Bonus Points at U.S. supermarkets.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "Earn 5X Hilton Honors Bonus Points at U.S. gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "Earn 3X Hilton Honors Bonus Points on all other eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "Hilton Honors Silver Status",
      "description": "Complimentary Hilton Honors Silver elite status as long as the card is open. Silver includes a 20% bonus on Base Points and other entry-level Hilton perks, helping you reach free nights faster.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees on purchases made abroad with the card.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Events with Amex presale access",
      "description": "Access to special ticket presales and select events across sports, music, theatre, and more (while supplies last; not all seats may be offered).",
      "benefit_type": null,
      "new_benefit_type": "entertainment_presale_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Send & Split with Venmo and PayPal",
      "description": "Use Send & Split in the Amex App to send money and split purchases with Venmo or PayPal users (enrollment required; terms apply).",
      "benefit_type": null,
      "new_benefit_type": "send_and_split_venmo_paypal",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Targeted Amex Offers can be added to the card to earn extra rewards or statement credits on qualifying purchases at select brands (enrollment required; offers vary and are not guaranteed).",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 2000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 70,000 Hilton Honors Bonus Points plus a Free Night Reward after you spend $2,000 in purchases in the first 6 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "points",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/hilton-honors/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/hilton-honors/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "hilton_honors_american_express_card.png"
},
  [CreditCard.MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD,
  "name": "Marriott Bonvoy Bevy\u00ae American Express\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/category/cardarts/marriott-bonvoy-bevy-card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.MARRIOTT_BONVOY,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.marriott",
      "earnRate": 6.0,
      "description": "Eligible purchases at hotels participating in Marriott Bonvoy.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 4.0,
      "description": "Earn 4X on combined purchases at restaurants worldwide (including takeout and delivery in the U.S.) and U.S. supermarkets on up to $15,000 per calendar year; purchases above the cap earn 2X.",
      "spendCap": 15000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "dining"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Restaurants worldwide; includes takeout and delivery in the U.S."
          },
          {
            "categories": [
              "grocery"
            ],
            "exclude_subcategories": null,
            "is_us_only": true,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "U.S. supermarkets only."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Restaurants worldwide (including takeout and delivery in the U.S.) and U.S. supermarkets; combined cap applies across both categories.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "All other eligible purchases not in bonus categories; purchases in restaurants and U.S. supermarkets above the combined cap also earn 2X.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 250.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 250.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "Marriott Bonvoy 1K Bonus Points Per Stay",
      "description": "Earn 1,000 Marriott Bonvoy bonus points per paid eligible stay booked directly with Marriott at properties participating in Marriott Bonvoy. Estimated value \u2248 $7 per stay assuming ~0.7 cents per point; actual value varies by redemption.",
      "benefit_type": "bonus_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Marriott Bonvoy Gold Elite Status",
      "description": "Complimentary Marriott Bonvoy Gold Elite status. Earn up to 2.5X points from Marriott Bonvoy on eligible hotel purchases with the 25% Bonus Points on stays benefit. Only available for Qualifying Rates.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "15 Elite Night Credits",
      "description": "Receive 15 Elite Night Credits each calendar year toward the next level of Marriott Bonvoy Elite status. Limitations per Marriott Bonvoy account. Benefit is not exclusive to Cards offered by American Express.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees on purchases made abroad with the card.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Marriott Bonvoy Bevy Free Night Award (up to 50,000 points)",
      "description": "Earn 1 Free Night Award after spending $15,000 in eligible purchases on the card in a calendar year. Valid for one night with a redemption level at or under 50,000 Marriott Bonvoy points at participating hotels; certain hotels have resort fees. Estimated value roughly $300\u2013$400 depending on redemption; midpoint \u2248 $350 at ~0.7 cents per point.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": 15000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Explore and add targeted Amex Offers to the card to earn extra rewards on qualifying purchases at select brands. Offer availability and value vary.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 85,000 Marriott Bonvoy bonus points after you make $5,000 in purchases in the first 6 months of card membership. Estimated value \u2248 $595 at ~0.7 cents per point (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 85000.0,
          "value_unit": "points",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/marriott-bonvoy-bevy/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/marriott-bonvoy-bevy/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "marriott_bonvoy_bevy_american_express_card.png"
},
  [CreditCard.MY_BEST_BUY_CREDIT_CARDS]: {
  "id": CreditCard.MY_BEST_BUY_CREDIT_CARDS,
  "name": "My Best Buy\u00ae Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-best-buy-visa/citi-best-buy-visa_171x108.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "electronics.bestBuy",
      "earnRate": 10.0,
      "description": "New cardmember first-day Best Buy purchases bonus when choosing Standard Credit (no promotional financing).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "new_cardmember",
        "first_day_purchases",
        "within_first_14_days",
        "standard_credit_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "electronics.bestBuy",
      "earnRate": 5.0,
      "description": "Ongoing Best Buy earn when choosing rewards (no promotional financing). Applies to both My Best Buy Credit Card and My Best Buy Visa.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "standard_credit_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% back in rewards on gas purchases where Visa is accepted (Visa version only).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "visa_card_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% back in rewards on grocery store purchases (Visa version only).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "visa_card_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2% back in rewards on dining (restaurants and bars) (Visa version only).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "visa_card_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 2.0,
      "description": "2% back in rewards on takeout and delivery purchases (Visa version only).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "visa_card_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back in rewards on other purchases where Visa is accepted, excluding Best Buy and Pacific Sales.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "visa_card_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 59.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.3149,
    "apr_low": 0.3149
  },
  "annualFee": 59.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3149,
    "high": 0.3149,
    "description": "As of 12/24/24 per Citi disclosures: Purchase APR (store card and My Best Buy Visa) is variable 31.49% (0.3149). Balance Transfer APR is variable 31.49% (0.3149). Cash APR is variable 29.99% (0.2999). Balance transfer fee is 5% of each transfer (minimum $15). Cash advance fee is 5% (minimum $10). Minimum interest charge: $2 on store card purchases and $1 on Visa. Annual fee ranges from $0 to $59 based on creditworthiness. No foreign transaction fees on the My Best Buy Visa; the store card is not usable outside Best Buy."
  },
  "benefits": [
    {
      "name": "Flexible financing on Best Buy purchases",
      "description": "Choose promotional financing with low monthly payments on Best Buy purchases; multiple plans can be open. Note: promotional financing purchases do not earn points.",
      "benefit_type": null,
      "new_benefit_type": "flexible_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Point banking",
      "description": "Option to bank My Best Buy reward points until you\u2019re ready to redeem. Banked points will be issued as reward certificates if the account is closed.",
      "benefit_type": null,
      "new_benefit_type": "point_banking",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free shipping at Best Buy",
      "description": "Free shipping on qualifying Best Buy purchases; limitations apply.",
      "benefit_type": null,
      "new_benefit_type": "free_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees (Visa only)",
      "description": "No foreign transaction fees on the My Best Buy Visa Card (store card not eligible). Potential savings of about 3% versus typical foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember offers and limited-time promotions",
      "description": "Cardmembers in good standing receive ongoing special offers throughout the year, including occasional limited-time bonus reward categories (outside Best Buy on the Visa).",
      "benefit_type": null,
      "new_benefit_type": "cardmember_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Earn 10% back in rewards on your first day of purchases at Best Buy when you are approved for the Card and use Standard Credit; first-day purchases must occur within 14 days of account opening to qualify. Points are not awarded on promotional financing purchases. May not be combined with other offers. One acquisition offer per customer. In select stores; online offer may vary. Estimated value equals 10% of eligible first-day Best Buy spend (e.g., $500 first-day spend \u2248 $50 in Best Buy rewards).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "enhanced_earn_rate",
          "amount": 10.0,
          "value_unit": "percent_back"
        }
      ]
    }
  ],
  "apply_link": "https://www.bestbuy.com/profile/bbycard-application/route-apply?&ref=186&loc=citi_app&cmp=A~E~Z~Z~Z~Z~ZZZ0~ZZ~BB~EB",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-best-buy-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/citi-best-buy-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "my_best_buy_credit_cards.png"
},
  [CreditCard.DISNEY_PREMIER_VISA_CARD]: {
  "id": CreditCard.DISNEY_PREMIER_VISA_CARD,
  "name": "Disney\u00ae Premier Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/disney_premier_visa_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DISNEY_REWARDS_DOLLARS,
  "rewards_earn_rates": [
    {
      "category": "streaming.disneyplus",
      "earnRate": 5.0,
      "description": "5% total (1% base + 4% additional) on eligible direct purchases at Disney+, Hulu, and ESPN+ websites.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "hulu",
      "earnRate": 5.0,
      "description": "5% total (1% base + 4% additional) on eligible direct purchases at Disney+, Hulu, and ESPN+ websites.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2% total at gas stations based on merchant category coding. Some purchases may not qualify if the merchant is not coded as a gas station or if processed via certain wallets/third\u2011party payment accounts.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% total at grocery stores based on merchant category coding. Some merchants/items may not qualify if not coded as grocery or if processed via certain wallets/third\u2011party payment accounts.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2% total at restaurants based on merchant category coding. Some purchases may not qualify if not coded as dining or if processed via certain wallets/third\u2011party payment accounts.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "entertainment.disney_us_locations",
      "earnRate": 2.0,
      "description": "2% total at Disney\u2011branded U.S. locations and select eligible U.S. partner locations where Disney Rewards Dollars may be redeemed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% on all other Qualifying Purchases (excludes: balance transfers, cash advances and cash\u2011like transactions, travelers checks, foreign currency, money orders, wire transfers, lottery tickets, casino gaming chips, race track wagers or similar, checks that access the account, interest, unauthorized/fraudulent charges, and fees of any kind including annual fee). Merchant coding applies; third\u2011party payment accounts or wallets may not qualify if not coded correctly.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 49.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2699,
    "apr_low": 0.1799
  },
  "annualFee": 49.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.2699,
    "description": "Variable APRs: Purchases 0.1799\u20130.2699 (based on creditworthiness; varies with Prime Rate). Balance transfers 0.1799\u20130.2699 (variable; account may not be eligible for balance transfers). Cash advances 0.2899 (variable). Penalty APR up to 0.2999 (variable). 0% promotional APR for 6 months on select Disney vacation packages or Disney Vacation Club real estate purchases if account not past due. Minimum interest charge: none. Grace period: at least 21 days."
  },
  "benefits": [
    {
      "name": "12 months of complimentary DashPass (DoorDash and Caviar)",
      "description": "Activate between 02/01/2025 and 12/31/2027 to receive 12 months of DashPass for use on DoorDash and Caviar; must add the card as default payment and pay with it on eligible orders. Auto-renews at then-current rate after 12 months unless canceled. Estimated value \u2248 $120 based on ~$9.99/month DashPass pricing (actual value depends on your usage).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$10 off per calendar quarter on one eligible DoorDash non-restaurant order (with active DashPass)",
      "description": "After activating your complimentary DashPass, get $10 off one qualifying non-restaurant order each calendar quarter; discount does not cover fees, taxes, or gratuity, and does not roll over. Estimated annual value up to $40 if used every quarter.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "0% promo APR for 6 months on select Disney vacation purchases",
      "description": "0% promotional APR for the first 6 months from purchase date on select Disney vacation packages and purchases of a real estate interest (including Member Add On) in a Disney Vacation Club Resort, provided the account is not past due on the purchase date. Potential interest savings depend on amount financed and your standard APR.",
      "benefit_type": null,
      "new_benefit_type": "special_vacation_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Disney Store and DisneyStore.com merchandise savings",
      "description": "10% off select, in-stock merchandise in a single transaction at U.S. Disney Store, Disney Outlet Stores, and DisneyStore.com (use promo code DRVCMEMBER online). Numerous exclusions apply. Estimated value: $10 savings per $100 of eligible spend.",
      "benefit_type": null,
      "new_benefit_type": "merchandise_discount_disney_store",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Merchandise savings at Disney Theme Parks & Resorts",
      "description": "Discount on select merchandise purchases at participating retail locations at Disneyland Resort and Walt Disney World Resort; many item and location exclusions apply and availability may vary. Must pay with your Disney Visa or Disney Rewards Redemption Card.",
      "benefit_type": null,
      "new_benefit_type": "merchandise_discount_disney_parks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% off select merchandise onboard Disney Cruise Line",
      "description": "Receive 10% off select onboard merchandise purchases when your Disney Visa is the designated card for onboard purchases (sailings through 12/31/2025). Exclusions apply. Estimated value: $10 savings per $100 of eligible onboard merchandise spend.",
      "benefit_type": null,
      "new_benefit_type": "merchandise_discount_disney_cruise_line",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Dining savings at Disney Parks & Resorts",
      "description": "Discount on select food and beverage purchases at participating restaurants at Disneyland Resort, Walt Disney World Resort, and Disney\u2019s Vero Beach Resort; alcohol excluded; blackout dates and location restrictions apply. Must pay with your Disney Visa or Disney Rewards Redemption Card. Value depends on discount offered at each location and your spend.",
      "benefit_type": null,
      "new_benefit_type": "dining_discount_disney_parks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Guided tour and recreation experience savings at Disney Parks",
      "description": "Discounts on select guided tours and recreation experiences at Walt Disney World Resort and Disneyland Resort; advance reservations and theme park admission/reservations may be required; blackout dates and restrictions apply. Must pay with your Disney Visa or Disney Rewards Redemption Card. Value depends on experience cost and discount offered.",
      "benefit_type": null,
      "new_benefit_type": "guided_tour_discount_disney_parks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember Photo Opportunities with complimentary PhotoPass downloads (select locations)",
      "description": "Exclusive Disney Visa Cardmember photo locations at Disneyland Resort and Walt Disney World Resort with complimentary downloads of photos taken at those specific locations; up to 6 people per account per day; separate park admission/reservations required. Value depends on number of photos downloaded and prevailing photo pricing.",
      "benefit_type": null,
      "new_benefit_type": "cardmember_photo_op_with_photopass_downloads",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Pay Yourself Back redemption option",
      "description": "Redeem Disney Rewards Dollars for statement credits toward eligible Disney purchases (Disney Parks and Resorts locations in the U.S., Disney Store/DisneyStore.com, Disney+, Hulu, ESPN+) within 90 days of purchase at 1 Rewards Dollar = $1. For Disney Premier Visa, Pay Yourself Back also applies to airline purchases made directly with airlines within 90 days. Useful to realize full $1 per Rewards Dollar value on qualifying purchases.",
      "benefit_type": null,
      "new_benefit_type": "pay_yourself_back_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Receive a $200 Disney Gift Card eGift upon approval, plus earn a $100 statement credit after spending $500 in purchases within 3 months.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 300.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HQDR&action=guest#/origination/cardDetails/index/index;cellCode=626980;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/rewards-credit-cards/disney/premier?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61204.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Terms & Conditions",
      "url": "https://www.chase.com/disneyrewardsterms"
    }
  ],
  "bank_name": "Chase",
  "imageName": "disney_premier_visa_card.png"
},
  [CreditCard.BILT_OBSIDIAN_CARD]: {
  "id": CreditCard.BILT_OBSIDIAN_CARD,
  "name": "Bilt Obsidian Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/bilt_obsidian_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BILT_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "housing",
      "earnRate": 0,
      "description": "0.5X-1.25X points on housing through Bilt based on everyday spend ratio.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_issuer_platform"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 0.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "0.5X when spending \u226525% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_25
        },
        {
          "earnRate": 0.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "0.75X when spending \u226550% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_50
        },
        {
          "earnRate": 1.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "1X when spending \u226575% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_75
        },
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "1.25X when spending \u2265100% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_100
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3X points on dining (choose dining or grocery as your 3X category).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3X points on grocery (up to $25K/year). Choose dining or grocery as your 3X category.",
      "spendCap": 25000,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2X points on travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X points on everyday spend, plus 4% back in Bilt Cash.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "No transaction fees on housing payments",
      "description": "Pay rent or mortgage through Bilt without transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "waived_rent_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Insurance",
      "description": "Trip delay insurance coverage.",
      "benefit_type": "trip_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Bilt Travel Hotel Credit",
      "description": "$100 annual Bilt Travel Hotel credit (applied as $50 twice yearly).",
      "credit_type": "travel",
      "credit_category": null,
      "new_credit_category": "hotel_credit",
      "value": 100,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "$200 Bilt Cash sign-up bonus",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "bilt_cash",
          "amount": 200,
          "value_unit": "dollars",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.biltrewards.com/card",
  "learn_more_link": "https://www.biltrewards.com/card",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Bilt",
  "imageName": "bilt_obsidian_card.png"
},
  [CreditCard.CHOICE_PRIVILEGES_SELECT_MASTERCARD]: {
  "id": CreditCard.CHOICE_PRIVILEGES_SELECT_MASTERCARD,
  "name": "Choice Privileges\u00ae Select Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/W-Card-MarketPlace/v9-10-25/images/Products/ChoicePrivilegesSelect/WF_Choice_Fee_Card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CHOICE,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.choiceHotels",
      "earnRate": 10.0,
      "description": "10x (1 base + 9 bonus) on qualifying stays at eligible Choice brand hotels when billed by the hotel as merchant of record. Book via choicehotels.com, directly with the hotel, or by calling the Choice Hotels Service Center. Cash equivalents do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5x (1 base + 4 bonus) at gas stations, automated fuel dispensers, and EV charging stations when the merchant is coded as gas. Purchases via third\u2011party payment accounts, online marketplaces, mobile/wireless card readers, or mobile/digital wallets may not qualify for bonus points. Cash equivalents do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 5.0,
      "description": "5x (1 base + 4 bonus) at grocery stores, supermarkets, delis, and bakeries when the merchant is coded accordingly. Purchases via third\u2011party payment accounts, online marketplaces, mobile/wireless card readers, or mobile/digital wallets may not qualify for bonus points. Cash equivalents do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeImprovement",
      "earnRate": 5.0,
      "description": "5x (1 base + 4 bonus) at home improvement stores and related services when coded accordingly (includes hardware, nurseries/garden supply, furniture/household appliances, home accessories, flooring/glass/paint/wallpaper, lease/rental services for furniture/appliances, swimming pool sales/supplies, contractors, and home\u2011improvement specialists). Purchases via third\u2011party payment accounts, online marketplaces, mobile/wireless card readers, or mobile/digital wallets may not qualify for bonus points. Cash equivalents do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 5.0,
      "description": "5x (1 base + 4 bonus) on telephone plan services with landline and cell phone providers coded as telecommunication services. Purchases via third\u2011party payment accounts, online marketplaces, mobile/wireless card readers, or mobile/digital wallets may not qualify for bonus points. Cash equivalents do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x on other purchases. Cash equivalents (e.g., cash advances, money orders, traveler\u2019s checks, prepaid gift cards, P2P payments, wire transfers) do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1974
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2899,
    "description": "Purchase APR: 19.74%, 23.99%, or 28.99% (variable, based on creditworthiness and U.S. Prime Rate). Balance transfer APR: same as purchase APR (variable). Cash advance APR: 29.99% (variable). Minimum interest charge: $1. Grace period: at least 25 days on purchases if you pay your balance in full by the due date. Method: average daily balance (including new purchases)."
  },
  "benefits": [
    {
      "name": "Anniversary bonus: 30,000 Choice Privileges points",
      "description": "Earn 30,000 points each account anniversary year while the account is open and in good standing. Posts around your anniversary date and becomes redeemable within ~7 days after the billing cycle closes. Estimated value \u2248$180 assuming 0.6\u00a2 per point; your value can vary by redemption.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic Platinum Elite status with Choice Privileges",
      "description": "Automatic Platinum Elite membership; includes a 25% bonus on base Choice Privileges points on qualifying stays (per program rules; WoodSpring Suites not participating). Status terms governed by Choice Privileges program.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "20 Elite Night Credits each calendar year",
      "description": "Receive 20 elite night credits within ~14 days of account opening and within ~14 days after January 1 each subsequent calendar year, as long as the account remains open. Helps you qualify for at least Platinum level status. Credits subject to Choice Privileges program rules.",
      "benefit_type": null,
      "new_benefit_type": "elite_night_credits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Trusted Traveler (Global Entry/TSA PreCheck) application fee credit",
      "description": "One statement credit up to $120 every 4 years when you charge an eligible application or renewal fee for Global Entry or TSA PreCheck to the card. Credit applies to the first eligible fee that posts. Estimated annualized value \u2248$30/year when amortized over 4 years.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "$0 foreign currency conversion/foreign transaction fees on purchases made abroad and converted to U.S. dollars.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $800 per approved claim, $25 deductible, maximum two paid claims per 12-month period, when you pay your monthly cell phone bill with the card. Does not cover lost phones (mysterious disappearance) or electronic/software failures. Coverage begins the month after your first eligible bill payment.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard World Elite Concierge and lifestyle services",
      "description": "Access to World Elite concierge, travel and lifestyle services, and select offers; terms and availability per Mastercard World Elite program.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Trusted Traveler Program statement credit",
      "description": "Reimbursement up to $120 for Global Entry or TSA PreCheck application or renewal when charged to the card; one credit every 4 years.",
      "credit_category": null,
      "new_credit_category": "trusted_traveler_program_fee",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 Choice Privileges points after $3,000 in purchases within the first 3 months from account opening. Points typically become redeemable within 1\u20132 billing periods after they are earned. Excludes cash advances and equivalents, balance transfers, fees/interest, gambling, disputed/illegal transactions. Family rule: You may be ineligible if you opened a Choice Privileges or Choice Privileges Select Mastercard within the last 15 months and received an introductory bonus (even if closed). Estimated value \u2248$360 assuming 0.6\u00a2 per point; actual value depends on redemption (e.g., hotel category and dates).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.choicehotels.com/choice-privileges/earn-points/mastercard-credit-card?FPID=0123CBIXP10000&utm_source=WF&app_source=WELLS_FARGO_COM&locale=en_US&product_code=CC&subproduct_code=CE&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&referrerurl=creditcardswellsfargocom&lang=en",
  "learn_more_link": "https://creditcards.wellsfargo.com/choice-hotels-privileges-select-mastercard/?FPID=0123CBIXP10000&product_code=CC&subproduct_code=CE&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/choice-select/terms/?FPID=0123CBIXP10000&app_source=WELLS_FARGO_COM&product_code=CC&subproduct_code=CE&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [
    {
      "name": "Choice Privileges credit cards",
      "url": "https://creditcards.wellsfargo.com/wells-fargo-choice-privileges-credit-cards/?product_code=CC&subproduct_code=MC&sub_channel=SEO&vendor_code=G"
    }
  ],
  "bank_name": "Wells Fargo",
  "imageName": "choice_privileges_select_mastercard.png"
},
  [CreditCard.CITI_DOUBLE_CASH_CARD]: {
  "id": CreditCard.CITI_DOUBLE_CASH_CARD,
  "name": "Citi Double Cash\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citi-double-cash-credit-card/citi-double-cash-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2% total cash back on every purchase, earned as 1% when you buy and an additional 1% as you pay (points post as 1 TY point per $1 spent and 1 TY point per $1 paid when there is a corresponding Purchase Tracker balance). No caps and no category enrollment.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_paying_account_balance"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Earn 5% total cash back on hotels, car rentals, and attractions when booked through the Citi Travel portal; cash back is earned as ThankYou Points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal",
        "require_paying_account_balance"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Earn 5% total cash back on hotels, car rentals, and attractions when booked through the Citi Travel portal; cash back is earned as ThankYou Points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal",
        "require_paying_account_balance"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2799,
    "apr_low": 0.1799
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.2799,
    "description": "Purchase APR: variable 0.1799\u20130.2799 based on creditworthiness. Balance transfers: 0% intro APR for 18 months on transfers completed within 4 months of account opening; thereafter variable 0.1799\u20130.2799 applies to unpaid promo balances and new balance transfers. Cash advance APR: 0.2924. Penalty APR up to 0.2999 if you pay late or a payment is returned. Minimum interest charge: $0.50. Balance transfer fee: intro 0.03 ($5 min) within first 4 months; then 0.05 ($5 min). Foreign transaction fee: 0.03 of each purchase."
  },
  "benefits": [
    {
      "name": "Citi Entertainment access",
      "description": "Access to purchase tickets to thousands of events, including presale tickets and exclusive experiences for concerts, sports, dining experiences and more.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Identity theft monitoring program offered by Mastercard that alerts you if suspicious activity is found on the information you choose to monitor. Free enrollment required.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Liability on Unauthorized Charges",
      "description": "You are not responsible for unauthorized charges made on your account, online or otherwise.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24/7 Customer Service",
      "description": "Customer service representatives available 24 hours a day, 7 days a week.",
      "benefit_type": null,
      "new_benefit_type": "24_7_customer_service",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1500.0,
      "spendRequirementMonths": 6,
      "description": "Earn $200 cash back after $1,500 in purchases in the first 6 months of account opening. This offer is fulfilled as 20,000 ThankYou Points, redeemable for $200 cash back (1 cent per point). Bonus ThankYou Points are not available if you have received a new account bonus for a Citi Double Cash account in the past 48 months or if you converted another Citi credit card account on which you earned a new account bonus in the last 48 months into a Citi Double Cash account. Offers may vary by application source.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-double-cash-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "See if You're Pre-qualified",
      "url": "https://online.citi.com/US/ag/cards/pre-screen?intc=citihpmenu_creditcards_pq&PP=citi-double-cash&OC=CC-CITI-3CY"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi-double-cash-card.png"
},
  [CreditCard.BANKAMERICARD_FOR_STUDENTS]: {
  "id": CreditCard.BANKAMERICARD_FOR_STUDENTS,
  "name": "BankAmericard\u00ae Credit Card for Students",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cae_nrwcm_mc_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2524,
    "apr_low": 0.1524
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1524,
    "high": 0.2524,
    "description": "0.0 intro APR for 18 billing cycles on purchases and on balance transfers made within 60 days of account opening; thereafter variable APR 0.1524\u20130.2524 based on creditworthiness and the Prime Rate. Penalty APR: none."
  },
  "benefits": [
    {
      "name": "$0 Liability Guarantee",
      "description": "You are not responsible for fraudulent charges on your account.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076562&productoffercode=9Y&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/low-interest-student-credit-card/?campaign=4076562~9Y~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076562&productoffercode=9Y&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for BankAmericard\u00ae Credit Card for Students",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bankamericard_for_students.png"
},
  [CreditCard.WEST_ELM_KEY_REWARDS_VISA]: {
  "id": CreditCard.WEST_ELM_KEY_REWARDS_VISA,
  "name": "West Elm Key Rewards\u00ae Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/we_ca_cb_rgb.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 10.0,
      "description": "10% back in rewards at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham during the first 30 days from account opening; online and in stores; rewards are not earned on promotional financing purchases; earnings depend on merchant category codes (MCCs).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_30_days"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 10.0,
      "description": "10% back in rewards at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham during the first 30 days from account opening; online and in stores; rewards are not earned on promotional financing purchases; earnings depend on merchant category codes (MCCs).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_30_days"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.potteryBarn",
      "earnRate": 5.0,
      "description": "5% back in rewards at participating brands (Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham) after the first 30 days; online and in stores; excludes GreenRow; rewards are not earned on promotional financing purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeFurnishings.williamsSonoma",
      "earnRate": 5.0,
      "description": "5% back in rewards at participating brands (Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham) after the first 30 days; online and in stores; excludes GreenRow; rewards are not earned on promotional financing purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 4.0,
      "description": "4% back in rewards on Net Eligible purchases at grocery stores, restaurants (including fast food), and food delivery services. Grocery purchases made at gas stations, convenience stores, warehouse clubs, discount stores, and super stores (or at grocery stores associated with discount/super stores) earn 1% instead. Earnings depend on MCCs set by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4% back in rewards on Net Eligible purchases at grocery stores, restaurants (including fast food), and food delivery services. Grocery purchases made at gas stations, convenience stores, warehouse clubs, discount stores, and super stores (or at grocery stores associated with discount/super stores) earn 1% instead. Earnings depend on MCCs set by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 4.0,
      "description": "4% back in rewards on Net Eligible purchases at grocery stores, restaurants (including fast food), and food delivery services. Grocery purchases made at gas stations, convenience stores, warehouse clubs, discount stores, and super stores (or at grocery stores associated with discount/super stores) earn 1% instead. Earnings depend on MCCs set by the merchant.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% back in rewards on all other Net Eligible purchases anywhere Visa is accepted.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.2924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2924,
    "high": 0.2924,
    "description": "Purchase APR: 29.24% variable; Balance Transfer APR: 29.24% variable; Cash Advance APR: 29.24% variable. 12-month zero-interest promotional financing with equal monthly payments on qualifying purchases ($750+); if not paid in full after 12 months, 29.24% variable APR applies to the remaining program balance. Balance Transfer Fee: 3% on transfers that post at a Promotional APR. Cash Advance Fee: $5 or 5% (whichever is greater)."
  },
  "benefits": [
    {
      "name": "$25 birthday reward",
      "description": "Receive a $25 birthday rewards certificate each year during your birthday month, delivered via your Williams\u2011Sonoma, Inc. account. To qualify, the account must have a valid email and U.S. mailing address, be open and current, and you must make at least one purchase in the 12 months before your birthday month. New accounts opened in your birthday month are not eligible until the next calendar year. Certificate expires 30 days after issuance.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free standard shipping at Williams Sonoma and participating brands",
      "description": "Free standard shipping within the contiguous U.S. on eligible purchases at participating Williams Sonoma, Inc. brands when you pay with the West Elm Key Rewards Visa (purchase of $0.01+). Not available when an order is paid entirely with Rewards, or when using digital wallets/third\u2011party payment solutions (e.g., Apple Pay, Google Wallet, PayPal).",
      "benefit_type": null,
      "new_benefit_type": "free_standard_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to sales and events",
      "description": "Cardmembers get early access to select sales and events at participating brands.",
      "benefit_type": null,
      "new_benefit_type": "early_access_to_sales_and_events",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "12-month promotional financing (zero interest)",
      "description": "Option to forgo rewards and receive 12 equal monthly payments at 0% interest on qualifying purchases of $750 or more (excluding shipping/tax) at Pottery Barn, Williams Sonoma, West Elm, Rejuvenation and other participating brands. Account must be open and current. Standard variable APR applies to any remaining balance after 12 months. Rewards are not earned on promotional financing purchases; certain payment methods (e.g., third\u2011party wallets) are excluded.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing_12_months_zero_interest",
      "spend_requirement": 750,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Welcome bonus: 10% back in rewards on Net Eligible purchases at Williams Sonoma, Williams Sonoma Home, Pottery Barn, Pottery Barn Kids, Pottery Barn Teen, West Elm, Rejuvenation, and Mark & Graham for the first 30 days from account opening; 5% back thereafter. No stated minimum spend. Some customers may be unable to make same\u2011day purchases if virtual card access isn\u2019t available. Estimated value: incremental ~$50 per $1,000 spent at participating brands in the first 30 days versus the ongoing 5% rate.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "enhanced_rewards_rate_first_30_days_at_participating_brands",
          "amount": 10.0,
          "value_unit": "percent_back"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/westelm/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/westelm/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "west_elm_key_rewards_visa.png"
},
  [CreditCard.AAA_TRAVEL_ADVANTAGE_VISA_SIGNATURE]: {
  "id": CreditCard.AAA_TRAVEL_ADVANTAGE_VISA_SIGNATURE,
  "name": "AAA Travel Advantage Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/aaa_travel_advantage_visa_signature.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5% cash back at gas and EV charging stations. Maximum $350 cash back per calendar year on this category (equivalent to $7,000 in spend), then 1% thereafter.",
      "spendCap": 7000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.evCharging",
      "earnRate": 5.0,
      "description": "5% cash back at gas and EV charging stations. Maximum $350 cash back per calendar year on this category (equivalent to $7,000 in spend), then 1% thereafter.",
      "spendCap": 7000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "3% cash back on travel, restaurants, grocery stores, and AAA purchases. Merchant category codes determine eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3% cash back on travel, restaurants, grocery stores, and AAA purchases. Merchant category codes determine eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3% cash back on travel, restaurants, grocery stores, and AAA purchases. Merchant category codes determine eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3149,
    "apr_low": 0.1749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1749,
    "high": 0.3149,
    "description": "Variable Purchase and Balance Transfer APRs of 17.49% - 31.49% based on creditworthiness and the Prime Rate. Variable Cash Advance APR of 32.49%."
  },
  "benefits": [
    {
      "name": "No Annual Fee",
      "description": "No annual fee for the life of the card.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Flexible Cash Back Redemption",
      "description": "Cash back can be redeemed as statement credits, direct deposit, rewards, and qualifying purchases at participating AAA locations.",
      "benefit_type": null,
      "new_benefit_type": "flexible_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $100 statement credit when you spend $1,000 within the first 90 days of account opening. Valid one time only; credit received within 1-2 billing cycles after qualifying spend.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://d.comenity.net/ac/traveladvantagesig/public/home",
  "learn_more_link": "https://finance.aaa.com/credit-card",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Comenity",
  "imageName": "aaa_travel_advantage_visa_signature.webp"
},
  [CreditCard.ROYAL_CARIBBEAN_VISA_SIGNATURE]: {
  "id": CreditCard.ROYAL_CARIBBEAN_VISA_SIGNATURE,
  "name": "Royal Caribbean\u00ae Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://secure.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/raem_sigcm_v_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.MYCRUISE_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.cruise.royalCaribbean",
      "earnRate": 2.0,
      "description": "Earn 2 MyCruise points (1 base + 1 bonus) per $1 on eligible purchases made directly with Royal Caribbean and sister brands Celebrity Cruises and Silversea when the merchant or ship name appears on your statement. Non\u2011purchase transactions (e.g., fees, interest, cash advances, balance transfers) do not earn points. Program cap: maximum 540,000 MyCruise points earned per calendar year across all purchases; points expire 60 months after they are earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 MyCruise point per $1 on all other purchases. Non\u2011purchase transactions (e.g., fees, interest, cash advances, balance transfers) do not earn points. Program cap: maximum 540,000 MyCruise points earned per calendar year across all purchases; points expire 60 months after they are earned.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "Purchases APR 0.1824\u20130.2824 variable based on Prime Rate; no intro APR; penalty APR up to 0.2999 may apply if late; at least 25-day grace period on purchases; interest on balance transfers and cash advances accrues from the transaction date."
  },
  "benefits": [
    {
      "name": "Visa Signature Concierge",
      "description": "Access to Visa Signature Concierge service (call 800-953-7392) for travel, dining and entertainment assistance; terms, conditions and exclusions apply per Benefits Guide.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Online-only welcome offers: (1) 30,000 MyCruise bonus points after at least $1,000 in purchases within 90 days of account opening. Estimated value ~$300 in onboard credit at issuer-stated 1\u00a2/point valuation. Purchases only (no cash advances/balance transfers); account must be open/active; limit 1 per new account; bonus posts ~1\u20132 billing cycles after qualifying; returns/credits reduce qualifying spend; value may be taxable. (2) One-time $50 Air2Sea airfare discount for new cardholders after at least $3,500 in purchases within 90 days; discount is delivered by mail with redemption instructions, expires 18 months from issue, must be used on Air2Sea airfare tied to a Royal Caribbean cruise; discount credited after final cruise payment; Air2Sea booking service fee applies ($15 NA / $25 international); purchases only; returns/credits reduce spend.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": 3500.0,
      "spendRequirementMonths": 3,
      "description": "Online-only welcome offers: (1) 30,000 MyCruise bonus points after at least $1,000 in purchases within 90 days of account opening. Estimated value ~$300 in onboard credit at issuer-stated 1\u00a2/point valuation. Purchases only (no cash advances/balance transfers); account must be open/active; limit 1 per new account; bonus posts ~1\u20132 billing cycles after qualifying; returns/credits reduce qualifying spend; value may be taxable. (2) One-time $50 Air2Sea airfare discount for new cardholders after at least $3,500 in purchases within 90 days; discount is delivered by mail with redemption instructions, expires 18 months from issue, must be used on Air2Sea airfare tied to a Royal Caribbean cruise; discount credited after final cruise payment; Air2Sea booking service fee applies ($15 NA / $25 international); purchases only; returns/credits reduce spend.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "airfare_discount",
          "amount": 50.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "royal_caribbean_visa_signature.png"
},
  [CreditCard.CITI_AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.CITI_AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD,
  "name": "Citi\u00ae / AAdvantage\u00ae Executive World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citi-aadvantage-executive-credit-card/citi-aadvantage-executive-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.american",
      "earnRate": 4.0,
      "description": "4x AAdvantage miles on eligible American Airlines purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.american",
      "earnRate": 5.0,
      "description": "After you spend $150,000 in purchases on the card in a calendar year, earn a total of 5x AAdvantage miles on eligible American Airlines purchases for the remainder of that calendar year.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": 150000.0,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 10.0,
      "description": "10x AAdvantage miles on eligible hotels booked through aadvantagehotels.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 10.0,
      "description": "10x AAdvantage miles on eligible car rentals booked through aadvantagecars.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x AAdvantage mile on all other purchases (no cap).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 595.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 595.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable APR for purchases, balance transfers, and Citi Flex Plans: 0.1999\u20130.2899 based on creditworthiness. Cash advance variable APR: 0.2924. Penalty APR up to 0.2999. Minimum interest charge: $0.50. Citi Flex Pay Plan Fee: monthly fee up to 0.0172 (based on plan duration, applicable APR, and other factors)."
  },
  "benefits": [
    {
      "name": "Admirals Club Membership",
      "description": "Full Admirals Club membership with access to nearly 100 Admirals Club and partner lounges worldwide. Guesting permitted (immediate family or up to 2 guests). Citi indicates an \u201cup to $850 value.\u201d Authorized users also receive Admirals Club access when added to the account (AU fees apply).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "First Checked Bag Free (American Airlines domestic itineraries)",
      "description": "First checked bag free on domestic American Airlines itineraries for the primary cardmember and up to 8 companions on the same reservation.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Check-in, Screening, and Boarding",
      "description": "Complimentary priority check-in and screening (where available) and priority boarding for the primary cardmember and up to 8 companions on the same reservation.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "TSA PreCheck or Global Entry Application Fee Credit",
      "description": "Reimbursement for the application fee for Global Entry or TSA PreCheck of up to $120 every 4 years.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% Savings on Inflight Food and Beverage (American Airlines)",
      "description": "Receive 25% savings on food and beverage purchases when you use the card on American Airlines flights.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Monthly Lyft Credits",
      "description": "Earn a $10 Lyft credit each month after taking 3 eligible Lyft rides in that calendar month (up to $120 per year).",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 3,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Monthly Grubhub Credits",
      "description": "Up to $10 statement credit per monthly billing statement on eligible Grubhub purchases (up to $120 in 12 billing statements).",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Avis and Budget Prepaid Rental Credit",
      "description": "Up to $120 in statement credits each calendar year when eligible prepaid car rentals are booked directly on avis.com or budget.com.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation & Interruption Protection",
      "description": "Coverage for certain non-refundable trip expenses if your trip is canceled or interrupted for covered reasons. Terms and exclusions apply.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Protection",
      "description": "Reimbursement for reasonable expenses incurred during eligible trip delays, subject to policy limits and conditions.",
      "benefit_type": null,
      "new_benefit_type": "trip_delay_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Coverage for essential items when your checked baggage is delayed beyond a covered time threshold, subject to policy limits.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Reimbursement for lost or stolen checked or carry-on bags, subject to policy limits and exclusions.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Worldwide Car Rental Insurance (CDW)",
      "description": "Collision Damage Waiver coverage for eligible car rentals worldwide when you pay with your card. Terms vary by country and rental; coverage often acts as secondary in the U.S.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment Access",
      "description": "Access to special event offers and the ability to purchase presale tickets and exclusive experiences for concerts, sports, dining and more.",
      "benefit_type": null,
      "new_benefit_type": "citi_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "AAdvantage Loyalty Points Milestone Bonuses",
      "description": "Earn a 10,000 Loyalty Points bonus after reaching 50,000 Loyalty Points in a status qualification year and another 10,000 after reaching 90,000 in the same year (up to 20,000 bonus LP annually).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Up to $120 back on eligible prepaid Avis\u00ae and Budget car rentals",
      "description": "Earn up to $120 in statement credits each calendar year when eligible prepaid car rentals are booked directly on avis.com or budget.com (once per calendar year).",
      "credit_category": "travel_car_rental",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "usd",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $120 in Lyft credits",
      "description": "After taking 3 eligible Lyft rides in a calendar month, earn a $10 Lyft credit (up to $120 in credits annually).",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "usd",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $120 back on eligible Grubhub purchases",
      "description": "Earn a statement credit up to $10 per monthly billing statement on eligible Grubhub purchases (up to $120 every 12 billing statements).",
      "credit_category": "dining",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "usd",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Global Entry\u00ae or TSA PreCheck\u00ae Application Fee Credit",
      "description": "Receive a statement credit up to $120 every 4 years as reimbursement for your Global Entry or TSA PreCheck application fee (primary cardmember only).",
      "credit_category": "travel_security",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "usd",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": "every_four_years"
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 10000.0,
      "spendRequirementMonths": 3,
      "description": "70,000 AAdvantage bonus miles after making $7,000 in purchases within the first 3 months of account opening. Not available if you have received a new account bonus for this card in the past 48 months or converted another Citi card (on which you earned a new account bonus in the last 48 months) to this card. Offer may be location/page-specific and is only available to U.S. residents of the 50 states and territories excluding Puerto Rico and U.S. Virgin Islands. Estimated value \u2248 $910 at 1.3 cents per mile (your value may vary by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 70000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-aadvantage-executive-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_aadvantage_executive_world_elite_mastercard.png"
},
  [CreditCard.BUSINESS_GREEN_REWARDS_CARD]: {
  "id": CreditCard.BUSINESS_GREEN_REWARDS_CARD,
  "name": "Business Green Rewards Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/business-green-rewards.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline",
      "earnRate": 2.0,
      "description": "2X Membership Rewards points on flights booked through AmexTravel.com or the Amex Travel App. Other booking channels are not eligible for this bonus.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2X Membership Rewards points on prepaid hotel bookings made through AmexTravel.com or the Amex Travel App. Non-prepaid hotel bookings are excluded from this bonus.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 Membership Rewards point per dollar on other eligible purchases made with the Business Green Rewards Card.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1824
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.027,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2899,
    "description": "Variable Pay Over Time purchase APR 18.24%\u201328.99% based on creditworthiness; varies with Prime Rate. Penalty APR 29.99% may apply for returned payment, 2 late payments in 12 billing periods, or not paying Minimum Payment Due by the Closing Date; applies for at least 12 billing periods. At least 25-day grace period; no interest if entire balance is paid by due date. Variable APRs will not exceed 29.99%."
  },
  "benefits": [
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance for emergencies while traveling; you are responsible for third-party costs. See terms at americanexpress.com/GAterms.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Coverage for damage or theft of a rental vehicle when you pay with the Card; terms, conditions and exclusions apply (see americanexpress.com/CRLDIterms). Coverage is typically secondary\u2014verify specifics in the benefit guide.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage for baggage when traveling; terms, conditions and exclusions apply (see americanexpress.com/BIPterms).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends eligible U.S. manufacturer\u2019s warranties on covered purchases; terms apply (see americanexpress.com/EWterms).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Protection for eligible purchases against accidental damage or theft; terms apply (see americanexpress.com/PPterms).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Membership Rewards Points Transfer",
      "description": "Transfer Membership Rewards points to participating airline and hotel partners (enrollment required). A $0.0006 per point fee applies for U.S. airline transfers, up to $99 per transfer.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Insider Fares on Flights via AmexTravel.com",
      "description": "Discounted points pricing (fewer Membership Rewards points required) on select flights when using Pay with Points and logged in with enough points.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you find the same prepaid or qualifying pay-later hotel booking for less online, Amex will refund the difference. Restrictions and exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rate_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Concessions Credit",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at venues in the Amex Venue Collection, up to $250 back per calendar year after enrollment. Offer currently through 12/31/2026; terms apply.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "credit_type": "american_express_venue_collection_concessions",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 15,000 Membership Rewards points after $3,000 in eligible purchases within the first 3 months of Card Membership. Excludes fees/interest, traveler\u2019s checks, prepaid/gift cards, person-to-person payments, and other cash equivalents. One offer per account; not available if you have or have had this Card. Points post 8\u201312 weeks after meeting the requirement. Estimated value: $90\u2013$150 (assumes ~0.6\u20131.0 cents per point via statement credits or Pay with Points for flights; actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 15000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-green-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Green",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-green-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Green",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/business-green-rewards-charge-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/business-green-rewards-charge-card/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "business_green_rewards_card.png"
},
  [CreditCard.CITI_MACYS_CREDIT_CARDS]: {
  "id": CreditCard.CITI_MACYS_CREDIT_CARDS,
  "name": "Macy's American Express\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-macys-amex/citi-macys-amex_171x108.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "departmentStores.macys",
      "earnRate": 2.0,
      "description": "Silver status: 2 points per $1 at Macy\u2019s stores, Macy\u2019s Backstage, and macys.com. Excludes gift cards, services, and fees. New accounts start at Silver.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "departmentStores.macys",
      "earnRate": 3.0,
      "description": "Gold status: 3 points per $1 at Macy\u2019s stores, Macy\u2019s Backstage, and macys.com. Excludes gift cards, services, and fees. Gold is earned with $500\u2013$1,199 annual Macy\u2019s spend on the card.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "departmentStores.macys",
      "earnRate": 5.0,
      "description": "Platinum status: 5 points per $1 at Macy\u2019s stores, Macy\u2019s Backstage, and macys.com. Excludes gift cards, services, and fees. Platinum is earned with $1,200+ annual Macy\u2019s spend on the card.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Macy\u2019s American Express Card only: 3 points per $1 at restaurants (includes dine-in and takeout; delivery services included per card terms).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 3.0,
      "description": "Macy\u2019s American Express Card only: 3 points per $1 on restaurant delivery services (e.g., food delivery apps) as noted by 'restaurants including delivery.'",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Macy\u2019s American Express Card only: 2 points per $1 at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "Macy\u2019s American Express Card only: 2 points per $1 at supermarkets.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Macy\u2019s American Express Card only: 1 point per $1 on purchases everywhere else American Express is accepted (outside of Macy\u2019s).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "No annual fee",
      "description": "No annual fee for Macy's Credit Cards.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Star Money Bonus Days",
      "description": "Exclusive promotional periods when you can earn rewards faster at Macy\u2019s (details vary by promotion).",
      "benefit_type": null,
      "new_benefit_type": "star_money_bonus_days",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Member Exclusives",
      "description": "Cardholder-only offers to earn bonus points on select brands and promotions at Macy\u2019s.",
      "benefit_type": null,
      "new_benefit_type": "member_exclusives_bonus_points",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Star Passes",
      "description": "Special savings offers available only to Macy\u2019s cardholders.",
      "benefit_type": null,
      "new_benefit_type": "star_passes_cardholder_discounts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Birthday Surprise",
      "description": "Annual birthday surprise sent to cardholders.",
      "benefit_type": null,
      "new_benefit_type": "birthday_surprise",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free shipping benefit (status-based)",
      "description": "Silver members get free shipping at $25; Gold and Platinum get free shipping with no minimum when using a Macy\u2019s Card at Macy\u2019s. Status depends on annual Macy\u2019s spend.",
      "benefit_type": null,
      "new_benefit_type": "free_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers (Macy\u2019s American Express only)",
      "description": "Targeted offers to save on shopping, dining and more when you add offers and pay with your Macy\u2019s American Express Card.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Presale/early-access tickets (Macy\u2019s American Express only)",
      "description": "Early access to premium tickets for concerts, theater, sports and more.",
      "benefit_type": null,
      "new_benefit_type": "presale_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel upgrades and savings (Macy\u2019s American Express only)",
      "description": "Access to select travel-related savings and potential upgrades when booking through participating partners; specific details vary by offer.",
      "benefit_type": null,
      "new_benefit_type": "travel_upgrades_and_savings",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Open a Macy\u2019s Card and get 30% off macys.com purchases the same day you open the card (in-store discount varies). Savings capped at $100. Subject to credit approval. Estimated value: up to $100 (30% off up to roughly $333 in purchases to reach the cap).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 30.0,
          "value_unit": "percent (macys.com purchases on approval day; up to $100 cap; in-store discount varies)"
        }
      ]
    }
  ],
  "apply_link": "https://citiretailservices.citibankonline.com/apply/macys-credit-card?app=UNSOL&siteId=PLCN_MACYS&langId=EN&sc=80002&cmp=W~C~V~B~Z~E~ZZZZ~AI~MA~ZZ",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-macys-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/citi-macys-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_macys_credit_cards.png"
},
  [CreditCard.RALPHS_REWARDS_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.RALPHS_REWARDS_WORLD_ELITE_MASTERCARD,
  "name": "Ralphs Rewards World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.ralphsmastercard.com/credit/mc_ralphs/images/hero-xs.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases.mobileWallet",
      "earnRate": 5.0,
      "description": "Kroger Pay is a proprietary wallet usable at Kroger Family of Companies. If a Kroger Pay transaction could also qualify for another category, the issuer decides which category applies.",
      "spendCap": 3000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 3.0,
      "description": "Combined annual cap across dining and fuel station purchases. Above the cap, these purchases earn 1%.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "dining",
          "gas"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Dining and fuel station purchases earn 3% cash back on the first $6,000 in combined purchases each calendar year; 1% thereafter. Kroger Pay transactions at Fuel Centers are included in this combined cap and rate. Mobile wallet transactions at Kroger Fuel Centers earn no rewards.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other eligible purchases earn 1% cash back. Note: Mobile wallet transactions at Kroger Fuel Centers do not earn rewards.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time new cardmember offers: (1) Earn a $100 statement credit after $500 in eligible purchases within 90 days of account opening. (2) Receive a FREE Boost Essential membership (approx. $69 value) upon approval and Boost enrollment; alternatively, get a $69 waiver if you choose the $99 Same-Day Boost membership. Boost membership includes 2x Fuel Points on qualifying in-store, pickup, and delivery purchases at Kroger Family of Companies (exclusions apply). Account must be open and in good standing; allow 6\u20138 weeks for the $100 statement credit after the promotion period.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": "$100 statement credit after $500 in eligible purchases within 90 days; new cardmembers only; account must be open and in good standing; allow 6\u20138 weeks after promotion period."
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Limited-time new cardmember offers: (1) Earn a $100 statement credit after $500 in eligible purchases within 90 days of account opening. (2) Receive a FREE Boost Essential membership (approx. $69 value) upon approval and Boost enrollment; alternatively, get a $69 waiver if you choose the $99 Same-Day Boost membership. Boost membership includes 2x Fuel Points on qualifying in-store, pickup, and delivery purchases at Kroger Family of Companies (exclusions apply). Account must be open and in good standing; allow 6\u20138 weeks for the $100 statement credit after the promotion period.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "boost_essential_membership",
          "amount": 69.0,
          "value_unit": "dollars",
          "category": null,
          "category_description": "FREE Next-Day Delivery Boost Essential membership upon approval and Boost enrollment (estimated $69 value). If choosing Same-Day $99/year Boost, a $69 waiver applies instead. One per household; enrollment and payment info required; terms apply."
        },
        {
          "reward_type": null,
          "new_reward_type": "fuel_points_multiplier",
          "amount": 2.0,
          "value_unit": "x",
          "category": "grocery",
          "category_description": "2x Fuel Points (1 base + 1 bonus per $1) on qualifying in-store, curbside pickup, and delivery purchases at Kroger Family of Companies as a benefit of Boost membership; exclusions apply."
        }
      ]
    }
  ],
  "apply_link": "https://www.ralphsmastercard.com/",
  "learn_more_link": "https://www.ralphsmastercard.com/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "ralphs_rewards_world_elite_mastercard.png"
},
  [CreditCard.JETBLUE_CARD]: {
  "id": CreditCard.JETBLUE_CARD,
  "name": "JetBlue Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/JBM_card_NoFee_WM_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.JETBLUE,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.jetblue",
      "earnRate": 3.0,
      "description": "3x TrueBlue points on eligible JetBlue purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x TrueBlue points at restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x TrueBlue points at eligible grocery stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x TrueBlue points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchases APR 0.2024 to 0.2999 variable based on the Prime Rate and creditworthiness. Cash advances APR 0.2999 variable. Minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "Inflight purchase savings",
      "description": "Savings on eligible inflight purchases on JetBlue-operated flights (codeshare and partner-operated flights not eligible).",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn toward Mosaic status with every purchase",
      "description": "Card purchases earn credit toward JetBlue Mosaic elite status (specific earning mechanics not detailed on the page).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points Payback (redeem points for statement credits)",
      "description": "Points Payback allows you to redeem TrueBlue points for a statement credit toward your card purchases.",
      "benefit_type": null,
      "new_benefit_type": "points_payback_statement_credit_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn bonus TrueBlue points after spending $1,000 on purchases in the first 90 days of account opening. Offer subject to approval; bonus may be earned once; additional eligibility restrictions apply\u2014see terms.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/jetblue-card/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/jetblue-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "jetblue_card.png"
},
  [CreditCard.BEST_FRIENDS_CREDIT_CARD]: {
  "id": CreditCard.BEST_FRIENDS_CREDIT_CARD,
  "name": "Best Friends\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/best-friends-orange.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "petPurchases",
      "earnRate": 5.0,
      "description": "5% cash back on eligible purchases at pet shops and pet food & supply stores, on up to $5,000 in purchases per calendar year. Exclusions: pet grooming (unless ancillary to a pet shop), pet sitting and boarding (unless ancillary to a pet shop), veterinary services, purchases at discount supercenters (e.g., Walmart, Target), purchases at warehouse clubs (e.g., Sam\u2019s Club, Costco), and purchases made with PayPal. Merchant category coding must reflect pet shops/pet supply stores; transactions without an eligible code do not qualify. Rewards post as automatic statement credits on statements with at least one Net Eligible Purchase. No rewards on cash advances, balance transfers, fees/interest, or while the account is delinquent or in default.",
      "spendCap": 5000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "petPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on additional eligible pet shop and pet food & supply store purchases after the first $5,000 in such purchases has been reached in the calendar year. Same exclusions and coding requirements apply as the 5% category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "Variable APR based on creditworthiness; disclosed as 0.2949; variable rates accurate as of 2025-08-31 per terms."
  },
  "benefits": [
    {
      "name": "Experian IdentityWorks membership",
      "description": "Free membership in Experian IdentityWorks when you complete and submit your application online; membership is optional and operated by Experian; subject to change or cancellation by the provider.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_monitoring_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Exclusive discounts at Best Friends locations",
      "description": "Exclusive discounts at the Best Friends Retail Store, Best Friends Roadhouse and Lodging; issuer does not specify discount amounts or detailed terms.",
      "benefit_type": null,
      "new_benefit_type": "merchant_discounts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "1% donation to Best Friends Animal Society",
      "description": "Credit One Bank donates an amount equal to 1% of Net Eligible Purchases to Best Friends Animal Society; donations do not accrue while the account is in default and may be changed by the issuer.",
      "benefit_type": null,
      "new_benefit_type": "charitable_donation_on_purchases",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Fraud Liability",
      "description": "Visa Zero Liability protection; you will not be held responsible for unauthorized charges if reported promptly.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Potential credit line increases",
      "description": "Future credit line increases may be granted based on overall credit performance; minimum starting credit line is $300.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1OB&C1BSpecificationID=bc-best-friends",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/best-friends-visa",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/1m?pc=WB15",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [],
  "bank_name": "Credit One",
  "imageName": "best_friends_credit_card.png"
},
  [CreditCard.DISNEY_VISA_CARD]: {
  "id": CreditCard.DISNEY_VISA_CARD,
  "name": "Disney\u00ae Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/disney_visacard.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DISNEY_REWARDS_DOLLARS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% in Disney Rewards Dollars on all card purchases; no caps noted.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2699,
    "apr_low": 0.1799
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.2699,
    "description": "Variable purchase APR 0.1799-0.2699 based on creditworthiness and Prime Rate. 0% promo APR for 6 months on select Disney vacation packages and Disney Vacation Club real estate purchases; after that 0.1799-0.2699. Balance transfer APR 0.1799-0.2699 (account may not be eligible for balance transfers). Cash advance APR 0.2899. Penalty APR up to 0.2999. At least a 21-day grace period on new purchases."
  },
  "benefits": [
    {
      "name": "Baggage Delay Insurance",
      "description": "Reimburses up to $100 per day for up to 3 days for essential purchases when your baggage is delayed more than 6 hours. NY residents: coverage period 90 days for Purchase Protection; baggage delay terms otherwise as stated. Restrictions and exclusions apply; see Guide to Benefits.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days from date of purchase against damage or theft, up to $500 per item. NY residents: 90 days. Terms, limitations, and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of three years or less (up to a maximum of 4 total years from the purchase date). Terms and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DoorDash DashPass Membership",
      "description": "One-year complimentary DashPass for DoorDash and Caviar when activated with the Disney Visa Card between Feb 1, 2025 and Dec 31, 2027. After the complimentary period, auto-enrolls at then-current monthly rate unless canceled. Includes up to $10 off once per calendar quarter on one qualifying non-restaurant DoorDash order through Dec 31, 2027 while enrolled. Estimated value: roughly $120 for 12 months based on a typical $9.99/mo DashPass rate, plus up to $40 from quarterly discounts if fully used (actual value varies by usage).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "Special Disney Vacation Financing",
      "description": "0% promotional APR for 6 months on select Disney vacation packages and select Disney Vacation Club real estate purchases when charged to the card; after promo period, standard variable APR applies. Packages include Walt Disney Travel Company, Disney Cruise Line, Adventures by Disney, National Geographic Expeditions, AULANI and other eligible Disney sites/agents. Restrictions apply.",
      "benefit_type": null,
      "new_benefit_type": "special_financing_disney_vacation_packages",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Disney Merchandise Discounts",
      "description": "10% off select merchandise purchases at DisneyStore.com, at select locations at Disneyland Resort and Walt Disney World Resort, and 10% off select merchandise onboard Disney Cruise Line (restrictions, brand/location exclusions, and blackout terms apply). Must pay with Disney Visa or Disney Rewards Redemption Card and mention the offer/code as applicable.",
      "benefit_type": null,
      "new_benefit_type": "disney_merchandise_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Disney Dining Discounts",
      "description": "10% off at select dining locations most days at Disneyland Resort and Walt Disney World Resort when you pay with the card; extensive location lists and blackout dates apply; exclusions for alcohol, gratuity, certain dates, and special events.",
      "benefit_type": null,
      "new_benefit_type": "disney_dining_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Guided Tours Discount",
      "description": "15% off the non-discounted price of select guided tours at Disneyland Resort and Walt Disney World Resort when purchased with the card; capacity limits, exclusions, and blackout dates apply.",
      "benefit_type": null,
      "new_benefit_type": "disney_guided_tours_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Private Character Photo Opportunities with Complimentary Downloads",
      "description": "Access to special Disney Visa Cardmember photo locations (Disney/Star Wars at both resorts, plus Super Heroes at Disneyland Resort). Includes complimentary downloads of photos taken at the Cardmember Photo Opportunity. Park admission and reservations may be required; one session per account per day; terms and availability vary.",
      "benefit_type": null,
      "new_benefit_type": "disney_cardmember_photo_opportunities",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Refer-A-Friend Earnings",
      "description": "Earn 100 Disney Rewards Dollars for each friend (up to 5 per year) who is approved for a Disney Visa Card via your referral, up to 500 Rewards Dollars per calendar year. Terms apply; availability may vary.",
      "benefit_type": null,
      "new_benefit_type": "refer_a_friend_bonus",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Receive a $100 Disney Gift Card eGift upon approval, plus earn a $50 statement credit after spending $500 in purchases within 3 months.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 150.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HQFZ&action=guest#/origination/cardDetails/index/index;cellCode=626980;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/rewards-credit-cards/disney/rewards?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC61208.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Terms & Conditions",
      "url": "https://www.chase.com/disneyrewardsterms"
    }
  ],
  "bank_name": "Chase",
  "imageName": "disney_visa_card.png"
},
  [CreditCard.PAYPAL_CREDIT]: {
  "id": CreditCard.PAYPAL_CREDIT,
  "name": "PayPal Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.paypalobjects.com/marketing/web23/us/en/ppe/paypal-credit/hero_size_mobile_up_v1.jpg?quality=75&width=300",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3039,
    "apr_low": 0.3039
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3039,
    "high": 0.3039,
    "description": "For new accounts: Purchase and Cash APR 0.3039 (variable); Penalty APR 0.3499 (variable); accurate as of 2025-03-01 and varies with the Prime Rate. Minimum interest charge $2.00. Special financing: No interest if paid in full within 6 months on purchases of $149+; otherwise interest is charged from the purchase date at the Purchase APR. Minimum monthly payments required. Late fee up to $41."
  },
  "benefits": [
    {
      "name": "6 months special financing on $149+ via PayPal checkout",
      "description": "No Interest if paid in full in 6 months on purchases of $149+ when you check out with PayPal using the PayPal Credit Card or PayPal Credit digital line. Interest will be charged from the purchase date at your Purchase APR (30.39% variable as of 3/1/2025) if not paid in full within 6 months; minimum monthly payments required. Estimated value: avoids roughly ~$13 in interest on a $149 purchase or ~$44 on a $500 purchase over 6 months if you would otherwise revolve at ~30.39% APR (assumes 6 equal payments).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_6_months",
      "spend_requirement": 149,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Limited-time 6 months special financing on qualifying travel purchases",
      "description": "For a limited time, No Interest if paid in full in 6 months on qualifying travel purchases (e.g., hotels, rental cars, flights) posted to your account by January 31, 2026. Interest accrues from the purchase date if not paid in full within 6 months; minimum monthly payments required. Estimated value: avoiding ~30.39% APR over 6 months on $1,000 saves about ~$88 in interest if paid in 6 equal payments (scaled from amortized interest at that APR).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_travel_6_months",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "PayPal Purchase Protection",
      "description": "Coverage for eligible purchases you don\u2019t receive or items that are significantly not as described when using PayPal; terms and limitations apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Access to Mastercard ID Theft Protection services (see Mastercard Guide to Benefits for details). Comparable standalone monitoring services often cost a monthly fee; actual value depends on usage and needs.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard Travel Concierge",
      "description": "Access to Mastercard travel concierge services for trip planning and reservations (see Guide to Benefits for details).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.paypal.com/us/digital-wallet/ways-to-pay/credit-services/paypal-credit?intcmp=NoOff_PayPalCredit_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.paypal.com/us/digital-wallet/ways-to-pay/credit-services/paypal-credit?intcmp=NoOff_PayPalCredit_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": "https://www.paypal.com/credit-application/paypal-credit/da/us/landing?intcmp=NoOff_PayPal%20Credit_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_button_text": "Terms and Rates",
  "additional_links": [
    {
      "name": "Learn more (promo details)",
      "url": "https://www.paypal.com/us/webapps/mpp/paypal-credit"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "paypal_credit.jpg?quality=75&width=300"
},
  [CreditCard.CABELAS_CLUB_CARD]: {
  "id": CreditCard.CABELAS_CLUB_CARD,
  "name": "Cabela\u2019s CLUB Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/cabelas_card_art_2023.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "sportingGoods.bassProAndCabelas",
      "earnRate": 2.0,
      "description": "Earn 2% in CLUB Points at Bass Pro Shops and Cabela\u2019s with Classic status.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "require_club_tier_classic"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "sportingGoods.bassProAndCabelas",
      "earnRate": 3.0,
      "description": "Earn 3% in CLUB Points at Bass Pro Shops and Cabela\u2019s with Silver status.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "require_club_tier_silver"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "sportingGoods.bassProAndCabelas",
      "earnRate": 5.0,
      "description": "Earn 5% in CLUB Points at Bass Pro Shops and Cabela\u2019s with Black status.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "require_club_tier_black"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Exclusive member perks and pricing",
      "description": "Access to in-store events, extra point offerings and discounts, exclusive CLUB Member pricing, and giveaways at Bass Pro Shops and Cabela\u2019s.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_member_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Access to outdoor experiences",
      "description": "CLUB Members get exclusive access to world-class hunting and fishing experiences.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_experiences_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Price match beat by 5% for CLUB Members",
      "description": "At Bass Pro Shops and Cabela\u2019s, qualifying price matches for CLUB Members are beaten by 5% (see cabelas.com/club for details). Value varies by purchase and competitor price.",
      "benefit_type": null,
      "new_benefit_type": "price_match_plus_5_percent",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Special 9.99% APR on Bass Pro and Cabela\u2019s purchases",
      "description": "Purchases made with Bass Pro Shops and Cabela\u2019s (in-store, online, by phone, and Signature Events) qualify for a 9.99% APR. Financing value depends on purchase size and time carried.",
      "benefit_type": null,
      "new_benefit_type": "special_financing_apr",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "CLUB Points don\u2019t expire (open accounts)",
      "description": "CLUB Points never expire for open accounts, there\u2019s no cap on earning, and they are redeemable for purchases at Bass Pro Shops and Cabela\u2019s. Estimated redemption value ~1 cent per point equivalent based on issuer stating bonus as dollar-denominated points.",
      "benefit_type": null,
      "new_benefit_type": "points_never_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Earn up to $50 in CLUB Points: $20 in CLUB Points upon approval; $10 in CLUB Points after 2 Bass Pro Shops or Cabela\u2019s purchases within 30 days; $20 in CLUB Points after 5 purchases everywhere else Mastercard is accepted within 30 days. Issued as CLUB Points redeemable at Bass Pro Shops and Cabela\u2019s. Estimated total value \u2248 $50 toward Bass Pro/Cabela\u2019s purchases (points are presented by issuer in dollar value).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "club_points",
          "amount": 20.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 1,
      "description": "Earn up to $50 in CLUB Points: $20 in CLUB Points upon approval; $10 in CLUB Points after 2 Bass Pro Shops or Cabela\u2019s purchases within 30 days; $20 in CLUB Points after 5 purchases everywhere else Mastercard is accepted within 30 days. Issued as CLUB Points redeemable at Bass Pro Shops and Cabela\u2019s. Estimated total value \u2248 $50 toward Bass Pro/Cabela\u2019s purchases (points are presented by issuer in dollar value).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "club_points",
          "amount": 10.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 1,
      "description": "Earn up to $50 in CLUB Points: $20 in CLUB Points upon approval; $10 in CLUB Points after 2 Bass Pro Shops or Cabela\u2019s purchases within 30 days; $20 in CLUB Points after 5 purchases everywhere else Mastercard is accepted within 30 days. Issued as CLUB Points redeemable at Bass Pro Shops and Cabela\u2019s. Estimated total value \u2248 $50 toward Bass Pro/Cabela\u2019s purchases (points are presented by issuer in dollar value).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "club_points",
          "amount": 20.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/cabelas/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/cabelas/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "cabelas_club_card.png"
},
  [CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED]: {
  "id": CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED,
  "name": "Bank of America\u00ae Customized Cash Rewards Secured Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8ckn_cshcm_v_250x158.png",
  "recommendedMinCreditScore": "no_credit_history",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "3% cash back in one selected choice category after the first 12 months (or after the first-year promo ends). Shares a combined $2,500 quarterly cap with the 2% grocery/wholesale club category; after the cap, purchases earn 1%. An additional 3% boost applies during the first 12 months (modeled via signup bonus earn rate fields) before reverting to 3%.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": 3.0,
      "signupBonusEarnRateIncreaseDurationMonths": 12,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          {
            "categories": [
              "gas"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas and EV charging stations (EV charging included per card marketing)."
          },
          {
            "categories": [
              "onlineShopping"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": true,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Online Shopping: purchases must be made via a website or app; phone/in\u2011person payments do not qualify. Some non\u2011retail services may not qualify."
          },
          "dining",
          "travel",
          "drugstore",
          {
            "categories": [
              "homeImprovement",
              "homeFurnishings"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Home improvement stores and home furnishings stores."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.MONTHLY,
        "categoriesDescription": "Choice category (one at a time; changeable once per calendar month): Gas and EV charging stations; Online Shopping (online-only); Dining; Travel; Drug Stores/Pharmacies; Home Improvement & Furnishings.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% cash back at grocery stores and wholesale clubs. Excludes superstores and smaller stores (e.g., drug stores) that sell groceries and other products. Shares a combined $2,500 quarterly cap with the 3%/6% choice category; after the cap, purchases earn 1%.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "wholesaleClub",
      "earnRate": 2.0,
      "description": "2% cash back at grocery stores and wholesale clubs. Excludes superstores and smaller stores (e.g., drug stores) that sell groceries and other products. Shares a combined $2,500 quarterly cap with the 3%/6% choice category; after the cap, purchases earn 1%.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Unlimited 1% cash back on all other purchases, and on purchases in bonus categories after reaching the quarterly cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.2824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2824,
    "high": 0.2824,
    "description": "Variable APRs tied to the Prime Rate. Purchase APR: 28.24% variable. Balance transfer APR: 28.24% variable. Cash advance APR: 29.24% (Direct Deposit, Check, and Bank Cash Advances). Penalty APR: up to 29.99% may apply indefinitely after a late payment. At least a 25-day grace period on purchases if you pay your entire balance or Interest Saving Balance by the due date. Interest on balance transfers and cash advances accrues from the transaction date. Balance transfer fee: 4% of each transaction. Foreign transaction fee: 3% of each transaction made in a foreign currency. Late payment fee up to $40. Monthly Custom Pay Plan fee (fixed finance charge): 1.72% of the amount assigned to a plan."
  },
  "benefits": [
    {
      "name": "Security deposit review and potential return",
      "description": "Bank of America will periodically review your account; based on your overall credit history and relationship, you may qualify to have your security deposit returned (not all customers will qualify). If you close the account and pay the balance in full, your deposit is returned within up to two billing cycles plus ten days.",
      "benefit_type": null,
      "new_benefit_type": "security_deposit_return",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076370&productoffercode=WY&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/cash-back-secured-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076370&productoffercode=WY&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Customized Cash Rewards secured credit card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_customized_cash_rewards_secured.png"
},
  [CreditCard.SYNCHRONY_PREMIER_WORLD_MASTERCARD]: {
  "id": CreditCard.SYNCHRONY_PREMIER_WORLD_MASTERCARD,
  "name": "Synchrony Premier World Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://apply.syf.com/cs/groups/public/documents/et_clientoffer/e061555.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "1% cash back on eligible net purchases (purchases minus returns/adjustments). Excludes balance transfers, cash advances, finance charges, and fees. Cash back is automatically applied as a statement credit within two billing periods after the purchase is made. Account must be open and in good standing when earned and when the credit is applied; accrued rewards may be delayed or forfeited if past due, suspended, closed, or for misuse. No stated spend cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.3399,
    "description": "New Accounts as of Jan 1, 2025: Variable Purchase APR 18.24%, 27.24%, or 33.99%. Variable Balance Transfer APR 18.24%, 27.24%, or 33.99% with a 4% fee ($10 min). Variable Cash APR 21.24%, 30.24%, or 36.99% with a 5% fee ($10 min). Variable Penalty APR 28.24%, 37.24%, or 39.99%. Minimum Interest Charge $2. Foreign Transaction Fee 3%."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://apply.syf.com/eapply/eapply.action?clientCode=SYFMCPREM&intcmp=NoOff_SynchronyPremierWorldMastercard%C2%AE_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://www.synchrony.com/sites/syc/financing/synchrony-mastercards",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Rewards Program Terms",
      "url": "https://www.synchronycredit.com/essimages/cs/groups/ess_webasset/dualcard/@tru/en/promohtmls/ess048626.html"
    },
    {
      "name": "Mastercard Guide to Benefits",
      "url": "https://mastercard.com/worldcredit-GTB"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_premier_world_mastercard.png"
},
  [CreditCard.ROOMS_TO_GO_CREDIT_CARD]: {
  "id": CreditCard.ROOMS_TO_GO_CREDIT_CARD,
  "name": "Rooms To Go Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_clientoffer/e094688.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.3499,
    "apr_low": 0.3499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3499,
    "high": 0.3499,
    "description": "New Accounts as of 7/31/2025: Purchase APR is 34.99%. Penalty APR is 39.99%. Minimum Interest Charge is $2. Regular account terms apply to non-promo purchases. Promotional financing offers of 18, 36, or 50 months with no interest on the amount financed require equal monthly payments."
  },
  "benefits": [
    {
      "name": "50-Month Interest-Free Financing (Limited-Time)",
      "description": "On purchases of $875+ made with your Rooms To Go Credit Card from 9/16/2025\u20139/29/2025. Equal monthly payments required for 50 months; no interest charged on the amount financed during the promo. Rooms To Go requires a down payment equal to sales tax and delivery (card cannot be used for any required down payment). Subject to credit approval; regular account terms apply to non-promo purchases (new accounts APR 34.99%, Penalty APR 39.99%, Min Interest $2). Offer availability noted for AL, FL, GA, TX, LA, MS, NC, VA, SC, TN. Estimated value: avoiding interest on a $1,000 purchase paid over 50 months at 34.99% APR with equal payments could save roughly ~$900 in interest (amortized estimate).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_interest_free",
      "spend_requirement": 875,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "36-Month Interest-Free Financing (Limited-Time)",
      "description": "On purchases made with your Rooms To Go Credit Card now through 9/29/2025. Equal monthly payments required for 36 months; no interest charged on the amount financed during the promo. Card cannot be used for any required down payment. Subject to credit approval; regular account terms apply to non-promo purchases (new accounts APR 34.99%, Penalty APR 39.99%, Min Interest $2). Estimated value: avoiding interest on a $1,000 purchase paid over 36 months at 34.99% APR with equal payments could save roughly ~$630 in interest (amortized estimate).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_interest_free",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "18-Month Interest-Free Financing (Limited-Time)",
      "description": "On purchases made with your Rooms To Go Credit Card now through 9/29/2025. Equal monthly payments required for 18 months; no interest charged on the amount financed during the promo. Rooms To Go states no down payment required for this offer. Subject to credit approval; regular account terms apply to non-promo purchases (new accounts APR 34.99%, Penalty APR 39.99%, Min Interest $2). Estimated value: avoiding interest on a $1,000 purchase paid over 18 months at 34.99% APR with equal payments could save roughly ~$300 in interest (amortized estimate).",
      "benefit_type": null,
      "new_benefit_type": "special_financing_interest_free",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Exclusive Cardholder Offers",
      "description": "Cardholders may receive limited-time, private/exclusive promotional offers from Rooms To Go. Value varies by promotion and is not guaranteed.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_cardholder_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=72D604A6DC14650CBC0382E5D3916FEFAC9588579FD11A00&client=Rooms%20To%20Go&_gl=1*wa2kmw*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMTU4LjAuMC4w&intcmp=NoOff_RoomsToGoCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=72D604A6DC14650CBC0382E5D3916FEFAC9588579FD11A00&client=Rooms%20To%20Go&_gl=1*wa2kmw*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMTU4LjAuMC4w&intcmp=NoOff_RoomsToGoCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=72D604A6DC14650CBC0382E5D3916FEFAC9588579FD11A00&preQual=Y&_gl=1*wp6pu6*_ga*MTI4MDg0NTIwMi4xNjczMDE1ODM5*_ga_SHD5X90J3V*MTY5MjYzOTg1OS4xMTMuMS4xNjkyNjQwMTc3LjAuMC4w&intcmp=NoOff_RoomsToGoCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    },
    {
      "name": "Financing details",
      "url": "https://roomstogo.com/financing"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "rooms_to_go_credit_card.jpg"
},
  [CreditCard.DELTA_SKYMILES_PLATINUM_BUSINESS_CARD]: {
  "id": CreditCard.DELTA_SKYMILES_PLATINUM_BUSINESS_CARD,
  "name": "Delta SkyMiles\u00ae Platinum Business American Express Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/platinum-delta-skymiles-business.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.DELTA,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 3.0,
      "description": "3x miles on purchases made directly with hotels worldwide. Pay the hotel directly (e.g., at check\u2011in/check\u2011out). No bonus if you prepay through a third party or as part of a vacation package. Incidental charges may qualify when charged to your room and paid at checkout; establishments inside hotels (e.g., timeshares, spas, restaurants, event spaces) may not qualify unless charged to room.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.delta",
      "earnRate": 3.0,
      "description": "3x miles on eligible purchases charged directly with Delta (Delta as merchant of record), including purchases via delta.com, Fly Delta app, phone, or ticket counters for flights, upgrades, seat selection, Delta Sky Club membership, and in\u2011flight food/beverage on Delta\u2011operated flights. Excludes in\u2011flight purchases where Delta is not the merchant of record (e.g., Wi\u2011Fi) and charitable contributions, Delta Gift Cards, deltashop.com, and Delta Flight Museum. Includes Delta Vacations packages and new Delta Stays prepaid hotel or vacation rental bookings on delta.com/stays.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 1.5,
      "description": "1.5x miles on eligible transit purchases (train, taxi, rideshare, ferry, tolls, parking, bus, subway). Airfare, car rental, and cruises are not considered transit. Combined cap of $100,000 per calendar year across transit, eligible U.S. shipping, and single purchases of $5,000+.",
      "spendCap": 100000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "shipping",
      "earnRate": 1.5,
      "description": "1.5x miles on eligible U.S. shipping purchases made at courier, postal, and freight shippers located in the U.S. Excludes shipping costs added to retail purchases and moving services. Combined cap of $100,000 per calendar year across transit, eligible U.S. shipping, and single purchases of $5,000+.",
      "spendCap": 100000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x mile on all other eligible purchases that do not fall into a bonus category or after caps are reached. If a purchase qualifies for a higher accelerator, only the highest rate applies.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 350.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 350.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Variable APR for purchases 19.99%\u201328.99% (Prime Rate + 12.74% to +21.74%), based on creditworthiness; variable Penalty APR 29.99% may apply after certain delinquencies. Variable APRs will not exceed 29.99%."
  },
  "benefits": [
    {
      "name": "Annual Companion Certificate",
      "description": "Each year after account renewal, receive a Companion Certificate valid for one round-trip Delta Main Cabin fare (domestic, Caribbean, or Central America) on select fare classes; taxes/fees $22\u2013$250 apply; Basic Economy not eligible. Estimated value varies widely by route and dates (often $200\u2013$500+).",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "MQD Boost",
      "description": "Earn 1 Medallion Qualification Dollar (MQD) for each $20 in eligible purchases to help qualify for Delta Medallion Status for the next year.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "MQD Headstart",
      "description": "Receive 2,500 MQDs deposited each Medallion Qualification Year to jump-start Medallion Status qualification.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "TakeOff 15 Award Discount",
      "description": "Get at least 15% off the mileage portion when booking Award Travel on Delta and Delta Connection flights at delta.com or in the Fly Delta app (taxes/fees not discounted; not valid on partners).",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Upgrade List (non\u2011Medallion)",
      "description": "Card Members who are not Medallion Members are added to the Complimentary Upgrade list (after Medallion and Reserve Card Members) on eligible tickets and routes; subject to availability; Basic Economy not eligible.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "First Checked Bag Free",
      "description": "First checked bag free on Delta flights for the Basic Card Member and up to 8 companions on the same reservation; savings up to $70 per person on a round trip.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zone 5 Priority Boarding",
      "description": "Priority boarding (Zone 5) for the Basic Card Member and up to 8 companions on the same reservation on Delta/Delta Connection flights.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry or TSA PreCheck Application Fee Credit",
      "description": "Statement credit for Global Entry ($120 every 4 years) or TSA PreCheck (up to $85 every 4.5 years) when paid with the Card; one credit per account per interval.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$120 Resy Dining Credit",
      "description": "Up to $10 per month in statement credits (up to $120/year) on eligible U.S. Resy purchases; enrollment required. Estimate: up to $120/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$120 Rideshare Credit",
      "description": "Up to $10 back per month (up to $120/year) in statement credits on eligible U.S. rideshare purchases with select providers; enrollment required. Estimate: up to $120/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Delta Stays Credit",
      "description": "Up to $200 per calendar year in statement credits for prepaid hotels or vacation rentals booked via Delta Stays at delta.com/stays. Estimate: up to $200/year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "20% Back on In\u2011Flight Food & Beverage Purchases",
      "description": "Get 20% back as a statement credit on eligible pre-purchased meals and in-flight food and beverage purchases on Delta-operated flights when charged to the Card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star Status",
      "description": "Complimentary Hertz Five Star status after enrollment and linking accounts; enhanced car rental benefits subject to availability.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Insurance",
      "description": "If a round trip is paid fully with the Card and a covered reason delays your trip >12 hours, reimbursement up to $300 per trip; max 2 claims per 12 months; terms apply.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage for lost, damaged, or stolen baggage when the entire fare is purchased with the Card (up to $1,250 carry-on, $500 checked, excess of carrier coverage; NY aggregate limits apply).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Secondary coverage for damage or theft of a rental vehicle when you pay with the Card and decline the rental company\u2019s CDW; exclusions and territory limits apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "Cell phone protection coverage when eligibility requirements are met; coverage limits and terms apply.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extended warranty protection on eligible purchases; terms, conditions, and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Purchase protection on eligible items; terms, conditions, and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No American Express foreign transaction fees on purchases made outside the U.S.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Expanded Buying Power",
      "description": "Ability to spend above the credit limit based on factors like payment history and usage; amount is flexible, not unlimited.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Pay with Miles",
      "description": "Use SkyMiles in 5,000\u2011mile increments to reduce the cost of Delta tickets at roughly $50 per 5,000 miles; residual and eligibility rules apply.",
      "benefit_type": null,
      "new_benefit_type": "pay_with_miles",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$120 Resy Credit",
      "description": "Up to $10 in statement credits per month (up to $120/year) on eligible U.S. Resy purchases; enrollment required.",
      "credit_category": null,
      "new_credit_category": "dining_resy",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$120 Rideshare Credit",
      "description": "Up to $10 back per month (up to $120/year) on eligible U.S. rideshare purchases with select providers; enrollment required.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$200 Delta Stays Credit",
      "description": "Up to $200 in statement credits per calendar year for prepaid hotels or vacation rentals booked through Delta Stays on delta.com.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry/TSA PreCheck Fee Credit",
      "description": "Statement credit for Global Entry ($120 every 4 years) or TSA PreCheck (up to $85 every 4.5 years) when paid with the Card; one credit per account per interval.",
      "credit_category": null,
      "new_credit_category": "trusted_traveler_programs",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "20% Back on Delta In\u2011Flight Food & Beverage",
      "description": "20% statement credit on eligible in\u2011flight food and beverage purchases on Delta-operated flights when charged to the Card.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 8000.0,
      "spendRequirementMonths": 6,
      "description": "Limited Time Offer: Earn 100,000 Bonus Miles after $8,000 in purchases on the new Card within the first 6 months of Card Membership (offer ends 10/29/2025). Miles post 8\u201312 weeks after meeting the requirement; certain transactions do not count (e.g., cash equivalents, gift cards). Account must be open and not past due at fulfillment. Estimated value about $1,100\u2013$1,400 assuming ~1.1\u20131.4 cents per SkyMile; actual value depends on redemption.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-platinum/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaPlatinum",
  "learn_more_link": "https://www.americanexpress.com/en-us/business/credit-cards/delta-skymiles-platinum/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-DeltaPlatinum",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-platinum/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/delta-skymiles-platinum/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "delta_skymiles_platinum_business_card.png"
},
  [CreditCard.US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD]: {
  "id": CreditCard.US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD,
  "name": "U.S. Bank Altitude\u00ae Go Visa Signature\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/us_bank_altitude_go_visa_signature_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.US_BANK_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4x (1x base + 3x bonus) on restaurant, fast\u2011food restaurant, and bar purchases on the first $2,000 in combined dining purchases each quarter; purchases above that cap during the quarter earn 1x. Eligibility is based on the merchant\u2019s category code assigned by Visa; if the merchant is not coded as restaurant/fast\u2011food/bar, it will not earn 4x.",
      "spendCap": 2000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x (1x base + 1x bonus) at grocery stores and supermarkets. Purchases at wholesale clubs and discount stores/supercenters (e.g., Walmart, Target) earn only 1x. Merchant category coding determines eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x (1x base + 1x bonus) at gas stations and EV charging stations. Purchases at wholesale clubs, discount stores/supercenters, and grocery stores/supermarkets earn only 1x. Merchant category coding determines eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "2x (1x base + 1x bonus) on qualifying streaming subscription services. Official list includes: Amazon Music Unlimited, Amazon Prime Video, AMC+, Apple Music, Apple TV+, Audible, DirecTV Stream, Discovery+, Disney+, ESPN+, Fandango at Home, FanDuel Sports Network, Fubo TV, Max, Hulu, iHeart, LiveOne, Luminary, MLB TV, NBA League Pass, Netflix, Pandora, Paramount+, Peacock, Showtime, SiriusXM, Sling TV, Spotify, Starz, Stitcher, Tidal, YouTube Music, YouTube Premium, YouTube TV. Merchant category coding determines eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other eligible Net Purchases. Excludes transactions such as balance transfers, cash advances (including ATM withdrawals and cash equivalents), fees/interest, certain prepaid funding, U.S. Mint purchases, and other cash\u2011like items. Account must be open and in good standing to earn; points typically post within 1\u20132 statements (up to 60 days).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2799,
    "apr_low": 0.1799
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.2799,
    "description": "0% intro APR on purchases for the first 15 billing cycles; after that variable 17.99%\u201327.99% based on creditworthiness (varies with Prime Rate). Cash advance APR 30.99% variable. Penalty APR: Not applicable."
  },
  "benefits": [
    {
      "name": "$15 annual streaming services statement credit",
      "description": "Automatic $15 statement credit per 12\u2011month period after 11 consecutive calendar months of eligible streaming service purchases (e.g., Netflix, Hulu, Apple Music). Credit posts within 2 billing cycles if the account is in good standing. Estimated value: $15/year if you maintain an eligible subscription.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer points to other Altitude Go or Altitude Connect accounts",
      "description": "You can transfer points to other qualifying U.S. Bank Altitude Go or Altitude Connect credit card accounts in good standing. Limit 20,000 points you can transfer out per calendar year and 20,000 points you can accept per calendar year. All transfers are final.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer points to participating travel loyalty programs",
      "description": "You may transfer points to participating airline/hotel loyalty programs via the Rewards Center. Partner list and transfer value are shown at the time of transfer; most transfers process by the next business day (up to 72 hours). All transfers are final.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Real\u2011Time Rewards (instant redemption by text)",
      "description": "Opt in to redeem points for recent purchases via text; a statement credit is applied typically within 3 business days. Travel purchases must be made directly with airlines, hotels, car rentals, taxis/limos, trains, or cruise lines; minimum $150 for lodging and car rentals. U.S. merchants only; you must have enough points to cover the full purchase amount. All redemptions are final.",
      "benefit_type": null,
      "new_benefit_type": "real_time_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$15 streaming services credit",
      "description": "Automatic $15 statement credit per 12\u2011month period after 11 consecutive months of eligible streaming service purchases; posts within 2 billing cycles if the account is in good standing.",
      "credit_category": "streaming",
      "new_credit_category": null,
      "value": 15.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [],
  "apply_link": "https://onboarding.usbank.com/consumer/cards/HQWRM3D57Q/18569/33720/start",
  "learn_more_link": "https://www.usbank.com/content/usbank/us/en/credit-cards/altitude-go-visa-signature-credit-card",
  "terms_and_conditions_link": "https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=18569&offerId=HQWRM3D57Q&sourceCode=88268",
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Program Rules",
      "url": "https://rewards.usbank.com/benefits/card/AltitudeGoBenefits/program-rules"
    }
  ],
  "bank_name": "US Bank",
  "imageName": "us_bank_altitude_go_visa_signature_card.png"
},
  [CreditCard.CITI_REWARDS_CREDIT_CARD]: {
  "id": CreditCard.CITI_REWARDS_CREDIT_CARD,
  "name": "Citi Rewards+\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-rewards-plus/citi-rewards-plus_171x108.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5X ThankYou Points on hotels, car rentals, and attractions booked through Citi Travel. No stated spend cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5X ThankYou Points on hotels, car rentals, and attractions booked through Citi Travel. No stated spend cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2X ThankYou Points at supermarkets, up to $6,000 per year; then 1X.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2X ThankYou Points at gas stations, up to $6,000 per year; then 1X.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X ThankYou Points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "10% Points Back",
      "description": "Get 10% of your ThankYou Points back when you redeem, up to the first 100,000 points redeemed per year. This effectively makes each point worth more.",
      "benefit_type": null,
      "new_benefit_type": "points_rebate",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment",
      "description": "Get special access to purchase tickets to thousands of events, including presale tickets and exclusive experiences for concerts, sporting events, dining experiences and more.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1500.0,
      "spendRequirementMonths": 3,
      "description": "Earn 20,000 bonus ThankYou Points after spending $1,500 on purchases within the first 3 months of account opening. Redeemable for $200 in gift cards or travel rewards at thankyou.com.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://online.citi.com/US/ag/cards/application?app=UNSOL&HKOP=2444caf3d314becef62109c891379aeb5f596a7c074a964823559f1584149500&ID=3000&ProspectID=PzkDVV5AoeYafXeGs2WUDarrsUfbQFht&intc=citihpmenu~creditcards~vac&pid=408&category=view-all-credit-cards&afc=161",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-rewards-plus-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161",
  "terms_and_conditions_link": "https://online.citi.com/US/ag/cards/displayterms?app=UNSOL&HKOP=2444caf3d314becef62109c891379aeb5f596a7c074a964823559f1584149500",
  "terms_and_conditions_button_text": "Important Pricing & Information+",
  "additional_links": [],
  "bank_name": "Citi",
  "imageName": "citi_rewards_credit_card.png"
},
  [CreditCard.XBOX_MASTERCARD]: {
  "id": CreditCard.XBOX_MASTERCARD,
  "name": "Xbox Mastercard",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/XBO_card_Xbox_MC_Angle_359x246.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GAME_PASS_ULTIMATE,
  "rewards_earn_rates": [
    {
      "category": "digitalMicrosoftStore",
      "earnRate": 5.0,
      "description": "5X points at the digital Microsoft Store on eligible purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "3X points on eligible streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 3.0,
      "description": "3X points on eligible dining delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X point per dollar on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2999,
    "description": "Variable APR based on creditworthiness; varies with the Prime Rate. Purchases: 0.1999\u20130.2999. Balance transfers: 0.1999\u20130.2999. Cash advances: 0.2999. Minimum interest charge: $0.50. Balance transfer fee: 5% (min $10). Cash advance fee: 5% (min $10). Foreign transaction fee: 3%."
  },
  "benefits": [
    {
      "name": "Custom Xbox card design with gamertag",
      "description": "Choose from five card designs and personalize with your gamertag (primary cardmember only; gamertag must comply with Xbox standards).",
      "benefit_type": null,
      "new_benefit_type": "custom_card_design",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": 6,
      "description": "After your first purchase within 180 days of account opening: $50 value bonus (issued as cash back or points per issuer terms), 3 months of Xbox Game Pass Ultimate for new members, and 3 months of Spotify Premium Individual for eligible new Spotify users. Plus, spend $7,000 in the first 12 months to receive two 3\u2011month Game Pass Ultimate gift codes for friends/family who are new members. Estimated values: $50 bonus = $50; Game Pass 3 months \u2248 $50.97 (assuming $16.99/mo); Spotify 3 months \u2248 $35.97 (at $11.99/mo); two 3\u2011month Game Pass codes \u2248 $101.94. Total potential value \u2248 $238.88 for eligible users. Terms apply; Game Pass offers valid only for new members; Spotify offer subject to stated deadlines.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 50.0,
          "value_unit": "dollars"
        },
        {
          "reward_type": null,
          "new_reward_type": "xbox_game_pass_ultimate_trial",
          "amount": 3.0,
          "value_unit": "months"
        },
        {
          "reward_type": null,
          "new_reward_type": "spotify_premium_trial",
          "amount": 3.0,
          "value_unit": "months"
        }
      ]
    },
    {
      "spendRequirement": 7000.0,
      "spendRequirementMonths": 12,
      "description": "After your first purchase within 180 days of account opening: $50 value bonus (issued as cash back or points per issuer terms), 3 months of Xbox Game Pass Ultimate for new members, and 3 months of Spotify Premium Individual for eligible new Spotify users. Plus, spend $7,000 in the first 12 months to receive two 3\u2011month Game Pass Ultimate gift codes for friends/family who are new members. Estimated values: $50 bonus = $50; Game Pass 3 months \u2248 $50.97 (assuming $16.99/mo); Spotify 3 months \u2248 $35.97 (at $11.99/mo); two 3\u2011month Game Pass codes \u2248 $101.94. Total potential value \u2248 $238.88 for eligible users. Terms apply; Game Pass offers valid only for new members; Spotify offer subject to stated deadlines.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "xbox_game_pass_ultimate_gift_codes",
          "amount": 2.0,
          "value_unit": "3-month Game Pass Ultimate codes (new members only)"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/xbox-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/xbox-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "xbox_mastercard.png"
},
  [CreditCard.HUNTINGTON_VOICE_BUSINESS_MASTERCARD]: {
  "id": CreditCard.HUNTINGTON_VOICE_BUSINESS_MASTERCARD,
  "name": "Huntington Voice Business Mastercard\u00ae",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/huntington_voice_business_mastercard.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 4.0,
      "description": "4% cash back on up to $7,000 spent in one user-selected category each quarter. 10 categories to choose from.",
      "spendCap": 7000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          {
            "categories": [
              "gas"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas stations"
          },
          {
            "categories": [
              "travel",
              "entertainment"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Travel & Entertainment"
          },
          {
            "categories": [
              "dining"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Restaurants"
          },
          {
            "categories": [
              "wholesaleClub"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Discount Stores & Wholesale Clubs including Costco (online only) and Sam's Club"
          },
          {
            "categories": [
              "grocery"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Supermarkets"
          },
          {
            "categories": [
              "billsAndUtilities",
              "officeSupplies"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Utilities & Office Supply Stores"
          },
          {
            "categories": [
              "electronics"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Electronic, Computer & Camera Stores"
          },
          {
            "categories": [
              "departmentStores"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Department, Apparel & Sporting Goods Stores"
          },
          {
            "categories": [
              "homeImprovement"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Home Improvement Stores"
          },
          {
            "categories": [
              "automotive"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Auto Parts & Service Stores"
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "Choose one of 10 categories each quarter for 4% cash back.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": null,
  "learn_more_link": "https://www.huntington.com/SmallBusiness/voice-business-credit-card",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Huntington",
  "imageName": "huntington_voice_business_mastercard.jpg"
},
  [CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS]: {
  "id": CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS,
  "name": "Bank of America\u00ae Unlimited Cash Rewards Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cty_cshsigcm_v_250x157.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earns 1.5% cash back on all Net Purchases per billing cycle. Online-only introductory applications receive an additional 0.5% for the first 12 months (modeled via signup bonus fields) before reverting to the base 1.5%. Excludes balance transfers, cash advances, fees, interest, fraudulent transactions, and certain other charges. No cap; rewards do not expire while the account is open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": 0.5,
      "signupBonusEarnRateIncreaseDurationMonths": 12
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "0% intro APR for 15 billing cycles on purchases and on balance transfers made within 60 days of account opening; after that, variable APR 0.1824\u20130.2824 based on creditworthiness and the Prime Rate. Cash advance APR: 0.2124\u20130.2924 for Direct Deposit/Check Cash Advances; 0.2924 for Bank Cash Advances. Penalty APR up to 0.2999 may apply indefinitely after a late payment."
  },
  "benefits": [
    {
      "name": "Bank of America Preferred Rewards bonus (25%-75% more cash back)",
      "description": "Preferred Rewards members earn an additional 25%-75% cash back multiplier on every purchase (on top of the base earn). Not applied to the extra 0.5% first-year bonus. Eligibility requires meeting Bank of America/Merrill relationship requirements for Preferred Rewards tiers; terms apply.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "$200 online cash rewards bonus after qualifying spend. Conditions: make at least $1,000 in purchases that post within 90 days of account opening; Balance Transfers and Cash Advances do not count; returns/credits reduce qualifying spend; limit 1 bonus per new account; account must be open with active charging privileges to receive; typically posts within 1\u20132 billing cycles. Estimated value: $200 (cash).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "First-year additional earn bonus: earn an extra 0.5% cash back (for a total of 2% on all purchases) on Net Purchases that post within 365 days of account opening. Balance Transfers and Cash Advances do not count. Limit 1 such promotional offer per new account. Preferred Rewards bonus does not apply to the extra 0.5% portion. Estimated value: additional cash back equals 0.5% \u00d7 first-year Net Purchases (e.g., $10,000 spend \u2192 $50 extra; $20,000 \u2192 $100 extra).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": "additional_cash_back_percentage",
          "amount": 0.5,
          "value_unit": "percentage"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076441&productOfferCode=HB&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-credit-card/?campaign=4076441~HB~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076441&productoffercode=HB&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Unlimited Cash Rewards credit card",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-credit-card//?campaign=4076441~HB~en_US#headlineCcalcModule"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_unlimited_cash_rewards.png"
},
  [CreditCard.CHASE_FREEDOM_FLEX_CREDIT_CARD]: {
  "id": CreditCard.CHASE_FREEDOM_FLEX_CREDIT_CARD,
  "name": "Chase Freedom Flex\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/freedom_flex_card_alt.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CHASE_ULTIMATE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "quarterly_categories",
      "earnRate": 5.0,
      "description": "Quarterly rotating 5% bonus points categories (non-dining). Activation required each quarter; combined spend cap $1,500 per quarter across all active categories. Specific merchants/categories and timing as listed; December-only PayPal bonus in Q4 2025.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "quarterly_spend_milestone_bonus"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "old_navy"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": "Q4",
            "start_date": "2025-10-01",
            "end_date": "2025-12-31",
            "category_description": "Q4 2025: Old Navy purchases qualify for 5% as a rotating quarterly category."
          },
          {
            "categories": [
              "departmentStores"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": "Q4",
            "start_date": "2025-10-01",
            "end_date": "2025-12-31",
            "category_description": "Q4 2025: Department stores qualify for 5% as a rotating quarterly category."
          },
          {
            "categories": [
              "travel"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": true,
            "active_quarter": "Q4",
            "start_date": "2025-10-01",
            "end_date": "2025-12-31",
            "category_description": "Q4 2025: Travel purchased through Chase Travel qualifies for 5% within the quarterly bonus cap; booking must be through Chase Travel."
          },
          {
            "categories": [
              "onlineShopping.paypal"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": true,
            "requires_travel_portal": false,
            "active_quarter": "Q4",
            "start_date": "2025-12-01",
            "end_date": "2025-12-31",
            "category_description": "Q4 2025 December Birthday Bonus: PayPal purchases qualify for 5% during December only."
          },
          {
            "categories": [
              "travel.cruise.norwegian"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": "Q1",
            "start_date": "2026-01-01",
            "end_date": "2026-03-31",
            "category_description": "Q1 2026: Norwegian Cruise Line purchases qualify for 5% as a rotating quarterly category."
          }
        ],
        "categoryRotationFrequency": Frequency.QUARTERLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Rotating 5% categories each quarter on up to $1,500 in combined purchases per quarter (activation required). Examples vary by quarter and may include specific merchants and broad categories. For Q4 2025: Old Navy, Chase Travel (booked through Chase Travel), Department Stores, and PayPal (December only). For Q1 2026: Norwegian Cruise Line and the American Heart Association (Dining is modeled separately at 7% and shares the same quarterly cap).",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "quarterly_categories",
      "earnRate": 7.0,
      "description": "Quarterly dining bonus: 7% total points (4% quarterly bonus + base 3%) in Q1 2026; shares the $1,500 quarterly cap with other rotating categories.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "quarterly_spend_milestone_bonus"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "dining"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": "Q1",
            "start_date": "2026-01-01",
            "end_date": "2026-03-31",
            "category_description": "Q1 2026: Dining qualifies for 7% total (4% quarterly bonus + base 3%)."
          }
        ],
        "categoryRotationFrequency": Frequency.QUARTERLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Q1 2026 only: Dining earns 7% total (4% quarterly bonus + base 3%). Shares the $1,500 quarterly cap with other rotating categories.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "Ongoing earn of 5% bonus points on travel purchased through Chase Travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Dining at restaurants, including takeout and eligible delivery services, earns 3% points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 3.0,
      "description": "Dining at restaurants, including takeout and eligible delivery services, earns 3% points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "drugstore",
      "earnRate": 3.0,
      "description": "Drugstore purchases earn 3% points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare.lyft",
      "earnRate": 2.0,
      "description": "Lyft purchases earn 2% total points through 9/30/2027.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": "2027-09-30",
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_7_days"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other purchases earn 1% points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1874
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1874,
    "high": 0.2824,
    "description": "Purchases: 0% intro APR for 15 months from account opening, then variable 0.1874\u20130.2824 based on creditworthiness (varies with Prime). Balance transfers: 0% intro APR for 15 months, then variable 0.1874\u20130.2824 (varies with Prime). Intro APR may end if a required minimum payment is 60 days late. Penalty APR up to 0.2999 may apply. Cash advance APR 0.2899."
  },
  "benefits": [
    {
      "name": "Complimentary DashPass membership + quarterly DoorDash discount",
      "description": "Get 6 months of complimentary DashPass (DoorDash and Caviar) when activated between 02/01/2025 and 12/31/2027; auto-renews at the then-current monthly rate unless canceled. Must add the card as default payment and pay with this card at checkout; U.S. address required; other fees/taxes/tips may apply. Plus, while enrolled in DashPass, get up to $10 off once per calendar quarter on one qualifying non-restaurant DoorDash order through 12/31/2027 (limit 1 per quarter; discount applies to subtotal; exclusions include gift cards; no rollover). Estimated value: ~$60 for 6 months if DashPass is ~$9.99/mo, plus potential $40/year in quarterly discounts if fully used.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $500 per item; New York residents: 90 days. Restrictions, limitations and exclusions apply; see Guide to Benefits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends the manufacturer\u2019s U.S. warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years from purchase). Restrictions apply; see Guide to Benefits.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Coverage for theft and collision damage on most rental vehicles when you decline the rental company\u2019s collision insurance and pay the entire rental with your card. In the U.S., coverage is secondary to your personal insurance. Exclusions and limitations apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "Reimbursement up to $1,500 per covered traveler and $6,000 per trip for prepaid, non-refundable passenger fares if your trip is canceled or cut short due to covered reasons (e.g., sickness, severe weather). Restrictions apply; see Guide to Benefits.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "When you pay your monthly cell phone bill with the card, get up to $800 per claim and $1,000 per 12-month period for covered theft or damage; maximum 2 claims per 12 months; $50 deductible per claim. Secondary coverage; terms and exclusions apply (see Mastercard Guide to Benefits).",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance",
      "description": "Provides access to legal and medical referrals and other travel/emergency assistance services when traveling away from home; you are responsible for the cost of any goods/services obtained. Restrictions apply; see Guide to Benefits.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Liability Protection",
      "description": "You won\u2019t be held responsible for unauthorized charges made with your card or account information. Does not apply to use by an authorized user without the primary cardmember\u2019s approval. Additional terms apply.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $200 bonus (awarded as 20,000 points, redeemable for $200 cash back) after you spend $500 on purchases in the first 3 months from account opening. Not available to current cardmembers of this card or previous cardmembers who received a new cardmember bonus for this card within the last 24 months. Account must be open and not in default at fulfillment; allow 6\u20138 weeks for posting.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPKP&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPKP&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://creditcards.chase.com/cash-back-credit-cards/freedom/flex?CELL=6269"
    },
    {
      "name": "Link 3",
      "url": "https://www.chase.com/freedomflex/rewardsagreement"
    },
    {
      "name": "Link 4",
      "url": "https://www.chase.com/personal/credit-cards/freedom/freedomfive"
    }
  ],
  "bank_name": "Chase",
  "imageName": "chase_freedom_flex_credit_card.png"
},
  [CreditCard.ELAN_EVERYDAY_REWARDS_PLUS]: {
  "id": CreditCard.ELAN_EVERYDAY_REWARDS_PLUS,
  "name": "Elan Everyday Rewards+ Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.US_BANK_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4% cash back on dining. No cap.",
      "spendCap": 2000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% cash back on grocery, gas, and streaming.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2% cash back on grocery, gas, and streaming.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "2% cash back on grocery, gas, and streaming.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "$200 cash back after spending $1,000 in first 3 months.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": "https://card.myaccountaccess.com/credit/visa-everyday-rewards-plus.do",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Elan",
  "imageName": ""
},
  [CreditCard.SYNCHRONY_OUTDOORS_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_OUTDOORS_CREDIT_CARD,
  "name": "Synchrony Outdoors Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_clientoffer/e074300.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3499,
    "apr_low": 0.3499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3499,
    "high": 0.3499,
    "description": "Purchase APR 34.99% (0.3499). Penalty APR 39.99% (0.3999). Minimum Interest Charge $2. Deferred interest promotions: No interest if paid in full within 6, 12, or 18 months on qualifying purchases; interest accrues at the standard rate from the purchase date and is charged if the promo balance is not paid in full by the end of the promo period; minimum monthly payments required. Gas station purchases are not eligible for promotional financing. A promo fee of 2% applies to equal payment no-interest promotions of 18 months or more; no promo fee for the 6-month deferred interest offer. Terms cited as of 7/16/2024 and 7/31/2025."
  },
  "benefits": [
    {
      "name": "Promotional financing: No interest if paid in full within 6, 12, or 18 months",
      "description": "Enjoy deferred-interest promotional financing at select Synchrony Outdoors dealers on qualifying purchases. Everyday promo financing is typically: 6 months on $199\u2013$1,999.99; 12 months on $2,000\u2013$3,499.99; 18 months on $3,500+. Interest accrues from the purchase date and is charged if the promotional balance is not paid in full by the end of the promo period. Minimum monthly payments required. Gas station purchases are not eligible. Card generally usable for powersports parts, gear, apparel, equipment $5,000 or less, service, and fuel; not valid for down payments on powersports or trailer purchases. Example value estimate: avoiding interest by paying a $1,000 purchase evenly over 6 months could save roughly ~$90 in interest versus revolving at a 34.99% APR (approximate; assumes average balance method). Paying $1,000 evenly over 12 months could avoid roughly ~$175 in interest at 34.99% APR. Actual savings depend on purchase amount, promo length, and payment allocation.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing_deferred_interest",
      "spend_requirement": 199,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Ability to request a credit limit increase",
      "description": "Cardholders can request a credit limit increase; eligibility is subject to approval and may require providing annual net income.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=39E71C5BFDC38A5D0C22AD55F56CC0A1B21099576CFF7183&client=Synchrony%20Outdoors&intcmp=NoOff_SynchronyOutdoorsCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=39E71C5BFDC38A5D0C22AD55F56CC0A1B21099576CFF7183&client=Synchrony%20Outdoors&intcmp=NoOff_SynchronyOutdoorsCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=39E71C5BFDC38A5D0C22AD55F56CC0A1B21099576CFF7183&preQual=Y&intcmp=NoOff_SynchronyOutdoorsCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    },
    {
      "name": "Learn more about outdoors financing",
      "url": "https://www.synchrony.com/marketplace/outdoors"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_outdoors_credit_card.avif"
},
  [CreditCard.CAPITAL_VACATIONSWORLD_MASTERCARD]: {
  "id": CreditCard.CAPITAL_VACATIONSWORLD_MASTERCARD,
  "name": "Capital Vacations\u00ae World Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/CAP_card_CapitalVaca_PM_WM_Flat_359x246.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BARCLAYCARD_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "capitalVacations",
      "earnRate": 2.0,
      "description": "Eligible Capital Vacations purchases, including maintenance fees, exchange fees, and Lifestyles+ purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "rci",
      "earnRate": 2.0,
      "description": "Eligible RCI purchases and travel, gas, and EV charging purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "Eligible RCI purchases and travel, gas, and EV charging purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Eligible RCI purchases and travel, gas, and EV charging purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other eligible purchases (base earn rate).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.1999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2999,
    "description": "Purchases APR: 0.1999-0.2999 variable (based on Prime Rate and creditworthiness). Special 0 APR for 6 billing cycles on Qualifying Capital Vacations Club down payment purchases. Cash advance APR: 0.2999 variable."
  },
  "benefits": [
    {
      "name": "3-Night Capital Vacations Resort Stay Certificate",
      "description": "Earn a 3-night Capital Vacations Resort Stay Certificate (approximate retail value about $250) after spending $10,000 in net purchases each calendar year. Availability may depend on assigned credit line and ability to maintain it.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Bonus back on redemptions",
      "description": "Receive a bonus back every time you redeem rewards to use toward your next redemption (percentage not specified in source).",
      "benefit_type": null,
      "new_benefit_type": "redemption_bonus",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero liability protection",
      "description": "You\u2019re not responsible for unauthorized charges you report.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Introductory bonus after making your first purchase (amount not specified in the provided content). Bonus may only be earned once; additional issuer eligibility restrictions and anti-gaming provisions apply. Refer to the Introductory Bonus Offer section of the Terms and Conditions.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/capital-vacations/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/capital-vacations/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "capital_vacationsworld_mastercard.png"
},
  [CreditCard.SAVOR_REWARDS_FOR_STUDENTS]: {
  "id": CreditCard.SAVOR_REWARDS_FOR_STUDENTS,
  "name": "Savor Rewards for Students",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/new-savor-card-art.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "Earn unlimited 3% cash back on purchases coded as grocery stores. Capital One notes this excludes superstores like Walmart and Target. Examples include supermarkets, specialty markets, meat lockers, freezer and dairy product stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Earn unlimited 3% cash back at restaurants, cafes, bars, lounges, fast-food chains, and bakeries. Some merchants inside larger establishments or via certain payment technologies may not code as dining.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "entertainment",
      "earnRate": 3.0,
      "description": "Earn unlimited 3% cash back on entertainment such as movie theaters, sports promoters, theatrical promoters, amusement parks, tourist attractions, aquariums, zoos, dance halls, record stores, pool halls, and bowling alleys. Excludes golf courses, collegiate sporting events, and non-industry entertainment merchant codes like cable, digital streaming, and membership services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "Earn unlimited 3% cash back on popular streaming services from eligible providers.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% cash back on all other eligible purchases not covered by a higher category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2924,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2924,
    "description": "Variable purchase APR 0.1924 - 0.2924; balance transfer APR same range."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making purchases outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Concierge Service (24/7)",
      "description": "Personalized assistance for dining, entertainment and travel\u201424 hours a day, 365 days a year.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Additional warranty protection at no charge on eligible items purchased with your card (network terms apply).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24-hour Travel Assistance Services",
      "description": "If your card is lost or stolen while traveling, you can get emergency card replacement and a cash advance.",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Automatic insurance for a covered loss when you use your card to purchase your fare (see Guide to Benefits for terms/exclusions).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2013 Price Drop Protection",
      "description": "When you book a flight when Capital One Travel recommends and the price drops within 10 days, you\u2019ll get up to $50 in travel credit for the difference (terms apply). Value varies by use; max $50 per eligible booking.",
      "benefit_type": null,
      "new_benefit_type": "price_drop_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel \u2013 Price Match Guarantee",
      "description": "If you find a better price within 24 hours of booking an eligible flight, hotel or rental car, Capital One will give you a travel credit for the difference (terms apply).",
      "benefit_type": null,
      "new_benefit_type": "price_match_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining Access",
      "description": "Access to cardholder-only reservations at award\u2011winning restaurants and tickets to curated culinary events.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment Access",
      "description": "Access to the Capital One Entertainment ticketing platform for music, sports and events (8% cash back earn on eligible platform purchases is part of rewards, not a separate benefit; terms apply).",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Caf\u00e9 Beverage Discount",
      "description": "50% off all handcrafted beverages every day at Capital One Caf\u00e9s nationwide when paying with a Capital One card; limit one per person, while supplies last (Caf\u00e9 terms apply).",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 100.0,
      "spendRequirementMonths": 3,
      "description": "Earn a one-time $50 cash bonus after you spend $100 on purchases within 3 months from account opening. Existing or previous accountholders may not be eligible. Bonus is applied to your rewards balance within two billing cycles after qualification. Estimated value: $50 cash.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 50.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/savor-student/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/savor-student/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "savor_rewards_for_students.png"
},
  [CreditCard.US_BANK_SECURED_VISA_CARD]: {
  "id": CreditCard.US_BANK_SECURED_VISA_CARD,
  "name": "U.S. Bank Secured Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/us_bank_secured_visa_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2799,
    "apr_low": 0.2799
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2799,
    "high": 0.2799,
    "description": "Variable APRs based on the Prime Rate: Purchases 27.99%, Balance Transfers 27.99%, Cash Advances 30.99%. Penalty APR not applicable. Minimum interest charge $1. 24\u201330 day grace period on purchases if paid in full by due date."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://applications.usbank.com/oad/begin?locationCode=8069&sourceCode=37913&offerId=7961492XPV",
  "learn_more_link": "https://www.usbank.com/content/usbank/us/en/credit-cards/secured-visa-credit-card",
  "terms_and_conditions_link": "https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=7961492XPV&sourceCode=88237",
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "us_bank_secured_visa_card.png"
},
  [CreditCard.PLUM_CARD]: {
  "id": CreditCard.PLUM_CARD,
  "name": "The Plum Card\u00ae",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/plum.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5% statement credit (Early Pay Discount) on eligible purchases when payment is received within 10 days after the statement closing date. No purchase categories or caps.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "pay_within_10_days_of_statement_closing_date",
        "pay_at_least_minimum_by_due_date"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 250.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 250.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Early Pay Discount (1.5% back)",
      "description": "Earn unlimited 1.5% back as a statement credit on eligible charges when you pay within 10 days of your statement closing date. Credited on the following statement; terms apply.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extra Days to Pay (up to 60 days)",
      "description": "Get up to 60 days to pay without interest when you pay at least the Minimum Payment Due by the Payment Due Date; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "extra_days_to_pay",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Preset Spending Limit",
      "description": "Flexible spending limit that adapts based on factors such as purchase, payment, and credit history.",
      "benefit_type": null,
      "new_benefit_type": "no_preset_spending_limit",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Choose Your Billing Cycle",
      "description": "Select the billing cycle timing most convenient for your business.",
      "benefit_type": null,
      "new_benefit_type": "choose_billing_cycle",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance services when traveling; Card Member is responsible for third\u2011party costs; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No foreign transaction fees on purchases made outside the U.S.; merchant/ATM fees may still apply.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Coverage when you use the Card to reserve and pay for your rental and decline the rental company\u2019s collision damage waiver; terms apply. Typically secondary coverage unless otherwise noted in policy.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends eligible U.S. manufacturer\u2019s warranties on covered purchases; terms apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Protection for eligible purchases against accidental damage or theft for a limited time after purchase; terms apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "If a merchant won\u2019t accept a return on an eligible item within a specified period, Amex may refund you; terms apply.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you find the same prepaid or pay\u2011later hotel room for less online after booking via Amex Travel, Amex will refund the difference; exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rates_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Presale Tickets",
      "description": "Access to purchase presale tickets for select events when using an eligible American Express Card; availability limited; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "amex_presale_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Reserved Tickets",
      "description": "Access to select reserved tickets for events during specified periods when paying with an eligible American Express Card; availability limited; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "amex_reserved_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Entrances and Fast Lanes",
      "description": "Access dedicated entrances/fast lanes at select venues in the Amex Venue Collection by presenting an eligible Amex Card and event ticket; availability varies by venue/event.",
      "benefit_type": null,
      "new_benefit_type": "amex_venue_collection_entrances_fast_lanes",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Concessions Statement Credit",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at participating Amex Venue Collection locations, up to $250 back per calendar year after enrollment; offer currently ends 12/31/2026; terms apply.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "credit_type": "american_express_venue_collection_concessions",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers",
      "description": "Targeted merchant offers that can provide additional statement credits or bonus rewards after enrollment; offers vary and are limited; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Connect to QuickBooks",
      "description": "Integrates eligible Business Card transactions with QuickBooks Online for easier bookkeeping; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "connect_to_quickbooks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Vendor Pay by Bill.com",
      "description": "Access to Vendor Pay by Bill.com for virtual card payments and AP automation; plan fees and per\u2011transaction fees may apply per Bill.com pricing; enrollment required.",
      "benefit_type": null,
      "new_benefit_type": "vendor_pay_by_bill_com",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Year\u2011End Summary",
      "description": "Online Year\u2011End Summary typically available in January, covering prior calendar year posted charges.",
      "benefit_type": null,
      "new_benefit_type": "year_end_summary",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-plum-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Plum",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-plum-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Plum",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/the-plum-card-business-charge-card/45094-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/the-plum-card-business-charge-card/45094-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "plum_card.png"
},
  [CreditCard.CHASE_UNITED_EXPLORER_CARD]: {
  "id": CreditCard.CHASE_UNITED_EXPLORER_CARD,
  "name": "United\u2120 Explorer Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/chase_united_explorer_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 2.0,
      "description": "2x total miles (1 base + 1 additional) on qualifying purchases from United as described; merchant coding and booking channel must reflect direct United purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "travel.airline.united"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Earns 2 miles per $1 on airline tickets purchased from United and on qualifying purchases made from United: seat upgrades, Economy Plus, inflight food and beverages, inflight Wi\u2011Fi and Wi\u2011Fi subscriptions, baggage service charges, and other United fees. Excludes other United-related purchases such as United Cruises, United MileagePlus X, DIRECTV, and Merchandise Awards. United tickets booked through some discount travel websites or as part of a third\u2011party travel package will not qualify."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": null,
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x total miles at restaurants; eligibility depends on merchant category coding per Chase Rewards Category FAQs. Third\u2011party wallets or payment technology that do not transmit the restaurant MCC may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2x total miles on hotel stays when purchased directly with the hotel; merchant coding must reflect a hotel and direct purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "direct_booking_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 mile per $1 on all other purchases. Excludes transactions that aren\u2019t considered purchases (e.g., balance transfers, cash advances, cash\u2011like transactions, lottery or betting transactions, checks that access the account, interest, fees, and unauthorized/fraudulent charges).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.2049
  },
  "annualFee": 150.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2049,
    "high": 0.2899,
    "description": "Variable APRs based on the Prime Rate (7.50% as of 2/4/2025). Purchase APR: 20.49%\u201328.99% (0.2049\u20130.2899). Balance Transfer APR: 20.49%\u201328.99% (0.2049\u20130.2899). Cash Advance APR: 29.24% (0.2924). Penalty APR: up to 29.99% (0.2999). Minimum interest charge: None. At least 21-day grace period on purchases if you pay your balance in full (or Interest Saving Balance) by the due date; interest on balance transfers and cash advances starts on the transaction date."
  },
  "benefits": [
    {
      "name": "Free first checked bag (primary + 1 companion) on United/United Express",
      "description": "Primary cardmember and one companion on the same reservation each get their first standard checked bag free on United- and United Express-operated flights. Ticket must be purchased with the card (requirement waived for flights completed within 90 days of account opening) and MileagePlus number must be in the reservation. Estimate: domestic first checked bag often ~$35 per person each way; potential value up to ~$140 roundtrip for two people.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "2 United Club one-time passes each year",
      "description": "Two one-time United Club passes deposited after account opening and every 12 months thereafter while account remains open. Estimate: United day pass often priced around $59 each; roughly ~$118 in potential annual value.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Priority boarding on United/United Express",
      "description": "Primary cardmember and companions on the same reservation board before general boarding (after Premier members and Premier Access). Available about 2 weeks after account opening.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing discount on United awards",
      "description": "United indicates Explorer cardmembers saw award prices 32% lower (when the \u201cCardmembers Save\u201d banner was present) versus general members for the same itinerary in 2024. Savings vary and exclude taxes/fees.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$100 United TravelBank credit after $10,000 calendar-year spend",
      "description": "Earn $100 in United TravelBank cash after $10,000 in purchases in a calendar year (limit 1 per calendar year). TravelBank posts 6\u20138 weeks after meeting requirement. Estimate: $100/year if earned.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 10000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 United Hotels statement credits per card year",
      "description": "Automatic $50 statement credit after your first and second hotel stays of $50+ when booked and paid directly through United Hotels (total up to $100 per card year based on your account anniversary cycle). Estimate: up to $100/year.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Rideshare statement credits, up to $60 per calendar year",
      "description": "Enroll annually to earn up to $5 back each month on eligible rideshare purchases, up to $60 per calendar year. Credits post 6\u20138 weeks after posting of purchase. Estimate: up to $60/year with monthly use.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Monthly Instacart credit with active Instacart+",
      "description": "Receive one $10 Instacart credit each month you have an active Instacart+ membership after activating the complimentary Chase Instacart+ offer (valid 3/23/2025\u201312/31/2027). Credit applies to a single order of $10+; unused portion doesn\u2019t roll over. Estimate: up to $120/year during promo window, subject to having/activating Instacart+.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership for 3 months, then 25% off annual rate through 12/31/2027",
      "description": "Activate between 3/23/2025 and 12/31/2027 to receive 3 months of Instacart+ complimentary; then renew at 25% off the then-current annual rate through 12/31/2027 when paid with the card. Estimate: 3 free months \u2248 ~$24.75 value if $99/yr list price; ongoing 25% discount value depends on renewal.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $50 Avis/Budget TravelBank credit per card year",
      "description": "Earn $25 United TravelBank cash on your first and $25 on your second eligible Avis or Budget rental (min 2 days) booked via cars.united.com with specified codes, up to $50 annually. Posts 6\u20138 weeks after eligible rental return. Estimate: up to $50/year.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$100 annual JSX statement credit",
      "description": "Automatic statement credit for purchases made directly with JSX, up to $100 per card year. Estimate: up to $100/year.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "One statement credit up to $120 every 4 years after the program fee is charged to the card (primary or AU). Estimate: effective ~$30/year averaged over 4 years.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on United inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on food, beverage, and Wi\u2011Fi purchases onboard United/United Express and on premium drink purchases at United Clubs when paid with the card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Premier Qualifying Points (PQP) from card spend",
      "description": "Earn 1 PQP per $20 in net purchases, up to 1,000 PQP per calendar year, which can apply toward Premier status (up to Premier 1K). Posts 6\u20138 weeks after qualifying purchases.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10,000-mile award flight discount after $20,000 calendar-year spend",
      "description": "After $20,000 in purchases in a calendar year, receive one 10,000-mile award flight discount for eligible United/United Express award travel; limit 1 per year; discount expires 12 months after issue. Estimate: roughly ~$130 value if you redeem at ~1.3\u00a2/mile.",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Concierge service",
      "description": "Access to a concierge for assistance; cardholder pays cost of goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "One statement credit up to $120 every 4 years after the program fee is charged to the card (primary or AU). Estimate: effective ~$30/year averaged over 4 years.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "60,000 bonus miles after $3,000 in purchases within the first 3 months from account opening. Not available to current cardmembers of this card, or previous cardmembers who received a new cardmember bonus within the last 24 months. Miles post in 6\u20138 weeks; account must be open and not in default; miles do not count toward Premier status; bonus may be clawed back if account not open at least 6 months. Estimated value: about ~$780 at ~1.3\u00a2 per mile (your value may vary).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "10,000 bonus miles after adding an authorized user within the first 3 months from account opening (awarded once for the first authorized user added). Authorized user must remain on the account at fulfillment; miles post in 6\u20138 weeks; account must be open and not in default; miles do not count toward Premier status; bonus may be clawed back if account not open at least 6 months. Estimated value: about ~$130 at ~1.3\u00a2 per mile (your value may vary).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "chase_united_explorer_card.png"
},
  [CreditCard.NASCAR_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.NASCAR_AMERICAN_EXPRESS_CARD,
  "name": "Credit One Bank NASCAR\u00ae American Express\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/nascar-amex.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% cash back on all net purchases. Rewards post as automatic statement credits on statements with at least one net purchase and reduce your balance but do not count as payments. No rewards on cash advances, balance transfers, interest, fees, other charges, or while the account is delinquent or in default.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 39.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 39.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "Variable purchase APR based on creditworthiness; accurate as of 2025-08-31."
  },
  "benefits": [
    {
      "name": "Retail Protection",
      "description": "Eligible items are covered if accidentally damaged or stolen within 90 days of purchase (via American Express network).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Offers",
      "description": "Access to Amex Offers for targeted discounts and statement credits at participating merchants.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Travel accident insurance provided by the American Express network; terms and coverage limits per Amex network disclosures.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Experian IdentityWorks Membership",
      "description": "Optional free membership in Experian IdentityWorks when you complete and submit the application online; service subject to change.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=C1ON&C1BSpecificationID=bc-nascar-american-express",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/american-express-nascar",
  "terms_and_conditions_link": "https://www.creditonebank.com/pre-qualification/terms/nascar-amex-all-terms",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [],
  "bank_name": "Credit One",
  "imageName": "nascar_american_express_card.png"
},
  [CreditCard.SYNCHRONY_CAR_CARE_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_CAR_CARE_CREDIT_CARD,
  "name": "Synchrony Car Care\u2122 Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://etail.mysynchrony.com/cs/groups/public/documents/et_clientoffer/e074237.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.3499,
    "apr_low": 0.3499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3499,
    "high": 0.3499,
    "description": "New Accounts as of 7/16/24: Purchase APR 34.99% (0.3499). Penalty APR 39.99% (0.3999). Minimum interest charge $2. Deferred Interest Offer: No Interest if Paid in Full within 6 months on purchases of $199+ (interest accrues from purchase date and is assessed if not paid in full by promo end; gas purchases not eligible; minimum payments required). A promo fee of 2% applies on equal payment no interest promotions of 18 months or more. Regular account terms apply to non\u2011promo purchases and after the promo ends."
  },
  "benefits": [
    {
      "name": "Deferred-interest promotional financing (6 months on $199+)",
      "description": "No interest if paid in full within 6 months on purchases of $199 or more made with your Synchrony Car Care credit card at participating locations. Gas station purchases are not eligible. Minimum monthly payments required. If the promotional balance is not paid in full by the promo expiration date, interest accrues from the purchase date at the account\u2019s standard APR (as disclosed; e.g., New Accounts APR 34.99%, Penalty APR 39.99%, Minimum Interest Charge $2). Promotional financing offers may vary by merchant; equal-payment, no-interest plans of 18 months or more may be available and can incur a 2% promo fee of the amount financed.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing_deferred_interest",
      "spend_requirement": 199,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=ABB75F4E7839CB18E21D8DFC208DC369EAF15F97ABA1C619&client=SynchronyCarCare&intcmp=NoOff_SynchronyCarCareCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=ABB75F4E7839CB18E21D8DFC208DC369EAF15F97ABA1C619&client=SynchronyCarCare&intcmp=NoOff_SynchronyCarCareCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://etail.mysynchrony.com/eapply/eapply.action?uniqueId=ABB75F4E7839CB18E21D8DFC208DC369EAF15F97ABA1C619&preQual=Y&client=SynchronyCarCare&intcmp=NoOff_SynchronyCarCareCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=catb"
    },
    {
      "name": "Find merchant locations",
      "url": "https://www.synchrony.com/financing/car-care/locations/"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_car_care_credit_card.jpg"
},
  [CreditCard.SYNCHRONY_CARE_CREDIT_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_CARE_CREDIT_CREDIT_CARD,
  "name": "CareCredit Rewards Mastercard",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.carecredit.com/sites/cc/image/carecredit-rewards-cards.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3299,
    "apr_low": 0.3299
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3299,
    "high": 0.3299,
    "description": "For New Accounts as of 5/30/2024: Purchase APR 32.99%. Penalty APR 39.99%. Minimum Interest Charge $2. CareCredit Rewards Mastercard: Cash APR 32.99% and 4% fee ($10 min). Balance Transfer APR 32.99% and 5% fee ($5 min). Foreign Transaction Fee 3%."
  },
  "benefits": [
    {
      "name": "No Annual Fee",
      "description": "No annual fee for the CareCredit credit card. This reduces ongoing card cost compared with fee-based cards.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Promotional Financing (CareCredit Network)",
      "description": "Access to promotional financing options on qualifying purchases at CareCredit Network providers (subject to credit approval; minimum monthly payments required). Exact promo terms vary by provider and offer.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Accepted at 270,000+ CareCredit Network Locations",
      "description": "Usable at 270,000+ participating healthcare and wellness providers across categories such as dental, vision, hearing, veterinary, cosmetic and more.",
      "benefit_type": null,
      "new_benefit_type": "provider_network_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.carecredit.com/apply/?intcmp=NoOff_CareCreditCreditCard_credit%20cards_body-catalog-cards_apply_int&storeNumber=othc",
  "learn_more_link": "https://www.carecredit.com/apply/?intcmp=NoOff_CareCreditCreditCard_credit%20cards_body-catalog-cards_apply_int&storeNumber=othc",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "See if you prequalify",
      "url": "https://www.carecredit.com/apply/?intcmp=NoOff_CareCreditCreditCard_credit%20cards_body-catalog-cards_apply_int&storeNumber=othc"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_care_credit_credit_card.png"
},
  [CreditCard.MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD]: {
  "id": CreditCard.MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD,
  "name": "Marriott Bonvoy Brilliant\u00ae American Express\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000313_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.MARRIOTT_BONVOY,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.marriott",
      "earnRate": 6.0,
      "description": "Eligible purchases at hotels participating in Marriott Bonvoy.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "At restaurants worldwide.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 3.0,
      "description": "On flights booked directly with airlines.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "booked_directly_with_airlines"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "For other eligible purchases not covered by higher bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 650.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 650.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "19.99% to 28.99% variable APR on purchases."
  },
  "benefits": [
    {
      "name": "$300 Brilliant Dining Credit",
      "description": "Each calendar year, receive up to $300 in statement credits (up to $25 per month) for eligible purchases made on the card at restaurants worldwide. Estimated value: up to $300 per year if fully utilized.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Marriott Bonvoy Brilliant Free Night Award (up to 85,000 points)",
      "description": "Receive 1 Free Night Award every year after your card renewal month. Valid for one night at participating Marriott Bonvoy hotels with a redemption level at or under 85,000 points (resort fees may apply). Estimated value varies widely; using ~0.6\u00a2\u20130.8\u00a2 per point, the cap allows potential value of roughly $510\u2013$680 depending on availability and property.",
      "benefit_type": "free_hotel_night",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Marriott Bonvoy Platinum Elite Status",
      "description": "Enjoy Marriott Bonvoy Platinum Elite status, which can include room upgrades (including enhanced views or suites when available) when booked with a Qualifying Rate, among other on-property benefits. Estimated value depends on stay frequency; frequent guests may realize substantial value from upgrades, late checkout, and earning bonuses.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "Pay no foreign transaction fees on purchases abroad made with this card.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Brilliant Earned Choice Award (after $60,000 calendar-year spend)",
      "description": "Each calendar year after spending $60,000 in eligible purchases on the card, you are eligible to select one Brilliant Earned Choice Award benefit (one per calendar year). See https://www.choice-benefit.marriott.com/brilliant for current options.",
      "benefit_type": null,
      "new_benefit_type": "marriott_bonvoy_brilliant_earned_choice_award",
      "spend_requirement": 60000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$300 Brilliant Dining Credit",
      "description": "Up to $25 in statement credits each calendar month (up to $300 per year) for eligible purchases at restaurants worldwide made on the card.",
      "credit_type": "monthly_credit",
      "credit_category": "dining",
      "new_credit_category": null,
      "value": 25.0,
      "value_unit": "dollars",
      "value_unit_schedule": [
        {
          "frequency": "monthly",
          "values": [
            25.0,
            25.0,
            25.0,
            25.0,
            25.0,
            25.0,
            25.0,
            25.0,
            25.0,
            25.0,
            25.0,
            25.0
          ]
        }
      ],
      "total_yearly_value": 300.0,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "statement_credit_percentage_back": null,
      "is_guaranteed": true,
      "is_recurring": true,
      "max_occurrences_per_period": 1
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 6,
      "description": "Earn 100,000 Marriott Bonvoy bonus points after $6,000 in purchases in the first 6 months of card membership. Estimated value ~$600 at 0.6\u00a2 per point (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "points",
          "category": "all_purchases",
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card/marriott-bonvoy-brilliant/",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/marriott-bonvoy-brilliant/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "American Express",
  "imageName": "marriott_bonvoy_brilliant_american_express_card.png"
},
  [CreditCard.COSTCO_ANYWHERE_VISA_CARD_BY_CITI]: {
  "id": CreditCard.COSTCO_ANYWHERE_VISA_CARD_BY_CITI,
  "name": "Costco Anywhere Visa\u00ae Card by Citi",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/costco-anywhere/costco-anywhere_90x57.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "5% cash back on gas purchased at Costco warehouse locations worldwide. The $7,000 annual cap is combined with the 'other eligible gas and EV charging' category; after the combined cap is reached, these purchases earn 1%.",
      "spendCap": 7000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 4.0,
      "description": "4% cash back on other eligible gas and EV charging purchases worldwide (excluding gas purchased at Costco). The $7,000 annual cap is combined with the Costco gas 5% category; after the combined cap is reached, these purchases earn 1%.",
      "spendCap": 7000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3% cash back on restaurant purchases worldwide, including cafes, bars, lounges, and fast food. Exclusions that earn 1% include purchases at certain bakeries, department store restaurants, grocery or warehouse clubs.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 3.0,
      "description": "3% cash back on eligible travel purchases worldwide, including airfare, hotels, car rentals, travel agencies, cruise lines, and Costco Travel. Exclusions that earn 1% include train and commuter travel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "costco",
      "earnRate": 2.0,
      "description": "2% cash back on all other purchases from Costco and Costco.com (i.e., Costco in-warehouse and online purchases that are not gas/EV charging).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases, including non-qualifying restaurant/travel subcategories and on gas/EV charging after the $7,000 combined annual cap is reached.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2724,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2724,
    "description": "Variable APR for purchases, balance transfers, and Citi Flex Plans subject to an APR: 19.24%\u201327.24% based on creditworthiness. Cash advance APR: 29.24%. Penalty APR: up to 29.99% if you pay late or a payment is returned. Minimum interest charge: $0.50. For Citi Flex Pay Plans subject to a Plan Fee, a monthly fee of up to 1.72% may apply."
  },
  "benefits": [
    {
      "name": "Damage & Theft Purchase Protection",
      "description": "Covers eligible items purchased with the card if damaged or stolen within 120 days of purchase (90 days for New York residents). Estimated value: equal to the repair/replacement cost of a covered item up to policy limits; useful for newly purchased items that are damaged or stolen shortly after purchase. Terms, limits, and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Worldwide Car Rental Insurance (Auto Rental CDW)",
      "description": "Collision Damage Waiver coverage when you pay for your rental with the card and decline the rental agency\u2019s CDW. Worldwide coverage per card benefits guide; terms vary and typically exclude liability. Estimated savings: cost of the CDW you might otherwise buy from the rental agency (often around $10\u2013$30 per rental day). Terms, limits, and exclusions apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Insurance coverage for covered travel when the trip is paid with the card. Estimated value is contingent on covered events and policy limits; not typically realized unless a covered incident occurs. Terms, limits, and exclusions apply.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance",
      "description": "Access to a service line for help with travel emergencies and coordination (you are responsible for third\u2011party costs). Value is in convenience and support; no fixed cash value. Terms and exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Assistance Dispatch Service",
      "description": "Dispatch service to help arrange towing, jump-starts, locksmiths, and more; you pay the service provider costs. Value equals avoided standalone membership fees and time savings; no fixed cash value. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "0% foreign transaction fees on purchases. Estimated savings: about 3% of your international card spend (e.g., roughly $30 per $1,000 spent abroad) versus cards that charge typical foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment Access",
      "description": "Access to presale tickets and exclusive experiences for select concerts, sporting events, dining experiences, and more. Value depends on event availability and personal use; no fixed cash value.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_presale_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-costco-anywhere-visa-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "See if You're Pre-qualified",
      "url": "https://online.citi.com/US/ag/cards/pre-screen?intc=citihpmenu_creditcards_pq&PP=costco-anywhere&OC=CC-CITI-3CY"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "costco_anywhere_visa_card_by_citi.jpeg"
},
  [CreditCard.NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD]: {
  "id": CreditCard.NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD,
  "name": "Norwegian Cruise Line\u00ae World Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/radz_wldcm_mc_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.NORWEGIAN_CRUISE_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.cruise.norwegian",
      "earnRate": 3.0,
      "description": "3 points per $1 on eligible purchases charged through Norwegian Cruise Line (including cruise fares). Merchant category coding and statement descriptor determine eligibility.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 4.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 5.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 2.0,
      "description": "2 points per $1 on eligible airline and hotel purchases (includes motels, inns, and resorts when coded as hotel/motel).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2 points per $1 on eligible airline and hotel purchases (includes motels, inns, and resorts when coded as hotel/motel).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 point per $1 on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 1.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 1.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "Variable APRs that vary with the Prime Rate. Purchases: 0.1824\u20130.2824 based on creditworthiness; no introductory APR. Balance transfers: 0.1824\u20130.2824 (variable) and accrue interest from the transaction date. Penalty APR up to 0.2999 may apply for late payment."
  },
  "benefits": [
    {
      "name": "Bank of America Preferred Rewards bonus",
      "description": "Preferred Rewards members earn 25%-75% more points on every purchase, applied to the base earn rate of 1 point per $1.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay no foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 20,000 bonus points after $1,000 in purchases in the first 90 days of account opening. Advertised as enough for a $200 onboard credit or $200 off a Norwegian cruise (implies ~1.0 cent per point value; estimated bonus value \u2248 $200). Excludes balance transfers and cash advances; limit 1 per new account; account must be open with active charging privileges. Points typically post within 1\u20132 billing cycles after qualification.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 20000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076166&productoffercode=35&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/norwegian-cruise-lines-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076166&productoffercode=35&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Norwegian Cruise Line\u00ae World Mastercard\u00ae",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "norwegian_cruise_line_world_mastercard.png"
},
  [CreditCard.EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD,
  "name": "Emirates Skywards Premium World Elite Mastercard",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/EKE_card_rRGB_Premium_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.EMIRATES,
  "rewards_earn_rates": [
    {
      "category": "emirates_airlines",
      "earnRate": 3.0,
      "description": "3 Skywards Miles per dollar on eligible Emirates purchases made directly with Emirates (including Emirates.com, ticket offices, and onboard purchases).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "Eligible travel purchases earn 2 Skywards Miles per dollar. No travel portal requirement disclosed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 Skywards Mile per dollar on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 499.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 499.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchases APR is variable 0.2024 to 0.2999 based on creditworthiness; varies with the Prime Rate. Balance transfers have a 0.0 introductory APR for 12 months on transfers that post within 45 days of account opening; thereafter 0.2024 to 0.2999 variable."
  },
  "benefits": [
    {
      "name": "Emirates Skywards tier status",
      "description": "Enjoy Emirates Skywards tier status during your first year; retain your tier status by spending $40,000 each cardmembership year.",
      "benefit_type": "airline_status",
      "new_benefit_type": null,
      "spend_requirement": 40000,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global lounge access",
      "description": "Provides unlimited access to 1,200+ lounges worldwide for the primary cardmember and their guest(s).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry/TSA PreCheck credit",
      "description": "Automatic statement credit for one Global Entry or TSA PreCheck application fee every five years, up to $120 (equivalent to up to ~$24/year over a 5-year cycle).",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "$0 foreign transaction fees on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% discount on buying/gifting Skywards Miles",
      "description": "Receive a 25% savings when you Buy Skywards Miles for yourself or Gift Miles.",
      "benefit_type": "points_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry/TSA PreCheck application fee credit",
      "description": "Automatic statement credit for one Global Entry or TSA PreCheck application fee every five years, up to $120.",
      "credit_category": null,
      "new_credit_category": "tsa_precheck_global_entry",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Bonus Skywards Miles after spending $3,000 on purchases in the first 90 days (miles amount not specified in source).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 70000,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/emirates-skywards-premium-world-elite-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/emirates-skywards-premium-world-elite-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "emirates_skywards_premium_world_elite_mastercard.png"
},
  [CreditCard.UNITED_BUSINESS_CARD]: {
  "id": CreditCard.UNITED_BUSINESS_CARD,
  "name": "United\u2120 Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_biz_card_tilted.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.united",
      "earnRate": 2.0,
      "description": "2x miles on airline tickets purchased from United and on eligible United purchases such as seat upgrades, Economy Plus, inflight food/beverages/Wi\u2011Fi, baggage service charges, and other United fees. Excludes United Cruises, United MileagePlus X, DIRECTV and Merchandise Awards. United tickets booked via some discount travel sites or as part of third\u2011party packages do not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2x miles on hotel stays purchased directly via United Hotels. Marketing notes total up to 5x when combining United program earnings with the card.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x miles on dining, including eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x miles at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "officeSupplies",
      "earnRate": 2.0,
      "description": "2x miles at office supply stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2x miles on local transit and commuting including rideshare services, taxicabs, train tickets, tolls, and mass transit.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2874,
    "apr_low": 0.2024
  },
  "annualFee": 150.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2874,
    "description": "Variable APRs based on Prime Rate (7.25% as of 2025-09-23). Purchase APR: 0.2024\u20130.2874; Balance transfer APR: 0.2024\u20130.2874 (account may not be eligible for balance transfers); Cash advance APR: 0.2899; Penalty/Default APR: up to 0.2999. Grace period: at least 20 days on purchases (no interest on new purchases if the entire balance or Interest Saving Balance is paid by the due date). Minimum interest charge: None. Balance transfer fee: 0.05 (min $5). Cash advance fee: 0.05 (min $15). Late fee: $40. Return payment fee: $40. Chase Pay Over Time fee: up to 1.72% monthly fixed finance charge."
  },
  "benefits": [
    {
      "name": "2 United Club one-time passes per year",
      "description": "Two United Club one-time passes deposited after account opening and every 12 months thereafter. Over a $100 value; access includes complimentary beverages, snacks, Wi\u2011Fi (subject to club rules).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free first checked bag",
      "description": "Primary cardmember and one companion on the same reservation each receive the first standard checked bag free on United/United Express-operated flights (up to $40 each way per person; up to $160 per roundtrip for two people). Ticket must be purchased from United with the card (purchase requirement waived for first 90 days after account opening).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority boarding",
      "description": "Primary cardmember and companions on the same reservation are invited to board United-operated flights before general boarding (after MileagePlus Premier and Premier Access).",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on inflight purchases and United Club premium drinks",
      "description": "Get 25% back as a statement credit on food, beverage and Wi\u2011Fi purchases on United/United Express-operated flights and on premium drink purchases at United Clubs when paying with the card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing on United",
      "description": "Save an average of about 30% in miles on select United-operated award flights when the \u201cCardmembers Save\u201d banner is shown (savings vary by itinerary and availability).",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "5,000-mile better-together anniversary bonus",
      "description": "Earn 5,000 bonus miles each account anniversary year if the business card\u2019s Authorizing Officer is also the primary cardmember on a personal Chase United credit card; both accounts must be open and not in default.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "2 Economy Plus seat upgrades after $25,000 calendar-year spend",
      "description": "Earn 2 credits to upgrade to Economy Plus seating on eligible United/United Express flights within the continental U.S. after $25,000 in purchases each calendar year. Credits valid 12 months from issue; value varies by route and seat availability.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": 25000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$125 United TravelBank credit",
      "description": "Receive $125 in United TravelBank cash after making five United flight purchases of $100+ each in a calendar year. TravelBank cash posts 6\u20138 weeks after the 5th qualifying purchase and expires 12 months after issue.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 500,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 United Hotels statement credits per anniversary year",
      "description": "$50 statement credit on your 1st and 2nd prepaid hotel stays of $50+ booked and paid directly through United Hotels, up to $100 per anniversary year.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 50,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 rideshare statement credits per calendar year (enrollment required)",
      "description": "Enroll annually to receive up to $100 back per calendar year on rideshare purchases: $8 per month Jan\u2013Nov and $12 in Dec when paying with the card. Credits post 6\u20138 weeks after qualifying transactions.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $50 in United TravelBank cash for Avis/Budget rentals",
      "description": "Earn $25 TravelBank cash on your 1st and $25 on your 2nd eligible Avis or Budget rental (booked via cars.united.com, paid with the card; minimum 2-day rental; designated discount codes required) each anniversary year, up to $50 total.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $120 in Instacart credits per calendar year (through 12/31/27)",
      "description": "Receive a $10 Instacart credit each month (requires active Instacart+ membership; complimentary 3-month Instacart+ then 25% off annual rate available through 12/31/27 when activated with this card). One credit per month; excludes fees and tips.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 JSX statement credits per anniversary year",
      "description": "Automatically receive up to $100 in statement credits per anniversary year for purchases made directly with JSX when paid with the card.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $25 FareLock statement credit per anniversary year",
      "description": "Get up to $25 back as a statement credit each anniversary year on FareLock purchases for United/United Express flights when paid with the card.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn up to 4,000 PQP from spend",
      "description": "Earn 1 Premier Qualifying Point (PQP) for every $20 in net purchases (including authorized users), up to 4,000 PQP per calendar year, applicable toward MileagePlus Premier status up to and including Premier 1K (per program rules).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Auto rental collision damage waiver (primary for business rentals)",
      "description": "Primary coverage for theft and collision damage when you decline the rental company\u2019s CDW and charge the entire rental to the card (for most rentals with MSRP \u2264 $125,000). Coverage up to $60,000.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage delay insurance",
      "description": "Reimburses up to $100 per day for up to 3 days for essential purchases when baggage is delayed more than 6 hours on a covered trip.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost luggage reimbursement",
      "description": "Reimbursement up to $3,000 per covered traveler for checked or carry\u2011on baggage that is lost, damaged or stolen during a covered trip (NY limits apply).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip cancellation and interruption insurance",
      "description": "Reimbursement up to $1,500 per covered traveler and $6,000 per trip for prepaid, non\u2011refundable passenger fares if your trip is canceled or cut short due to covered reasons.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip delay reimbursement",
      "description": "If your common carrier travel is delayed more than 12 hours or requires an overnight stay, you\u2019re covered for unreimbursed expenses (e.g., meals and lodging) up to $500 per covered traveler.",
      "benefit_type": null,
      "new_benefit_type": "trip_delay_reimbursement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $10,000 per item (90 days in NY).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty protection",
      "description": "Extends the original U.S. manufacturer\u2019s warranty by 1 additional year on eligible warranties of 3 years or less (up to 4 years total from purchase date).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "24/7 complimentary assistance for dining, entertainment, travel and gifting requests; cardholder is responsible for the cost of goods/services.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Avoid typical ~3% foreign transaction fees on purchases made outside the U.S. (example: save about $150 on $5,000 in international spend).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "United Card Events and MileagePlus Exclusives access",
      "description": "Access to curated events and the ability to use miles for exclusive experiences via United Card Events from Chase and MileagePlus Exclusives.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_events_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$125 United TravelBank credit",
      "description": "Receive $125 in United TravelBank cash after five United flight purchases of $100+ each in a calendar year.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 125.0,
      "value_unit": "dollars",
      "spend_requirement": 500,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $100 United Hotels credits",
      "description": "$50 back on your 1st and 2nd prepaid hotel stays ($50+ each) booked directly through United Hotels per anniversary year.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": 50,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $100 rideshare credits (enrollment required)",
      "description": "$8/mo Jan\u2013Nov and $12 in Dec when you pay with the card; up to $100 per calendar year.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $50 Avis/Budget TravelBank credits",
      "description": "$25 TravelBank cash on your 1st and $25 on your 2nd eligible Avis or Budget rental booked via cars.united.com each anniversary year (min 2-day rental).",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $120 Instacart credits (through 12/31/27)",
      "description": "$10 Instacart credit monthly when linked to an active Instacart+ membership activated with this card; up to $120 per calendar year.",
      "credit_category": "grocery",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Up to $100 JSX statement credits",
      "description": "Automatically receive up to $100 back per anniversary year on purchases made directly with JSX.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $25 United FareLock statement credit",
      "description": "Get up to $25 back per anniversary year on FareLock purchases for United/United Express flights.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 25.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time offer: Earn 100,000 United miles + 2,000 Premier Qualifying Points (PQP) after $5,000 in purchases in the first 3 months from account opening. Plus, earn 10,000 bonus miles after you add an employee (authorized user) card in the first 3 months. Estimated value: 100k miles \u2248 $1,200 at 1.2\u00a2/mile (valuation varies); 10k miles \u2248 $120. PQP help you qualify for Premier status and have no direct cash value.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "miles"
        },
        {
          "reward_type": null,
          "new_reward_type": "status_qualifying_points_united",
          "amount": 2000.0,
          "value_unit": "PQP"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Limited-time offer: Earn 100,000 United miles + 2,000 Premier Qualifying Points (PQP) after $5,000 in purchases in the first 3 months from account opening. Plus, earn 10,000 bonus miles after you add an employee (authorized user) card in the first 3 months. Estimated value: 100k miles \u2248 $1,200 at 1.2\u00a2/mile (valuation varies); 10k miles \u2248 $120. PQP help you qualify for Premier status and have no direct cash value.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HV5W&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/united/united-business-card?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62231.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/unitedbusinesscard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "united_business_card.png"
},
  [CreditCard.ACTIVE_CASH_CARD]: {
  "id": CreditCard.ACTIVE_CASH_CARD,
  "name": "Wells Fargo Active Cash\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www17.wellsfargomedia.com/assets/images/photography/product/credit-cards/WF_ActiveCash_VS_Collateral_Front_290px_RGB_04082_lowres.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Earn 2% cash rewards (two cents per $1) on unlimited net purchases; no categories to track. Exclusions: ATM transactions, cash advances of any kind, balance transfers, SUPERCHECKS, cash equivalents (e.g., money orders, prepaid gift cards, traveler\u2019s checks, wire transfers), peer\u2011to\u2011peer payments, overdraft protection advances, any fees or interest, and gambling transactions (bets/wagers online, casino chips, lottery tickets, off\u2011track wagers). Rewards are calculated on net purchases and rounded to the nearest whole dollar; cash rewards don\u2019t expire while the account is open.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1899
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1899,
    "high": 0.2899,
    "description": "0% intro APR for 12 months on purchases and qualifying balance transfers (BTs must be made within 120 days to qualify for intro APR and intro BT fee). After that, variable APR 18.99%\u201328.99% based on creditworthiness (varies with the U.S. Prime Rate). Cash advances: 29.99% variable. Minimum interest charge $1; at least 25-day grace period on purchases. BT and cash advance interest begins on the transaction date."
  },
  "benefits": [
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $600 per approved claim (max 2 claims per 12 months; $1,200 annual max) with a $25 deductible when you pay your monthly wireless bill with the card. Excludes loss (mysterious disappearance), electronic failure/software issues, cosmetic damage, cracked screens, and scratches. Coverage begins the first day of the month after your first eligible wireless bill posts.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver (Secondary)",
      "description": "Secondary coverage for theft or damage to a rental car when you pay for the entire rental with the card and decline the rental company\u2019s collision coverage. Certain vehicles and limitations apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel and Emergency Assistance Services",
      "description": "24/7 referral and assistance for emergencies while traveling; cardholder is responsible for costs of services provided.",
      "benefit_type": null,
      "new_benefit_type": "travel_and_emergency_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Dispatch",
      "description": "Pay-per-use roadside assistance and towing available 24/7; fees apply and vary by service; availability may be limited in some areas.",
      "benefit_type": null,
      "new_benefit_type": "roadside_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency Cash Disbursement and Card Replacement",
      "description": "Visa can arrange emergency cash advances and card replacement typically within 1\u20133 business days after issuer approval; cash advance fees and interest apply.",
      "benefit_type": null,
      "new_benefit_type": "emergency_cash_disbursement_and_card_replacement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "My Wells Fargo Deals",
      "description": "Activate targeted merchant offers and earn statement credits as account credits after qualifying purchases; exclusions and posting timelines apply.",
      "benefit_type": null,
      "new_benefit_type": "my_wells_fargo_deals",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero Liability Protection",
      "description": "You won\u2019t be held responsible for promptly reported unauthorized transactions, subject to conditions.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "Complimentary 24/7 concierge assistance for dining, travel, and event arrangements; cardholder pays for goods/services booked.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Luxury Hotel Collection Perks",
      "description": "Access to benefits at participating properties when booked via Visa Signature channels; terms, limitations, and property-specific benefits apply.",
      "benefit_type": null,
      "new_benefit_type": "visa_signature_luxury_hotel_collection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $200 cash rewards bonus after at least $500 in net purchases post within the first 3 months from account opening. Bonus typically posts within 1\u20132 billing periods after earning. Transactions that do NOT count toward the spend and do NOT earn the bonus include cash advances and equivalents (ATM transactions, cash advances, money orders, prepaid gift cards, traveler\u2019s checks, wire transfers, peer\u2011to\u2011peer payments), balance transfers/SUPERCHECKS, fees/interest, disputed/illegal purchases, and gambling transactions. Offer availability may vary by channel and you may be ineligible if you currently have or have opened the Wells Fargo Active Cash Visa within the last 48 months.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://apply.wellsfargo.com/getting_started?FPID=0126D7I6F40000&applicationtype=consumercreditcard&product_code=CC&subproduct_code=AC&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "learn_more_link": "https://creditcards.wellsfargo.com/active-cash-credit-card/?FPID=0126D7I6F40000&product_code=CC&subproduct_code=AC&cx_nm=CXNAME_CSMPD_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/active-cash/terms/?FPID=0126D7I6F40000&product_code=CC&subproduct_code=AC&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [],
  "bank_name": "Wells Fargo",
  "imageName": "active_cash_card.png"
},
  [CreditCard.HSBC_ELITE_CREDIT_CARD]: {
  "id": CreditCard.HSBC_ELITE_CREDIT_CARD,
  "name": "HSBC Elite World Elite Mastercard\u00ae credit card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.us.hsbc.com/content/dam/hsbc/us/images/tile-16-9/14388-hsbc-elite-mastercard-left-cropped-hex-1600x900.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "5x Points on new travel purchases, including flights, hotels, and car rentals. No travel portal booking requirement stated.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x Points at restaurants and dining out.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x Points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 495.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2424,
    "apr_low": 0.2024
  },
  "annualFee": 495.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2424,
    "description": "Variable purchase APR: 0.2024\u20130.2424 based on creditworthiness. Variable balance transfer APR: 0.2024\u20130.2424. Cash advance APR: 0.2924. APRs vary with the Prime Rate (maximum 0.2999). Minimum interest charge $1. Balance transfer/check/cash advance transaction fee: greater of $10 or 0.05 of the amount. No foreign transaction fee."
  },
  "benefits": [
    {
      "name": "HSBC Travel Credit (up to $400/yr)",
      "description": "Automatic $100 statement credit for each $2,000 in cumulative travel purchases (airfare, hotels, car rentals) booked through HSBC Travel, up to $400 per calendar year. Est. value: up to $400/yr if you book $8,000 of eligible travel via HSBC Travel.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": 2000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry / TSA PreCheck / NEXUS / TSA PreCheck by CLEAR Credit",
      "description": "Up to $120 statement credit for the application fee for the first eligible program that posts, once every 54 months (4.5 years). Est. value \u2248 $26.67 per year on average.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass Lounge Access",
      "description": "Complimentary, unlimited airport lounge access via Priority Pass for the cardholder and up to 2 guests. HSBC notes value of more than $469 annually. Lounge visit fees may apply at some locations; enrollment/activation may be required.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rewards for Miles (Points Transfer Partners)",
      "description": "Transfer HSBC points to 11 airline and 2 hotel loyalty programs. Transfers may take up to 14 days; conversion rates vary by partner.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "MasterRental Coverage",
      "description": "Collision damage waiver coverage for rental cars when you pay with the card. See Guide to Benefits for terms, limits, and exclusions.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Travel Insurance",
      "description": "Travel protections available per the Guide to Benefits (coverage types, limits, and exclusions apply).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24/7 Concierge Service (Aspire Lifestyles)",
      "description": "Unlimited concierge assistance for travel, dining, shopping, entertainment, and special arrangements.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rideshare/Taxi Monthly Credit",
      "description": "Up to $10 in statement credits each month on purchases coded MCC 4121 (limousines and taxicabs), up to $120 per calendar year. Est. value: up to $120/yr if used monthly.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Instacart+ Membership Offer (new members)",
      "description": "Up to $140 annually: 3 free months of Instacart+ plus $10 off your second qualifying order of $10+ each month. Offer for eligible cardholders new to Instacart+; expires 01/31/2027. Est. value up to $140/yr if fully used.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary ShopRunner Membership",
      "description": "Free ShopRunner membership (2-day shipping and returns at participating merchants). Mastercard offer valid through 9/30/2025. Est. value: $79/yr.",
      "benefit_type": null,
      "new_benefit_type": "shoprunner_membership",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Lyft Take 3, Get $5 Monthly Credit",
      "description": "Get a $5 Lyft app credit each month after taking 3 Lyft rides paid with the card. Limit 1 credit per month; credits expire 30 days after application. Program runs through 1/31/2026. Est. value: up to $60/yr if qualified monthly.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Assurance",
      "description": "Covers most purchases against damage or theft within 90 days of purchase, up to $1,000. Terms and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Wireless Telephone Protection",
      "description": "Coverage up to $800 if your cell phone is stolen or damaged. Terms, conditions, and exclusions apply (see Guide to Benefits).",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection and Identity Fraud Expense Reimbursement",
      "description": "Support and expense reimbursement if your identity is compromised through identity fraud; registration may be required. Terms and exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry / TSA PreCheck / NEXUS / TSA PreCheck by CLEAR Credit",
      "description": "Up to $120 statement credit for the application fee for the first eligible program that posts, once every 54 months (4.5 years). Est. value \u2248 $26.67 per year on average.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "HSBC Travel Credit",
      "description": "Automatic $100 credit per $2,000 in eligible travel booked via HSBC Travel, up to $400 per calendar year.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 400.0,
      "value_unit": "dollars",
      "spend_requirement": 2000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Rideshare/Taxi Monthly Credit",
      "description": "Up to $10 in statement credits each month on MCC 4121 (limousines and taxicabs), up to $120 per year.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 10.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Global Entry/TSA PreCheck/NEXUS Credit",
      "description": "Up to $120 application fee credit every 54 months for one eligible program.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Lyft Take 3, Get $5",
      "description": "$5 Lyft app credit each month after 3 rides, through 1/31/2026.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 5.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 HSBC Welcome Bonus Points after $4,000 in purchases within the first 3 months of account opening. Advertised as worth up to $900 in travel when booked through HSBC Travel. Excludes upgrades/transfers and non-purchase transactions; must be open/in good standing; allow 4\u20136 weeks after promo period; not available if you opened the same card within the last 36 months.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.us.hsbc.com/credit-cards/products/elite/#apply",
  "learn_more_link": "https://www.us.hsbc.com/credit-cards/products/elite/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "HSBC",
  "imageName": "hsbc_elite_credit_card.jpg"
},
  [CreditCard.NAVYIST_REWARDS_MASTERCARD]: {
  "id": CreditCard.NAVYIST_REWARDS_MASTERCARD,
  "name": "Navyist Rewards Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/ON_card_NEW_Enth_MC_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "not_available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BARCLAYCARD_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "gap",
      "earnRate": 5.0,
      "description": "Earn 5 points per $1 spent at Gap, Banana Republic, Old Navy, and Athleta when you use your Navyist Rewards Mastercard as the sole payment method. Points are redeemable across Gap Inc. brands; no merchandise restrictions noted.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "banana_republic",
      "earnRate": 5.0,
      "description": "Earn 5 points per $1 spent at Gap, Banana Republic, Old Navy, and Athleta when you use your Navyist Rewards Mastercard as the sole payment method. Points are redeemable across Gap Inc. brands; no merchandise restrictions noted.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "old_navy",
      "earnRate": 5.0,
      "description": "Earn 5 points per $1 spent at Gap, Banana Republic, Old Navy, and Athleta when you use your Navyist Rewards Mastercard as the sole payment method. Points are redeemable across Gap Inc. brands; no merchandise restrictions noted.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "athleta",
      "earnRate": 5.0,
      "description": "Earn 5 points per $1 spent at Gap, Banana Republic, Old Navy, and Athleta when you use your Navyist Rewards Mastercard as the sole payment method. Points are redeemable across Gap Inc. brands; no merchandise restrictions noted.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point per $1 on all Mastercard purchases made outside the Gap Inc. family of brands.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.3399
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3399,
    "high": 0.3399,
    "description": "APR for purchases, balance transfers, and cash advances is 33.99% variable; this APR will vary with the market based on the Prime Rate (when using your Mastercard)."
  },
  "benefits": [
    {
      "name": "Free shipping on online orders $50+",
      "description": "Must be signed into your online account. Valid on orders totaling at least $50 after discounts and before taxes shipped anywhere in the U.S. (including Puerto Rico) to a single address. Eligible program members receive free Standard shipping; Icon members receive free Express shipping on orders of $50 or greater. See Reward Program Terms for details and any eligibility restrictions.",
      "benefit_type": null,
      "new_benefit_type": "free_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early access to select sales",
      "description": "Eligible program members may receive early access to select sales; additional terms and conditions may apply.",
      "benefit_type": null,
      "new_benefit_type": "early_access_sales",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 liability for unauthorized charges",
      "description": "You are not responsible for charges you did not authorize.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_fraud_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Donate rewards to select charities",
      "description": "Eligible program members can convert rewards to dollars to donate to select organizations. 100 points = $1 donation dollar. Subject to program caps and terms.",
      "benefit_type": null,
      "new_benefit_type": "points_to_charity",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "30% off your first Old Navy purchase when you open a new Navyist Rewards Credit Card or Navyist Rewards Mastercard account and use the new card as the sole payment method. Discount applies in-store the same day for in-store account openings; online discount code expires at 11:59 pm PT fourteen (14) days from account opening. Valid only in the U.S. (including Puerto Rico). One account-opening discount per account. Cannot be combined with the Family of Brands Discount or Gap Inc. employee discount; can be combined with other eligible offers. Excludes gift cards, shipping, taxes, and merchandise sold and shipped by third-party sellers. Not valid at other Gap Inc. brands. Estimated value: equals 30% of your eligible first purchase amount (e.g., $15 on a $50 purchase, $30 on $100, $60 on $200); no maximum specified in the provided terms.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percent_discount",
          "amount": 30.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "navyist_rewards_mastercard.png"
},
  [CreditCard.DISCOVER_IT_CHROME_GAS_RESTAURANT_CREDIT_CARD]: {
  "id": CreditCard.DISCOVER_IT_CHROME_GAS_RESTAURANT_CREDIT_CARD,
  "name": "Discover it\u00ae Chrome Gas & Restaurant Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://www.discover.com/content/dam/discover/en_us/credit-cards/card-acquisitions/grey-redesign/global/images/cardart/cardart-cash-chrome-platinum-620-382.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 2.0,
      "description": "Earn 2% cash back at gas stations and restaurants on up to $1,000 in combined purchases each quarter; no activation required. Excess spend and all other categories earn the base rate.",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "gas",
          "dining"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Gas stations and restaurants earn 2% cash back with a combined quarterly cap; rewards post automatically with no activation required.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn unlimited 1% cash back on all purchases (base rate). Purchases in 2% categories earn 2% until the combined quarterly cap is reached, then 1% thereafter.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2724,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2724,
    "description": "0.0 intro APR for 15 months on purchases; then 0.1824\u20130.2724 variable. Balance transfers: 0.0 intro APR for 15 months, then purchase APR applies (0.1824\u20130.2724 variable). Cash advance APR: 0.2924 variable. Minimum interest charge: $0.50. Balance transfer fee: 0.03 intro until 2025-12-10; then 0.05 for future transfers. Cash advance fee: greater of $10 or 0.05 of the advance amount. Annual fee: $0. Rates as of 2025-08-29."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Unlimited Cashback Match: Discover will automatically match all the cash back you earn at the end of your first year as a cardmember. No activation or minimum spend required; no cap on the match. Example estimate: if you earn $150 in cash back during the first 12 months from your regular spend, Discover will match $150, for $300 total cash back.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": null,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.discovercard.com/application/website/apply?srcCde=GJVR&ICMPGN=ALL_CC_GAS_AND_RESTAURANT_APPLY_NOW_BTN&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "learn_more_link": "https://www.discover.com/credit-cards/cash-back/chrome.html?ICMPGN=ALL_CC_GAS_AND_RESTAURANT_LEARN_MORE",
  "terms_and_conditions_link": "https://www.discovercard.com/application/website/ratesrewards?srcCde=GJVR&adobe_mc=TS%3D1758990184%7CMCMID%3D20501890631132972703094407262038999682%7CMCORGID%3D0D6C4673527839230A490D45%2540AdobeOrg",
  "terms_and_conditions_button_text": "\u2020See rates, rewards, fees, and other cost information > , Opens new window",
  "additional_links": [
    {
      "name": "Reviews",
      "url": "https://www.discover.com/credit-cards/cash-back/chrome/reviews/#all-reviews"
    }
  ],
  "bank_name": "Discover",
  "imageName": "discover_it_chrome_gas_restaurant_credit_card.png"
},
  [CreditCard.AAA_DAILY_ADVANTAGE_VISA_SIGNATURE]: {
  "id": CreditCard.AAA_DAILY_ADVANTAGE_VISA_SIGNATURE,
  "name": "AAA Daily Advantage Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/aaa_daily_advantage_visa_signature.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "grocery",
      "earnRate": 5.0,
      "description": "5% cash back at grocery stores. Subject to combined $500/year cash back cap with gas and wholesale clubs.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "combined_cap_with_gas_and_wholesale"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, wholesale clubs, streaming services, pharmacy, and AAA purchases. Gas and wholesale club portions subject to combined $500/year cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "combined_cap_with_grocery_and_wholesale"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.evCharging",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, wholesale clubs, streaming services, pharmacy, and AAA purchases. Gas and wholesale club portions subject to combined $500/year cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "combined_cap_with_grocery_and_wholesale"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "wholesaleClub",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, wholesale clubs, streaming services, pharmacy, and AAA purchases. Gas and wholesale club portions subject to combined $500/year cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "combined_cap_with_grocery_and_wholesale"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, wholesale clubs, streaming services, pharmacy, and AAA purchases. Gas and wholesale club portions subject to combined $500/year cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "combined_cap_with_grocery_and_wholesale"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "pharmacy",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, wholesale clubs, streaming services, pharmacy, and AAA purchases. Gas and wholesale club portions subject to combined $500/year cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "combined_cap_with_grocery_and_wholesale"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3174,
    "apr_low": 0.1774
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1774,
    "high": 0.3174,
    "description": "Variable Purchase and Balance Transfer APRs of 17.74% - 31.74% based on creditworthiness and the Prime Rate. Variable Cash Advance APR of 32.74%."
  },
  "benefits": [
    {
      "name": "No Annual Fee",
      "description": "No annual fee for the life of the card.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Flexible Cash Back Redemption",
      "description": "Cash back can be redeemed as statement credits, direct deposit, rewards, and qualifying purchases at participating AAA locations.",
      "benefit_type": null,
      "new_benefit_type": "flexible_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $100 statement credit when you spend $1,000 within the first 90 days of account opening. Valid one time only; credit received within 1-2 billing cycles after qualifying spend.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://d.comenity.net/aaa/common/AAADAILY/home.xhtml",
  "learn_more_link": "https://d.comenity.net/aaa/common/AAADAILY/home.xhtml",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Comenity",
  "imageName": "aaa_daily_advantage_visa_signature.webp"
},
  [CreditCard.US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD]: {
  "id": CreditCard.US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD,
  "name": "U.S. Bank Altitude\u00ae Connect Visa Signature\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/us_bank_altitude_connect_visa_signature_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.US_BANK_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5x points per $1 on prepaid car and hotel reservations purchased in the Altitude Rewards Center using the card (cash/points mix allowed; 5x applies to the cash portion). If canceled or refunded, bonus points may be reversed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5x points per $1 on prepaid car and hotel reservations purchased in the Altitude Rewards Center using the card (cash/points mix allowed; 5x applies to the cash portion). If canceled or refunded, bonus points may be reversed.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 4.0,
      "description": "4x points per $1 on travel purchases made directly with airlines, hotels, car rentals, taxicabs, limousines, passenger trains, and cruise line companies.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 4.0,
      "description": "4x points per $1 on the first $1,000 in combined purchases each quarter at gas stations and EV charging stations; purchases over $1,000 in the same quarter earn 1x. Purchases at wholesale clubs, discount stores/supercenters, and grocery stores/supermarkets earn 1x.",
      "spendCap": 1000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "gas"
            ],
            "exclude_subcategories": [
              "wholesaleClub",
              "grocery",
              "walmart",
              "target"
            ],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas station and electric vehicle charging station purchases. Purchases made at discount stores/supercenters, wholesale clubs, and grocery stores/supermarkets are excluded from the bonus and earn 1x."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Gas stations and EV charging stations (excludes purchases at discount stores/supercenters, wholesale clubs, and grocery stores).",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2x points per $1 at grocery stores and supermarkets. Purchases at discount stores/supercenters such as Target and Walmart and at wholesale clubs earn 1x.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x points per $1 at restaurants, fast-food restaurants, and bars.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "2x points per $1 on qualifying streaming subscription services. Qualifying services include: Amazon Music Unlimited, Amazon Prime Video, AMC+, Apple Music, Apple TV+, Audible, DirecTV Stream, Discovery+, Disney+, ESPN+, Fandango at Home, FanDuel Sports Network, Fubo TV, Max (HBO Max), Hulu, iHeart, LiveOne, Luminary, MLB TV, NBA League Pass, Netflix, Pandora, Paramount+, Peacock, Showtime, SiriusXM, Sling TV, Spotify, Starz, Stitcher, Tidal, YouTube Music, YouTube Premium, and YouTube TV.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other eligible net purchases. Excludes non-purchase transactions such as balance transfers, cash advances (including ATM withdrawals, wire transfers, traveler\u2019s checks, money orders, foreign cash transactions, betting/lottery), fees and interest, credit insurance premiums, certain prepaid card funding, U.S. Mint purchases, and other cash-equivalents.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2799,
    "apr_low": 0.1799
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1799,
    "high": 0.2799,
    "description": "0% intro APR on purchases for 15 billing cycles; then variable 17.99%\u201327.99% based on creditworthiness (varies with Prime Rate). Balance transfers: 0% for 15 billing cycles if transferred within 60 days of account opening; then 17.99%\u201327.99% variable. Cash advance APR 30.99%. No penalty APR. Minimum interest charge $1."
  },
  "benefits": [
    {
      "name": "Transfer points between eligible U.S. Bank Altitude accounts",
      "description": "Transfer Points to other qualifying U.S. Bank Altitude Connect or Altitude Go credit card accounts via the Rewards Center or by phone. Both accounts must be open and in good standing. Outbound transfers are limited to 20,000 Points per calendar year; inbound transfers you may accept are also limited to 20,000 Points per calendar year. All transfers are final.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Transfer points to participating travel loyalty programs",
      "description": "Transfer Points to participating airline/hotel travel loyalty programs through the Rewards Center. The name on your credit card account must match the partner loyalty account. Transfer ratios may vary by partner and over time; most transfers complete by the next business day (up to 72 hours). Transfers are final and may be subject to bank-imposed limits on amount and frequency.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Real-Time Rewards instant redemption via text",
      "description": "Enroll to instantly redeem Points for eligible purchases via text message; a statement credit posts within about three business days. U.S. merchants only; you must have enough Points to cover the full purchase. Example preset minimums include $150 for lodging and $150 for car rentals. Redemptions are final and reduce your balance but do not count toward the minimum payment due.",
      "benefit_type": null,
      "new_benefit_type": "real_time_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "100% match on charitable contribution redemptions",
      "description": "When you redeem Points toward a monetary charitable contribution through the Rewards Center, U.S. Bank will match your contribution 100% (no cap). The named charity may vary. Contributions may not be tax deductible\u2014consult a tax advisor.",
      "benefit_type": null,
      "new_benefit_type": "charitable_contribution_match",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://onboarding.usbank.com/consumer/cards/8BB5BD89H1/18569/87106/start",
  "learn_more_link": "https://www.usbank.com/content/usbank/us/en/credit-cards/altitude-connect-visa-signature-credit-card",
  "terms_and_conditions_link": "https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=18569&offerId=8BB5BD89H1&sourceCode=88416",
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Program Rules",
      "url": "https://rewards.usbank.com/benefits/card/AltitudeConnectBenefits/program-rules"
    }
  ],
  "bank_name": "US Bank",
  "imageName": "us_bank_altitude_connect_visa_signature_card.png"
},
  [CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE]: {
  "id": CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE,
  "name": "Bank of America\u00ae Premium Rewards\u00ae Elite Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/prmeltcm_v_infinite_250px.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.BANK_OF_AMERICA_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2 points per $1 (1.5 base + 0.5 bonus) on purchases that code as Travel. Travel includes airlines; hotels/motels; timeshares; trailer parks; RV rentals; campgrounds; car, truck and trailer rentals; cruise lines; travel agencies and tour operators; passenger trains, buses, taxis and limousines; ferries; boat rentals; parking lots/garages; tolls/bridge fees; and tourist attractions/exhibits (e.g., art galleries, amusement parks, carnivals, circuses, aquariums, zoos). Purchases that do not transmit a qualifying MCC (e.g., some in\u2011flight purchases, duty\u2011free) earn 1.5 points. No spend cap. Preferred Rewards members earn an extra 25%\u201375% on every purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2 points per $1 (1.5 base + 0.5 bonus) on purchases that code as Dining. Dining includes restaurants (including fast food), caterers, and drinking establishments such as bars and taverns. Transactions that don\u2019t transmit a qualifying MCC earn 1.5 points. No spend cap. Preferred Rewards members earn an extra 25%\u201375% on every purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5 points per $1 on all net purchases; applies to non\u2011travel/non\u2011dining purchases and to travel/dining transactions that don\u2019t code in the eligible MCCs. No spend cap. Preferred Rewards members earn an extra 25%\u201375% on every purchase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 550.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 550.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable purchase APR 0.2024\u20130.2824 based on Prime Rate; no intro APR. Balance transfer APR 0.2024\u20130.2824 (variable). Cash advance APR 0.2324\u20130.2924 for Direct Deposit/Check and 0.2924 for Bank Cash Advances. Penalty APR up to 0.2999. At least 25-day grace period on purchases if paid in full; balance transfers and cash advances accrue interest from the transaction date."
  },
  "benefits": [
    {
      "name": "Airline incidental statement credit",
      "description": "Receive up to $300 in statement credits each calendar year for qualifying airline incidental fees (e.g., seat upgrades, ticket change/cancellation fees, checked baggage, in-flight purchases, and eligible airline lounge fees) on select U.S.-domestic carriers. Excludes airfare, mileage purchases/transfers, gift cards, duty-free, award tickets, and certain carriers (Allegiant, Spirit, Sun Country). Credits typically post in 2\u20133 weeks. Estimated value: up to $300/year if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Lifestyle statement credit",
      "description": "Receive up to $150 in statement credits each calendar year for purchases at select merchants in categories such as rideshare, food delivery, video streaming services, and fitness. Merchant eligibility determined by MCC/identifiers; credits typically post in 2\u20133 weeks. Estimated value: up to $150/year if fully used.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "TSA PreCheck or Global Entry application fee credit",
      "description": "Get up to $120 in statement credits per account every four years for TSA PreCheck or Global Entry application fees when paid with the card. Estimated long-run value: averages ~$30/year across a 4-year cycle.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass Select lounge access",
      "description": "Complimentary Priority Pass Select lounge access with up to 4 enrollable memberships for the life of the account; unlimited visits for members and accompanying guests at participating lounges/experiences (access and guesting may vary by lounge and capacity). Memberships auto-renew annually while the benefit is offered. Estimated retail reference: Priority Pass Prestige is ~${469}/year per person; actual value depends on usage.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Airfare discount when redeeming points",
      "description": "Receive 20% off the cost of airfare when redeeming points via the Bank of America Travel Center or through the concierge (discount applies only to the portion paid with points). Example: 80,000 points covers a $1,000 flight (vs. 100,000 normally), implying an effective 1.25\u00a2 per point on the points-applied portion.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Full-service Visa Infinite concierge",
      "description": "24/7 complimentary concierge assistance for travel, dining, entertainment, and experiences. Cardholder pays for goods/services booked.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Luxury Hotel Collection perks",
      "description": "Benefits at participating luxury hotels such as daily breakfast for two, potential room upgrades, late checkout, and other VIP amenities (benefits vary by property and availability).",
      "benefit_type": null,
      "new_benefit_type": "visa_infinite_luxury_hotel_collection_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car rental partner status/amenities",
      "description": "VIP amenities, complimentary status upgrades and discounts with Avis, Hertz, and National. Benefits and availability vary by partner/location.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip cancellation/interruption coverage",
      "description": "Coverage assistance for trip cancellations and interruptions. See benefit guide for covered reasons, limits, and terms.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip delay, emergency evacuation and transportation, roadside assistance",
      "description": "Travel protections including trip delay assistance, emergency evacuation and transportation, and roadside assistance. Coverage details and limits vary; see guide to benefits.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage delay insurance",
      "description": "Assistance/coverage for baggage delays. Coverage amounts and waiting periods apply; see guide to benefits.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost luggage reimbursement",
      "description": "Reimbursement for lost luggage subject to coverage limits and terms. See guide to benefits for details.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred Rewards points boost",
      "description": "Bank of America Preferred Rewards members earn 25%\u201375% more points on every purchase (e.g., up to 3.5x on travel & dining; up to 2.62x on other purchases).",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Airline incidental statement credit",
      "description": "Up to $300 in statement credits each calendar year for qualifying airline incidental fees (U.S.-domestic carriers; exclusions apply).",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 300.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Lifestyle statement credit",
      "description": "Up to $150 in statement credits each calendar year for select rideshare, food delivery, video streaming services, and fitness purchases (merchant eligibility by MCC/identifier).",
      "credit_category": null,
      "new_credit_category": "lifestyle (rideshare, food delivery, streaming, fitness)",
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "TSA PreCheck / Global Entry credit",
      "description": "Up to $120 in statement credits per account every 4 years for TSA PreCheck or Global Entry application fees.",
      "credit_category": null,
      "new_credit_category": "tsa_pre_global_entry",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "75,000 online bonus points (worth $750 at 1\u00a2/point) after making at least $5,000 in purchases in the first 90 days of account opening. Purchases only (no balance transfers or cash advances); returns/credits reduce qualifying spend. Limit 1 per new account; account must be open and in good standing; points typically post within 1\u20132 billing cycles.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 75000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076454&productOfferCode=6A&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/premium-rewards-elite-credit-card/?campaign=4076454~6A~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076454&productoffercode=6A&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Premium Rewards\u00ae Elite credit card",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://www.bankofamerica.com/credit-cards/products/premium-rewards-elite-credit-card/?campaign=4076454~6A~en_US#headlineCcalcModule"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_premium_rewards_elite.png"
},
  [CreditCard.CITI_PRO_XTRA_CREDIT_CARD]: {
  "id": CreditCard.CITI_PRO_XTRA_CREDIT_CARD,
  "name": "Pro Xtra\u00ae Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-home-depot-pro-xtra/citi-home-depot-pro-xtra_222x140.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "homeImprovement.homeDepot",
      "earnRate": 4.0,
      "description": "4x Pro Xtra rewards on The Home Depot purchases (in-store and online). Store card; usable only at The Home Depot and HomeDepot.com.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Extended return window (Hassle-Free Returns)",
      "description": "Cardmembers get 1-year Hassle-Free Returns (4X longer to make returns) on eligible Home Depot purchases. Refer to The Home Depot Returns Policy for details.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Limited-time offer: Save up to $100 on your first qualifying purchase when you open a new Pro Xtra Credit Card. Discount applies to the first qualifying Home Depot purchase; actual value depends on purchase amount and offer terms.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.homedepot.com/auth/view/signin?redirect=/myaccount/commercialsavecardtoprofile?crc=true&cardType=PLCR_HOMEDEPOT&originUrl=https://www.homedepot.com/c/Credit_Center&step=initial&insideCheckout=false&siteId=PLCR_HOMEDEPOT&cmp=W~P~V~0~Z~E~ZZZ1~CR",
  "learn_more_link": "https://www.citi.com/credit-cards/home-depot-pro-xtra-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/home-depot-pro-xtra-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_pro_xtra_credit_card.png"
},
  [CreditCard.GREENSTATE_CU_WORLD_MASTERCARD]: {
  "id": CreditCard.GREENSTATE_CU_WORLD_MASTERCARD,
  "name": "GreenState CU World Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/greenstate_cu_world_mastercard.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5x points on hotel purchases. Based on MCC codes 3501-3834. Some smaller hotels may not code correctly as hotel and would earn at the base rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "5x points on airline purchases. Based on MCC codes 3000-3299 and 4511.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x points on gas and EV charging purchases. Based on MCC codes 5169, 5172, 5541, 5542.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.evCharging",
      "earnRate": 2.0,
      "description": "2x points on gas and EV charging purchases. Based on MCC codes 5169, 5172, 5541, 5542.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.greenstate.org/credit-cards/mastercards/world-mastercard",
  "learn_more_link": "https://www.greenstate.org/credit-cards/mastercards/compare-credit-cards",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "GreenState CU",
  "imageName": "greenstate_cu_world_mastercard.png"
},
  [CreditCard.CITI_REWARDS_STUDENT_CREDIT_CARD]: {
  "id": CreditCard.CITI_REWARDS_STUDENT_CREDIT_CARD,
  "name": "Citi Rewards+\u00ae Student Credit Card",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-rewards-plus-student/citi-rewards-plus-student_171x108.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "5X ThankYou Points on travel booked through Citi Travel, up to $6,000 per year.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2X ThankYou Points at gas stations, up to $6,000 per year; then 1X.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2X ThankYou Points at supermarkets, up to $6,000 per year; then 1X.",
      "spendCap": 6000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X ThankYou Points on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "10% Points Back",
      "description": "Get 10% of your ThankYou Points back when you redeem, up to the first 100,000 points redeemed per year.",
      "benefit_type": null,
      "new_benefit_type": "points_rebate",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment",
      "description": "Get special access to purchase tickets to thousands of events, including presale tickets and exclusive experiences for concerts, sporting events, dining experiences and more.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard ID Theft Protection",
      "description": "Complimentary identity theft monitoring and alerts from Mastercard after enrollment.",
      "benefit_type": null,
      "new_benefit_type": "id_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "Earn 5,000 bonus ThankYou Points after spending $500 on purchases within the first 3 months of account opening.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 5000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://online.citi.com/US/ag/cards/application?app=COLLEGE&HKOP=56e6eef64aae0280068f87cf3329f05da77cb369fa981ef2590abf16700a2f4b&ID=3000&ProspectID=P4z5Ggnj8VBvYAKNEBi2vWBablUnnBPI&intc=citihpmenu~creditcards~vac&pid=408&category=view-all-credit-cards&afc=161",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-rewards-plus-student-credit-card?category=view-all-credit-cards&intc=citihpmenu~creditcards~vac&afc=161",
  "terms_and_conditions_link": "https://online.citi.com/US/ag/cards/displayterms?app=COLLEGE&HKOP=56e6eef64aae0280068f87cf3329f05da77cb369fa981ef2590abf16700a2f4b",
  "terms_and_conditions_button_text": "Important Pricing & Information+",
  "additional_links": [],
  "bank_name": "Citi",
  "imageName": "citi_rewards_student_credit_card.png"
},
  [CreditCard.CITI_EXXON_MOBIL_SMART_CARD_CREDIT_CARD]: {
  "id": CreditCard.CITI_EXXON_MOBIL_SMART_CARD_CREDIT_CARD,
  "name": "Exxon Mobil Smart Card+\u2122 Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-exxon-mobil/citi-exxon-mobil_222x140.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "exxon",
      "earnRate": 5.0,
      "description": "Get 5% back as a statement credit on qualifying non\u2011fuel purchases (drinks, snacks, car washes, and more) at participating Exxon and Mobil stations. Earnings apply to the first $1,200 in non\u2011fuel purchases per year; statement credits are applied monthly.",
      "spendCap": 1200.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "mobil",
      "earnRate": 5.0,
      "description": "Get 5% back as a statement credit on qualifying non\u2011fuel purchases (drinks, snacks, car washes, and more) at participating Exxon and Mobil stations. Earnings apply to the first $1,200 in non\u2011fuel purchases per year; statement credits are applied monthly.",
      "spendCap": 1200.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Per-gallon fuel savings at Exxon and Mobil",
      "description": "Instant savings at the pump when you pay with the card: save 10\u00a2/gal on regular, mid-grade and diesel; save 12\u00a2/gal on Synergy Supreme+ premium. No cap mentioned in the provided materials. Example value: ~480 gallons/year on regular fuel would save about $48/year at 10\u00a2/gal; all-premium at 12\u00a2/gal would be about $57.60/year (actual value varies with gallons purchased).",
      "benefit_type": null,
      "new_benefit_type": "fuel_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "5% back on in-store purchases and car washes at Exxon and Mobil",
      "description": "Earn 5% back as a statement credit on the first $1,200 in eligible non-fuel purchases per year at participating Exxon and Mobil stations (drinks, snacks, car washes, etc.). Max annual value: $60 (calculated as 5% of $1,200).",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$0 liability on unauthorized charges",
      "description": "You are not responsible for unauthorized charges made on your account.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Stacks with select grocery fuel rewards programs (where available)",
      "description": "Exxon Mobil Smart Card+ fuel savings can combine with Albertsons for U, Safeway for U, ACME for U, Shaw\u2019s for U and Star Market for U discounts where available.",
      "benefit_type": null,
      "new_benefit_type": "fuel_rewards_stacking",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Citi",
  "imageName": "citi_exxon_mobil_smart_card_credit_card.png"
},
  [CreditCard.SPARK_15_CASH_SELECT]: {
  "id": CreditCard.SPARK_15_CASH_SELECT,
  "name": "Spark 1.5% Cash Select",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/spark_15_cash_select.avif",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5% cash back on all purchases with no limits or category restrictions.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on hotels and rental cars booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Unlimited 5% cash back on hotels and rental cars booked through Capital One\u2019s travel booking site.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2349,
    "apr_low": 0.1749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1749,
    "high": 0.2349,
    "description": "17.49% - 23.49% variable APR based on your creditworthiness."
  },
  "benefits": [
    {
      "name": "Extended warranty protection",
      "description": "Get free additional warranty and protection on eligible items purchased with the card. Coverage details per Guide to Benefits. Value depends on eligible purchases and claims; not estimated.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay zero foreign transaction fees on purchases made outside of the United States. Estimated savings example: typically 3% fee avoided\u2014about $30 saved per $1,000 in foreign purchases (actual savings depend on your foreign spend).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside assistance",
      "description": "Access services for auto-related emergencies (e.g., jump-start, tire change, towing). Service availability and potential per-use fees per program terms; value varies by use.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Business Travel portal access",
      "description": "Complimentary access to an all-in-one business travel management solution via Capital One Business Travel.",
      "benefit_type": null,
      "new_benefit_type": "business_travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Virtual card numbers",
      "description": "Create virtual card numbers to make safer online payments without exposing your actual card number.",
      "benefit_type": null,
      "new_benefit_type": "virtual_card_numbers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free employee cards",
      "description": "Add employee cards at no additional cost and earn rewards on their purchases.",
      "benefit_type": null,
      "new_benefit_type": "free_employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Employee card spend limits",
      "description": "Set customized spending limits for employee cards and view transactions as they post.",
      "benefit_type": null,
      "new_benefit_type": "employee_card_controls",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a one-time $750 cash bonus after spending $6,000 on purchases within the first 3 months from account opening. Per footnote, the bonus is available by starting the application process from the offer page and may not be available to existing or previous Capital One Business cardholders.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 750.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/small-business/credit-cards/spark-cash-select/",
  "learn_more_link": "https://www.capitalone.com/small-business/credit-cards/spark-cash-select/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "spark_15_cash_select.avif"
},
  [CreditCard.QUICKSILVER_REWARDS_FOR_GOOD_CREDIT]: {
  "id": CreditCard.QUICKSILVER_REWARDS_FOR_GOOD_CREDIT,
  "name": "Quicksilver Rewards for Good Credit",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/quicksilver_cardart.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Unlimited 1.5% cash back on all purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5% cash back on hotels, vacation rentals and rental cars when booked via Capital One Travel. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5% cash back on hotels, vacation rentals and rental cars when booked via Capital One Travel. No stated cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "Purchase APR 29.74% variable. No 0% intro APR. Balance transfer APR 29.74% variable."
  },
  "benefits": [
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making purchases outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Concierge Service",
      "description": "Personalized assistance in dining, entertainment and travel\u201424 hours a day, 365 days a year.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Additional warranty protection at no charge on eligible items purchased with the card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "24-hour Travel Assistance Services",
      "description": "If your credit card is lost or stolen, you can get an emergency replacement card and a cash advance.",
      "benefit_type": null,
      "new_benefit_type": "travel_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel Accident Insurance",
      "description": "Automatic insurance for a covered loss at no extra charge when you use your card to purchase your fare.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star Status",
      "description": "Complimentary Hertz Five Star status with enrollment via the Capital One benefits portal; skip the counter at select locations and choose from a wider selection of rental cars.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining Access",
      "description": "Access to cardholder-only reservations at award\u2011winning restaurants and tickets to curated culinary events.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment Access",
      "description": "Access to exclusive presales, tickets, and select experiences across music, sports and dining.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Access to Capital One Travel",
      "description": "Book through Capital One Travel with features like price drop protection (up to $50 travel credit when booking as recommended and price drops within 10 days), price match within 24 hours, price watch alerts, and flexible cancellation options (where available).",
      "benefit_type": null,
      "new_benefit_type": "capital_one_travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "50% off Handcrafted Beverages at Capital One Caf\u00e9s",
      "description": "Enjoy 50% off all handcrafted beverages every day at Capital One Caf\u00e9s when paying with a Capital One card; limits and availability apply.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/quicksilver-good-credit/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/quicksilver-good-credit/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "quicksilver_rewards_for_good_credit.png"
},
  [CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED]: {
  "id": CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED,
  "name": "Bank of America\u00ae Travel Rewards Secured Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8blm_trvcm_v_250x158.png",
  "recommendedMinCreditScore": "no_credit_history",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BANK_OF_AMERICA_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn unlimited 1.5 points per $1 on all purchases. Non-purchase transactions (e.g., balance transfers, cash advances, fees, interest, fraudulent transactions and certain other charges) do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.2824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2824,
    "high": 0.2824,
    "description": "Variable APRs: Purchases 0.2824 (variable based on Prime Rate). Balance transfers 0.2824 (variable; interest accrues from the transaction date; no intro APR). Cash advances 0.2924 (Direct Deposit/Check and Bank Cash Advances). Penalty APR up to 0.2999 may apply indefinitely to new transactions after a late payment. Grace period: at least 25 days; no interest on purchases if you pay your entire balance or Interest Saving Balance by the due date. Monthly Custom Pay Plan fee: 0.0172 of the amount assigned. Late payment fee up to $40. Balance transfer fee 0.04 of each transfer. Cash advance fees: 0.04 (Direct Deposit/Check) or 0.05 (ATM/OTC/Same-Day/Cash Equivalent)."
  },
  "benefits": [
    {
      "name": "Preferred Rewards points boost",
      "description": "Bank of America Preferred Rewards members earn 25%\u201375% more points on every purchase (1.87\u20132.62 points per $1), based on tier status.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076860&productoffercode=U8&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/travel-rewards-secured-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076860&productoffercode=U8&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Travel Rewards Visa\u00ae secured credit card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_travel_rewards_secured.png"
},
  [CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS]: {
  "id": CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS,
  "name": "Bank of America\u00ae Unlimited Cash Rewards Credit Card for Students",
  "cardType": "personal",
  "isCardForStudents": true,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cty_cshsigcm_v_250x157.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "Earn 1.5% cash back on all Net Purchases each billing cycle. Online-only introductory applications earn an extra 0.5% for the first 12 months (modeled via signup bonus fields) before reverting to the base 1.5%. No limit to the cash back you can earn and rewards do not expire as long as your account remains open. Balance Transfers, Cash Advances, fees, interest, fraudulent transactions and certain other charges do not earn rewards. Preferred Rewards members receive 25%-75% more cash back on base earnings (this Preferred Rewards bonus does not apply to the first-year additional 0.5% offer).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.875,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 2.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 2.625,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": 0.5,
      "signupBonusEarnRateIncreaseDurationMonths": 12
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "0.0 intro APR for first 15 billing cycles on purchases and on balance transfers made within 60 days of account opening; thereafter variable APR 0.1824-0.2824 based on creditworthiness (Prime-indexed). Cash advance APR 0.2124-0.2924 for Direct Deposit/Check and 0.2924 for Bank Cash Advances. Penalty APR up to 0.2999 may apply indefinitely after a late payment. At least 25-day grace period on purchases if paid in full; interest on balance transfers and cash advances accrues from the transaction date. Balance transfer fee 0.03 intro (first 60 days), then 0.04. Late fee up to $40. Optional Custom Pay Plan monthly fee 0.0172 of the amount assigned to the plan."
  },
  "benefits": [
    {
      "name": "Bank of America Preferred Rewards bonus (25%\u201375% more)",
      "description": "Preferred Rewards members earn 25%\u201375% more cash back on every purchase. Estimate: increases base 1.5% earn rate to 1.875% (Gold, +25%), 2.25% (Platinum, +50%), or 2.625% (Platinum Honors, +75%). Note: The Preferred Rewards bonus is NOT applied to the extra 0.5% first-year promotional earn.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Online $200 cash rewards bonus after making at least $1,000 in purchases in the first 90 days from account opening. Limit 1 per new account; account must be open and in good standing to receive. Estimated value: $200 cash (effectively 20% back on the first $1,000 in qualifying purchases).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Additional 0.5% cash rewards on all purchases for the first 365 days from account opening (raising total earn to 2.0% during the promo period). Preferred Rewards multiplier does NOT apply to this extra 0.5%. Estimated value examples: $5,000 year-one spend => $25 extra; $10,000 => $50 extra; $15,000 => $75 extra.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "additional_cash_back_rate",
          "amount": 0.5,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4076447&productoffercode=95&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-student-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076447&productoffercode=95&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Unlimited Cash Rewards credit card for Students",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_unlimited_cash_rewards_for_students.png"
},
  [CreditCard.AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD,
  "name": "Citi\u00ae / AAdvantage\u00ae Platinum Select\u00ae World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/aa-platinum-select/aa-platinum-select_90x57.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn 2 AAdvantage miles per $1 on purchases at restaurants. No stated cap or enrollment required. Also earns 1 Loyalty Point per eligible mile.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Earn 2 AAdvantage miles per $1 at gas stations. No stated cap or enrollment required. Also earns 1 Loyalty Point per eligible mile.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.american",
      "earnRate": 2.0,
      "description": "Earn 2 AAdvantage miles per $1 on eligible American Airlines purchases. No travel portal required; no stated cap. Also earns 1 Loyalty Point per eligible mile.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 AAdvantage mile per $1 on all other purchases not in bonus categories. Also earns 1 Loyalty Point per eligible mile.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1999
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2899,
    "description": "Standard variable APR for purchases and balance transfers is 0.1999\u20130.2899 based on creditworthiness. Cash advance APR is 0.2924 variable. Penalty APR up to 0.2999 may apply if you make a late or returned payment. Minimum interest charge $0.50. No intro 0% APR disclosed."
  },
  "benefits": [
    {
      "name": "First checked bag free",
      "description": "First checked bag free on domestic American Airlines itineraries for you and up to 4 companions traveling on the same reservation.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred boarding",
      "description": "Preferred boarding on American Airlines flights for you and up to 4 companions on the same reservation.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% savings on American Airlines inflight food and beverages",
      "description": "Receive 25% savings on in-flight food and beverage purchases when you use the card on American Airlines flights.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citi Entertainment presale and exclusive access",
      "description": "Access to purchase presale tickets and exclusive experiences for select concerts, sporting events, dining and more.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_presale_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn AAdvantage Loyalty Points from purchases",
      "description": "Earn 1 Loyalty Point for every 1 eligible AAdvantage mile earned from purchases to help qualify for AAdvantage status.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 2500.0,
      "spendRequirementMonths": 4,
      "description": "Limited-time offer: Earn 80,000 American Airlines AAdvantage miles after $3,500 in purchases within the first 4 months of account opening. Bonus not available if you have received a new account bonus for this card in the past 48 months or converted another Citi card into this card in the last 48 months. Offer available to U.S. residents and territories only, excluding Puerto Rico and U.S. Virgin Islands. Estimated value: about $1,040 assuming ~1.3 cents per mile (valuation varies by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-aadvantage-platinum-elite-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "american_airlines_aadvantage_platinum_select_world_elite_mastercard.webp"
},
  [CreditCard.ALLWAYS_REWARDS_VISA]: {
  "id": CreditCard.ALLWAYS_REWARDS_VISA,
  "name": "Allways Rewards Visa\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://secure.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/ragp_sigcm_v_250.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.ALLWAYS_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.allegiant",
      "earnRate": 3.0,
      "description": "Earn 3 Allways Points per $1 on eligible Allegiant travel and onboard purchases when processed by Allegiant as the merchant of record. Balance transfers, cash advances, fees, interest, and other non-purchase transactions do not earn Allways Points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Eligible Dining includes Caterers; Eating Places and Restaurants; and Drinking Places. Fast Food is excluded. Allegiant purchases do not qualify for this dining earn rate. Earn 2x Allways Points per $1 on qualifying dining.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 Allways Point per $1 on all other net purchases. Balance transfers, cash advances, fees, interest, fraudulent transactions, and certain other charges do not earn Allways Points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 59.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 59.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable APR. Purchases and balance transfers: 20.24%\u201328.24% variable based on Prime Rate. Cash advances: 23.24%\u201328.24% (Direct Deposit & Check) and 28.24% for Bank Cash Advances. Penalty APR up to 29.99%. No introductory APR. At least 25-day grace period on purchases if you pay your balance (or Interest Saving Balance) in full; interest on balance transfers and cash advances accrues from the transaction date."
  },
  "benefits": [
    {
      "name": "Buy One, Get One Free Airfare on Qualifying Allegiant Vacation Packages",
      "description": "Receive one companion airfare free when you purchase an Allegiant vacation package that includes either 4+ hotel nights or 7+ rental car days on the same itinerary. Must book through Allegiant Member Services, pay with the Allways Rewards Visa, and the primary cardholder must be a passenger. Both tickets must be booked and ticketed together; point redemptions are not eligible; canceling any part cancels both. Estimated value: roughly equal to the companion\u2019s base fare (taxes/fees may still apply), often $50\u2013$150+ roundtrip depending on route and fare.",
      "benefit_type": "bogo_flight_coupon",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Boarding and Priority Check-in on Allegiant",
      "description": "Present your Allways Rewards Visa to receive complimentary priority check-in and priority boarding on Allegiant flights. Estimated value: comparable to Allegiant\u2019s priority options typically priced around $10\u2013$20 per person each way.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "One Complimentary Inflight Beverage on Allegiant",
      "description": "Receive one free beverage on board every Allegiant flight when you present your card. Estimated value: about $6\u2013$10 per flight.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "Pay no foreign transaction fees on international purchases. Estimated value: saves about 3% versus cards that charge foreign transaction fees; value depends on your foreign spend.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1500.0,
      "spendRequirementMonths": 3,
      "description": "Online offer: Earn 30,000 Allways points after $1,500 in purchases within 90 days of account opening. Equal to $300 toward a future Allegiant trip when redeemed on Allegiant at an effective 1.0\u00a2 per point. Purchases only (annual fee, cash advances, and balance transfers excluded). Limit 1 bonus per new account. Account must be open and in good standing; bonus typically posts within 1\u20132 billing cycles. Value may be taxable (Form 1099 possible).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4071700&productoffercode=NH&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/allegiant-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4071700&productoffercode=NH&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Allways Rewards Visa\u00ae card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "allways_rewards_visa.png"
},
  [CreditCard.ALASKA_AIRLINES_BUSINESS_CREDIT_CARD]: {
  "id": CreditCard.ALASKA_AIRLINES_BUSINESS_CREDIT_CARD,
  "name": "Atmos\u2122 Rewards Visa Signature\u00ae Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www2.bac-assets.com/smallbusiness/credit-cards/spa-assets/images/assets-images-site-sb-credit-cards-card-arts-en-1bbt_bussigcm_v_atmos-CSXc2982f7d.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.ALASKA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.alaska",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible Alaska Airlines purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America small business account: 10% rewards bonus applied to base earnings for this category.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.hawaiian",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 on eligible Hawaiian Airlines purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America small business account: 10% rewards bonus applied to base earnings for this category.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Earn 2 points per $1 on eligible gas and EV charging station purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America small business account: 10% rewards bonus applied to base earnings for this category.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "shipping",
      "earnRate": 2.0,
      "description": "Earn 2 points per $1 on eligible shipping purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America small business account: 10% rewards bonus applied to base earnings for this category.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "Earn 2 points per $1 on eligible local transit purchases, including rideshare.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America small business account: 10% rewards bonus applied to base earnings for this category.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point per $1 on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.1,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Eligible Bank of America small business account: 10% rewards bonus applied to base earnings for this category.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 70.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 70.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable APR applies to purchases and balance transfers; range 0.2024\u20130.2824. No introductory APR."
  },
  "benefits": [
    {
      "name": "Annual $99 Companion Fare (anniversary)",
      "description": "Receive one Companion Fare for $99 (plus taxes and fees from $23) each account anniversary after spending $6,000 or more on purchases in the prior anniversary year. Typical value varies widely; often $150\u2013$400+ in savings depending on route and fare versus the $99+taxes you pay.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 6000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free checked bag on Alaska and Hawaiian",
      "description": "First checked bag free for the cardholder and up to 6 guests on the same reservation when the ticket is purchased with the card on Alaska Airlines or Hawaiian Airlines.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred boarding on Alaska",
      "description": "Preferred boarding on Alaska Airlines flights when you pay for your flight with the card.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "20% back on inflight purchases",
      "description": "Get 20% back on inflight purchases on Alaska Airlines and Hawaiian Airlines when you pay with the card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$100 off Alaska Lounge+ Membership",
      "description": "Receive $100 off the purchase of an annual Alaska Lounge+ Membership when purchased with the card.",
      "benefit_type": null,
      "new_benefit_type": "lounge_membership_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Travel accident insurance and assistance",
      "description": "Travel benefits include $1,000,000 travel accident insurance and emergency services (ticket replacement, lost-luggage assistance, legal/medical referrals).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto rental collision damage waiver",
      "description": "Coverage for rental cars when you pay with the card (issuer materials do not specify primary vs. secondary; this benefit is typically secondary\u2014see your Guide to Benefits).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase protection",
      "description": "Eligible purchases may be covered against loss, damage, theft, or fire (see Guide to Benefits for terms, caps, and time limits).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Extends eligible U.S. manufacturer warranties on covered purchases (see Guide to Benefits for eligible terms and caps).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% rewards bonus with eligible BoA business account",
      "description": "Earn a 10% bonus on points from card purchases if your company has an eligible Bank of America small business account.",
      "benefit_type": "bofa_small_business_account_10_percent_rewards_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No international transaction fees on purchases abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time online offer: Earn 80,000 bonus points plus one Companion Fare for $99 (plus taxes and fees from $23) after $5,000 in purchases within the first 90 days of opening your account. Estimated value: points roughly ~$1,040 assuming 1.3\u00a2/point; Companion Fare value varies by route, often ~$150\u2013$400+ net savings after paying $99 + taxes. Offer may not be available elsewhere if you leave the application page.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "points"
        },
        {
          "reward_type": "companion_fare_alaska_99_dollar",
          "new_reward_type": null,
          "amount": 1.0,
          "value_unit": "companion_fare_code"
        }
      ]
    }
  ],
  "apply_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/alaska-airlines-business-credit-card/?campaign=4075544~8B~en_US",
  "learn_more_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/products/alaska-airlines-business-credit-card/?campaign=4075544~8B~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/smallbusiness/credit-cards/#rates-fees-4075544~8B~en_US",
  "terms_and_conditions_button_text": "Interest Rates & Fees Summary\u2020",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "alaska_airlines_business_credit_card.png"
},
  [CreditCard.BANKAMERICARD_SECURED]: {
  "id": CreditCard.BANKAMERICARD_SECURED,
  "name": "BankAmericard\u00ae Secured Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8cae_nrwcm_mc_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2524,
    "apr_low": 0.2524
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2524,
    "high": 0.2524,
    "description": "Purchases: 25.24% variable APR based on the Prime Rate. Balance Transfers: 25.24% variable APR. Cash Advances: 28.24% (Direct Deposit and Check) and 29.24% (Bank Cash Advances). Penalty APR: None. Interest on balance transfers and cash advances accrues from the transaction date; at least a 25\u2011day grace period on purchases if the balance (or Interest Saving Balance) is paid in full by the due date."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076560&productOfferCode=VP&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/secured-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076560&productoffercode=VP&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for BankAmericard\u00ae secured credit card",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "bankamericard_secured.png"
},
  [CreditCard.BARCLAYS_G_M_REWARDS_MASTERCARD]: {
  "id": CreditCard.BARCLAYS_G_M_REWARDS_MASTERCARD,
  "name": "GM Rewards\u2122 Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/credit-card/gm/gm-consumer/GMR_LP_Card_Rewards_359x226.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GM_REWARDS_POINTS,
  "rewards_earn_rates": [
    {
      "category": "gm_purchases",
      "earnRate": 7.0,
      "description": "7x points per $1 on eligible GM purchases when using the GM Rewards Mastercard. GM Rewards membership tiers may add up to 3x additional points per $1 on GM purchases (per GM Rewards Program terms); this extra is program-based and not included in the earn_rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "3x points per $1 on all other purchases, including groceries, gas, restaurants, travel, and more. Eligible GM purchases earn 7x instead.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3299,
    "apr_low": 0.2299
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2299,
    "high": 0.3299,
    "description": "Variable purchase APR 0.2299\u20130.3299 based on creditworthiness; APRs vary with the Prime Rate. 0% intro APR for 9 billing cycles on qualifying GM purchases > $499 made within 30 days of account opening; 0% promotional APR for 6 billing cycles on qualifying GM purchases > $499 made after 30 days. Balance transfer APR 0.2299\u20130.3299 variable. Cash advance APR 0.3399. Minimum interest charge $1. Balance transfer fee 5% (min $5). Cash advance fee 5% (min $10). Foreign transaction fee 3%."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Bonus GM Rewards points after spending $1,000 in the first 90 days of account opening (amount not specified in provided content; see Terms & Conditions).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 30000,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/general-motors/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/general-motors/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "barclays_g_m_rewards_mastercard.jpg"
},
  [CreditCard.CHASE_UNITED_CLUB_INFINITE_CARD]: {
  "id": CreditCard.CHASE_UNITED_CLUB_INFINITE_CARD,
  "name": "United Club\u2120 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/chase_united_club_infinite_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.united",
      "earnRate": 4.0,
      "description": "4x miles on airline tickets purchased from United and on the following purchases made from United: seat upgrades, Economy Plus, inflight food/beverages/Wi\u2011Fi, baggage service charges, and other eligible United fees. Excludes other United-related purchases such as United Cruises, MileagePlus X, DIRECTV, and Merchandise Awards. United tickets booked via some discount travel websites or as part of a third\u2011party travel package will not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x miles on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2x miles on general travel purchases (excluding United purchases that qualify for the 4x United category).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x mile per $1 on all other purchases that do not fall into a higher earning category. Excludes non-purchase transactions (e.g., balance transfers, cash advances, cash-like transactions, fees, interest, etc.).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 695.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.2049
  },
  "annualFee": 695.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2049,
    "high": 0.2899,
    "description": "Variable APRs based on the Prime Rate (7.50% as of 03/25/2025). Purchase APR: 0.2049\u20130.2899 based on creditworthiness; Balance transfer APR: 0.2049\u20130.2899 (account may not be eligible for balance transfers); Cash advance APR: 0.2924; Penalty APR up to 0.2999 (may apply indefinitely after late/returned payment). Grace period: at least 21 days on purchases if paid in full; no minimum interest charge. Fees: Balance transfer fee 0.05 (min $5), Cash advance fee 0.05 (min $10), Late fee up to $40, Returned payment fee up to $40, Foreign transactions: none."
  },
  "benefits": [
    {
      "name": "United Club membership lounge access (primary cardmember)",
      "description": "Complimentary United Club card membership for the primary cardmember with access for one adult guest and dependent children under 18 on each visit. Star Alliance lounge access is not included with basic Club membership. Authorized users do not receive their own membership and may enter only when accompanying the primary cardmember as an eligible guest. Estimate: standalone United Club membership typically costs around $650\u2013$700/yr; included with the card.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "United Club All Access membership (earnable)",
      "description": "As of Aug 1, 2025, primary cardmember can earn United Club All Access membership by either: (a) spending $50,000 in net purchases on the card in a calendar year, or (b) earning Premier Gold status or higher. All Access allows access to United Clubs plus Star Alliance lounges and permits two adult guests (or one adult guest and dependents under 18). Membership is valid for the remainder of the year earned and the following year; must requalify each year via $50,000 spend or maintaining Premier Gold+.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": 50000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "United Club passes (anniversary; requires All Access and an AU)",
      "description": "Four United Club one-time passes are deposited into the primary cardmember\u2019s MileagePlus account after each cardmember anniversary if the primary cardmember has United Club All Access membership AND has an authorized user on the account at the time of anniversary. Each pass admits one person when the primary or an AU is admitted. Passes are non-transferable, subject to expiration, and require space availability.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": true
    },
    {
      "name": "Free first and second checked bags",
      "description": "Primary cardmember and one companion on the same reservation each receive their first AND second standard checked bags free on United- and United Express-operated flights. Ticket must be purchased with the card (waived for flights completed in the first 90 days after account opening). Oversize/overweight fees still apply. Estimate: domestic first bag ~$35 and second bag ~$45 each way; potential savings up to ~$160 per traveler on a round trip (prices vary).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premier Access priority services",
      "description": "Primary cardmember and companions on the same reservation receive Premier Access on United/United Express: designated check-in lanes, priority security (where available), priority boarding, and priority baggage handling.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on United inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on purchases of food, beverages, and Wi\u2011Fi on United/United Express flights and on premium drink purchases at United Clubs when paid with the card (including by authorized users). Credits typically post within 24 hours of the purchase posting.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry / TSA PreCheck / NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the first eligible application fee is charged to the card (primary or AU). Applies only to fees paid directly to the program administrators. Estimate: averages ~$30/year in value over a 4-year cycle if utilized.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% Saver Award discount (Economy within U.S./Canada)",
      "description": "Primary cardmember can book Economy Saver Awards (fare classes X/XN) on United/United Express with 10% fewer miles for itineraries within the continental U.S. or between the continental U.S. and Canada. Taxes/fees excluded; not valid on partners.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing discount (select itineraries)",
      "description": "On itineraries where the \u201cCardmembers Save\u201d banner appears, cardmember award pricing averaged 32% fewer miles vs. general members in 2024 (excludes taxes/fees). Savings vary and are controlled by United.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Award flight discount: 10,000-mile discount per $20,000 annual spend",
      "description": "Earn a 10,000-mile award flight discount for each $20,000 in purchases in a calendar year, up to 2 discounts per year (max at $40,000 spend). Discount applies when redeeming >10,000 miles for eligible United/United Express award flights; each discount expires 12 months after issue.",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Premier Qualifying Points (PQP) from spend",
      "description": "Earn 1 PQP per $15 in net purchases (including AU spend), up to a maximum of 28,000 PQP per calendar year. PQP apply toward Premier status up to Premier 1K.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "1,500 Card Bonus PQP each year",
      "description": "Receive 1,500 Card Bonus PQP within 6\u20138 weeks after February 1 each year. Account must be open as of Dec 31 of the prior year and in good standing at fulfillment. These PQP do not count toward the annual PQP cap from spend.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "IHG One Rewards Platinum Elite status",
      "description": "Primary cardmember is eligible for IHG One Rewards Platinum Elite status after registering at united.com/ihgstatus; must keep card open and IHG account in good standing to maintain benefits.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Avis President\u2019s Club status",
      "description": "Primary cardmember may enroll in Avis President\u2019s Club via united.com/AvisChaseBenefit and include Avis Preferred number in reservations to receive benefits; Avis terms apply.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rideshare credit up to $150 per calendar year (enrollment required)",
      "description": "Earn up to $12 in statement credits each month Jan\u2013Nov and up to $18 in Dec on eligible rideshare purchases paid with the card, after enrollment each calendar year (max $150/yr). Credits post 6\u20138 weeks after transactions; available starting the day after enrollment. Estimate: up to $150/yr if fully used.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Renowned Hotels & Resorts annual statement credit",
      "description": "Automatically receive up to $200 in statement credits annually for bookings paid with the card through Renowned Hotels and Resorts for United Cardmembers via Chase Travel. Credits post in 6\u20138 weeks. Estimate: up to $200/yr if utilized.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 annual JSX statement credit",
      "description": "Automatically receive up to $200 in annual statement credits for purchases made directly with JSX using the card. Credits post in 6\u20138 weeks. Estimate: up to $200/yr if utilized.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $100 Avis or Budget annual TravelBank credit",
      "description": "Earn $50 United TravelBank cash after your first eligible Avis or Budget rental and another $50 after your second eligible rental (booked at cars.united.com with specified codes, 2-day minimum). Max $100/yr; TravelBank cash posts within 6\u20138 weeks and expires 12 months after issue. Estimate: up to $100/yr if utilized.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership",
      "description": "Complimentary Instacart+ membership after activation at instacart.com/p/chase-united with this card through 12/31/2027 (or minimum 1-year term, whichever is longer). Membership auto-renews at then-current rate (e.g., $99/yr) unless canceled. Estimate: ~$99/yr value during promotional period, if you would otherwise pay for Instacart+.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Instacart monthly credits with active Instacart+",
      "description": "Receive two $10 credits per month in the Instacart app for orders of $10+ when you have an active Instacart+ membership and have activated via the Chase/United link; credits are in-app (not statement credits), do not roll over, and exclude taxes/fees/tips; valid 3/23/2025\u201312/31/2027. Estimate: up to $20/month if fully used during the promo window.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Premier Upgrades on award tickets (for Premier members)",
      "description": "Primary cardmember with MileagePlus Premier status traveling on an award ticket and one companion on the same reservation are eligible for Complimentary Premier Upgrades on select United/United Express flights, subject to availability.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Concierge",
      "description": "Access to Visa Infinite Concierge for assistance; cardmember pays for goods/services purchased via concierge.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry / TSA PreCheck / NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the first eligible application fee is charged to the card (primary or AU). Applies only to fees paid directly to the program administrators. Estimate: averages ~$30/year in value over a 4-year cycle if utilized.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Rideshare credit up to $150 per calendar year (enrollment required)",
      "description": "Earn up to $12 in statement credits each month Jan\u2013Nov and up to $18 in Dec on eligible rideshare purchases paid with the card, after enrollment each calendar year (max $150/yr). Credits post 6\u20138 weeks after transactions; available starting the day after enrollment. Estimate: up to $150/yr if fully used.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$200 Renowned Hotels & Resorts annual statement credit",
      "description": "Automatically receive up to $200 in statement credits annually for bookings paid with the card through Renowned Hotels and Resorts for United Cardmembers via Chase Travel. Credits post in 6\u20138 weeks. Estimate: up to $200/yr if utilized.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$200 annual JSX statement credit",
      "description": "Automatically receive up to $200 in annual statement credits for purchases made directly with JSX using the card. Credits post in 6\u20138 weeks. Estimate: up to $200/yr if utilized.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $100 Avis or Budget annual TravelBank credit",
      "description": "Earn $50 United TravelBank cash after your first eligible Avis or Budget rental and another $50 after your second eligible rental (booked at cars.united.com with specified codes, 2-day minimum). Max $100/yr; TravelBank cash posts within 6\u20138 weeks and expires 12 months after issue. Estimate: up to $100/yr if utilized.",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry / TSA PreCheck / NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the first eligible application fee is charged to the card (primary or AU). Applies only to fees paid directly to the program administrators. Estimate: averages ~$30/year in value over a 4-year cycle if utilized.",
      "credit_category": null,
      "new_credit_category": "trusted_traveler_program_fee_credit",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Instacart monthly credits with active Instacart+",
      "description": "Receive two $10 credits per month in the Instacart app for orders of $10+ when you have an active Instacart+ membership and have activated via the Chase/United link; credits are in-app (not statement credits), do not roll over, and exclude taxes/fees/tips; valid 3/23/2025\u201312/31/2027. Estimate: up to $20/month if fully used during the promo window.",
      "credit_category": "grocery",
      "new_credit_category": null,
      "value": 20.0,
      "value_unit": "dollars_per_month",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time public offer. Earn 80,000 United MileagePlus miles after $5,000 in purchases in the first 3 months from account opening, plus 10,000 bonus miles after adding an authorized user within the first 3 months (awarded once for the first AU added). Not available to current cardmembers of this credit card, or to previous cardmembers who received a new cardmember bonus for this card within the last 24 months. Bonus miles post in 6\u20138 weeks after qualifying; account must be open and not in default at fulfillment. Bonus miles do not count toward Premier status. Estimated value: at 1.4\u00a2/mile, 80,000 miles \u2248 $1,120; AU bonus 10,000 miles \u2248 $140; combined \u2248 $1,260 in value (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Limited-time public offer. Earn 80,000 United MileagePlus miles after $5,000 in purchases in the first 3 months from account opening, plus 10,000 bonus miles after adding an authorized user within the first 3 months (awarded once for the first AU added). Not available to current cardmembers of this credit card, or to previous cardmembers who received a new cardmember bonus for this card within the last 24 months. Bonus miles post in 6\u20138 weeks after qualifying; account must be open and not in default at fulfillment. Bonus miles do not count toward Premier status. Estimated value: at 1.4\u00a2/mile, 80,000 miles \u2248 $1,120; AU bonus 10,000 miles \u2248 $140; combined \u2248 $1,260 in value (actual value varies by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "chase_united_club_infinite_card.png"
},
  [CreditCard.AMERICAN_EXPRESS_THE_PLATINUM_CARD]: {
  "id": CreditCard.AMERICAN_EXPRESS_THE_PLATINUM_CARD,
  "name": "The Platinum Card\u00ae from American Express",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/acquisition/card-art/NUS000000237_480x304_straight_withname.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline",
      "earnRate": 5.0,
      "description": "5X on purchases of air tickets on scheduled flights booked directly with passenger airlines or through American Express Travel; up to $500,000 per calendar year in these airline purchases. Excludes charter/private jet flights, tours, ticketing service fees, cancellation/change fees, and cash equivalents.",
      "spendCap": 500000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5X on prepaid hotel reservations booked through American Express Travel (AmexTravel.com). Modifying a prepaid booking directly with the hotel may forfeit additional points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X on other eligible purchases that do not qualify for a higher category rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 895.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2924,
    "apr_low": 0.2024
  },
  "annualFee": 895.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2924,
    "description": "Pay Over Time variable APR: 20.24%\u201329.24% (varies with Prime Rate). Cash Advance APR: 29.49% variable. Pay Over Time Penalty APR: 29.99% variable (may apply for at least 6 months after a late or returned payment)."
  },
  "benefits": [
    {
      "name": "Global Lounge Collection access",
      "description": "Access 1,400+ lounges worldwide (Centurion Lounge, Delta Sky Club when flying Delta with visit limits, Lufthansa select lounges when flying Lufthansa Group, Priority Pass Select upon enrollment, Plaza Premium, Escape Lounges). Subject to space, access rules, and guesting policies. Amex cites over $500 annual value if you visit Centurion and partner lounges regularly.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Airline Fee Credit",
      "description": "Up to $200 in statement credits per calendar year for incidental fees charged by one selected qualifying U.S. airline. Enrollment and airline selection required. Typical value: up to $200/yr.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Hotel Credit (FHR and The Hotel Collection)",
      "description": "Up to $200 in statement credits per calendar year on eligible prepaid Fine Hotels + Resorts or The Hotel Collection bookings made via Amex Travel (THC requires 2-night minimum). Typical value: up to $200/yr.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$199 CLEAR Plus Credit",
      "description": "Up to $199 in statement credits per calendar year for CLEAR Plus membership (taxes/fees excluded). Auto-renewal applies. Typical value: up to $199/yr.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$200 Uber Cash",
      "description": "Receive $15 in Uber Cash each month, plus an extra $20 in December (U.S. rides and Uber Eats) after adding your eligible card and using Amex as payment with Uber Cash toggled on. Estimated value: up to $200/yr.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$240 Digital Entertainment Credit",
      "description": "Up to $20 per month in statement credits for eligible subscriptions purchased directly from Disney+, Disney Bundle, ESPN+, Hulu, The New York Times, Peacock, or The Wall Street Journal. Enrollment required. Estimated value: up to $240/yr.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Shop Saks with Platinum",
      "description": "Up to $100 in Saks Fifth Avenue statement credits annually: $50 from Jan\u2013Jun and $50 from Jul\u2013Dec. Enrollment required. Estimated value: up to $100/yr.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Walmart+ Monthly Membership Credit",
      "description": "Receive a statement credit covering one monthly Walmart+ membership fee (up to $12.95 + tax) when paid with the card; monthly plan required. Estimated value: up to ~$155/yr before taxes.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "$300 Equinox Credit",
      "description": "Up to $300 in statement credits each calendar year for eligible Equinox memberships (includes Equinox+) or a standalone Equinox+ subscription after validating eligibility and paying directly with the card. Estimated value: up to $300/yr.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$300 SoulCycle At-Home Bike Credit",
      "description": "$300 statement credit per SoulCycle At-Home Bike purchase (up to 15 bikes/yr) when purchased online at equinoxplus.com/bike with required 12-month Equinox+ membership. Estimated value: $300 per eligible bike purchase.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Fee Credit for Global Entry or TSA PreCheck",
      "description": "Statement credit for one Global Entry application fee (up to $120 every 4 years) or one TSA PreCheck application fee (up to $85 every 4.5 years) when paid with the card.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hilton Honors Gold Status",
      "description": "Enroll to receive complimentary Hilton Honors Gold status. Benefits vary by hotel (e.g., space-available upgrades, breakfast/food credit where offered).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Marriott Bonvoy Gold Elite Status",
      "description": "Enroll to receive complimentary Marriott Bonvoy Gold Elite status. Benefits vary by brand and property (e.g., space-available upgrades).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Privileges and Status",
      "description": "Complimentary status/benefits with select car rental programs (e.g., Hertz, National, Avis) after enrollment; benefits and availability subject to partner terms.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation & Interruption Insurance",
      "description": "Secondary coverage provided by New Hampshire Insurance Company (AIG). Terms, conditions, and limits apply (see Guide to Benefits).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": "trip_interruption_insurance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Insurance",
      "description": "Secondary coverage for eligible trip delays; terms and limits apply (see Guide to Benefits).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": "trip_delay_insurance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Coverage for lost, damaged, or stolen baggage; terms and limits apply (see Guide to Benefits).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": "baggage_insurance_plan",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Coverage for essential items when baggage is delayed; terms and limits apply.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss & Damage Insurance",
      "description": "Collision damage waiver coverage when renting a car; generally secondary. Terms, exclusions, and vehicle restrictions apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Coverage for eligible purchases against accidental damage or theft for a limited period; terms and limits apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original manufacturer\u2019s warranty on eligible items; terms and limits apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "If a merchant won\u2019t accept a return on an eligible item, Amex may refund the purchase price; terms and caps apply.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "Coverage for damage or theft of an eligible cell phone; excess to other coverage. Terms, limits, and exclusions apply.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Dining Access by Resy",
      "description": "Special access to sought-after restaurants, Priority Notify, and exclusive dining events when you add your Platinum Card to your Resy profile.",
      "benefit_type": null,
      "new_benefit_type": "global_dining_access_by_resy",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Fine Hotels + Resorts benefits",
      "description": "On eligible FHR bookings: daily breakfast for two (min. $60 value), property credit (~$100, varies), noon check-in and room upgrade when available, and guaranteed 4pm late checkout. Enrollment/booking via Amex Travel required.",
      "benefit_type": null,
      "new_benefit_type": "fine_hotels_and_resorts_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "The Hotel Collection benefits",
      "description": "On eligible THC bookings of 2+ nights: up to $100 property experience credit and space-available room upgrade at check-in. Booking via Amex Travel required.",
      "benefit_type": null,
      "new_benefit_type": "the_hotel_collection_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "International Airline Program",
      "description": "Savings on select first, business, and premium economy fares with participating airlines when booked via Amex Travel. Cardholder must be on the itinerary.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cruise Privileges Program",
      "description": "On eligible cruises booked via Amex Travel: onboard credit and additional amenity (varies by line, typically $100\u2013$300+ per stateroom).",
      "benefit_type": null,
      "new_benefit_type": "cruise_privileges_program",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premium Global Assist Hotline",
      "description": "24/7 coordination and assistance; emergency medical transportation may be provided at no cost if approved and coordinated by Premium Global Assist. Third\u2011party costs may apply.",
      "benefit_type": null,
      "new_benefit_type": "premium_global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection Concessions Credit",
      "description": "Earn 10% back as a statement credit on qualifying food & beverage concessions at participating Venue Collection stadiums/arenas, up to $250 per calendar year (through 12/31/2026).",
      "benefit_type": "statement_credit",
      "new_benefit_type": "venue_collection_concessions_credit",
      "credit_type": "american_express_venue_collection_concessions",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$199 CLEAR Plus Credit",
      "description": "Up to $199 back in statement credits per calendar year for CLEAR Plus membership fees when charged to the Card.",
      "credit_category": "travel",
      "new_credit_category": null,
      "value": 199.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$200 Airline Fee Credit",
      "description": "Up to $200 per calendar year in statement credits for incidental fees charged by one selected qualifying airline.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$600 Hotel Credit",
      "description": "Up to $300 back in statement credits semi-annually on eligible prepaid Fine Hotels + Resorts or The Hotel Collection bookings through Amex Travel.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$200 Uber Cash",
      "description": "$15 in Uber Cash each month plus an extra $20 in December for U.S. rides and Uber Eats after adding your Card in the Uber app.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$240 Digital Entertainment Credit",
      "description": "Up to $20 per month in statement credits for eligible subscriptions (Disney+, Disney Bundle, ESPN+, Hulu, The New York Times, Peacock, The Wall Street Journal). Enrollment required.",
      "credit_category": "streaming",
      "new_credit_category": null,
      "value": 240.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Shop Saks with Platinum",
      "description": "Up to $100 in statement credits each year for purchases at Saks Fifth Avenue ($50 Jan\u2013Jun and $50 Jul\u2013Dec). Enrollment required.",
      "credit_category": "departmentStores",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.BIANNUALLY
    },
    {
      "name": "Walmart+ Monthly Membership Credit",
      "description": "Monthly statement credit for one Walmart+ membership fee (up to $12.95 + taxes) when paid with the Card.",
      "credit_category": "walmart",
      "new_credit_category": null,
      "value": 155.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$300 Equinox Credit",
      "description": "Up to $300 in statement credits per calendar year on eligible Equinox memberships or Equinox+ subscription after validating eligibility and paying directly with the card.",
      "credit_category": null,
      "new_credit_category": "fitness_membership",
      "value": 300.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$300 SoulCycle At-Home Bike Credit",
      "description": "$300 statement credit per SoulCycle At-Home Bike purchase (up to 15 per year) when purchased online with required 12\u2011month Equinox+ membership.",
      "credit_category": null,
      "new_credit_category": "fitness_equipment",
      "value": 300.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Global Entry or TSA PreCheck Fee Credit",
      "description": "Statement credit for one Global Entry fee (up to $120 every 4 years) or one TSA PreCheck fee (up to $85 every 4.5 years) when paid with the Card.",
      "credit_category": null,
      "new_credit_category": "trusted_traveler_program_fees",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "American Express Venue Collection Concessions Credit",
      "description": "10% back as a statement credit on qualifying concessions at participating venues, up to $250 in credits per calendar year, through 12/31/2026.",
      "credit_type": "american_express_venue_collection_concessions",
      "credit_category": null,
      "new_credit_category": "event_concessions",
      "value": 250.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 8000.0,
      "spendRequirementMonths": 6,
      "description": "As high as 175,000 Membership Rewards points after you spend $8,000 in purchases in the first 6 months. The exact welcome offer amount is disclosed after you apply and may be less than 175,000 points. Points post 8\u201312 weeks after meeting the threshold; account must be open and not past due. Not available to prior cardholders of this or certain Platinum variants; Amex may withhold/revoke points for abuse/gaming. Estimated value: ~$1,750 at 1.0\u00a2/point to ~$2,625 at 1.5\u00a2/point, depending on redemption.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 175000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/platinum-card/25330-10-0",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/card/platinum/",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/platinum-card/25330-10-0",
  "terms_and_conditions_button_text": "Rates & Fees",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/platinum-card/25330-10-0"
    }
  ],
  "bank_name": "American Express",
  "imageName": "american_express_the_platinum_card.png"
},
  [CreditCard.UNITED_CLUB_INFINITE_CARD]: {
  "id": CreditCard.UNITED_CLUB_INFINITE_CARD,
  "name": "United Club\u2120 Infinite Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/united_club_infinite_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.united",
      "earnRate": 4.0,
      "description": "4 miles per $1 on airline tickets purchased from United and the following purchases made from United: seat upgrades, Economy Plus, inflight food/beverages/Wi\u2011Fi, baggage service charges and other United fees. United tickets booked through some discount travel websites or as part of third\u2011party travel packages do not qualify. Other United-related purchases like United Cruises, United MileagePlus X, DIRECTV and Merchandise Awards are excluded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2 miles per $1 on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 2.0,
      "description": "2 miles per $1 on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel",
      "earnRate": 2.0,
      "description": "2 miles per $1 on general travel purchases. Excludes United purchases that qualify for 4x (e.g., tickets purchased from United and specified United fees) and United Card Events from Chase.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 mile per $1 spent on all other purchases that do not fall into a higher-earning category; excludes non-purchase transactions per program terms.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 695.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2874,
    "apr_low": 0.2024
  },
  "annualFee": 695.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2874,
    "description": "Purchase APR: 0.2024 to 0.2874 variable (based on creditworthiness; varies with Prime Rate). Balance transfer APR: 0.2024 to 0.2874 variable. Cash advance APR: 0.2899 variable. Penalty APR: up to 0.2999 variable; may apply indefinitely after a late or returned payment. Grace period: at least 21 days; no interest on new purchases if you pay your entire balance or Interest Saving Balance by the due date. Interest on balance transfers and cash advances begins on the transaction date. Minimum interest charge: None. Balance transfer fee: 5% ($5 min). Foreign transaction fee: None. Note: This account may not be eligible for balance transfers. Prime Rate 7.25% as of 9/23/2025."
  },
  "benefits": [
    {
      "name": "United Club membership (primary cardmember)",
      "description": "Complimentary United Club lounge membership for the primary cardmember (1 adult guest + dependent children under 18 admitted per visit). Star Alliance lounges not included with base membership. Estimated value: roughly $650\u2013$700/yr based on typical United Club membership pricing.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "United Club All Access membership (earnable)",
      "description": "Earn United Club All Access membership (includes Star Alliance lounge access and 2 adult guests or 1 adult guest + dependent children) after $50,000 in net purchases in a calendar year or by earning Premier Gold status or higher. Valid for the remainder of the calendar year earned and the following year. Effective Aug 1, 2025. Estimated incremental value vs base membership varies by traveler access to Star Alliance lounges.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": 50000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Four United Club one-time passes at anniversary (with All Access + AU)",
      "description": "4 United Club one-time passes deposited after each card anniversary if you hold United Club All Access membership AND have an authorized user on the account at the time of anniversary. Each pass admits one person when the primary cardmember or an AU is also admitted. Estimated value: about $59 per pass (based on typical United Club day pass pricing), up to ~$236/year.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": true
    },
    {
      "name": "First and second checked bags free",
      "description": "Primary cardmember and one companion on the same reservation each get their first and second standard checked bags free on United/United Express flights (ticket must be purchased with the card; this purchase requirement is waived for flights completed within 90 days of account opening). Estimated savings can exceed $200 round-trip for two travelers depending on prevailing bag fees.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Premier Access travel services",
      "description": "Priority check-in, priority security lanes (where available), priority boarding, and priority baggage handling for the primary cardmember and companions on the same reservation on United/United Express flights.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on United inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on eligible inflight food, beverage and Wi\u2011Fi purchases on United/United Express and on premium drink purchases at United Clubs when using the card.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing (when available)",
      "description": "When the \u201cCardmembers Save\u201d banner is present, award flight pricing for cardmembers was 32% lower in 2024 versus general members for the same itinerary. Discount varies and does not apply to taxes/fees.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% Saver Award discount (economy)",
      "description": "Book Economy Saver Awards (fare classes X/XN) within the continental U.S. or between the continental U.S. and Canada with 10% fewer miles for all passengers on the same reservation when booked through the primary cardmember\u2019s MileagePlus account.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10,000-mile award flight discount credits",
      "description": "Earn a 10,000-mile award flight discount for every $20,000 in purchases in a calendar year, up to two discounts per year (up to 20,000 total miles off award pricing). Discounts expire 12 months after issue and apply when redeeming >10,000 miles for eligible United/United Express award travel.",
      "benefit_type": "award_flight_discount",
      "new_benefit_type": null,
      "spend_requirement": 20000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "IHG One Rewards Platinum Elite status",
      "description": "Primary cardmember is eligible for complimentary IHG One Rewards Platinum Elite status (registration required). Estimated value: ~$100\u2013$200+/yr depending on usage (late checkout, room upgrades where available, bonus points, etc.).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Avis President\u2019s Club",
      "description": "Primary cardmember can enroll in Avis President\u2019s Club for enhanced car rental benefits (enrollment required).",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn PQP toward United Premier status",
      "description": "Earn 1 Premier Qualifying Point (PQP) per $15 in net purchases, up to 28,000 PQP per calendar year. Helps qualify up to Premier 1K.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual 1,500 Card Bonus PQP",
      "description": "1,500 PQP are deposited each year within 6\u20138 weeks after Feb 1, provided the account was open as of Dec 31 of the prior year and at fulfillment.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Premier Upgrades on award tickets (for elites)",
      "description": "Primary cardmember with United Premier status, traveling on an award ticket, and one companion on the same reservation are eligible for Complimentary Premier Upgrades on select United/United Express flights, subject to availability.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Infinite Concierge",
      "description": "Access to personal travel/concierge assistance. Cardmember pays for any goods/services arranged.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Instacart+ membership",
      "description": "Complimentary Instacart+ membership after activation through 12/31/2027 (or minimum 1 year, whichever is longer). Estimated value: ~$99/yr (standard annual price), excluding any order fees, tips, or monthly credit promos.",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No fees on foreign transactions (Pricing & Terms lists Foreign Transactions: None).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Renowned Hotels & Resorts for United Cardmembers program perks",
      "description": "Special on-property benefits when booking participating properties via Chase Travel (e.g., complimentary Wi\u2011Fi; benefits may vary by property and availability).",
      "benefit_type": null,
      "new_benefit_type": "hotel_program_perks",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Rideshare credit up to $150 per calendar year (enrollment required)",
      "description": "Earn up to $12 in statement credits each month Jan\u2013Nov and up to $18 in Dec on eligible rideshare purchases paid with the card, after enrollment each calendar year (max $150/yr). Credits post 6\u20138 weeks after transactions; available starting the day after enrollment. Estimate: up to $150/yr if fully used.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "$200 Renowned Hotels & Resorts annual statement credit",
      "description": "Automatically receive up to $200 in statement credits annually for bookings paid with the card through Renowned Hotels and Resorts for United Cardmembers via Chase Travel. Credits post in 6\u20138 weeks. Estimate: up to $200/yr if utilized.",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "$200 annual JSX statement credit",
      "description": "Automatically receive up to $200 in annual statement credits for purchases made directly with JSX using the card. Credits post in 6\u20138 weeks. Estimate: up to $200/yr if utilized.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 200.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Up to $100 Avis or Budget annual TravelBank credit",
      "description": "Earn $50 United TravelBank cash after your first eligible Avis or Budget rental and another $50 after your second eligible rental (booked at cars.united.com with specified codes, 2-day minimum). Max $100/yr; TravelBank cash posts within 6\u20138 weeks and expires 12 months after issue. Estimate: up to $100/yr if utilized.",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Global Entry / TSA PreCheck / NEXUS application fee credit",
      "description": "Receive one statement credit up to $120 every 4 years after the first eligible application fee is charged to the card (primary or AU). Applies only to fees paid directly to the program administrators. Estimate: averages ~$30/year in value over a 4-year cycle if utilized.",
      "credit_category": null,
      "new_credit_category": "trusted_traveler_program_fee_credit",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Instacart monthly credits with active Instacart+",
      "description": "Receive two $10 credits per month in the Instacart app for orders of $10+ when you have an active Instacart+ membership and have activated via the Chase/United link; credits are in-app (not statement credits), do not roll over, and exclude taxes/fees/tips; valid 3/23/2025\u201312/31/2027. Estimate: up to $20/month if fully used during the promo window.",
      "credit_category": "grocery",
      "new_credit_category": null,
      "value": 20.0,
      "value_unit": "dollars_per_month",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 80,000 United MileagePlus miles after $5,000 in purchases in the first 3 months. Plus, earn 10,000 bonus miles when you add your first authorized user within the first 3 months. Offer not available to current cardmembers or previous cardmembers who received a new cardmember bonus for this card within the past 24 months. Miles post in 6\u20138 weeks and do not count toward Premier status. Estimated value: 90,000 miles \u2248 $1,080\u2013$1,350 (assuming 1.2\u20131.5\u00a2/mile; at 1.3\u00a2/mile \u2248 $1,170).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Earn 80,000 United MileagePlus miles after $5,000 in purchases in the first 3 months. Plus, earn 10,000 bonus miles when you add your first authorized user within the first 3 months. Offer not available to current cardmembers or previous cardmembers who received a new cardmember bonus for this card within the past 24 months. Miles post in 6\u20138 weeks and do not count toward Premier status. Estimated value: 90,000 miles \u2248 $1,080\u2013$1,350 (assuming 1.2\u20131.5\u00a2/mile; at 1.3\u00a2/mile \u2248 $1,170).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HTYJ&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/united/club-infinite?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62177.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/unitedcard/clubrewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "united_club_infinite_card.png"
},
  [CreditCard.CHOICE_PRIVILEGES_MASTERCARD]: {
  "id": CreditCard.CHOICE_PRIVILEGES_MASTERCARD,
  "name": "Choice Privileges\u00ae Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/W-Card-MarketPlace/v9-10-25/images/Products/ChoicePrivileges/WF_Choice_NoFee_Card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CHOICE,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.choiceHotels",
      "earnRate": 5.0,
      "description": "Earn 5 points per $1 (1 base + 4 bonus) on qualifying stays at participating Choice Hotels properties when booked directly via approved Choice channels and billed by the hotel.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 (1 base + 2 bonus) at gas stations, automated fuel dispensers, and EV charging stations when properly coded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 (1 base + 2 bonus) at grocery stores, supermarkets, delis, and bakeries when properly coded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "homeImprovement",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 (1 base + 2 bonus) at qualifying home improvement merchants and services when properly coded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 3.0,
      "description": "Earn 3 points per $1 (1 base + 2 bonus) on phone plan services from telecommunication providers when properly coded.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 point per $1 on other net purchases not in bonus categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2899,
    "apr_low": 0.1974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2899,
    "description": "Variable APRs based on creditworthiness and U.S. Prime Rate: Purchases 19.74%, 23.99%, or 28.99% (0.1974\u20130.2899); Balance transfers 19.74%, 23.99%, or 28.99% (same as purchases); Cash advances 29.99% (0.2999). Minimum interest charge $1. At least 25-day grace period on purchases; no interest on purchases if paid in full by due date. Interest on cash advances and balance transfers begins on the transaction date."
  },
  "benefits": [
    {
      "name": "Automatic Gold Elite membership",
      "description": "Automatic Choice Privileges Gold Elite status; includes a 10% bonus on base Choice points earned on qualifying stays (excludes certain brands per program terms). Estimated incremental value roughly 0.6% back on eligible room rate before taxes if valuing Choice points at ~0.6 cents each.",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10 Elite Night Credits each year",
      "description": "Receive 10 Elite Night Credits deposited within ~14 days of opening and each year within ~14 days after Jan 1, helping you qualify for at least Gold status.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $800 per approved claim (max 2 claims per 12-month period) with a $25 deductible when you pay your monthly cell phone bill with the card; theft, damage, or involuntary and accidental parting covered; exclusions apply (e.g., lost phones, electronic/software failures).",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% fee on purchases made abroad or in foreign currencies, typically saving ~3% versus cards that charge foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Mastercard World Elite benefits (concierge and more)",
      "description": "Access to Mastercard World Elite concierge, travel and lifestyle services, and additional protections/offers; terms and exclusions apply\u2014see Guide to Benefits.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 40,000 Choice Privileges points after $1,000 in purchases in the first 3 months. Points typically post as redeemable within 1\u20132 billing periods after they are earned. Not available if you opened a Choice Privileges or Choice Privileges Select card in the last 15 months and received an introductory bonus. Excludes cash equivalents, balance transfers, fees, interest, and gambling transactions from qualifying spend. Estimated value \u2248 $240 at 0.6 cents/point (range ~$200\u2013$320 at 0.5\u20130.8 cpp), actual value varies by redemption; marketed as enough for up to 5 reward nights at select properties (fees may apply).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 40000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.choicehotels.com/choice-privileges/earn-points/mastercard-credit-card?FPID=0124CAIXP10000&utm_source=WF&app_source=WELLS_FARGO_COM&locale=en_US&product_code=CC&subproduct_code=CP&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC&referrerurl=creditcardswellsfargocom&lang=en",
  "learn_more_link": "https://creditcards.wellsfargo.com/choice-hotel-privileges-mastercard/?FPID=0124CAIXP10000&product_code=CC&subproduct_code=CP&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMPD_MC",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/choice/terms/?FPID=0124CAIXP10000&app_source=WELLS_FARGO_COM&product_code=CC&subproduct_code=CP&sub_channel=SEO&vendor_code=G&cx_nm=CXNAME_CSMHP_MC",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [
    {
      "name": "Choice Privileges credit cards",
      "url": "https://creditcards.wellsfargo.com/wells-fargo-choice-privileges-credit-cards/?product_code=CC&subproduct_code=MC&sub_channel=SEO&vendor_code=G"
    }
  ],
  "bank_name": "Wells Fargo",
  "imageName": "choice_privileges_mastercard.png"
},
  [CreditCard.BUSINESS_GOLD_CARD]: {
  "id": CreditCard.BUSINESS_GOLD_CARD,
  "name": "American Express\u00ae Business Gold Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/business-gold.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 4.0,
      "description": "4X Membership Rewards on the top 2 categories each billing cycle from the 6 eligible categories listed; up to $150,000 in combined purchases per calendar year across those categories, then 1X. Gas excludes superstores, supermarkets, and warehouse clubs that sell gas. Wireless phone category excludes Google Fi and payments not made directly with U.S. wireless providers. Additional points may not be earned if the merchant\u2019s coding doesn\u2019t match the category or if third-party payment processors/wallets are used.",
      "spendCap": 150000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": 2,
        "categories": [
          "onlineAdvertising",
          {
            "categories": [
              "electronics",
              "computerServices"
            ],
            "exclude_subcategories": null,
            "is_us_only": true,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "U.S. purchases made from electronic goods retailers and software & cloud system providers."
          },
          "dining",
          "gas",
          "travel.transit",
          "phonePlans"
        ],
        "categoryRotationFrequency": Frequency.MONTHLY,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Earn 4X on the two categories with the most spend each billing cycle from: U.S. media providers for advertising (online, TV, radio); U.S. electronic goods retailers and software & cloud system providers; U.S. restaurants (including takeout and delivery); U.S. gas stations (excludes superstores, supermarkets, and warehouse clubs that sell gas); transit (trains, taxis, rideshare, ferries, tolls, parking, buses, subways); and monthly wireless telephone service charges paid directly to U.S. wireless providers. Purchases from Google Fi, third parties, authorized retailers or resellers are excluded from the wireless category.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "travel.airline",
      "earnRate": 3.0,
      "description": "3X Membership Rewards on flights booked online through American Express Travel; excludes fees, non-flight purchases, and bookings not made online. Extra points typically post 6\u201310 weeks after eligible charges appear.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 3.0,
      "description": "3X Membership Rewards on prepaid hotels booked through American Express Travel; excludes non-prepaid hotel bookings, vacation packages, car rentals, cruises, group reservations/events, and fees. Extra points typically post 6\u201310 weeks after eligible charges appear.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X Membership Rewards on all other eligible purchases, including amounts beyond the $150,000 annual cap for the 4X categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 375.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.1824
  },
  "annualFee": 375.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2899,
    "description": "Pay Over Time purchase APR is variable 18.24%\u201328.99% (Prime + 10.99% to +21.74%), based on creditworthiness; Penalty APR 29.99% variable may apply for late/returned payments. At least 25-day grace period; no interest if entire balance is paid by due date."
  },
  "benefits": [
    {
      "name": "$240 Flexible Business Credit (FedEx, Grubhub, U.S. Office Supply Stores)",
      "description": "Enroll and earn up to $20 per month in statement credits (up to $240 per calendar year) for eligible U.S. purchases made directly with FedEx, Grubhub, and at U.S. Office Supply Stores on the account. Estimated annual value: up to $240 if fully utilized. Enrollment required; one $20 cap per account per calendar month; excludes gift cards/cash equivalents; see terms for merchant coding and processing timing.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Walmart+ Monthly Membership Credit (up to $12.95+tax/mo)",
      "description": "Receive a statement credit for one monthly Walmart+ membership fee per account (up to $12.95 plus applicable taxes each month) when paid with the card; excludes Plus Ups and Walmart Business+. Must be on monthly (not annual) membership. Estimated annual value: \u2248$155 if used 12 months. Terms apply; credit may take 6\u20138 weeks.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "0% foreign transaction fee on purchases made outside the U.S. (merchant/ATM fees may still apply). Estimated savings: typically 1%\u20133% vs. cards that charge FX fees, depending on your foreign spend.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cell Phone Protection",
      "description": "Cell phone protection provided by New Hampshire Insurance Company (an AIG company); coverage at no additional cost, secondary to other insurance; terms, limits, and exclusions apply (see Guide to Benefits).",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Insurance",
      "description": "Coverage for eligible trip delays; provided at no additional cost; secondary coverage with terms, conditions, and limits as specified (see Guide to Benefits). Value varies by use; no fixed cash value.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan \u2013 Baggage Delay",
      "description": "Coverage for baggage delays subject to terms, conditions, and exclusions (see Guide to Benefits). Value varies by use.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan \u2013 Lost, Stolen, or Damaged Luggage",
      "description": "Coverage for lost, stolen, or damaged baggage subject to terms, conditions, and exclusions (see Guide to Benefits). Value varies by use.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Loss & Damage Insurance (Secondary)",
      "description": "Car rental collision damage waiver insurance underwritten by AMEX Assurance Company; typically secondary coverage in the U.S.; terms, vehicle exclusions, and limits apply (see Guide to Benefits).",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends eligible U.S. manufacturer\u2019s warranty on covered purchases; terms, conditions, and exclusions apply (see Guide to Benefits).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Coverage for eligible purchases against accidental damage or theft for a limited period; terms, conditions, and exclusions apply (see Guide to Benefits).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "The Hotel Collection benefits (via Amex Travel)",
      "description": "On stays of 2+ consecutive nights booked through Amex Travel at participating properties: $100 experience credit (type varies by property), room upgrade at check-in if available, plus noon check-in/late checkout where offered. Must pay with an eligible Amex card and the cardmember must travel. Value varies by stay and usage.",
      "benefit_type": null,
      "new_benefit_type": "the_hotel_collection_benefits",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Membership Rewards \u2013 Points Transfer",
      "description": "Transfer Membership Rewards points to participating airline and hotel partners (enrollment required). Excise fee of $0.0006 per point (max $99) applies for U.S. airline transfers. Value depends on transfer partner and redemption.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance services when traveling; third-party provider costs are the cardmember\u2019s responsibility. Useful for emergencies and travel support; no fixed cash value.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Entertainment Access (Presale, Preferred, Reserved Tickets)",
      "description": "Access to Amex presale, preferred, and reserved tickets for select events when paying with an eligible Amex card; availability, seat types, and limits vary by event and seller; not guaranteed for every event.",
      "benefit_type": null,
      "new_benefit_type": "ticket_presale_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection \u2013 Entrances and Fast Lanes",
      "description": "Access to dedicated Amex Card Member entrances or fast lanes at select venues in the Venue Collection for eligible events; availability varies by venue and event; valid ticket and Amex card required.",
      "benefit_type": null,
      "new_benefit_type": "venue_fast_lanes_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "American Express Venue Collection \u2013 10% Concessions Statement Credit (through 12/31/2026)",
      "description": "Earn 10% back as a statement credit on qualifying in-venue food and beverage concessions purchases at participating American Express Venue Collection arenas/stadiums, up to $250 back in statement credits per calendar year. Enrollment required; see terms and venue list.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$240 Flexible Business Credit",
      "description": "Up to $20/month in statement credits (up to $240/yr) for eligible U.S. purchases with FedEx, Grubhub, and at U.S. Office Supply Stores. Enrollment required; one $20 cap per account per calendar month; terms apply.",
      "credit_category": "businessConsultingServices",
      "new_credit_category": "fedex_grubhub_us_office_supply_stores",
      "value": 240.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "Walmart+ Monthly Membership Credit",
      "description": "Statement credit for one monthly Walmart+ membership fee per account (up to $12.95+tax each month); excludes Plus Ups and Walmart Business+. Must be on monthly plan; terms apply.",
      "credit_category": "walmart",
      "new_credit_category": null,
      "value": 155.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY
    },
    {
      "name": "American Express Venue Collection \u2013 10% Concessions Credit",
      "description": "10% back as a statement credit on qualifying concessions purchases at participating Venue Collection locations, up to $250 per calendar year, through 12/31/2026. Enrollment required; terms apply.",
      "credit_category": "entertainment",
      "new_credit_category": "venue_collection_concessions",
      "value": 250.0,
      "value_unit": "dollars_per_year",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 15000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 150,000 Membership Rewards points after $15,000 in eligible purchases in the first 3 months of Card Membership. Not available to applicants who have or have had this card. Limit one welcome offer per account. Eligible purchases exclude fees/interest, traveler's checks, prepaid/gift cards, person-to-person payments, and other cash equivalents. Points post 8\u201312 weeks after meeting the threshold. American Express may withhold or revoke points for abuse/misuse/gaming. Estimated value: \u2248$2,250 at 1.5\u00a2/point (value varies by redemption; ~1.0\u20132.0\u00a2+ typical range).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 150000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-gold-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Gold",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/american-express-business-gold-card-amex/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-Gold",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/businessgold-card/64573-9-0?key=tncBody&rwdFlag=rwd#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/prospect/terms/businessgold-card/64573-9-0?key=tncBody&rwdFlag=rwd"
    }
  ],
  "bank_name": "American Express",
  "imageName": "business_gold_card.png"
},
  [CreditCard.SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD]: {
  "id": CreditCard.SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD,
  "name": "Southwest Rapid Rewards\u00ae Performance Business Credit Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/swa_preformance_biz_card_ribbon.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.SOUTHWEST,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.southwest",
      "earnRate": 4.0,
      "description": "Purchases made directly with Southwest Airlines, including flights, inflight purchases, Southwest gift cards, and Southwest Vacations or Getaways by Southwest packages. Excludes Southwest Charters and Southwest Cargo. Merchant eligibility based on coding; third-party or wallet payments may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 3.0,
      "description": "3x points on qualifying Rapid Rewards car rental partners through 12/31/2025 when reservations are made through the Rapid Rewards car rental portal.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "Hotel accommodations when purchased directly with the hotel. During 2025, some participating Rapid Rewards hotel partners may instead earn 3x under the partner offer; those may be excluded from this 2x category.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Gas station purchases based on merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Dining at restaurants, including takeout and eligible delivery services, based on merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "Local transit and commuting purchases based on merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare",
      "earnRate": 2.0,
      "description": "Rideshare services (e.g., Uber, Lyft) based on merchant coding; included within local transit and commuting benefits.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineAdvertising",
      "earnRate": 2.0,
      "description": "Social media and search engine advertising purchases until 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "Internet, cable, and phone services until 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other purchases (excluding non-purchase and cash-like transactions as defined by the issuer).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 299.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 299.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Purchase APR is variable 0.1974\u20130.2824 based on creditworthiness and the Prime Rate; Balance Transfer APR is variable 0.1974\u20130.2824; Cash Advance APR is variable 0.2899; Penalty/Default APR up to 0.2999. APRs vary with the market based on the Prime Rate. Note: This account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "Preferred seat selection at booking",
      "description": "Complimentary Preferred or Standard seat selection at booking for the primary cardmember and up to 8 passengers on the same reservation when available (flights operating in 2026 and beyond). Authorized users/employee cards not eligible.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extra Legroom seat upgrade within 48 hours",
      "description": "Unlimited upgrades to an Extra Legroom seat within 48 hours prior to departure at no additional charge when available for the primary cardmember and up to 8 passengers on the same reservation (flights operating in 2026 and beyond).",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 5 boarding benefit",
      "description": "Primary cardmember and up to 8 passengers on the same reservation can board with Group 5 on Southwest-operated flights (marketing indicates for flights operating in 2026 and beyond).",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "First checked bag free",
      "description": "Primary cardmember and up to 8 passengers on the same reservation each get their first standard checked bag free on Southwest (oversize/overweight fees may apply; not valid on partner bookings).",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on Southwest inflight purchases",
      "description": "Get 25% back as a statement credit on inflight purchases (drinks and WiFi) made with the card; applies to employee card purchases as well.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Inflight WiFi credits",
      "description": "Up to 365 WiFi credits per year on Southwest flights, each credit worth $8 (max theoretical value $2,920/year if fully used). Credits post as statement credits.",
      "benefit_type": "airline_wifi_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Upgraded Boardings reimbursement (A1\u2013A15) \u2013 2025 flights",
      "description": "Reimbursed for up to 4 Upgraded Boardings per anniversary year when available for 2025 flights (purchase with the card; statement credit up to the price paid).",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Southwest points transfer fee credit",
      "description": "Automatic statement credits reimbursing fees for transferring Rapid Rewards points to another member or eligible charity, up to $500 per anniversary year.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry, TSA PreCheck, or NEXUS application fee credit",
      "description": "One statement credit of up to $120 every 4 years when you use the card to pay the application fee for Global Entry, TSA PreCheck, or NEXUS.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Anniversary bonus points",
      "description": "Receive 9,000 Rapid Rewards points each account anniversary year. Estimated value ~$117\u2013$135 at ~1.3\u20131.5 cpp (midpoint ~$126 at 1.4 cpp).",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Tier Qualifying Points (TQPs) on spend",
      "description": "Earn 2,500 TQPs toward A\u2011List/A\u2011List Preferred for every $5,000 in purchases annually.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 5000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Companion Pass qualifying points boost",
      "description": "Receive a 10,000 Companion Pass qualifying points boost each calendar year (deposited by Jan 31 or up to 30 days after account opening).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Up to $3,000 per covered traveler for lost, damaged, or stolen baggage on a covered trip (NY: $2,000 per bag; $10,000 total cap for all travelers per trip).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Up to $100 per day for up to 3 days for essential purchases when baggage is delayed more than 6 hours on a covered trip.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty Protection",
      "description": "Extends eligible U.S. manufacturer\u2019s warranties by 1 additional year on warranties of 3 years or less (up to 4 years from purchase).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $10,000 per item (NY: 90 days).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay no foreign transaction fees on purchases made outside the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry/TSA PreCheck/NEXUS credit",
      "description": "One statement credit up to $120 every four years for Global Entry, TSA PreCheck, or NEXUS application fee when charged to the card.",
      "credit_category": null,
      "new_credit_category": "government_trusted_traveler_programs",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Southwest inflight WiFi credits",
      "description": "Up to 365 credits per year for inflight WiFi purchases on Southwest, each credit worth $8.",
      "credit_category": "travel.airline.skyteamAirlines",
      "new_credit_category": null,
      "value": 8.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Upgraded Boardings reimbursement (2025 flights)",
      "description": "Reimbursement for up to 4 Upgraded Boardings (A1\u2013A15) per anniversary year when available for 2025 flights.",
      "credit_category": "travel.airline.skyteamAirlines",
      "new_credit_category": null,
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Southwest points transfer fee credit",
      "description": "Automatic statement credits reimbursing fees to transfer Rapid Rewards points, up to $500 per anniversary year.",
      "credit_category": null,
      "new_credit_category": "points_transfer_fees",
      "value": 500.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 120,000 Rapid Rewards points after you spend $10,000 on purchases in the first 3 months from account opening. Estimated value roughly $1,560\u2013$1,800 assuming ~1.3\u20131.5 cents per point (midpoint ~$1,680 at 1.4 cpp). Allow up to 8 weeks for the bonus to post; account must be open and not in default.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 120000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HTXQ&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/business-credit-cards/southwest/performance-business?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC62170.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement",
      "url": "https://www.chase.com/swaperformancebizcard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "southwest_rapid_rewards_performance_business_credit_card.png"
},
  [CreditCard.AMAZON_BUSINESS_CARD]: {
  "id": CreditCard.AMAZON_BUSINESS_CARD,
  "name": "Amazon Business American Express Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://icm.aexp-static.com/Internet/Acquisition/US_en/AppContent/OneSite/open/category/cardarts/amazon-business-angled.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "fixed_category_group",
      "earnRate": 3.0,
      "description": "Designated Amazon properties include Amazon.com, Amazon Business, Whole Foods Market, Amazon Go, Amazon Books, and AWS. Earn 3% Back on the first $120,000 in eligible purchases each calendar year when choosing rewards; 1% thereafter. Purchases via third\u2011party payment accounts or online marketplaces (other than designated Amazon properties) may not qualify for the higher rate.",
      "spendCap": 120000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          {
            "categories": [
              "onlineShopping.amazon",
              "whole_foods"
            ],
            "exclude_subcategories": null,
            "is_us_only": true,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "category_description": "Designated U.S. Amazon properties: Amazon.com, Amazon Business, AWS (Amazon Web Services), Whole Foods Market, and Amazon physical retail like Amazon Go and Amazon Books."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "3% Back on eligible U.S. purchases at designated Amazon properties when choosing rewards (instead of Payment Terms). Applies to the first $120,000 per calendar year; purchases beyond the cap earn 1% Back.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2% Back at U.S. restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2% Back at U.S. gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 2.0,
      "description": "2% Back on wireless telephone services purchased directly from U.S. service providers (excludes Google Fi).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "us_purchases_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% Back on other eligible purchases not in the bonus categories; also applies to designated Amazon property purchases when not eligible for or not receiving the higher rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2624,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2624,
    "description": "Variable purchase APR 18.24%\u201326.24% (Prime Rate +10.99% to +18.99%), based on creditworthiness; varies with the Prime Rate. Cash advance APR 28.99% (Prime +21.74%). Penalty APR 29.99% may apply for certain late/returned payment triggers for a minimum of 12 billing periods. Variable APRs will not exceed 29.99%."
  },
  "benefits": [
    {
      "name": "Car Rental Loss and Damage Insurance",
      "description": "Coverage for damage or theft of a rental vehicle when you pay with the card; typically secondary coverage. Terms and exclusions apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Insurance Plan",
      "description": "Insurance for lost, damaged, or stolen baggage on eligible travel itineraries when you pay with the card. Terms and exclusions apply.",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Eligible purchases are covered against accidental damage or theft for a limited period after the purchase date. Terms and exclusions apply.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends the original manufacturer\u2019s warranty on eligible purchases. Terms and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Return Protection",
      "description": "If a merchant won\u2019t accept a return, you may be refunded for eligible items purchased with the card within a specified window. Terms and exclusions apply.",
      "benefit_type": "return_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Assist Hotline",
      "description": "24/7 coordination and assistance services for travel; third\u2011party costs are the cardholder\u2019s responsibility. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "global_assist_hotline",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "No Amex foreign transaction fees on purchases made outside the U.S. Merchant/ATM fees may still apply.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lowest Hotel Rates Guarantee (Amex Travel)",
      "description": "If you book a qualifying hotel on Amex Travel and find a lower publicly available rate for the same room and terms, Amex will refund the difference. Terms apply.",
      "benefit_type": null,
      "new_benefit_type": "lowest_hotel_rates_guarantee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amazon Business Enhanced Data Views",
      "description": "Item\u2011level detail for Amazon Business purchases appears on your Amex statement to help simplify reconciliation.",
      "benefit_type": null,
      "new_benefit_type": "amazon_enhanced_data_views",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amazon Shop with Points",
      "description": "Redeem your % Back rewards as points at checkout on Amazon.com and Amazon Business or as a statement credit.",
      "benefit_type": null,
      "new_benefit_type": "amazon_shop_with_points",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Presale Tickets",
      "description": "Access to purchase tickets for select events during a presale window when using an eligible Amex card. Availability and terms vary by event.",
      "benefit_type": null,
      "new_benefit_type": "amex_presale_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Reserved Tickets",
      "description": "Access to select seats for certain events when using an eligible Amex card. Availability and terms vary by event.",
      "benefit_type": null,
      "new_benefit_type": "amex_reserved_tickets",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Venue Collection Entrances & Fast Lanes",
      "description": "Dedicated Amex Card Member entrances/fast lanes at select venues in the Amex Venue Collection. Availability varies by venue/event; valid event ticket required.",
      "benefit_type": null,
      "new_benefit_type": "amex_venue_collection_fast_lanes",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "American Express Venue Collection Concessions Statement Credit",
      "description": "Earn 10% back as a statement credit on qualifying food and beverage concessions purchases at participating Amex Venue Collection stadiums/arenas, up to $250 back per calendar year after enrollment. Offer ends 12/31/2026. Terms apply.",
      "credit_type": "american_express_venue_collection_concessions",
      "credit_category": null,
      "new_credit_category": "entertainment_concessions",
      "value": 250.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Get a $100 Amazon Gift Card upon approval for the Amazon Business American Express Card (no minimum spend required). Gift card is loaded to the Amazon account used to apply; cannot be used to purchase other gift cards. Terms apply.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "gift_card",
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusiness",
  "learn_more_link": "https://www.americanexpress.com/us/credit-cards/business/business-credit-cards/amazon-business-card/?linknav=US-Acq-GCP-BusinessCards-ViewAllCards-LearnMore-AmazonBusiness",
  "terms_and_conditions_link": "https://www.americanexpress.com/us/credit-cards/card-application/apply/partner/print/business-card/microsite/amz/amazon-core-business-credit-card/ep-45094?print=false#offer-terms",
  "terms_and_conditions_button_text": "Offer & Benefit Terms",
  "additional_links": [
    {
      "name": "Rates & Fees",
      "url": "https://www.americanexpress.com/us/credit-cards/card-application/apply/partner/print/business-card/microsite/amz/amazon-core-business-credit-card/ep-45094?print=false"
    }
  ],
  "bank_name": "American Express",
  "imageName": "amazon_business_card.png"
},
  [CreditCard.MILES_MOREWORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.MILES_MOREWORLD_ELITE_MASTERCARD,
  "name": "Miles & More\u00ae World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/LFT_card_rCMY_Lufthansa_359x246_angled_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.LUFTHANSA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.airDolomiti",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.austrianAirlines",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.brusselsAirlines",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.croatiaAirlines",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.eurowings",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.lotPolishAirlines",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.lufthansa",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.luxair",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.swissInternationalAirLines",
      "earnRate": 2.0,
      "description": "Earn 2 miles per $1 spent on tickets purchased directly from Miles & More partner airlines (Air Dolomiti, Austrian Airlines, Brussels Airlines, Croatia Airlines, Eurowings, LOT Polish Airlines, Lufthansa, Luxair, SWISS).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1 mile per $1 on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 89.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 89.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchases: variable APR 0.2024\u20130.2999 based on creditworthiness; Balance transfers: 0.0 introductory APR for 15 billing cycles on transfers that post within 45 days of account opening, then variable 0.2024\u20130.2999; Cash advances: variable 0.2999. APRs vary with the Prime Rate. Minimum interest charge $0.50."
  },
  "benefits": [
    {
      "name": "Lufthansa Business Lounge vouchers",
      "description": "Receive two complimentary Lufthansa Business Lounge vouchers each year. Estimated value ~$80\u2013$120 total assuming ~$40\u2013$60 per lounge visit; actual value depends on airport and lounge access policies. Terms apply.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Economy Companion Ticket",
      "description": "Receive an Economy Class Companion Ticket after each account anniversary (taxes and fees apply). Valid for travel on the Lufthansa Group; value varies widely because taxes/fees can be substantial. Rough estimate: $50\u2013$200 in savings on typical economy itineraries, but can be more or less depending on route/fare.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fee on international purchases. Estimated value: avoids the typical 3% fee many cards charge (e.g., $5,000 abroad spend saves ~$150).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Convert miles to status points annually",
      "description": "Once each calendar year, convert 5,000\u201325,000 miles earned on purchases into 20\u2013100 Points + 20\u2013100 Qualifying Points to help with Miles & More status qualification.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual fee waiver for elites",
      "description": "Annual fee is waived for Miles & More Senator and HON Circle Members while that status is maintained. Estimated value: $89 per year during eligible years.",
      "benefit_type": null,
      "new_benefit_type": "annual_fee_waiver_for_senator_and_hon_circle",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 60,000 miles if you spend $3,000 in purchases and pay the annual fee in full, both within the first 90 days.",
      "rewards": [
        {
          "reward_type": "lufthansa",
          "new_reward_type": null,
          "amount": 60000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/lufthansa-miles-more-world-elite-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/lufthansa-miles-more-world-elite-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "miles_moreworld_elite_mastercard.png"
},
  [CreditCard.CAPITAL_ONE_SAVOR_ONE_REWARDS]: {
  "id": CreditCard.CAPITAL_ONE_SAVOR_ONE_REWARDS,
  "name": "SavorOne Rewards from Capital One",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/savorone-2025-cardart.png",
  "recommendedMinCreditScore": "Fair",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "Earn 3% cash back on dining purchases at restaurants, cafes, bars, lounges, fast-food chains and bakeries. Based on merchant category codes; some merchants within larger establishments may not code as dining.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "Earn 3% cash back at grocery stores (supermarkets, meat lockers, freezer, dairy product stores and specialty markets). Excludes superstores like Walmart and Target.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "entertainment",
      "earnRate": 3.0,
      "description": "Earn 3% cash back on entertainment purchases including tickets from movie theaters, professional and semi-professional sports promoters, theatrical promoters, amusement parks, tourist attractions, aquariums, zoos, dance halls, record stores, pool halls and bowling alleys. Excludes golf courses, collegiate sporting events and non-industry entertainment merchant codes like cable, digital streaming and membership services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 3.0,
      "description": "Earn 3% cash back on popular streaming services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% cash back on all other purchases not in the 3% or 8% categories.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 39.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 39.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "Purchase APR: 29.74% variable"
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "You won\u2019t pay a transaction fee when making a purchase outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary concierge service",
      "description": "24/7 personalized assistance for dining, entertainment and travel.",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty",
      "description": "Additional warranty protection at no charge on eligible items purchased with the card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel accident insurance",
      "description": "Automatic insurance for a covered loss when you use the card to purchase your fare.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining access",
      "description": "Access to cardholder-only reservations at award\u2011winning restaurants and tickets to curated culinary events.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment access",
      "description": "Access to Capital One Entertainment for tickets to music, sports and events, with cardholder perks.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Travel portal access",
      "description": "Book travel through Capital One Travel with low prices and flexible redemption using rewards, card or both.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_travel_portal_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Redeem rewards with PayPal",
      "description": "Use your Capital One rewards to pay at millions of online stores when you checkout with PayPal.",
      "benefit_type": null,
      "new_benefit_type": "redeem_rewards_with_paypal",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Use rewards at Amazon.com",
      "description": "Pay for Amazon.com purchases using Capital One rewards.",
      "benefit_type": null,
      "new_benefit_type": "redeem_rewards_at_amazon",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Rewards don\u2019t expire",
      "description": "Cash back doesn\u2019t expire for the life of the account.",
      "benefit_type": null,
      "new_benefit_type": "rewards_dont_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Redeem any amount",
      "description": "Redeem cash back for any amount as a statement credit, check, gift cards or to cover a recent purchase.",
      "benefit_type": null,
      "new_benefit_type": "redeem_any_amount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Caf\u00e9s beverage discount",
      "description": "50% off all handcrafted beverages at Capital One Caf\u00e9s nationwide when paying with a Capital One card; limit one per person, while supplies last.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/savorone/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/savorone/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "capital_one_savor_one_rewards.avif"
},
  [CreditCard.FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD,
  "name": "Free Spirit\u00ae Travel More World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/ragb_eltcm_mc_blk_250.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.SPIRIT_AIRLINES,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.spirit",
      "earnRate": 3.0,
      "description": "Eligible Spirit purchases include Spirit Airlines tickets and fees billed by Spirit as merchant of record; onboard purchases (food, beverages, Wi\u2011Fi); eligible Spirit SeatBid purchases; and eligible Spirit vacation packages, hotels, and rental cars booked via Spirit.com or Spirit Vacations phone line. Purchases made through third parties (e.g., online travel agencies) or where the MCC is not passed may not qualify. No cap; points credited to primary cardholder\u2019s Free Spirit account.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Dining includes restaurants (including fast food), bars/taverns, and catering based on merchant category code. Purchases that do not process under an eligible MCC or that process through unsupported third-party payment accounts/digital wallets may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "Grocery stores include supermarkets, freezer/meat lockers, candy/nut/confection stores, dairy product stores, bakeries, and miscellaneous food stores based on MCC. Excludes wholesale clubs, superstores, and smaller stores (e.g., drugstores and convenience stores) that sell groceries, and Spirit onboard purchases. Transactions that do not process under an eligible MCC or that process through unsupported third-party payment accounts/digital wallets may not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Base rate on purchases that do not qualify for a higher category. Balance transfers, cash advances, fees, interest, fraudulent transactions, and other non-purchase charges do not earn points.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 79.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.2024
  },
  "annualFee": 79.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2824,
    "description": "Variable APRs that move with the Prime Rate. Purchases: 0.2024\u20130.2824 based on creditworthiness. Balance transfers: 0.2024\u20130.2824. Cash advances: 0.2324\u20130.2824 (Direct Deposit/Check) and 0.2824 for Bank Cash Advances. Penalty APR up to 0.2999 may apply indefinitely after a late payment. No introductory 0% APR; interest on balance transfers and cash advances accrues from the transaction date."
  },
  "benefits": [
    {
      "name": "Up to two free checked bags (primary cardholder)",
      "description": "Primary cardholder may check up to two bags free on qualifying Spirit reservations booked directly with Spirit; card must be open and linked to the Free Spirit account (linking may take up to 7 days). Only applies to the primary cardholder; baggage rules and restrictions apply.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 2 Priority Boarding",
      "description": "Primary cardholder and companions on the same reservation receive Group 2 priority boarding when the account is open and the primary cardholder is the primary passenger.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Check-In",
      "description": "Access priority check-in at participating airports by presenting the valid Free Spirit Mastercard at check-in; applies to you and accompanied guests.",
      "benefit_type": null,
      "new_benefit_type": "priority_check_in",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% in\u2011flight food & beverage rebate",
      "description": "Get a 25% rebate as a statement credit for Spirit in\u2011flight food and beverage purchases when paid with the card; credit typically posts within 7 days. Est. value: saves $2.50 per $10 spent onboard.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual $100 Companion Flight Voucher (with spend)",
      "description": "Receive a $100 Companion Flight Voucher each account anniversary after at least $5,000 in net purchases in the prior anniversary year; code valid for 12 months and applied to a companion fare (taxes/fees excluded) on the same paid itinerary booked on Spirit.com. Est. value: up to $100 per year if used.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": 5000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn Status Qualifying Points (SQPs) via spend",
      "description": "Earn 1 SQP per $10 in net purchases toward Free Spirit elite status; unlimited SQPs per year. Silver at 2,000 SQPs ($20,000 spend) and Gold at 5,000 SQPs ($50,000 spend). Status valid for remainder of qualifying year and the next calendar year.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points Pooling access",
      "description": "Eligible to create/manage a pool with up to 8 additional Free Spirit members to combine points for redemptions on Spirit.com; subject to Points Pooling terms.",
      "benefit_type": null,
      "new_benefit_type": "points_pooling",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay no foreign transaction fees on purchases made outside the U.S.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No points expiration while account open",
      "description": "Free Spirit points earned on the card do not expire as long as the credit card account remains open; points may be forfeited if the account is closed.",
      "benefit_type": null,
      "new_benefit_type": "no_points_expiration",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "In-flight food & beverage rebate (mechanics)",
      "description": "Operational note: The 25% in-flight savings is delivered as a statement credit within ~7 days when paying with the card.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 25.0,
      "value_unit": "percent_rebate",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Companion Flight Voucher (anniversary)",
      "description": "$100 Companion Flight Voucher issued after $5,000 prior-anniversary-year spend; valid 12 months, applies to a companion fare on the same paid itinerary; taxes/fees extra.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": 5000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Online offer: Earn 50,000 bonus points plus a $100 Companion Flight Voucher after at least $1,000 in purchases within 90 days of account opening. Limit 1 offer per new account; purchases only (no BTs/Cash Advances). Account must be open and primary cardholder must have a valid email with Spirit; rewards usually post 1\u20132 billing cycles after qualification. Estimated value \u2248 $600 assuming Spirit points at ~1.0\u00a2 each ($500) + $100 voucher; actual value varies by route, fare type, and redemption timing.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 50000.0,
          "value_unit": "points"
        },
        {
          "reward_type": null,
          "new_reward_type": "companion_flight_voucher",
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/apply-now-services/credit-cards/initialize-icai?requesttype=C&campaignid=4070592&productoffercode=Y9&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/spirit-airlines-credit-card/",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4070592&productoffercode=Y9&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Free Spirit\u00ae Travel More World Elite Mastercard\u00ae",
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "free_spirit_travel_more_world_elite_mastercard.png"
},
  [CreditCard.REFLECT_CARD]: {
  "id": CreditCard.REFLECT_CARD,
  "name": "Wells Fargo Reflect\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.wellsfargo.com/W-Card-MarketPlace/v9-10-25/images/Products/Reflect/Reflect_homepage.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2874,
    "apr_low": 0.1699
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1699,
    "high": 0.2874,
    "description": "0.0 intro APR for 21 months from account opening on purchases and qualifying balance transfers; then variable APR 0.1699, 0.2349, or 0.2874 based on creditworthiness (varies with U.S. Prime Rate). Cash advances/overdraft advances APR 0.2999 variable. Minimum interest charge $1. Grace period: at least 25 days on purchases if you pay your entire balance by the due date; no grace period on balance transfers (interest begins when the balance transfer posts). Balance transfers must be requested within 120 days of account opening to qualify for the intro APR. Late payment fee up to $40. Balance transfers are subject to a 0.05 fee (min $5) and do not earn rewards."
  },
  "benefits": [
    {
      "name": "Cellular Telephone Protection",
      "description": "Up to $600 per claim (max 2 claims and $1,200 per 12-month period) for damage, theft, or involuntary and accidental parting when you pay your monthly wireless bill with the card; $25 deductible per approved claim. Coverage starts the first day of the calendar month after you pay your first wireless bill with the card and continues while you keep charging your bill. Exclusions include cosmetic damage, cracked screens, scratches, electronic failure/software issues, and phones that are simply lost (mysteriously disappear). Estimated value: up to $1,200/year maximum protection potential, subject to claims limits and deductibles.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside Dispatch",
      "description": "24/7 access to pay-per-use towing and roadside assistance; standard service fee confirmed at time of request. Vehicles up to 10,000 lbs; mileage beyond 5 miles may incur additional charges; availability may vary; service provider is responsible for service delivery.",
      "benefit_type": null,
      "new_benefit_type": "roadside_dispatch",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "My Wells Fargo Deals",
      "description": "Access to targeted, opt-in merchant offers that can earn cash back as a statement credit when activated and paid with the eligible card. Must activate each deal and meet the specific terms; credits generally post within 60 days; certain payment methods (e.g., some digital wallets/third-party processors) may not qualify.",
      "benefit_type": null,
      "new_benefit_type": "merchant_offers_portal",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://apply.wellsfargo.com/getting_started?FPID=013000IGF80000&applicationtype=consumercreditcard&product_code=CC&subproduct_code=VV&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "learn_more_link": "https://creditcards.wellsfargo.com/reflect-visa-credit-card/?FPID=013000IGF80000&product_code=CC&subproduct_code=VV&cx_nm=CXNAME_CSMPD_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_link": "https://www.wellsfargo.com/credit-cards/reflect-visa/terms/?FPID=013000IGF80000&product_code=CC&subproduct_code=VV&cx_nm=CXNAME_CSMHP_MC_CG&sub_channel=SEO&vendor_code=G",
  "terms_and_conditions_button_text": "Important Credit Terms",
  "additional_links": [],
  "bank_name": "Wells Fargo",
  "imageName": "reflect_card.png"
},
  [CreditCard.UPROMISEWORLD_MASTERCARD]: {
  "id": CreditCard.UPROMISEWORLD_MASTERCARD,
  "name": "Upromise\u00ae World Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/UPR_card_rRGB_Upromise_WM_angled_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 1.25,
      "description": "Earn 1.25% bonus cash back rewards on all purchases if your Upromise Program account is not linked to a College Savings Plan.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "not_linked_to_college_savings_plan"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.529,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Earn 1.529% bonus cash back rewards on all purchases if your Upromise Program account is linked to an eligible College Savings Plan.",
          "promotional_type": PromotionalType.UPROMISE_COLLEGE_SAVINGS_PLAN
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.1924
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1924,
    "high": 0.2999,
    "description": "Variable APRs: purchases 0.1924\u20130.2999 based on creditworthiness; cash advances 0.2999. APRs vary with the Prime Rate; minimum monthly interest charge $0.50."
  },
  "benefits": [
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fee on international purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Up to $250 cash back per calendar year at MyGiftCardsPlus",
      "description": "Get up to $250 in cash back rewards per calendar year on eligible gift card purchases at MyGiftCardsPlus, powered by Upromise. Conditions and limitations apply; benefit provided and administered by Upromise.",
      "benefit_type": null,
      "new_benefit_type": "mygiftcardsplus_annual_cash_back",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Upromise Round Up feature",
      "description": "Round up purchases to the nearest dollar (limit set by you from $1 to $500). The total Round Up amount is treated as a purchase and converted to cash back rewards.",
      "benefit_type": null,
      "new_benefit_type": "round_up_feature",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Fraud Liability",
      "description": "You are not responsible for unauthorized charges.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn $100 bonus cash back after spending $500 on purchases in the first 90 days. Estimated value: $100 (cash). Offer may be earned once; additional issuer terms and limitations apply.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/upromise-world-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/upromise-world-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "upromiseworld_mastercard.png"
},
  [CreditCard.WYNDHAM_REWARDS_EARNER_BUSINESS_CARD]: {
  "id": CreditCard.WYNDHAM_REWARDS_EARNER_BUSINESS_CARD,
  "name": "Wyndham Rewards Earner\u00ae Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/BWY_card_rRGB_EarnerBusiness_VS_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.WYNDHAM,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel.wyndham",
      "earnRate": 8.0,
      "description": "8x points per $1 on eligible purchases made at Hotels by Wyndham.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 8.0,
      "description": "8x points per $1 on qualifying gas purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "onlineAdvertising",
      "earnRate": 5.0,
      "description": "5x points per $1 on eligible marketing and advertising purchases. Online advertising is included; issuer language suggests broader advertising may also qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "billsAndUtilities",
      "earnRate": 5.0,
      "description": "5x points per $1 on eligible utility payments.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x point per $1 on all other purchases, excluding Wyndham Timeshare resort down payments.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.03,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Variable purchase APR 0.2024\u20130.2999 based on creditworthiness; varies with Prime Rate. Promotional 0% APR for 6 billing cycles on Wyndham Timeshare Purchases only; afterward 0.2024\u20130.2999 variable. Balance transfer APR 0.2024\u20130.2999 variable. Cash advance APR 0.2999 variable. Minimum interest charge $1. Balance transfer fee 3% (min $5). Cash advance fee 3% (min $10)."
  },
  "benefits": [
    {
      "name": "Anniversary points bonus",
      "description": "Receive 15,000 Wyndham Rewards points each anniversary year. Estimated value \u2248 $135 assuming 0.9 cents/point; actual value varies by redemption.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Automatic Wyndham Rewards DIAMOND status",
      "description": "Automatic DIAMOND member level with perks like suite upgrades and a welcome amenity at check-in (per Wyndham program terms).",
      "benefit_type": "hotel_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10% award redemption discount",
      "description": "Redeem 10% fewer points when you book free nights at participating properties. Example: a 15,000\u2011point night costs 13,500 points (saves 1,500 points \u2248 $13.50 at 0.9 cpp).",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember hotel rate discount",
      "description": "Cardmembers can save off the Standard Rate at participating Hotels by Wyndham (discount percentage not specified; varies by property and dates).",
      "benefit_type": null,
      "new_benefit_type": "hotel_rate_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases (potential savings around 3% compared to cards that charge such fees).",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty protection",
      "description": "Extended warranty on eligible purchases; see Guide to Benefits for coverage and exclusions.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa SavingsEdge discounts",
      "description": "Access to Visa SavingsEdge program that provides automatic discounts on qualifying business purchases.",
      "benefit_type": null,
      "new_benefit_type": "visa_savingsedge_business_discounts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free employee cards",
      "description": "Add employee cards at no additional cost for expense control and tracking.",
      "benefit_type": null,
      "new_benefit_type": "free_employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Zero liability protection",
      "description": "You\u2019re not responsible for unauthorized charges.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 3000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 45,000 Wyndham Rewards bonus points after spending $3,000 on purchases and paying the annual fee in full within the first 90 days. Estimated value \u2248 $405 at 0.9 cents/point (value varies by redemption). Free nights can require up to 30,000 points per bedroom; resort fees may apply and can\u2019t be paid with points.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 45000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-business-card/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/wyndham-rewards-earner-business-card/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "wyndham_rewards_earner_business_card.png"
},
  [CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD]: {
  "id": CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD,
  "name": "Hawaiian Airlines\u00ae World Elite Mastercard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://cards.barclaycardus.com/content/dam/bcuspublic/card-plastic/card-angled/HCL_card_PremWhite_WE_Angle_359x246_L.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.ALASKA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.hawaiian",
      "earnRate": 3.0,
      "description": "Earn on eligible Hawaiian Airlines purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.alaska",
      "earnRate": 3.0,
      "description": "Earn on eligible Alaska Airlines purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Earn on gas purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "Earn on dining purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "Earn on eligible grocery store purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2999,
    "apr_low": 0.2024
  },
  "annualFee": 99.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2024,
    "high": 0.2999,
    "description": "Purchase APR: 0.2024\u20130.2999 variable (based on creditworthiness; varies with Prime Rate). Balance transfers: 0.0 intro APR for 15 billing cycles on transfers that post within 45 days of account opening; thereafter 0.2024\u20130.2999 variable (varies with Prime Rate). Cash advance APR: 0.2999 variable. Minimum interest charge: $0.50."
  },
  "benefits": [
    {
      "name": "Two free checked bags on Hawaiian and Alaska",
      "description": "Receive two free checked bags, including sports equipment, when you use your card to purchase tickets directly from Hawaiian Airlines or Alaska Airlines. Potential value estimate: ~$60\u2013$80 one-way per traveler (assuming ~$30\u2013$40 per checked bag), or ~$120\u2013$160 roundtrip; actual savings depend on route and baggage policies.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Annual companion fare discount (Hawaiian, anniversary)",
      "description": "Companion discount for roundtrip travel between Hawaii and North America on Hawaiian Airlines after each account anniversary. Amount not shown in source. Historical public offers have been $100 off; treat $100 as an estimate only. Estimated value: ~$100 per year if used.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "One\u2011time companion fare discount (Hawaiian, new card)",
      "description": "One-time companion discount for roundtrip travel between Hawaii and North America on Hawaiian Airlines. Amount not shown in source. Historically this has been a 50% off companion discount; treat 50% off as an estimate only. Estimated savings vary widely by fare.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Earn elite\u2011qualifying miles from spend",
      "description": "Cardmembers earn 1 elite\u2011qualifying mile for every $3 spent toward airline elite status. Program note: On Oct. 1, 2025, HawaiianMiles transitions to Alaska\u2019s Atmos Rewards.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "0% foreign transaction fees on international purchases. Typical savings vs. cards that charge ~3% FTF: $30 per $1,000 spent abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Miles never expire",
      "description": "HawaiianMiles do not expire (program migrating to Alaska\u2019s Atmos Rewards on Oct. 1, 2025).",
      "benefit_type": null,
      "new_benefit_type": "points_do_not_expire",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 2500.0,
      "spendRequirementMonths": 3,
      "description": "Earn up to 80,000 HawaiianMiles: 80,000 miles after $2,500 in purchases in the first 90 days, plus 30,000 miles after $5,000 total purchases in the first 180 days. Estimated value: about $960 at 1.2\u00a2 per mile (range ~$800\u2013$1,040 at 1.0\u20131.3\u00a2/mile), before taxes/fees and based on award availability.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "miles"
        }
      ]
    },
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 6,
      "description": "Earn up to 80,000 HawaiianMiles: 80,000 miles after $2,500 in purchases in the first 90 days, plus 30,000 miles after $5,000 total purchases in the first 180 days. Estimated value: about $960 at 1.2\u00a2 per mile (range ~$800\u2013$1,040 at 1.0\u20131.3\u00a2/mile), before taxes/fees and based on award availability.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 30000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-mastercard/",
  "learn_more_link": "https://cards.barclaycardus.com/banking/cards/hawaiian-airlines-world-elite-mastercard/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Barclays",
  "imageName": "hawaiian_airlines_world_elite_mastercard.png"
},
  [CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS]: {
  "id": CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS,
  "name": "Bank of America\u00ae Customized Cash Rewards Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/CreditCardArt/en_US/Approved_PCM/8ckn_cshsigcm_v_250x158.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 3.0,
      "description": "Ongoing 3% cash back in your selected Choice Category after the first 12 months. The $2,500 quarterly cap is combined across Choice Category and the 2% Grocery/Wholesale Club category; after the cap, purchases earn 1% for the rest of the quarter. An additional 3% boost applies during the first 12 months (modeled via signup bonus earn rate fields) before reverting to 3%.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 4.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 5.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": 3.0,
      "signupBonusEarnRateIncreaseDurationMonths": 12,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          {
            "categories": [
              "gas"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas and EV charging stations (EV charging included with gas)."
          },
          {
            "categories": [
              "onlineShopping"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": true,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Online Shopping: purchases must be made online via website or app; excludes phone/mail orders, in\u2011person purchases (including in-store mobile wallet/contactless). Some non-retail services are excluded (e.g., doctors/hospitals, government/taxes, insurance, memberships, education/schools, some utilities)."
          },
          "dining",
          "travel",
          "drugstore",
          {
            "categories": [
              "homeImprovement",
              "homeFurnishings"
            ],
            "exclude_subcategories": null,
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Home improvement and home furnishings merchants."
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.MONTHLY,
        "categoriesDescription": "Choice of one category: Gas & EV charging; Online Shopping (includes cable, internet, phone plans, streaming under the online channel); Dining; Travel; Drug Stores; or Home Improvement & Furnishings. Default is Gas & EV Charging at account opening. Choice can be changed once per calendar month.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "grocery",
      "earnRate": 2.0,
      "description": "2% cash back at grocery stores and wholesale clubs. Excludes superstores and smaller stores (e.g., drugstores) that sell groceries and other products. The $2,500 quarterly cap is combined with the Choice Category cap; after the cap, purchases earn 1% for the rest of the quarter.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "wholesaleClub",
      "earnRate": 2.0,
      "description": "2% cash back at grocery stores and wholesale clubs. Excludes superstores and smaller stores (e.g., drugstores) that sell groceries and other products. The $2,500 quarterly cap is combined with the Choice Category cap; after the cap, purchases earn 1% for the rest of the quarter.",
      "spendCap": 2500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": 1,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 3.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 3.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Unlimited 1% cash back on all other purchases (and on Choice/Grocery/Wholesale Club purchases after the quarterly cap is reached).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 20000.0,
          "description": "Preferred Rewards Gold (25% bonus): 25% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD
        },
        {
          "earnRate": 1.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 50000.0,
          "description": "Preferred Rewards Platinum (50% bonus): 50% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM
        },
        {
          "earnRate": 1.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": 100000.0,
          "description": "Preferred Rewards Platinum Honors (75% bonus): 75% bonus applied to base earnings for this category. Requires a 3-month combined average daily balance meeting the tier minimum.",
          "promotional_type": PromotionalType.BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2824,
    "apr_low": 0.1824
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1824,
    "high": 0.2824,
    "description": "0% intro APR for 15 billing cycles on purchases and on balance transfers made within 60 days of account opening; then variable APR 0.1824\u20130.2824 based on creditworthiness (varies with Prime). Penalty APR up to 0.2999. Cash advance APR 0.2124\u20130.2924 for Direct Deposit/Check Cash Advances and 0.2924 for Bank Cash Advances. Balance transfer fee 0.03 intro for first 60 days, then 0.04. Foreign transaction fee 0.03. Payment allocation: minimum to lower-APR balances first; excess to higher-APR balances. Monthly Custom Pay Plan fee: 0.0172 of purchases assigned to a plan (fixed finance charge)."
  },
  "benefits": [
    {
      "name": "Bank of America Preferred Rewards bonus (25%-75% more cash back)",
      "description": "Bank of America Preferred Rewards members earn 25%-75% more cash back on every purchase. The Preferred Rewards bonus is not applied to the additional 3% first-year choice category offer.",
      "benefit_type": "bank_of_america_preferred_rewards",
      "new_benefit_type": "bank_of_america_preferred_rewards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "$200 online cash rewards bonus after making at least $1,000 in purchases in the first 90 days of account opening. Purchases only (excludes balance transfers, cash advances, fees). Limit one per new account; account must be open and in good standing to receive. Credited within 1\u20132 billing cycles after qualifying. Estimated value: $200 (paid as cash rewards).",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://secure.bankofamerica.com/ogateway/public/apply-now-services/iaoconsumer/rest/public/usa/initialize/cc/v1?requesttype=usa&campaignId=4076366&productOfferCode=P5&locale=en_US",
  "learn_more_link": "https://www.bankofamerica.com/credit-cards/products/cash-back-credit-card/?campaign=4076366~P5~en_US",
  "terms_and_conditions_link": "https://www.bankofamerica.com/credit-cards/terms-and-conditions/?campaignid=4076366&productoffercode=P5&locale=en_US",
  "terms_and_conditions_button_text": "\u2020 Terms & Conditions for Bank of America\u00ae Customized Cash Rewards credit card",
  "additional_links": [
    {
      "name": "Calculate rewards",
      "url": "https://www.bankofamerica.com/credit-cards/products/cash-back-credit-card//?campaign=4076366~P5~en_US#headlineCcalcModule"
    }
  ],
  "bank_name": "Bank of America",
  "imageName": "bank_of_america_customized_cash_rewards.png"
},
  [CreditCard.SYNCHRONY_AT_HOME_INSIDER_PERKS_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_AT_HOME_INSIDER_PERKS_CREDIT_CARD,
  "name": "At Home Insider Perks\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://static.athome.com/image/upload/f_auto,q_auto/v1637257599/webcontent/Loyalty2/credit-card-footer.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "Earn three (3) points per $1 on purchases made at merchants and services where Mastercard is accepted, excluding At Home purchases (which earn 5%). Points apply to net purchases; certificates issue at $5 per 500 points and are valid 90 days; up to four certificates can be issued per statement month.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "mastercard_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.3399
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3399,
    "high": 0.3399,
    "description": "New Accounts as of 1/30/2025: Variable Purchase APR 33.99% (0.3399). Variable Penalty APR 39.99% (0.3999). Minimum interest charge $2. At Home Insider Perks Mastercard: Variable Cash APR 33.99% (0.3399) and cash advance fee 5% ($10 min). Deferred-interest promo: No interest if paid in full within 6 months on At Home purchases of $299+; otherwise interest is charged from the purchase date; minimum monthly payments required."
  },
  "benefits": [
    {
      "name": "6 Months Special Financing on $299+ At Home purchases",
      "description": "Deferred-interest promotion: No interest if paid in full within 6 months on At Home purchases of $299 or more; interest accrues from purchase date if not paid in full; minimum monthly payments required.",
      "benefit_type": null,
      "new_benefit_type": "special_financing_deferred_interest",
      "spend_requirement": 299,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Annual Fee",
      "description": "No annual fee for the At Home Insider Perks Credit Card or Mastercard versions.",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Limited-time (through 10/30/2025) new-account offer: 10% off your first purchase when you open an account, plus a $20 Bonus Reward (issued as an At Home reward certificate) after approval. 10% off is for new accounts only, one per customer; exclusions apply (e.g., gift cards, taxes, J.A. Henckels), and cannot be combined with other promos except markdown/clearance. $20 Bonus Reward requires approval by 10/30/2025; limit one per account; sent within up to two billing cycles. Estimated value example: on a $300 first purchase, discount \u2248 $30 + $20 reward \u2248 $50 total value.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percent_discount",
          "amount": 10.0,
          "value_unit": "percent"
        },
        {
          "reward_type": null,
          "new_reward_type": "store_reward_certificate",
          "amount": 20.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://apply.syf.com/eapply/eapply.action?clientCode=ATHOME&sitecode=ahhplmlan&icid=01996&intcmp=NoOff_AtHomeInsiderPerksCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://www.athome.com/creditcard.html?intcmp=NoOff_AtHomeInsiderPerksCreditCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Synchrony",
  "imageName": "synchrony_at_home_insider_perks_credit_card.png"
},
  [CreditCard.PLATINUM_SECURED]: {
  "id": CreditCard.PLATINUM_SECURED,
  "name": "Capital One Platinum Secured Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": true,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/plat_cardart_prim_323x203.png",
  "recommendedMinCreditScore": "no_credit_history",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2974,
    "apr_low": 0.2974
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2974,
    "high": 0.2974,
    "description": "Purchase APR 29.74% (variable). Interest is charged immediately on cash advances and special transfers. No 0% intro APR mentioned."
  },
  "benefits": [
    {
      "name": "Automatic Credit Line Reviews",
      "description": "Be automatically considered for a higher credit line in as little as 6 months based on responsible use.",
      "benefit_type": "credit_limit_increase",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No Foreign Transaction Fees",
      "description": "You won\u2019t pay a transaction fee when making a purchase outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Emergency Card Replacement",
      "description": "If your card is lost or stolen, you can get an emergency replacement card.",
      "benefit_type": null,
      "new_benefit_type": "emergency_card_replacement",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Virtual Card Numbers from Eno",
      "description": "Generate virtual card numbers for online purchases to keep your actual card number private.",
      "benefit_type": null,
      "new_benefit_type": "virtual_card_numbers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "50% off Handcrafted Beverages at Capital One Caf\u00e9s",
      "description": "Capital One cardholders get 50% off handcrafted beverages at Capital One Caf\u00e9s nationwide; limit one per person; while supplies last.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Potential Upgrade to Unsecured Card and Deposit Return",
      "description": "With responsible use, you could earn back your security deposit and be upgraded to a standard, unsecured Platinum card.",
      "benefit_type": null,
      "new_benefit_type": "security_deposit_refund_and_upgrade",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.capitalone.com/credit-cards/platinum-secured/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/platinum-secured/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "platinum_secured.png"
},
  [CreditCard.VENTURE_REWARDS]: {
  "id": CreditCard.VENTURE_REWARDS,
  "name": "Venture Rewards Travel Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/background-images/refresh/venture/e10.a-showcase-tab1-desktop-at-2x/tablet.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CAPITAL_ONE_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Unlimited 2 miles per dollar on every purchase; miles do not expire while the account remains open and in good standing.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "Earn 5 miles per dollar on hotel, vacation rental, and rental car bookings made through Capital One Travel. Flights are not included in this 5x earn rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "Earn 5 miles per dollar on hotel, vacation rental, and rental car bookings made through Capital One Travel. Flights are not included in this 5x earn rate.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Global Entry/TSA PreCheck credit",
      "description": "Receive up to a $120 statement credit for Global Entry or TSA PreCheck application fee once every four years (posts within two billing cycles; account must be open and in good standing). Est. value $120 per 4 years (~$30/year).",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Hertz Five Star status",
      "description": "Complimentary Hertz Five Star status upon enrollment via the Capital One benefits link; includes potential upgrades, shorter lines and wider vehicle selection. Status activation typically 24\u201372 hours after enrollment; duration per offer terms.",
      "benefit_type": "car_rental_status",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lifestyle Collection $50 experience credit",
      "description": "Receive a $50 experience credit per eligible stay when booking participating hotels or vacation rentals through Capital One Travel\u2019s Lifestyle Collection; may also include Wi\u2011Fi and, when available, room upgrades, early check\u2011in and late checkout. Hotel/host terms and minimum nights may apply.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Travel accident insurance",
      "description": "Automatic insurance for a covered loss when you use your card to purchase your fare; see Guide to Benefits for coverage details and exclusions.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Auto Rental Collision Damage Waiver",
      "description": "Coverage for damage due to collision or theft when renting an eligible vehicle with your card; terms vary by product\u2014see Guide to Benefits.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty protection",
      "description": "Additional warranty protection at no charge on eligible items purchased with your card; terms and exclusions apply.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No fees on purchases made outside of the United States.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points transfer to partners",
      "description": "Transfer miles to 15+ travel loyalty programs for more flexibility; once transferred, partner program terms and expirations apply.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Dining access",
      "description": "Access exclusive restaurant reservations and dining experiences for eligible Capital One cardholders; terms apply.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_dining_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Entertainment access",
      "description": "Access to presales, VIP packages and special events via Capital One Entertainment; through 12/31/25, qualifying purchases on the platform earn enhanced rewards (earning rate per promo; terms apply).",
      "benefit_type": null,
      "new_benefit_type": "capital_one_entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Caf\u00e9 beverage discount",
      "description": "50% off handcrafted beverages at Capital One Caf\u00e9s when paying with a Capital One card; limit one per person; while supplies last; see Caf\u00e9 terms.",
      "benefit_type": null,
      "new_benefit_type": "capital_one_cafe_beverage_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Capital One Offers (merchant offers)",
      "description": "Access to targeted merchant offers that can earn statement credits when shopping online at select retailers via Capital One Offers; availability and values vary.",
      "benefit_type": null,
      "new_benefit_type": "merchant_offers_portal",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Lifestyle Collection $50 experience credit",
      "description": "Receive a $50 experience credit per eligible stay when booking participating hotels or vacation rentals through Capital One Travel\u2019s Lifestyle Collection; may also include Wi\u2011Fi and, when available, room upgrades, early check\u2011in and late checkout. Hotel/host terms and minimum nights may apply.",
      "credit_category": null,
      "new_credit_category": "travel_credit",
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    },
    {
      "name": "Global Entry/TSA PreCheck credit",
      "description": "Up to $120 statement credit for Global Entry or TSA PreCheck application fee once every 4 years; posts within two billing cycles; account must be open and in good standing.",
      "credit_category": null,
      "new_credit_category": "government_trusted_traveler_program_fees",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 3,
      "description": "Earn 75,000 bonus miles after spending $4,000 on purchases within the first 3 months of account opening. Estimated value \u2248 $750 at 1.0\u00a2/mile (based on Capital One\u2019s own example valuation of 52,800 miles \u2248 $528); potential for higher value with transfer partners. Offer available via the \u201cApply Now\u201d link on the offer page; not available if you navigate away/close the page. Not available to existing/previous cardmembers who have received a new cardmember bonus on this product in the past 48 months.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 75000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/credit-cards/venture/",
  "learn_more_link": "https://www.capitalone.com/credit-cards/venture/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "venture_rewards.png"
},
  [CreditCard.VERIZON_VISA_CARD]: {
  "id": CreditCard.VERIZON_VISA_CARD,
  "name": "Verizon Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/verizon_visa_card.jpeg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "grocery",
      "earnRate": 4.0,
      "description": "4% in Verizon Dollars at grocery stores and supermarkets. MCC-based; grocery purchases at big-box retailers like Walmart or Target may not code as grocery. No caps or limits.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 4.0,
      "description": "4% in Verizon Dollars at gas stations (Service Stations/Automated Fuel Dispensers) and EV charging stations. Purchases at merchants coded as parking lots/garages may not qualify for EV charging. No caps or limits.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 4.0,
      "description": "4% in Verizon Dollars at restaurants, bars, fast food, and caterers. MCC-based; purchases in non-restaurant locations (e.g., a cafe inside a department store) may not code as dining. No caps or limits.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining.takeoutDelivery",
      "earnRate": 4.0,
      "description": "4% in Verizon Dollars on dining takeout and delivery purchases. Subject to MCC coding of the delivery/takeout merchant. No caps or limits.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "telecommunications.verizon",
      "earnRate": 4.0,
      "description": "4% in Verizon Dollars on Verizon purchases at Verizon-operated stores, Verizon online, over the phone with a Verizon representative, and exclusive Verizon Authorized Retailers. Includes devices and accessories. Excludes payment of Verizon Wireless or Verizon Fios account bills. No caps or limits.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "telecommunications.verizon",
      "earnRate": 1.0,
      "description": "1% in Verizon Dollars on Verizon Wireless account bill and Verizon Fios account bill payments only.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% in Verizon Dollars on all other purchases everywhere Visa is accepted, including big-box retailers such as Walmart or Best Buy that offer Verizon services. No caps or limits.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.2299
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2299,
    "high": 0.3399,
    "description": "For New Accounts as of 1/1/25: Variable Purchase APRs are 22.99%, 27.99% or 33.99% (based on creditworthiness). Variable Penalty APRs are 32.99%, 37.99% or 39.99%. Minimum Interest Charge $2. Variable Cash Advance APRs are 27.24%, 32.24% or 38.24% with a 5% cash advance fee ($10 min). Variable Balance Transfer APRs are 22.99%, 27.99% or 33.99% with a 5% balance transfer fee ($5 min)."
  },
  "benefits": [
    {
      "name": "Auto Pay discount when paying with Verizon Visa",
      "description": "New enrollees to Verizon\u2019s Auto Pay can get up to $10/month off each eligible wireless phone line (up to 12 lines depending on plan) and/or $10/month off each eligible Fios service when enrolled in Auto Pay and paper\u2011free billing using the Verizon Visa Card. Existing Auto Pay discounts via other methods won\u2019t stack. Potential value: up to $10 per line/service monthly.",
      "benefit_type": null,
      "new_benefit_type": "verizon_autopay_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "0% APR accessory financing (12 months)",
      "description": "0% APR with 12 equal monthly payments on Verizon accessory purchases totaling $100 or more on one receipt when charged to the Verizon Visa Card; Verizon Wireless account required. Promotional financing terms apply as disclosed by Verizon/Synchrony.",
      "benefit_type": null,
      "new_benefit_type": "0_percent_apr_accessory_financing",
      "spend_requirement": 100,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No foreign transaction fees on purchases, which can save around 3% compared to many cards that charge foreign transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Verizon TravelPass days (limited)",
      "description": "Card holders are eligible for certain limited free TravelPass days when using the Verizon Visa Card. Exact number of days and eligibility rules vary; see Verizon FAQs for current terms.",
      "benefit_type": null,
      "new_benefit_type": "verizon_travelpass_free_days",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Up to $150 in statement credits: $50 after your first purchase within 90 days of account opening, plus an additional $100 after $1,500 in qualifying purchases within the first 90 days. One offer per account; account must be open and in good standing when credits post. Credits post 1\u20132 billing cycles after qualifying. Available for applicants approved starting 1/23/2025; limited-time; statement credits can\u2019t be used to satisfy the required monthly payment and aren\u2019t redeemable for cash.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 50.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": 1500.0,
      "spendRequirementMonths": 3,
      "description": "Up to $150 in statement credits: $50 after your first purchase within 90 days of account opening, plus an additional $100 after $1,500 in qualifying purchases within the first 90 days. One offer per account; account must be open and in good standing when credits post. Credits post 1\u20132 billing cycles after qualifying. Available for applicants approved starting 1/23/2025; limited-time; statement credits can\u2019t be used to satisfy the required monthly payment and aren\u2019t redeemable for cash.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.verizon.com/solutions-and-services/verizon-visa-card/?intcmp=NoOff_VerizonVisaCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.verizon.com/solutions-and-services/verizon-visa-card/?intcmp=NoOff_VerizonVisaCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Rewards Program Terms & Conditions",
      "url": "https://www.verizon.com/support/verizon-visa-card-rewards-legal/"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "verizon_visa_card.jpeg"
},
  [CreditCard.VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD]: {
  "id": CreditCard.VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD,
  "name": "Vegas Golden Knights Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.creditonebank.com/content/dam/cob-corp-acquisition/images/cards/card-compare/vbc-visa-gold.png",
  "recommendedMinCreditScore": "Poor",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 1.0,
      "description": "Eligible gas station purchases coded as gasoline. Purchases at oil, propane, or home heating companies are not eligible. Transactions processed via warehouse clubs or discount supercenters (e.g., Walmart, Target, Costco) and PayPal are excluded. Rewards depend on merchant category coding; purchases without an eligible code will not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 1.0,
      "description": "Eligible grocery store purchases only; excludes purchases at superstores and at stores that sell groceries and other products (e.g., drugstores and convenience stores), and smaller specialty food shops (bakeries, candy/nut/confection stores). Purchases via warehouse clubs or discount supercenters (e.g., Walmart, Target, Costco) and PayPal are not eligible. Rewards eligibility depends on merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "phonePlans",
      "earnRate": 1.0,
      "description": "Eligible mobile phone service purchases. Transactions via warehouse clubs or discount supercenters (e.g., Walmart, Target, Costco) and PayPal are excluded. Rewards depend on merchant category coding; purchases without an eligible code will not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 1.0,
      "description": "Eligible internet, cable TV, and satellite TV service purchases. Transactions via warehouse clubs or discount supercenters (e.g., Walmart, Target, Costco) and PayPal are excluded. Rewards depend on merchant category coding; purchases without an eligible code will not qualify.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 99.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2949,
    "apr_low": 0.2949
  },
  "annualFee": 99.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2949,
    "high": 0.2949,
    "description": "Purchase APR 29.49% (variable), based on creditworthiness. Variable rates are accurate as of 8/31/2025."
  },
  "benefits": [
    {
      "name": "Vegas Born Perks: Exclusive offers, deals, and experiences for Vegas Golden Knights fans",
      "description": "Ongoing access to merchant offers/discounts for VGK fans, such as 20% off food at MacKenzie River Pizza at City National Arena (excludes alcohol), 10% off logo apparel at The Arsenal (excluding jerseys), 15% off at participating Grimaldi\u2019s Pizzeria locations in Southern Nevada, and 10% off wine purchases at FoleyFoodandWineSociety.com with sign-up. Offers are provided by participating merchants and may change or be withdrawn at any time. Estimated value varies based on usage (e.g., 15% off a $50 meal saves $7.50).",
      "benefit_type": null,
      "new_benefit_type": "merchant_offers_and_discounts",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free Experian IdentityWorks membership (online applicants)",
      "description": "Optional free membership in Experian IdentityWorks when you apply online and register through Experian; service operated by Experian and subject to change. Credit One Bank is not responsible for provision of the service. Estimated value depends on plan length and market pricing of identity monitoring services (often roughly $10\u2013$20/month), but exact value not specified by issuer.",
      "benefit_type": null,
      "new_benefit_type": "identity_theft_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.creditonebank.com/pre-qualification/data-entry/index?C1BSourceID=VGKX&C1BDescriptorID=AEA3806L00&C1BSpecificationID=bc-vgk",
  "learn_more_link": "https://www.creditonebank.com/credit-cards/vegas-golden-knights-visa",
  "terms_and_conditions_link": "https://www.creditonebank.com/terms/4e?pc=WGM3",
  "terms_and_conditions_button_text": "\u2020Terms, fees & conditions",
  "additional_links": [],
  "bank_name": "Credit One",
  "imageName": "vegas_golden_knights_credit_card.png"
},
  [CreditCard.THE_HOME_DEPOT_CONSUMER_CREDIT_CARD]: {
  "id": CreditCard.THE_HOME_DEPOT_CONSUMER_CREDIT_CARD,
  "name": "The Home Depot\u00ae Consumer Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/citi-home-depot-consumer/citi-home-depot-consumer_222x140.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2999,
    "apr_low": 0.2999
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2999,
    "high": 0.2999,
    "description": "Purchase APR 29.99%; minimum interest charge $2. Deferred-interest financing available: no interest if paid in full within the promotional period (6 months on purchases of $299+; up to 24 months during special promotions). Due date at least 25 days after the close of each billing cycle."
  },
  "benefits": [
    {
      "name": "1-year return window at The Home Depot",
      "description": "Cardmembers get 1 year to make returns (4x longer than the standard 3 months), subject to The Home Depot Returns Policy.",
      "benefit_type": null,
      "new_benefit_type": "extended_return_window",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "6-month special financing on $299+ purchases",
      "description": "No interest if paid in full within 6 months on qualifying purchases of $299 or more. Interest accrues from the purchase date if the promotional balance isn\u2019t paid in full by the end of the promo period.",
      "benefit_type": null,
      "new_benefit_type": "special_financing_deferred_interest",
      "spend_requirement": 299,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Up to 24-month financing during special promotions",
      "description": "Eligible purchases may qualify for extended promotional financing of up to 24 months during special promotions throughout the year. Terms vary by promotion.",
      "benefit_type": null,
      "new_benefit_type": "special_promotion_financing_up_to_24_months",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Choose your payment due date",
      "description": "Select an available due date in the beginning, middle, or end of the month; pay either the full balance or the minimum due each month.",
      "benefit_type": null,
      "new_benefit_type": "flexible_payment_due_date",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 liability on unauthorized charges",
      "description": "You won\u2019t be responsible for unauthorized charges on your account. See cardbenefits.citi.com for details.",
      "benefit_type": null,
      "new_benefit_type": "zero_liability_on_unauthorized_charges",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Limited Time Offer: Save up to $100 on your qualifying purchase when you open a new The Home Depot\u00ae Consumer Credit Card account. Actual discount depends on the qualifying purchase; maximum value is $100.",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 100.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://citiretailservices.citibankonline.com/apply/home-depot-credit-card?app=UNSOL&siteId=PLCN_HOMEDEPOT&sc=30005&cmp=W~P~Z~B~7~D~ZZZ0~AI~HD~ZZ_1D3",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-home-depot-consumer-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/citi-home-depot-consumer-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "the_home_depot_consumer_credit_card.png"
},
  [CreditCard.SYNCHRONY_H_O_M_E_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_H_O_M_E_CREDIT_CARD,
  "name": "Synchrony HOME\u2122 Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.DISCOVER,
  "creditCardImageUrl": "https://www.mysynchrony.com/mysyf/img/logo_syf-home-brand-mark.svg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [],
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Promotional financing at participating Synchrony HOME retailers",
      "description": "Subject to credit approval. Minimum monthly payments required. Promotional financing offers available at the time of purchase may vary by location; see store for details. Cards with the Synchrony HOME brand mark are accepted at thousands of locations nationwide.",
      "benefit_type": null,
      "new_benefit_type": "promotional_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.mysynchrony.com/home/partners.html",
  "learn_more_link": "https://www.mysynchrony.com/home/partners.html",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Synchrony",
  "imageName": "synchrony_car_care_credit_card.jpg"
},
  [CreditCard.ELAN_MAX_CASH_PREFERRED_VISA]: {
  "id": CreditCard.ELAN_MAX_CASH_PREFERRED_VISA,
  "name": "Elan Max Cash Preferred Visa",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/elan_max_cash_preferred_visa.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.US_BANK_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "selectable_categories",
      "earnRate": 5.0,
      "description": "5% cash back on up to $2,000 combined spent in two user-selected categories each quarter.",
      "spendCap": 2000.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 2,
        "categories": [
          {
            "categories": [
              "streaming",
              "internet",
              "cable"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "TV, Internet and Streaming Services"
          },
          {
            "categories": [
              "fast_food"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Fast Food"
          },
          {
            "categories": [
              "cell_phone"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Cell Phone Providers"
          },
          {
            "categories": [
              "department_store"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Department Stores"
          },
          {
            "categories": [
              "utilities"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Home Utilities"
          },
          {
            "categories": [
              "furniture"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Furniture Stores"
          },
          {
            "categories": [
              "electronics"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Electronics Stores"
          },
          {
            "categories": [
              "recreation"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Recreation"
          },
          {
            "categories": [
              "entertainment"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Entertainment"
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "Choose two of 9 categories each quarter for 5% cash back.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "travel",
      "earnRate": 5.0,
      "description": "5% cash back on travel booked through U.S. Bank's travel portal. No cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "selectable_categories",
      "earnRate": 2.0,
      "description": "2% cash back in one user-selected category each quarter. No cap. Categories: Supermarkets, Gas/EV/Ground Transportation, Restaurants.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": true,
        "applicableCategoryCount": 1,
        "categories": [
          {
            "categories": [
              "grocery"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Supermarkets (including Target and Walmart)"
          },
          {
            "categories": [
              "gas",
              "gas.evCharging",
              "travel.transit"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Gas, EV Charging and Ground Transportation"
          },
          {
            "categories": [
              "dining"
            ],
            "exclude_subcategories": [],
            "is_us_only": false,
            "is_online_only": false,
            "requires_travel_portal": false,
            "active_quarter": null,
            "start_date": null,
            "end_date": null,
            "category_description": "Restaurants"
          }
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": Frequency.QUARTERLY,
        "categoriesDescription": "Choose one of 3 categories each quarter for 2% cash back.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 500.0,
      "spendRequirementMonths": 3,
      "description": "$150 cash back after spending $500 in first 3 months.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 150.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.elanfinancialservices.com/consumer-cards/max-cash-preferred",
  "learn_more_link": "https://www.elanfinancialservices.com/consumer-cards/max-cash-preferred",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Elan",
  "imageName": "elan_max_cash_preferred_visa.jpg"
},
  [CreditCard.BMO_CASH_BACK_MASTERCARD]: {
  "id": CreditCard.BMO_CASH_BACK_MASTERCARD,
  "name": "BMO Cash Back Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/bmo_cash_back_mastercard.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "streaming",
      "earnRate": 5.0,
      "description": "5% cash back on eligible streaming, cable TV, and satellite services. No cap.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, and grocery purchases up to $1,500 combined per calendar quarter, then 1%.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.evCharging",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, and grocery purchases up to $1,500 combined per calendar quarter, then 1%.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "3% cash back on gas, EV charging, and grocery purchases up to $1,500 combined per calendar quarter, then 1%.",
      "spendCap": 1500.0,
      "spendCapResetFrequency": Frequency.QUARTERLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1% cash back on all other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2749,
    "apr_low": 0.1949
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.04,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1949,
    "high": 0.2749,
    "description": ""
  },
  "benefits": [
    {
      "name": "Cell Phone Protection",
      "description": "Up to $400 per claim ($50 deductible, max 2 claims per 12 months) when you pay your monthly cell phone bill with the card.",
      "benefit_type": null,
      "new_benefit_type": "cell_phone_protection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "$200 cash back after spending $1,000 in first 3 months.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": "https://www.bmo.com/en-us/main/personal/credit-cards/bmo-cash-back-credit-card",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "BMO",
  "imageName": "bmo_cash_back_mastercard.webp"
},
  [CreditCard.CITI_BLOOMINGDALES_CREDIT_CARDS]: {
  "id": CreditCard.CITI_BLOOMINGDALES_CREDIT_CARDS,
  "name": "Bloomingdale\u2019s American Express Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "https://www.citi.com/CRD/images/bloomingdales-amex/bloomingdales-amex_171x108.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [
    {
      "category": "bloomingdales",
      "earnRate": 3.0,
      "description": "Bloomingdale\u2019s purchases earn 3 points per $1 for Loyallist members; higher tiers earn more (see promotions).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Top of the List tier: 4 points per $1 spent at Bloomingdale\u2019s. 5,000 points = $25 Reward; rewards usable online or in-store at Bloomingdale\u2019s.",
          "promotional_type": PromotionalType.BLOOMINGDALES_TOP_OF_LIST_TIER
        },
        {
          "earnRate": 10.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Top of the List Unlocked tier: 10 points per $1 spent at Bloomingdale\u2019s. 5,000 points = $25 Reward; rewards usable online or in-store at Bloomingdale\u2019s.",
          "promotional_type": PromotionalType.BLOOMINGDALES_TOP_OF_LIST_TIER
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 3.0,
      "description": "Outside Bloomingdale\u2019s, Loyallist members earn 3 points per $1 with the Bloomingdale\u2019s American Express Card; higher tiers earn more (see promotions).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "amex_variant_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 4.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "Outside Bloomingdale\u2019s, Top of the List tier earns 4 points per $1 with the Bloomingdale\u2019s American Express Card. 5,000 points = $25 Reward; rewards usable online or in-store at Bloomingdale\u2019s.",
          "promotional_type": PromotionalType.BLOOMINGDALES_TOP_OF_LIST_TIER
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3349,
    "apr_low": 0.3349
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3349,
    "high": 0.3349,
    "description": "As of Dec 24, 2024: Purchase APR 33.49% variable (based on the Prime Rate) for both the Bloomingdale\u2019s Store Card and the Bloomingdale\u2019s American Express Card. The Amex version also has a Cash Advance APR of 33.49%, a Cash Advance Fee of the greater of $5 or 4% of each cash advance, a Minimum Interest Charge of $2, and a 3% foreign transaction fee on purchases in foreign currency."
  },
  "benefits": [
    {
      "name": "Free shipping every day",
      "description": "Free shipping on bloomingdales.com with no minimum purchase required for Loyallists when using a Bloomingdale\u2019s Credit Card (store or Amex).",
      "benefit_type": null,
      "new_benefit_type": "free_shipping",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Personal triple points days",
      "description": "Choose days throughout the year to earn Triple Points on purchases in store and online. This is an ongoing Loyallist perk available to Bloomingdale\u2019s cardholders.",
      "benefit_type": null,
      "new_benefit_type": "bonus_points_days",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Exclusive storewide offers",
      "description": "Access to special double, triple and Power Points offers to help earn rewards faster at Bloomingdale\u2019s.",
      "benefit_type": null,
      "new_benefit_type": "exclusive_store_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Personalized monthly offers",
      "description": "Tailored \u201cPerks of the Month\u201d sent to your inbox each month.",
      "benefit_type": null,
      "new_benefit_type": "personalized_monthly_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.MONTHLY,
      "requires_authorized_user": false
    },
    {
      "name": "Amex Offers (Bloomingdale\u2019s American Express Card only)",
      "description": "Targeted statement-credit style offers to save on shopping, dining and more when activating and using Amex Offers on the Bloomingdale\u2019s American Express Card.",
      "benefit_type": null,
      "new_benefit_type": "amex_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Entertainment Access (Bloomingdale\u2019s American Express Card only)",
      "description": "Early access to premium tickets for concerts, theater, sports and more via American Express entertainment benefits.",
      "benefit_type": null,
      "new_benefit_type": "entertainment_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Get 20% off purchases made today and tomorrow (the first two days after account opening) when you open a Bloomingdale\u2019s card; total savings capped at $250 over the two days. Subject to credit approval. Applies to either the Bloomingdale\u2019s Store Card or Bloomingdale\u2019s American Express Card. Estimated value: up to $250 if you spend $1,250+ across the two days; for example, $500 spend would save ~$100.",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percentage_discount",
          "amount": 20.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://citiretailservices.citibankonline.com/apply/bloomingdales-credit-card?app=UNSOL&siteId=PLCN_BLOOMINGDALES&langId=EN&sc=80202&cmp=W~C~V~B~Z~E~ZZZZ~AI~BL~ZZ",
  "learn_more_link": "https://www.citi.com/credit-cards/bloomingdales-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Card details",
      "url": "https://www.citi.com/credit-cards/bloomingdales-credit-cards?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161"
    },
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_bloomingdales_credit_cards.png"
},
  [CreditCard.CHASE_UNITED_BUSINESS_CARD]: {
  "id": CreditCard.CHASE_UNITED_BUSINESS_CARD,
  "name": "United\u2120 Business Card",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://creditcards.chase.com/content/dam/jpmc-marketplace/card-art/united_biz_card_tilted.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.UNITED,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.united",
      "earnRate": 2.0,
      "description": "2x miles on purchases from United Airlines, including airline tickets purchased from United and the following made from United: seat upgrades, Economy Plus, inflight food/beverages/Wi\u2011Fi, baggage service charges, and other eligible United fees. Excludes other United-related purchases such as United Cruises, United MileagePlus X, DIRECTV, and Merchandise Awards. United tickets booked via some discount travel websites or third\u2011party travel packages may not qualify. Rewards category qualification is based on merchant category coding (see Chase Rewards Category FAQs).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x miles at restaurants; includes eligible delivery services when they code as restaurants. Category qualification is based on merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x miles at gas stations. Category qualification is based on merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "officeSupplies",
      "earnRate": 2.0,
      "description": "2x miles at office supply stores. Category qualification is based on merchant coding.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "2x miles on local transit and commuting, including rideshare services, taxicabs, train tickets, tolls, and mass transit (when coded accordingly).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x mile per dollar on all other purchases that do not fall into a bonus category. Excludes non-purchase transactions like balance transfers, cash advances, cash-like transactions, fees, and interest.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.2049
  },
  "annualFee": 150.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2049,
    "high": 0.2899,
    "description": "Variable purchase APR 0.2049\u20130.2899 based on creditworthiness; varies with the Prime Rate (7.50% as of 5/13/2025). Balance transfer APR 0.2049\u20130.2899 (account may not be eligible for balance transfers). Cash advance APR 0.2924. Penalty APR up to 0.2999. Minimum 20-day grace period on new purchases if paid in full; no minimum interest charge."
  },
  "benefits": [
    {
      "name": "2 United Club one-time passes per year",
      "description": "Two United Club one-time passes deposited after account opening and every 12 months while the account remains open; over $100 total value. Each pass grants one person one-time access, subject to United Club rules and space availability.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free first checked bag for primary and one companion",
      "description": "Primary Cardmember and one companion on the same reservation each get the first standard checked bag free on United/United Express when the primary includes their MileagePlus number and purchases tickets with the card (purchase requirement waived for flights within 90 days of account opening). Estimated savings up to $160 per roundtrip.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority boarding on United-operated flights",
      "description": "Primary Cardmember and companions on the same reservation board prior to general boarding on United/United Express (after Premier members/Premier Access and special-assistance boarding).",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on inflight purchases and United Club premium drinks",
      "description": "Receive 25% back as a statement credit on food, beverages, and Wi\u2011Fi on United/United Express flights and on premium drinks in United Clubs; credits typically post within ~24 hours of the purchase posting.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cardmember award pricing discount",
      "description": "Special pricing on award tickets for United-operated flights when available under the \u201cCardmembers Save\u201d banner. United reports average savings of about 30% in miles (32% in 2024); taxes/fees excluded.",
      "benefit_type": "award_pricing_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "2 Economy Plus seat upgrades after $25,000 spend",
      "description": "Earn 2 Economy Plus upgrades for continental U.S. United/United Express flights after $25,000 in purchases each calendar year; upgrades valid 12 months, for primary Cardmember only, subject to availability.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": 25000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "5,000-mile better\u2011together anniversary bonus",
      "description": "Receive 5,000 bonus miles each account anniversary year if you also hold an eligible personal Chase United credit card (both accounts must be open and in good standing). Estimated value \u2248 $70 assuming 1.4\u00a2 per mile.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn up to 4,000 PQP from card spend per year",
      "description": "Earn 1 Premier Qualifying Point (PQP) per $20 in net purchases, up to 4,000 PQP per calendar year, applicable toward Premier status qualification (up to Premier 1K).",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Primary Auto Rental Collision Damage Waiver (for business rentals)",
      "description": "Decline the rental company\u2019s CDW and pay in full with the card to get primary coverage for theft and collision damage when renting for business purposes; up to $60,000 coverage for most vehicles with MSRP \u2264 $125,000.",
      "benefit_type": "auto_rental_collision_damage_waiver_primary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation/Interruption Insurance",
      "description": "Reimburses up to $1,500 per covered traveler and $6,000 per trip for prepaid, nonrefundable passenger fares if your trip is canceled or cut short for covered reasons.",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Reimbursement",
      "description": "If common carrier travel is delayed more than 12 hours or requires an overnight stay, reimbursement for unreimbursed expenses like meals and lodging up to $500 per covered traveler.",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Baggage Delay Insurance",
      "description": "Up to $100 per day for 3 days for essential purchases when baggage is delayed more than 6 hours.",
      "benefit_type": "baggage_delay_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost Luggage Reimbursement",
      "description": "Up to $3,000 per covered traveler for lost, damaged, or stolen checked/carry-on baggage on a covered trip (NY state-specific limits apply).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Covers eligible new purchases for 120 days against damage or theft, up to $10,000 per item (90 days for NY residents).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extends eligible U.S. manufacturer warranties of 3 years or less by one additional year (up to 4 total years).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Visa Signature Concierge",
      "description": "24/7 complimentary concierge assistance for dining, entertainment, tickets, gifts and more (cardmember pays for goods/services arranged).",
      "benefit_type": "personal_travel_concierge",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Premier Upgrades on award tickets (for elites)",
      "description": "Primary Cardmember with MileagePlus Premier status and one companion on the same reservation are eligible for Complimentary Premier Upgrades on select United/United Express flights when traveling on award tickets, subject to availability.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "3\u2011month complimentary Instacart+ membership",
      "description": "Three months of Instacart+ complimentary membership, then 25% off the annual rate through 12/31/27 (activation required; terms apply).",
      "benefit_type": "instacart_plus_membership",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "$125 United TravelBank credit",
      "description": "Receive $125 in United TravelBank cash each calendar year after making five United flight-related purchases of $100+ each.",
      "credit_category": "travel.airline",
      "new_credit_category": null,
      "value": 125.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "United Hotels statement credits up to $100 per year",
      "description": "$50 statement credit on your 1st and 2nd prepaid hotel stays booked directly through United Hotels each anniversary year (up to $100).",
      "credit_category": "travel.hotel",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Rideshare statement credits up to $100 per calendar year",
      "description": "Enroll to receive up to $8 back monthly Jan\u2013Nov and $12 in Dec on rideshare purchases, up to $100 per calendar year.",
      "credit_category": "travel.rideshare",
      "new_credit_category": null,
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Avis/Budget United TravelBank credit up to $50 per year",
      "description": "Earn $25 TravelBank cash on your 1st and $25 on your 2nd Avis or Budget rental booked at cars.united.com and paid with the card (2\u2011day minimum; specific discount codes required).",
      "credit_category": "travel.rentalCar",
      "new_credit_category": null,
      "value": 50.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Instacart credits up to $120 per calendar year",
      "description": "Receive a $10 Instacart credit each month (up to $120/year) for purchases made directly through Instacart when paying with the card; benefits end 12/31/27.",
      "credit_category": "grocery",
      "new_credit_category": "instacart_purchases",
      "value": 120.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "JSX statement credits up to $100 per year",
      "description": "Get up to $100 back in statement credits each anniversary year on purchases made directly with JSX.",
      "credit_category": "travel.airline",
      "new_credit_category": "jsx",
      "value": 100.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "FareLock statement credit up to $25 per year",
      "description": "Earn up to $25 back in statement credits each anniversary year on United/United Express FareLock purchases.",
      "credit_category": "travel.airline",
      "new_credit_category": "farelock",
      "value": 25.0,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time new cardmember offer: Earn 100,000 bonus miles plus 2,000 Premier Qualifying Points (PQP) after $5,000 in purchases within the first 3 months from account opening. Not available to current/previous cardmembers who received a new cardmember bonus for this business card in the past 24 months. PQP post directly to MileagePlus and do not count toward the 4,000 PQP calendar-year cap from card spend. Estimated value of 100,000 miles \u2248 $1,400 at 1.4\u00a2/mile (value varies by redemption).",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "miles"
        },
        {
          "reward_type": null,
          "new_reward_type": "status_qualifying_points_united",
          "amount": 2000.0,
          "value_unit": "points"
        }
      ]
    },
    {
      "spendRequirement": null,
      "spendRequirementMonths": 3,
      "description": "Add an employee (authorized user) card bonus: Earn 10,000 bonus miles after adding an authorized user within the first 3 months from account opening. Awarded once for the first AU added; account must be open and not in default. Estimated value \u2248 $140 at 1.4\u00a2/mile.",
      "rewards": [
        {
          "reward_type": "miles",
          "new_reward_type": null,
          "amount": 10000.0,
          "value_unit": "miles"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "chase_united_business_card.png"
},
  [CreditCard.BANK_OF_AMERICA_ATMOS_REWARDS_ASCENT_VISA_SIGNATURE_CARD]: {
  "id": CreditCard.BANK_OF_AMERICA_ATMOS_REWARDS_ASCENT_VISA_SIGNATURE_CARD,
  "name": "Atmos\u2122 Rewards Ascent Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://bat.bing.com/action/0?ti=4028467&Ver=2&mid=8757386d-b11a-433d-b3aa-4138ef19eb7a&bo=1&sid=9c736180b28111f092802fdf08ca316f&vid=9c734610b28111f0a64b754fd16bc47e&vids=1&msclkid=N&pi=918639831&lg=en-US&sw=800&sh=600&sc=24&tl=The%20Atmos%E2%84%A2%20Rewards%20Ascent%20Visa%20Signature%20Card%20-%20Apply%20Today&p=https%3A%2F%2Fwww.alaskaair.com%2Fatmosrewards%2Fcontent%2Fcredit-cards%2Fvisa-ascent&r=&lt=8273&evt=pageLoad&sv=2&cdb=AQIR&rn=829340",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.ALASKA,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.alaska",
      "earnRate": 3.0,
      "description": "Eligible purchases with Alaska Airlines and Hawaiian Airlines, including airfare and in-flight purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.hawaiian",
      "earnRate": 3.0,
      "description": "Eligible purchases with Alaska Airlines and Hawaiian Airlines, including airfare and in-flight purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 3.3,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "Eligible gas station purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas.evCharging",
      "earnRate": 2.0,
      "description": "Eligible electric vehicle charging station purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "Eligible local transit purchases (including rideshare).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rideshare",
      "earnRate": 2.0,
      "description": "Eligible rideshare purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "Eligible cable (and related telecom) purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "Eligible streaming services purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 2.2,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "All other purchases.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 1.1,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "10% rewards bonus on all points earned if you have an eligible Bank of America account.",
          "promotional_type": null
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Annual $99 Companion Fare (after $6,000 annual spend)",
      "description": "Each account anniversary, receive a $99 Companion Fare (plus taxes and fees from $23) valid on Alaska Airlines or Hawaiian Airlines-operated flights within North America when you spend at least $6,000 in purchases during the prior anniversary year. Book on AlaskaAir.com. Typically received at/after the first anniversary once the spend threshold is met.",
      "benefit_type": "companion_ticket",
      "new_benefit_type": null,
      "spend_requirement": 6000,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Free checked bag",
      "description": "First checked bag free for the cardholder and up to six guests on the same reservation when Alaska or Hawaiian Airlines airfare is purchased with the card.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred boarding",
      "description": "Preferred boarding on Alaska Airlines flights for the cardholder (and up to six guests on the same reservation) when the flight is paid with the card.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "20% back on in\u2011flight purchases",
      "description": "Get 20% back when paying with the card for Wi\u2011Fi, drinks, and other extras on Alaska Airlines and Hawaiian Airlines in\u2011flight purchases.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$100 off Alaska Lounge+ membership",
      "description": "Receive $100 off an annual Alaska Lounge+ Membership when you pay for the membership with the card. Est. value: $100 per year if you would otherwise purchase Lounge+.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "10% rewards bonus with eligible Bank of America account",
      "description": "Earn a 10% rewards bonus on all points earned from card purchases if you have an eligible Bank of America account.",
      "benefit_type": "bofa_account_10_percent_rewards_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Earn status points via spend",
      "description": "Earn 1 status point for every $3 spent on purchases\u2014up to 30,000 status points in 2025 (uncapped starting in 2026) toward elite status qualification.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 4,
      "description": "Limited time online offer: Earn 80,000 bonus points plus a $99 Companion Fare (plus taxes and fees from $23) after $4,000 in purchases within the first 120 days of account opening. Est. points value \u2248 $800 at 1.0\u00a2/point (actual value varies by redemption). Companion Fare value depends on route; you pay $99 + taxes/fees from $23; valid on Alaska or Hawaiian-operated flights within North America when booked on AlaskaAir.com.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "points",
          "category": "all_purchases",
          "category_description": null
        },
        {
          "reward_type": "companion_fare_alaska_99_dollar",
          "new_reward_type": null,
          "amount": 1.0,
          "value_unit": "companion_fare",
          "category": "airline",
          "category_description": "Companion Fare valid on Alaska Airlines and Hawaiian Airlines-operated flights within North America; taxes and fees from $23 apply; book on AlaskaAir.com."
        }
      ]
    }
  ],
  "apply_link": "https://www.alaskaair.com/atmosrewards/content/credit-cards/visa-ascent",
  "learn_more_link": "https://www.alaskaair.com/atmosrewards/content/credit-cards/visa-ascent",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Bank of America",
  "imageName": "BANK_OF_AMERICA_ATMOS_REWARDS_ASCENT_VISA_SIGNATURE_CARD.webp"
},
  [CreditCard.REAL_REWARDS_CREDIT_CARD]: {
  "id": CreditCard.REAL_REWARDS_CREDIT_CARD,
  "name": "American Eagle Outfitters, INC. Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://apply.syf.com/cs/groups/public/documents/et_clientoffer/e046515.jpg",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.3399
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.3399,
    "high": 0.3399,
    "description": "New Accounts as of 1/1/2025: Variable Purchase APR 33.99%; Variable Penalty APR 39.99%; Minimum Interest Charge $2. Real Rewards Visa Cash Advance APR 34.99% and 5% fee ($10 min). Foreign transaction fee 3%."
  },
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "First Purchase Discount: 20% off your first purchase upon credit approval when using the Real Rewards credit card as the sole payment method. Discount is applied before tax and shipping; cannot be combined with other coupons/discounts; excludes 3rd-party merchandise, previous purchases, and gift cards; valid in U.S. (including PR) stores only; no cash value. If you do not receive an immediate decision but are later approved after the promo ends, you will still receive 20% off. Estimated value equals 20% of your first purchase (e.g., a $50 purchase saves $10).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "percentage_discount",
          "amount": 20.0,
          "value_unit": "percent"
        }
      ]
    }
  ],
  "apply_link": "https://apply.syf.com/eapply/eapply.action?clientCode=AE&intcmp=NoOff_RealRewardsCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "learn_more_link": "https://apply.syf.com/eapply/eapply.action?clientCode=AE&intcmp=NoOff_RealRewardsCreditCard_credit%20cards_body-catalog-cards_apply_int&platformtoken=&orgchannel=SyfMarketing&storeNumber=cata",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Synchrony",
  "imageName": "real_rewards_credit_card.png"
},
  [CreditCard.EVERGREENBY_FNBO_CREDIT_CARD]: {
  "id": CreditCard.EVERGREENBY_FNBO_CREDIT_CARD,
  "name": "Evergreen\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://s7d1.scene7.com/is/image/fnnistage/evergreen-1?ts=1755532199294&$TransparentPNG$&dpr=off",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Earn unlimited 2% cash back (earned as points) on all purchases with no stated spend cap or category restrictions; points do not expire and can be redeemed for statement credit, ACH deposit, or check.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Roadside Dispatch",
      "description": "24/7 access to roadside assistance (e.g., towing, jump starts, tire changes) with pre\u2011negotiated, pay\u2011per\u2011use fees available to Visa cardholders.",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Global Services",
      "description": "24/7 global assistance for emergency card replacement or emergency cash disbursement while traveling.",
      "benefit_type": null,
      "new_benefit_type": "global_assistance_services",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $200 cash bonus (20,000 points equivalent) after spending $1,000 in the first 3 billing cycles after account opening. Bonus points are awarded 6\u20138 weeks after qualifying. Must apply via this specific offer; offers may vary elsewhere. Estimated value: $200, based on 20,000 points redeemable at 1\u00a2 per point.",
      "rewards": [
        {
          "reward_type": "cash_back_or_points",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.fnbo.com/personal-banking/credit-cards#",
  "learn_more_link": "https://www.fnbo.com/personal-banking/credit-cards/evergreen",
  "terms_and_conditions_link": "https://www.firstbankcard.com/lynx/#/soct/XK6RTT9FBSJ5Z",
  "terms_and_conditions_button_text": "Summary of Credit Terms",
  "additional_links": [],
  "bank_name": "FNBO",
  "imageName": "evergreenby_fnbo_credit_card.png"
},
  [CreditCard.IBERIA_VISA_SIGNATURE_CREDIT_CARD]: {
  "id": CreditCard.IBERIA_VISA_SIGNATURE_CREDIT_CARD,
  "name": "Iberia Visa Signature\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/iberia_visa_signature_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.AVIOS,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.iberia",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Iberia, British Airways, LEVEL, and Aer Lingus. Third-party bookings, wallets, and payment processors may not qualify for the airline category. Standard non-purchase and cash-like transactions do not earn Avios.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.britishAirways",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Iberia, British Airways, LEVEL, and Aer Lingus. Third-party bookings, wallets, and payment processors may not qualify for the airline category. Standard non-purchase and cash-like transactions do not earn Avios.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.level",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Iberia, British Airways, LEVEL, and Aer Lingus. Third-party bookings, wallets, and payment processors may not qualify for the airline category. Standard non-purchase and cash-like transactions do not earn Avios.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline.aerLingus",
      "earnRate": 3.0,
      "description": "3 Avios per $1 on flight purchases made directly with Iberia, British Airways, LEVEL, and Aer Lingus. Third-party bookings, wallets, and payment processors may not qualify for the airline category. Standard non-purchase and cash-like transactions do not earn Avios.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 2.0,
      "description": "2 Avios per $1 on hotel accommodations when purchased directly with the hotel. Bookings through third parties may not code as hotel. Standard non-purchase and cash-like transactions do not earn Avios.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1 Avios per $1 on all other purchases. Excludes balance transfers, cash advances, cash-like transactions, lottery or betting transactions, checks that access the account, interest, fees, and unauthorized or fraudulent charges.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 95.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2824,
    "apr_low": 0.1974
  },
  "annualFee": 95.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1974,
    "high": 0.2824,
    "description": "Variable APRs tied to the Prime Rate. Purchase APR: 19.74%\u201328.24%; Balance Transfer APR: 19.74%\u201328.24%; Cash Advance APR: 28.99%; Penalty APR: up to 29.99%. Minimum interest charge: None. At least a 21-day grace period on purchases if paid in full. Prime Rate 7.25% as of 9/23/2025. Note: This account may not be eligible for balance transfers."
  },
  "benefits": [
    {
      "name": "Annual $1,000 Iberia airfare discount voucher (after $30,000 calendar-year spend)",
      "description": "Earn a $1,000 discount voucher code after $30,000 in purchases in a single calendar year. Valid only on Iberia-operated flights, applied when purchasing two tickets for the same flights in the same class; primary cardmember must travel. One voucher per calendar year; issued 4\u20136 weeks after crossing the threshold and valid for 12 months. Taxes/fees still apply to the full fare. Estimated value: up to $1,000 per year if used on eligible Iberia roundtrip for two.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": 30000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "10% discount on Iberia airfare",
      "description": "Ongoing 10% discount on the flight fare (excludes taxes/fees/carrier charges) for new roundtrip bookings on Iberia-operated flights when booked at iberia.com/Chase10 and paid with the Iberia Visa. Cardmember must travel; one discount per roundtrip booking; up to 9 passengers on same booking. Not valid on codeshares/franchise. Example value: saves $60 on a $600 fare.",
      "benefit_type": "airfare_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "12 months of complimentary DashPass (DoorDash & Caviar)",
      "description": "Activate with the Iberia Visa between 02/01/2025 and 12/31/2027 to receive 12 months of DashPass; must use the card at checkout for DashPass benefits. Auto-renews at the then-current rate unless canceled. Estimated value \u2248 $120 (assuming ~$9.99/month).",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Quarterly $10 off one DoorDash non-restaurant order (with active DashPass)",
      "description": "Once DashPass is activated and while enrolled, receive a $10 discount each calendar quarter on one qualifying non-restaurant DoorDash order when paying with the card. Does not cover fees/taxes/tips; no rollover; limit 1 per quarter. Estimated value up to $40/year.",
      "benefit_type": null,
      "new_benefit_type": "doordash_quarterly_discount",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 5000.0,
      "spendRequirementMonths": 3,
      "description": "85,000 bonus Avios after $5,000 in purchases in the first 3 months from account opening. Not available to current cardmembers of this card or previous cardmembers who received a new cardmember bonus for this card in the last 24 months. Purchases exclude balance transfers, cash advances, and other cash-like transactions. Account must be open and not in default; allow 6\u20138 weeks for Avios to post. Estimated value \u2248 $1,020 at 1.2\u00a2/Avios (range varies by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 85000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://secure.chase.com/web/oao/application/card?sourceCode=HPNN&action=guest#/origination/cardDetails/index/index;cellCode=6269;combo=Y",
  "learn_more_link": "https://creditcards.chase.com/travel-credit-cards/avios/iberia?CELL=6269",
  "terms_and_conditions_link": "https://sites.chase.com/services/creatives/pricingandterms.html/content/dam/pricingandterms/LGC60973.html",
  "terms_and_conditions_button_text": "Pricing & Terms",
  "additional_links": [
    {
      "name": "Rewards Program Agreement (PDF)",
      "url": "https://www.chase.com/iberiacard/rewardsagreement"
    }
  ],
  "bank_name": "Chase",
  "imageName": "iberia_visa_signature_credit_card.png"
},
  [CreditCard.CHASE_SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD]: {
  "id": CreditCard.CHASE_SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD,
  "name": "Southwest Rapid Rewards\u00ae Priority Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "/cards/chase_southwest_rapid_rewards_priority_credit_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.SOUTHWEST,
  "rewards_earn_rates": [
    {
      "category": "travel.airline.southwest",
      "earnRate": 4.0,
      "description": "Starting 01/01/2026: 4x on purchases made directly with Southwest Airlines, including flight, inflight, Southwest gift cards, and Getaways by Southwest packages. Excludes Southwest Cruises, Southwest Charters, and Southwest Cargo.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "gas",
      "earnRate": 2.0,
      "description": "2x at gas stations.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 2.0,
      "description": "2x on dining at restaurants, including takeout and eligible delivery services.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.transit",
      "earnRate": 2.0,
      "description": "Limited-time: 2x on local transit and commuting purchases through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_2025"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "internetCablePhone",
      "earnRate": 2.0,
      "description": "Limited-time: 2x on internet, cable, and phone services through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_2025"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "streaming",
      "earnRate": 2.0,
      "description": "Limited-time: 2x on select streaming services through 12/31/2025.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "time_limited_2025"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1x on all other purchases. Purchases that do not earn points include balance transfers, cash advances and other cash-like transactions, lottery tickets, casino gaming chips, race track wagers or similar betting transactions, any checks that access your account, interest, unauthorized or fraudulent charges, and fees of any kind.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 229.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2849,
    "apr_low": 0.1999
  },
  "annualFee": 229.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1999,
    "high": 0.2849,
    "description": "Purchase APR: 0.1999\u20130.2849 variable based on creditworthiness and Prime Rate (7.50% as of 03/25/2025). Balance transfer APR: 0.1999\u20130.2849 variable (note: account may not be eligible for balance transfers). Cash advance APR: 0.2924 variable. Penalty APR: up to 0.2999 variable. Grace period: at least 21 days on purchases if paid in full (or Interest Saving Balance) by due date. Minimum interest charge: none. Fees: balance transfer fee 0.05 (min $5), cash advance fee 0.05 (min $10), late fee up to $40, return payment fee up to $40. Foreign transaction fees: none."
  },
  "benefits": [
    {
      "name": "$75 Southwest annual travel credit",
      "description": "Automatic statement credits for Southwest Airlines purchases (excluding Upgraded Boardings and inflight purchases) up to $75 each account anniversary year. Estimated value: $75/year if fully used. Starts immediately in your first anniversary year (which begins on account opening).",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Up to 4 Upgraded Boardings reimbursed per anniversary year (A1\u2013A15)",
      "description": "Get reimbursed for up to 4 Upgraded Boardings per anniversary year when available (purchase with the card, then receive statement credit). Not valid on flights with assigned seating starting in 2026. Typical cost ~$30\u2013$80 each; estimated value up to ~$120\u2013$320/year if fully used.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "7,500 anniversary points",
      "description": "Receive 7,500 Rapid Rewards points each account anniversary. Estimated value \u2248 $105 at ~1.4\u00a2/point (estimate varies with redemption).",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Preferred seat selection at booking (when available)",
      "description": "Primary cardmember can select a Preferred or Standard seat at booking (or up to 30 minutes prior to departure) for themselves and up to 8 additional passengers on the same reservation, when available. Authorized users are not eligible. Benefit may not apply on itineraries booked with partner airlines.",
      "benefit_type": null,
      "new_benefit_type": "preferred_seat_selection",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extra Legroom seat upgrade within 48 hours of departure (when available)",
      "description": "Primary cardmember can upgrade to an Extra Legroom seat within 48 hours of departure for themselves and up to 8 additional passengers on the same reservation, when available. Authorized users are not eligible. Benefit may not apply on itineraries booked with partner airlines.",
      "benefit_type": "airline_seat_upgrade",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "First checked bag free",
      "description": "Primary cardmember and up to 8 passengers on the same reservation get their first standard checked bag free on Southwest-operated flights. Oversize/overweight and extra bag fees may apply. Authorized users are not eligible. Estimated value varies by route and airline bag fees.",
      "benefit_type": "free_checked_bags",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Group 5 boarding benefit",
      "description": "Primary cardmember and up to 8 passengers on the same reservation can board with Group 5 on Southwest-operated flights. Authorized users are not eligible.",
      "benefit_type": "airline_priority_boarding",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "25% back on inflight purchases (drinks and Wi\u2011Fi)",
      "description": "Get 25% back as statement credits on inflight purchases of drinks and Wi\u2011Fi made with the card (authorized user purchases also qualify). Estimated value depends on usage.",
      "benefit_type": "airline_inflight_purchase_discount",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "10,000 Companion Pass qualifying points boost each calendar year",
      "description": "Receive one boost of 10,000 Companion Pass qualifying points each calendar year (deposited by Jan 31 or up to 30 days after account opening). Helps toward Companion Pass qualification; no direct cash value.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "2,500 Tier Qualifying Points (TQPs) per $5,000 spend",
      "description": "Earn 2,500 TQPs toward A\u2011List/A\u2011List Preferred status for each $5,000 in purchases annually. Value depends on your pursuit of status benefits.",
      "benefit_type": "tier_qualifying_points",
      "new_benefit_type": null,
      "spend_requirement": 5000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary DashPass (DoorDash/Caviar) for 12 months",
      "description": "Activate with this card between 02/01/2025 and 12/31/2027 to receive 12 months of DashPass for DoorDash and Caviar (must enroll and use this card for eligible orders). Estimated value \u2248 $120 at ~$9.99/month if you would otherwise pay.",
      "benefit_type": "free_doordash_dashpass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "$10 off one DoorDash non\u2011restaurant order each calendar quarter",
      "description": "Once DashPass is activated, get a $10 discount each calendar quarter on one qualifying non\u2011restaurant order when paying with this card; does not roll over. Estimated value up to $40/year if used all four quarters.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.QUARTERLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay no fees on foreign transactions when using the card abroad.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 4000.0,
      "spendRequirementMonths": 5,
      "description": "Earn 100,000 Rapid Rewards points after you spend $4,000 on purchases in the first 5 months from account opening. Estimated value \u2248 $1,400 at ~1.4\u00a2/point (actual value varies by route and fare). Eligibility: Not available to current Southwest Rapid Rewards consumer credit cardmembers, or to previous Southwest Rapid Rewards consumer cardmembers who received a new cardmember bonus within the last 24 months (does not apply to Southwest Rapid Rewards Business/Employee cards). Purchases that do NOT count include balance transfers, cash advances, cash\u2011like transactions, etc. Account must be open and not in default at fulfillment; allow up to 8 weeks for points to post.",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 100000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": null,
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Chase",
  "imageName": "chase_southwest_rapid_rewards_priority_credit_card.png"
},
  [CreditCard.BILT_BLUE_CARD]: {
  "id": CreditCard.BILT_BLUE_CARD,
  "name": "Bilt Blue Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/bilt_blue_card.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.BILT_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "housing",
      "earnRate": 0,
      "description": "0.5X-1.25X points on housing through Bilt based on everyday spend ratio.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_issuer_platform"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 0.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "0.5X when spending \u226525% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_25
        },
        {
          "earnRate": 0.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "0.75X when spending \u226550% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_50
        },
        {
          "earnRate": 1.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "1X when spending \u226575% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_75
        },
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "1.25X when spending \u2265100% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_100
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "1X points on everyday spend (all purchases).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3474,
    "apr_low": 0.2674
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2674,
    "high": 0.3474,
    "description": "Intro APR 0.10 on new purchases for 12 billing cycles; then variable purchase APR 0.2674\u20130.3474 based on creditworthiness and the Prime Rate."
  },
  "benefits": [
    {
      "name": "No transaction fees on housing payments",
      "description": "Cardholder exclusive\u2014no transaction fees on housing payments (rent or mortgage) when using the Bilt ecosystem to pay housing.",
      "benefit_type": null,
      "new_benefit_type": "no_transaction_fees_on_housing_payments",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Enjoy no foreign transaction fees when traveling internationally.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Cellular Wireless Telephone Protection",
      "description": "Cell phone protection when you pay your wireless bill with the card; see Guide to Benefits for coverage details and exclusions.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Assurance",
      "description": "Purchase protection for eligible new purchases; terms, limits, and exclusions apply per Guide to Benefits.",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "MasterRental Collision Damage Waiver",
      "description": "MasterRental coverage provides reimbursement for covered damage or theft to your rental car when you use the card; terms and exclusions apply.",
      "benefit_type": "auto_rental_collision_damage_waiver_secondary",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Earn $100 of Bilt Cash as a sign-up bonus when you apply and get approved; credited upon account opening (no minimum spend stated).",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "bilt_cash",
          "amount": 100.0,
          "value_unit": "dollars",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.biltrewards.com/card",
  "learn_more_link": "https://www.biltrewards.com/card",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "Link 2",
      "url": "https://legal.cardless.com/schumer/bilt/rates_and_fees.pdf"
    },
    {
      "name": "Link 3",
      "url": "https://www.biltrewards.com/terms/bilt-cash"
    }
  ],
  "bank_name": "Bilt",
  "imageName": "bilt_blue_card.webp"
},
  [CreditCard.USAA_CASHBACK_REWARDS_PLUS]: {
  "id": CreditCard.USAA_CASHBACK_REWARDS_PLUS,
  "name": "USAA Cashback Rewards Plus American Express\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.AMERICAN_EXPRESS,
  "creditCardImageUrl": "",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "gas",
      "earnRate": 5.0,
      "description": "",
      "spendCap": 3000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "grocery",
      "earnRate": 3.0,
      "description": "",
      "spendCap": 3000.0,
      "spendCapResetFrequency": Frequency.ANNUALLY,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": 1000.0,
      "spendRequirementMonths": 3,
      "description": "Earn a $200 reward bonus after spending $1,000 on qualifying purchases within 90 days of account opening.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 200.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": null,
  "learn_more_link": "https://www.usaa.com/banking/credit-cards-public/cash-back/rewards-plus",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "USAA",
  "imageName": ""
},
  [CreditCard.SYNCHRONY_Q_CARD_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_Q_CARD_CREDIT_CARD,
  "name": "QCard\u00ae",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://qvc.scene7.com/is/image/QVC/pic/ap/sq1_ccm_QCard_Benefits_ap_20250901.jpg?v0",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.GIFT_CARD,
  "rewards_earn_rates": [],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 0.0,
  "foreignTransactionFee": null,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "$10 Anniversary Offer",
      "description": "$10 off for your QCard anniversary. Typically issued around your account anniversary; valid email on file may be required. Estimated value: ~$10 annually.",
      "benefit_type": "anniversary_bonus",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "5 Easy Pays on Everything",
      "description": "5 Easy Pays on everything you buy with your QCard, every day. QVC does not charge Easy Pay fees, but if you pay with QCard interest/fees may apply per your card terms. Items with Special Financing are not eligible for Easy Pay; max Easy Pays is six; exclusions apply.",
      "benefit_type": null,
      "new_benefit_type": "easy_pay_installments",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "QCard Special Financing",
      "description": "No interest if paid in full within 9, 12, or 18 months on select items purchased with QCard. Interest accrues from purchase date if the promotional balance is not paid in full within the promo period; minimum monthly payments required; subject to credit approval; not available on QVC+/HSN+ or certain checkout methods.",
      "benefit_type": null,
      "new_benefit_type": "special_financing",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "VIP Savings Events",
      "description": "12+ QCard VIP savings events each year offering exclusive discounts and promotions. Estimated value varies based on participation/spend.",
      "benefit_type": null,
      "new_benefit_type": "vip_savings_events",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Access to Live Audience Shows & Events",
      "description": "Invitations or access to select live audience shows and events. A valid email on file may be required.",
      "benefit_type": null,
      "new_benefit_type": "access_to_live_events",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Early Access",
      "description": "Early access to select products and promotions for QCard VIPs. A valid email on file may be required.",
      "benefit_type": null,
      "new_benefit_type": "early_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "QCard Priority Line",
      "description": "Dedicated VIP customer service line at 800-600-1608.",
      "benefit_type": null,
      "new_benefit_type": "priority_customer_service",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 Fraud Liability",
      "description": "$0 liability for unauthorized purchases.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "HSN VIP Benefits Access",
      "description": "QCard VIPs are HSN Card VIPs too; use your QCard at HSN for additional benefits and offers.",
      "benefit_type": null,
      "new_benefit_type": "hsn_benefits_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "$20 off instantly when you open and use a QCard by 12/31/2025 with the provided promo code at checkout (limit one per account; exclusions include gift cards, charitable contributions, As Is, Clearance/Final Sale/Lunchtime Specials, and purchases on QVC+/HSN+ or via Speed Buy; shipping/tax excluded; no cash value).",
      "rewards": [
        {
          "reward_type": "statement_credit",
          "new_reward_type": null,
          "amount": 20.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.qvc.com/content/featured/q-card-benefits.html?qq=ft&intcmp=NoOff_QCardCreditCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.qvc.com/content/featured/q-card-benefits.html?qq=ft&intcmp=NoOff_QCardCreditCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Synchrony",
  "imageName": "synchrony_car_care_credit_card.jpg"
},
  [CreditCard.BILT_PALLADIUM_CARD]: {
  "id": CreditCard.BILT_PALLADIUM_CARD,
  "name": "Bilt Palladium Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "/cards/bilt_palladium_card.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.BILT_REWARDS,
  "rewards_earn_rates": [
    {
      "category": "housing",
      "earnRate": 0,
      "description": "0.5X-1.25X points on housing through Bilt based on everyday spend ratio.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_issuer_platform"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 0.5,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "0.5X when spending \u226525% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_25
        },
        {
          "earnRate": 0.75,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "0.75X when spending \u226550% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_50
        },
        {
          "earnRate": 1.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "1X when spending \u226575% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_75
        },
        {
          "earnRate": 1.25,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "1.25X when spending \u2265100% of housing on everyday purchases",
          "promotional_type": PromotionalType.BILT_SPEND_RATIO_100
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "2X points on everyday spend, plus 4% back in Bilt Cash.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 495.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 495.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "No transaction fees on housing payments",
      "description": "Pay rent or mortgage through Bilt without transaction fees.",
      "benefit_type": null,
      "new_benefit_type": "waived_rent_transaction_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass",
      "description": "Priority Pass lounge access (worth $469/year).",
      "benefit_type": "priority_pass",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Bilt Travel Hotel Credit",
      "description": "$400 annual Bilt Travel Hotel credit (applied as $200 twice yearly).",
      "credit_type": "travel",
      "credit_category": null,
      "new_credit_category": "hotel_credit",
      "value": 400,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    },
    {
      "name": "Annual Bilt Cash",
      "description": "$200 annual Bilt Cash (up to $100 rolls over).",
      "credit_type": "other",
      "credit_category": null,
      "new_credit_category": "statement_credit",
      "value": 200,
      "value_unit": "dollars",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 4000,
      "spendRequirementMonths": 3,
      "description": "50,000 Bilt Points + Gold Status after $4,000 spend in 3 months, plus $300 Bilt Cash",
      "rewards": [
        {
          "reward_type": null,
          "new_reward_type": "bilt_points",
          "amount": 50000,
          "value_unit": "points",
          "category": null,
          "category_description": null
        },
        {
          "reward_type": null,
          "new_reward_type": "bilt_cash",
          "amount": 300,
          "value_unit": "dollars",
          "category": null,
          "category_description": null
        }
      ]
    }
  ],
  "apply_link": "https://www.biltrewards.com/card",
  "learn_more_link": "https://www.biltrewards.com/card",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Bilt",
  "imageName": "bilt_palladium_card.png"
},
  [CreditCard.SYNCHRONY_MY_WALGREENS_CREDIT_CARD]: {
  "id": CreditCard.SYNCHRONY_MY_WALGREENS_CREDIT_CARD,
  "name": "myWalgreens\u00ae Credit Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://www.walgreens.com/images/adaptive/1683647_081621_Credit_Card_Single.png",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "drugstore.walgreens",
      "earnRate": 10.0,
      "description": "Earn 10% Walgreens Cash rewards on eligible Walgreens-branded purchases at Walgreens stores and Walgreens.com when you use your myWalgreens Credit Card or myWalgreens Mastercard.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "drugstore.walgreens",
      "earnRate": 5.0,
      "description": "Earn 5% Walgreens Cash rewards on eligible purchases of non\u2011Walgreens brands at Walgreens and Walgreens.com (excluding prescriptions).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "fixed_category_group",
      "earnRate": 3.0,
      "description": "Earn 3% Walgreens Cash rewards on grocery and health & wellness purchases made outside Walgreens, such as at grocery stores, pet stores, gyms, salons/spas, and sporting goods stores.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "excludeMerchants": [
        "walgreens"
      ],
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "mywalgreens_mastercard_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null,
      "selectableCategories": {
        "requireUserSelection": false,
        "applicableCategoryCount": null,
        "categories": [
          "grocery",
          "fitness",
          "selfCare",
          "petPurchases",
          "sportsEquipment"
        ],
        "categoryRotationFrequency": null,
        "selectionChangeFrequency": null,
        "categoriesDescription": "Grocery and health & wellness purchases outside of Walgreens, including grocery stores, spa/salon appointments (self care), pet stores, sporting goods stores, and gym memberships.",
        "startDate": null,
        "endDate": null
      }
    },
    {
      "category": "allPurchases",
      "earnRate": 1.0,
      "description": "Earn 1% Walgreens Cash rewards on other purchases everywhere Mastercard is accepted (non\u2011Walgreens purchases).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_membership",
        "mywalgreens_mastercard_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.3399,
    "apr_low": 0.2499
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2499,
    "high": 0.3399,
    "description": "New Accounts as of 1/1/25: myWalgreens Credit Card variable purchase APR 33.99%. myWalgreens Mastercard variable purchase APR 24.99%, 30.99% or 33.99%. Penalty APR 34.99% or 39.99%. Minimum interest charge $2. Cash advance APR 34.99% and 5% fee ($10 min). Foreign transaction fee 3%."
  },
  "benefits": [
    {
      "name": "No annual fee",
      "description": "No annual fee with the myWalgreens Credit Card (and myWalgreens Mastercard, if approved).",
      "benefit_type": null,
      "new_benefit_type": "no_annual_fee",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0 fraud liability",
      "description": "Cardholders are not responsible for unauthorized transactions.",
      "benefit_type": null,
      "new_benefit_type": "zero_fraud_liability",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Instant rewards redemption",
      "description": "Redeem Walgreens Cash rewards instantly at checkout toward eligible purchases.",
      "benefit_type": null,
      "new_benefit_type": "instant_rewards_redemption",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Personalized offers and deals",
      "description": "Receive only-for-you sales, personalized offers, and product recommendations.",
      "benefit_type": null,
      "new_benefit_type": "personalized_offers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [
    {
      "spendRequirement": null,
      "spendRequirementMonths": null,
      "description": "Account-opening offer: Earn at least $25 in Walgreens Cash rewards (amount may be higher per personalized offer) after opening a new myWalgreens Credit Card or myWalgreens Mastercard and making your first eligible purchase within 45 days. Rewards post within 30 days of the eligible purchase. Eligible purchases exclude items/categories listed in the program exclusions; rewards on prescriptions, pharmacy items and services cannot be earned in AR, NJ, or NY. Walgreens Cash redeems at $1 Walgreens Cash = $1 at checkout in set increments. Estimated value: at least $25, based on 1:1 redemption value.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 40.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.walgreens.com/mywalgreens/cards/credit.jsp?BAN=SYFPP&sitecode=WGDCOMSFPP&intcmp=NoOff_myWalgreensCreditCard_credit%20cards_body-catalog-cards_ext",
  "learn_more_link": "https://www.walgreens.com/mywalgreens/cards/credit.jsp?BAN=SYFPP&sitecode=WGDCOMSFPP&intcmp=NoOff_myWalgreensCreditCard_credit%20cards_body-catalog-cards_ext",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [
    {
      "name": "myWalgreens Terms and Conditions",
      "url": "https://www.walgreens.com/topic/help/generalhelp/mywalgreens-termsofuse.jsp"
    },
    {
      "name": "Credit Card Reward Program Terms",
      "url": "https://www.walgreens.com/topic/help/generalhelp/mywalgreens-credit-card-terms-of-use.jsp"
    }
  ],
  "bank_name": "Synchrony",
  "imageName": "synchrony_my_walgreens_credit_card.png"
},
  [CreditCard.SPARK_2_CASH_PLUS]: {
  "id": CreditCard.SPARK_2_CASH_PLUS,
  "name": "Spark Cash Plus",
  "cardType": "business",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://ecm.capitalone.com/WCM/card/products/spark-cash-plus_our-best-offer_large.png",
  "recommendedMinCreditScore": "Excellent",
  "availability": "available",
  "lastChecked": "2026-03-05",
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "allPurchases",
      "earnRate": 2.0,
      "description": "Earn unlimited 2% cash back on every purchase\u2014no category restrictions or caps.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 5.0,
      "description": "5% cash back on hotels and rental cars booked through Capital One\u2019s travel booking site; otherwise standard earn rates apply.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal",
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 5.0,
      "description": "5% cash back on hotels and rental cars booked through Capital One\u2019s travel booking site; otherwise standard earn rates apply.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "require_travel_portal",
        "online_only"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 150.0,
    "annual_fee_waived_first_year": false,
    "apr_high": null,
    "apr_low": null
  },
  "annualFee": 150.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": null,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {},
  "benefits": [
    {
      "name": "Annual fee refund after $150,000 spend",
      "description": "Receive a $150 statement credit each year to refund the annual fee when you spend at least $150,000 in net purchases by your membership anniversary date. Estimated value: $150 per year if requirement is met.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": 150000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "Pay $0 in foreign transaction fees on purchases made outside the U.S. Estimated savings: ~3% vs. typical cards, depending on your foreign spend.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Roadside assistance",
      "description": "Access services for auto-related emergencies such as jump-starting, tire changing, and towing (service fees may apply; see issuer for terms).",
      "benefit_type": null,
      "new_benefit_type": "roadside_assistance",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Complimentary Capital One Business Travel access",
      "description": "Complimentary access to Capital One\u2019s business travel management and booking platform. Rewards and benefits may vary between Capital One Travel and Capital One Business Travel.",
      "benefit_type": null,
      "new_benefit_type": "business_travel_management_platform_access",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended warranty protection",
      "description": "Get free additional warranty and protection on eligible items purchased with your card.",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Free employee cards",
      "description": "Add employee and virtual cards at no extra cost; set customized spending limits and earn rewards on employee purchases.",
      "benefit_type": null,
      "new_benefit_type": "free_employee_cards",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Virtual card numbers",
      "description": "Create virtual card numbers for safer online payments without exposing your actual card number.",
      "benefit_type": null,
      "new_benefit_type": "virtual_card_numbers",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Annual fee refund after $150,000 spend",
      "description": "Receive a $150 statement credit each year when you spend at least $150,000 in net purchases by your membership anniversary date.",
      "credit_category": null,
      "new_credit_category": "annual_fee_credit",
      "value": 150.0,
      "value_unit": "dollars",
      "spend_requirement": 150000,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 30000.0,
      "spendRequirementMonths": 3,
      "description": "Earn $2,000 after spending $30,000 in the first 3 months, plus an additional $2,000 for every $500,000 spent in the first year. These spend bonuses may be earned independently (you can earn one or both) and are uncapped in the first year. Offer availability may require using the Apply Now link on the page and may not be available to existing or previous Capital One Business cardholders.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 2000.0,
          "value_unit": "dollars"
        }
      ]
    },
    {
      "spendRequirement": 500000.0,
      "spendRequirementMonths": 12,
      "description": "Earn $2,000 after spending $30,000 in the first 3 months, plus an additional $2,000 for every $500,000 spent in the first year. These spend bonuses may be earned independently (you can earn one or both) and are uncapped in the first year. Offer availability may require using the Apply Now link on the page and may not be available to existing or previous Capital One Business cardholders.",
      "rewards": [
        {
          "reward_type": "cash_back",
          "new_reward_type": null,
          "amount": 2000.0,
          "value_unit": "dollars"
        }
      ]
    }
  ],
  "apply_link": "https://www.capitalone.com/small-business/credit-cards/spark-cash-plus/",
  "learn_more_link": "https://www.capitalone.com/small-business/credit-cards/spark-cash-plus/",
  "terms_and_conditions_link": null,
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "Capital One",
  "imageName": "spark_2_cash_plus.png"
},
  [CreditCard.CITI_STRATA_ELITE_CARD]: {
  "id": CreditCard.CITI_STRATA_ELITE_CARD,
  "name": "Citi Strata Elite\u2120 Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.MASTERCARD,
  "creditCardImageUrl": "https://aemapi.citi.com/content/dam/cfs/uspb/usmkt/cards/en/static/images/citi-strata-elite-credit-card/citi-strata-elite-credit-card_306x192.webp",
  "recommendedMinCreditScore": null,
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CITI_THANKYOU_POINTS,
  "rewards_earn_rates": [
    {
      "category": "travel.hotel",
      "earnRate": 12.0,
      "description": "12x ThankYou Points per $1 on hotels, car rentals, and attractions booked through Citi Travel (cititravel.com).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 12.0,
      "description": "12x ThankYou Points per $1 on hotels, car rentals, and attractions booked through Citi Travel (cititravel.com).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.airline",
      "earnRate": 6.0,
      "description": "6x ThankYou Points per $1 on air travel booked through Citi Travel (cititravel.com).",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "dining",
      "earnRate": 3.0,
      "description": "3x ThankYou Points per $1 at restaurants at all other times outside of Citi Nights hours.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [
        {
          "earnRate": 6.0,
          "isSignupBonusEarnRate": false,
          "signupBonusDurationMonths": null,
          "requireMinimumBankBalance": null,
          "requireMinimumDepositAmount": null,
          "description": "6x ThankYou Points per $1 at restaurants during Citi Nights (Fridays and Saturdays, 6 PM\u20136 AM ET).",
          "promotional_type": PromotionalType.CITI_NIGHTS
        }
      ],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "allPurchases",
      "earnRate": 1.5,
      "description": "1.5x ThankYou Points per $1 on all other purchases that do not qualify for the higher category bonuses.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": false,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": null,
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 595.0,
    "annual_fee_waived_first_year": false,
    "apr_high": 0.2899,
    "apr_low": 0.2099
  },
  "annualFee": 595.0,
  "foreignTransactionFee": 0.0,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.2099,
    "high": 0.2899,
    "description": "Variable APR for purchases and balance transfers is 0.2099\u20130.2899 based on creditworthiness. Cash advance APR is 0.2924. Penalty APR is up to 0.2999 and may apply for late or returned payments. Minimum interest charge: $0.50."
  },
  "benefits": [
    {
      "name": "Annual Hotel Benefit (up to $300)",
      "description": "Up to $300 off a single hotel stay of 2 nights or more when booked through cititravel.com once per calendar year; applied instantly at booking. Estimated value: up to $300 annually.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Splurge Credit (up to $200)",
      "description": "Up to $200 in statement credits per calendar year on your choice of up to 2 brands: 1stDibs, American Airlines (exclusions apply), Best Buy, Future Personal Training, Live Nation (exclusions apply). Estimated value: up to $200 annually.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Annual Blacklane Credit (up to $200)",
      "description": "Up to $200 in statement credits for Blacklane chauffeur service each calendar year\u2014up to $100 January\u2013June and up to $100 July\u2013December. Estimated value: up to $200 annually.",
      "benefit_type": "travel_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Priority Pass Select membership",
      "description": "Complimentary Priority Pass Select membership with access to 1,500+ airport lounges worldwide. Citi cites an annual membership value of about $469 (estimate reflects comparable retail pricing).",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "American Airlines Admirals Club Lounge Access Passes",
      "description": "Receive 4 Admirals Club Citi Strata Elite Passes every calendar year for access to nearly 50 Admirals Club lounges. Estimated value: $300+ depending on usage.",
      "benefit_type": "lounge_access",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Global Entry or TSA PreCheck application fee credit",
      "description": "Up to $120 statement credit every 4 years for Global Entry or TSA PreCheck application fee.",
      "benefit_type": "tsa_pre_and_global_entry_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Points transfer to partners",
      "description": "Transfer ThankYou Points to airline and hotel partners including American Airlines, JetBlue, Virgin Atlantic, Cathay Pacific, EVA Air, Choice Hotels, The Leading Hotels of the World, and others. No fee; minimum transfer 1,000 points.",
      "benefit_type": "points_transfer",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Cancellation and Interruption Protection",
      "description": "Coverage for eligible common carrier trip cancellation or interruption events (per terms).",
      "benefit_type": "trip_cancellation_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Trip Delay Protection",
      "description": "Protection for eligible trip delays (per terms).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Lost or Damaged Luggage",
      "description": "Coverage for lost or damaged luggage on eligible trips (per terms).",
      "benefit_type": "lost_luggage_reimbursement",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Car Rental Coverage (MasterRental)",
      "description": "Car rental collision damage waiver coverage via MasterRental (see Guide to Benefits for primary/secondary details, exclusions, and requirements).",
      "benefit_type": "travel_insurance",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Extended Warranty",
      "description": "Extended warranty protection on eligible purchases (per terms).",
      "benefit_type": "extended_warranty",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Purchase Protection",
      "description": "Purchase Assurance Plus coverage on eligible new purchases (per terms).",
      "benefit_type": "purchase_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "No foreign transaction fees",
      "description": "No fees on foreign purchases.",
      "benefit_type": null,
      "new_benefit_type": "no_foreign_transaction_fees",
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "Citigold/Citigold Private Client relationship credits",
      "description": "Qualifying Citigold clients: $145 annual banking relationship credit if annual card fee is assessed. Qualifying Citigold Private Client: $595 first-year banking relationship credit, then $145 annually thereafter. Terms and eligibility apply. Estimated value: up to $595 first year (CPC) and $145 annually thereafter.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [
    {
      "name": "Global Entry or TSA PreCheck application fee credit",
      "description": "Up to $120 statement credit every 4 years for Global Entry or TSA PreCheck application fee.",
      "credit_category": "tsa_pre_and_global_entry_credit",
      "new_credit_category": "tsa_pre_global_entry",
      "value": null,
      "value_unit": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null
    }
  ],
  "signupBonus": [
    {
      "spendRequirement": 6000.0,
      "spendRequirementMonths": 3,
      "description": "Limited-time offer: Earn 80,000 ThankYou Points after spending $4,000 in the first 3 months. Not available if you have received a new account bonus for a Citi Strata Elite account in the past 48 months or if you converted another Citi credit card on which you earned a new account bonus in the last 48 months into a Citi Strata Elite. Estimated value: about $800 at 1.0 cpp for simple redemptions; potentially ~$1,200 at 1.5 cpp when transferring to partners (valuation estimates vary by redemption).",
      "rewards": [
        {
          "reward_type": "points",
          "new_reward_type": null,
          "amount": 80000.0,
          "value_unit": "points"
        }
      ]
    }
  ],
  "apply_link": "https://www.citi.com/credit-cards/",
  "learn_more_link": "https://www.citi.com/credit-cards/citi-strata-elite-credit-card?category=view-all-credit-cards&intc=old_to_new_vac_202508&afc=161",
  "terms_and_conditions_link": "https://www.citi.com/credit-cards/",
  "terms_and_conditions_button_text": "Important Pricing & Information +",
  "additional_links": [
    {
      "name": "Additional Information +",
      "url": "https://www.citi.com/credit-cards/"
    }
  ],
  "bank_name": "Citi",
  "imageName": "citi_strata_elite_card.webp"
},
  [CreditCard.U_S_BANK_U_S_B_A_N_K_S_H_I_E_L_D_V_I_S_A_C_A_R_D]: {
  "id": CreditCard.U_S_BANK_U_S_B_A_N_K_S_H_I_E_L_D_V_I_S_A_C_A_R_D,
  "name": "U.S. Bank Shield\u2122 Visa\u00ae Card",
  "cardType": "personal",
  "isCardForStudents": false,
  "isSecuredCard": false,
  "cardNetwork": CardNetwork.VISA,
  "creditCardImageUrl": "https://www.usbank.com/content/dam/usbank/en/images/illustrations/card-art/credit-cards/shield-credit-card.png",
  "recommendedMinCreditScore": "Good",
  "availability": "available",
  "lastChecked": null,
  "rewardsType": CreditCardRewardsType.CASH_BACK,
  "rewards_earn_rates": [
    {
      "category": "travel.airline",
      "earnRate": 4.0,
      "description": "4% cash back for every $1 in eligible Net Purchases spent on prepaid air, hotel, and car reservations in the U.S. Bank Travel Center when paid with the Shield card. Net Purchases are Purchases minus credits and returns. Account must be open and in good standing to earn and redeem.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.hotel",
      "earnRate": 4.0,
      "description": "4% cash back for every $1 in eligible Net Purchases spent on prepaid air, hotel, and car reservations in the U.S. Bank Travel Center when paid with the Shield card. Net Purchases are Purchases minus credits and returns. Account must be open and in good standing to earn and redeem.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    },
    {
      "category": "travel.rentalCar",
      "earnRate": 4.0,
      "description": "4% cash back for every $1 in eligible Net Purchases spent on prepaid air, hotel, and car reservations in the U.S. Bank Travel Center when paid with the Shield card. Net Purchases are Purchases minus credits and returns. Account must be open and in good standing to earn and redeem.",
      "spendCap": null,
      "spendCapResetFrequency": null,
      "sharedEarnRateGroupId": null,
      "requiresTravelPortal": true,
      "startDate": null,
      "endDate": null,
      "spendMinimum": null,
      "minimumTransactionCountPerCycle": null,
      "minimumTransactionCountType": null,
      "minimumTransactionAmountPerTransaction": null,
      "conditionalTags": [
        "requires_travel_portal"
      ],
      "requireQualifyingBankBalanceAmount": null,
      "promotions": [],
      "signupBonusEarnRateIncreasePercentage": null,
      "signupBonusEarnRateIncreaseDurationMonths": null
    }
  ],
  "fees": {
    "annual_fee_amount_dollars": 0.0,
    "annual_fee_waived_first_year": true,
    "apr_high": 0.2849,
    "apr_low": 0.1749
  },
  "annualFee": 0.0,
  "foreignTransactionFee": 0.03,
  "balanceTransferFee": 0.05,
  "cashAdvanceFee": 0,
  "latePaymentFee": 0,
  "apr": {
    "low": 0.1749,
    "high": 0.2849,
    "description": "Intro APR: 0.0 on purchases and balance transfers for 24 billing cycles (balance transfers must be made within 60 days of account opening). After intro, variable APR currently 0.1749\u20130.2849 based on creditworthiness and Prime Rate. Cash advance APR 0.3099 variable. No penalty APR. Minimum interest charge $1. Late/returned payment fee up to $41. Balance transfer fee 0.05 (min $5). Foreign transaction fee 0.03."
  },
  "benefits": [
    {
      "name": "$20 annual statement credit",
      "description": "Automatic $20 statement credit once per 12\u2011month period after 11 consecutive months of purchases; applied within 2 billing cycles; account must be in good standing. Estimated value: $20/year.",
      "benefit_type": "statement_credit",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    },
    {
      "name": "Cell phone protection",
      "description": "Get up to $600 reimbursed if your cell phone is stolen or damaged when you pay your monthly cellular bill with your card; terms, conditions and exclusions apply.",
      "benefit_type": "cell_phone_protection",
      "new_benefit_type": null,
      "spend_requirement": null,
      "applies_first_year": true,
      "reward_frequency": null,
      "requires_authorized_user": false
    },
    {
      "name": "$0\u2011fee ExtendPay Plan (once per year)",
      "description": "Opportunity to set up a 3\u2011month $0\u2011fee U.S. Bank ExtendPay Plan each calendar year after the new account 0% intro purchase APR offer has expired (offer becomes available within ~2 months after the 24\u2011cycle intro period ends); eligibility required.",
      "benefit_type": null,
      "new_benefit_type": "installment_plan_fee_waiver",
      "spend_requirement": null,
      "applies_first_year": false,
      "reward_frequency": Frequency.ANNUALLY,
      "requires_authorized_user": false
    }
  ],
  "credits": [],
  "signupBonus": [],
  "apply_link": "https://www.usbank.com/credit-cards/shield-visa-credit-card.html",
  "learn_more_link": "https://www.usbank.com/credit-cards/shield-visa-credit-card.html",
  "terms_and_conditions_link": "https://applications.usbank.com/oad/termsSimpleApply.controller?locationCode=8069&offerId=7HDBW6317B&sourceCode=86798",
  "terms_and_conditions_button_text": null,
  "additional_links": [],
  "bank_name": "US Bank",
  "imageName": "u_s_bank_u_s_b_a_n_k_s_h_i_e_l_d_v_i_s_a_c_a_r_d.webp"
},
};